
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire823f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire823f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ekkyY", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a6e2e2574a146636$export$ffb0004e005737fa; }, function (v) { return $a6e2e2574a146636$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $a6e2e2574a146636$export$34b9dba7ce09269b; }, function (v) { return $a6e2e2574a146636$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $a6e2e2574a146636$export$25062201e9e25d76; }, function (v) { return $a6e2e2574a146636$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6e2e2574a146636$export$ffb0004e005737fa;
var $a6e2e2574a146636$export$34b9dba7ce09269b;
var $a6e2e2574a146636$export$25062201e9e25d76;
"use strict";
var $a6e2e2574a146636$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a6e2e2574a146636$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $a6e2e2574a146636$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $a6e2e2574a146636$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$a6e2e2574a146636$export$ffb0004e005737fa = $a6e2e2574a146636$var$REACT_FRAGMENT_TYPE;
$a6e2e2574a146636$export$34b9dba7ce09269b = $a6e2e2574a146636$var$jsxProd;
$a6e2e2574a146636$export$25062201e9e25d76 = $a6e2e2574a146636$var$jsxProd;

});

parcelRegister("jofHE", function(module, exports) {

$parcel$export(module.exports, "enable", function () { return $e1dc708904eaae62$export$d7c4a0dd6a4567e5; }, function (v) { return $e1dc708904eaae62$export$d7c4a0dd6a4567e5 = v; });
var $e1dc708904eaae62$export$e20fbacbb41798b;
var $e1dc708904eaae62$export$d7c4a0dd6a4567e5;
'use strict';

var $4SONH = parcelRequire("4SONH");
var $e1dc708904eaae62$var$DEFAULT_WHITELIST = [
    ReferenceError,
    TypeError,
    RangeError
];
var $e1dc708904eaae62$var$enabled = false;
$e1dc708904eaae62$export$e20fbacbb41798b = $e1dc708904eaae62$var$disable;
function $e1dc708904eaae62$var$disable() {
    $e1dc708904eaae62$var$enabled = false;
    $4SONH._B = null;
    $4SONH._C = null;
}
$e1dc708904eaae62$export$d7c4a0dd6a4567e5 = $e1dc708904eaae62$var$enable;
function $e1dc708904eaae62$var$enable(options) {
    options = options || {};
    if ($e1dc708904eaae62$var$enabled) $e1dc708904eaae62$var$disable();
    $e1dc708904eaae62$var$enabled = true;
    var id = 0;
    var displayId = 0;
    var rejections = {};
    $4SONH._B = function(promise) {
        if (promise._y === 2 && // IS REJECTED
        rejections[promise._E]) {
            if (rejections[promise._E].logged) onHandled(promise._E);
            else clearTimeout(rejections[promise._E].timeout);
            delete rejections[promise._E];
        }
    };
    $4SONH._C = function(promise, err) {
        if (promise._x === 0) {
            promise._E = id++;
            rejections[promise._E] = {
                displayId: null,
                error: err,
                timeout: setTimeout(onUnhandled.bind(null, promise._E), // For reference errors and type errors, this almost always
                // means the programmer made a mistake, so log them after just
                // 100ms
                // otherwise, wait 2 seconds to see if they get handled
                $e1dc708904eaae62$var$matchWhitelist(err, $e1dc708904eaae62$var$DEFAULT_WHITELIST) ? 100 : 2000),
                logged: false
            };
        }
    };
    function onUnhandled(id) {
        if (options.allRejections || $e1dc708904eaae62$var$matchWhitelist(rejections[id].error, options.whitelist || $e1dc708904eaae62$var$DEFAULT_WHITELIST)) {
            rejections[id].displayId = displayId++;
            if (options.onUnhandled) {
                rejections[id].logged = true;
                options.onUnhandled(rejections[id].displayId, rejections[id].error);
            } else {
                rejections[id].logged = true;
                $e1dc708904eaae62$var$logError(rejections[id].displayId, rejections[id].error);
            }
        }
    }
    function onHandled(id) {
        if (rejections[id].logged) {
            if (options.onHandled) options.onHandled(rejections[id].displayId, rejections[id].error);
            else if (!rejections[id].onUnhandled) {
                console.warn('Promise Rejection Handled (id: ' + rejections[id].displayId + '):');
                console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + rejections[id].displayId + '.');
            }
        }
    }
}
function $e1dc708904eaae62$var$logError(id, error) {
    console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
    var errStr = (error && (error.stack || error)) + '';
    errStr.split('\n').forEach(function(line) {
        console.warn('  ' + line);
    });
}
function $e1dc708904eaae62$var$matchWhitelist(error, list) {
    return list.some(function(cls) {
        return error instanceof cls;
    });
}

});
parcelRegister("4SONH", function(module, exports) {
'use strict';

var $jQpSo = parcelRequire("jQpSo");
function $38e39c80b5765669$var$noop() {}
// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable
// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.
// to avoid using try/catch inside critical functions, we
// extract them to here.
var $38e39c80b5765669$var$LAST_ERROR = null;
var $38e39c80b5765669$var$IS_ERROR = {};
function $38e39c80b5765669$var$getThen(obj) {
    try {
        return obj.then;
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
function $38e39c80b5765669$var$tryCallOne(fn, a) {
    try {
        return fn(a);
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
function $38e39c80b5765669$var$tryCallTwo(fn, a, b) {
    try {
        fn(a, b);
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
module.exports = $38e39c80b5765669$var$Promise;
function $38e39c80b5765669$var$Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('Promise constructor\'s argument is not a function');
    this._x = 0;
    this._y = 0;
    this._z = null;
    this._A = null;
    if (fn === $38e39c80b5765669$var$noop) return;
    $38e39c80b5765669$var$doResolve(fn, this);
}
$38e39c80b5765669$var$Promise._B = null;
$38e39c80b5765669$var$Promise._C = null;
$38e39c80b5765669$var$Promise._D = $38e39c80b5765669$var$noop;
$38e39c80b5765669$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    if (this.constructor !== $38e39c80b5765669$var$Promise) return $38e39c80b5765669$var$safeThen(this, onFulfilled, onRejected);
    var res = new $38e39c80b5765669$var$Promise($38e39c80b5765669$var$noop);
    $38e39c80b5765669$var$handle(this, new $38e39c80b5765669$var$Handler(onFulfilled, onRejected, res));
    return res;
};
function $38e39c80b5765669$var$safeThen(self, onFulfilled, onRejected) {
    return new self.constructor(function(resolve, reject) {
        var res = new $38e39c80b5765669$var$Promise($38e39c80b5765669$var$noop);
        res.then(resolve, reject);
        $38e39c80b5765669$var$handle(self, new $38e39c80b5765669$var$Handler(onFulfilled, onRejected, res));
    });
}
function $38e39c80b5765669$var$handle(self, deferred) {
    while(self._y === 3)self = self._z;
    if ($38e39c80b5765669$var$Promise._B) $38e39c80b5765669$var$Promise._B(self);
    if (self._y === 0) {
        if (self._x === 0) {
            self._x = 1;
            self._A = deferred;
            return;
        }
        if (self._x === 1) {
            self._x = 2;
            self._A = [
                self._A,
                deferred
            ];
            return;
        }
        self._A.push(deferred);
        return;
    }
    $38e39c80b5765669$var$handleResolved(self, deferred);
}
function $38e39c80b5765669$var$handleResolved(self, deferred) {
    $jQpSo(function() {
        var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            if (self._y === 1) $38e39c80b5765669$var$resolve(deferred.promise, self._z);
            else $38e39c80b5765669$var$reject(deferred.promise, self._z);
            return;
        }
        var ret = $38e39c80b5765669$var$tryCallOne(cb, self._z);
        if (ret === $38e39c80b5765669$var$IS_ERROR) $38e39c80b5765669$var$reject(deferred.promise, $38e39c80b5765669$var$LAST_ERROR);
        else $38e39c80b5765669$var$resolve(deferred.promise, ret);
    });
}
function $38e39c80b5765669$var$resolve(self, newValue) {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) return $38e39c80b5765669$var$reject(self, new TypeError('A promise cannot be resolved with itself.'));
    if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = $38e39c80b5765669$var$getThen(newValue);
        if (then === $38e39c80b5765669$var$IS_ERROR) return $38e39c80b5765669$var$reject(self, $38e39c80b5765669$var$LAST_ERROR);
        if (then === self.then && newValue instanceof $38e39c80b5765669$var$Promise) {
            self._y = 3;
            self._z = newValue;
            $38e39c80b5765669$var$finale(self);
            return;
        } else if (typeof then === 'function') {
            $38e39c80b5765669$var$doResolve(then.bind(newValue), self);
            return;
        }
    }
    self._y = 1;
    self._z = newValue;
    $38e39c80b5765669$var$finale(self);
}
function $38e39c80b5765669$var$reject(self, newValue) {
    self._y = 2;
    self._z = newValue;
    if ($38e39c80b5765669$var$Promise._C) $38e39c80b5765669$var$Promise._C(self, newValue);
    $38e39c80b5765669$var$finale(self);
}
function $38e39c80b5765669$var$finale(self) {
    if (self._x === 1) {
        $38e39c80b5765669$var$handle(self, self._A);
        self._A = null;
    }
    if (self._x === 2) {
        for(var i = 0; i < self._A.length; i++)$38e39c80b5765669$var$handle(self, self._A[i]);
        self._A = null;
    }
}
function $38e39c80b5765669$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $38e39c80b5765669$var$doResolve(fn, promise) {
    var done = false;
    var res = $38e39c80b5765669$var$tryCallTwo(fn, function(value) {
        if (done) return;
        done = true;
        $38e39c80b5765669$var$resolve(promise, value);
    }, function(reason) {
        if (done) return;
        done = true;
        $38e39c80b5765669$var$reject(promise, reason);
    });
    if (!done && res === $38e39c80b5765669$var$IS_ERROR) {
        done = true;
        $38e39c80b5765669$var$reject(promise, $38e39c80b5765669$var$LAST_ERROR);
    }
}

});
parcelRegister("jQpSo", function(module, exports) {
"use strict";
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = $e726f225b7e4c6c6$var$rawAsap;
function $e726f225b7e4c6c6$var$rawAsap(task) {
    if (!$e726f225b7e4c6c6$var$queue.length) {
        $e726f225b7e4c6c6$var$requestFlush();
        $e726f225b7e4c6c6$var$flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    $e726f225b7e4c6c6$var$queue[$e726f225b7e4c6c6$var$queue.length] = task;
}
var $e726f225b7e4c6c6$var$queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var $e726f225b7e4c6c6$var$flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var $e726f225b7e4c6c6$var$requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var $e726f225b7e4c6c6$var$index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var $e726f225b7e4c6c6$var$capacity = 1024;
// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function $e726f225b7e4c6c6$var$flush() {
    while($e726f225b7e4c6c6$var$index < $e726f225b7e4c6c6$var$queue.length){
        var currentIndex = $e726f225b7e4c6c6$var$index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        $e726f225b7e4c6c6$var$index = $e726f225b7e4c6c6$var$index + 1;
        $e726f225b7e4c6c6$var$queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if ($e726f225b7e4c6c6$var$index > $e726f225b7e4c6c6$var$capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for(var scan = 0, newLength = $e726f225b7e4c6c6$var$queue.length - $e726f225b7e4c6c6$var$index; scan < newLength; scan++)$e726f225b7e4c6c6$var$queue[scan] = $e726f225b7e4c6c6$var$queue[scan + $e726f225b7e4c6c6$var$index];
            $e726f225b7e4c6c6$var$queue.length -= $e726f225b7e4c6c6$var$index;
            $e726f225b7e4c6c6$var$index = 0;
        }
    }
    $e726f225b7e4c6c6$var$queue.length = 0;
    $e726f225b7e4c6c6$var$index = 0;
    $e726f225b7e4c6c6$var$flushing = false;
}
// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var $e726f225b7e4c6c6$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
var $e726f225b7e4c6c6$var$BrowserMutationObserver = $e726f225b7e4c6c6$var$scope.MutationObserver || $e726f225b7e4c6c6$var$scope.WebKitMutationObserver;
// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof $e726f225b7e4c6c6$var$BrowserMutationObserver === "function") $e726f225b7e4c6c6$var$requestFlush = $e726f225b7e4c6c6$var$makeRequestCallFromMutationObserver($e726f225b7e4c6c6$var$flush);
else $e726f225b7e4c6c6$var$requestFlush = $e726f225b7e4c6c6$var$makeRequestCallFromTimer($e726f225b7e4c6c6$var$flush);
// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
$e726f225b7e4c6c6$var$rawAsap.requestFlush = $e726f225b7e4c6c6$var$requestFlush;
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $e726f225b7e4c6c6$var$makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new $e726f225b7e4c6c6$var$BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
function $e726f225b7e4c6c6$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
$e726f225b7e4c6c6$var$rawAsap.makeRequestCallFromTimer = $e726f225b7e4c6c6$var$makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

});



parcelRegister("b0WhD", function(module, exports) {
'use strict';

var $4SONH = parcelRequire("4SONH");
module.exports = $4SONH;
/* Static Functions */ var $804ce7adfc1784b1$var$TRUE = $804ce7adfc1784b1$var$valuePromise(true);
var $804ce7adfc1784b1$var$FALSE = $804ce7adfc1784b1$var$valuePromise(false);
var $804ce7adfc1784b1$var$NULL = $804ce7adfc1784b1$var$valuePromise(null);
var $804ce7adfc1784b1$var$UNDEFINED = $804ce7adfc1784b1$var$valuePromise(undefined);
var $804ce7adfc1784b1$var$ZERO = $804ce7adfc1784b1$var$valuePromise(0);
var $804ce7adfc1784b1$var$EMPTYSTRING = $804ce7adfc1784b1$var$valuePromise('');
function $804ce7adfc1784b1$var$valuePromise(value) {
    var p = new $4SONH($4SONH._D);
    p._y = 1;
    p._z = value;
    return p;
}
$4SONH.resolve = function(value) {
    if (value instanceof $4SONH) return value;
    if (value === null) return $804ce7adfc1784b1$var$NULL;
    if (value === undefined) return $804ce7adfc1784b1$var$UNDEFINED;
    if (value === true) return $804ce7adfc1784b1$var$TRUE;
    if (value === false) return $804ce7adfc1784b1$var$FALSE;
    if (value === 0) return $804ce7adfc1784b1$var$ZERO;
    if (value === '') return $804ce7adfc1784b1$var$EMPTYSTRING;
    if (typeof value === 'object' || typeof value === 'function') try {
        var then = value.then;
        if (typeof then === 'function') return new $4SONH(then.bind(value));
    } catch (ex) {
        return new $4SONH(function(resolve, reject) {
            reject(ex);
        });
    }
    return $804ce7adfc1784b1$var$valuePromise(value);
};
var $804ce7adfc1784b1$var$iterableToArray = function(iterable) {
    if (typeof Array.from === 'function') {
        // ES2015+, iterables exist
        $804ce7adfc1784b1$var$iterableToArray = Array.from;
        return Array.from(iterable);
    }
    // ES5, only arrays and array-likes exist
    $804ce7adfc1784b1$var$iterableToArray = function(x) {
        return Array.prototype.slice.call(x);
    };
    return Array.prototype.slice.call(iterable);
};
$4SONH.all = function(arr) {
    var args = $804ce7adfc1784b1$var$iterableToArray(arr);
    return new $4SONH(function(resolve, reject) {
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                if (val instanceof $4SONH && val.then === $4SONH.prototype.then) {
                    while(val._y === 3)val = val._z;
                    if (val._y === 1) return res(i, val._z);
                    if (val._y === 2) reject(val._z);
                    val.then(function(val) {
                        res(i, val);
                    }, reject);
                    return;
                } else {
                    var then = val.then;
                    if (typeof then === 'function') {
                        var p = new $4SONH(then.bind(val));
                        p.then(function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
            }
            args[i] = val;
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
function $804ce7adfc1784b1$var$onSettledFulfill(value) {
    return {
        status: 'fulfilled',
        value: value
    };
}
function $804ce7adfc1784b1$var$onSettledReject(reason) {
    return {
        status: 'rejected',
        reason: reason
    };
}
function $804ce7adfc1784b1$var$mapAllSettled(item) {
    if (item && (typeof item === 'object' || typeof item === 'function')) {
        if (item instanceof $4SONH && item.then === $4SONH.prototype.then) return item.then($804ce7adfc1784b1$var$onSettledFulfill, $804ce7adfc1784b1$var$onSettledReject);
        var then = item.then;
        if (typeof then === 'function') return new $4SONH(then.bind(item)).then($804ce7adfc1784b1$var$onSettledFulfill, $804ce7adfc1784b1$var$onSettledReject);
    }
    return $804ce7adfc1784b1$var$onSettledFulfill(item);
}
$4SONH.allSettled = function(iterable) {
    return $4SONH.all($804ce7adfc1784b1$var$iterableToArray(iterable).map($804ce7adfc1784b1$var$mapAllSettled));
};
$4SONH.reject = function(value) {
    return new $4SONH(function(resolve, reject) {
        reject(value);
    });
};
$4SONH.race = function(values) {
    return new $4SONH(function(resolve, reject) {
        $804ce7adfc1784b1$var$iterableToArray(values).forEach(function(value) {
            $4SONH.resolve(value).then(resolve, reject);
        });
    });
};
/* Prototype Methods */ $4SONH.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
function $804ce7adfc1784b1$var$getAggregateError(errors) {
    if (typeof AggregateError === 'function') return new AggregateError(errors, 'All promises were rejected');
    var error = new Error('All promises were rejected');
    error.name = 'AggregateError';
    error.errors = errors;
    return error;
}
$4SONH.any = function promiseAny(values) {
    return new $4SONH(function(resolve, reject) {
        var promises = $804ce7adfc1784b1$var$iterableToArray(values);
        var hasResolved = false;
        var rejectionReasons = [];
        function resolveOnce(value) {
            if (!hasResolved) {
                hasResolved = true;
                resolve(value);
            }
        }
        function rejectionCheck(reason) {
            rejectionReasons.push(reason);
            if (rejectionReasons.length === promises.length) reject($804ce7adfc1784b1$var$getAggregateError(rejectionReasons));
        }
        if (promises.length === 0) reject($804ce7adfc1784b1$var$getAggregateError(rejectionReasons));
        else promises.forEach(function(value) {
            $4SONH.resolve(value).then(resolveOnce, rejectionCheck);
        });
    });
};

});

parcelRegister("aZEZV", function(module, exports) {

$parcel$export(module.exports, "Headers", function () { return $800f672d0d31be6d$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $800f672d0d31be6d$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $800f672d0d31be6d$export$9f633d56d7ec90d3; });
$parcel$export(module.exports, "DOMException", function () { return $800f672d0d31be6d$export$fe58bcf938607f6a; });
$parcel$export(module.exports, "fetch", function () { return $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3; });
/* eslint-disable no-prototype-builtins */ var $800f672d0d31be6d$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $800f672d0d31be6d$var$support = {
    searchParams: 'URLSearchParams' in $800f672d0d31be6d$var$g,
    iterable: 'Symbol' in $800f672d0d31be6d$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $800f672d0d31be6d$var$g && 'Blob' in $800f672d0d31be6d$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $800f672d0d31be6d$var$g,
    arrayBuffer: 'ArrayBuffer' in $800f672d0d31be6d$var$g
};
function $800f672d0d31be6d$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($800f672d0d31be6d$var$support.arrayBuffer) {
    var $800f672d0d31be6d$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $800f672d0d31be6d$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $800f672d0d31be6d$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $800f672d0d31be6d$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $800f672d0d31be6d$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $800f672d0d31be6d$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($800f672d0d31be6d$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $800f672d0d31be6d$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $800f672d0d31be6d$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $800f672d0d31be6d$var$normalizeName(name);
    value = $800f672d0d31be6d$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$800f672d0d31be6d$var$normalizeName(name)];
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $800f672d0d31be6d$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($800f672d0d31be6d$var$normalizeName(name));
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$800f672d0d31be6d$var$normalizeName(name)] = $800f672d0d31be6d$var$normalizeValue(value);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
if ($800f672d0d31be6d$var$support.iterable) $800f672d0d31be6d$export$79b704688b15c0f4.prototype[Symbol.iterator] = $800f672d0d31be6d$export$79b704688b15c0f4.prototype.entries;
function $800f672d0d31be6d$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $800f672d0d31be6d$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $800f672d0d31be6d$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $800f672d0d31be6d$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $800f672d0d31be6d$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $800f672d0d31be6d$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $800f672d0d31be6d$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $800f672d0d31be6d$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $800f672d0d31be6d$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($800f672d0d31be6d$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($800f672d0d31be6d$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($800f672d0d31be6d$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($800f672d0d31be6d$var$support.arrayBuffer && $800f672d0d31be6d$var$support.blob && $800f672d0d31be6d$var$isDataView(body)) {
            this._bodyArrayBuffer = $800f672d0d31be6d$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($800f672d0d31be6d$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $800f672d0d31be6d$var$isArrayBufferView(body))) this._bodyArrayBuffer = $800f672d0d31be6d$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($800f672d0d31be6d$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($800f672d0d31be6d$var$support.blob) this.blob = function() {
        var rejected = $800f672d0d31be6d$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $800f672d0d31be6d$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($800f672d0d31be6d$var$support.blob) return this.blob().then($800f672d0d31be6d$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $800f672d0d31be6d$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $800f672d0d31be6d$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($800f672d0d31be6d$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($800f672d0d31be6d$var$support.formData) this.formData = function() {
        return this.text().then($800f672d0d31be6d$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $800f672d0d31be6d$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $800f672d0d31be6d$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $800f672d0d31be6d$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $800f672d0d31be6d$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $800f672d0d31be6d$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $800f672d0d31be6d$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(options.headers);
    this.method = $800f672d0d31be6d$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $800f672d0d31be6d$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$800f672d0d31be6d$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $800f672d0d31be6d$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $800f672d0d31be6d$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $800f672d0d31be6d$var$parseHeaders(rawHeaders) {
    var headers = new $800f672d0d31be6d$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$800f672d0d31be6d$var$Body.call($800f672d0d31be6d$export$7fa6c5b6f8193917.prototype);
function $800f672d0d31be6d$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $800f672d0d31be6d$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$800f672d0d31be6d$var$Body.call($800f672d0d31be6d$export$9f633d56d7ec90d3.prototype);
$800f672d0d31be6d$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $800f672d0d31be6d$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $800f672d0d31be6d$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$800f672d0d31be6d$export$9f633d56d7ec90d3.error = function() {
    var response = new $800f672d0d31be6d$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $800f672d0d31be6d$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$800f672d0d31be6d$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($800f672d0d31be6d$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $800f672d0d31be6d$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $800f672d0d31be6d$export$fe58bcf938607f6a = $800f672d0d31be6d$var$g.DOMException;
try {
    new $800f672d0d31be6d$export$fe58bcf938607f6a();
} catch (err) {
    $800f672d0d31be6d$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $800f672d0d31be6d$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $800f672d0d31be6d$export$fe58bcf938607f6a.prototype.constructor = $800f672d0d31be6d$export$fe58bcf938607f6a;
}
function $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $800f672d0d31be6d$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $800f672d0d31be6d$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $800f672d0d31be6d$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $800f672d0d31be6d$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $800f672d0d31be6d$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $800f672d0d31be6d$var$g.location.href ? $800f672d0d31be6d$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($800f672d0d31be6d$var$support.blob) xhr.responseType = 'blob';
            else if ($800f672d0d31be6d$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $800f672d0d31be6d$export$79b704688b15c0f4 || $800f672d0d31be6d$var$g.Headers && init.headers instanceof $800f672d0d31be6d$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($800f672d0d31be6d$var$normalizeName(name));
                xhr.setRequestHeader(name, $800f672d0d31be6d$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$800f672d0d31be6d$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$800f672d0d31be6d$var$g.fetch) {
    $800f672d0d31be6d$var$g.fetch = $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3;
    $800f672d0d31be6d$var$g.Headers = $800f672d0d31be6d$export$79b704688b15c0f4;
    $800f672d0d31be6d$var$g.Request = $800f672d0d31be6d$export$7fa6c5b6f8193917;
    $800f672d0d31be6d$var$g.Response = $800f672d0d31be6d$export$9f633d56d7ec90d3;
}

});

parcelRegister("cbYl1", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $8e055102d0a4bcdc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8e055102d0a4bcdc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8e055102d0a4bcdc$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $8e055102d0a4bcdc$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $8e055102d0a4bcdc$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $8e055102d0a4bcdc$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $8e055102d0a4bcdc$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($8e055102d0a4bcdc$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($8e055102d0a4bcdc$var$getOwnPropertySymbols) {
            symbols = $8e055102d0a4bcdc$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($8e055102d0a4bcdc$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7h4ZC", function(module, exports) {
'use strict';

var $13EFV = parcelRequire("13EFV");
parcelRequire("B3Rmu");
parcelRequire("7H6Ip");
parcelRequire("dqfzw");
parcelRequire("1Uru5");
parcelRequire("3CVe2");
parcelRequire("5UszO");
parcelRequire("cxaIU");
parcelRequire("kIR3S");
parcelRequire("2u8TL");
parcelRequire("khlXA");
module.exports = $13EFV;

});
parcelRegister("13EFV", function(module, exports) {
'use strict';

var $kvQwq = parcelRequire("kvQwq");
parcelRequire("4AEWC");
parcelRequire("h3JRe");
parcelRequire("haEFx");
parcelRequire("lYc2Q");
module.exports = $kvQwq;

});
parcelRegister("kvQwq", function(module, exports) {
'use strict';

var $bTQWA = parcelRequire("bTQWA");
parcelRequire("3SQhX");
module.exports = $bTQWA;

});
parcelRegister("bTQWA", function(module, exports) {
'use strict';
parcelRequire("lyoXg");
parcelRequire("1aLfi");
parcelRequire("dkMmr");
parcelRequire("hPO2C");
parcelRequire("bGQI8");
parcelRequire("sd6Ri");
parcelRequire("lsEcz");
parcelRequire("2poLz");
parcelRequire("b49To");
parcelRequire("7EE6t");
parcelRequire("2kqse");
parcelRequire("39hva");
parcelRequire("5XA6M");
parcelRequire("1yBYS");
parcelRequire("6knIt");
parcelRequire("fkY1G");
parcelRequire("dFgdm");
parcelRequire("crz9y");
parcelRequire("6fJW1");
parcelRequire("kJNPM");
parcelRequire("cgXro");
parcelRequire("hsROu");

var $9AtxJ = parcelRequire("9AtxJ");
module.exports = $9AtxJ.Symbol;

});
parcelRegister("lyoXg", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $bAE3C = parcelRequire("bAE3C");

var $ay2cC = parcelRequire("ay2cC");

var $9OhmT = parcelRequire("9OhmT");

var $hicPf = parcelRequire("hicPf");

var $6HcaS = parcelRequire("6HcaS");

var $hjGLe = parcelRequire("hjGLe");

var $7F0dl = parcelRequire("7F0dl");

var $gqEDU = parcelRequire("gqEDU");

var $lRrDo = parcelRequire("lRrDo");

var $6Sqdy = parcelRequire("6Sqdy");

var $mgvTx = parcelRequire("mgvTx");

var $9FPXB = parcelRequire("9FPXB");
var $fb10217466c7da75$var$IS_CONCAT_SPREADABLE = $mgvTx('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $fb10217466c7da75$var$IS_CONCAT_SPREADABLE_SUPPORT = $9FPXB >= 51 || !$bAE3C(function() {
    var array = [];
    array[$fb10217466c7da75$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $fb10217466c7da75$var$isConcatSpreadable = function(O) {
    if (!$9OhmT(O)) return false;
    var spreadable = O[$fb10217466c7da75$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $ay2cC(O);
};
var $fb10217466c7da75$var$FORCED = !$fb10217466c7da75$var$IS_CONCAT_SPREADABLE_SUPPORT || !$6Sqdy('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$1XSJh({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $fb10217466c7da75$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $hicPf(this);
        var A = $lRrDo(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($fb10217466c7da75$var$isConcatSpreadable(E)) {
                len = $6HcaS(E);
                $hjGLe(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $7F0dl(A, n, E[k]);
            } else {
                $hjGLe(n + 1);
                $7F0dl(A, n++, E);
            }
        }
        $gqEDU(A, n);
        return A;
    }
});

});
parcelRegister("1XSJh", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $kmjYa = parcelRequire("kmjYa");
var $16e5c14025897904$require$getOwnPropertyDescriptor = $kmjYa.f;

var $aPaKH = parcelRequire("aPaKH");

var $2t4Gp = parcelRequire("2t4Gp");

var $f3kK8 = parcelRequire("f3kK8");

var $fnTTa = parcelRequire("fnTTa");

var $bp1kS = parcelRequire("bp1kS");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $kvDzZ;
    else if (STATIC) target = $kvDzZ[TARGET] || $f3kK8(TARGET, {});
    else target = $kvDzZ[TARGET] && $kvDzZ[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $16e5c14025897904$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $bp1kS(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $fnTTa(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $aPaKH(sourceProperty, 'sham', true);
        $2t4Gp(target, key, sourceProperty, options);
    }
};

});
parcelRegister("kvDzZ", function(module, exports) {
'use strict';
var $eee5678a9ae0b7c5$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$eee5678a9ae0b7c5$var$check(typeof globalThis == 'object' && globalThis) || $eee5678a9ae0b7c5$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$eee5678a9ae0b7c5$var$check(typeof self == 'object' && self) || $eee5678a9ae0b7c5$var$check(typeof $parcel$global == 'object' && $parcel$global) || $eee5678a9ae0b7c5$var$check(typeof module.exports == 'object' && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("kmjYa", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ed255a3f44f06044$export$2d1720544b23b823; }, function (v) { return $ed255a3f44f06044$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $ed255a3f44f06044$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $8lKVU = parcelRequire("8lKVU");

var $5luz1 = parcelRequire("5luz1");

var $3qjfQ = parcelRequire("3qjfQ");

var $4EWOr = parcelRequire("4EWOr");

var $eSWL8 = parcelRequire("eSWL8");

var $keZ2c = parcelRequire("keZ2c");

var $fydMg = parcelRequire("fydMg");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ed255a3f44f06044$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$ed255a3f44f06044$export$2d1720544b23b823 = $9100U ? $ed255a3f44f06044$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4EWOr(O);
    P = $eSWL8(P);
    if ($fydMg) try {
        return $ed255a3f44f06044$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($keZ2c(O, P)) return $3qjfQ(!$8lKVU($5luz1.f, O, P), O[P]);
};

});
parcelRegister("9100U", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});
parcelRegister("bAE3C", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRegister("8lKVU", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $6144b0d3c69220c6$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $c3otN ? $6144b0d3c69220c6$var$call.bind($6144b0d3c69220c6$var$call) : function() {
    return $6144b0d3c69220c6$var$call.apply($6144b0d3c69220c6$var$call, arguments);
};

});
parcelRegister("c3otN", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
module.exports = !$bAE3C(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});


parcelRegister("5luz1", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3e469f440f32c89f$export$2d1720544b23b823; }, function (v) { return $3e469f440f32c89f$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $3e469f440f32c89f$export$2d1720544b23b823;
'use strict';
var $3e469f440f32c89f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3e469f440f32c89f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3e469f440f32c89f$var$NASHORN_BUG = $3e469f440f32c89f$var$getOwnPropertyDescriptor && !$3e469f440f32c89f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$3e469f440f32c89f$export$2d1720544b23b823 = $3e469f440f32c89f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3e469f440f32c89f$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3e469f440f32c89f$var$$propertyIsEnumerable;

});

parcelRegister("3qjfQ", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("4EWOr", function(module, exports) {
'use strict';

var $8SixO = parcelRequire("8SixO");

var $388Wm = parcelRequire("388Wm");
module.exports = function(it) {
    return $8SixO($388Wm(it));
};

});
parcelRegister("8SixO", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $fcHE3 = parcelRequire("fcHE3");
var $6761c06983d4c679$var$$Object = Object;
var $6761c06983d4c679$var$split = $7n9WH(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $bAE3C(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$6761c06983d4c679$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $fcHE3(it) === 'String' ? $6761c06983d4c679$var$split(it, '') : $6761c06983d4c679$var$$Object(it);
} : $6761c06983d4c679$var$$Object;

});
parcelRegister("7n9WH", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $55e2656d548a6fc1$var$FunctionPrototype = Function.prototype;
var $55e2656d548a6fc1$var$call = $55e2656d548a6fc1$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $55e2656d548a6fc1$var$uncurryThisWithBind = $c3otN && $55e2656d548a6fc1$var$FunctionPrototype.bind.bind($55e2656d548a6fc1$var$call, $55e2656d548a6fc1$var$call);
module.exports = $c3otN ? $55e2656d548a6fc1$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $55e2656d548a6fc1$var$call.apply(fn, arguments);
    };
};

});

parcelRegister("fcHE3", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
var $b119d503052534af$var$toString = $7n9WH({}.toString);
var $b119d503052534af$var$stringSlice = $7n9WH(''.slice);
module.exports = function(it) {
    return $b119d503052534af$var$stringSlice($b119d503052534af$var$toString(it), 8, -1);
};

});


parcelRegister("388Wm", function(module, exports) {
'use strict';

var $hKX7u = parcelRequire("hKX7u");
var $24790dcafb0ddc3d$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($hKX7u(it)) throw new $24790dcafb0ddc3d$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("hKX7u", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("eSWL8", function(module, exports) {
'use strict';

var $2W54u = parcelRequire("2W54u");

var $1Q1gI = parcelRequire("1Q1gI");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $2W54u(argument, 'string');
    return $1Q1gI(key) ? key : key + '';
};

});
parcelRegister("2W54u", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $9OhmT = parcelRequire("9OhmT");

var $1Q1gI = parcelRequire("1Q1gI");

var $eZ5qV = parcelRequire("eZ5qV");

var $5ghrU = parcelRequire("5ghrU");

var $mgvTx = parcelRequire("mgvTx");
var $2234eea1b9da0598$var$$TypeError = TypeError;
var $2234eea1b9da0598$var$TO_PRIMITIVE = $mgvTx('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$9OhmT(input) || $1Q1gI(input)) return input;
    var exoticToPrim = $eZ5qV(input, $2234eea1b9da0598$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $8lKVU(exoticToPrim, input, pref);
        if (!$9OhmT(result) || $1Q1gI(result)) return result;
        throw new $2234eea1b9da0598$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $5ghrU(input, pref);
};

});
parcelRegister("9OhmT", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : $1ZKCr(it);
};

});
parcelRegister("1ZKCr", function(module, exports) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $173fa684f12168d1$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $173fa684f12168d1$var$documentAll == 'undefined' && $173fa684f12168d1$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $173fa684f12168d1$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});


parcelRegister("1Q1gI", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $1ZKCr = parcelRequire("1ZKCr");

var $7mAhs = parcelRequire("7mAhs");

var $iqMxs = parcelRequire("iqMxs");
var $156ba1b3b70e8441$var$$Object = Object;
module.exports = $iqMxs ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $4uwSa('Symbol');
    return $1ZKCr($Symbol) && $7mAhs($Symbol.prototype, $156ba1b3b70e8441$var$$Object(it));
};

});
parcelRegister("4uwSa", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $1ZKCr = parcelRequire("1ZKCr");
var $3453769bace2d3ce$var$aFunction = function(argument) {
    return $1ZKCr(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $3453769bace2d3ce$var$aFunction($kvDzZ[namespace]) : $kvDzZ[namespace] && $kvDzZ[namespace][method];
};

});

parcelRegister("7mAhs", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
module.exports = $7n9WH({}.isPrototypeOf);

});

parcelRegister("iqMxs", function(module, exports) {
'use strict';

var $iKqSh = parcelRequire("iKqSh");
module.exports = $iKqSh && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});
parcelRegister("iKqSh", function(module, exports) {
'use strict';

var $9FPXB = parcelRequire("9FPXB");

var $bAE3C = parcelRequire("bAE3C");

var $kvDzZ = parcelRequire("kvDzZ");
var $da615e9761d472e5$var$$String = $kvDzZ.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$bAE3C(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$da615e9761d472e5$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $9FPXB && $9FPXB < 41;
});

});
parcelRegister("9FPXB", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $7J63U = parcelRequire("7J63U");
var $70b03fa5d903865b$var$process = $kvDzZ.process;
var $70b03fa5d903865b$var$Deno = $kvDzZ.Deno;
var $70b03fa5d903865b$var$versions = $70b03fa5d903865b$var$process && $70b03fa5d903865b$var$process.versions || $70b03fa5d903865b$var$Deno && $70b03fa5d903865b$var$Deno.version;
var $70b03fa5d903865b$var$v8 = $70b03fa5d903865b$var$versions && $70b03fa5d903865b$var$versions.v8;
var $70b03fa5d903865b$var$match, $70b03fa5d903865b$var$version;
if ($70b03fa5d903865b$var$v8) {
    $70b03fa5d903865b$var$match = $70b03fa5d903865b$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $70b03fa5d903865b$var$version = $70b03fa5d903865b$var$match[0] > 0 && $70b03fa5d903865b$var$match[0] < 4 ? 1 : +($70b03fa5d903865b$var$match[0] + $70b03fa5d903865b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$70b03fa5d903865b$var$version && $7J63U) {
    $70b03fa5d903865b$var$match = $7J63U.match(/Edge\/(\d+)/);
    if (!$70b03fa5d903865b$var$match || $70b03fa5d903865b$var$match[1] >= 74) {
        $70b03fa5d903865b$var$match = $7J63U.match(/Chrome\/(\d+)/);
        if ($70b03fa5d903865b$var$match) $70b03fa5d903865b$var$version = +$70b03fa5d903865b$var$match[1];
    }
}
module.exports = $70b03fa5d903865b$var$version;

});
parcelRegister("7J63U", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
var $5a0170289caee550$var$navigator = $kvDzZ.navigator;
var $5a0170289caee550$var$userAgent = $5a0170289caee550$var$navigator && $5a0170289caee550$var$navigator.userAgent;
module.exports = $5a0170289caee550$var$userAgent ? String($5a0170289caee550$var$userAgent) : '';

});





parcelRegister("eZ5qV", function(module, exports) {
'use strict';

var $g7x3l = parcelRequire("g7x3l");

var $hKX7u = parcelRequire("hKX7u");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $hKX7u(func) ? undefined : $g7x3l(func);
};

});
parcelRegister("g7x3l", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");

var $7MtCT = parcelRequire("7MtCT");
var $bbc6f070263d3c4f$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($1ZKCr(argument)) return argument;
    throw new $bbc6f070263d3c4f$var$$TypeError($7MtCT(argument) + ' is not a function');
};

});
parcelRegister("7MtCT", function(module, exports) {
'use strict';
var $5aa3ff46ee7d982f$var$$String = String;
module.exports = function(argument) {
    try {
        return $5aa3ff46ee7d982f$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("5ghrU", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $1ZKCr = parcelRequire("1ZKCr");

var $9OhmT = parcelRequire("9OhmT");
var $3d4bfb64fa47d8ec$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $1ZKCr(fn = input.toString) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    if ($1ZKCr(fn = input.valueOf) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    if (pref !== 'string' && $1ZKCr(fn = input.toString) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    throw new $3d4bfb64fa47d8ec$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("mgvTx", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $cITHp = parcelRequire("cITHp");

var $keZ2c = parcelRequire("keZ2c");

var $66HFQ = parcelRequire("66HFQ");

var $iKqSh = parcelRequire("iKqSh");

var $iqMxs = parcelRequire("iqMxs");
var $042edd699f2e22e9$var$Symbol = $kvDzZ.Symbol;
var $042edd699f2e22e9$var$WellKnownSymbolsStore = $cITHp('wks');
var $042edd699f2e22e9$var$createWellKnownSymbol = $iqMxs ? $042edd699f2e22e9$var$Symbol['for'] || $042edd699f2e22e9$var$Symbol : $042edd699f2e22e9$var$Symbol && $042edd699f2e22e9$var$Symbol.withoutSetter || $66HFQ;
module.exports = function(name) {
    if (!$keZ2c($042edd699f2e22e9$var$WellKnownSymbolsStore, name)) $042edd699f2e22e9$var$WellKnownSymbolsStore[name] = $iKqSh && $keZ2c($042edd699f2e22e9$var$Symbol, name) ? $042edd699f2e22e9$var$Symbol[name] : $042edd699f2e22e9$var$createWellKnownSymbol('Symbol.' + name);
    return $042edd699f2e22e9$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("cITHp", function(module, exports) {
'use strict';

var $kMeiU = parcelRequire("kMeiU");
module.exports = function(key, value) {
    return $kMeiU[key] || ($kMeiU[key] = value || {});
};

});
parcelRegister("kMeiU", function(module, exports) {
'use strict';

var $axseE = parcelRequire("axseE");

var $kvDzZ = parcelRequire("kvDzZ");

var $f3kK8 = parcelRequire("f3kK8");
var $f20362d5610dcd3f$var$SHARED = '__core-js_shared__';
var $f20362d5610dcd3f$var$store = module.exports = $kvDzZ[$f20362d5610dcd3f$var$SHARED] || $f3kK8($f20362d5610dcd3f$var$SHARED, {});
($f20362d5610dcd3f$var$store.versions || ($f20362d5610dcd3f$var$store.versions = [])).push({
    version: '3.49.0',
    mode: $axseE ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("axseE", function(module, exports) {
'use strict';
module.exports = false;

});

parcelRegister("f3kK8", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $af5739fbebe226ea$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $af5739fbebe226ea$var$defineProperty($kvDzZ, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $kvDzZ[key] = value;
    }
    return value;
};

});



parcelRegister("keZ2c", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $hicPf = parcelRequire("hicPf");
var $ebc4759d72c8a37d$var$hasOwnProperty = $7n9WH({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $ebc4759d72c8a37d$var$hasOwnProperty($hicPf(it), key);
};

});
parcelRegister("hicPf", function(module, exports) {
'use strict';

var $388Wm = parcelRequire("388Wm");
var $c96e110268acaa11$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $c96e110268acaa11$var$$Object($388Wm(argument));
};

});


parcelRegister("66HFQ", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
var $47252e586adc78d7$var$id = 0;
var $47252e586adc78d7$var$postfix = Math.random();
var $47252e586adc78d7$var$toString = $7n9WH(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $47252e586adc78d7$var$toString(++$47252e586adc78d7$var$id + $47252e586adc78d7$var$postfix, 36);
};

});




parcelRegister("fydMg", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $bAE3C = parcelRequire("bAE3C");

var $iJAYS = parcelRequire("iJAYS");
// Thanks to IE8 for its funny defineProperty
module.exports = !$9100U && !$bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($iJAYS('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("iJAYS", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $9OhmT = parcelRequire("9OhmT");
var $da391d9ae46ed13b$var$document = $kvDzZ.document;
// typeof document.createElement is 'object' in old IE
var $da391d9ae46ed13b$var$EXISTS = $9OhmT($da391d9ae46ed13b$var$document) && $9OhmT($da391d9ae46ed13b$var$document.createElement);
module.exports = function(it) {
    return $da391d9ae46ed13b$var$EXISTS ? $da391d9ae46ed13b$var$document.createElement(it) : {};
};

});



parcelRegister("aPaKH", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $dsVjX = parcelRequire("dsVjX");

var $3qjfQ = parcelRequire("3qjfQ");
module.exports = $9100U ? function(object, key, value) {
    return $dsVjX.f(object, key, $3qjfQ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("dsVjX", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9cda5aa3742e4370$export$2d1720544b23b823; }, function (v) { return $9cda5aa3742e4370$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9cda5aa3742e4370$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $fydMg = parcelRequire("fydMg");

var $kev11 = parcelRequire("kev11");

var $4LaI4 = parcelRequire("4LaI4");

var $eSWL8 = parcelRequire("eSWL8");
var $9cda5aa3742e4370$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9cda5aa3742e4370$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9cda5aa3742e4370$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9cda5aa3742e4370$var$ENUMERABLE = 'enumerable';
var $9cda5aa3742e4370$var$CONFIGURABLE = 'configurable';
var $9cda5aa3742e4370$var$WRITABLE = 'writable';
$9cda5aa3742e4370$export$2d1720544b23b823 = $9100U ? $kev11 ? function defineProperty(O, P, Attributes) {
    $4LaI4(O);
    P = $eSWL8(P);
    $4LaI4(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $9cda5aa3742e4370$var$WRITABLE in Attributes && !Attributes[$9cda5aa3742e4370$var$WRITABLE]) {
        var current = $9cda5aa3742e4370$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9cda5aa3742e4370$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9cda5aa3742e4370$var$CONFIGURABLE in Attributes ? Attributes[$9cda5aa3742e4370$var$CONFIGURABLE] : current[$9cda5aa3742e4370$var$CONFIGURABLE],
                enumerable: $9cda5aa3742e4370$var$ENUMERABLE in Attributes ? Attributes[$9cda5aa3742e4370$var$ENUMERABLE] : current[$9cda5aa3742e4370$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9cda5aa3742e4370$var$$defineProperty(O, P, Attributes);
} : $9cda5aa3742e4370$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $4LaI4(O);
    P = $eSWL8(P);
    $4LaI4(Attributes);
    if ($fydMg) try {
        return $9cda5aa3742e4370$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $9cda5aa3742e4370$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("kev11", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $bAE3C = parcelRequire("bAE3C");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $9100U && $bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("4LaI4", function(module, exports) {
'use strict';

var $9OhmT = parcelRequire("9OhmT");
var $3773dbf118076332$var$$String = String;
var $3773dbf118076332$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($9OhmT(argument)) return argument;
    throw new $3773dbf118076332$var$$TypeError($3773dbf118076332$var$$String(argument) + ' is not an object');
};

});



parcelRegister("2t4Gp", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");

var $dsVjX = parcelRequire("dsVjX");

var $lQepi = parcelRequire("lQepi");

var $f3kK8 = parcelRequire("f3kK8");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($1ZKCr(value)) $lQepi(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f3kK8(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $dsVjX.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

});
parcelRegister("lQepi", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $keZ2c = parcelRequire("keZ2c");

var $9100U = parcelRequire("9100U");

var $hCoZT = parcelRequire("hCoZT");
var $fe69a14049adb05c$require$CONFIGURABLE_FUNCTION_NAME = $hCoZT.CONFIGURABLE;

var $f8Jih = parcelRequire("f8Jih");

var $4eljv = parcelRequire("4eljv");
var $fe69a14049adb05c$var$enforceInternalState = $4eljv.enforce;
var $fe69a14049adb05c$var$getInternalState = $4eljv.get;
var $fe69a14049adb05c$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $fe69a14049adb05c$var$defineProperty = Object.defineProperty;
var $fe69a14049adb05c$var$stringSlice = $7n9WH(''.slice);
var $fe69a14049adb05c$var$replace = $7n9WH(''.replace);
var $fe69a14049adb05c$var$join = $7n9WH([].join);
var $fe69a14049adb05c$var$CONFIGURABLE_LENGTH = $9100U && !$bAE3C(function() {
    return $fe69a14049adb05c$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $fe69a14049adb05c$var$TEMPLATE = String(String).split('String');
var $fe69a14049adb05c$var$makeBuiltIn = module.exports = function(value, name, options) {
    if ($fe69a14049adb05c$var$stringSlice($fe69a14049adb05c$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $fe69a14049adb05c$var$replace($fe69a14049adb05c$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$keZ2c(value, 'name') || $fe69a14049adb05c$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($9100U) $fe69a14049adb05c$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($fe69a14049adb05c$var$CONFIGURABLE_LENGTH && options && $keZ2c(options, 'arity') && value.length !== options.arity) $fe69a14049adb05c$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $keZ2c(options, 'constructor') && options.constructor) {
            if ($9100U) $fe69a14049adb05c$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $fe69a14049adb05c$var$enforceInternalState(value);
    if (!$keZ2c(state, 'source')) state.source = $fe69a14049adb05c$var$join($fe69a14049adb05c$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $fe69a14049adb05c$var$makeBuiltIn(function toString() {
    return $1ZKCr(this) && $fe69a14049adb05c$var$getInternalState(this).source || $f8Jih(this);
}, 'toString');

});
parcelRegister("hCoZT", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $keZ2c = parcelRequire("keZ2c");
var $cd396032df90257d$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $cd396032df90257d$var$getDescriptor = $9100U && Object.getOwnPropertyDescriptor;
var $cd396032df90257d$var$EXISTS = $keZ2c($cd396032df90257d$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $cd396032df90257d$var$PROPER = $cd396032df90257d$var$EXISTS && (function something() {}).name === 'something';
var $cd396032df90257d$var$CONFIGURABLE = $cd396032df90257d$var$EXISTS && (!$9100U || $9100U && $cd396032df90257d$var$getDescriptor($cd396032df90257d$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $cd396032df90257d$var$EXISTS,
    PROPER: $cd396032df90257d$var$PROPER,
    CONFIGURABLE: $cd396032df90257d$var$CONFIGURABLE
};

});

parcelRegister("f8Jih", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $1ZKCr = parcelRequire("1ZKCr");

var $kMeiU = parcelRequire("kMeiU");
var $b05abcc5ed289bb0$var$functionToString = $7n9WH(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$1ZKCr($kMeiU.inspectSource)) $kMeiU.inspectSource = function(it) {
    return $b05abcc5ed289bb0$var$functionToString(it);
};
module.exports = $kMeiU.inspectSource;

});

parcelRegister("4eljv", function(module, exports) {
'use strict';

var $aPGru = parcelRequire("aPGru");

var $kvDzZ = parcelRequire("kvDzZ");

var $9OhmT = parcelRequire("9OhmT");

var $aPaKH = parcelRequire("aPaKH");

var $keZ2c = parcelRequire("keZ2c");

var $kMeiU = parcelRequire("kMeiU");

var $k3YZr = parcelRequire("k3YZr");

var $3pX3o = parcelRequire("3pX3o");
var $314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $314900ac05bea597$var$TypeError = $kvDzZ.TypeError;
var $314900ac05bea597$var$WeakMap = $kvDzZ.WeakMap;
var $314900ac05bea597$var$set, $314900ac05bea597$var$get, $314900ac05bea597$var$has;
var $314900ac05bea597$var$enforce = function(it) {
    return $314900ac05bea597$var$has(it) ? $314900ac05bea597$var$get(it) : $314900ac05bea597$var$set(it, {});
};
var $314900ac05bea597$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$9OhmT(it) || (state = $314900ac05bea597$var$get(it)).type !== TYPE) throw new $314900ac05bea597$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($aPGru || $kMeiU.state) {
    var $314900ac05bea597$var$store = $kMeiU.state || ($kMeiU.state = new $314900ac05bea597$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $314900ac05bea597$var$store.get = $314900ac05bea597$var$store.get;
    $314900ac05bea597$var$store.has = $314900ac05bea597$var$store.has;
    $314900ac05bea597$var$store.set = $314900ac05bea597$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $314900ac05bea597$var$set = function(it, metadata) {
        if ($314900ac05bea597$var$store.has(it)) throw new $314900ac05bea597$var$TypeError($314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $314900ac05bea597$var$store.set(it, metadata);
        return metadata;
    };
    $314900ac05bea597$var$get = function(it) {
        return $314900ac05bea597$var$store.get(it) || {};
    };
    $314900ac05bea597$var$has = function(it) {
        return $314900ac05bea597$var$store.has(it);
    };
} else {
    var $314900ac05bea597$var$STATE = $k3YZr('state');
    $3pX3o[$314900ac05bea597$var$STATE] = true;
    $314900ac05bea597$var$set = function(it, metadata) {
        if ($keZ2c(it, $314900ac05bea597$var$STATE)) throw new $314900ac05bea597$var$TypeError($314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $aPaKH(it, $314900ac05bea597$var$STATE, metadata);
        return metadata;
    };
    $314900ac05bea597$var$get = function(it) {
        return $keZ2c(it, $314900ac05bea597$var$STATE) ? it[$314900ac05bea597$var$STATE] : {};
    };
    $314900ac05bea597$var$has = function(it) {
        return $keZ2c(it, $314900ac05bea597$var$STATE);
    };
}
module.exports = {
    set: $314900ac05bea597$var$set,
    get: $314900ac05bea597$var$get,
    has: $314900ac05bea597$var$has,
    enforce: $314900ac05bea597$var$enforce,
    getterFor: $314900ac05bea597$var$getterFor
};

});
parcelRegister("aPGru", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $1ZKCr = parcelRequire("1ZKCr");
var $7e2f96f426172600$var$WeakMap = $kvDzZ.WeakMap;
module.exports = $1ZKCr($7e2f96f426172600$var$WeakMap) && /native code/.test(String($7e2f96f426172600$var$WeakMap));

});

parcelRegister("k3YZr", function(module, exports) {
'use strict';

var $cITHp = parcelRequire("cITHp");

var $66HFQ = parcelRequire("66HFQ");
var $e9b365cbb1a86635$var$keys = $cITHp('keys');
module.exports = function(key) {
    return $e9b365cbb1a86635$var$keys[key] || ($e9b365cbb1a86635$var$keys[key] = $66HFQ(key));
};

});

parcelRegister("3pX3o", function(module, exports) {
'use strict';
module.exports = {};

});




parcelRegister("fnTTa", function(module, exports) {
'use strict';

var $keZ2c = parcelRequire("keZ2c");

var $bDDtb = parcelRequire("bDDtb");

var $kmjYa = parcelRequire("kmjYa");

var $dsVjX = parcelRequire("dsVjX");
module.exports = function(target, source, exceptions) {
    var keys = $bDDtb(source);
    var defineProperty = $dsVjX.f;
    var getOwnPropertyDescriptor = $kmjYa.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$keZ2c(target, key) && !(exceptions && $keZ2c(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("bDDtb", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");

var $3GY1P = parcelRequire("3GY1P");

var $8pg8R = parcelRequire("8pg8R");

var $4LaI4 = parcelRequire("4LaI4");
var $8791f41b6639efea$var$concat = $7n9WH([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $4uwSa('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $3GY1P.f($4LaI4(it));
    var getOwnPropertySymbols = $8pg8R.f;
    return getOwnPropertySymbols ? $8791f41b6639efea$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("3GY1P", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $2b03dbb9ef92e3eb$export$2d1720544b23b823; }, function (v) { return $2b03dbb9ef92e3eb$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $2b03dbb9ef92e3eb$export$2d1720544b23b823;
'use strict';

var $d4Vda = parcelRequire("d4Vda");

var $liuRV = parcelRequire("liuRV");
var $2b03dbb9ef92e3eb$var$hiddenKeys = $liuRV.concat('length', 'prototype');
$2b03dbb9ef92e3eb$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $d4Vda(O, $2b03dbb9ef92e3eb$var$hiddenKeys);
};

});
parcelRegister("d4Vda", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $keZ2c = parcelRequire("keZ2c");

var $4EWOr = parcelRequire("4EWOr");

var $5oIxL = parcelRequire("5oIxL");
var $9858070d1fe0c2ed$require$indexOf = $5oIxL.indexOf;

var $3pX3o = parcelRequire("3pX3o");
var $9858070d1fe0c2ed$var$push = $7n9WH([].push);
module.exports = function(object, names) {
    var O = $4EWOr(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$keZ2c($3pX3o, key) && $keZ2c(O, key) && $9858070d1fe0c2ed$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($keZ2c(O, key = names[i++])) ~$9858070d1fe0c2ed$require$indexOf(result, key) || $9858070d1fe0c2ed$var$push(result, key);
    return result;
};

});
parcelRegister("5oIxL", function(module, exports) {
'use strict';

var $4EWOr = parcelRequire("4EWOr");

var $ceQt9 = parcelRequire("ceQt9");

var $6HcaS = parcelRequire("6HcaS");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $3ee1bf137d85ab12$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4EWOr($this);
        var length = $6HcaS(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $ceQt9(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $3ee1bf137d85ab12$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $3ee1bf137d85ab12$var$createMethod(false)
};

});
parcelRegister("ceQt9", function(module, exports) {
'use strict';

var $hXJr0 = parcelRequire("hXJr0");
var $8e8f7e1cc4b76412$var$max = Math.max;
var $8e8f7e1cc4b76412$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $hXJr0(index);
    return integer < 0 ? $8e8f7e1cc4b76412$var$max(integer + length, 0) : $8e8f7e1cc4b76412$var$min(integer, length);
};

});
parcelRegister("hXJr0", function(module, exports) {
'use strict';

var $lTLHG = parcelRequire("lTLHG");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $lTLHG(number);
};

});
parcelRegister("lTLHG", function(module, exports) {
'use strict';
var $ff13bcf0f708f706$var$ceil = Math.ceil;
var $ff13bcf0f708f706$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $ff13bcf0f708f706$var$floor : $ff13bcf0f708f706$var$ceil)(n);
};

});



parcelRegister("6HcaS", function(module, exports) {
'use strict';

var $dgesD = parcelRequire("dgesD");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $dgesD(obj.length);
};

});
parcelRegister("dgesD", function(module, exports) {
'use strict';

var $hXJr0 = parcelRequire("hXJr0");
var $9a77fc96b6f7f2f8$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $hXJr0(argument);
    return len > 0 ? $9a77fc96b6f7f2f8$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRegister("liuRV", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("8pg8R", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $61ed2dfe80a4e214$export$2d1720544b23b823; }, function (v) { return $61ed2dfe80a4e214$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $61ed2dfe80a4e214$export$2d1720544b23b823;
'use strict';
$61ed2dfe80a4e214$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("bp1kS", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");
var $84d310c49c1d3101$var$replacement = /#|\.prototype\./;
var $84d310c49c1d3101$var$isForced = function(feature, detection) {
    var value = $84d310c49c1d3101$var$data[$84d310c49c1d3101$var$normalize(feature)];
    return value === $84d310c49c1d3101$var$POLYFILL ? true : value === $84d310c49c1d3101$var$NATIVE ? false : $1ZKCr(detection) ? $bAE3C(detection) : !!detection;
};
var $84d310c49c1d3101$var$normalize = $84d310c49c1d3101$var$isForced.normalize = function(string) {
    return String(string).replace($84d310c49c1d3101$var$replacement, '.').toLowerCase();
};
var $84d310c49c1d3101$var$data = $84d310c49c1d3101$var$isForced.data = {};
var $84d310c49c1d3101$var$NATIVE = $84d310c49c1d3101$var$isForced.NATIVE = 'N';
var $84d310c49c1d3101$var$POLYFILL = $84d310c49c1d3101$var$isForced.POLYFILL = 'P';
module.exports = $84d310c49c1d3101$var$isForced;

});


parcelRegister("ay2cC", function(module, exports) {
'use strict';

var $fcHE3 = parcelRequire("fcHE3");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $fcHE3(argument) === 'Array';
};

});

parcelRegister("hjGLe", function(module, exports) {
'use strict';
var $c9b56166eaab6985$var$$TypeError = TypeError;
var $c9b56166eaab6985$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $c9b56166eaab6985$var$MAX_SAFE_INTEGER) throw new $c9b56166eaab6985$var$$TypeError('Maximum allowed index exceeded');
    return it;
};

});

parcelRegister("7F0dl", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $dsVjX = parcelRequire("dsVjX");

var $3qjfQ = parcelRequire("3qjfQ");
module.exports = function(object, key, value) {
    if ($9100U) $dsVjX.f(object, key, $3qjfQ(0, value));
    else object[key] = value;
};

});

parcelRegister("gqEDU", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $ay2cC = parcelRequire("ay2cC");
var $bf5e99d6be962390$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bf5e99d6be962390$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $bf5e99d6be962390$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $9100U && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = $bf5e99d6be962390$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($ay2cC(O) && !$bf5e99d6be962390$var$getOwnPropertyDescriptor(O, 'length').writable) throw new $bf5e99d6be962390$var$$TypeError('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

});

parcelRegister("lRrDo", function(module, exports) {
'use strict';

var $iQoKD = parcelRequire("iQoKD");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($iQoKD(originalArray))(length === 0 ? 0 : length);
};

});
parcelRegister("iQoKD", function(module, exports) {
'use strict';

var $ay2cC = parcelRequire("ay2cC");

var $cmnjY = parcelRequire("cmnjY");

var $9OhmT = parcelRequire("9OhmT");

var $mgvTx = parcelRequire("mgvTx");
var $db80486136c437f9$var$SPECIES = $mgvTx('species');
var $db80486136c437f9$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($ay2cC(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($cmnjY(C) && (C === $db80486136c437f9$var$$Array || $ay2cC(C.prototype))) C = undefined;
        else if ($9OhmT(C)) {
            C = C[$db80486136c437f9$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $db80486136c437f9$var$$Array : C;
};

});
parcelRegister("cmnjY", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $401SB = parcelRequire("401SB");

var $4uwSa = parcelRequire("4uwSa");

var $f8Jih = parcelRequire("f8Jih");
var $8ff9a136cc5c5311$var$noop = function() {};
var $8ff9a136cc5c5311$var$construct = $4uwSa('Reflect', 'construct');
var $8ff9a136cc5c5311$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $8ff9a136cc5c5311$var$exec = $7n9WH($8ff9a136cc5c5311$var$constructorRegExp.exec);
var $8ff9a136cc5c5311$var$INCORRECT_TO_STRING = !$8ff9a136cc5c5311$var$constructorRegExp.test($8ff9a136cc5c5311$var$noop);
var $8ff9a136cc5c5311$var$isConstructorModern = function isConstructor(argument) {
    if (!$1ZKCr(argument)) return false;
    try {
        $8ff9a136cc5c5311$var$construct($8ff9a136cc5c5311$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $8ff9a136cc5c5311$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$1ZKCr(argument)) return false;
    switch($401SB(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $8ff9a136cc5c5311$var$INCORRECT_TO_STRING || !!$8ff9a136cc5c5311$var$exec($8ff9a136cc5c5311$var$constructorRegExp, $f8Jih(argument));
    } catch (error) {
        return true;
    }
};
$8ff9a136cc5c5311$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$8ff9a136cc5c5311$var$construct || $bAE3C(function() {
    var called;
    return $8ff9a136cc5c5311$var$isConstructorModern($8ff9a136cc5c5311$var$isConstructorModern.call) || !$8ff9a136cc5c5311$var$isConstructorModern(Object) || !$8ff9a136cc5c5311$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $8ff9a136cc5c5311$var$isConstructorLegacy : $8ff9a136cc5c5311$var$isConstructorModern;

});
parcelRegister("401SB", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $1ZKCr = parcelRequire("1ZKCr");

var $fcHE3 = parcelRequire("fcHE3");

var $mgvTx = parcelRequire("mgvTx");
var $2e989ec6822b6221$var$TO_STRING_TAG = $mgvTx('toStringTag');
var $2e989ec6822b6221$var$$Object = Object;
// ES3 wrong here
var $2e989ec6822b6221$var$CORRECT_ARGUMENTS = $fcHE3(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $2e989ec6822b6221$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $cSemj ? $fcHE3 : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $2e989ec6822b6221$var$tryGet(O = $2e989ec6822b6221$var$$Object(it), $2e989ec6822b6221$var$TO_STRING_TAG)) == 'string' ? tag : $2e989ec6822b6221$var$CORRECT_ARGUMENTS ? $fcHE3(O) : (result = $fcHE3(O)) === 'Object' && $1ZKCr(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("cSemj", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");
var $95f5aa8bc1490bf8$var$TO_STRING_TAG = $mgvTx('toStringTag');
var $95f5aa8bc1490bf8$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$95f5aa8bc1490bf8$var$test[$95f5aa8bc1490bf8$var$TO_STRING_TAG] = 'z';
module.exports = String($95f5aa8bc1490bf8$var$test) === '[object z]';

});





parcelRegister("6Sqdy", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $mgvTx = parcelRequire("mgvTx");

var $9FPXB = parcelRequire("9FPXB");
var $501c1f84d7c8fa90$var$SPECIES = $mgvTx('species');
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $9FPXB >= 51 || !$bAE3C(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$501c1f84d7c8fa90$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});


parcelRegister("1aLfi", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $2t4Gp = parcelRequire("2t4Gp");

var $gMVfE = parcelRequire("gMVfE");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$cSemj) $2t4Gp(Object.prototype, 'toString', $gMVfE, {
    unsafe: true
});

});
parcelRegister("gMVfE", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $401SB = parcelRequire("401SB");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $cSemj ? ({}).toString : function toString() {
    return '[object ' + $401SB(this) + ']';
};

});


parcelRegister("dkMmr", function(module, exports) {
'use strict';
parcelRequire("6F7XI");
parcelRequire("95iEZ");
parcelRequire("69KBB");
parcelRequire("1VW2X");
parcelRequire("jtDp7");

});
parcelRegister("6F7XI", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $kvDzZ = parcelRequire("kvDzZ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $axseE = parcelRequire("axseE");

var $9100U = parcelRequire("9100U");

var $iKqSh = parcelRequire("iKqSh");

var $bAE3C = parcelRequire("bAE3C");

var $keZ2c = parcelRequire("keZ2c");

var $7mAhs = parcelRequire("7mAhs");

var $4LaI4 = parcelRequire("4LaI4");

var $4EWOr = parcelRequire("4EWOr");

var $eSWL8 = parcelRequire("eSWL8");

var $1H3Lz = parcelRequire("1H3Lz");

var $3qjfQ = parcelRequire("3qjfQ");

var $emiQA = parcelRequire("emiQA");

var $1Eis3 = parcelRequire("1Eis3");

var $3GY1P = parcelRequire("3GY1P");

var $yJ9RD = parcelRequire("yJ9RD");

var $8pg8R = parcelRequire("8pg8R");

var $kmjYa = parcelRequire("kmjYa");

var $dsVjX = parcelRequire("dsVjX");

var $7fIoH = parcelRequire("7fIoH");

var $5luz1 = parcelRequire("5luz1");

var $2t4Gp = parcelRequire("2t4Gp");

var $4GKxk = parcelRequire("4GKxk");

var $cITHp = parcelRequire("cITHp");

var $k3YZr = parcelRequire("k3YZr");

var $3pX3o = parcelRequire("3pX3o");

var $66HFQ = parcelRequire("66HFQ");

var $mgvTx = parcelRequire("mgvTx");

var $gsYcM = parcelRequire("gsYcM");

var $18GwD = parcelRequire("18GwD");

var $3ppV5 = parcelRequire("3ppV5");

var $2Zevq = parcelRequire("2Zevq");

var $4eljv = parcelRequire("4eljv");

var $aqTg6 = parcelRequire("aqTg6");
var $4d9cbf85e18833d5$require$$forEach = $aqTg6.forEach;
var $4d9cbf85e18833d5$var$HIDDEN = $k3YZr('hidden');
var $4d9cbf85e18833d5$var$SYMBOL = 'Symbol';
var $4d9cbf85e18833d5$var$PROTOTYPE = 'prototype';
var $4d9cbf85e18833d5$var$setInternalState = $4eljv.set;
var $4d9cbf85e18833d5$var$getInternalState = $4eljv.getterFor($4d9cbf85e18833d5$var$SYMBOL);
var $4d9cbf85e18833d5$var$ObjectPrototype = Object[$4d9cbf85e18833d5$var$PROTOTYPE];
var $4d9cbf85e18833d5$var$$Symbol = $kvDzZ.Symbol;
var $4d9cbf85e18833d5$var$SymbolPrototype = $4d9cbf85e18833d5$var$$Symbol && $4d9cbf85e18833d5$var$$Symbol[$4d9cbf85e18833d5$var$PROTOTYPE];
var $4d9cbf85e18833d5$var$RangeError = $kvDzZ.RangeError;
var $4d9cbf85e18833d5$var$TypeError = $kvDzZ.TypeError;
var $4d9cbf85e18833d5$var$QObject = $kvDzZ.QObject;
var $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor = $kmjYa.f;
var $4d9cbf85e18833d5$var$nativeDefineProperty = $dsVjX.f;
var $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames = $yJ9RD.f;
var $4d9cbf85e18833d5$var$nativePropertyIsEnumerable = $5luz1.f;
var $4d9cbf85e18833d5$var$push = $7n9WH([].push);
var $4d9cbf85e18833d5$var$AllSymbols = $cITHp('symbols');
var $4d9cbf85e18833d5$var$ObjectPrototypeSymbols = $cITHp('op-symbols');
var $4d9cbf85e18833d5$var$WellKnownSymbolsStore = $cITHp('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $4d9cbf85e18833d5$var$USE_SETTER = !$4d9cbf85e18833d5$var$QObject || !$4d9cbf85e18833d5$var$QObject[$4d9cbf85e18833d5$var$PROTOTYPE] || !$4d9cbf85e18833d5$var$QObject[$4d9cbf85e18833d5$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $4d9cbf85e18833d5$var$fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor($4d9cbf85e18833d5$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $4d9cbf85e18833d5$var$ObjectPrototype[P];
    $4d9cbf85e18833d5$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $4d9cbf85e18833d5$var$ObjectPrototype) $4d9cbf85e18833d5$var$nativeDefineProperty($4d9cbf85e18833d5$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
    return O;
};
var $4d9cbf85e18833d5$var$setSymbolDescriptor = $9100U && $bAE3C(function() {
    return $emiQA($4d9cbf85e18833d5$var$nativeDefineProperty({}, 'a', {
        get: function() {
            return $4d9cbf85e18833d5$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $4d9cbf85e18833d5$var$fallbackDefineProperty : $4d9cbf85e18833d5$var$nativeDefineProperty;
var $4d9cbf85e18833d5$var$wrap = function(tag, description) {
    var symbol = $4d9cbf85e18833d5$var$AllSymbols[tag] = $emiQA($4d9cbf85e18833d5$var$SymbolPrototype);
    $4d9cbf85e18833d5$var$setInternalState(symbol, {
        type: $4d9cbf85e18833d5$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$9100U) symbol.description = description;
    return symbol;
};
var $4d9cbf85e18833d5$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $4d9cbf85e18833d5$var$ObjectPrototype) $4d9cbf85e18833d5$var$$defineProperty($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, P, Attributes);
    $4LaI4(O);
    var key = $eSWL8(P);
    $4LaI4(Attributes);
    if ($keZ2c($4d9cbf85e18833d5$var$AllSymbols, key)) {
        // first definition - default non-enumerable; redefinition - preserve existing state
        if (!('enumerable' in Attributes) ? !$keZ2c(O, key) || $keZ2c(O, $4d9cbf85e18833d5$var$HIDDEN) && O[$4d9cbf85e18833d5$var$HIDDEN][key] : !Attributes.enumerable) {
            if (!$keZ2c(O, $4d9cbf85e18833d5$var$HIDDEN)) $4d9cbf85e18833d5$var$nativeDefineProperty(O, $4d9cbf85e18833d5$var$HIDDEN, $3qjfQ(1, $emiQA(null)));
            O[$4d9cbf85e18833d5$var$HIDDEN][key] = true;
        } else {
            if ($keZ2c(O, $4d9cbf85e18833d5$var$HIDDEN) && O[$4d9cbf85e18833d5$var$HIDDEN][key]) O[$4d9cbf85e18833d5$var$HIDDEN][key] = false;
            Attributes = $emiQA(Attributes, {
                enumerable: $3qjfQ(0, false)
            });
        }
        return $4d9cbf85e18833d5$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $4d9cbf85e18833d5$var$nativeDefineProperty(O, key, Attributes);
};
var $4d9cbf85e18833d5$var$$defineProperties = function defineProperties(O, Properties) {
    $4LaI4(O);
    var properties = $4EWOr(Properties);
    var keys = $1Eis3(properties).concat($4d9cbf85e18833d5$var$$getOwnPropertySymbols(properties));
    $4d9cbf85e18833d5$require$$forEach(keys, function(key) {
        if (!$9100U || $8lKVU($4d9cbf85e18833d5$var$$propertyIsEnumerable, properties, key)) $4d9cbf85e18833d5$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $4d9cbf85e18833d5$var$$create = function create(O, Properties) {
    return Properties === undefined ? $emiQA(O) : $4d9cbf85e18833d5$var$$defineProperties($emiQA(O), Properties);
};
var $4d9cbf85e18833d5$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $eSWL8(V);
    var enumerable = $8lKVU($4d9cbf85e18833d5$var$nativePropertyIsEnumerable, this, P);
    if (this === $4d9cbf85e18833d5$var$ObjectPrototype && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, P) && !$keZ2c($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$keZ2c(this, P) || !$keZ2c($4d9cbf85e18833d5$var$AllSymbols, P) || $keZ2c(this, $4d9cbf85e18833d5$var$HIDDEN) && this[$4d9cbf85e18833d5$var$HIDDEN][P] ? enumerable : true;
};
var $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $4EWOr(O);
    var key = $eSWL8(P);
    if (it === $4d9cbf85e18833d5$var$ObjectPrototype && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !$keZ2c($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !($keZ2c(it, $4d9cbf85e18833d5$var$HIDDEN) && it[$4d9cbf85e18833d5$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $4d9cbf85e18833d5$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames($4EWOr(O));
    var result = [];
    $4d9cbf85e18833d5$require$$forEach(names, function(key) {
        if (!$keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !$keZ2c($3pX3o, key)) $4d9cbf85e18833d5$var$push(result, key);
    });
    return result;
};
var $4d9cbf85e18833d5$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $4d9cbf85e18833d5$var$ObjectPrototype;
    var names = $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $4d9cbf85e18833d5$var$ObjectPrototypeSymbols : $4EWOr(O));
    var result = [];
    $4d9cbf85e18833d5$require$$forEach(names, function(key) {
        if ($keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $keZ2c($4d9cbf85e18833d5$var$ObjectPrototype, key))) $4d9cbf85e18833d5$var$push(result, $4d9cbf85e18833d5$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$iKqSh) {
    $4d9cbf85e18833d5$var$$Symbol = function Symbol() {
        if ($7mAhs($4d9cbf85e18833d5$var$SymbolPrototype, this)) throw new $4d9cbf85e18833d5$var$TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $1H3Lz(arguments[0]);
        var tag = $66HFQ(description);
        var setter = function(value) {
            var $this = this === undefined ? $kvDzZ : this;
            if ($this === $4d9cbf85e18833d5$var$ObjectPrototype) $8lKVU(setter, $4d9cbf85e18833d5$var$ObjectPrototypeSymbols, value);
            if ($keZ2c($this, $4d9cbf85e18833d5$var$HIDDEN) && $keZ2c($this[$4d9cbf85e18833d5$var$HIDDEN], tag)) $this[$4d9cbf85e18833d5$var$HIDDEN][tag] = false;
            var descriptor = $3qjfQ(1, value);
            try {
                $4d9cbf85e18833d5$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $4d9cbf85e18833d5$var$RangeError)) throw error;
                $4d9cbf85e18833d5$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($9100U && $4d9cbf85e18833d5$var$USE_SETTER) $4d9cbf85e18833d5$var$setSymbolDescriptor($4d9cbf85e18833d5$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $4d9cbf85e18833d5$var$wrap(tag, description);
    };
    $4d9cbf85e18833d5$var$SymbolPrototype = $4d9cbf85e18833d5$var$$Symbol[$4d9cbf85e18833d5$var$PROTOTYPE];
    $2t4Gp($4d9cbf85e18833d5$var$SymbolPrototype, 'toString', function toString() {
        return $4d9cbf85e18833d5$var$getInternalState(this).tag;
    });
    $2t4Gp($4d9cbf85e18833d5$var$$Symbol, 'withoutSetter', function(description) {
        return $4d9cbf85e18833d5$var$wrap($66HFQ(description), description);
    });
    $5luz1.f = $4d9cbf85e18833d5$var$$propertyIsEnumerable;
    $dsVjX.f = $4d9cbf85e18833d5$var$$defineProperty;
    $7fIoH.f = $4d9cbf85e18833d5$var$$defineProperties;
    $kmjYa.f = $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor;
    $3GY1P.f = $yJ9RD.f = $4d9cbf85e18833d5$var$$getOwnPropertyNames;
    $8pg8R.f = $4d9cbf85e18833d5$var$$getOwnPropertySymbols;
    $gsYcM.f = function(name) {
        return $4d9cbf85e18833d5$var$wrap($mgvTx(name), name);
    };
    if ($9100U) {
        // https://tc39.es/ecma262/#sec-symbol.prototype.description
        $4GKxk($4d9cbf85e18833d5$var$SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return $4d9cbf85e18833d5$var$getInternalState(this).description;
            }
        });
        if (!$axseE) $2t4Gp($4d9cbf85e18833d5$var$ObjectPrototype, 'propertyIsEnumerable', $4d9cbf85e18833d5$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$1XSJh({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$iKqSh,
    sham: !$iKqSh
}, {
    Symbol: $4d9cbf85e18833d5$var$$Symbol
});
$4d9cbf85e18833d5$require$$forEach($1Eis3($4d9cbf85e18833d5$var$WellKnownSymbolsStore), function(name) {
    $18GwD(name);
});
$1XSJh({
    target: $4d9cbf85e18833d5$var$SYMBOL,
    stat: true,
    forced: !$iKqSh
}, {
    useSetter: function() {
        $4d9cbf85e18833d5$var$USE_SETTER = true;
    },
    useSimple: function() {
        $4d9cbf85e18833d5$var$USE_SETTER = false;
    }
});
$1XSJh({
    target: 'Object',
    stat: true,
    forced: !$iKqSh,
    sham: !$9100U
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $4d9cbf85e18833d5$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $4d9cbf85e18833d5$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $4d9cbf85e18833d5$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor
});
$1XSJh({
    target: 'Object',
    stat: true,
    forced: !$iKqSh
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $4d9cbf85e18833d5$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$3ppV5();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$2Zevq($4d9cbf85e18833d5$var$$Symbol, $4d9cbf85e18833d5$var$SYMBOL);
$3pX3o[$4d9cbf85e18833d5$var$HIDDEN] = true;

});
parcelRegister("1H3Lz", function(module, exports) {
'use strict';

var $401SB = parcelRequire("401SB");
var $13bcba7ed5bb5bd6$var$$String = String;
module.exports = function(argument) {
    if ($401SB(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $13bcba7ed5bb5bd6$var$$String(argument);
};

});

parcelRegister("emiQA", function(module, exports) {
'use strict';

var $4LaI4 = parcelRequire("4LaI4");

var $7fIoH = parcelRequire("7fIoH");

var $liuRV = parcelRequire("liuRV");

var $3pX3o = parcelRequire("3pX3o");

var $22Vf9 = parcelRequire("22Vf9");

var $iJAYS = parcelRequire("iJAYS");

var $k3YZr = parcelRequire("k3YZr");
var $a741bd69fc0f1bc8$var$GT = '>';
var $a741bd69fc0f1bc8$var$LT = '<';
var $a741bd69fc0f1bc8$var$PROTOTYPE = 'prototype';
var $a741bd69fc0f1bc8$var$SCRIPT = 'script';
var $a741bd69fc0f1bc8$var$IE_PROTO = $k3YZr('IE_PROTO');
var $a741bd69fc0f1bc8$var$EmptyConstructor = function() {};
var $a741bd69fc0f1bc8$var$scriptTag = function(content) {
    return $a741bd69fc0f1bc8$var$LT + $a741bd69fc0f1bc8$var$SCRIPT + $a741bd69fc0f1bc8$var$GT + content + $a741bd69fc0f1bc8$var$LT + '/' + $a741bd69fc0f1bc8$var$SCRIPT + $a741bd69fc0f1bc8$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($a741bd69fc0f1bc8$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $a741bd69fc0f1bc8$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $iJAYS('iframe');
    var JS = 'java' + $a741bd69fc0f1bc8$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $22Vf9.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($a741bd69fc0f1bc8$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $a741bd69fc0f1bc8$var$activeXDocument;
var $a741bd69fc0f1bc8$var$NullProtoObject = function() {
    try {
        $a741bd69fc0f1bc8$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $a741bd69fc0f1bc8$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $a741bd69fc0f1bc8$var$activeXDocument ? $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX($a741bd69fc0f1bc8$var$activeXDocument) // old IE
     : $a741bd69fc0f1bc8$var$NullProtoObjectViaIFrame() : $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX($a741bd69fc0f1bc8$var$activeXDocument); // WSH
    var length = $liuRV.length;
    while(length--)delete $a741bd69fc0f1bc8$var$NullProtoObject[$a741bd69fc0f1bc8$var$PROTOTYPE][$liuRV[length]];
    return $a741bd69fc0f1bc8$var$NullProtoObject();
};
$3pX3o[$a741bd69fc0f1bc8$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $a741bd69fc0f1bc8$var$EmptyConstructor[$a741bd69fc0f1bc8$var$PROTOTYPE] = $4LaI4(O);
        result = new $a741bd69fc0f1bc8$var$EmptyConstructor();
        $a741bd69fc0f1bc8$var$EmptyConstructor[$a741bd69fc0f1bc8$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$a741bd69fc0f1bc8$var$IE_PROTO] = O;
    } else result = $a741bd69fc0f1bc8$var$NullProtoObject();
    return Properties === undefined ? result : $7fIoH.f(result, Properties);
};

});
parcelRegister("7fIoH", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $547c5f86a946d88a$export$2d1720544b23b823; }, function (v) { return $547c5f86a946d88a$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $547c5f86a946d88a$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $kev11 = parcelRequire("kev11");

var $dsVjX = parcelRequire("dsVjX");

var $4LaI4 = parcelRequire("4LaI4");

var $4EWOr = parcelRequire("4EWOr");

var $1Eis3 = parcelRequire("1Eis3");
$547c5f86a946d88a$export$2d1720544b23b823 = $9100U && !$kev11 ? Object.defineProperties : function defineProperties(O, Properties) {
    $4LaI4(O);
    var props = $4EWOr(Properties);
    var keys = $1Eis3(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$dsVjX.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("1Eis3", function(module, exports) {
'use strict';

var $d4Vda = parcelRequire("d4Vda");

var $liuRV = parcelRequire("liuRV");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $d4Vda(O, $liuRV);
};

});


parcelRegister("22Vf9", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");
module.exports = $4uwSa('document', 'documentElement');

});


parcelRegister("yJ9RD", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $0686348c533e1b6d$export$2d1720544b23b823; }, function (v) { return $0686348c533e1b6d$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $0686348c533e1b6d$export$2d1720544b23b823;
'use strict';

var $fcHE3 = parcelRequire("fcHE3");

var $4EWOr = parcelRequire("4EWOr");

var $3GY1P = parcelRequire("3GY1P");
var $0686348c533e1b6d$require$$getOwnPropertyNames = $3GY1P.f;

var $lKumW = parcelRequire("lKumW");
var $0686348c533e1b6d$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $0686348c533e1b6d$var$getWindowNames = function(it) {
    try {
        return $0686348c533e1b6d$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $lKumW($0686348c533e1b6d$var$windowNames);
    }
};
$0686348c533e1b6d$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $0686348c533e1b6d$var$windowNames && $fcHE3(it) === 'Window' ? $0686348c533e1b6d$var$getWindowNames(it) : $0686348c533e1b6d$require$$getOwnPropertyNames($4EWOr(it));
};

});
parcelRegister("lKumW", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
module.exports = $7n9WH([].slice);

});


parcelRegister("4GKxk", function(module, exports) {
'use strict';

var $lQepi = parcelRequire("lQepi");

var $dsVjX = parcelRequire("dsVjX");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) $lQepi(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $lQepi(descriptor.set, name, {
        setter: true
    });
    return $dsVjX.f(target, name, descriptor);
};

});

parcelRegister("gsYcM", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $bfcdf65efd683741$export$2d1720544b23b823; }, function (v) { return $bfcdf65efd683741$export$2d1720544b23b823 = v; });
var $bfcdf65efd683741$export$2d1720544b23b823;
'use strict';

var $mgvTx = parcelRequire("mgvTx");
$bfcdf65efd683741$export$2d1720544b23b823 = $mgvTx;

});

parcelRegister("18GwD", function(module, exports) {
'use strict';

var $9AtxJ = parcelRequire("9AtxJ");

var $keZ2c = parcelRequire("keZ2c");

var $gsYcM = parcelRequire("gsYcM");

var $dsVjX = parcelRequire("dsVjX");
var $0d47867294a46a70$require$defineProperty = $dsVjX.f;
module.exports = function(NAME) {
    var Symbol = $9AtxJ.Symbol || ($9AtxJ.Symbol = {});
    if (!$keZ2c(Symbol, NAME)) $0d47867294a46a70$require$defineProperty(Symbol, NAME, {
        value: $gsYcM.f(NAME)
    });
};

});
parcelRegister("9AtxJ", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
module.exports = $kvDzZ;

});


parcelRegister("3ppV5", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $4uwSa = parcelRequire("4uwSa");

var $mgvTx = parcelRequire("mgvTx");

var $2t4Gp = parcelRequire("2t4Gp");
module.exports = function() {
    var Symbol = $4uwSa('Symbol');
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $mgvTx('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $2t4Gp(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $8lKVU(valueOf, this);
    }, {
        arity: 1
    });
};

});

parcelRegister("2Zevq", function(module, exports) {
'use strict';

var $dsVjX = parcelRequire("dsVjX");
var $22cc87dd0f363230$require$defineProperty = $dsVjX.f;

var $keZ2c = parcelRequire("keZ2c");

var $mgvTx = parcelRequire("mgvTx");
var $22cc87dd0f363230$var$TO_STRING_TAG = $mgvTx('toStringTag');
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$keZ2c(target, $22cc87dd0f363230$var$TO_STRING_TAG)) $22cc87dd0f363230$require$defineProperty(target, $22cc87dd0f363230$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});

parcelRegister("aqTg6", function(module, exports) {
'use strict';

var $lvfol = parcelRequire("lvfol");

var $8SixO = parcelRequire("8SixO");

var $hicPf = parcelRequire("hicPf");

var $6HcaS = parcelRequire("6HcaS");

var $lRrDo = parcelRequire("lRrDo");

var $7F0dl = parcelRequire("7F0dl");
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $79873252e79d7f93$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that) {
        var O = $hicPf($this);
        var self = $8SixO(O);
        var length = $6HcaS(self);
        var boundFunction = $lvfol(callbackfn, that);
        var index = 0;
        var resIndex = 0;
        var target = IS_MAP ? $lRrDo($this, length) : IS_FILTER || IS_FILTER_REJECT ? $lRrDo($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) $7F0dl(target, index, result); // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $7F0dl(target, resIndex++, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $7F0dl(target, resIndex++, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $79873252e79d7f93$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $79873252e79d7f93$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $79873252e79d7f93$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $79873252e79d7f93$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $79873252e79d7f93$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $79873252e79d7f93$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $79873252e79d7f93$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $79873252e79d7f93$var$createMethod(7)
};

});
parcelRegister("lvfol", function(module, exports) {
'use strict';

var $fG0wf = parcelRequire("fG0wf");

var $g7x3l = parcelRequire("g7x3l");

var $c3otN = parcelRequire("c3otN");
var $fa786eb0c61cdd08$var$bind = $fG0wf($fG0wf.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $g7x3l(fn);
    return that === undefined ? fn : $c3otN ? $fa786eb0c61cdd08$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("fG0wf", function(module, exports) {
'use strict';

var $fcHE3 = parcelRequire("fcHE3");

var $7n9WH = parcelRequire("7n9WH");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($fcHE3(fn) === 'Function') return $7n9WH(fn);
};

});




parcelRegister("95iEZ", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $4uwSa = parcelRequire("4uwSa");

var $keZ2c = parcelRequire("keZ2c");

var $1H3Lz = parcelRequire("1H3Lz");

var $cITHp = parcelRequire("cITHp");

var $h4OsA = parcelRequire("h4OsA");
var $69d30e35ccee0219$var$StringToSymbolRegistry = $cITHp('string-to-symbol-registry');
var $69d30e35ccee0219$var$SymbolToStringRegistry = $cITHp('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: !$h4OsA
}, {
    'for': function(key) {
        var string = $1H3Lz(key);
        if ($keZ2c($69d30e35ccee0219$var$StringToSymbolRegistry, string)) return $69d30e35ccee0219$var$StringToSymbolRegistry[string];
        var symbol = $4uwSa('Symbol')(string);
        $69d30e35ccee0219$var$StringToSymbolRegistry[string] = symbol;
        $69d30e35ccee0219$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRegister("h4OsA", function(module, exports) {
'use strict';

var $iKqSh = parcelRequire("iKqSh");
/* eslint-disable es/no-symbol -- safe */ module.exports = $iKqSh && !!Symbol['for'] && !!Symbol.keyFor;

});


parcelRegister("69KBB", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $keZ2c = parcelRequire("keZ2c");

var $1Q1gI = parcelRequire("1Q1gI");

var $7MtCT = parcelRequire("7MtCT");

var $cITHp = parcelRequire("cITHp");

var $h4OsA = parcelRequire("h4OsA");
var $47b7bc340dbc2ec2$var$SymbolToStringRegistry = $cITHp('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: !$h4OsA
}, {
    keyFor: function keyFor(sym) {
        if (!$1Q1gI(sym)) throw new TypeError($7MtCT(sym) + ' is not a symbol');
        if ($keZ2c($47b7bc340dbc2ec2$var$SymbolToStringRegistry, sym)) return $47b7bc340dbc2ec2$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRegister("1VW2X", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $4uwSa = parcelRequire("4uwSa");

var $edBaQ = parcelRequire("edBaQ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $ay2cC = parcelRequire("ay2cC");

var $1ZKCr = parcelRequire("1ZKCr");

var $cq50O = parcelRequire("cq50O");

var $1Q1gI = parcelRequire("1Q1gI");

var $fcHE3 = parcelRequire("fcHE3");

var $1H3Lz = parcelRequire("1H3Lz");

var $lKumW = parcelRequire("lKumW");

var $hmOkz = parcelRequire("hmOkz");

var $66HFQ = parcelRequire("66HFQ");

var $iKqSh = parcelRequire("iKqSh");

var $6Sqa1 = parcelRequire("6Sqa1");
var $1688242957791681$var$$String = String;
var $1688242957791681$var$$stringify = $4uwSa('JSON', 'stringify');
var $1688242957791681$var$exec = $7n9WH(/./.exec);
var $1688242957791681$var$charAt = $7n9WH(''.charAt);
var $1688242957791681$var$charCodeAt = $7n9WH(''.charCodeAt);
var $1688242957791681$var$replace = $7n9WH(''.replace);
var $1688242957791681$var$slice = $7n9WH(''.slice);
var $1688242957791681$var$push = $7n9WH([].push);
var $1688242957791681$var$numberToString = $7n9WH(1.1.toString);
var $1688242957791681$var$surrogates = /[\uD800-\uDFFF]/g;
var $1688242957791681$var$leadingSurrogates = /^[\uD800-\uDBFF]$/;
var $1688242957791681$var$trailingSurrogates = /^[\uDC00-\uDFFF]$/;
var $1688242957791681$var$MARK = $66HFQ();
var $1688242957791681$var$MARK_LENGTH = $1688242957791681$var$MARK.length;
var $1688242957791681$var$WRONG_SYMBOLS_CONVERSION = !$iKqSh || $bAE3C(function() {
    var symbol = $4uwSa('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $1688242957791681$var$$stringify([
        symbol
    ]) !== '[null]' || $1688242957791681$var$$stringify({
        a: symbol
    }) !== '{}' || $1688242957791681$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $1688242957791681$var$ILL_FORMED_UNICODE = $bAE3C(function() {
    return $1688242957791681$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $1688242957791681$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $1688242957791681$var$stringifyWithProperSymbolsConversion = $1688242957791681$var$WRONG_SYMBOLS_CONVERSION ? function(it, replacer) {
    var args = $lKumW(arguments);
    var $replacer = $1688242957791681$var$getReplacerFunction(replacer);
    if (!$1ZKCr($replacer) && (it === undefined || $1Q1gI(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($1ZKCr($replacer)) value = $8lKVU($replacer, this, $1688242957791681$var$$String(key), value);
        if (!$1Q1gI(value)) return value;
    };
    return $edBaQ($1688242957791681$var$$stringify, null, args);
} : $1688242957791681$var$$stringify;
var $1688242957791681$var$fixIllFormedJSON = function(match, offset, string) {
    var prev = $1688242957791681$var$charAt(string, offset - 1);
    var next = $1688242957791681$var$charAt(string, offset + 1);
    if ($1688242957791681$var$exec($1688242957791681$var$leadingSurrogates, match) && !$1688242957791681$var$exec($1688242957791681$var$trailingSurrogates, next) || $1688242957791681$var$exec($1688242957791681$var$trailingSurrogates, match) && !$1688242957791681$var$exec($1688242957791681$var$leadingSurrogates, prev)) return '\\u' + $1688242957791681$var$numberToString($1688242957791681$var$charCodeAt(match, 0), 16);
    return match;
};
var $1688242957791681$var$getReplacerFunction = function(replacer) {
    if ($1ZKCr(replacer)) return replacer;
    if (!$ay2cC(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $1688242957791681$var$push(keys, element);
        else if (typeof element == 'number' || $fcHE3(element) === 'Number' || $fcHE3(element) === 'String') $1688242957791681$var$push(keys, $1H3Lz(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($ay2cC(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};
// `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
// https://github.com/tc39/proposal-json-parse-with-source
if ($1688242957791681$var$$stringify) $1XSJh({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $1688242957791681$var$WRONG_SYMBOLS_CONVERSION || $1688242957791681$var$ILL_FORMED_UNICODE || !$6Sqa1
}, {
    stringify: function stringify(text, replacer, space) {
        var replacerFunction = $1688242957791681$var$getReplacerFunction(replacer);
        var rawStrings = [];
        var json = $1688242957791681$var$stringifyWithProperSymbolsConversion(text, function(key, value) {
            // some old implementations (like WebKit) could pass numbers as keys
            var v = $1ZKCr(replacerFunction) ? $8lKVU(replacerFunction, this, $1688242957791681$var$$String(key), value) : value;
            return !$6Sqa1 && $cq50O(v) ? $1688242957791681$var$MARK + ($1688242957791681$var$push(rawStrings, v.rawJSON) - 1) : v;
        }, space);
        if (typeof json != 'string') return json;
        if ($1688242957791681$var$ILL_FORMED_UNICODE) json = $1688242957791681$var$replace(json, $1688242957791681$var$surrogates, $1688242957791681$var$fixIllFormedJSON);
        if ($6Sqa1) return json;
        var result = '';
        var length = json.length;
        for(var i = 0; i < length; i++){
            var chr = $1688242957791681$var$charAt(json, i);
            if (chr === '"') {
                var end = $hmOkz(json, ++i).end - 1;
                var string = $1688242957791681$var$slice(json, i, end);
                result += $1688242957791681$var$slice(string, 0, $1688242957791681$var$MARK_LENGTH) === $1688242957791681$var$MARK ? rawStrings[$1688242957791681$var$slice(string, $1688242957791681$var$MARK_LENGTH)] : '"' + string + '"';
                i = end;
            } else result += chr;
        }
        return result;
    }
});

});
parcelRegister("edBaQ", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $a59f1d910546347d$var$FunctionPrototype = Function.prototype;
var $a59f1d910546347d$var$apply = $a59f1d910546347d$var$FunctionPrototype.apply;
var $a59f1d910546347d$var$call = $a59f1d910546347d$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || ($c3otN ? $a59f1d910546347d$var$call.bind($a59f1d910546347d$var$apply) : function() {
    return $a59f1d910546347d$var$call.apply($a59f1d910546347d$var$apply, arguments);
});

});

parcelRegister("cq50O", function(module, exports) {
'use strict';

var $9OhmT = parcelRequire("9OhmT");

var $4eljv = parcelRequire("4eljv");
var $90abcd0bdf546f4d$require$getInternalState = $4eljv.get;
module.exports = function isRawJSON(O) {
    if (!$9OhmT(O)) return false;
    var state = $90abcd0bdf546f4d$require$getInternalState(O);
    return !!state && state.type === 'RawJSON';
};

});

parcelRegister("hmOkz", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $keZ2c = parcelRequire("keZ2c");
var $ca4b8866ac0ce032$var$$SyntaxError = SyntaxError;
var $ca4b8866ac0ce032$var$$parseInt = parseInt;
var $ca4b8866ac0ce032$var$fromCharCode = String.fromCharCode;
var $ca4b8866ac0ce032$var$at = $7n9WH(''.charAt);
var $ca4b8866ac0ce032$var$slice = $7n9WH(''.slice);
var $ca4b8866ac0ce032$var$exec = $7n9WH(/./.exec);
var $ca4b8866ac0ce032$var$codePoints = {
    '\\"': '"',
    '\\\\': '\\',
    '\\/': '/',
    '\\b': '\b',
    '\\f': '\f',
    '\\n': '\n',
    '\\r': '\r',
    '\\t': '\t'
};
var $ca4b8866ac0ce032$var$IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
// eslint-disable-next-line regexp/no-control-character -- safe
var $ca4b8866ac0ce032$var$IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
module.exports = function(source, i) {
    var unterminated = true;
    var value = '';
    while(i < source.length){
        var chr = $ca4b8866ac0ce032$var$at(source, i);
        if (chr === '\\') {
            var twoChars = $ca4b8866ac0ce032$var$slice(source, i, i + 2);
            if ($keZ2c($ca4b8866ac0ce032$var$codePoints, twoChars)) {
                value += $ca4b8866ac0ce032$var$codePoints[twoChars];
                i += 2;
            } else if (twoChars === '\\u') {
                i += 2;
                var fourHexDigits = $ca4b8866ac0ce032$var$slice(source, i, i + 4);
                if (!$ca4b8866ac0ce032$var$exec($ca4b8866ac0ce032$var$IS_4_HEX_DIGITS, fourHexDigits)) throw new $ca4b8866ac0ce032$var$$SyntaxError('Bad Unicode escape at: ' + i);
                value += $ca4b8866ac0ce032$var$fromCharCode($ca4b8866ac0ce032$var$$parseInt(fourHexDigits, 16));
                i += 4;
            } else throw new $ca4b8866ac0ce032$var$$SyntaxError('Unknown escape sequence: "' + twoChars + '"');
        } else if (chr === '"') {
            unterminated = false;
            i++;
            break;
        } else {
            if ($ca4b8866ac0ce032$var$exec($ca4b8866ac0ce032$var$IS_C0_CONTROL_CODE, chr)) throw new $ca4b8866ac0ce032$var$$SyntaxError('Bad control character in string literal at: ' + i);
            value += chr;
            i++;
        }
    }
    if (unterminated) throw new $ca4b8866ac0ce032$var$$SyntaxError('Unterminated string at: ' + i);
    return {
        value: value,
        end: i
    };
};

});

parcelRegister("6Sqa1", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
module.exports = !$bAE3C(function() {
    var unsafeInt = '9007199254740993';
    // eslint-disable-next-line es/no-json-rawjson -- feature detection
    var raw = JSON.rawJSON(unsafeInt);
    // eslint-disable-next-line es/no-json-israwjson -- feature detection
    return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
});

});


parcelRegister("jtDp7", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $iKqSh = parcelRequire("iKqSh");

var $bAE3C = parcelRequire("bAE3C");

var $8pg8R = parcelRequire("8pg8R");

var $hicPf = parcelRequire("hicPf");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $e2df4a9e2cc08738$var$FORCED = !$iKqSh || $bAE3C(function() {
    $8pg8R.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$1XSJh({
    target: 'Object',
    stat: true,
    forced: $e2df4a9e2cc08738$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $8pg8R.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($hicPf(it)) : [];
    }
});

});


parcelRegister("hPO2C", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $18GwD = parcelRequire("18GwD");

var $dsVjX = parcelRequire("dsVjX");
var $cfbe0438317e6b91$require$defineProperty = $dsVjX.f;

var $kmjYa = parcelRequire("kmjYa");
var $cfbe0438317e6b91$require$getOwnPropertyDescriptor = $kmjYa.f;
var $cfbe0438317e6b91$var$Symbol = $kvDzZ.Symbol;
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$18GwD('asyncDispose');
if ($cfbe0438317e6b91$var$Symbol) {
    var $cfbe0438317e6b91$var$descriptor = $cfbe0438317e6b91$require$getOwnPropertyDescriptor($cfbe0438317e6b91$var$Symbol, 'asyncDispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($cfbe0438317e6b91$var$descriptor.enumerable && $cfbe0438317e6b91$var$descriptor.configurable && $cfbe0438317e6b91$var$descriptor.writable) $cfbe0438317e6b91$require$defineProperty($cfbe0438317e6b91$var$Symbol, 'asyncDispose', {
        value: $cfbe0438317e6b91$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}

});

parcelRegister("bGQI8", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$18GwD('asyncIterator');

});

parcelRegister("sd6Ri", function(module, exports) {
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $9100U = parcelRequire("9100U");

var $kvDzZ = parcelRequire("kvDzZ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $keZ2c = parcelRequire("keZ2c");

var $1ZKCr = parcelRequire("1ZKCr");

var $7mAhs = parcelRequire("7mAhs");

var $1H3Lz = parcelRequire("1H3Lz");

var $4GKxk = parcelRequire("4GKxk");

var $fnTTa = parcelRequire("fnTTa");
var $054cc8effebf666b$var$NativeSymbol = $kvDzZ.Symbol;
var $054cc8effebf666b$var$SymbolPrototype = $054cc8effebf666b$var$NativeSymbol && $054cc8effebf666b$var$NativeSymbol.prototype;
if ($9100U && $1ZKCr($054cc8effebf666b$var$NativeSymbol) && (!('description' in $054cc8effebf666b$var$SymbolPrototype) || // Safari 12 bug
$054cc8effebf666b$var$NativeSymbol().description !== undefined)) {
    var $054cc8effebf666b$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $054cc8effebf666b$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $1H3Lz(arguments[0]);
        var result = $7mAhs($054cc8effebf666b$var$SymbolPrototype, this) ? new $054cc8effebf666b$var$NativeSymbol(description) : description === undefined ? $054cc8effebf666b$var$NativeSymbol() : $054cc8effebf666b$var$NativeSymbol(description);
        if (description === '') $054cc8effebf666b$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $fnTTa($054cc8effebf666b$var$SymbolWrapper, $054cc8effebf666b$var$NativeSymbol);
    // wrap Symbol.for for correct handling of empty string descriptions
    var $054cc8effebf666b$var$nativeFor = $054cc8effebf666b$var$SymbolWrapper['for'];
    $054cc8effebf666b$var$SymbolWrapper['for'] = ({
        'for': function(key) {
            var stringKey = $1H3Lz(key);
            var symbol = $8lKVU($054cc8effebf666b$var$nativeFor, this, stringKey);
            if (stringKey === '') $054cc8effebf666b$var$EmptyStringDescriptionStore[symbol] = true;
            return symbol;
        }
    })['for'];
    $054cc8effebf666b$var$SymbolWrapper.prototype = $054cc8effebf666b$var$SymbolPrototype;
    $054cc8effebf666b$var$SymbolPrototype.constructor = $054cc8effebf666b$var$SymbolWrapper;
    var $054cc8effebf666b$var$NATIVE_SYMBOL = String($054cc8effebf666b$var$NativeSymbol('description detection')) === 'Symbol(description detection)';
    var $054cc8effebf666b$var$thisSymbolValue = $7n9WH($054cc8effebf666b$var$SymbolPrototype.valueOf);
    var $054cc8effebf666b$var$symbolDescriptiveString = $7n9WH($054cc8effebf666b$var$SymbolPrototype.toString);
    var $054cc8effebf666b$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $054cc8effebf666b$var$replace = $7n9WH(''.replace);
    var $054cc8effebf666b$var$stringSlice = $7n9WH(''.slice);
    $4GKxk($054cc8effebf666b$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = $054cc8effebf666b$var$thisSymbolValue(this);
            if ($keZ2c($054cc8effebf666b$var$EmptyStringDescriptionStore, symbol)) return '';
            var string = $054cc8effebf666b$var$symbolDescriptiveString(symbol);
            var desc = $054cc8effebf666b$var$NATIVE_SYMBOL ? $054cc8effebf666b$var$stringSlice(string, 7, -1) : $054cc8effebf666b$var$replace(string, $054cc8effebf666b$var$regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $1XSJh({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $054cc8effebf666b$var$SymbolWrapper
    });
}

});

parcelRegister("lsEcz", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $18GwD = parcelRequire("18GwD");

var $dsVjX = parcelRequire("dsVjX");
var $f9fb65c0ef023fb2$require$defineProperty = $dsVjX.f;

var $kmjYa = parcelRequire("kmjYa");
var $f9fb65c0ef023fb2$require$getOwnPropertyDescriptor = $kmjYa.f;
var $f9fb65c0ef023fb2$var$Symbol = $kvDzZ.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$18GwD('dispose');
if ($f9fb65c0ef023fb2$var$Symbol) {
    var $f9fb65c0ef023fb2$var$descriptor = $f9fb65c0ef023fb2$require$getOwnPropertyDescriptor($f9fb65c0ef023fb2$var$Symbol, 'dispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($f9fb65c0ef023fb2$var$descriptor.enumerable && $f9fb65c0ef023fb2$var$descriptor.configurable && $f9fb65c0ef023fb2$var$descriptor.writable) $f9fb65c0ef023fb2$require$defineProperty($f9fb65c0ef023fb2$var$Symbol, 'dispose', {
        value: $f9fb65c0ef023fb2$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}

});

parcelRegister("2poLz", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$18GwD('hasInstance');

});

parcelRegister("b49To", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$18GwD('isConcatSpreadable');

});

parcelRegister("7EE6t", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$18GwD('iterator');

});

parcelRegister("2kqse", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$18GwD('match');

});

parcelRegister("39hva", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$18GwD('matchAll');

});

parcelRegister("5XA6M", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$18GwD('replace');

});

parcelRegister("1yBYS", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$18GwD('search');

});

parcelRegister("6knIt", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$18GwD('species');

});

parcelRegister("fkY1G", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$18GwD('split');

});

parcelRegister("dFgdm", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");

var $3ppV5 = parcelRequire("3ppV5");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$18GwD('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$3ppV5();

});

parcelRegister("crz9y", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $18GwD = parcelRequire("18GwD");

var $2Zevq = parcelRequire("2Zevq");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$18GwD('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$2Zevq($4uwSa('Symbol'), 'Symbol');

});

parcelRegister("6fJW1", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$18GwD('unscopables');

});

parcelRegister("kJNPM", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $2Zevq = parcelRequire("2Zevq");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$2Zevq($kvDzZ.JSON, 'JSON', true);

});

parcelRegister("cgXro", function(module, exports) {
'use strict';

var $2Zevq = parcelRequire("2Zevq");
// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$2Zevq(Math, 'Math', true);

});

parcelRegister("hsROu", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $kvDzZ = parcelRequire("kvDzZ");

var $2Zevq = parcelRequire("2Zevq");
$1XSJh({
    global: true
}, {
    Reflect: {}
});
// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
$2Zevq($kvDzZ.Reflect, 'Reflect', true);

});


parcelRegister("3SQhX", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $igLrZ = parcelRequire("igLrZ");

var $hWyQc = parcelRequire("hWyQc");

var $bvzmg = parcelRequire("bvzmg");

var $aPaKH = parcelRequire("aPaKH");

var $2Zevq = parcelRequire("2Zevq");

var $mgvTx = parcelRequire("mgvTx");
var $2d3ef9ab4e770834$var$ITERATOR = $mgvTx('iterator');
var $2d3ef9ab4e770834$var$ArrayValues = $bvzmg.values;
var $2d3ef9ab4e770834$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$2d3ef9ab4e770834$var$ITERATOR] !== $2d3ef9ab4e770834$var$ArrayValues) try {
            $aPaKH(CollectionPrototype, $2d3ef9ab4e770834$var$ITERATOR, $2d3ef9ab4e770834$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$2d3ef9ab4e770834$var$ITERATOR] = $2d3ef9ab4e770834$var$ArrayValues;
        }
        $2Zevq(CollectionPrototype, COLLECTION_NAME, true);
        if ($igLrZ[COLLECTION_NAME]) for(var METHOD_NAME in $bvzmg){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $bvzmg[METHOD_NAME]) try {
                $aPaKH(CollectionPrototype, METHOD_NAME, $bvzmg[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $bvzmg[METHOD_NAME];
            }
        }
    }
};
for(var $2d3ef9ab4e770834$var$COLLECTION_NAME in $igLrZ)$2d3ef9ab4e770834$var$handlePrototype($kvDzZ[$2d3ef9ab4e770834$var$COLLECTION_NAME] && $kvDzZ[$2d3ef9ab4e770834$var$COLLECTION_NAME].prototype, $2d3ef9ab4e770834$var$COLLECTION_NAME);
$2d3ef9ab4e770834$var$handlePrototype($hWyQc, 'DOMTokenList');

});
parcelRegister("igLrZ", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRegister("hWyQc", function(module, exports) {
'use strict';

var $iJAYS = parcelRequire("iJAYS");
var $d102e11c076179cf$var$classList = $iJAYS('span').classList;
var $d102e11c076179cf$var$DOMTokenListPrototype = $d102e11c076179cf$var$classList && $d102e11c076179cf$var$classList.constructor && $d102e11c076179cf$var$classList.constructor.prototype;
module.exports = $d102e11c076179cf$var$DOMTokenListPrototype === Object.prototype ? undefined : $d102e11c076179cf$var$DOMTokenListPrototype;

});

parcelRegister("bvzmg", function(module, exports) {
'use strict';

var $4EWOr = parcelRequire("4EWOr");

var $fe51S = parcelRequire("fe51S");

var $7HAsE = parcelRequire("7HAsE");

var $4eljv = parcelRequire("4eljv");

var $dsVjX = parcelRequire("dsVjX");
var $860e0454ad31c3c3$require$defineProperty = $dsVjX.f;

var $8Lwcp = parcelRequire("8Lwcp");

var $lQpvq = parcelRequire("lQpvq");

var $axseE = parcelRequire("axseE");

var $9100U = parcelRequire("9100U");
var $860e0454ad31c3c3$var$ARRAY_ITERATOR = 'Array Iterator';
var $860e0454ad31c3c3$var$setInternalState = $4eljv.set;
var $860e0454ad31c3c3$var$getInternalState = $4eljv.getterFor($860e0454ad31c3c3$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $8Lwcp(Array, 'Array', function(iterated, kind) {
    $860e0454ad31c3c3$var$setInternalState(this, {
        type: $860e0454ad31c3c3$var$ARRAY_ITERATOR,
        target: $4EWOr(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $860e0454ad31c3c3$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $lQpvq(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $lQpvq(index, false);
        case 'values':
            return $lQpvq(target[index], false);
    }
    return $lQpvq([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $860e0454ad31c3c3$var$values = $7HAsE.Arguments = $7HAsE.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$fe51S('keys');
$fe51S('values');
$fe51S('entries');
// V8 ~ Chrome 45- bug
if (!$axseE && $9100U && $860e0454ad31c3c3$var$values.name !== 'values') try {
    $860e0454ad31c3c3$require$defineProperty($860e0454ad31c3c3$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("fe51S", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $emiQA = parcelRequire("emiQA");

var $dsVjX = parcelRequire("dsVjX");
var $b15c1088d3844b30$require$defineProperty = $dsVjX.f;
var $b15c1088d3844b30$var$UNSCOPABLES = $mgvTx('unscopables');
var $b15c1088d3844b30$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($b15c1088d3844b30$var$ArrayPrototype[$b15c1088d3844b30$var$UNSCOPABLES] === undefined) $b15c1088d3844b30$require$defineProperty($b15c1088d3844b30$var$ArrayPrototype, $b15c1088d3844b30$var$UNSCOPABLES, {
    configurable: true,
    value: $emiQA(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $b15c1088d3844b30$var$ArrayPrototype[$b15c1088d3844b30$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("7HAsE", function(module, exports) {
'use strict';
module.exports = {};

});

parcelRegister("8Lwcp", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $8lKVU = parcelRequire("8lKVU");

var $axseE = parcelRequire("axseE");

var $hCoZT = parcelRequire("hCoZT");

var $1ZKCr = parcelRequire("1ZKCr");

var $5Jked = parcelRequire("5Jked");

var $eHPSS = parcelRequire("eHPSS");

var $BroF8 = parcelRequire("BroF8");

var $2Zevq = parcelRequire("2Zevq");

var $aPaKH = parcelRequire("aPaKH");

var $2t4Gp = parcelRequire("2t4Gp");

var $mgvTx = parcelRequire("mgvTx");

var $7HAsE = parcelRequire("7HAsE");

var $J9W4z = parcelRequire("J9W4z");
var $661bb09cba2f48ef$var$PROPER_FUNCTION_NAME = $hCoZT.PROPER;
var $661bb09cba2f48ef$var$CONFIGURABLE_FUNCTION_NAME = $hCoZT.CONFIGURABLE;
var $661bb09cba2f48ef$var$IteratorPrototype = $J9W4z.IteratorPrototype;
var $661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS = $J9W4z.BUGGY_SAFARI_ITERATORS;
var $661bb09cba2f48ef$var$ITERATOR = $mgvTx('iterator');
var $661bb09cba2f48ef$var$KEYS = 'keys';
var $661bb09cba2f48ef$var$VALUES = 'values';
var $661bb09cba2f48ef$var$ENTRIES = 'entries';
var $661bb09cba2f48ef$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5Jked(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $661bb09cba2f48ef$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $661bb09cba2f48ef$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $661bb09cba2f48ef$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$661bb09cba2f48ef$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $eHPSS(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$axseE && $eHPSS(CurrentIteratorPrototype) !== $661bb09cba2f48ef$var$IteratorPrototype) {
                if ($BroF8) $BroF8(CurrentIteratorPrototype, $661bb09cba2f48ef$var$IteratorPrototype);
                else if (!$1ZKCr(CurrentIteratorPrototype[$661bb09cba2f48ef$var$ITERATOR])) $2t4Gp(CurrentIteratorPrototype, $661bb09cba2f48ef$var$ITERATOR, $661bb09cba2f48ef$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $2Zevq(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($axseE) $7HAsE[TO_STRING_TAG] = $661bb09cba2f48ef$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($661bb09cba2f48ef$var$PROPER_FUNCTION_NAME && DEFAULT === $661bb09cba2f48ef$var$VALUES && nativeIterator && nativeIterator.name !== $661bb09cba2f48ef$var$VALUES) {
        if (!$axseE && $661bb09cba2f48ef$var$CONFIGURABLE_FUNCTION_NAME) $aPaKH(IterablePrototype, 'name', $661bb09cba2f48ef$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $8lKVU(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($661bb09cba2f48ef$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($661bb09cba2f48ef$var$KEYS),
            entries: getIterationMethod($661bb09cba2f48ef$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $2t4Gp(IterablePrototype, KEY, methods[KEY]);
        } else $1XSJh({
            target: NAME,
            proto: true,
            forced: $661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$axseE || FORCED) && IterablePrototype[$661bb09cba2f48ef$var$ITERATOR] !== defaultIterator) $2t4Gp(IterablePrototype, $661bb09cba2f48ef$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $7HAsE[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("5Jked", function(module, exports) {
'use strict';

var $J9W4z = parcelRequire("J9W4z");
var $42c0d8a7ba4cc266$require$IteratorPrototype = $J9W4z.IteratorPrototype;

var $emiQA = parcelRequire("emiQA");

var $3qjfQ = parcelRequire("3qjfQ");

var $2Zevq = parcelRequire("2Zevq");

var $7HAsE = parcelRequire("7HAsE");
var $42c0d8a7ba4cc266$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $emiQA($42c0d8a7ba4cc266$require$IteratorPrototype, {
        next: $3qjfQ(+!ENUMERABLE_NEXT, next)
    });
    $2Zevq(IteratorConstructor, TO_STRING_TAG, false, true);
    $7HAsE[TO_STRING_TAG] = $42c0d8a7ba4cc266$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("J9W4z", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $9OhmT = parcelRequire("9OhmT");

var $emiQA = parcelRequire("emiQA");

var $eHPSS = parcelRequire("eHPSS");

var $2t4Gp = parcelRequire("2t4Gp");

var $mgvTx = parcelRequire("mgvTx");

var $axseE = parcelRequire("axseE");
var $087be9192a66014c$var$ITERATOR = $mgvTx('iterator');
var $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $087be9192a66014c$var$IteratorPrototype, $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype, $087be9192a66014c$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $087be9192a66014c$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $087be9192a66014c$var$arrayIterator)) $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype = $eHPSS($eHPSS($087be9192a66014c$var$arrayIterator));
        if ($087be9192a66014c$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $087be9192a66014c$var$IteratorPrototype = $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $087be9192a66014c$var$NEW_ITERATOR_PROTOTYPE = !$9OhmT($087be9192a66014c$var$IteratorPrototype) || $bAE3C(function() {
    var test = {};
    // FF44- legacy iterators case
    return $087be9192a66014c$var$IteratorPrototype[$087be9192a66014c$var$ITERATOR].call(test) !== test;
});
if ($087be9192a66014c$var$NEW_ITERATOR_PROTOTYPE) $087be9192a66014c$var$IteratorPrototype = {};
else if ($axseE) $087be9192a66014c$var$IteratorPrototype = $emiQA($087be9192a66014c$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$1ZKCr($087be9192a66014c$var$IteratorPrototype[$087be9192a66014c$var$ITERATOR])) $2t4Gp($087be9192a66014c$var$IteratorPrototype, $087be9192a66014c$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $087be9192a66014c$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("eHPSS", function(module, exports) {
'use strict';

var $keZ2c = parcelRequire("keZ2c");

var $1ZKCr = parcelRequire("1ZKCr");

var $hicPf = parcelRequire("hicPf");

var $k3YZr = parcelRequire("k3YZr");

var $eXils = parcelRequire("eXils");
var $ab4d53f8128d56b5$var$IE_PROTO = $k3YZr('IE_PROTO');
var $ab4d53f8128d56b5$var$$Object = Object;
var $ab4d53f8128d56b5$var$ObjectPrototype = $ab4d53f8128d56b5$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $eXils ? $ab4d53f8128d56b5$var$$Object.getPrototypeOf : function(O) {
    var object = $hicPf(O);
    if ($keZ2c(object, $ab4d53f8128d56b5$var$IE_PROTO)) return object[$ab4d53f8128d56b5$var$IE_PROTO];
    var constructor = object.constructor;
    if ($1ZKCr(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $ab4d53f8128d56b5$var$$Object ? $ab4d53f8128d56b5$var$ObjectPrototype : null;
};

});
parcelRegister("eXils", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
module.exports = !$bAE3C(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});




parcelRegister("BroF8", function(module, exports) {
'use strict';

var $cO8Cy = parcelRequire("cO8Cy");

var $9OhmT = parcelRequire("9OhmT");

var $388Wm = parcelRequire("388Wm");

var $1RqXI = parcelRequire("1RqXI");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $cO8Cy(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $388Wm(O);
        $1RqXI(proto);
        if (!$9OhmT(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("cO8Cy", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $g7x3l = parcelRequire("g7x3l");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $7n9WH($g7x3l(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("1RqXI", function(module, exports) {
'use strict';

var $cpvpr = parcelRequire("cpvpr");
var $15afa7c928a92e4f$var$$String = String;
var $15afa7c928a92e4f$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($cpvpr(argument)) return argument;
    throw new $15afa7c928a92e4f$var$$TypeError("Can't set " + $15afa7c928a92e4f$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("cpvpr", function(module, exports) {
'use strict';

var $9OhmT = parcelRequire("9OhmT");
module.exports = function(argument) {
    return $9OhmT(argument) || argument === null;
};

});




parcelRegister("lQpvq", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});




parcelRegister("4AEWC", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $dsVjX = parcelRequire("dsVjX");
var $357a48eab54f2feb$require$defineProperty = $dsVjX.f;
var $357a48eab54f2feb$var$METADATA = $mgvTx('metadata');
var $357a48eab54f2feb$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($357a48eab54f2feb$var$FunctionPrototype[$357a48eab54f2feb$var$METADATA] === undefined) $357a48eab54f2feb$require$defineProperty($357a48eab54f2feb$var$FunctionPrototype, $357a48eab54f2feb$var$METADATA, {
    value: null
});

});

parcelRegister("h3JRe", function(module, exports) {
'use strict';
parcelRequire("hPO2C");

});

parcelRegister("haEFx", function(module, exports) {
'use strict';
parcelRequire("lsEcz");

});

parcelRegister("lYc2Q", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$18GwD('metadata');

});


parcelRegister("B3Rmu", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $2pjhR = parcelRequire("2pjhR");
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$1XSJh({
    target: 'Symbol',
    stat: true
}, {
    isRegisteredSymbol: $2pjhR
});

});
parcelRegister("2pjhR", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");
var $1c0ce09382c54cbc$var$Symbol = $4uwSa('Symbol');
var $1c0ce09382c54cbc$var$keyFor = $1c0ce09382c54cbc$var$Symbol.keyFor;
var $1c0ce09382c54cbc$var$thisSymbolValue = $7n9WH($1c0ce09382c54cbc$var$Symbol.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = $1c0ce09382c54cbc$var$Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $1c0ce09382c54cbc$var$keyFor($1c0ce09382c54cbc$var$thisSymbolValue(value)) !== undefined;
    } catch (error) {
        return false;
    }
};

});


parcelRegister("7H6Ip", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $fNAJI = parcelRequire("fNAJI");
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $fNAJI
});

});
parcelRegister("fNAJI", function(module, exports) {
'use strict';

var $cITHp = parcelRequire("cITHp");

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");

var $1Q1gI = parcelRequire("1Q1gI");

var $mgvTx = parcelRequire("mgvTx");
var $b807edb17772293b$var$Symbol = $4uwSa('Symbol');
var $b807edb17772293b$var$$isWellKnownSymbol = $b807edb17772293b$var$Symbol.isWellKnownSymbol;
var $b807edb17772293b$var$getOwnPropertyNames = $4uwSa('Object', 'getOwnPropertyNames');
var $b807edb17772293b$var$thisSymbolValue = $7n9WH($b807edb17772293b$var$Symbol.prototype.valueOf);
var $b807edb17772293b$var$WellKnownSymbolsStore = $cITHp('wks');
for(var $b807edb17772293b$var$i = 0, $b807edb17772293b$var$symbolKeys = $b807edb17772293b$var$getOwnPropertyNames($b807edb17772293b$var$Symbol), $b807edb17772293b$var$symbolKeysLength = $b807edb17772293b$var$symbolKeys.length; $b807edb17772293b$var$i < $b807edb17772293b$var$symbolKeysLength; $b807edb17772293b$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $b807edb17772293b$var$symbolKey = $b807edb17772293b$var$symbolKeys[$b807edb17772293b$var$i];
    if ($1Q1gI($b807edb17772293b$var$Symbol[$b807edb17772293b$var$symbolKey])) $mgvTx($b807edb17772293b$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
    if ($b807edb17772293b$var$$isWellKnownSymbol && $b807edb17772293b$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $b807edb17772293b$var$thisSymbolValue(value);
        for(var j = 0, keys = $b807edb17772293b$var$getOwnPropertyNames($b807edb17772293b$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if ($b807edb17772293b$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};

});


parcelRegister("dqfzw", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('customMatcher');

});

parcelRegister("1Uru5", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$18GwD('observable');

});

parcelRegister("3CVe2", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $2pjhR = parcelRequire("2pjhR");
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$1XSJh({
    target: 'Symbol',
    stat: true,
    name: 'isRegisteredSymbol'
}, {
    isRegistered: $2pjhR
});

});

parcelRegister("5UszO", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $fNAJI = parcelRequire("fNAJI");
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$1XSJh({
    target: 'Symbol',
    stat: true,
    name: 'isWellKnownSymbol',
    forced: true
}, {
    isWellKnown: $fNAJI
});

});

parcelRegister("cxaIU", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('matcher');

});

parcelRegister("kIR3S", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$18GwD('metadataKey');

});

parcelRegister("2u8TL", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('patternMatch');

});

parcelRegister("khlXA", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
$18GwD('replaceAll');

});


parcelRegister("3MGWX", function(module, exports) {
'use strict';

var $9XOqv = parcelRequire("9XOqv");
module.exports = $9XOqv;

});
parcelRegister("9XOqv", function(module, exports) {
'use strict';

var $hX9IH = parcelRequire("hX9IH");
module.exports = $hX9IH;

});
parcelRegister("hX9IH", function(module, exports) {
'use strict';

var $k0dS9 = parcelRequire("k0dS9");
module.exports = $k0dS9;

});
parcelRegister("k0dS9", function(module, exports) {
'use strict';
parcelRequire("f7BYa");
parcelRequire("cvwxk");

var $9AtxJ = parcelRequire("9AtxJ");
module.exports = $9AtxJ.Array.from;

});
parcelRegister("f7BYa", function(module, exports) {
'use strict';

var $hkAQY = parcelRequire("hkAQY");
var $b024f66566f06736$require$charAt = $hkAQY.charAt;

var $1H3Lz = parcelRequire("1H3Lz");

var $4eljv = parcelRequire("4eljv");

var $8Lwcp = parcelRequire("8Lwcp");

var $lQpvq = parcelRequire("lQpvq");
var $b024f66566f06736$var$STRING_ITERATOR = 'String Iterator';
var $b024f66566f06736$var$setInternalState = $4eljv.set;
var $b024f66566f06736$var$getInternalState = $4eljv.getterFor($b024f66566f06736$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$8Lwcp(String, 'String', function(iterated) {
    $b024f66566f06736$var$setInternalState(this, {
        type: $b024f66566f06736$var$STRING_ITERATOR,
        string: $1H3Lz(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $b024f66566f06736$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $lQpvq(undefined, true);
    point = $b024f66566f06736$require$charAt(string, index);
    state.index += point.length;
    return $lQpvq(point, false);
});

});
parcelRegister("hkAQY", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $hXJr0 = parcelRequire("hXJr0");

var $1H3Lz = parcelRequire("1H3Lz");

var $388Wm = parcelRequire("388Wm");
var $c9e0e4405f6933db$var$charAt = $7n9WH(''.charAt);
var $c9e0e4405f6933db$var$charCodeAt = $7n9WH(''.charCodeAt);
var $c9e0e4405f6933db$var$stringSlice = $7n9WH(''.slice);
var $c9e0e4405f6933db$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $1H3Lz($388Wm($this));
        var position = $hXJr0(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $c9e0e4405f6933db$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $c9e0e4405f6933db$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $c9e0e4405f6933db$var$charAt(S, position) : first : CONVERT_TO_STRING ? $c9e0e4405f6933db$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $c9e0e4405f6933db$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $c9e0e4405f6933db$var$createMethod(true)
};

});


parcelRegister("cvwxk", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $lBNRQ = parcelRequire("lBNRQ");

var $haiBW = parcelRequire("haiBW");
var $91b19e5a13496a48$var$INCORRECT_ITERATION = !$haiBW(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$1XSJh({
    target: 'Array',
    stat: true,
    forced: $91b19e5a13496a48$var$INCORRECT_ITERATION
}, {
    from: $lBNRQ
});

});
parcelRegister("lBNRQ", function(module, exports) {
'use strict';

var $lvfol = parcelRequire("lvfol");

var $8lKVU = parcelRequire("8lKVU");

var $hicPf = parcelRequire("hicPf");

var $iEf5n = parcelRequire("iEf5n");

var $9r4Pz = parcelRequire("9r4Pz");

var $cmnjY = parcelRequire("cmnjY");

var $6HcaS = parcelRequire("6HcaS");

var $7F0dl = parcelRequire("7F0dl");

var $gqEDU = parcelRequire("gqEDU");

var $kD1mB = parcelRequire("kD1mB");

var $lyncN = parcelRequire("lyncN");

var $gPp4U = parcelRequire("gPp4U");
var $fbb3bc4d85a696a7$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var IS_CONSTRUCTOR = $cmnjY(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $lvfol(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var O = $hicPf(arrayLike);
    var iteratorMethod = $lyncN(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $fbb3bc4d85a696a7$var$$Array && $9r4Pz(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $kD1mB(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $8lKVU(next, iterator)).done; index++){
            value = mapping ? $iEf5n(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            try {
                $7F0dl(result, index, value);
            } catch (error) {
                $gPp4U(iterator, 'throw', error);
            }
        }
    } else {
        length = $6HcaS(O);
        result = IS_CONSTRUCTOR ? new this(length) : $fbb3bc4d85a696a7$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $7F0dl(result, index, value);
        }
    }
    $gqEDU(result, index);
    return result;
};

});
parcelRegister("iEf5n", function(module, exports) {
'use strict';

var $4LaI4 = parcelRequire("4LaI4");

var $gPp4U = parcelRequire("gPp4U");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($4LaI4(value)[0], value[1]) : fn(value);
    } catch (error) {
        $gPp4U(iterator, 'throw', error);
    }
};

});
parcelRegister("gPp4U", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $4LaI4 = parcelRequire("4LaI4");

var $eZ5qV = parcelRequire("eZ5qV");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $4LaI4(iterator);
    try {
        innerResult = $eZ5qV(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $8lKVU(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $4LaI4(innerResult);
    return value;
};

});


parcelRegister("9r4Pz", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $7HAsE = parcelRequire("7HAsE");
var $6dea61f91d02b61c$var$ITERATOR = $mgvTx('iterator');
var $6dea61f91d02b61c$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($7HAsE.Array === it || $6dea61f91d02b61c$var$ArrayPrototype[$6dea61f91d02b61c$var$ITERATOR] === it);
};

});

parcelRegister("kD1mB", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $g7x3l = parcelRequire("g7x3l");

var $4LaI4 = parcelRequire("4LaI4");

var $7MtCT = parcelRequire("7MtCT");

var $lyncN = parcelRequire("lyncN");
var $f04881f0a594a8f1$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $lyncN(argument) : usingIterator;
    if ($g7x3l(iteratorMethod)) return $4LaI4($8lKVU(iteratorMethod, argument));
    throw new $f04881f0a594a8f1$var$$TypeError($7MtCT(argument) + ' is not iterable');
};

});
parcelRegister("lyncN", function(module, exports) {
'use strict';

var $401SB = parcelRequire("401SB");

var $eZ5qV = parcelRequire("eZ5qV");

var $hKX7u = parcelRequire("hKX7u");

var $7HAsE = parcelRequire("7HAsE");

var $mgvTx = parcelRequire("mgvTx");
var $fb0ec61352810087$var$ITERATOR = $mgvTx('iterator');
module.exports = function(it) {
    if (!$hKX7u(it)) return $eZ5qV(it, $fb0ec61352810087$var$ITERATOR) || $eZ5qV(it, '@@iterator') || $7HAsE[$401SB(it)];
};

});



parcelRegister("haiBW", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");
var $c7f1ce996adbbdcb$var$ITERATOR = $mgvTx('iterator');
var $c7f1ce996adbbdcb$var$SAFE_CLOSING = false;
try {
    var $c7f1ce996adbbdcb$var$called = 0;
    var $c7f1ce996adbbdcb$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$c7f1ce996adbbdcb$var$called++
            };
        },
        'return': function() {
            $c7f1ce996adbbdcb$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $c7f1ce996adbbdcb$var$iteratorWithReturn[$c7f1ce996adbbdcb$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($c7f1ce996adbbdcb$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$c7f1ce996adbbdcb$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$c7f1ce996adbbdcb$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});






parcelRegister("eIZlp", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $ab84c276d9b3d7c1$export$9c16c1426311996d; }, function (v) { return $ab84c276d9b3d7c1$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $ab84c276d9b3d7c1$export$dca3b0875bd9a954; }, function (v) { return $ab84c276d9b3d7c1$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ab84c276d9b3d7c1$export$16fa2f45be04daa8; }, function (v) { return $ab84c276d9b3d7c1$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ab84c276d9b3d7c1$export$ffb0004e005737fa; }, function (v) { return $ab84c276d9b3d7c1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ab84c276d9b3d7c1$export$e2c29f18771995cb; }, function (v) { return $ab84c276d9b3d7c1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ab84c276d9b3d7c1$export$221d75b3f55bb0bd; }, function (v) { return $ab84c276d9b3d7c1$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ab84c276d9b3d7c1$export$5f8d39834fd61797; }, function (v) { return $ab84c276d9b3d7c1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ab84c276d9b3d7c1$export$74bf444e3cd11ea5; }, function (v) { return $ab84c276d9b3d7c1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $ab84c276d9b3d7c1$export$1ced07cd6b1985ce; }, function (v) { return $ab84c276d9b3d7c1$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $ab84c276d9b3d7c1$export$abd8e32b826d7ea7; }, function (v) { return $ab84c276d9b3d7c1$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $ab84c276d9b3d7c1$export$69a3209f1a06c04d; }, function (v) { return $ab84c276d9b3d7c1$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $ab84c276d9b3d7c1$export$8c538325882c7eec; }, function (v) { return $ab84c276d9b3d7c1$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ab84c276d9b3d7c1$export$e530037191fcd5d7; }, function (v) { return $ab84c276d9b3d7c1$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ab84c276d9b3d7c1$export$fd42f52fd3ae1109; }, function (v) { return $ab84c276d9b3d7c1$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ab84c276d9b3d7c1$export$c8a8987d4410bf2d; }, function (v) { return $ab84c276d9b3d7c1$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $ab84c276d9b3d7c1$export$7d1e3a5e95ceca43; }, function (v) { return $ab84c276d9b3d7c1$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ab84c276d9b3d7c1$export$257a8862b851cb5b; }, function (v) { return $ab84c276d9b3d7c1$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ab84c276d9b3d7c1$export$a8257692ac88316c; }, function (v) { return $ab84c276d9b3d7c1$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ab84c276d9b3d7c1$export$488013bae63b21da; }, function (v) { return $ab84c276d9b3d7c1$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ab84c276d9b3d7c1$export$7c73462e0d25e514; }, function (v) { return $ab84c276d9b3d7c1$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ab84c276d9b3d7c1$export$7568632d0d33d16d; }, function (v) { return $ab84c276d9b3d7c1$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $ab84c276d9b3d7c1$export$f93f40ac0ca7e3a8; }, function (v) { return $ab84c276d9b3d7c1$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $ab84c276d9b3d7c1$export$1f96ae73734a86cc; }, function (v) { return $ab84c276d9b3d7c1$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $ab84c276d9b3d7c1$export$9a47ced3238df325; }, function (v) { return $ab84c276d9b3d7c1$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ab84c276d9b3d7c1$export$35808ee640e87ca7; }, function (v) { return $ab84c276d9b3d7c1$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ab84c276d9b3d7c1$export$fae74005e78b1a27; }, function (v) { return $ab84c276d9b3d7c1$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ab84c276d9b3d7c1$export$dc8fbce3eb94dc1e; }, function (v) { return $ab84c276d9b3d7c1$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ab84c276d9b3d7c1$export$6a7bc4e911dc01cf; }, function (v) { return $ab84c276d9b3d7c1$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ab84c276d9b3d7c1$export$6d9c69b0de29b591; }, function (v) { return $ab84c276d9b3d7c1$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $ab84c276d9b3d7c1$export$7f54fc3180508a52; }, function (v) { return $ab84c276d9b3d7c1$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $ab84c276d9b3d7c1$export$f680877a34711e37; }, function (v) { return $ab84c276d9b3d7c1$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ab84c276d9b3d7c1$export$d5a552a76deda3c2; }, function (v) { return $ab84c276d9b3d7c1$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ab84c276d9b3d7c1$export$aaabe4eda9ed9969; }, function (v) { return $ab84c276d9b3d7c1$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ab84c276d9b3d7c1$export$e5c5a5f917a5871c; }, function (v) { return $ab84c276d9b3d7c1$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ab84c276d9b3d7c1$export$1538c33de8887b59; }, function (v) { return $ab84c276d9b3d7c1$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $ab84c276d9b3d7c1$export$fca7f784ae7a249a; }, function (v) { return $ab84c276d9b3d7c1$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $ab84c276d9b3d7c1$export$13e3392192263954; }, function (v) { return $ab84c276d9b3d7c1$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ab84c276d9b3d7c1$export$b8f5890fc79d6aca; }, function (v) { return $ab84c276d9b3d7c1$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ab84c276d9b3d7c1$export$60241385465d0a34; }, function (v) { return $ab84c276d9b3d7c1$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ab84c276d9b3d7c1$export$306c0aa65ff9ec16; }, function (v) { return $ab84c276d9b3d7c1$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ab84c276d9b3d7c1$export$7b286972b8d8ccbf; }, function (v) { return $ab84c276d9b3d7c1$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ab84c276d9b3d7c1$export$83d89fbfd8236492; }, function (v) { return $ab84c276d9b3d7c1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ab84c276d9b3d7c1$export$9c16c1426311996d;
var $ab84c276d9b3d7c1$export$dca3b0875bd9a954;
var $ab84c276d9b3d7c1$export$16fa2f45be04daa8;
var $ab84c276d9b3d7c1$export$ffb0004e005737fa;
var $ab84c276d9b3d7c1$export$e2c29f18771995cb;
var $ab84c276d9b3d7c1$export$221d75b3f55bb0bd;
var $ab84c276d9b3d7c1$export$5f8d39834fd61797;
var $ab84c276d9b3d7c1$export$74bf444e3cd11ea5;
var $ab84c276d9b3d7c1$export$1ced07cd6b1985ce;
var $ab84c276d9b3d7c1$export$abd8e32b826d7ea7;
var $ab84c276d9b3d7c1$export$69a3209f1a06c04d;
var $ab84c276d9b3d7c1$export$8c538325882c7eec;
var $ab84c276d9b3d7c1$export$e530037191fcd5d7;
var $ab84c276d9b3d7c1$export$fd42f52fd3ae1109;
var $ab84c276d9b3d7c1$export$c8a8987d4410bf2d;
var $ab84c276d9b3d7c1$export$7d1e3a5e95ceca43;
var $ab84c276d9b3d7c1$export$257a8862b851cb5b;
var $ab84c276d9b3d7c1$export$a8257692ac88316c;
var $ab84c276d9b3d7c1$export$488013bae63b21da;
var $ab84c276d9b3d7c1$export$7c73462e0d25e514;
var $ab84c276d9b3d7c1$export$7568632d0d33d16d;
var $ab84c276d9b3d7c1$export$f93f40ac0ca7e3a8;
var $ab84c276d9b3d7c1$export$1f96ae73734a86cc;
var $ab84c276d9b3d7c1$export$9a47ced3238df325;
var $ab84c276d9b3d7c1$export$35808ee640e87ca7;
var $ab84c276d9b3d7c1$export$fae74005e78b1a27;
var $ab84c276d9b3d7c1$export$dc8fbce3eb94dc1e;
var $ab84c276d9b3d7c1$export$6a7bc4e911dc01cf;
var $ab84c276d9b3d7c1$export$6d9c69b0de29b591;
var $ab84c276d9b3d7c1$export$7f54fc3180508a52;
var $ab84c276d9b3d7c1$export$f680877a34711e37;
var $ab84c276d9b3d7c1$export$d5a552a76deda3c2;
var $ab84c276d9b3d7c1$export$aaabe4eda9ed9969;
var $ab84c276d9b3d7c1$export$e5c5a5f917a5871c;
var $ab84c276d9b3d7c1$export$1538c33de8887b59;
var $ab84c276d9b3d7c1$export$fca7f784ae7a249a;
var $ab84c276d9b3d7c1$export$13e3392192263954;
var $ab84c276d9b3d7c1$export$b8f5890fc79d6aca;
var $ab84c276d9b3d7c1$export$60241385465d0a34;
var $ab84c276d9b3d7c1$export$306c0aa65ff9ec16;
var $ab84c276d9b3d7c1$export$7b286972b8d8ccbf;
var $ab84c276d9b3d7c1$export$83d89fbfd8236492;
"use strict";
var $ab84c276d9b3d7c1$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ab84c276d9b3d7c1$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ab84c276d9b3d7c1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ab84c276d9b3d7c1$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ab84c276d9b3d7c1$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ab84c276d9b3d7c1$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ab84c276d9b3d7c1$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ab84c276d9b3d7c1$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ab84c276d9b3d7c1$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ab84c276d9b3d7c1$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ab84c276d9b3d7c1$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ab84c276d9b3d7c1$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $ab84c276d9b3d7c1$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $ab84c276d9b3d7c1$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $ab84c276d9b3d7c1$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$ab84c276d9b3d7c1$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $ab84c276d9b3d7c1$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ab84c276d9b3d7c1$var$assign = Object.assign, $ab84c276d9b3d7c1$var$emptyObject = {};
function $ab84c276d9b3d7c1$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ab84c276d9b3d7c1$var$emptyObject;
    this.updater = updater || $ab84c276d9b3d7c1$var$ReactNoopUpdateQueue;
}
$ab84c276d9b3d7c1$var$Component.prototype.isReactComponent = {};
$ab84c276d9b3d7c1$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$ab84c276d9b3d7c1$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $ab84c276d9b3d7c1$var$ComponentDummy() {}
$ab84c276d9b3d7c1$var$ComponentDummy.prototype = $ab84c276d9b3d7c1$var$Component.prototype;
function $ab84c276d9b3d7c1$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ab84c276d9b3d7c1$var$emptyObject;
    this.updater = updater || $ab84c276d9b3d7c1$var$ReactNoopUpdateQueue;
}
var $ab84c276d9b3d7c1$var$pureComponentPrototype = $ab84c276d9b3d7c1$var$PureComponent.prototype = new $ab84c276d9b3d7c1$var$ComponentDummy();
$ab84c276d9b3d7c1$var$pureComponentPrototype.constructor = $ab84c276d9b3d7c1$var$PureComponent;
$ab84c276d9b3d7c1$var$assign($ab84c276d9b3d7c1$var$pureComponentPrototype, $ab84c276d9b3d7c1$var$Component.prototype);
$ab84c276d9b3d7c1$var$pureComponentPrototype.isPureReactComponent = !0;
var $ab84c276d9b3d7c1$var$isArrayImpl = Array.isArray;
function $ab84c276d9b3d7c1$var$noop() {}
var $ab84c276d9b3d7c1$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $ab84c276d9b3d7c1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ab84c276d9b3d7c1$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $ab84c276d9b3d7c1$var$cloneAndReplaceKey(oldElement, newKey) {
    return $ab84c276d9b3d7c1$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $ab84c276d9b3d7c1$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ab84c276d9b3d7c1$var$REACT_ELEMENT_TYPE;
}
function $ab84c276d9b3d7c1$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $ab84c276d9b3d7c1$var$userProvidedKeyEscapeRegex = /\/+/g;
function $ab84c276d9b3d7c1$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $ab84c276d9b3d7c1$var$escape("" + element.key) : index.toString(36);
}
function $ab84c276d9b3d7c1$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($ab84c276d9b3d7c1$var$noop, $ab84c276d9b3d7c1$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $ab84c276d9b3d7c1$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $ab84c276d9b3d7c1$var$REACT_ELEMENT_TYPE:
                case $ab84c276d9b3d7c1$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $ab84c276d9b3d7c1$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $ab84c276d9b3d7c1$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $ab84c276d9b3d7c1$var$getElementKey(children, 0) : nameSoFar, $ab84c276d9b3d7c1$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($ab84c276d9b3d7c1$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $ab84c276d9b3d7c1$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($ab84c276d9b3d7c1$var$isValidElement(callback) && (callback = $ab84c276d9b3d7c1$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($ab84c276d9b3d7c1$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($ab84c276d9b3d7c1$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $ab84c276d9b3d7c1$var$getElementKey(nameSoFar, i), invokeCallback += $ab84c276d9b3d7c1$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $ab84c276d9b3d7c1$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $ab84c276d9b3d7c1$var$getElementKey(nameSoFar, i++), invokeCallback += $ab84c276d9b3d7c1$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $ab84c276d9b3d7c1$var$mapIntoArray($ab84c276d9b3d7c1$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $ab84c276d9b3d7c1$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $ab84c276d9b3d7c1$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $ab84c276d9b3d7c1$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $ab84c276d9b3d7c1$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $ab84c276d9b3d7c1$var$Children = {
    map: $ab84c276d9b3d7c1$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $ab84c276d9b3d7c1$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $ab84c276d9b3d7c1$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $ab84c276d9b3d7c1$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$ab84c276d9b3d7c1$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$ab84c276d9b3d7c1$export$9c16c1426311996d = $ab84c276d9b3d7c1$var$REACT_ACTIVITY_TYPE;
$ab84c276d9b3d7c1$export$dca3b0875bd9a954 = $ab84c276d9b3d7c1$var$Children;
$ab84c276d9b3d7c1$export$16fa2f45be04daa8 = $ab84c276d9b3d7c1$var$Component;
$ab84c276d9b3d7c1$export$ffb0004e005737fa = $ab84c276d9b3d7c1$var$REACT_FRAGMENT_TYPE;
$ab84c276d9b3d7c1$export$e2c29f18771995cb = $ab84c276d9b3d7c1$var$REACT_PROFILER_TYPE;
$ab84c276d9b3d7c1$export$221d75b3f55bb0bd = $ab84c276d9b3d7c1$var$PureComponent;
$ab84c276d9b3d7c1$export$5f8d39834fd61797 = $ab84c276d9b3d7c1$var$REACT_STRICT_MODE_TYPE;
$ab84c276d9b3d7c1$export$74bf444e3cd11ea5 = $ab84c276d9b3d7c1$var$REACT_SUSPENSE_TYPE;
$ab84c276d9b3d7c1$export$1ced07cd6b1985ce = $ab84c276d9b3d7c1$var$ReactSharedInternals;
$ab84c276d9b3d7c1$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$ab84c276d9b3d7c1$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$ab84c276d9b3d7c1$export$8c538325882c7eec = function() {
    return null;
};
$ab84c276d9b3d7c1$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $ab84c276d9b3d7c1$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$ab84c276d9b3d7c1$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $ab84c276d9b3d7c1$var$ReactElement(element.type, key, props);
};
$ab84c276d9b3d7c1$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$ab84c276d9b3d7c1$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$ab84c276d9b3d7c1$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $ab84c276d9b3d7c1$var$ReactElement(type, key, props);
};
$ab84c276d9b3d7c1$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ab84c276d9b3d7c1$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$ab84c276d9b3d7c1$export$a8257692ac88316c = $ab84c276d9b3d7c1$var$isValidElement;
$ab84c276d9b3d7c1$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $ab84c276d9b3d7c1$var$lazyInitializer
    };
};
$ab84c276d9b3d7c1$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $ab84c276d9b3d7c1$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$ab84c276d9b3d7c1$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $ab84c276d9b3d7c1$var$ReactSharedInternals.T, currentTransition = {};
    $ab84c276d9b3d7c1$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $ab84c276d9b3d7c1$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($ab84c276d9b3d7c1$var$noop, $ab84c276d9b3d7c1$var$reportGlobalError);
    } catch (error) {
        $ab84c276d9b3d7c1$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $ab84c276d9b3d7c1$var$ReactSharedInternals.T = prevTransition;
    }
};
$ab84c276d9b3d7c1$export$f93f40ac0ca7e3a8 = function() {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useCacheRefresh();
};
$ab84c276d9b3d7c1$export$1f96ae73734a86cc = function(usable) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.use(usable);
};
$ab84c276d9b3d7c1$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$ab84c276d9b3d7c1$export$35808ee640e87ca7 = function(callback, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$ab84c276d9b3d7c1$export$fae74005e78b1a27 = function(Context) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useContext(Context);
};
$ab84c276d9b3d7c1$export$dc8fbce3eb94dc1e = function() {};
$ab84c276d9b3d7c1$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$ab84c276d9b3d7c1$export$6d9c69b0de29b591 = function(create, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useEffect(create, deps);
};
$ab84c276d9b3d7c1$export$7f54fc3180508a52 = function(callback) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$ab84c276d9b3d7c1$export$f680877a34711e37 = function() {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useId();
};
$ab84c276d9b3d7c1$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$ab84c276d9b3d7c1$export$aaabe4eda9ed9969 = function(create, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$ab84c276d9b3d7c1$export$e5c5a5f917a5871c = function(create, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$ab84c276d9b3d7c1$export$1538c33de8887b59 = function(create, deps) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useMemo(create, deps);
};
$ab84c276d9b3d7c1$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$ab84c276d9b3d7c1$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$ab84c276d9b3d7c1$export$b8f5890fc79d6aca = function(initialValue) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useRef(initialValue);
};
$ab84c276d9b3d7c1$export$60241385465d0a34 = function(initialState) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useState(initialState);
};
$ab84c276d9b3d7c1$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$ab84c276d9b3d7c1$export$7b286972b8d8ccbf = function() {
    return $ab84c276d9b3d7c1$var$ReactSharedInternals.H.useTransition();
};
$ab84c276d9b3d7c1$export$83d89fbfd8236492 = "19.2.7";

});

parcelRegister("laHNN", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $f69c825c3eb0ddcd$export$882461b6382ed46c; }, function (v) { return $f69c825c3eb0ddcd$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f69c825c3eb0ddcd$export$757ceba2d55c277e; }, function (v) { return $f69c825c3eb0ddcd$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $f69c825c3eb0ddcd$export$83d89fbfd8236492; }, function (v) { return $f69c825c3eb0ddcd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f69c825c3eb0ddcd$export$882461b6382ed46c;
var $f69c825c3eb0ddcd$export$757ceba2d55c277e;
var $f69c825c3eb0ddcd$export$83d89fbfd8236492;
"use strict";

var $3CIn6 = parcelRequire("3CIn6");

var $ieaan = parcelRequire("ieaan");

var $ie2rr = parcelRequire("ie2rr");
function $f69c825c3eb0ddcd$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f69c825c3eb0ddcd$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f69c825c3eb0ddcd$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f69c825c3eb0ddcd$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$assertIsMounted(fiber) {
    if ($f69c825c3eb0ddcd$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(188));
}
function $f69c825c3eb0ddcd$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f69c825c3eb0ddcd$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f69c825c3eb0ddcd$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f69c825c3eb0ddcd$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f69c825c3eb0ddcd$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f69c825c3eb0ddcd$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f69c825c3eb0ddcd$var$assign = Object.assign, $f69c825c3eb0ddcd$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f69c825c3eb0ddcd$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f69c825c3eb0ddcd$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f69c825c3eb0ddcd$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f69c825c3eb0ddcd$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f69c825c3eb0ddcd$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f69c825c3eb0ddcd$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f69c825c3eb0ddcd$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f69c825c3eb0ddcd$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f69c825c3eb0ddcd$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f69c825c3eb0ddcd$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f69c825c3eb0ddcd$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f69c825c3eb0ddcd$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f69c825c3eb0ddcd$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f69c825c3eb0ddcd$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f69c825c3eb0ddcd$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f69c825c3eb0ddcd$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f69c825c3eb0ddcd$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f69c825c3eb0ddcd$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f69c825c3eb0ddcd$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f69c825c3eb0ddcd$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f69c825c3eb0ddcd$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f69c825c3eb0ddcd$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $f69c825c3eb0ddcd$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f69c825c3eb0ddcd$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f69c825c3eb0ddcd$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f69c825c3eb0ddcd$var$getComponentNameFromType(type.type) || "Memo";
        case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f69c825c3eb0ddcd$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f69c825c3eb0ddcd$var$isArrayImpl = Array.isArray, $f69c825c3eb0ddcd$var$ReactSharedInternals = $ieaan.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f69c825c3eb0ddcd$var$ReactDOMSharedInternals = $ie2rr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f69c825c3eb0ddcd$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f69c825c3eb0ddcd$var$valueStack = [], $f69c825c3eb0ddcd$var$index = -1;
function $f69c825c3eb0ddcd$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f69c825c3eb0ddcd$var$pop(cursor) {
    0 > $f69c825c3eb0ddcd$var$index || (cursor.current = $f69c825c3eb0ddcd$var$valueStack[$f69c825c3eb0ddcd$var$index], $f69c825c3eb0ddcd$var$valueStack[$f69c825c3eb0ddcd$var$index] = null, $f69c825c3eb0ddcd$var$index--);
}
function $f69c825c3eb0ddcd$var$push(cursor, value) {
    $f69c825c3eb0ddcd$var$index++;
    $f69c825c3eb0ddcd$var$valueStack[$f69c825c3eb0ddcd$var$index] = cursor.current;
    cursor.current = value;
}
var $f69c825c3eb0ddcd$var$contextStackCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$contextFiberStackCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$rootInstanceStackCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$hostTransitionProviderCursor = $f69c825c3eb0ddcd$var$createCursor(null);
function $f69c825c3eb0ddcd$var$pushHostContainer(fiber, nextRootInstance) {
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$rootInstanceStackCursor, nextRootInstance);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$contextFiberStackCursor, fiber);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f69c825c3eb0ddcd$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f69c825c3eb0ddcd$var$getOwnHostContext(nextRootInstance), fiber = $f69c825c3eb0ddcd$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$contextStackCursor);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$contextStackCursor, fiber);
}
function $f69c825c3eb0ddcd$var$popHostContainer() {
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$contextStackCursor);
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$contextFiberStackCursor);
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$rootInstanceStackCursor);
}
function $f69c825c3eb0ddcd$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$hostTransitionProviderCursor, fiber);
    var context = $f69c825c3eb0ddcd$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f69c825c3eb0ddcd$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$contextFiberStackCursor, fiber), $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$contextStackCursor, JSCompiler_inline_result));
}
function $f69c825c3eb0ddcd$var$popHostContext(fiber) {
    $f69c825c3eb0ddcd$var$contextFiberStackCursor.current === fiber && ($f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$contextStackCursor), $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$contextFiberStackCursor));
    $f69c825c3eb0ddcd$var$hostTransitionProviderCursor.current === fiber && ($f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$hostTransitionProviderCursor), $f69c825c3eb0ddcd$var$HostTransitionContext._currentValue = $f69c825c3eb0ddcd$var$sharedNotPendingObject);
}
var $f69c825c3eb0ddcd$var$prefix, $f69c825c3eb0ddcd$var$suffix;
function $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f69c825c3eb0ddcd$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f69c825c3eb0ddcd$var$prefix = match && match[1] || "";
        $f69c825c3eb0ddcd$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f69c825c3eb0ddcd$var$prefix + name + $f69c825c3eb0ddcd$var$suffix;
}
var $f69c825c3eb0ddcd$var$reentry = !1;
function $f69c825c3eb0ddcd$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f69c825c3eb0ddcd$var$reentry) return "";
    $f69c825c3eb0ddcd$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f69c825c3eb0ddcd$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f69c825c3eb0ddcd$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame("Suspense Fallback") : $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f69c825c3eb0ddcd$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f69c825c3eb0ddcd$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f69c825c3eb0ddcd$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f69c825c3eb0ddcd$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f69c825c3eb0ddcd$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $f69c825c3eb0ddcd$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $f69c825c3eb0ddcd$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f69c825c3eb0ddcd$var$scheduleCallback$3 = $3CIn6.unstable_scheduleCallback, $f69c825c3eb0ddcd$var$cancelCallback$1 = $3CIn6.unstable_cancelCallback, $f69c825c3eb0ddcd$var$shouldYield = $3CIn6.unstable_shouldYield, $f69c825c3eb0ddcd$var$requestPaint = $3CIn6.unstable_requestPaint, $f69c825c3eb0ddcd$var$now = $3CIn6.unstable_now, $f69c825c3eb0ddcd$var$getCurrentPriorityLevel = $3CIn6.unstable_getCurrentPriorityLevel, $f69c825c3eb0ddcd$var$ImmediatePriority = $3CIn6.unstable_ImmediatePriority, $f69c825c3eb0ddcd$var$UserBlockingPriority = $3CIn6.unstable_UserBlockingPriority, $f69c825c3eb0ddcd$var$NormalPriority$1 = $3CIn6.unstable_NormalPriority, $f69c825c3eb0ddcd$var$LowPriority = $3CIn6.unstable_LowPriority, $f69c825c3eb0ddcd$var$IdlePriority = $3CIn6.unstable_IdlePriority, $f69c825c3eb0ddcd$var$log$1 = $3CIn6.log, $f69c825c3eb0ddcd$var$unstable_setDisableYieldValue = $3CIn6.unstable_setDisableYieldValue, $f69c825c3eb0ddcd$var$rendererID = null, $f69c825c3eb0ddcd$var$injectedHook = null;
function $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f69c825c3eb0ddcd$var$log$1 && $f69c825c3eb0ddcd$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f69c825c3eb0ddcd$var$injectedHook && "function" === typeof $f69c825c3eb0ddcd$var$injectedHook.setStrictMode) try {
        $f69c825c3eb0ddcd$var$injectedHook.setStrictMode($f69c825c3eb0ddcd$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f69c825c3eb0ddcd$var$clz32 = Math.clz32 ? Math.clz32 : $f69c825c3eb0ddcd$var$clz32Fallback, $f69c825c3eb0ddcd$var$log = Math.log, $f69c825c3eb0ddcd$var$LN2 = Math.LN2;
function $f69c825c3eb0ddcd$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f69c825c3eb0ddcd$var$log(x) / $f69c825c3eb0ddcd$var$LN2 | 0) | 0;
}
var $f69c825c3eb0ddcd$var$nextTransitionUpdateLane = 256, $f69c825c3eb0ddcd$var$nextTransitionDeferredLane = 262144, $f69c825c3eb0ddcd$var$nextRetryLane = 4194304;
function $f69c825c3eb0ddcd$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f69c825c3eb0ddcd$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f69c825c3eb0ddcd$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f69c825c3eb0ddcd$var$claimNextRetryLane() {
    var lane = $f69c825c3eb0ddcd$var$nextRetryLane;
    $f69c825c3eb0ddcd$var$nextRetryLane <<= 1;
    0 === ($f69c825c3eb0ddcd$var$nextRetryLane & 62914560) && ($f69c825c3eb0ddcd$var$nextRetryLane = 4194304);
    return lane;
}
function $f69c825c3eb0ddcd$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f69c825c3eb0ddcd$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f69c825c3eb0ddcd$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $f69c825c3eb0ddcd$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f69c825c3eb0ddcd$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f69c825c3eb0ddcd$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f69c825c3eb0ddcd$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $f69c825c3eb0ddcd$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $f69c825c3eb0ddcd$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f69c825c3eb0ddcd$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $f69c825c3eb0ddcd$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $f69c825c3eb0ddcd$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f69c825c3eb0ddcd$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f69c825c3eb0ddcd$var$resolveUpdatePriority() {
    var updatePriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f69c825c3eb0ddcd$var$getEventPriority(updatePriority.type);
}
function $f69c825c3eb0ddcd$var$runWithPriority(priority, fn) {
    var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    try {
        return $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f69c825c3eb0ddcd$var$randomKey = Math.random().toString(36).slice(2), $f69c825c3eb0ddcd$var$internalInstanceKey = "__reactFiber$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalPropsKey = "__reactProps$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalContainerInstanceKey = "__reactContainer$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalEventHandlersKey = "__reactEvents$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalEventHandlerListenersKey = "__reactListeners$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalEventHandlesSetKey = "__reactHandles$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalRootNodeResourcesKey = "__reactResources$" + $f69c825c3eb0ddcd$var$randomKey, $f69c825c3eb0ddcd$var$internalHoistableMarker = "__reactMarker$" + $f69c825c3eb0ddcd$var$randomKey;
function $f69c825c3eb0ddcd$var$detachDeletedInstance(node) {
    delete node[$f69c825c3eb0ddcd$var$internalInstanceKey];
    delete node[$f69c825c3eb0ddcd$var$internalPropsKey];
    delete node[$f69c825c3eb0ddcd$var$internalEventHandlersKey];
    delete node[$f69c825c3eb0ddcd$var$internalEventHandlerListenersKey];
    delete node[$f69c825c3eb0ddcd$var$internalEventHandlesSetKey];
}
function $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f69c825c3eb0ddcd$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f69c825c3eb0ddcd$var$internalContainerInstanceKey] || parentNode[$f69c825c3eb0ddcd$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f69c825c3eb0ddcd$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f69c825c3eb0ddcd$var$internalInstanceKey]) return parentNode;
                targetNode = $f69c825c3eb0ddcd$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$getInstanceFromNode(node) {
    if (node = node[$f69c825c3eb0ddcd$var$internalInstanceKey] || node[$f69c825c3eb0ddcd$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(33));
}
function $f69c825c3eb0ddcd$var$getResourcesFromRoot(root) {
    var resources = root[$f69c825c3eb0ddcd$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f69c825c3eb0ddcd$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f69c825c3eb0ddcd$var$markNodeAsHoistable(node) {
    node[$f69c825c3eb0ddcd$var$internalHoistableMarker] = !0;
}
var $f69c825c3eb0ddcd$var$allNativeEvents = new Set(), $f69c825c3eb0ddcd$var$registrationNameDependencies = {};
function $f69c825c3eb0ddcd$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f69c825c3eb0ddcd$var$registerDirectEvent(registrationName, dependencies);
    $f69c825c3eb0ddcd$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f69c825c3eb0ddcd$var$registerDirectEvent(registrationName, dependencies) {
    $f69c825c3eb0ddcd$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f69c825c3eb0ddcd$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f69c825c3eb0ddcd$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f69c825c3eb0ddcd$var$illegalAttributeNameCache = {}, $f69c825c3eb0ddcd$var$validatedAttributeNameCache = {};
function $f69c825c3eb0ddcd$var$isAttributeNameSafe(attributeName) {
    if ($f69c825c3eb0ddcd$var$hasOwnProperty.call($f69c825c3eb0ddcd$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f69c825c3eb0ddcd$var$hasOwnProperty.call($f69c825c3eb0ddcd$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f69c825c3eb0ddcd$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f69c825c3eb0ddcd$var$validatedAttributeNameCache[attributeName] = !0;
    $f69c825c3eb0ddcd$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f69c825c3eb0ddcd$var$setValueForAttribute(node, name, value) {
    if ($f69c825c3eb0ddcd$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f69c825c3eb0ddcd$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $f69c825c3eb0ddcd$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f69c825c3eb0ddcd$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f69c825c3eb0ddcd$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f69c825c3eb0ddcd$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $f69c825c3eb0ddcd$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $f69c825c3eb0ddcd$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $f69c825c3eb0ddcd$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f69c825c3eb0ddcd$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f69c825c3eb0ddcd$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f69c825c3eb0ddcd$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f69c825c3eb0ddcd$var$getToStringValue(value);
        } else element.value !== "" + $f69c825c3eb0ddcd$var$getToStringValue(value) && (element.value = "" + $f69c825c3eb0ddcd$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f69c825c3eb0ddcd$var$setDefaultValue(element, type, $f69c825c3eb0ddcd$var$getToStringValue(value)) : null != defaultValue ? $f69c825c3eb0ddcd$var$setDefaultValue(element, type, $f69c825c3eb0ddcd$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f69c825c3eb0ddcd$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f69c825c3eb0ddcd$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $f69c825c3eb0ddcd$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $f69c825c3eb0ddcd$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f69c825c3eb0ddcd$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $f69c825c3eb0ddcd$var$track(element);
}
function $f69c825c3eb0ddcd$var$setDefaultValue(node, type, value) {
    "number" === type && $f69c825c3eb0ddcd$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f69c825c3eb0ddcd$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f69c825c3eb0ddcd$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f69c825c3eb0ddcd$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f69c825c3eb0ddcd$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f69c825c3eb0ddcd$var$getToStringValue(defaultValue) : "";
}
function $f69c825c3eb0ddcd$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(92));
            if ($f69c825c3eb0ddcd$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f69c825c3eb0ddcd$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $f69c825c3eb0ddcd$var$track(element);
}
function $f69c825c3eb0ddcd$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f69c825c3eb0ddcd$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f69c825c3eb0ddcd$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f69c825c3eb0ddcd$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f69c825c3eb0ddcd$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f69c825c3eb0ddcd$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f69c825c3eb0ddcd$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f69c825c3eb0ddcd$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f69c825c3eb0ddcd$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f69c825c3eb0ddcd$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f69c825c3eb0ddcd$var$sanitizeURL(url) {
    return $f69c825c3eb0ddcd$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $f69c825c3eb0ddcd$var$noop$1() {}
var $f69c825c3eb0ddcd$var$currentReplayingEvent = null;
function $f69c825c3eb0ddcd$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f69c825c3eb0ddcd$var$restoreTarget = null, $f69c825c3eb0ddcd$var$restoreQueue = null;
function $f69c825c3eb0ddcd$var$restoreStateOfTarget(target) {
    var internalInstance = $f69c825c3eb0ddcd$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f69c825c3eb0ddcd$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f69c825c3eb0ddcd$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f69c825c3eb0ddcd$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(90));
                            $f69c825c3eb0ddcd$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f69c825c3eb0ddcd$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f69c825c3eb0ddcd$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f69c825c3eb0ddcd$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f69c825c3eb0ddcd$var$isInsideEventHandler = !1;
function $f69c825c3eb0ddcd$var$batchedUpdates$1(fn, a, b) {
    if ($f69c825c3eb0ddcd$var$isInsideEventHandler) return fn(a, b);
    $f69c825c3eb0ddcd$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f69c825c3eb0ddcd$var$isInsideEventHandler = !1, null !== $f69c825c3eb0ddcd$var$restoreTarget || null !== $f69c825c3eb0ddcd$var$restoreQueue) {
            if ($f69c825c3eb0ddcd$var$flushSyncWork$1(), $f69c825c3eb0ddcd$var$restoreTarget && (a = $f69c825c3eb0ddcd$var$restoreTarget, fn = $f69c825c3eb0ddcd$var$restoreQueue, $f69c825c3eb0ddcd$var$restoreQueue = $f69c825c3eb0ddcd$var$restoreTarget = null, $f69c825c3eb0ddcd$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f69c825c3eb0ddcd$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f69c825c3eb0ddcd$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f69c825c3eb0ddcd$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f69c825c3eb0ddcd$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f69c825c3eb0ddcd$var$passiveBrowserEventsSupported = !1;
if ($f69c825c3eb0ddcd$var$canUseDOM) try {
    var $f69c825c3eb0ddcd$var$options = {};
    Object.defineProperty($f69c825c3eb0ddcd$var$options, "passive", {
        get: function() {
            $f69c825c3eb0ddcd$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f69c825c3eb0ddcd$var$options, $f69c825c3eb0ddcd$var$options);
    window.removeEventListener("test", $f69c825c3eb0ddcd$var$options, $f69c825c3eb0ddcd$var$options);
} catch (e) {
    $f69c825c3eb0ddcd$var$passiveBrowserEventsSupported = !1;
}
var $f69c825c3eb0ddcd$var$root = null, $f69c825c3eb0ddcd$var$startText = null, $f69c825c3eb0ddcd$var$fallbackText = null;
function $f69c825c3eb0ddcd$var$getData() {
    if ($f69c825c3eb0ddcd$var$fallbackText) return $f69c825c3eb0ddcd$var$fallbackText;
    var start, startValue = $f69c825c3eb0ddcd$var$startText, startLength = startValue.length, end, endValue = "value" in $f69c825c3eb0ddcd$var$root ? $f69c825c3eb0ddcd$var$root.value : $f69c825c3eb0ddcd$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f69c825c3eb0ddcd$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f69c825c3eb0ddcd$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f69c825c3eb0ddcd$var$functionThatReturnsTrue() {
    return !0;
}
function $f69c825c3eb0ddcd$var$functionThatReturnsFalse() {
    return !1;
}
function $f69c825c3eb0ddcd$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f69c825c3eb0ddcd$var$functionThatReturnsTrue : $f69c825c3eb0ddcd$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f69c825c3eb0ddcd$var$functionThatReturnsFalse;
        return this;
    }
    $f69c825c3eb0ddcd$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f69c825c3eb0ddcd$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f69c825c3eb0ddcd$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f69c825c3eb0ddcd$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f69c825c3eb0ddcd$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f69c825c3eb0ddcd$var$SyntheticEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$EventInterface), $f69c825c3eb0ddcd$var$UIEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    view: 0,
    detail: 0
}), $f69c825c3eb0ddcd$var$SyntheticUIEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$UIEventInterface), $f69c825c3eb0ddcd$var$lastMovementX, $f69c825c3eb0ddcd$var$lastMovementY, $f69c825c3eb0ddcd$var$lastMouseEvent, $f69c825c3eb0ddcd$var$MouseEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f69c825c3eb0ddcd$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f69c825c3eb0ddcd$var$lastMouseEvent && ($f69c825c3eb0ddcd$var$lastMouseEvent && "mousemove" === event.type ? ($f69c825c3eb0ddcd$var$lastMovementX = event.screenX - $f69c825c3eb0ddcd$var$lastMouseEvent.screenX, $f69c825c3eb0ddcd$var$lastMovementY = event.screenY - $f69c825c3eb0ddcd$var$lastMouseEvent.screenY) : $f69c825c3eb0ddcd$var$lastMovementY = $f69c825c3eb0ddcd$var$lastMovementX = 0, $f69c825c3eb0ddcd$var$lastMouseEvent = event);
        return $f69c825c3eb0ddcd$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f69c825c3eb0ddcd$var$lastMovementY;
    }
}), $f69c825c3eb0ddcd$var$SyntheticMouseEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$MouseEventInterface), $f69c825c3eb0ddcd$var$DragEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$MouseEventInterface, {
    dataTransfer: 0
}), $f69c825c3eb0ddcd$var$SyntheticDragEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$DragEventInterface), $f69c825c3eb0ddcd$var$FocusEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$UIEventInterface, {
    relatedTarget: 0
}), $f69c825c3eb0ddcd$var$SyntheticFocusEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$FocusEventInterface), $f69c825c3eb0ddcd$var$AnimationEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f69c825c3eb0ddcd$var$SyntheticAnimationEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$AnimationEventInterface), $f69c825c3eb0ddcd$var$ClipboardEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f69c825c3eb0ddcd$var$SyntheticClipboardEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$ClipboardEventInterface), $f69c825c3eb0ddcd$var$CompositionEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    data: 0
}), $f69c825c3eb0ddcd$var$SyntheticCompositionEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$CompositionEventInterface), $f69c825c3eb0ddcd$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f69c825c3eb0ddcd$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f69c825c3eb0ddcd$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f69c825c3eb0ddcd$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f69c825c3eb0ddcd$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f69c825c3eb0ddcd$var$getEventModifierState() {
    return $f69c825c3eb0ddcd$var$modifierStateGetter;
}
var $f69c825c3eb0ddcd$var$KeyboardEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f69c825c3eb0ddcd$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f69c825c3eb0ddcd$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f69c825c3eb0ddcd$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f69c825c3eb0ddcd$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f69c825c3eb0ddcd$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f69c825c3eb0ddcd$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f69c825c3eb0ddcd$var$SyntheticKeyboardEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$KeyboardEventInterface), $f69c825c3eb0ddcd$var$PointerEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f69c825c3eb0ddcd$var$SyntheticPointerEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$PointerEventInterface), $f69c825c3eb0ddcd$var$TouchEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f69c825c3eb0ddcd$var$getEventModifierState
}), $f69c825c3eb0ddcd$var$SyntheticTouchEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$TouchEventInterface), $f69c825c3eb0ddcd$var$TransitionEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f69c825c3eb0ddcd$var$SyntheticTransitionEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$TransitionEventInterface), $f69c825c3eb0ddcd$var$WheelEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f69c825c3eb0ddcd$var$SyntheticWheelEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$WheelEventInterface), $f69c825c3eb0ddcd$var$ToggleEventInterface = $f69c825c3eb0ddcd$var$assign({}, $f69c825c3eb0ddcd$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f69c825c3eb0ddcd$var$SyntheticToggleEvent = $f69c825c3eb0ddcd$var$createSyntheticEvent($f69c825c3eb0ddcd$var$ToggleEventInterface), $f69c825c3eb0ddcd$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f69c825c3eb0ddcd$var$canUseCompositionEvent = $f69c825c3eb0ddcd$var$canUseDOM && "CompositionEvent" in window, $f69c825c3eb0ddcd$var$documentMode = null;
$f69c825c3eb0ddcd$var$canUseDOM && "documentMode" in document && ($f69c825c3eb0ddcd$var$documentMode = document.documentMode);
var $f69c825c3eb0ddcd$var$canUseTextInputEvent = $f69c825c3eb0ddcd$var$canUseDOM && "TextEvent" in window && !$f69c825c3eb0ddcd$var$documentMode, $f69c825c3eb0ddcd$var$useFallbackCompositionData = $f69c825c3eb0ddcd$var$canUseDOM && (!$f69c825c3eb0ddcd$var$canUseCompositionEvent || $f69c825c3eb0ddcd$var$documentMode && 8 < $f69c825c3eb0ddcd$var$documentMode && 11 >= $f69c825c3eb0ddcd$var$documentMode), $f69c825c3eb0ddcd$var$SPACEBAR_CHAR = String.fromCharCode(32), $f69c825c3eb0ddcd$var$hasSpaceKeypress = !1;
function $f69c825c3eb0ddcd$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f69c825c3eb0ddcd$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f69c825c3eb0ddcd$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f69c825c3eb0ddcd$var$isComposing = !1;
function $f69c825c3eb0ddcd$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f69c825c3eb0ddcd$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f69c825c3eb0ddcd$var$hasSpaceKeypress = !0;
            return $f69c825c3eb0ddcd$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f69c825c3eb0ddcd$var$SPACEBAR_CHAR && $f69c825c3eb0ddcd$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f69c825c3eb0ddcd$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f69c825c3eb0ddcd$var$isComposing) return "compositionend" === domEventName || !$f69c825c3eb0ddcd$var$canUseCompositionEvent && $f69c825c3eb0ddcd$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f69c825c3eb0ddcd$var$getData(), $f69c825c3eb0ddcd$var$fallbackText = $f69c825c3eb0ddcd$var$startText = $f69c825c3eb0ddcd$var$root = null, $f69c825c3eb0ddcd$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f69c825c3eb0ddcd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f69c825c3eb0ddcd$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f69c825c3eb0ddcd$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f69c825c3eb0ddcd$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f69c825c3eb0ddcd$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f69c825c3eb0ddcd$var$restoreTarget ? $f69c825c3eb0ddcd$var$restoreQueue ? $f69c825c3eb0ddcd$var$restoreQueue.push(target) : $f69c825c3eb0ddcd$var$restoreQueue = [
        target
    ] : $f69c825c3eb0ddcd$var$restoreTarget = target;
    inst = $f69c825c3eb0ddcd$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f69c825c3eb0ddcd$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f69c825c3eb0ddcd$var$activeElement$1 = null, $f69c825c3eb0ddcd$var$activeElementInst$1 = null;
function $f69c825c3eb0ddcd$var$runEventInBatch(dispatchQueue) {
    $f69c825c3eb0ddcd$var$processDispatchQueue(dispatchQueue, 0);
}
function $f69c825c3eb0ddcd$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f69c825c3eb0ddcd$var$getNodeFromInstance(targetInst);
    if ($f69c825c3eb0ddcd$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f69c825c3eb0ddcd$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f69c825c3eb0ddcd$var$isInputEventSupported = !1;
if ($f69c825c3eb0ddcd$var$canUseDOM) {
    var $f69c825c3eb0ddcd$var$JSCompiler_inline_result$jscomp$286;
    if ($f69c825c3eb0ddcd$var$canUseDOM) {
        var $f69c825c3eb0ddcd$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$f69c825c3eb0ddcd$var$isSupported$jscomp$inline_427) {
            var $f69c825c3eb0ddcd$var$element$jscomp$inline_428 = document.createElement("div");
            $f69c825c3eb0ddcd$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $f69c825c3eb0ddcd$var$isSupported$jscomp$inline_427 = "function" === typeof $f69c825c3eb0ddcd$var$element$jscomp$inline_428.oninput;
        }
        $f69c825c3eb0ddcd$var$JSCompiler_inline_result$jscomp$286 = $f69c825c3eb0ddcd$var$isSupported$jscomp$inline_427;
    } else $f69c825c3eb0ddcd$var$JSCompiler_inline_result$jscomp$286 = !1;
    $f69c825c3eb0ddcd$var$isInputEventSupported = $f69c825c3eb0ddcd$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $f69c825c3eb0ddcd$var$stopWatchingForValueChange() {
    $f69c825c3eb0ddcd$var$activeElement$1 && ($f69c825c3eb0ddcd$var$activeElement$1.detachEvent("onpropertychange", $f69c825c3eb0ddcd$var$handlePropertyChange), $f69c825c3eb0ddcd$var$activeElementInst$1 = $f69c825c3eb0ddcd$var$activeElement$1 = null);
}
function $f69c825c3eb0ddcd$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f69c825c3eb0ddcd$var$getInstIfValueChanged($f69c825c3eb0ddcd$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f69c825c3eb0ddcd$var$createAndAccumulateChangeEvent(dispatchQueue, $f69c825c3eb0ddcd$var$activeElementInst$1, nativeEvent, $f69c825c3eb0ddcd$var$getEventTarget(nativeEvent));
        $f69c825c3eb0ddcd$var$batchedUpdates$1($f69c825c3eb0ddcd$var$runEventInBatch, dispatchQueue);
    }
}
function $f69c825c3eb0ddcd$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f69c825c3eb0ddcd$var$stopWatchingForValueChange(), $f69c825c3eb0ddcd$var$activeElement$1 = target, $f69c825c3eb0ddcd$var$activeElementInst$1 = targetInst, $f69c825c3eb0ddcd$var$activeElement$1.attachEvent("onpropertychange", $f69c825c3eb0ddcd$var$handlePropertyChange)) : "focusout" === domEventName && $f69c825c3eb0ddcd$var$stopWatchingForValueChange();
}
function $f69c825c3eb0ddcd$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f69c825c3eb0ddcd$var$getInstIfValueChanged($f69c825c3eb0ddcd$var$activeElementInst$1);
}
function $f69c825c3eb0ddcd$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f69c825c3eb0ddcd$var$getInstIfValueChanged(targetInst);
}
function $f69c825c3eb0ddcd$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f69c825c3eb0ddcd$var$getInstIfValueChanged(targetInst);
}
function $f69c825c3eb0ddcd$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f69c825c3eb0ddcd$var$objectIs = "function" === typeof Object.is ? Object.is : $f69c825c3eb0ddcd$var$is;
function $f69c825c3eb0ddcd$var$shallowEqual(objA, objB) {
    if ($f69c825c3eb0ddcd$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f69c825c3eb0ddcd$var$hasOwnProperty.call(objB, currentKey) || !$f69c825c3eb0ddcd$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f69c825c3eb0ddcd$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f69c825c3eb0ddcd$var$getNodeForCharacterOffset(root, offset) {
    var node = $f69c825c3eb0ddcd$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f69c825c3eb0ddcd$var$getLeafNode(node);
    }
}
function $f69c825c3eb0ddcd$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f69c825c3eb0ddcd$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f69c825c3eb0ddcd$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f69c825c3eb0ddcd$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f69c825c3eb0ddcd$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f69c825c3eb0ddcd$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f69c825c3eb0ddcd$var$skipSelectionChangeEvent = $f69c825c3eb0ddcd$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f69c825c3eb0ddcd$var$activeElement = null, $f69c825c3eb0ddcd$var$activeElementInst = null, $f69c825c3eb0ddcd$var$lastSelection = null, $f69c825c3eb0ddcd$var$mouseDown = !1;
function $f69c825c3eb0ddcd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f69c825c3eb0ddcd$var$mouseDown || null == $f69c825c3eb0ddcd$var$activeElement || $f69c825c3eb0ddcd$var$activeElement !== $f69c825c3eb0ddcd$var$getActiveElement(doc) || (doc = $f69c825c3eb0ddcd$var$activeElement, "selectionStart" in doc && $f69c825c3eb0ddcd$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f69c825c3eb0ddcd$var$lastSelection && $f69c825c3eb0ddcd$var$shallowEqual($f69c825c3eb0ddcd$var$lastSelection, doc) || ($f69c825c3eb0ddcd$var$lastSelection = doc, doc = $f69c825c3eb0ddcd$var$accumulateTwoPhaseListeners($f69c825c3eb0ddcd$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f69c825c3eb0ddcd$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f69c825c3eb0ddcd$var$activeElement)));
}
function $f69c825c3eb0ddcd$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f69c825c3eb0ddcd$var$vendorPrefixes = {
    animationend: $f69c825c3eb0ddcd$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f69c825c3eb0ddcd$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f69c825c3eb0ddcd$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f69c825c3eb0ddcd$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f69c825c3eb0ddcd$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f69c825c3eb0ddcd$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f69c825c3eb0ddcd$var$makePrefixMap("Transition", "TransitionEnd")
}, $f69c825c3eb0ddcd$var$prefixedEventNames = {}, $f69c825c3eb0ddcd$var$style = {};
$f69c825c3eb0ddcd$var$canUseDOM && ($f69c825c3eb0ddcd$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f69c825c3eb0ddcd$var$vendorPrefixes.animationend.animation, delete $f69c825c3eb0ddcd$var$vendorPrefixes.animationiteration.animation, delete $f69c825c3eb0ddcd$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f69c825c3eb0ddcd$var$vendorPrefixes.transitionend.transition);
function $f69c825c3eb0ddcd$var$getVendorPrefixedEventName(eventName) {
    if ($f69c825c3eb0ddcd$var$prefixedEventNames[eventName]) return $f69c825c3eb0ddcd$var$prefixedEventNames[eventName];
    if (!$f69c825c3eb0ddcd$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f69c825c3eb0ddcd$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f69c825c3eb0ddcd$var$style) return $f69c825c3eb0ddcd$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f69c825c3eb0ddcd$var$ANIMATION_END = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("animationend"), $f69c825c3eb0ddcd$var$ANIMATION_ITERATION = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("animationiteration"), $f69c825c3eb0ddcd$var$ANIMATION_START = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("animationstart"), $f69c825c3eb0ddcd$var$TRANSITION_RUN = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("transitionrun"), $f69c825c3eb0ddcd$var$TRANSITION_START = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("transitionstart"), $f69c825c3eb0ddcd$var$TRANSITION_CANCEL = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("transitioncancel"), $f69c825c3eb0ddcd$var$TRANSITION_END = $f69c825c3eb0ddcd$var$getVendorPrefixedEventName("transitionend"), $f69c825c3eb0ddcd$var$topLevelEventsToReactNames = new Map(), $f69c825c3eb0ddcd$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f69c825c3eb0ddcd$var$simpleEventPluginEvents.push("scrollEnd");
function $f69c825c3eb0ddcd$var$registerSimpleEvent(domEventName, reactName) {
    $f69c825c3eb0ddcd$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f69c825c3eb0ddcd$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f69c825c3eb0ddcd$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $f69c825c3eb0ddcd$var$concurrentQueues = [], $f69c825c3eb0ddcd$var$concurrentQueuesIndex = 0, $f69c825c3eb0ddcd$var$concurrentlyUpdatedLanes = 0;
function $f69c825c3eb0ddcd$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f69c825c3eb0ddcd$var$concurrentQueuesIndex, i = $f69c825c3eb0ddcd$var$concurrentlyUpdatedLanes = $f69c825c3eb0ddcd$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f69c825c3eb0ddcd$var$concurrentQueues[i];
        $f69c825c3eb0ddcd$var$concurrentQueues[i++] = null;
        var queue = $f69c825c3eb0ddcd$var$concurrentQueues[i];
        $f69c825c3eb0ddcd$var$concurrentQueues[i++] = null;
        var update = $f69c825c3eb0ddcd$var$concurrentQueues[i];
        $f69c825c3eb0ddcd$var$concurrentQueues[i++] = null;
        var lane = $f69c825c3eb0ddcd$var$concurrentQueues[i];
        $f69c825c3eb0ddcd$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f69c825c3eb0ddcd$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f69c825c3eb0ddcd$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f69c825c3eb0ddcd$var$concurrentQueues[$f69c825c3eb0ddcd$var$concurrentQueuesIndex++] = fiber;
    $f69c825c3eb0ddcd$var$concurrentQueues[$f69c825c3eb0ddcd$var$concurrentQueuesIndex++] = queue;
    $f69c825c3eb0ddcd$var$concurrentQueues[$f69c825c3eb0ddcd$var$concurrentQueuesIndex++] = update;
    $f69c825c3eb0ddcd$var$concurrentQueues[$f69c825c3eb0ddcd$var$concurrentQueuesIndex++] = lane;
    $f69c825c3eb0ddcd$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f69c825c3eb0ddcd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f69c825c3eb0ddcd$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f69c825c3eb0ddcd$var$getRootForUpdatedFiber(fiber);
}
function $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f69c825c3eb0ddcd$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f69c825c3eb0ddcd$var$getRootForUpdatedFiber(fiber);
}
function $f69c825c3eb0ddcd$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f69c825c3eb0ddcd$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f69c825c3eb0ddcd$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f69c825c3eb0ddcd$var$nestedUpdateCount) throw $f69c825c3eb0ddcd$var$nestedUpdateCount = 0, $f69c825c3eb0ddcd$var$rootWithNestedUpdates = null, Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f69c825c3eb0ddcd$var$emptyContextObject = {};
function $f69c825c3eb0ddcd$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f69c825c3eb0ddcd$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f69c825c3eb0ddcd$var$FiberNode(tag, pendingProps, key, mode);
}
function $f69c825c3eb0ddcd$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f69c825c3eb0ddcd$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f69c825c3eb0ddcd$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f69c825c3eb0ddcd$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f69c825c3eb0ddcd$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f69c825c3eb0ddcd$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f69c825c3eb0ddcd$var$isHostHoistableType(type, pendingProps, $f69c825c3eb0ddcd$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f69c825c3eb0ddcd$var$REACT_ACTIVITY_TYPE:
            return type = $f69c825c3eb0ddcd$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f69c825c3eb0ddcd$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE:
            return $f69c825c3eb0ddcd$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f69c825c3eb0ddcd$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f69c825c3eb0ddcd$var$REACT_PROFILER_TYPE:
            return type = $f69c825c3eb0ddcd$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f69c825c3eb0ddcd$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f69c825c3eb0ddcd$var$REACT_SUSPENSE_TYPE:
            return type = $f69c825c3eb0ddcd$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f69c825c3eb0ddcd$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f69c825c3eb0ddcd$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f69c825c3eb0ddcd$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f69c825c3eb0ddcd$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f69c825c3eb0ddcd$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f69c825c3eb0ddcd$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f69c825c3eb0ddcd$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f69c825c3eb0ddcd$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f69c825c3eb0ddcd$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f69c825c3eb0ddcd$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f69c825c3eb0ddcd$var$createFiberFromText(content, mode, lanes) {
    content = $f69c825c3eb0ddcd$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f69c825c3eb0ddcd$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $f69c825c3eb0ddcd$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $f69c825c3eb0ddcd$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f69c825c3eb0ddcd$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f69c825c3eb0ddcd$var$CapturedStacks = new WeakMap();
function $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f69c825c3eb0ddcd$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f69c825c3eb0ddcd$var$getStackByFiberInDevAndProd(source)
        };
        $f69c825c3eb0ddcd$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f69c825c3eb0ddcd$var$getStackByFiberInDevAndProd(source)
    };
}
var $f69c825c3eb0ddcd$var$forkStack = [], $f69c825c3eb0ddcd$var$forkStackIndex = 0, $f69c825c3eb0ddcd$var$treeForkProvider = null, $f69c825c3eb0ddcd$var$treeForkCount = 0, $f69c825c3eb0ddcd$var$idStack = [], $f69c825c3eb0ddcd$var$idStackIndex = 0, $f69c825c3eb0ddcd$var$treeContextProvider = null, $f69c825c3eb0ddcd$var$treeContextId = 1, $f69c825c3eb0ddcd$var$treeContextOverflow = "";
function $f69c825c3eb0ddcd$var$pushTreeFork(workInProgress, totalChildren) {
    $f69c825c3eb0ddcd$var$forkStack[$f69c825c3eb0ddcd$var$forkStackIndex++] = $f69c825c3eb0ddcd$var$treeForkCount;
    $f69c825c3eb0ddcd$var$forkStack[$f69c825c3eb0ddcd$var$forkStackIndex++] = $f69c825c3eb0ddcd$var$treeForkProvider;
    $f69c825c3eb0ddcd$var$treeForkProvider = workInProgress;
    $f69c825c3eb0ddcd$var$treeForkCount = totalChildren;
}
function $f69c825c3eb0ddcd$var$pushTreeId(workInProgress, totalChildren, index) {
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextId;
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextOverflow;
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextProvider;
    $f69c825c3eb0ddcd$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f69c825c3eb0ddcd$var$treeContextId;
    workInProgress = $f69c825c3eb0ddcd$var$treeContextOverflow;
    var baseLength = 32 - $f69c825c3eb0ddcd$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f69c825c3eb0ddcd$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f69c825c3eb0ddcd$var$treeContextId = 1 << 32 - $f69c825c3eb0ddcd$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f69c825c3eb0ddcd$var$treeContextOverflow = length + workInProgress;
    } else $f69c825c3eb0ddcd$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f69c825c3eb0ddcd$var$treeContextOverflow = workInProgress;
}
function $f69c825c3eb0ddcd$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f69c825c3eb0ddcd$var$pushTreeFork(workInProgress, 1), $f69c825c3eb0ddcd$var$pushTreeId(workInProgress, 1, 0));
}
function $f69c825c3eb0ddcd$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f69c825c3eb0ddcd$var$treeForkProvider;)$f69c825c3eb0ddcd$var$treeForkProvider = $f69c825c3eb0ddcd$var$forkStack[--$f69c825c3eb0ddcd$var$forkStackIndex], $f69c825c3eb0ddcd$var$forkStack[$f69c825c3eb0ddcd$var$forkStackIndex] = null, $f69c825c3eb0ddcd$var$treeForkCount = $f69c825c3eb0ddcd$var$forkStack[--$f69c825c3eb0ddcd$var$forkStackIndex], $f69c825c3eb0ddcd$var$forkStack[$f69c825c3eb0ddcd$var$forkStackIndex] = null;
    for(; workInProgress === $f69c825c3eb0ddcd$var$treeContextProvider;)$f69c825c3eb0ddcd$var$treeContextProvider = $f69c825c3eb0ddcd$var$idStack[--$f69c825c3eb0ddcd$var$idStackIndex], $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex] = null, $f69c825c3eb0ddcd$var$treeContextOverflow = $f69c825c3eb0ddcd$var$idStack[--$f69c825c3eb0ddcd$var$idStackIndex], $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex] = null, $f69c825c3eb0ddcd$var$treeContextId = $f69c825c3eb0ddcd$var$idStack[--$f69c825c3eb0ddcd$var$idStackIndex], $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex] = null;
}
function $f69c825c3eb0ddcd$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextId;
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextOverflow;
    $f69c825c3eb0ddcd$var$idStack[$f69c825c3eb0ddcd$var$idStackIndex++] = $f69c825c3eb0ddcd$var$treeContextProvider;
    $f69c825c3eb0ddcd$var$treeContextId = suspendedContext.id;
    $f69c825c3eb0ddcd$var$treeContextOverflow = suspendedContext.overflow;
    $f69c825c3eb0ddcd$var$treeContextProvider = workInProgress;
}
var $f69c825c3eb0ddcd$var$hydrationParentFiber = null, $f69c825c3eb0ddcd$var$nextHydratableInstance = null, $f69c825c3eb0ddcd$var$isHydrating = !1, $f69c825c3eb0ddcd$var$hydrationErrors = null, $f69c825c3eb0ddcd$var$rootOrSingletonContext = !1, $f69c825c3eb0ddcd$var$HydrationMismatchException = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(519));
function $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $f69c825c3eb0ddcd$var$queueHydrationError($f69c825c3eb0ddcd$var$createCapturedValueAtFiber(error, fiber));
    throw $f69c825c3eb0ddcd$var$HydrationMismatchException;
}
function $f69c825c3eb0ddcd$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f69c825c3eb0ddcd$var$internalInstanceKey] = fiber;
    instance[$f69c825c3eb0ddcd$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("cancel", instance);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f69c825c3eb0ddcd$var$mediaEventTypes.length; type++)$f69c825c3eb0ddcd$var$listenToNonDelegatedEvent($f69c825c3eb0ddcd$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("error", instance);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", instance);
            $f69c825c3eb0ddcd$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", instance), $f69c825c3eb0ddcd$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f69c825c3eb0ddcd$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("beforetoggle", instance), $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f69c825c3eb0ddcd$var$noop$1), instance = !0) : instance = !1;
    instance || $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(fiber, !0);
}
function $f69c825c3eb0ddcd$var$popToNextHostParent(fiber) {
    for($f69c825c3eb0ddcd$var$hydrationParentFiber = fiber.return; $f69c825c3eb0ddcd$var$hydrationParentFiber;)switch($f69c825c3eb0ddcd$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $f69c825c3eb0ddcd$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f69c825c3eb0ddcd$var$rootOrSingletonContext = !0;
            return;
        default:
            $f69c825c3eb0ddcd$var$hydrationParentFiber = $f69c825c3eb0ddcd$var$hydrationParentFiber.return;
    }
}
function $f69c825c3eb0ddcd$var$popHydrationState(fiber) {
    if (fiber !== $f69c825c3eb0ddcd$var$hydrationParentFiber) return !1;
    if (!$f69c825c3eb0ddcd$var$isHydrating) return $f69c825c3eb0ddcd$var$popToNextHostParent(fiber), $f69c825c3eb0ddcd$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f69c825c3eb0ddcd$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f69c825c3eb0ddcd$var$nextHydratableInstance && $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(fiber);
    $f69c825c3eb0ddcd$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(317));
        $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(317));
        $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $f69c825c3eb0ddcd$var$nextHydratableInstance, $f69c825c3eb0ddcd$var$isSingletonScope(fiber.type) ? (fiber = $f69c825c3eb0ddcd$var$previousHydratableOnEnteringScopedSingleton, $f69c825c3eb0ddcd$var$previousHydratableOnEnteringScopedSingleton = null, $f69c825c3eb0ddcd$var$nextHydratableInstance = fiber) : $f69c825c3eb0ddcd$var$nextHydratableInstance = tag) : $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$hydrationParentFiber ? $f69c825c3eb0ddcd$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f69c825c3eb0ddcd$var$resetHydrationState() {
    $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$hydrationParentFiber = null;
    $f69c825c3eb0ddcd$var$isHydrating = !1;
}
function $f69c825c3eb0ddcd$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f69c825c3eb0ddcd$var$hydrationErrors;
    null !== queuedErrors && (null === $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors ? $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = queuedErrors : $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors.push.apply($f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors, queuedErrors), $f69c825c3eb0ddcd$var$hydrationErrors = null);
    return queuedErrors;
}
function $f69c825c3eb0ddcd$var$queueHydrationError(error) {
    null === $f69c825c3eb0ddcd$var$hydrationErrors ? $f69c825c3eb0ddcd$var$hydrationErrors = [
        error
    ] : $f69c825c3eb0ddcd$var$hydrationErrors.push(error);
}
var $f69c825c3eb0ddcd$var$valueCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = null, $f69c825c3eb0ddcd$var$lastContextDependency = null;
function $f69c825c3eb0ddcd$var$pushProvider(providerFiber, context, nextValue) {
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f69c825c3eb0ddcd$var$popProvider(context) {
    context._currentValue = $f69c825c3eb0ddcd$var$valueCursor.current;
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$valueCursor);
}
function $f69c825c3eb0ddcd$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f69c825c3eb0ddcd$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f69c825c3eb0ddcd$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f69c825c3eb0ddcd$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f69c825c3eb0ddcd$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f69c825c3eb0ddcd$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f69c825c3eb0ddcd$var$HostTransitionContext) : current = [
                $f69c825c3eb0ddcd$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f69c825c3eb0ddcd$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f69c825c3eb0ddcd$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f69c825c3eb0ddcd$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress) {
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = workInProgress;
    $f69c825c3eb0ddcd$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f69c825c3eb0ddcd$var$readContext(context) {
    return $f69c825c3eb0ddcd$var$readContextForConsumer($f69c825c3eb0ddcd$var$currentlyRenderingFiber$1, context);
}
function $f69c825c3eb0ddcd$var$readContextDuringReconciliation(consumer, context) {
    null === $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 && $f69c825c3eb0ddcd$var$prepareToReadContext(consumer);
    return $f69c825c3eb0ddcd$var$readContextForConsumer(consumer, context);
}
function $f69c825c3eb0ddcd$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f69c825c3eb0ddcd$var$lastContextDependency) {
        if (null === consumer) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(308));
        $f69c825c3eb0ddcd$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f69c825c3eb0ddcd$var$lastContextDependency = $f69c825c3eb0ddcd$var$lastContextDependency.next = context;
    return value;
}
var $f69c825c3eb0ddcd$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f69c825c3eb0ddcd$var$scheduleCallback$2 = $3CIn6.unstable_scheduleCallback, $f69c825c3eb0ddcd$var$NormalPriority = $3CIn6.unstable_NormalPriority, $f69c825c3eb0ddcd$var$CacheContext = {
    $$typeof: $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f69c825c3eb0ddcd$var$createCache() {
    return {
        controller: new $f69c825c3eb0ddcd$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f69c825c3eb0ddcd$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f69c825c3eb0ddcd$var$scheduleCallback$2($f69c825c3eb0ddcd$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f69c825c3eb0ddcd$var$currentEntangledListeners = null, $f69c825c3eb0ddcd$var$currentEntangledPendingCount = 0, $f69c825c3eb0ddcd$var$currentEntangledLane = 0, $f69c825c3eb0ddcd$var$currentEntangledActionThenable = null;
function $f69c825c3eb0ddcd$var$entangleAsyncAction(transition, thenable) {
    if (null === $f69c825c3eb0ddcd$var$currentEntangledListeners) {
        var entangledListeners = $f69c825c3eb0ddcd$var$currentEntangledListeners = [];
        $f69c825c3eb0ddcd$var$currentEntangledPendingCount = 0;
        $f69c825c3eb0ddcd$var$currentEntangledLane = $f69c825c3eb0ddcd$var$requestTransitionLane();
        $f69c825c3eb0ddcd$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f69c825c3eb0ddcd$var$currentEntangledPendingCount++;
    thenable.then($f69c825c3eb0ddcd$var$pingEngtangledActionScope, $f69c825c3eb0ddcd$var$pingEngtangledActionScope);
    return thenable;
}
function $f69c825c3eb0ddcd$var$pingEngtangledActionScope() {
    if (0 === --$f69c825c3eb0ddcd$var$currentEntangledPendingCount && null !== $f69c825c3eb0ddcd$var$currentEntangledListeners) {
        null !== $f69c825c3eb0ddcd$var$currentEntangledActionThenable && ($f69c825c3eb0ddcd$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f69c825c3eb0ddcd$var$currentEntangledListeners;
        $f69c825c3eb0ddcd$var$currentEntangledListeners = null;
        $f69c825c3eb0ddcd$var$currentEntangledLane = 0;
        $f69c825c3eb0ddcd$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f69c825c3eb0ddcd$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f69c825c3eb0ddcd$var$prevOnStartTransitionFinish = $f69c825c3eb0ddcd$var$ReactSharedInternals.S;
$f69c825c3eb0ddcd$var$ReactSharedInternals.S = function(transition, returnValue) {
    $f69c825c3eb0ddcd$var$globalMostRecentTransitionTime = $f69c825c3eb0ddcd$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f69c825c3eb0ddcd$var$entangleAsyncAction(transition, returnValue);
    null !== $f69c825c3eb0ddcd$var$prevOnStartTransitionFinish && $f69c825c3eb0ddcd$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f69c825c3eb0ddcd$var$resumedCache = $f69c825c3eb0ddcd$var$createCursor(null);
function $f69c825c3eb0ddcd$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f69c825c3eb0ddcd$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f69c825c3eb0ddcd$var$workInProgressRoot.pooledCache;
}
function $f69c825c3eb0ddcd$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$resumedCache, $f69c825c3eb0ddcd$var$resumedCache.current) : $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$resumedCache, prevCachePool.pool);
}
function $f69c825c3eb0ddcd$var$getSuspendedCache() {
    var cacheFromPool = $f69c825c3eb0ddcd$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f69c825c3eb0ddcd$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f69c825c3eb0ddcd$var$SuspenseException = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(460)), $f69c825c3eb0ddcd$var$SuspenseyCommitException = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(474)), $f69c825c3eb0ddcd$var$SuspenseActionException = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(542)), $f69c825c3eb0ddcd$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f69c825c3eb0ddcd$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f69c825c3eb0ddcd$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f69c825c3eb0ddcd$var$noop$1, $f69c825c3eb0ddcd$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f69c825c3eb0ddcd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f69c825c3eb0ddcd$var$noop$1, $f69c825c3eb0ddcd$var$noop$1);
            else {
                thenableState = $f69c825c3eb0ddcd$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f69c825c3eb0ddcd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f69c825c3eb0ddcd$var$suspendedThenable = thenable;
            throw $f69c825c3eb0ddcd$var$SuspenseException;
    }
}
function $f69c825c3eb0ddcd$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $f69c825c3eb0ddcd$var$suspendedThenable = x, $f69c825c3eb0ddcd$var$SuspenseException;
        throw x;
    }
}
var $f69c825c3eb0ddcd$var$suspendedThenable = null;
function $f69c825c3eb0ddcd$var$getSuspendedThenable() {
    if (null === $f69c825c3eb0ddcd$var$suspendedThenable) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(459));
    var thenable = $f69c825c3eb0ddcd$var$suspendedThenable;
    $f69c825c3eb0ddcd$var$suspendedThenable = null;
    return thenable;
}
function $f69c825c3eb0ddcd$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f69c825c3eb0ddcd$var$SuspenseException || rejectedReason === $f69c825c3eb0ddcd$var$SuspenseActionException) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(483));
}
var $f69c825c3eb0ddcd$var$thenableState$1 = null, $f69c825c3eb0ddcd$var$thenableIndexCounter$1 = 0;
function $f69c825c3eb0ddcd$var$unwrapThenable(thenable) {
    var index = $f69c825c3eb0ddcd$var$thenableIndexCounter$1;
    $f69c825c3eb0ddcd$var$thenableIndexCounter$1 += 1;
    null === $f69c825c3eb0ddcd$var$thenableState$1 && ($f69c825c3eb0ddcd$var$thenableState$1 = []);
    return $f69c825c3eb0ddcd$var$trackUsedThenable($f69c825c3eb0ddcd$var$thenableState$1, thenable, index);
}
function $f69c825c3eb0ddcd$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f69c825c3eb0ddcd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $f69c825c3eb0ddcd$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f69c825c3eb0ddcd$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f69c825c3eb0ddcd$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f69c825c3eb0ddcd$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE && $f69c825c3eb0ddcd$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f69c825c3eb0ddcd$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f69c825c3eb0ddcd$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f69c825c3eb0ddcd$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f69c825c3eb0ddcd$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f69c825c3eb0ddcd$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f69c825c3eb0ddcd$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f69c825c3eb0ddcd$var$REACT_ELEMENT_TYPE:
                    return lanes = $f69c825c3eb0ddcd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f69c825c3eb0ddcd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE:
                    return newChild = $f69c825c3eb0ddcd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
                    return newChild = $f69c825c3eb0ddcd$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($f69c825c3eb0ddcd$var$isArrayImpl(newChild) || $f69c825c3eb0ddcd$var$getIteratorFn(newChild)) return newChild = $f69c825c3eb0ddcd$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f69c825c3eb0ddcd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f69c825c3eb0ddcd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f69c825c3eb0ddcd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f69c825c3eb0ddcd$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
                    return newChild = $f69c825c3eb0ddcd$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f69c825c3eb0ddcd$var$isArrayImpl(newChild) || $f69c825c3eb0ddcd$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f69c825c3eb0ddcd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f69c825c3eb0ddcd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f69c825c3eb0ddcd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f69c825c3eb0ddcd$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
                    return newChild = $f69c825c3eb0ddcd$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f69c825c3eb0ddcd$var$isArrayImpl(newChild) || $f69c825c3eb0ddcd$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f69c825c3eb0ddcd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f69c825c3eb0ddcd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f69c825c3eb0ddcd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f69c825c3eb0ddcd$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE && $f69c825c3eb0ddcd$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f69c825c3eb0ddcd$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f69c825c3eb0ddcd$var$REACT_FRAGMENT_TYPE ? (lanes = $f69c825c3eb0ddcd$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f69c825c3eb0ddcd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f69c825c3eb0ddcd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f69c825c3eb0ddcd$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f69c825c3eb0ddcd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f69c825c3eb0ddcd$var$REACT_LAZY_TYPE:
                    return newChild = $f69c825c3eb0ddcd$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f69c825c3eb0ddcd$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f69c825c3eb0ddcd$var$getIteratorFn(newChild)) {
                key = $f69c825c3eb0ddcd$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f69c825c3eb0ddcd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f69c825c3eb0ddcd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f69c825c3eb0ddcd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f69c825c3eb0ddcd$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f69c825c3eb0ddcd$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f69c825c3eb0ddcd$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f69c825c3eb0ddcd$var$SuspenseException || x === $f69c825c3eb0ddcd$var$SuspenseActionException) throw x;
            var fiber = $f69c825c3eb0ddcd$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f69c825c3eb0ddcd$var$reconcileChildFibers = $f69c825c3eb0ddcd$var$createChildReconciler(!0), $f69c825c3eb0ddcd$var$mountChildFibers = $f69c825c3eb0ddcd$var$createChildReconciler(!1), $f69c825c3eb0ddcd$var$hasForceUpdate = !1;
function $f69c825c3eb0ddcd$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f69c825c3eb0ddcd$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f69c825c3eb0ddcd$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f69c825c3eb0ddcd$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f69c825c3eb0ddcd$var$getRootForUpdatedFiber(fiber);
        $f69c825c3eb0ddcd$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f69c825c3eb0ddcd$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f69c825c3eb0ddcd$var$getRootForUpdatedFiber(fiber);
}
function $f69c825c3eb0ddcd$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f69c825c3eb0ddcd$var$markRootEntangled(root, lane);
    }
}
function $f69c825c3eb0ddcd$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f69c825c3eb0ddcd$var$didReadFromEntangledAsyncAction = !1;
function $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f69c825c3eb0ddcd$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f69c825c3eb0ddcd$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f69c825c3eb0ddcd$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f69c825c3eb0ddcd$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f69c825c3eb0ddcd$var$currentEntangledLane && ($f69c825c3eb0ddcd$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f69c825c3eb0ddcd$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f69c825c3eb0ddcd$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f69c825c3eb0ddcd$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f69c825c3eb0ddcd$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f69c825c3eb0ddcd$var$callCallback(callbacks[updateQueue], context);
}
var $f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$prevEntangledRenderLanesCursor = $f69c825c3eb0ddcd$var$createCursor(0);
function $f69c825c3eb0ddcd$var$pushHiddenContext(fiber, context) {
    fiber = $f69c825c3eb0ddcd$var$entangledRenderLanes;
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$prevEntangledRenderLanesCursor, fiber);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor, context);
    $f69c825c3eb0ddcd$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f69c825c3eb0ddcd$var$reuseHiddenContextOnStack() {
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$prevEntangledRenderLanesCursor, $f69c825c3eb0ddcd$var$entangledRenderLanes);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor, $f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor.current);
}
function $f69c825c3eb0ddcd$var$popHiddenContext() {
    $f69c825c3eb0ddcd$var$entangledRenderLanes = $f69c825c3eb0ddcd$var$prevEntangledRenderLanesCursor.current;
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor);
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$prevEntangledRenderLanesCursor);
}
var $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor = $f69c825c3eb0ddcd$var$createCursor(null), $f69c825c3eb0ddcd$var$shellBoundary = null;
function $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current & 1);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseHandlerStackCursor, handler);
    null === $f69c825c3eb0ddcd$var$shellBoundary && (null === current || null !== $f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor.current ? $f69c825c3eb0ddcd$var$shellBoundary = handler : null !== current.memoizedState && ($f69c825c3eb0ddcd$var$shellBoundary = handler));
}
function $f69c825c3eb0ddcd$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseHandlerStackCursor, fiber);
    null === $f69c825c3eb0ddcd$var$shellBoundary && ($f69c825c3eb0ddcd$var$shellBoundary = fiber);
}
function $f69c825c3eb0ddcd$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current), $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseHandlerStackCursor, fiber), null === $f69c825c3eb0ddcd$var$shellBoundary && ($f69c825c3eb0ddcd$var$shellBoundary = fiber)) : $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack() {
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current);
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseHandlerStackCursor, $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current);
}
function $f69c825c3eb0ddcd$var$popSuspenseHandler(fiber) {
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$suspenseHandlerStackCursor);
    $f69c825c3eb0ddcd$var$shellBoundary === fiber && ($f69c825c3eb0ddcd$var$shellBoundary = null);
    $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$suspenseStackCursor);
}
var $f69c825c3eb0ddcd$var$suspenseStackCursor = $f69c825c3eb0ddcd$var$createCursor(0);
function $f69c825c3eb0ddcd$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $f69c825c3eb0ddcd$var$isSuspenseInstancePending(state) || $f69c825c3eb0ddcd$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $f69c825c3eb0ddcd$var$renderLanes = 0, $f69c825c3eb0ddcd$var$currentlyRenderingFiber = null, $f69c825c3eb0ddcd$var$currentHook = null, $f69c825c3eb0ddcd$var$workInProgressHook = null, $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdate = !1, $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f69c825c3eb0ddcd$var$localIdCounter = 0, $f69c825c3eb0ddcd$var$thenableIndexCounter = 0, $f69c825c3eb0ddcd$var$thenableState = null, $f69c825c3eb0ddcd$var$globalClientIdCounter = 0;
function $f69c825c3eb0ddcd$var$throwInvalidHookError() {
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(321));
}
function $f69c825c3eb0ddcd$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f69c825c3eb0ddcd$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f69c825c3eb0ddcd$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f69c825c3eb0ddcd$var$renderLanes = nextRenderLanes;
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f69c825c3eb0ddcd$var$HooksDispatcherOnMount : $f69c825c3eb0ddcd$var$HooksDispatcherOnUpdate;
    $f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f69c825c3eb0ddcd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f69c825c3eb0ddcd$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f69c825c3eb0ddcd$var$finishRenderingHooks(current) {
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = $f69c825c3eb0ddcd$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f69c825c3eb0ddcd$var$currentHook && null !== $f69c825c3eb0ddcd$var$currentHook.next;
    $f69c825c3eb0ddcd$var$renderLanes = 0;
    $f69c825c3eb0ddcd$var$workInProgressHook = $f69c825c3eb0ddcd$var$currentHook = $f69c825c3eb0ddcd$var$currentlyRenderingFiber = null;
    $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdate = !1;
    $f69c825c3eb0ddcd$var$thenableIndexCounter = 0;
    $f69c825c3eb0ddcd$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(300));
    null === current || $f69c825c3eb0ddcd$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f69c825c3eb0ddcd$var$checkIfContextChanged(current) && ($f69c825c3eb0ddcd$var$didReceiveUpdate = !0));
}
function $f69c825c3eb0ddcd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f69c825c3eb0ddcd$var$thenableState = null);
        $f69c825c3eb0ddcd$var$thenableIndexCounter = 0;
        $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f69c825c3eb0ddcd$var$workInProgressHook = $f69c825c3eb0ddcd$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f69c825c3eb0ddcd$var$ReactSharedInternals.H = $f69c825c3eb0ddcd$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f69c825c3eb0ddcd$var$TransitionAwareHostComponent() {
    var dispatcher = $f69c825c3eb0ddcd$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f69c825c3eb0ddcd$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f69c825c3eb0ddcd$var$currentHook ? $f69c825c3eb0ddcd$var$currentHook.memoizedState : null) !== dispatcher && ($f69c825c3eb0ddcd$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f69c825c3eb0ddcd$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f69c825c3eb0ddcd$var$localIdCounter;
    $f69c825c3eb0ddcd$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f69c825c3eb0ddcd$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f69c825c3eb0ddcd$var$resetHooksOnUnwind(workInProgress) {
    if ($f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f69c825c3eb0ddcd$var$renderLanes = 0;
    $f69c825c3eb0ddcd$var$workInProgressHook = $f69c825c3eb0ddcd$var$currentHook = $f69c825c3eb0ddcd$var$currentlyRenderingFiber = null;
    $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f69c825c3eb0ddcd$var$thenableIndexCounter = $f69c825c3eb0ddcd$var$localIdCounter = 0;
    $f69c825c3eb0ddcd$var$thenableState = null;
}
function $f69c825c3eb0ddcd$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f69c825c3eb0ddcd$var$workInProgressHook ? $f69c825c3eb0ddcd$var$currentlyRenderingFiber.memoizedState = $f69c825c3eb0ddcd$var$workInProgressHook = hook : $f69c825c3eb0ddcd$var$workInProgressHook = $f69c825c3eb0ddcd$var$workInProgressHook.next = hook;
    return $f69c825c3eb0ddcd$var$workInProgressHook;
}
function $f69c825c3eb0ddcd$var$updateWorkInProgressHook() {
    if (null === $f69c825c3eb0ddcd$var$currentHook) {
        var nextCurrentHook = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f69c825c3eb0ddcd$var$currentHook.next;
    var nextWorkInProgressHook = null === $f69c825c3eb0ddcd$var$workInProgressHook ? $f69c825c3eb0ddcd$var$currentlyRenderingFiber.memoizedState : $f69c825c3eb0ddcd$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f69c825c3eb0ddcd$var$workInProgressHook = nextWorkInProgressHook, $f69c825c3eb0ddcd$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f69c825c3eb0ddcd$var$currentlyRenderingFiber.alternate) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(467));
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(310));
        }
        $f69c825c3eb0ddcd$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f69c825c3eb0ddcd$var$currentHook.memoizedState,
            baseState: $f69c825c3eb0ddcd$var$currentHook.baseState,
            baseQueue: $f69c825c3eb0ddcd$var$currentHook.baseQueue,
            queue: $f69c825c3eb0ddcd$var$currentHook.queue,
            next: null
        };
        null === $f69c825c3eb0ddcd$var$workInProgressHook ? $f69c825c3eb0ddcd$var$currentlyRenderingFiber.memoizedState = $f69c825c3eb0ddcd$var$workInProgressHook = nextCurrentHook : $f69c825c3eb0ddcd$var$workInProgressHook = $f69c825c3eb0ddcd$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f69c825c3eb0ddcd$var$workInProgressHook;
}
function $f69c825c3eb0ddcd$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f69c825c3eb0ddcd$var$useThenable(thenable) {
    var index = $f69c825c3eb0ddcd$var$thenableIndexCounter;
    $f69c825c3eb0ddcd$var$thenableIndexCounter += 1;
    null === $f69c825c3eb0ddcd$var$thenableState && ($f69c825c3eb0ddcd$var$thenableState = []);
    thenable = $f69c825c3eb0ddcd$var$trackUsedThenable($f69c825c3eb0ddcd$var$thenableState, thenable, index);
    index = $f69c825c3eb0ddcd$var$currentlyRenderingFiber;
    null === (null === $f69c825c3eb0ddcd$var$workInProgressHook ? index.memoizedState : $f69c825c3eb0ddcd$var$workInProgressHook.next) && (index = index.alternate, $f69c825c3eb0ddcd$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f69c825c3eb0ddcd$var$HooksDispatcherOnMount : $f69c825c3eb0ddcd$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f69c825c3eb0ddcd$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f69c825c3eb0ddcd$var$useThenable(usable);
        if (usable.$$typeof === $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE) return $f69c825c3eb0ddcd$var$readContext(usable);
    }
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(438, String(usable)));
}
function $f69c825c3eb0ddcd$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f69c825c3eb0ddcd$var$createFunctionComponentUpdateQueue(), $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f69c825c3eb0ddcd$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f69c825c3eb0ddcd$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f69c825c3eb0ddcd$var$updateReducer(reducer) {
    var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    return $f69c825c3eb0ddcd$var$updateReducerImpl(hook, $f69c825c3eb0ddcd$var$currentHook, reducer);
}
function $f69c825c3eb0ddcd$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f69c825c3eb0ddcd$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f69c825c3eb0ddcd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($f69c825c3eb0ddcd$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f69c825c3eb0ddcd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f69c825c3eb0ddcd$var$currentlyRenderingFiber.lanes |= revertLane, $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f69c825c3eb0ddcd$var$currentlyRenderingFiber.lanes |= updateLane, $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f69c825c3eb0ddcd$var$objectIs(pendingQueue, hook.memoizedState) && ($f69c825c3eb0ddcd$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $f69c825c3eb0ddcd$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f69c825c3eb0ddcd$var$rerenderReducer(reducer) {
    var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f69c825c3eb0ddcd$var$objectIs(newState, hook.memoizedState) || ($f69c825c3eb0ddcd$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f69c825c3eb0ddcd$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f69c825c3eb0ddcd$var$currentlyRenderingFiber, hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f69c825c3eb0ddcd$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f69c825c3eb0ddcd$var$objectIs(($f69c825c3eb0ddcd$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f69c825c3eb0ddcd$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $f69c825c3eb0ddcd$var$updateEffect($f69c825c3eb0ddcd$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f69c825c3eb0ddcd$var$workInProgressHook && $f69c825c3eb0ddcd$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f69c825c3eb0ddcd$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f69c825c3eb0ddcd$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f69c825c3eb0ddcd$var$workInProgressRoot) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f69c825c3eb0ddcd$var$renderLanes & 127) || $f69c825c3eb0ddcd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f69c825c3eb0ddcd$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f69c825c3eb0ddcd$var$createFunctionComponentUpdateQueue(), $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f69c825c3eb0ddcd$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f69c825c3eb0ddcd$var$checkIfSnapshotChanged(inst) && $f69c825c3eb0ddcd$var$forceStoreRerender(fiber);
}
function $f69c825c3eb0ddcd$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f69c825c3eb0ddcd$var$checkIfSnapshotChanged(inst) && $f69c825c3eb0ddcd$var$forceStoreRerender(fiber);
    });
}
function $f69c825c3eb0ddcd$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f69c825c3eb0ddcd$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f69c825c3eb0ddcd$var$forceStoreRerender(fiber) {
    var root = $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f69c825c3eb0ddcd$var$mountStateImpl(initialState) {
    var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f69c825c3eb0ddcd$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f69c825c3eb0ddcd$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f69c825c3eb0ddcd$var$updateReducerImpl(hook, $f69c825c3eb0ddcd$var$currentHook, "function" === typeof reducer ? reducer : $f69c825c3eb0ddcd$var$basicStateReducer);
}
function $f69c825c3eb0ddcd$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f69c825c3eb0ddcd$var$isRenderPhaseUpdate(fiber)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f69c825c3eb0ddcd$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f69c825c3eb0ddcd$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f69c825c3eb0ddcd$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f69c825c3eb0ddcd$var$ReactSharedInternals.T, currentTransition = {};
        $f69c825c3eb0ddcd$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f69c825c3eb0ddcd$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f69c825c3eb0ddcd$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f69c825c3eb0ddcd$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f69c825c3eb0ddcd$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f69c825c3eb0ddcd$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $f69c825c3eb0ddcd$var$onActionError(actionQueue, node, error$66);
    }
}
function $f69c825c3eb0ddcd$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f69c825c3eb0ddcd$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f69c825c3eb0ddcd$var$onActionError(actionQueue, node, error);
    }) : $f69c825c3eb0ddcd$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f69c825c3eb0ddcd$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f69c825c3eb0ddcd$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f69c825c3eb0ddcd$var$runActionStateAction(actionQueue, nextState)));
}
function $f69c825c3eb0ddcd$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f69c825c3eb0ddcd$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f69c825c3eb0ddcd$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f69c825c3eb0ddcd$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f69c825c3eb0ddcd$var$mountActionState(action, initialStateProp) {
    if ($f69c825c3eb0ddcd$var$isHydrating) {
        var ssrFormState = $f69c825c3eb0ddcd$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f69c825c3eb0ddcd$var$currentlyRenderingFiber;
                if ($f69c825c3eb0ddcd$var$isHydrating) {
                    if ($f69c825c3eb0ddcd$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f69c825c3eb0ddcd$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f69c825c3eb0ddcd$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f69c825c3eb0ddcd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f69c825c3eb0ddcd$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f69c825c3eb0ddcd$var$dispatchSetState.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f69c825c3eb0ddcd$var$mountStateImpl(!1);
    inRootOrSingleton = $f69c825c3eb0ddcd$var$dispatchOptimisticSetState.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f69c825c3eb0ddcd$var$dispatchActionState.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f69c825c3eb0ddcd$var$updateActionState(action) {
    var stateHook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    return $f69c825c3eb0ddcd$var$updateActionStateImpl(stateHook, $f69c825c3eb0ddcd$var$currentHook, action);
}
function $f69c825c3eb0ddcd$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f69c825c3eb0ddcd$var$updateReducerImpl(stateHook, currentStateHook, $f69c825c3eb0ddcd$var$actionStateReducer)[0];
    stateHook = $f69c825c3eb0ddcd$var$updateReducer($f69c825c3eb0ddcd$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f69c825c3eb0ddcd$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f69c825c3eb0ddcd$var$SuspenseException) throw $f69c825c3eb0ddcd$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f69c825c3eb0ddcd$var$currentlyRenderingFiber.flags |= 2048, $f69c825c3eb0ddcd$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $f69c825c3eb0ddcd$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f69c825c3eb0ddcd$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f69c825c3eb0ddcd$var$rerenderActionState(action) {
    var stateHook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook(), currentStateHook = $f69c825c3eb0ddcd$var$currentHook;
    if (null !== currentStateHook) return $f69c825c3eb0ddcd$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f69c825c3eb0ddcd$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f69c825c3eb0ddcd$var$createFunctionComponentUpdateQueue(), $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $f69c825c3eb0ddcd$var$updateRef() {
    return $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
}
function $f69c825c3eb0ddcd$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f69c825c3eb0ddcd$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $f69c825c3eb0ddcd$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f69c825c3eb0ddcd$var$currentHook && null !== deps && $f69c825c3eb0ddcd$var$areHookInputsEqual(deps, $f69c825c3eb0ddcd$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f69c825c3eb0ddcd$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f69c825c3eb0ddcd$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f69c825c3eb0ddcd$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f69c825c3eb0ddcd$var$mountEffect(create, deps) {
    $f69c825c3eb0ddcd$var$mountEffectImpl(8390656, 8, create, deps);
}
function $f69c825c3eb0ddcd$var$updateEffect(create, deps) {
    $f69c825c3eb0ddcd$var$updateEffectImpl(2048, 8, create, deps);
}
function $f69c825c3eb0ddcd$var$useEffectEventImpl(payload) {
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $f69c825c3eb0ddcd$var$createFunctionComponentUpdateQueue(), $f69c825c3eb0ddcd$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $f69c825c3eb0ddcd$var$updateEvent(callback) {
    var ref = $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
    $f69c825c3eb0ddcd$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 2)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $f69c825c3eb0ddcd$var$updateInsertionEffect(create, deps) {
    return $f69c825c3eb0ddcd$var$updateEffectImpl(4, 2, create, deps);
}
function $f69c825c3eb0ddcd$var$updateLayoutEffect(create, deps) {
    return $f69c825c3eb0ddcd$var$updateEffectImpl(4, 4, create, deps);
}
function $f69c825c3eb0ddcd$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f69c825c3eb0ddcd$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f69c825c3eb0ddcd$var$updateEffectImpl(4, 4, $f69c825c3eb0ddcd$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f69c825c3eb0ddcd$var$mountDebugValue() {}
function $f69c825c3eb0ddcd$var$updateCallback(callback, deps) {
    var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f69c825c3eb0ddcd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f69c825c3eb0ddcd$var$updateMemo(nextCreate, deps) {
    var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f69c825c3eb0ddcd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f69c825c3eb0ddcd$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f69c825c3eb0ddcd$var$renderLanes & 1073741824) && 0 === ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f69c825c3eb0ddcd$var$requestDeferredLane();
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber.lanes |= hook;
    $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f69c825c3eb0ddcd$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f69c825c3eb0ddcd$var$objectIs(value, prevValue)) return value;
    if (null !== $f69c825c3eb0ddcd$var$currentTreeHiddenStackCursor.current) return hook = $f69c825c3eb0ddcd$var$mountDeferredValueImpl(hook, value, initialValue), $f69c825c3eb0ddcd$var$objectIs(hook, prevValue) || ($f69c825c3eb0ddcd$var$didReceiveUpdate = !0), hook;
    if (0 === ($f69c825c3eb0ddcd$var$renderLanes & 42) || 0 !== ($f69c825c3eb0ddcd$var$renderLanes & 1073741824) && 0 === ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 261930)) return $f69c825c3eb0ddcd$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f69c825c3eb0ddcd$var$requestDeferredLane();
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber.lanes |= hook;
    $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f69c825c3eb0ddcd$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f69c825c3eb0ddcd$var$ReactSharedInternals.T, currentTransition = {};
    $f69c825c3eb0ddcd$var$ReactSharedInternals.T = currentTransition;
    $f69c825c3eb0ddcd$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f69c825c3eb0ddcd$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f69c825c3eb0ddcd$var$chainThenableValue(returnValue, finishedState);
            $f69c825c3eb0ddcd$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f69c825c3eb0ddcd$var$requestUpdateLane(fiber));
        } else $f69c825c3eb0ddcd$var$dispatchSetStateInternal(fiber, queue, finishedState, $f69c825c3eb0ddcd$var$requestUpdateLane(fiber));
    } catch (error) {
        $f69c825c3eb0ddcd$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f69c825c3eb0ddcd$var$requestUpdateLane());
    } finally{
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f69c825c3eb0ddcd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f69c825c3eb0ddcd$var$noop() {}
function $f69c825c3eb0ddcd$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(476));
    var queue = $f69c825c3eb0ddcd$var$ensureFormComponentIsStateful(formFiber).queue;
    $f69c825c3eb0ddcd$var$startTransition(formFiber, queue, pendingState, $f69c825c3eb0ddcd$var$sharedNotPendingObject, null === action ? $f69c825c3eb0ddcd$var$noop : function() {
        $f69c825c3eb0ddcd$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f69c825c3eb0ddcd$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f69c825c3eb0ddcd$var$sharedNotPendingObject,
        baseState: $f69c825c3eb0ddcd$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f69c825c3eb0ddcd$var$basicStateReducer,
            lastRenderedState: $f69c825c3eb0ddcd$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f69c825c3eb0ddcd$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f69c825c3eb0ddcd$var$requestFormReset$1(formFiber) {
    var stateHook = $f69c825c3eb0ddcd$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $f69c825c3eb0ddcd$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $f69c825c3eb0ddcd$var$requestUpdateLane());
}
function $f69c825c3eb0ddcd$var$useHostTransitionStatus() {
    return $f69c825c3eb0ddcd$var$readContext($f69c825c3eb0ddcd$var$HostTransitionContext);
}
function $f69c825c3eb0ddcd$var$updateId() {
    return $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
}
function $f69c825c3eb0ddcd$var$updateRefresh() {
    return $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
}
function $f69c825c3eb0ddcd$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f69c825c3eb0ddcd$var$requestUpdateLane();
                fiber = $f69c825c3eb0ddcd$var$createUpdate(lane);
                var root$69 = $f69c825c3eb0ddcd$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root$69, provider, lane), $f69c825c3eb0ddcd$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $f69c825c3eb0ddcd$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f69c825c3eb0ddcd$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f69c825c3eb0ddcd$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f69c825c3eb0ddcd$var$isRenderPhaseUpdate(fiber) ? $f69c825c3eb0ddcd$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f69c825c3eb0ddcd$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(action, fiber, lane), $f69c825c3eb0ddcd$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f69c825c3eb0ddcd$var$dispatchSetState(fiber, queue, action) {
    var lane = $f69c825c3eb0ddcd$var$requestUpdateLane();
    $f69c825c3eb0ddcd$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f69c825c3eb0ddcd$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f69c825c3eb0ddcd$var$isRenderPhaseUpdate(fiber)) $f69c825c3eb0ddcd$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f69c825c3eb0ddcd$var$objectIs(eagerState, currentState)) return $f69c825c3eb0ddcd$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f69c825c3eb0ddcd$var$workInProgressRoot && $f69c825c3eb0ddcd$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f69c825c3eb0ddcd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(action, fiber, lane), $f69c825c3eb0ddcd$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f69c825c3eb0ddcd$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f69c825c3eb0ddcd$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f69c825c3eb0ddcd$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f69c825c3eb0ddcd$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f69c825c3eb0ddcd$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f69c825c3eb0ddcd$var$currentlyRenderingFiber || null !== alternate && alternate === $f69c825c3eb0ddcd$var$currentlyRenderingFiber;
}
function $f69c825c3eb0ddcd$var$enqueueRenderPhaseUpdate(queue, update) {
    $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdateDuringThisPass = $f69c825c3eb0ddcd$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f69c825c3eb0ddcd$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f69c825c3eb0ddcd$var$markRootEntangled(root, lane);
    }
}
var $f69c825c3eb0ddcd$var$ContextOnlyDispatcher = {
    readContext: $f69c825c3eb0ddcd$var$readContext,
    use: $f69c825c3eb0ddcd$var$use,
    useCallback: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useContext: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useEffect: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useImperativeHandle: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useLayoutEffect: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useInsertionEffect: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useMemo: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useReducer: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useRef: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useState: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useDebugValue: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useDeferredValue: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useTransition: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useSyncExternalStore: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useId: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useHostTransitionStatus: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useFormState: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useActionState: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useOptimistic: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useMemoCache: $f69c825c3eb0ddcd$var$throwInvalidHookError,
    useCacheRefresh: $f69c825c3eb0ddcd$var$throwInvalidHookError
};
$f69c825c3eb0ddcd$var$ContextOnlyDispatcher.useEffectEvent = $f69c825c3eb0ddcd$var$throwInvalidHookError;
var $f69c825c3eb0ddcd$var$HooksDispatcherOnMount = {
    readContext: $f69c825c3eb0ddcd$var$readContext,
    use: $f69c825c3eb0ddcd$var$use,
    useCallback: function(callback, deps) {
        $f69c825c3eb0ddcd$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f69c825c3eb0ddcd$var$readContext,
    useEffect: $f69c825c3eb0ddcd$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f69c825c3eb0ddcd$var$mountEffectImpl(4194308, 4, $f69c825c3eb0ddcd$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f69c825c3eb0ddcd$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f69c825c3eb0ddcd$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f69c825c3eb0ddcd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f69c825c3eb0ddcd$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f69c825c3eb0ddcd$var$dispatchReducerAction.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f69c825c3eb0ddcd$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f69c825c3eb0ddcd$var$dispatchSetState.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f69c825c3eb0ddcd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        return $f69c825c3eb0ddcd$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f69c825c3eb0ddcd$var$mountStateImpl(!1);
        stateHook = $f69c825c3eb0ddcd$var$startTransition.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f69c825c3eb0ddcd$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f69c825c3eb0ddcd$var$currentlyRenderingFiber, hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        if ($f69c825c3eb0ddcd$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f69c825c3eb0ddcd$var$workInProgressRoot) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(349));
            0 !== ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 127) || $f69c825c3eb0ddcd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f69c825c3eb0ddcd$var$mountEffect($f69c825c3eb0ddcd$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f69c825c3eb0ddcd$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f69c825c3eb0ddcd$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook(), identifierPrefix = $f69c825c3eb0ddcd$var$workInProgressRoot.identifierPrefix;
        if ($f69c825c3eb0ddcd$var$isHydrating) {
            var JSCompiler_inline_result = $f69c825c3eb0ddcd$var$treeContextOverflow;
            var idWithLeadingBit = $f69c825c3eb0ddcd$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f69c825c3eb0ddcd$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f69c825c3eb0ddcd$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $f69c825c3eb0ddcd$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f69c825c3eb0ddcd$var$useHostTransitionStatus,
    useFormState: $f69c825c3eb0ddcd$var$mountActionState,
    useActionState: $f69c825c3eb0ddcd$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f69c825c3eb0ddcd$var$dispatchOptimisticSetState.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f69c825c3eb0ddcd$var$useMemoCache,
    useCacheRefresh: function() {
        return $f69c825c3eb0ddcd$var$mountWorkInProgressHook().memoizedState = $f69c825c3eb0ddcd$var$refreshCache.bind(null, $f69c825c3eb0ddcd$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $f69c825c3eb0ddcd$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 2)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $f69c825c3eb0ddcd$var$HooksDispatcherOnUpdate = {
    readContext: $f69c825c3eb0ddcd$var$readContext,
    use: $f69c825c3eb0ddcd$var$use,
    useCallback: $f69c825c3eb0ddcd$var$updateCallback,
    useContext: $f69c825c3eb0ddcd$var$readContext,
    useEffect: $f69c825c3eb0ddcd$var$updateEffect,
    useImperativeHandle: $f69c825c3eb0ddcd$var$updateImperativeHandle,
    useInsertionEffect: $f69c825c3eb0ddcd$var$updateInsertionEffect,
    useLayoutEffect: $f69c825c3eb0ddcd$var$updateLayoutEffect,
    useMemo: $f69c825c3eb0ddcd$var$updateMemo,
    useReducer: $f69c825c3eb0ddcd$var$updateReducer,
    useRef: $f69c825c3eb0ddcd$var$updateRef,
    useState: function() {
        return $f69c825c3eb0ddcd$var$updateReducer($f69c825c3eb0ddcd$var$basicStateReducer);
    },
    useDebugValue: $f69c825c3eb0ddcd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
        return $f69c825c3eb0ddcd$var$updateDeferredValueImpl(hook, $f69c825c3eb0ddcd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f69c825c3eb0ddcd$var$updateReducer($f69c825c3eb0ddcd$var$basicStateReducer)[0], start = $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f69c825c3eb0ddcd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f69c825c3eb0ddcd$var$updateSyncExternalStore,
    useId: $f69c825c3eb0ddcd$var$updateId,
    useHostTransitionStatus: $f69c825c3eb0ddcd$var$useHostTransitionStatus,
    useFormState: $f69c825c3eb0ddcd$var$updateActionState,
    useActionState: $f69c825c3eb0ddcd$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
        return $f69c825c3eb0ddcd$var$updateOptimisticImpl(hook, $f69c825c3eb0ddcd$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f69c825c3eb0ddcd$var$useMemoCache,
    useCacheRefresh: $f69c825c3eb0ddcd$var$updateRefresh
};
$f69c825c3eb0ddcd$var$HooksDispatcherOnUpdate.useEffectEvent = $f69c825c3eb0ddcd$var$updateEvent;
var $f69c825c3eb0ddcd$var$HooksDispatcherOnRerender = {
    readContext: $f69c825c3eb0ddcd$var$readContext,
    use: $f69c825c3eb0ddcd$var$use,
    useCallback: $f69c825c3eb0ddcd$var$updateCallback,
    useContext: $f69c825c3eb0ddcd$var$readContext,
    useEffect: $f69c825c3eb0ddcd$var$updateEffect,
    useImperativeHandle: $f69c825c3eb0ddcd$var$updateImperativeHandle,
    useInsertionEffect: $f69c825c3eb0ddcd$var$updateInsertionEffect,
    useLayoutEffect: $f69c825c3eb0ddcd$var$updateLayoutEffect,
    useMemo: $f69c825c3eb0ddcd$var$updateMemo,
    useReducer: $f69c825c3eb0ddcd$var$rerenderReducer,
    useRef: $f69c825c3eb0ddcd$var$updateRef,
    useState: function() {
        return $f69c825c3eb0ddcd$var$rerenderReducer($f69c825c3eb0ddcd$var$basicStateReducer);
    },
    useDebugValue: $f69c825c3eb0ddcd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
        return null === $f69c825c3eb0ddcd$var$currentHook ? $f69c825c3eb0ddcd$var$mountDeferredValueImpl(hook, value, initialValue) : $f69c825c3eb0ddcd$var$updateDeferredValueImpl(hook, $f69c825c3eb0ddcd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f69c825c3eb0ddcd$var$rerenderReducer($f69c825c3eb0ddcd$var$basicStateReducer)[0], start = $f69c825c3eb0ddcd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f69c825c3eb0ddcd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f69c825c3eb0ddcd$var$updateSyncExternalStore,
    useId: $f69c825c3eb0ddcd$var$updateId,
    useHostTransitionStatus: $f69c825c3eb0ddcd$var$useHostTransitionStatus,
    useFormState: $f69c825c3eb0ddcd$var$rerenderActionState,
    useActionState: $f69c825c3eb0ddcd$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f69c825c3eb0ddcd$var$updateWorkInProgressHook();
        if (null !== $f69c825c3eb0ddcd$var$currentHook) return $f69c825c3eb0ddcd$var$updateOptimisticImpl(hook, $f69c825c3eb0ddcd$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f69c825c3eb0ddcd$var$useMemoCache,
    useCacheRefresh: $f69c825c3eb0ddcd$var$updateRefresh
};
$f69c825c3eb0ddcd$var$HooksDispatcherOnRerender.useEffectEvent = $f69c825c3eb0ddcd$var$updateEvent;
function $f69c825c3eb0ddcd$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f69c825c3eb0ddcd$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f69c825c3eb0ddcd$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f69c825c3eb0ddcd$var$requestUpdateLane(), update = $f69c825c3eb0ddcd$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f69c825c3eb0ddcd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(payload, inst, lane), $f69c825c3eb0ddcd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f69c825c3eb0ddcd$var$requestUpdateLane(), update = $f69c825c3eb0ddcd$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f69c825c3eb0ddcd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(payload, inst, lane), $f69c825c3eb0ddcd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f69c825c3eb0ddcd$var$requestUpdateLane(), update = $f69c825c3eb0ddcd$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f69c825c3eb0ddcd$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(callback, inst, lane), $f69c825c3eb0ddcd$var$entangleTransitions(callback, inst, lane));
    }
};
function $f69c825c3eb0ddcd$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f69c825c3eb0ddcd$var$shallowEqual(oldProps, newProps) || !$f69c825c3eb0ddcd$var$shallowEqual(oldState, newState) : !0;
}
function $f69c825c3eb0ddcd$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f69c825c3eb0ddcd$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f69c825c3eb0ddcd$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f69c825c3eb0ddcd$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $f69c825c3eb0ddcd$var$defaultOnUncaughtError(error) {
    $f69c825c3eb0ddcd$var$reportGlobalError(error);
}
function $f69c825c3eb0ddcd$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f69c825c3eb0ddcd$var$defaultOnRecoverableError(error) {
    $f69c825c3eb0ddcd$var$reportGlobalError(error);
}
function $f69c825c3eb0ddcd$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f69c825c3eb0ddcd$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f69c825c3eb0ddcd$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f69c825c3eb0ddcd$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f69c825c3eb0ddcd$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f69c825c3eb0ddcd$var$createClassErrorUpdate(lane) {
    lane = $f69c825c3eb0ddcd$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f69c825c3eb0ddcd$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f69c825c3eb0ddcd$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f69c825c3eb0ddcd$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed ? $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f69c825c3eb0ddcd$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f69c825c3eb0ddcd$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $f69c825c3eb0ddcd$var$shellBoundary ? $f69c825c3eb0ddcd$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && ($f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f69c825c3eb0ddcd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f69c825c3eb0ddcd$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f69c825c3eb0ddcd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f69c825c3eb0ddcd$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f69c825c3eb0ddcd$var$attachPingListener(root, value, rootRenderLanes);
        $f69c825c3eb0ddcd$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f69c825c3eb0ddcd$var$isHydrating) return returnFiber = $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f69c825c3eb0ddcd$var$HydrationMismatchException && (root = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(422), {
        cause: value
    }), $f69c825c3eb0ddcd$var$queueHydrationError($f69c825c3eb0ddcd$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f69c825c3eb0ddcd$var$HydrationMismatchException && (returnFiber = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(423), {
        cause: value
    }), $f69c825c3eb0ddcd$var$queueHydrationError($f69c825c3eb0ddcd$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f69c825c3eb0ddcd$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f69c825c3eb0ddcd$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && ($f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors ? $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && ($f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f69c825c3eb0ddcd$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f69c825c3eb0ddcd$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed || !$f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f69c825c3eb0ddcd$var$createClassErrorUpdate(rootRenderLanes), $f69c825c3eb0ddcd$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f69c825c3eb0ddcd$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f69c825c3eb0ddcd$var$SelectiveHydrationException = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(461)), $f69c825c3eb0ddcd$var$didReceiveUpdate = !1;
function $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f69c825c3eb0ddcd$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f69c825c3eb0ddcd$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress);
    nextProps = $f69c825c3eb0ddcd$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f69c825c3eb0ddcd$var$checkDidRenderIdHook();
    if (null !== current && !$f69c825c3eb0ddcd$var$didReceiveUpdate) return $f69c825c3eb0ddcd$var$bailoutHooks(current, workInProgress, renderLanes), $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f69c825c3eb0ddcd$var$isHydrating && key && $f69c825c3eb0ddcd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f69c825c3eb0ddcd$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f69c825c3eb0ddcd$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f69c825c3eb0ddcd$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f69c825c3eb0ddcd$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f69c825c3eb0ddcd$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f69c825c3eb0ddcd$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f69c825c3eb0ddcd$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f69c825c3eb0ddcd$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f69c825c3eb0ddcd$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f69c825c3eb0ddcd$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f69c825c3eb0ddcd$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f69c825c3eb0ddcd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f69c825c3eb0ddcd$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $f69c825c3eb0ddcd$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f69c825c3eb0ddcd$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f69c825c3eb0ddcd$var$pushHiddenContext(workInProgress, prevState) : $f69c825c3eb0ddcd$var$reuseHiddenContextOnStack(), $f69c825c3eb0ddcd$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $f69c825c3eb0ddcd$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($f69c825c3eb0ddcd$var$pushTransition(workInProgress, prevState.cachePool), $f69c825c3eb0ddcd$var$pushHiddenContext(workInProgress, prevState), $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f69c825c3eb0ddcd$var$pushTransition(workInProgress, null), $f69c825c3eb0ddcd$var$reuseHiddenContextOnStack(), $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $f69c825c3eb0ddcd$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $f69c825c3eb0ddcd$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f69c825c3eb0ddcd$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f69c825c3eb0ddcd$var$pushTransition(workInProgress, null);
    $f69c825c3eb0ddcd$var$reuseHiddenContextOnStack();
    $f69c825c3eb0ddcd$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $f69c825c3eb0ddcd$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $f69c825c3eb0ddcd$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $f69c825c3eb0ddcd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f69c825c3eb0ddcd$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $f69c825c3eb0ddcd$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($f69c825c3eb0ddcd$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $f69c825c3eb0ddcd$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(null, current);
            $f69c825c3eb0ddcd$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $f69c825c3eb0ddcd$var$nextHydratableInstance) ? (current = $f69c825c3eb0ddcd$var$canHydrateHydrationBoundary(current, $f69c825c3eb0ddcd$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f69c825c3eb0ddcd$var$treeContextProvider ? {
                    id: $f69c825c3eb0ddcd$var$treeContextId,
                    overflow: $f69c825c3eb0ddcd$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f69c825c3eb0ddcd$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $f69c825c3eb0ddcd$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $f69c825c3eb0ddcd$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $f69c825c3eb0ddcd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(558));
        } else if ($f69c825c3eb0ddcd$var$didReceiveUpdate || $f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $f69c825c3eb0ddcd$var$didReceiveUpdate || didSuspend) {
            nextProps = $f69c825c3eb0ddcd$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $f69c825c3eb0ddcd$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(current, dehydrated), $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $f69c825c3eb0ddcd$var$SelectiveHydrationException;
            $f69c825c3eb0ddcd$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f69c825c3eb0ddcd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(dehydrated.nextSibling), $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$isHydrating = !0, $f69c825c3eb0ddcd$var$hydrationErrors = null, $f69c825c3eb0ddcd$var$rootOrSingletonContext = !1, null !== current && $f69c825c3eb0ddcd$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f69c825c3eb0ddcd$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $f69c825c3eb0ddcd$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $f69c825c3eb0ddcd$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f69c825c3eb0ddcd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress);
    Component = $f69c825c3eb0ddcd$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f69c825c3eb0ddcd$var$checkDidRenderIdHook();
    if (null !== current && !$f69c825c3eb0ddcd$var$didReceiveUpdate) return $f69c825c3eb0ddcd$var$bailoutHooks(current, workInProgress, renderLanes), $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f69c825c3eb0ddcd$var$isHydrating && nextProps && $f69c825c3eb0ddcd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f69c825c3eb0ddcd$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f69c825c3eb0ddcd$var$finishRenderingHooks(current);
    Component = $f69c825c3eb0ddcd$var$checkDidRenderIdHook();
    if (null !== current && !$f69c825c3eb0ddcd$var$didReceiveUpdate) return $f69c825c3eb0ddcd$var$bailoutHooks(current, workInProgress, renderLanes), $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f69c825c3eb0ddcd$var$isHydrating && Component && $f69c825c3eb0ddcd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f69c825c3eb0ddcd$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f69c825c3eb0ddcd$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f69c825c3eb0ddcd$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f69c825c3eb0ddcd$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f69c825c3eb0ddcd$var$readContext(contextType) : $f69c825c3eb0ddcd$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f69c825c3eb0ddcd$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f69c825c3eb0ddcd$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f69c825c3eb0ddcd$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f69c825c3eb0ddcd$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f69c825c3eb0ddcd$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f69c825c3eb0ddcd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f69c825c3eb0ddcd$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f69c825c3eb0ddcd$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f69c825c3eb0ddcd$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f69c825c3eb0ddcd$var$hasForceUpdate || $f69c825c3eb0ddcd$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f69c825c3eb0ddcd$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f69c825c3eb0ddcd$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f69c825c3eb0ddcd$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f69c825c3eb0ddcd$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f69c825c3eb0ddcd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f69c825c3eb0ddcd$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f69c825c3eb0ddcd$var$hasForceUpdate || null !== current && null !== current.dependencies && $f69c825c3eb0ddcd$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f69c825c3eb0ddcd$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f69c825c3eb0ddcd$var$hasForceUpdate || $f69c825c3eb0ddcd$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f69c825c3eb0ddcd$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f69c825c3eb0ddcd$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f69c825c3eb0ddcd$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f69c825c3eb0ddcd$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f69c825c3eb0ddcd$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f69c825c3eb0ddcd$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f69c825c3eb0ddcd$var$getSuspendedCache()
    };
}
function $f69c825c3eb0ddcd$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f69c825c3eb0ddcd$var$workInProgressDeferredLane);
    return current;
}
function $f69c825c3eb0ddcd$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f69c825c3eb0ddcd$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f69c825c3eb0ddcd$var$isHydrating) {
            showFallback ? $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $f69c825c3eb0ddcd$var$nextHydratableInstance) ? (current = $f69c825c3eb0ddcd$var$canHydrateHydrationBoundary(current, $f69c825c3eb0ddcd$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f69c825c3eb0ddcd$var$treeContextProvider ? {
                    id: $f69c825c3eb0ddcd$var$treeContextId,
                    overflow: $f69c825c3eb0ddcd$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f69c825c3eb0ddcd$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(workInProgress);
            $f69c825c3eb0ddcd$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $f69c825c3eb0ddcd$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $f69c825c3eb0ddcd$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $f69c825c3eb0ddcd$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f69c825c3eb0ddcd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f69c825c3eb0ddcd$var$SUSPENDED_MARKER, $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(null, nextProps);
        $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f69c825c3eb0ddcd$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f69c825c3eb0ddcd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $f69c825c3eb0ddcd$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $f69c825c3eb0ddcd$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f69c825c3eb0ddcd$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f69c825c3eb0ddcd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f69c825c3eb0ddcd$var$SUSPENDED_MARKER, workInProgress = $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(null, nextProps));
        else if ($f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f69c825c3eb0ddcd$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f69c825c3eb0ddcd$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f69c825c3eb0ddcd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f69c825c3eb0ddcd$var$didReceiveUpdate || $f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f69c825c3eb0ddcd$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f69c825c3eb0ddcd$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $f69c825c3eb0ddcd$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(current, nextProps), $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f69c825c3eb0ddcd$var$SelectiveHydrationException;
            $f69c825c3eb0ddcd$var$isSuspenseInstancePending(nextPrimaryChildren) || $f69c825c3eb0ddcd$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f69c825c3eb0ddcd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $f69c825c3eb0ddcd$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(nextPrimaryChildren.nextSibling), $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$isHydrating = !0, $f69c825c3eb0ddcd$var$hydrationErrors = null, $f69c825c3eb0ddcd$var$rootOrSingletonContext = !1, null !== current && $f69c825c3eb0ddcd$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f69c825c3eb0ddcd$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f69c825c3eb0ddcd$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $f69c825c3eb0ddcd$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $f69c825c3eb0ddcd$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $f69c825c3eb0ddcd$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $f69c825c3eb0ddcd$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $f69c825c3eb0ddcd$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $f69c825c3eb0ddcd$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $f69c825c3eb0ddcd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f69c825c3eb0ddcd$var$SUSPENDED_MARKER, $f69c825c3eb0ddcd$var$bailoutOffscreenComponent(current.child, nextProps);
    $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f69c825c3eb0ddcd$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f69c825c3eb0ddcd$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f69c825c3eb0ddcd$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f69c825c3eb0ddcd$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f69c825c3eb0ddcd$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $f69c825c3eb0ddcd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f69c825c3eb0ddcd$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f69c825c3eb0ddcd$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f69c825c3eb0ddcd$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f69c825c3eb0ddcd$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $f69c825c3eb0ddcd$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $f69c825c3eb0ddcd$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, suspenseContext);
    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $f69c825c3eb0ddcd$var$isHydrating ? $f69c825c3eb0ddcd$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $f69c825c3eb0ddcd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $f69c825c3eb0ddcd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f69c825c3eb0ddcd$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f69c825c3eb0ddcd$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f69c825c3eb0ddcd$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f69c825c3eb0ddcd$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $f69c825c3eb0ddcd$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f69c825c3eb0ddcd$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f69c825c3eb0ddcd$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f69c825c3eb0ddcd$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f69c825c3eb0ddcd$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f69c825c3eb0ddcd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f69c825c3eb0ddcd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, current.memoizedState.cache);
            $f69c825c3eb0ddcd$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f69c825c3eb0ddcd$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f69c825c3eb0ddcd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f69c825c3eb0ddcd$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $f69c825c3eb0ddcd$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f69c825c3eb0ddcd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f69c825c3eb0ddcd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($f69c825c3eb0ddcd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $f69c825c3eb0ddcd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $f69c825c3eb0ddcd$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, current.memoizedState.cache);
    }
    return $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f69c825c3eb0ddcd$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f69c825c3eb0ddcd$var$didReceiveUpdate = !0;
        else {
            if (!$f69c825c3eb0ddcd$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f69c825c3eb0ddcd$var$didReceiveUpdate = !1, $f69c825c3eb0ddcd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f69c825c3eb0ddcd$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f69c825c3eb0ddcd$var$didReceiveUpdate = !1, $f69c825c3eb0ddcd$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f69c825c3eb0ddcd$var$pushTreeId(workInProgress, $f69c825c3eb0ddcd$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $f69c825c3eb0ddcd$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $f69c825c3eb0ddcd$var$shouldConstruct(current) ? (props = $f69c825c3eb0ddcd$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $f69c825c3eb0ddcd$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f69c825c3eb0ddcd$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $f69c825c3eb0ddcd$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f69c825c3eb0ddcd$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $f69c825c3eb0ddcd$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f69c825c3eb0ddcd$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f69c825c3eb0ddcd$var$getComponentNameFromType(current) || current;
                    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f69c825c3eb0ddcd$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $f69c825c3eb0ddcd$var$resolveClassComponentProps(props, workInProgress.pendingProps), $f69c825c3eb0ddcd$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $f69c825c3eb0ddcd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $f69c825c3eb0ddcd$var$cloneUpdateQueue(current, workInProgress);
                $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, props);
                props !== prevState.cache && $f69c825c3eb0ddcd$var$propagateContextChanges(workInProgress, [
                    $f69c825c3eb0ddcd$var$CacheContext
                ], renderLanes, !0);
                $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f69c825c3eb0ddcd$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(424)), workInProgress);
                        $f69c825c3eb0ddcd$var$queueHydrationError($$typeof);
                        workInProgress = $f69c825c3eb0ddcd$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(current.firstChild);
                        $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress;
                        $f69c825c3eb0ddcd$var$isHydrating = !0;
                        $f69c825c3eb0ddcd$var$hydrationErrors = null;
                        $f69c825c3eb0ddcd$var$rootOrSingletonContext = !0;
                        renderLanes = $f69c825c3eb0ddcd$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f69c825c3eb0ddcd$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $f69c825c3eb0ddcd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f69c825c3eb0ddcd$var$markRef(current, workInProgress), null === current ? (renderLanes = $f69c825c3eb0ddcd$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f69c825c3eb0ddcd$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $f69c825c3eb0ddcd$var$getOwnerDocumentFromRootContainer($f69c825c3eb0ddcd$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress, props[$f69c825c3eb0ddcd$var$internalPropsKey] = current, $f69c825c3eb0ddcd$var$setInitialProperties(props, renderLanes, current), $f69c825c3eb0ddcd$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $f69c825c3eb0ddcd$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f69c825c3eb0ddcd$var$pushHostContext(workInProgress), null === current && $f69c825c3eb0ddcd$var$isHydrating && (props = workInProgress.stateNode = $f69c825c3eb0ddcd$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f69c825c3eb0ddcd$var$rootInstanceStackCursor.current), $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$rootOrSingletonContext = !0, $$typeof = $f69c825c3eb0ddcd$var$nextHydratableInstance, $f69c825c3eb0ddcd$var$isSingletonScope(workInProgress.type) ? ($f69c825c3eb0ddcd$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(props.firstChild)) : $f69c825c3eb0ddcd$var$nextHydratableInstance = $$typeof), $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f69c825c3eb0ddcd$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f69c825c3eb0ddcd$var$isHydrating) {
                if ($$typeof = props = $f69c825c3eb0ddcd$var$nextHydratableInstance) props = $f69c825c3eb0ddcd$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $f69c825c3eb0ddcd$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$nextHydratableInstance = $f69c825c3eb0ddcd$var$getNextHydratable(props.firstChild), $f69c825c3eb0ddcd$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(workInProgress);
            }
            $f69c825c3eb0ddcd$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $f69c825c3eb0ddcd$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $f69c825c3eb0ddcd$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $f69c825c3eb0ddcd$var$renderWithHooks(current, workInProgress, $f69c825c3eb0ddcd$var$TransitionAwareHostComponent, null, null, renderLanes), $f69c825c3eb0ddcd$var$HostTransitionContext._currentValue = $$typeof);
            $f69c825c3eb0ddcd$var$markRef(current, workInProgress);
            $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f69c825c3eb0ddcd$var$isHydrating) {
                if (current = renderLanes = $f69c825c3eb0ddcd$var$nextHydratableInstance) renderLanes = $f69c825c3eb0ddcd$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f69c825c3eb0ddcd$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f69c825c3eb0ddcd$var$hydrationParentFiber = workInProgress, $f69c825c3eb0ddcd$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f69c825c3eb0ddcd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f69c825c3eb0ddcd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $f69c825c3eb0ddcd$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $f69c825c3eb0ddcd$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $f69c825c3eb0ddcd$var$pushProvider(workInProgress, workInProgress.type, props.value), $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress), $$typeof = $f69c825c3eb0ddcd$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $f69c825c3eb0ddcd$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f69c825c3eb0ddcd$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f69c825c3eb0ddcd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $f69c825c3eb0ddcd$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $f69c825c3eb0ddcd$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $f69c825c3eb0ddcd$var$prepareToReadContext(workInProgress), props = $f69c825c3eb0ddcd$var$readContext($f69c825c3eb0ddcd$var$CacheContext), null === current ? ($$typeof = $f69c825c3eb0ddcd$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $f69c825c3eb0ddcd$var$workInProgressRoot, prevState = $f69c825c3eb0ddcd$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $f69c825c3eb0ddcd$var$initializeUpdateQueue(workInProgress), $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($f69c825c3eb0ddcd$var$cloneUpdateQueue(current, workInProgress), $f69c825c3eb0ddcd$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f69c825c3eb0ddcd$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, props)) : (props = prevState.cache, $f69c825c3eb0ddcd$var$pushProvider(workInProgress, $f69c825c3eb0ddcd$var$CacheContext, props), props !== $$typeof.cache && $f69c825c3eb0ddcd$var$propagateContextChanges(workInProgress, [
                $f69c825c3eb0ddcd$var$CacheContext
            ], renderLanes, !0))), $f69c825c3eb0ddcd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f69c825c3eb0ddcd$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f69c825c3eb0ddcd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($f69c825c3eb0ddcd$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $f69c825c3eb0ddcd$var$suspendedThenable = $f69c825c3eb0ddcd$var$noopSuspenseyCommitThenable, $f69c825c3eb0ddcd$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $f69c825c3eb0ddcd$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f69c825c3eb0ddcd$var$preloadResource(resource)) {
        if ($f69c825c3eb0ddcd$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $f69c825c3eb0ddcd$var$suspendedThenable = $f69c825c3eb0ddcd$var$noopSuspenseyCommitThenable, $f69c825c3eb0ddcd$var$SuspenseyCommitException;
    }
}
function $f69c825c3eb0ddcd$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f69c825c3eb0ddcd$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f69c825c3eb0ddcd$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $f69c825c3eb0ddcd$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f69c825c3eb0ddcd$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f69c825c3eb0ddcd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext);
            $f69c825c3eb0ddcd$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f69c825c3eb0ddcd$var$popHydrationState(workInProgress) ? $f69c825c3eb0ddcd$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f69c825c3eb0ddcd$var$upgradeHydrationErrorsToRecoverable());
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($f69c825c3eb0ddcd$var$markUpdate(workInProgress), null !== nextResource ? ($f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), $f69c825c3eb0ddcd$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), $f69c825c3eb0ddcd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($f69c825c3eb0ddcd$var$markUpdate(workInProgress), $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), $f69c825c3eb0ddcd$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $f69c825c3eb0ddcd$var$markUpdate(workInProgress), $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), $f69c825c3eb0ddcd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $f69c825c3eb0ddcd$var$popHostContext(workInProgress);
            renderLanes = $f69c825c3eb0ddcd$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f69c825c3eb0ddcd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(166));
                    $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f69c825c3eb0ddcd$var$contextStackCursor.current;
                $f69c825c3eb0ddcd$var$popHydrationState(workInProgress) ? $f69c825c3eb0ddcd$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f69c825c3eb0ddcd$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f69c825c3eb0ddcd$var$markUpdate(workInProgress));
            }
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f69c825c3eb0ddcd$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f69c825c3eb0ddcd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(166));
                    $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $f69c825c3eb0ddcd$var$contextStackCursor.current;
                if ($f69c825c3eb0ddcd$var$popHydrationState(workInProgress)) $f69c825c3eb0ddcd$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $f69c825c3eb0ddcd$var$getOwnerDocumentFromRootContainer($f69c825c3eb0ddcd$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress;
                    nextResource[$f69c825c3eb0ddcd$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($f69c825c3eb0ddcd$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $f69c825c3eb0ddcd$var$markUpdate(workInProgress);
                }
            }
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            $f69c825c3eb0ddcd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f69c825c3eb0ddcd$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(166));
                current = $f69c825c3eb0ddcd$var$rootInstanceStackCursor.current;
                if ($f69c825c3eb0ddcd$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f69c825c3eb0ddcd$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f69c825c3eb0ddcd$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f69c825c3eb0ddcd$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $f69c825c3eb0ddcd$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $f69c825c3eb0ddcd$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(557));
                        current[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress;
                    } else $f69c825c3eb0ddcd$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $f69c825c3eb0ddcd$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(558));
            }
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f69c825c3eb0ddcd$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(317));
                        type[$f69c825c3eb0ddcd$var$internalInstanceKey] = workInProgress;
                    } else $f69c825c3eb0ddcd$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f69c825c3eb0ddcd$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f69c825c3eb0ddcd$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f69c825c3eb0ddcd$var$popHostContainer(), null === current && $f69c825c3eb0ddcd$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f69c825c3eb0ddcd$var$popProvider(workInProgress.type), $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
        case 19:
            $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $f69c825c3eb0ddcd$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $f69c825c3eb0ddcd$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $f69c825c3eb0ddcd$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f69c825c3eb0ddcd$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, $f69c825c3eb0ddcd$var$suspenseStackCursor.current & 1 | 2);
                            $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $f69c825c3eb0ddcd$var$now() > $f69c825c3eb0ddcd$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $f69c825c3eb0ddcd$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f69c825c3eb0ddcd$var$scheduleRetryEffect(workInProgress, current), $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$f69c825c3eb0ddcd$var$isHydrating) return $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f69c825c3eb0ddcd$var$now() - newProps.renderingStartTime > $f69c825c3eb0ddcd$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $f69c825c3eb0ddcd$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $f69c825c3eb0ddcd$var$now(), current.sibling = null, renderLanes = $f69c825c3eb0ddcd$var$suspenseStackCursor.current, $f69c825c3eb0ddcd$var$push($f69c825c3eb0ddcd$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $f69c825c3eb0ddcd$var$isHydrating && $f69c825c3eb0ddcd$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress), $f69c825c3eb0ddcd$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f69c825c3eb0ddcd$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext), $f69c825c3eb0ddcd$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f69c825c3eb0ddcd$var$unwindWork(current, workInProgress) {
    $f69c825c3eb0ddcd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext), $f69c825c3eb0ddcd$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f69c825c3eb0ddcd$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(340));
                $f69c825c3eb0ddcd$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(340));
                $f69c825c3eb0ddcd$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$suspenseStackCursor), null;
        case 4:
            return $f69c825c3eb0ddcd$var$popHostContainer(), null;
        case 10:
            return $f69c825c3eb0ddcd$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f69c825c3eb0ddcd$var$popSuspenseHandler(workInProgress), $f69c825c3eb0ddcd$var$popHiddenContext(), null !== current && $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f69c825c3eb0ddcd$var$unwindInterruptedWork(current, interruptedWork) {
    $f69c825c3eb0ddcd$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext);
            $f69c825c3eb0ddcd$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f69c825c3eb0ddcd$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f69c825c3eb0ddcd$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $f69c825c3eb0ddcd$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $f69c825c3eb0ddcd$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$suspenseStackCursor);
            break;
        case 10:
            $f69c825c3eb0ddcd$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f69c825c3eb0ddcd$var$popSuspenseHandler(interruptedWork);
            $f69c825c3eb0ddcd$var$popHiddenContext();
            null !== current && $f69c825c3eb0ddcd$var$pop($f69c825c3eb0ddcd$var$resumedCache);
            break;
        case 24:
            $f69c825c3eb0ddcd$var$popProvider($f69c825c3eb0ddcd$var$CacheContext);
    }
}
function $f69c825c3eb0ddcd$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f69c825c3eb0ddcd$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f69c825c3eb0ddcd$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f69c825c3eb0ddcd$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f69c825c3eb0ddcd$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f69c825c3eb0ddcd$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f69c825c3eb0ddcd$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f69c825c3eb0ddcd$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $f69c825c3eb0ddcd$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f69c825c3eb0ddcd$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f69c825c3eb0ddcd$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f69c825c3eb0ddcd$var$internalPropsKey] = newProps;
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f69c825c3eb0ddcd$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f69c825c3eb0ddcd$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f69c825c3eb0ddcd$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f69c825c3eb0ddcd$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f69c825c3eb0ddcd$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f69c825c3eb0ddcd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f69c825c3eb0ddcd$var$noop$1));
    else if (4 !== tag && (27 === tag && $f69c825c3eb0ddcd$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f69c825c3eb0ddcd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f69c825c3eb0ddcd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f69c825c3eb0ddcd$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f69c825c3eb0ddcd$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f69c825c3eb0ddcd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f69c825c3eb0ddcd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f69c825c3eb0ddcd$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f69c825c3eb0ddcd$var$setInitialProperties(singleton, type, props);
        singleton[$f69c825c3eb0ddcd$var$internalInstanceKey] = finishedWork;
        singleton[$f69c825c3eb0ddcd$var$internalPropsKey] = props;
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden = !1, $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = !1, $f69c825c3eb0ddcd$var$needsFormReset = !1, $f69c825c3eb0ddcd$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f69c825c3eb0ddcd$var$nextEffect = null;
function $f69c825c3eb0ddcd$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f69c825c3eb0ddcd$var$eventsEnabled = $f69c825c3eb0ddcd$var$_enabled;
    root = $f69c825c3eb0ddcd$var$getActiveElementDeep(root);
    if ($f69c825c3eb0ddcd$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f69c825c3eb0ddcd$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f69c825c3eb0ddcd$var$_enabled = !1;
    for($f69c825c3eb0ddcd$var$nextEffect = firstChild; null !== $f69c825c3eb0ddcd$var$nextEffect;)if (firstChild = $f69c825c3eb0ddcd$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $f69c825c3eb0ddcd$var$nextEffect = root;
    else for(; null !== $f69c825c3eb0ddcd$var$nextEffect;){
        firstChild = $f69c825c3eb0ddcd$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f69c825c3eb0ddcd$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f69c825c3eb0ddcd$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f69c825c3eb0ddcd$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f69c825c3eb0ddcd$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f69c825c3eb0ddcd$var$nextEffect = root;
            break;
        }
        $f69c825c3eb0ddcd$var$nextEffect = firstChild.return;
    }
}
function $f69c825c3eb0ddcd$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f69c825c3eb0ddcd$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f69c825c3eb0ddcd$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $f69c825c3eb0ddcd$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f69c825c3eb0ddcd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f69c825c3eb0ddcd$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f69c825c3eb0ddcd$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f69c825c3eb0ddcd$var$commitHostMount(finishedWork);
            flags & 512 && $f69c825c3eb0ddcd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f69c825c3eb0ddcd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f69c825c3eb0ddcd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f69c825c3eb0ddcd$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f69c825c3eb0ddcd$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden;
                prevProps = $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden;
                $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden = flags;
                ($f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden = prevProps;
                $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f69c825c3eb0ddcd$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f69c825c3eb0ddcd$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f69c825c3eb0ddcd$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f69c825c3eb0ddcd$var$hostParent = null, $f69c825c3eb0ddcd$var$hostParentIsContainer = !1;
function $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f69c825c3eb0ddcd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f69c825c3eb0ddcd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f69c825c3eb0ddcd$var$injectedHook && "function" === typeof $f69c825c3eb0ddcd$var$injectedHook.onCommitFiberUnmount) try {
        $f69c825c3eb0ddcd$var$injectedHook.onCommitFiberUnmount($f69c825c3eb0ddcd$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || $f69c825c3eb0ddcd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || $f69c825c3eb0ddcd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f69c825c3eb0ddcd$var$hostParent, prevHostParentIsContainer = $f69c825c3eb0ddcd$var$hostParentIsContainer;
            $f69c825c3eb0ddcd$var$isSingletonScope(deletedFiber.type) && ($f69c825c3eb0ddcd$var$hostParent = deletedFiber.stateNode, $f69c825c3eb0ddcd$var$hostParentIsContainer = !1);
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f69c825c3eb0ddcd$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f69c825c3eb0ddcd$var$hostParent = prevHostParent;
            $f69c825c3eb0ddcd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || $f69c825c3eb0ddcd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f69c825c3eb0ddcd$var$hostParent;
            prevHostParentIsContainer = $f69c825c3eb0ddcd$var$hostParentIsContainer;
            $f69c825c3eb0ddcd$var$hostParent = null;
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f69c825c3eb0ddcd$var$hostParent = prevHostParent;
            $f69c825c3eb0ddcd$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f69c825c3eb0ddcd$var$hostParent) {
                if ($f69c825c3eb0ddcd$var$hostParentIsContainer) try {
                    (9 === $f69c825c3eb0ddcd$var$hostParent.nodeType ? $f69c825c3eb0ddcd$var$hostParent.body : "HTML" === $f69c825c3eb0ddcd$var$hostParent.nodeName ? $f69c825c3eb0ddcd$var$hostParent.ownerDocument.body : $f69c825c3eb0ddcd$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f69c825c3eb0ddcd$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f69c825c3eb0ddcd$var$hostParent && ($f69c825c3eb0ddcd$var$hostParentIsContainer ? (finishedRoot = $f69c825c3eb0ddcd$var$hostParent, $f69c825c3eb0ddcd$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f69c825c3eb0ddcd$var$retryIfBlockedOn(finishedRoot)) : $f69c825c3eb0ddcd$var$clearHydrationBoundary($f69c825c3eb0ddcd$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f69c825c3eb0ddcd$var$hostParent;
            prevHostParentIsContainer = $f69c825c3eb0ddcd$var$hostParentIsContainer;
            $f69c825c3eb0ddcd$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f69c825c3eb0ddcd$var$hostParentIsContainer = !0;
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f69c825c3eb0ddcd$var$hostParent = prevHostParent;
            $f69c825c3eb0ddcd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || ($f69c825c3eb0ddcd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f69c825c3eb0ddcd$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = (prevHostParent = $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f69c825c3eb0ddcd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $f69c825c3eb0ddcd$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f69c825c3eb0ddcd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f69c825c3eb0ddcd$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f69c825c3eb0ddcd$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f69c825c3eb0ddcd$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f69c825c3eb0ddcd$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f69c825c3eb0ddcd$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f69c825c3eb0ddcd$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $f69c825c3eb0ddcd$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f69c825c3eb0ddcd$var$isSingletonScope(parent.type)) {
                        $f69c825c3eb0ddcd$var$hostParent = parent.stateNode;
                        $f69c825c3eb0ddcd$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f69c825c3eb0ddcd$var$hostParent = parent.stateNode;
                    $f69c825c3eb0ddcd$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f69c825c3eb0ddcd$var$hostParent = parent.stateNode.containerInfo;
                    $f69c825c3eb0ddcd$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f69c825c3eb0ddcd$var$hostParent) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(160));
        $f69c825c3eb0ddcd$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f69c825c3eb0ddcd$var$hostParent = null;
        $f69c825c3eb0ddcd$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$f69c825c3eb0ddcd$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f69c825c3eb0ddcd$var$currentHoistableRoot = null;
function $f69c825c3eb0ddcd$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f69c825c3eb0ddcd$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f69c825c3eb0ddcd$var$commitHookEffectListMount(3, finishedWork), $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || null === current || $f69c825c3eb0ddcd$var$safelyDetachRef(current, current.return));
            flags & 64 && $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f69c825c3eb0ddcd$var$currentHoistableRoot;
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || null === current || $f69c825c3eb0ddcd$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f69c825c3eb0ddcd$var$internalHoistableMarker] || currentResource[$f69c825c3eb0ddcd$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f69c825c3eb0ddcd$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f69c825c3eb0ddcd$var$internalInstanceKey] = finishedWork;
                                        $f69c825c3eb0ddcd$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f69c825c3eb0ddcd$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f69c825c3eb0ddcd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f69c825c3eb0ddcd$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f69c825c3eb0ddcd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f69c825c3eb0ddcd$var$internalInstanceKey] = finishedWork;
                                $f69c825c3eb0ddcd$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f69c825c3eb0ddcd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f69c825c3eb0ddcd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f69c825c3eb0ddcd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f69c825c3eb0ddcd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f69c825c3eb0ddcd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || null === current || $f69c825c3eb0ddcd$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f69c825c3eb0ddcd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || null === current || $f69c825c3eb0ddcd$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f69c825c3eb0ddcd$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f69c825c3eb0ddcd$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f69c825c3eb0ddcd$var$needsFormReset = !0);
            break;
        case 6:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f69c825c3eb0ddcd$var$tagCaches = null;
            hoistableRoot = $f69c825c3eb0ddcd$var$currentHoistableRoot;
            $f69c825c3eb0ddcd$var$currentHoistableRoot = $f69c825c3eb0ddcd$var$getHoistableRoot(root.containerInfo);
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$currentHoistableRoot = hoistableRoot;
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f69c825c3eb0ddcd$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f69c825c3eb0ddcd$var$needsFormReset && ($f69c825c3eb0ddcd$var$needsFormReset = !1, $f69c825c3eb0ddcd$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f69c825c3eb0ddcd$var$currentHoistableRoot;
            $f69c825c3eb0ddcd$var$currentHoistableRoot = $f69c825c3eb0ddcd$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            $f69c825c3eb0ddcd$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f69c825c3eb0ddcd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f69c825c3eb0ddcd$var$globalMostRecentFallbackTime = $f69c825c3eb0ddcd$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f69c825c3eb0ddcd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden;
            $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f69c825c3eb0ddcd$var$offscreenSubtreeIsHidden || $f69c825c3eb0ddcd$var$offscreenSubtreeWasHidden || $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f69c825c3eb0ddcd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f69c825c3eb0ddcd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $f69c825c3eb0ddcd$var$hideOrUnhideDehydratedBoundary(instance, !0) : $f69c825c3eb0ddcd$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $f69c825c3eb0ddcd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f69c825c3eb0ddcd$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f69c825c3eb0ddcd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyTraverseMutationEffects(root, finishedWork), $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork);
    }
}
function $f69c825c3eb0ddcd$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f69c825c3eb0ddcd$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f69c825c3eb0ddcd$var$getHostSibling(finishedWork);
                    $f69c825c3eb0ddcd$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f69c825c3eb0ddcd$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $f69c825c3eb0ddcd$var$getHostSibling(finishedWork);
                    $f69c825c3eb0ddcd$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $f69c825c3eb0ddcd$var$getHostSibling(finishedWork);
                    $f69c825c3eb0ddcd$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f69c825c3eb0ddcd$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f69c825c3eb0ddcd$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f69c825c3eb0ddcd$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f69c825c3eb0ddcd$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f69c825c3eb0ddcd$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f69c825c3eb0ddcd$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f69c825c3eb0ddcd$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f69c825c3eb0ddcd$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f69c825c3eb0ddcd$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f69c825c3eb0ddcd$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f69c825c3eb0ddcd$var$commitClassCallbacks(finishedWork);
                $f69c825c3eb0ddcd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f69c825c3eb0ddcd$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f69c825c3eb0ddcd$var$commitHostMount(finishedWork);
                $f69c825c3eb0ddcd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f69c825c3eb0ddcd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f69c825c3eb0ddcd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f69c825c3eb0ddcd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f69c825c3eb0ddcd$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f69c825c3eb0ddcd$var$releaseCache(previousCache));
}
function $f69c825c3eb0ddcd$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f69c825c3eb0ddcd$var$releaseCache(current));
}
function $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f69c825c3eb0ddcd$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f69c825c3eb0ddcd$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f69c825c3eb0ddcd$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f69c825c3eb0ddcd$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $f69c825c3eb0ddcd$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f69c825c3eb0ddcd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f69c825c3eb0ddcd$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f69c825c3eb0ddcd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f69c825c3eb0ddcd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f69c825c3eb0ddcd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f69c825c3eb0ddcd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f69c825c3eb0ddcd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f69c825c3eb0ddcd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f69c825c3eb0ddcd$var$suspenseyCommitFlag = 8192;
function $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $f69c825c3eb0ddcd$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f69c825c3eb0ddcd$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $f69c825c3eb0ddcd$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $f69c825c3eb0ddcd$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f69c825c3eb0ddcd$var$suspendResource(suspendedState, $f69c825c3eb0ddcd$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f69c825c3eb0ddcd$var$currentHoistableRoot;
            $f69c825c3eb0ddcd$var$currentHoistableRoot = $f69c825c3eb0ddcd$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $f69c825c3eb0ddcd$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f69c825c3eb0ddcd$var$suspenseyCommitFlag, $f69c825c3eb0ddcd$var$suspenseyCommitFlag = 16777216, $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $f69c825c3eb0ddcd$var$suspenseyCommitFlag = previousHoistableRoot) : $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $f69c825c3eb0ddcd$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f69c825c3eb0ddcd$var$nextEffect = childToDelete;
            $f69c825c3eb0ddcd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f69c825c3eb0ddcd$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f69c825c3eb0ddcd$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f69c825c3eb0ddcd$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f69c825c3eb0ddcd$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f69c825c3eb0ddcd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f69c825c3eb0ddcd$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f69c825c3eb0ddcd$var$nextEffect = childToDelete;
            $f69c825c3eb0ddcd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f69c825c3eb0ddcd$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f69c825c3eb0ddcd$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f69c825c3eb0ddcd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f69c825c3eb0ddcd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f69c825c3eb0ddcd$var$nextEffect;){
        var fiber = $f69c825c3eb0ddcd$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f69c825c3eb0ddcd$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f69c825c3eb0ddcd$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f69c825c3eb0ddcd$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f69c825c3eb0ddcd$var$nextEffect;){
            cache = $f69c825c3eb0ddcd$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f69c825c3eb0ddcd$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f69c825c3eb0ddcd$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f69c825c3eb0ddcd$var$nextEffect = sibling;
                break a;
            }
            $f69c825c3eb0ddcd$var$nextEffect = returnFiber;
        }
    }
}
var $f69c825c3eb0ddcd$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f69c825c3eb0ddcd$var$readContext($f69c825c3eb0ddcd$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $f69c825c3eb0ddcd$var$readContext($f69c825c3eb0ddcd$var$CacheContext).controller.signal;
    }
}, $f69c825c3eb0ddcd$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f69c825c3eb0ddcd$var$executionContext = 0, $f69c825c3eb0ddcd$var$workInProgressRoot = null, $f69c825c3eb0ddcd$var$workInProgress = null, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes = 0, $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0, $f69c825c3eb0ddcd$var$workInProgressThrownValue = null, $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering = !1, $f69c825c3eb0ddcd$var$workInProgressRootDidAttachPingListener = !1, $f69c825c3eb0ddcd$var$entangledRenderLanes = 0, $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 0, $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes = 0, $f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes = 0, $f69c825c3eb0ddcd$var$workInProgressRootPingedLanes = 0, $f69c825c3eb0ddcd$var$workInProgressDeferredLane = 0, $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes = 0, $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors = null, $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = null, $f69c825c3eb0ddcd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f69c825c3eb0ddcd$var$globalMostRecentFallbackTime = 0, $f69c825c3eb0ddcd$var$globalMostRecentTransitionTime = 0, $f69c825c3eb0ddcd$var$workInProgressRootRenderTargetTime = Infinity, $f69c825c3eb0ddcd$var$workInProgressTransitions = null, $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed = null, $f69c825c3eb0ddcd$var$pendingEffectsStatus = 0, $f69c825c3eb0ddcd$var$pendingEffectsRoot = null, $f69c825c3eb0ddcd$var$pendingFinishedWork = null, $f69c825c3eb0ddcd$var$pendingEffectsLanes = 0, $f69c825c3eb0ddcd$var$pendingEffectsRemainingLanes = 0, $f69c825c3eb0ddcd$var$pendingPassiveTransitions = null, $f69c825c3eb0ddcd$var$pendingRecoverableErrors = null, $f69c825c3eb0ddcd$var$nestedUpdateCount = 0, $f69c825c3eb0ddcd$var$rootWithNestedUpdates = null;
function $f69c825c3eb0ddcd$var$requestUpdateLane() {
    return 0 !== ($f69c825c3eb0ddcd$var$executionContext & 2) && 0 !== $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes ? $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & -$f69c825c3eb0ddcd$var$workInProgressRootRenderLanes : null !== $f69c825c3eb0ddcd$var$ReactSharedInternals.T ? $f69c825c3eb0ddcd$var$requestTransitionLane() : $f69c825c3eb0ddcd$var$resolveUpdatePriority();
}
function $f69c825c3eb0ddcd$var$requestDeferredLane() {
    if (0 === $f69c825c3eb0ddcd$var$workInProgressDeferredLane) {
        if (0 === ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 536870912) || $f69c825c3eb0ddcd$var$isHydrating) {
            var lane = $f69c825c3eb0ddcd$var$nextTransitionDeferredLane;
            $f69c825c3eb0ddcd$var$nextTransitionDeferredLane <<= 1;
            0 === ($f69c825c3eb0ddcd$var$nextTransitionDeferredLane & 3932160) && ($f69c825c3eb0ddcd$var$nextTransitionDeferredLane = 262144);
            $f69c825c3eb0ddcd$var$workInProgressDeferredLane = lane;
        } else $f69c825c3eb0ddcd$var$workInProgressDeferredLane = 536870912;
    }
    lane = $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $f69c825c3eb0ddcd$var$workInProgressDeferredLane;
}
function $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f69c825c3eb0ddcd$var$workInProgressRoot && (2 === $f69c825c3eb0ddcd$var$workInProgressSuspendedReason || 9 === $f69c825c3eb0ddcd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f69c825c3eb0ddcd$var$prepareFreshStack(root, 0), $f69c825c3eb0ddcd$var$markRootSuspended(root, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, !1);
    $f69c825c3eb0ddcd$var$markRootUpdated$1(root, lane);
    if (0 === ($f69c825c3eb0ddcd$var$executionContext & 2) || root !== $f69c825c3eb0ddcd$var$workInProgressRoot) root === $f69c825c3eb0ddcd$var$workInProgressRoot && (0 === ($f69c825c3eb0ddcd$var$executionContext & 2) && ($f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && $f69c825c3eb0ddcd$var$markRootSuspended(root, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, !1)), $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root);
}
function $f69c825c3eb0ddcd$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 6)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f69c825c3eb0ddcd$var$renderRootConcurrent(root$jscomp$0, lanes) : $f69c825c3eb0ddcd$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f69c825c3eb0ddcd$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f69c825c3eb0ddcd$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f69c825c3eb0ddcd$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f69c825c3eb0ddcd$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f69c825c3eb0ddcd$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f69c825c3eb0ddcd$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors;
                            $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors ? $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors.push.apply($f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f69c825c3eb0ddcd$var$prepareFreshStack(root$jscomp$0, 0);
                $f69c825c3eb0ddcd$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f69c825c3eb0ddcd$var$markRootSuspended(shouldTimeSlice, lanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, !$f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f69c825c3eb0ddcd$var$globalMostRecentFallbackTime + 300 - $f69c825c3eb0ddcd$var$now(), 10 < exitStatus)) {
                    $f69c825c3eb0ddcd$var$markRootSuspended(shouldTimeSlice, lanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, !$f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f69c825c3eb0ddcd$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $f69c825c3eb0ddcd$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $f69c825c3eb0ddcd$var$scheduleTimeout($f69c825c3eb0ddcd$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors, $f69c825c3eb0ddcd$var$workInProgressTransitions, $f69c825c3eb0ddcd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, $f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes, $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes, $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $f69c825c3eb0ddcd$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors, $f69c825c3eb0ddcd$var$workInProgressTransitions, $f69c825c3eb0ddcd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, $f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes, $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes, $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f69c825c3eb0ddcd$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $f69c825c3eb0ddcd$var$noop$1
        };
        $f69c825c3eb0ddcd$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $f69c825c3eb0ddcd$var$globalMostRecentFallbackTime - $f69c825c3eb0ddcd$var$now() : (lanes & 4194048) === lanes ? $f69c825c3eb0ddcd$var$globalMostRecentTransitionTime - $f69c825c3eb0ddcd$var$now() : 0;
        timeoutOffset = $f69c825c3eb0ddcd$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $f69c825c3eb0ddcd$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($f69c825c3eb0ddcd$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $f69c825c3eb0ddcd$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f69c825c3eb0ddcd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f69c825c3eb0ddcd$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f69c825c3eb0ddcd$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f69c825c3eb0ddcd$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f69c825c3eb0ddcd$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $f69c825c3eb0ddcd$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f69c825c3eb0ddcd$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f69c825c3eb0ddcd$var$flushSyncWork$1() {
    return 0 === ($f69c825c3eb0ddcd$var$executionContext & 6) ? ($f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f69c825c3eb0ddcd$var$resetWorkInProgressStack() {
    if (null !== $f69c825c3eb0ddcd$var$workInProgress) {
        if (0 === $f69c825c3eb0ddcd$var$workInProgressSuspendedReason) var interruptedWork = $f69c825c3eb0ddcd$var$workInProgress.return;
        else interruptedWork = $f69c825c3eb0ddcd$var$workInProgress, $f69c825c3eb0ddcd$var$lastContextDependency = $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = null, $f69c825c3eb0ddcd$var$resetHooksOnUnwind(interruptedWork), $f69c825c3eb0ddcd$var$thenableState$1 = null, $f69c825c3eb0ddcd$var$thenableIndexCounter$1 = 0, interruptedWork = $f69c825c3eb0ddcd$var$workInProgress;
        for(; null !== interruptedWork;)$f69c825c3eb0ddcd$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f69c825c3eb0ddcd$var$workInProgress = null;
    }
}
function $f69c825c3eb0ddcd$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f69c825c3eb0ddcd$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f69c825c3eb0ddcd$var$pendingEffectsLanes = 0;
    $f69c825c3eb0ddcd$var$resetWorkInProgressStack();
    $f69c825c3eb0ddcd$var$workInProgressRoot = root;
    $f69c825c3eb0ddcd$var$workInProgress = timeoutHandle = $f69c825c3eb0ddcd$var$createWorkInProgress(root.current, null);
    $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes = lanes;
    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
    $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
    $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering = $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root, lanes);
    $f69c825c3eb0ddcd$var$workInProgressRootDidAttachPingListener = !1;
    $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes = $f69c825c3eb0ddcd$var$workInProgressDeferredLane = $f69c825c3eb0ddcd$var$workInProgressRootPingedLanes = $f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes = $f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes = $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 0;
    $f69c825c3eb0ddcd$var$workInProgressRootRecoverableErrors = $f69c825c3eb0ddcd$var$workInProgressRootConcurrentErrors = null;
    $f69c825c3eb0ddcd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $f69c825c3eb0ddcd$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $f69c825c3eb0ddcd$var$entangledRenderLanes = lanes;
    $f69c825c3eb0ddcd$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f69c825c3eb0ddcd$var$handleThrow(root, thrownValue) {
    $f69c825c3eb0ddcd$var$currentlyRenderingFiber = null;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = $f69c825c3eb0ddcd$var$ContextOnlyDispatcher;
    thrownValue === $f69c825c3eb0ddcd$var$SuspenseException || thrownValue === $f69c825c3eb0ddcd$var$SuspenseActionException ? (thrownValue = $f69c825c3eb0ddcd$var$getSuspendedThenable(), $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 3) : thrownValue === $f69c825c3eb0ddcd$var$SuspenseyCommitException ? (thrownValue = $f69c825c3eb0ddcd$var$getSuspendedThenable(), $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 4) : $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = thrownValue === $f69c825c3eb0ddcd$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f69c825c3eb0ddcd$var$workInProgressThrownValue = thrownValue;
    null === $f69c825c3eb0ddcd$var$workInProgress && ($f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 1, $f69c825c3eb0ddcd$var$logUncaughtError(root, $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f69c825c3eb0ddcd$var$shouldRemainOnPreviousScreen() {
    var handler = $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 4194048) === $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes ? null === $f69c825c3eb0ddcd$var$shellBoundary ? !0 : !1 : ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 62914560) === $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes || 0 !== ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 536870912) ? handler === $f69c825c3eb0ddcd$var$shellBoundary : !1;
}
function $f69c825c3eb0ddcd$var$pushDispatcher() {
    var prevDispatcher = $f69c825c3eb0ddcd$var$ReactSharedInternals.H;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = $f69c825c3eb0ddcd$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f69c825c3eb0ddcd$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f69c825c3eb0ddcd$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f69c825c3eb0ddcd$var$ReactSharedInternals.A;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.A = $f69c825c3eb0ddcd$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f69c825c3eb0ddcd$var$renderDidSuspendDelayIfPossible() {
    $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 4;
    $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings || ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 4194048) !== $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes && null !== $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current || ($f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering = !0);
    0 === ($f69c825c3eb0ddcd$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f69c825c3eb0ddcd$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f69c825c3eb0ddcd$var$workInProgressRoot || $f69c825c3eb0ddcd$var$markRootSuspended($f69c825c3eb0ddcd$var$workInProgressRoot, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes, $f69c825c3eb0ddcd$var$workInProgressDeferredLane, !1);
}
function $f69c825c3eb0ddcd$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f69c825c3eb0ddcd$var$executionContext;
    $f69c825c3eb0ddcd$var$executionContext |= 2;
    var prevDispatcher = $f69c825c3eb0ddcd$var$pushDispatcher(), prevAsyncDispatcher = $f69c825c3eb0ddcd$var$pushAsyncDispatcher();
    if ($f69c825c3eb0ddcd$var$workInProgressRoot !== root || $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes !== lanes) $f69c825c3eb0ddcd$var$workInProgressTransitions = null, $f69c825c3eb0ddcd$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f69c825c3eb0ddcd$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f69c825c3eb0ddcd$var$workInProgressSuspendedReason && null !== $f69c825c3eb0ddcd$var$workInProgress) {
            var unitOfWork = $f69c825c3eb0ddcd$var$workInProgress, thrownValue = $f69c825c3eb0ddcd$var$workInProgressThrownValue;
            switch($f69c825c3eb0ddcd$var$workInProgressSuspendedReason){
                case 8:
                    $f69c825c3eb0ddcd$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f69c825c3eb0ddcd$var$workInProgressSuspendedReason;
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                    $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                    $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f69c825c3eb0ddcd$var$workInProgressSuspendedReason, $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0, $f69c825c3eb0ddcd$var$workInProgressThrownValue = null, $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f69c825c3eb0ddcd$var$workLoopSync();
        exitStatus = $f69c825c3eb0ddcd$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $f69c825c3eb0ddcd$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f69c825c3eb0ddcd$var$lastContextDependency = $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = null;
    $f69c825c3eb0ddcd$var$executionContext = prevExecutionContext;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = prevDispatcher;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f69c825c3eb0ddcd$var$workInProgress && ($f69c825c3eb0ddcd$var$workInProgressRoot = null, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes = 0, $f69c825c3eb0ddcd$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f69c825c3eb0ddcd$var$workLoopSync() {
    for(; null !== $f69c825c3eb0ddcd$var$workInProgress;)$f69c825c3eb0ddcd$var$performUnitOfWork($f69c825c3eb0ddcd$var$workInProgress);
}
function $f69c825c3eb0ddcd$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f69c825c3eb0ddcd$var$executionContext;
    $f69c825c3eb0ddcd$var$executionContext |= 2;
    var prevDispatcher = $f69c825c3eb0ddcd$var$pushDispatcher(), prevAsyncDispatcher = $f69c825c3eb0ddcd$var$pushAsyncDispatcher();
    $f69c825c3eb0ddcd$var$workInProgressRoot !== root || $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes !== lanes ? ($f69c825c3eb0ddcd$var$workInProgressTransitions = null, $f69c825c3eb0ddcd$var$workInProgressRootRenderTargetTime = $f69c825c3eb0ddcd$var$now() + 500, $f69c825c3eb0ddcd$var$prepareFreshStack(root, lanes)) : $f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering = $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f69c825c3eb0ddcd$var$workInProgressSuspendedReason && null !== $f69c825c3eb0ddcd$var$workInProgress) {
            lanes = $f69c825c3eb0ddcd$var$workInProgress;
            var thrownValue = $f69c825c3eb0ddcd$var$workInProgressThrownValue;
            b: switch($f69c825c3eb0ddcd$var$workInProgressSuspendedReason){
                case 1:
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                    $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                    $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f69c825c3eb0ddcd$var$isThenableResolved(thrownValue)) {
                        $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                        $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                        $f69c825c3eb0ddcd$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f69c825c3eb0ddcd$var$workInProgressSuspendedReason && 9 !== $f69c825c3eb0ddcd$var$workInProgressSuspendedReason || $f69c825c3eb0ddcd$var$workInProgressRoot !== root || ($f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 7);
                        $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f69c825c3eb0ddcd$var$isThenableResolved(thrownValue) ? ($f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0, $f69c825c3eb0ddcd$var$workInProgressThrownValue = null, $f69c825c3eb0ddcd$var$replaySuspendedUnitOfWork(lanes)) : ($f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0, $f69c825c3eb0ddcd$var$workInProgressThrownValue = null, $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f69c825c3eb0ddcd$var$workInProgress.tag){
                        case 26:
                            resource = $f69c825c3eb0ddcd$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f69c825c3eb0ddcd$var$workInProgress;
                            if (resource ? $f69c825c3eb0ddcd$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                                $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f69c825c3eb0ddcd$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f69c825c3eb0ddcd$var$workInProgress = returnFiber, $f69c825c3eb0ddcd$var$completeUnitOfWork(returnFiber)) : $f69c825c3eb0ddcd$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                    $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                    $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f69c825c3eb0ddcd$var$workInProgressSuspendedReason = 0;
                    $f69c825c3eb0ddcd$var$workInProgressThrownValue = null;
                    $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f69c825c3eb0ddcd$var$resetWorkInProgressStack();
                    $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(462));
            }
        }
        $f69c825c3eb0ddcd$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $f69c825c3eb0ddcd$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $f69c825c3eb0ddcd$var$lastContextDependency = $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = null;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.H = prevDispatcher;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f69c825c3eb0ddcd$var$executionContext = prevExecutionContext;
    if (null !== $f69c825c3eb0ddcd$var$workInProgress) return 0;
    $f69c825c3eb0ddcd$var$workInProgressRoot = null;
    $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes = 0;
    $f69c825c3eb0ddcd$var$finishQueueingConcurrentUpdates();
    return $f69c825c3eb0ddcd$var$workInProgressRootExitStatus;
}
function $f69c825c3eb0ddcd$var$workLoopConcurrentByScheduler() {
    for(; null !== $f69c825c3eb0ddcd$var$workInProgress && !$f69c825c3eb0ddcd$var$shouldYield();)$f69c825c3eb0ddcd$var$performUnitOfWork($f69c825c3eb0ddcd$var$workInProgress);
}
function $f69c825c3eb0ddcd$var$performUnitOfWork(unitOfWork) {
    var next = $f69c825c3eb0ddcd$var$beginWork(unitOfWork.alternate, unitOfWork, $f69c825c3eb0ddcd$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f69c825c3eb0ddcd$var$completeUnitOfWork(unitOfWork) : $f69c825c3eb0ddcd$var$workInProgress = next;
}
function $f69c825c3eb0ddcd$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f69c825c3eb0ddcd$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f69c825c3eb0ddcd$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f69c825c3eb0ddcd$var$resetHooksOnUnwind(next);
        default:
            $f69c825c3eb0ddcd$var$unwindInterruptedWork(current, next), next = $f69c825c3eb0ddcd$var$workInProgress = $f69c825c3eb0ddcd$var$resetWorkInProgress(next, $f69c825c3eb0ddcd$var$entangledRenderLanes), next = $f69c825c3eb0ddcd$var$beginWork(current, next, $f69c825c3eb0ddcd$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f69c825c3eb0ddcd$var$completeUnitOfWork(unitOfWork) : $f69c825c3eb0ddcd$var$workInProgress = next;
}
function $f69c825c3eb0ddcd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f69c825c3eb0ddcd$var$lastContextDependency = $f69c825c3eb0ddcd$var$currentlyRenderingFiber$1 = null;
    $f69c825c3eb0ddcd$var$resetHooksOnUnwind(unitOfWork);
    $f69c825c3eb0ddcd$var$thenableState$1 = null;
    $f69c825c3eb0ddcd$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f69c825c3eb0ddcd$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes)) {
            $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 1;
            $f69c825c3eb0ddcd$var$logUncaughtError(root, $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f69c825c3eb0ddcd$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f69c825c3eb0ddcd$var$workInProgress = returnFiber, error;
        $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 1;
        $f69c825c3eb0ddcd$var$logUncaughtError(root, $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f69c825c3eb0ddcd$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f69c825c3eb0ddcd$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f69c825c3eb0ddcd$var$workInProgressRootIsPrerendering || 0 !== ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f69c825c3eb0ddcd$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f69c825c3eb0ddcd$var$unwindUnitOfWork(unitOfWork, root);
    } else $f69c825c3eb0ddcd$var$completeUnitOfWork(unitOfWork);
}
function $f69c825c3eb0ddcd$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f69c825c3eb0ddcd$var$unwindUnitOfWork(completedWork, $f69c825c3eb0ddcd$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f69c825c3eb0ddcd$var$completeWork(completedWork.alternate, completedWork, $f69c825c3eb0ddcd$var$entangledRenderLanes);
        if (null !== next) {
            $f69c825c3eb0ddcd$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f69c825c3eb0ddcd$var$workInProgress = completedWork;
            return;
        }
        $f69c825c3eb0ddcd$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && ($f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 5);
}
function $f69c825c3eb0ddcd$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f69c825c3eb0ddcd$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f69c825c3eb0ddcd$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f69c825c3eb0ddcd$var$workInProgress = unitOfWork;
            return;
        }
        $f69c825c3eb0ddcd$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f69c825c3eb0ddcd$var$workInProgressRootExitStatus = 6;
    $f69c825c3eb0ddcd$var$workInProgress = null;
}
function $f69c825c3eb0ddcd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f69c825c3eb0ddcd$var$flushPendingEffects();
    while (0 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus);
    if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 6)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f69c825c3eb0ddcd$var$concurrentlyUpdatedLanes;
        $f69c825c3eb0ddcd$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f69c825c3eb0ddcd$var$workInProgressRoot && ($f69c825c3eb0ddcd$var$workInProgress = $f69c825c3eb0ddcd$var$workInProgressRoot = null, $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes = 0);
        $f69c825c3eb0ddcd$var$pendingFinishedWork = finishedWork;
        $f69c825c3eb0ddcd$var$pendingEffectsRoot = root;
        $f69c825c3eb0ddcd$var$pendingEffectsLanes = lanes;
        $f69c825c3eb0ddcd$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f69c825c3eb0ddcd$var$pendingPassiveTransitions = transitions;
        $f69c825c3eb0ddcd$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f69c825c3eb0ddcd$var$scheduleCallback$1($f69c825c3eb0ddcd$var$NormalPriority$1, function() {
            $f69c825c3eb0ddcd$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
            $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
            transitions = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
            $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f69c825c3eb0ddcd$var$executionContext;
            $f69c825c3eb0ddcd$var$executionContext |= 4;
            try {
                $f69c825c3eb0ddcd$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f69c825c3eb0ddcd$var$executionContext = spawnedLane, $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = transitions, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 1;
        $f69c825c3eb0ddcd$var$flushMutationEffects();
        $f69c825c3eb0ddcd$var$flushLayoutEffects();
        $f69c825c3eb0ddcd$var$flushSpawnedWork();
    }
}
function $f69c825c3eb0ddcd$var$flushMutationEffects() {
    if (1 === $f69c825c3eb0ddcd$var$pendingEffectsStatus) {
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 0;
        var root = $f69c825c3eb0ddcd$var$pendingEffectsRoot, finishedWork = $f69c825c3eb0ddcd$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
            $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
            var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
            $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f69c825c3eb0ddcd$var$executionContext;
            $f69c825c3eb0ddcd$var$executionContext |= 4;
            try {
                $f69c825c3eb0ddcd$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f69c825c3eb0ddcd$var$selectionInformation, curFocusedElem = $f69c825c3eb0ddcd$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f69c825c3eb0ddcd$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f69c825c3eb0ddcd$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f69c825c3eb0ddcd$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f69c825c3eb0ddcd$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f69c825c3eb0ddcd$var$_enabled = !!$f69c825c3eb0ddcd$var$eventsEnabled;
                $f69c825c3eb0ddcd$var$selectionInformation = $f69c825c3eb0ddcd$var$eventsEnabled = null;
            } finally{
                $f69c825c3eb0ddcd$var$executionContext = prevExecutionContext, $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 2;
    }
}
function $f69c825c3eb0ddcd$var$flushLayoutEffects() {
    if (2 === $f69c825c3eb0ddcd$var$pendingEffectsStatus) {
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 0;
        var root = $f69c825c3eb0ddcd$var$pendingEffectsRoot, finishedWork = $f69c825c3eb0ddcd$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
            $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
            var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
            $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f69c825c3eb0ddcd$var$executionContext;
            $f69c825c3eb0ddcd$var$executionContext |= 4;
            try {
                $f69c825c3eb0ddcd$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f69c825c3eb0ddcd$var$executionContext = prevExecutionContext, $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 3;
    }
}
function $f69c825c3eb0ddcd$var$flushSpawnedWork() {
    if (4 === $f69c825c3eb0ddcd$var$pendingEffectsStatus || 3 === $f69c825c3eb0ddcd$var$pendingEffectsStatus) {
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 0;
        $f69c825c3eb0ddcd$var$requestPaint();
        var root = $f69c825c3eb0ddcd$var$pendingEffectsRoot, finishedWork = $f69c825c3eb0ddcd$var$pendingFinishedWork, lanes = $f69c825c3eb0ddcd$var$pendingEffectsLanes, recoverableErrors = $f69c825c3eb0ddcd$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f69c825c3eb0ddcd$var$pendingEffectsStatus = 5 : ($f69c825c3eb0ddcd$var$pendingEffectsStatus = 0, $f69c825c3eb0ddcd$var$pendingFinishedWork = $f69c825c3eb0ddcd$var$pendingEffectsRoot = null, $f69c825c3eb0ddcd$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f69c825c3eb0ddcd$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f69c825c3eb0ddcd$var$injectedHook && "function" === typeof $f69c825c3eb0ddcd$var$injectedHook.onCommitFiberRoot) try {
            $f69c825c3eb0ddcd$var$injectedHook.onCommitFiberRoot($f69c825c3eb0ddcd$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
            remainingLanes = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
            $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 2;
            $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f69c825c3eb0ddcd$var$ReactSharedInternals.T = finishedWork, $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f69c825c3eb0ddcd$var$pendingEffectsLanes & 3) && $f69c825c3eb0ddcd$var$flushPendingEffects();
        $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $f69c825c3eb0ddcd$var$rootWithNestedUpdates ? $f69c825c3eb0ddcd$var$nestedUpdateCount++ : ($f69c825c3eb0ddcd$var$nestedUpdateCount = 0, $f69c825c3eb0ddcd$var$rootWithNestedUpdates = root) : $f69c825c3eb0ddcd$var$nestedUpdateCount = 0;
        $f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f69c825c3eb0ddcd$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f69c825c3eb0ddcd$var$releaseCache(remainingLanes)));
}
function $f69c825c3eb0ddcd$var$flushPendingEffects() {
    $f69c825c3eb0ddcd$var$flushMutationEffects();
    $f69c825c3eb0ddcd$var$flushLayoutEffects();
    $f69c825c3eb0ddcd$var$flushSpawnedWork();
    return $f69c825c3eb0ddcd$var$flushPassiveEffects();
}
function $f69c825c3eb0ddcd$var$flushPassiveEffects() {
    if (5 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus) return !1;
    var root = $f69c825c3eb0ddcd$var$pendingEffectsRoot, remainingLanes = $f69c825c3eb0ddcd$var$pendingEffectsRemainingLanes;
    $f69c825c3eb0ddcd$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f69c825c3eb0ddcd$var$lanesToEventPriority($f69c825c3eb0ddcd$var$pendingEffectsLanes), prevTransition = $f69c825c3eb0ddcd$var$ReactSharedInternals.T, previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    try {
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
        renderPriority = $f69c825c3eb0ddcd$var$pendingPassiveTransitions;
        $f69c825c3eb0ddcd$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f69c825c3eb0ddcd$var$pendingEffectsRoot, lanes = $f69c825c3eb0ddcd$var$pendingEffectsLanes;
        $f69c825c3eb0ddcd$var$pendingEffectsStatus = 0;
        $f69c825c3eb0ddcd$var$pendingFinishedWork = $f69c825c3eb0ddcd$var$pendingEffectsRoot = null;
        $f69c825c3eb0ddcd$var$pendingEffectsLanes = 0;
        if (0 !== ($f69c825c3eb0ddcd$var$executionContext & 6)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f69c825c3eb0ddcd$var$executionContext;
        $f69c825c3eb0ddcd$var$executionContext |= 4;
        $f69c825c3eb0ddcd$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f69c825c3eb0ddcd$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f69c825c3eb0ddcd$var$executionContext = prevExecutionContext;
        $f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f69c825c3eb0ddcd$var$injectedHook && "function" === typeof $f69c825c3eb0ddcd$var$injectedHook.onPostCommitFiberRoot) try {
            $f69c825c3eb0ddcd$var$injectedHook.onPostCommitFiberRoot($f69c825c3eb0ddcd$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = prevTransition, $f69c825c3eb0ddcd$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f69c825c3eb0ddcd$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f69c825c3eb0ddcd$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f69c825c3eb0ddcd$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f69c825c3eb0ddcd$var$markRootUpdated$1(rootFiber, 2), $f69c825c3eb0ddcd$var$ensureRootIsScheduled(rootFiber));
}
function $f69c825c3eb0ddcd$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f69c825c3eb0ddcd$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f69c825c3eb0ddcd$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed || !$f69c825c3eb0ddcd$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f69c825c3eb0ddcd$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f69c825c3eb0ddcd$var$createClassErrorUpdate(2);
                instance = $f69c825c3eb0ddcd$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f69c825c3eb0ddcd$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f69c825c3eb0ddcd$var$markRootUpdated$1(instance, 2), $f69c825c3eb0ddcd$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f69c825c3eb0ddcd$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f69c825c3eb0ddcd$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f69c825c3eb0ddcd$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f69c825c3eb0ddcd$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f69c825c3eb0ddcd$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f69c825c3eb0ddcd$var$workInProgressRoot === root && ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f69c825c3eb0ddcd$var$workInProgressRootExitStatus || 3 === $f69c825c3eb0ddcd$var$workInProgressRootExitStatus && ($f69c825c3eb0ddcd$var$workInProgressRootRenderLanes & 62914560) === $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes && 300 > $f69c825c3eb0ddcd$var$now() - $f69c825c3eb0ddcd$var$globalMostRecentFallbackTime ? 0 === ($f69c825c3eb0ddcd$var$executionContext & 2) && $f69c825c3eb0ddcd$var$prepareFreshStack(root, 0) : $f69c825c3eb0ddcd$var$workInProgressRootPingedLanes |= pingedLanes, $f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes === $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes && ($f69c825c3eb0ddcd$var$workInProgressSuspendedRetryLanes = 0));
    $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root);
}
function $f69c825c3eb0ddcd$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f69c825c3eb0ddcd$var$claimNextRetryLane());
    boundaryFiber = $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f69c825c3eb0ddcd$var$markRootUpdated$1(boundaryFiber, retryLane), $f69c825c3eb0ddcd$var$ensureRootIsScheduled(boundaryFiber));
}
function $f69c825c3eb0ddcd$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f69c825c3eb0ddcd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f69c825c3eb0ddcd$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f69c825c3eb0ddcd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f69c825c3eb0ddcd$var$scheduleCallback$1(priorityLevel, callback) {
    return $f69c825c3eb0ddcd$var$scheduleCallback$3(priorityLevel, callback);
}
var $f69c825c3eb0ddcd$var$firstScheduledRoot = null, $f69c825c3eb0ddcd$var$lastScheduledRoot = null, $f69c825c3eb0ddcd$var$didScheduleMicrotask = !1, $f69c825c3eb0ddcd$var$mightHavePendingSyncWork = !1, $f69c825c3eb0ddcd$var$isFlushingWork = !1, $f69c825c3eb0ddcd$var$currentEventTransitionLane = 0;
function $f69c825c3eb0ddcd$var$ensureRootIsScheduled(root) {
    root !== $f69c825c3eb0ddcd$var$lastScheduledRoot && null === root.next && (null === $f69c825c3eb0ddcd$var$lastScheduledRoot ? $f69c825c3eb0ddcd$var$firstScheduledRoot = $f69c825c3eb0ddcd$var$lastScheduledRoot = root : $f69c825c3eb0ddcd$var$lastScheduledRoot = $f69c825c3eb0ddcd$var$lastScheduledRoot.next = root);
    $f69c825c3eb0ddcd$var$mightHavePendingSyncWork = !0;
    $f69c825c3eb0ddcd$var$didScheduleMicrotask || ($f69c825c3eb0ddcd$var$didScheduleMicrotask = !0, $f69c825c3eb0ddcd$var$scheduleImmediateRootScheduleTask());
}
function $f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f69c825c3eb0ddcd$var$isFlushingWork && $f69c825c3eb0ddcd$var$mightHavePendingSyncWork) {
        $f69c825c3eb0ddcd$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $f69c825c3eb0ddcd$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f69c825c3eb0ddcd$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f69c825c3eb0ddcd$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f69c825c3eb0ddcd$var$getNextLanes(root$170, root$170 === $f69c825c3eb0ddcd$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f69c825c3eb0ddcd$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $f69c825c3eb0ddcd$var$isFlushingWork = !1;
    }
}
function $f69c825c3eb0ddcd$var$processRootScheduleInImmediateTask() {
    $f69c825c3eb0ddcd$var$processRootScheduleInMicrotask();
}
function $f69c825c3eb0ddcd$var$processRootScheduleInMicrotask() {
    $f69c825c3eb0ddcd$var$mightHavePendingSyncWork = $f69c825c3eb0ddcd$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f69c825c3eb0ddcd$var$currentEventTransitionLane && $f69c825c3eb0ddcd$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f69c825c3eb0ddcd$var$currentEventTransitionLane);
    for(var currentTime = $f69c825c3eb0ddcd$var$now(), prev = null, root = $f69c825c3eb0ddcd$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f69c825c3eb0ddcd$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f69c825c3eb0ddcd$var$firstScheduledRoot = next : prev.next = next, null === next && ($f69c825c3eb0ddcd$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f69c825c3eb0ddcd$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus && 5 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus || $f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $f69c825c3eb0ddcd$var$currentEventTransitionLane && ($f69c825c3eb0ddcd$var$currentEventTransitionLane = 0);
}
function $f69c825c3eb0ddcd$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $f69c825c3eb0ddcd$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $f69c825c3eb0ddcd$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f69c825c3eb0ddcd$var$workInProgressRoot;
    suspendedLanes = $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes;
    suspendedLanes = $f69c825c3eb0ddcd$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f69c825c3eb0ddcd$var$workInProgressSuspendedReason || 9 === $f69c825c3eb0ddcd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f69c825c3eb0ddcd$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f69c825c3eb0ddcd$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f69c825c3eb0ddcd$var$cancelCallback$1(pingedLanes);
        switch($f69c825c3eb0ddcd$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f69c825c3eb0ddcd$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f69c825c3eb0ddcd$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f69c825c3eb0ddcd$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f69c825c3eb0ddcd$var$NormalPriority$1;
        }
        pingedLanes = $f69c825c3eb0ddcd$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f69c825c3eb0ddcd$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f69c825c3eb0ddcd$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f69c825c3eb0ddcd$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus && 5 !== $f69c825c3eb0ddcd$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f69c825c3eb0ddcd$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f69c825c3eb0ddcd$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f69c825c3eb0ddcd$var$getNextLanes(root, root === $f69c825c3eb0ddcd$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f69c825c3eb0ddcd$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f69c825c3eb0ddcd$var$scheduleTaskForRootDuringMicrotask(root, $f69c825c3eb0ddcd$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f69c825c3eb0ddcd$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f69c825c3eb0ddcd$var$performSyncWorkOnRoot(root, lanes) {
    if ($f69c825c3eb0ddcd$var$flushPendingEffects()) return null;
    $f69c825c3eb0ddcd$var$performWorkOnRoot(root, lanes, !0);
}
function $f69c825c3eb0ddcd$var$scheduleImmediateRootScheduleTask() {
    $f69c825c3eb0ddcd$var$scheduleMicrotask(function() {
        0 !== ($f69c825c3eb0ddcd$var$executionContext & 6) ? $f69c825c3eb0ddcd$var$scheduleCallback$3($f69c825c3eb0ddcd$var$ImmediatePriority, $f69c825c3eb0ddcd$var$processRootScheduleInImmediateTask) : $f69c825c3eb0ddcd$var$processRootScheduleInMicrotask();
    });
}
function $f69c825c3eb0ddcd$var$requestTransitionLane() {
    if (0 === $f69c825c3eb0ddcd$var$currentEventTransitionLane) {
        var actionScopeLane = $f69c825c3eb0ddcd$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $f69c825c3eb0ddcd$var$nextTransitionUpdateLane, $f69c825c3eb0ddcd$var$nextTransitionUpdateLane <<= 1, 0 === ($f69c825c3eb0ddcd$var$nextTransitionUpdateLane & 261888) && ($f69c825c3eb0ddcd$var$nextTransitionUpdateLane = 256));
        $f69c825c3eb0ddcd$var$currentEventTransitionLane = actionScopeLane;
    }
    return $f69c825c3eb0ddcd$var$currentEventTransitionLane;
}
function $f69c825c3eb0ddcd$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f69c825c3eb0ddcd$var$sanitizeURL("" + actionProp);
}
function $f69c825c3eb0ddcd$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f69c825c3eb0ddcd$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f69c825c3eb0ddcd$var$coerceFormActionProp((nativeEventTarget[$f69c825c3eb0ddcd$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f69c825c3eb0ddcd$var$internalPropsKey] || null) ? $f69c825c3eb0ddcd$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f69c825c3eb0ddcd$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f69c825c3eb0ddcd$var$currentEventTransitionLane) {
                                var formData = submitter ? $f69c825c3eb0ddcd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f69c825c3eb0ddcd$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f69c825c3eb0ddcd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f69c825c3eb0ddcd$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f69c825c3eb0ddcd$var$i$jscomp$inline_1577 = 0; $f69c825c3eb0ddcd$var$i$jscomp$inline_1577 < $f69c825c3eb0ddcd$var$simpleEventPluginEvents.length; $f69c825c3eb0ddcd$var$i$jscomp$inline_1577++){
    var $f69c825c3eb0ddcd$var$eventName$jscomp$inline_1578 = $f69c825c3eb0ddcd$var$simpleEventPluginEvents[$f69c825c3eb0ddcd$var$i$jscomp$inline_1577], $f69c825c3eb0ddcd$var$domEventName$jscomp$inline_1579 = $f69c825c3eb0ddcd$var$eventName$jscomp$inline_1578.toLowerCase(), $f69c825c3eb0ddcd$var$capitalizedEvent$jscomp$inline_1580 = $f69c825c3eb0ddcd$var$eventName$jscomp$inline_1578[0].toUpperCase() + $f69c825c3eb0ddcd$var$eventName$jscomp$inline_1578.slice(1);
    $f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$domEventName$jscomp$inline_1579, "on" + $f69c825c3eb0ddcd$var$capitalizedEvent$jscomp$inline_1580);
}
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$ANIMATION_END, "onAnimationEnd");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$ANIMATION_ITERATION, "onAnimationIteration");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$ANIMATION_START, "onAnimationStart");
$f69c825c3eb0ddcd$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f69c825c3eb0ddcd$var$registerSimpleEvent("focusin", "onFocus");
$f69c825c3eb0ddcd$var$registerSimpleEvent("focusout", "onBlur");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$TRANSITION_RUN, "onTransitionRun");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$TRANSITION_START, "onTransitionStart");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$TRANSITION_CANCEL, "onTransitionCancel");
$f69c825c3eb0ddcd$var$registerSimpleEvent($f69c825c3eb0ddcd$var$TRANSITION_END, "onTransitionEnd");
$f69c825c3eb0ddcd$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f69c825c3eb0ddcd$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f69c825c3eb0ddcd$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f69c825c3eb0ddcd$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f69c825c3eb0ddcd$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f69c825c3eb0ddcd$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f69c825c3eb0ddcd$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f69c825c3eb0ddcd$var$mediaEventTypes));
function $f69c825c3eb0ddcd$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f69c825c3eb0ddcd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f69c825c3eb0ddcd$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f69c825c3eb0ddcd$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f69c825c3eb0ddcd$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f69c825c3eb0ddcd$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f69c825c3eb0ddcd$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f69c825c3eb0ddcd$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f69c825c3eb0ddcd$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f69c825c3eb0ddcd$var$listeningMarker]) {
        rootContainerElement[$f69c825c3eb0ddcd$var$listeningMarker] = !0;
        $f69c825c3eb0ddcd$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f69c825c3eb0ddcd$var$nonDelegatedEvents.has(domEventName) || $f69c825c3eb0ddcd$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f69c825c3eb0ddcd$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f69c825c3eb0ddcd$var$listeningMarker] || (ownerDocument[$f69c825c3eb0ddcd$var$listeningMarker] = !0, $f69c825c3eb0ddcd$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f69c825c3eb0ddcd$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f69c825c3eb0ddcd$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f69c825c3eb0ddcd$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f69c825c3eb0ddcd$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f69c825c3eb0ddcd$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f69c825c3eb0ddcd$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f69c825c3eb0ddcd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f69c825c3eb0ddcd$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f69c825c3eb0ddcd$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f69c825c3eb0ddcd$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f69c825c3eb0ddcd$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticTouchEvent;
                        break;
                    case $f69c825c3eb0ddcd$var$ANIMATION_END:
                    case $f69c825c3eb0ddcd$var$ANIMATION_ITERATION:
                    case $f69c825c3eb0ddcd$var$ANIMATION_START:
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticAnimationEvent;
                        break;
                    case $f69c825c3eb0ddcd$var$TRANSITION_END:
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f69c825c3eb0ddcd$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f69c825c3eb0ddcd$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f69c825c3eb0ddcd$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f69c825c3eb0ddcd$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f69c825c3eb0ddcd$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f69c825c3eb0ddcd$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f69c825c3eb0ddcd$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f69c825c3eb0ddcd$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f69c825c3eb0ddcd$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f69c825c3eb0ddcd$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f69c825c3eb0ddcd$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $f69c825c3eb0ddcd$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f69c825c3eb0ddcd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f69c825c3eb0ddcd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f69c825c3eb0ddcd$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f69c825c3eb0ddcd$var$getTargetInstForChangeEvent;
                else if ($f69c825c3eb0ddcd$var$isTextInputElement(reactName)) {
                    if ($f69c825c3eb0ddcd$var$isInputEventSupported) getTargetInstFunc = $f69c825c3eb0ddcd$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f69c825c3eb0ddcd$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f69c825c3eb0ddcd$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f69c825c3eb0ddcd$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f69c825c3eb0ddcd$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f69c825c3eb0ddcd$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f69c825c3eb0ddcd$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f69c825c3eb0ddcd$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f69c825c3eb0ddcd$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f69c825c3eb0ddcd$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f69c825c3eb0ddcd$var$activeElement = handleEventFunc, $f69c825c3eb0ddcd$var$activeElementInst = targetInst, $f69c825c3eb0ddcd$var$lastSelection = null;
                    break;
                case "focusout":
                    $f69c825c3eb0ddcd$var$lastSelection = $f69c825c3eb0ddcd$var$activeElementInst = $f69c825c3eb0ddcd$var$activeElement = null;
                    break;
                case "mousedown":
                    $f69c825c3eb0ddcd$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f69c825c3eb0ddcd$var$mouseDown = !1;
                    $f69c825c3eb0ddcd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f69c825c3eb0ddcd$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f69c825c3eb0ddcd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f69c825c3eb0ddcd$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f69c825c3eb0ddcd$var$isComposing ? $f69c825c3eb0ddcd$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f69c825c3eb0ddcd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f69c825c3eb0ddcd$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f69c825c3eb0ddcd$var$isComposing && (fallbackData = $f69c825c3eb0ddcd$var$getData()) : ($f69c825c3eb0ddcd$var$root = nativeEventTarget, $f69c825c3eb0ddcd$var$startText = "value" in $f69c825c3eb0ddcd$var$root ? $f69c825c3eb0ddcd$var$root.value : $f69c825c3eb0ddcd$var$root.textContent, $f69c825c3eb0ddcd$var$isComposing = !0)), handleEventFunc = $f69c825c3eb0ddcd$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f69c825c3eb0ddcd$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f69c825c3eb0ddcd$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f69c825c3eb0ddcd$var$canUseTextInputEvent ? $f69c825c3eb0ddcd$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f69c825c3eb0ddcd$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f69c825c3eb0ddcd$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f69c825c3eb0ddcd$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f69c825c3eb0ddcd$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f69c825c3eb0ddcd$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f69c825c3eb0ddcd$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f69c825c3eb0ddcd$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f69c825c3eb0ddcd$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f69c825c3eb0ddcd$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f69c825c3eb0ddcd$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f69c825c3eb0ddcd$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f69c825c3eb0ddcd$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f69c825c3eb0ddcd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f69c825c3eb0ddcd$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f69c825c3eb0ddcd$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f69c825c3eb0ddcd$var$getListener(target, registrationName), null != stateNode && listeners.push($f69c825c3eb0ddcd$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f69c825c3eb0ddcd$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f69c825c3eb0ddcd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f69c825c3eb0ddcd$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f69c825c3eb0ddcd$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f69c825c3eb0ddcd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f69c825c3eb0ddcd$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f69c825c3eb0ddcd$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f69c825c3eb0ddcd$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f69c825c3eb0ddcd$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f69c825c3eb0ddcd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f69c825c3eb0ddcd$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f69c825c3eb0ddcd$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f69c825c3eb0ddcd$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f69c825c3eb0ddcd$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f69c825c3eb0ddcd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f69c825c3eb0ddcd$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f69c825c3eb0ddcd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f69c825c3eb0ddcd$var$setProp(domElement, tag, "name", props.name, props, null), $f69c825c3eb0ddcd$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f69c825c3eb0ddcd$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f69c825c3eb0ddcd$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f69c825c3eb0ddcd$var$setProp(domElement, tag, "encType", props.encType, props, null), $f69c825c3eb0ddcd$var$setProp(domElement, tag, "method", props.method, props, null), $f69c825c3eb0ddcd$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f69c825c3eb0ddcd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f69c825c3eb0ddcd$var$noop$1);
            break;
        case "onScroll":
            null != value && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f69c825c3eb0ddcd$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("toggle", domElement);
            $f69c825c3eb0ddcd$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f69c825c3eb0ddcd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f69c825c3eb0ddcd$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f69c825c3eb0ddcd$var$aliases.get(key) || key, $f69c825c3eb0ddcd$var$setValueForAttribute(domElement, key, value);
    }
}
function $f69c825c3eb0ddcd$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f69c825c3eb0ddcd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f69c825c3eb0ddcd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f69c825c3eb0ddcd$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f69c825c3eb0ddcd$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f69c825c3eb0ddcd$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f69c825c3eb0ddcd$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f69c825c3eb0ddcd$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f69c825c3eb0ddcd$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("error", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(137, tag));
                    default:
                        $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f69c825c3eb0ddcd$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f69c825c3eb0ddcd$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f69c825c3eb0ddcd$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $f69c825c3eb0ddcd$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f69c825c3eb0ddcd$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f69c825c3eb0ddcd$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f69c825c3eb0ddcd$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("toggle", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("cancel", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f69c825c3eb0ddcd$var$mediaEventTypes.length; hasSrc++)$f69c825c3eb0ddcd$var$listenToNonDelegatedEvent($f69c825c3eb0ddcd$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("error", domElement);
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("error", domElement), $f69c825c3eb0ddcd$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(137, tag));
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f69c825c3eb0ddcd$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $f69c825c3eb0ddcd$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f69c825c3eb0ddcd$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f69c825c3eb0ddcd$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $f69c825c3eb0ddcd$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f69c825c3eb0ddcd$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f69c825c3eb0ddcd$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $f69c825c3eb0ddcd$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $f69c825c3eb0ddcd$var$updateOptions(domElement, !!lastProps, tag, !0) : $f69c825c3eb0ddcd$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f69c825c3eb0ddcd$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f69c825c3eb0ddcd$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f69c825c3eb0ddcd$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($f69c825c3eb0ddcd$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $f69c825c3eb0ddcd$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $f69c825c3eb0ddcd$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $f69c825c3eb0ddcd$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $f69c825c3eb0ddcd$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $f69c825c3eb0ddcd$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $f69c825c3eb0ddcd$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $f69c825c3eb0ddcd$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $f69c825c3eb0ddcd$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $f69c825c3eb0ddcd$var$eventsEnabled = null, $f69c825c3eb0ddcd$var$selectionInformation = null;
function $f69c825c3eb0ddcd$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f69c825c3eb0ddcd$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f69c825c3eb0ddcd$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f69c825c3eb0ddcd$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f69c825c3eb0ddcd$var$currentPopstateTransitionEvent = null;
function $f69c825c3eb0ddcd$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f69c825c3eb0ddcd$var$currentPopstateTransitionEvent) return !1;
        $f69c825c3eb0ddcd$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f69c825c3eb0ddcd$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f69c825c3eb0ddcd$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f69c825c3eb0ddcd$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f69c825c3eb0ddcd$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f69c825c3eb0ddcd$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f69c825c3eb0ddcd$var$localPromise ? function(callback) {
    return $f69c825c3eb0ddcd$var$localPromise.resolve(null).then(callback).catch($f69c825c3eb0ddcd$var$handleErrorInNextTick);
} : $f69c825c3eb0ddcd$var$scheduleTimeout;
function $f69c825c3eb0ddcd$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f69c825c3eb0ddcd$var$isSingletonScope(type) {
    return "head" === type;
}
function $f69c825c3eb0ddcd$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f69c825c3eb0ddcd$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $f69c825c3eb0ddcd$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $f69c825c3eb0ddcd$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$f69c825c3eb0ddcd$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $f69c825c3eb0ddcd$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $f69c825c3eb0ddcd$var$retryIfBlockedOn(hydrationInstance);
}
function $f69c825c3eb0ddcd$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $f69c825c3eb0ddcd$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f69c825c3eb0ddcd$var$clearContainerSparingly(node);
                $f69c825c3eb0ddcd$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f69c825c3eb0ddcd$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f69c825c3eb0ddcd$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f69c825c3eb0ddcd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f69c825c3eb0ddcd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f69c825c3eb0ddcd$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f69c825c3eb0ddcd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f69c825c3eb0ddcd$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $f69c825c3eb0ddcd$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $f69c825c3eb0ddcd$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f69c825c3eb0ddcd$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $f69c825c3eb0ddcd$var$previousHydratableOnEnteringScopedSingleton = null;
function $f69c825c3eb0ddcd$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $f69c825c3eb0ddcd$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f69c825c3eb0ddcd$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f69c825c3eb0ddcd$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(451));
    }
}
function $f69c825c3eb0ddcd$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f69c825c3eb0ddcd$var$detachDeletedInstance(instance);
}
var $f69c825c3eb0ddcd$var$preloadPropsMap = new Map(), $f69c825c3eb0ddcd$var$preconnectsSet = new Set();
function $f69c825c3eb0ddcd$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f69c825c3eb0ddcd$var$previousDispatcher = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.d;
$f69c825c3eb0ddcd$var$ReactDOMSharedInternals.d = {
    f: $f69c825c3eb0ddcd$var$flushSyncWork,
    r: $f69c825c3eb0ddcd$var$requestFormReset,
    D: $f69c825c3eb0ddcd$var$prefetchDNS,
    C: $f69c825c3eb0ddcd$var$preconnect,
    L: $f69c825c3eb0ddcd$var$preload,
    m: $f69c825c3eb0ddcd$var$preloadModule,
    X: $f69c825c3eb0ddcd$var$preinitScript,
    S: $f69c825c3eb0ddcd$var$preinitStyle,
    M: $f69c825c3eb0ddcd$var$preinitModuleScript
};
function $f69c825c3eb0ddcd$var$flushSyncWork() {
    var previousWasRendering = $f69c825c3eb0ddcd$var$previousDispatcher.f(), wasRendering = $f69c825c3eb0ddcd$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f69c825c3eb0ddcd$var$requestFormReset(form) {
    var formInst = $f69c825c3eb0ddcd$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f69c825c3eb0ddcd$var$requestFormReset$1(formInst) : $f69c825c3eb0ddcd$var$previousDispatcher.r(form);
}
var $f69c825c3eb0ddcd$var$globalDocument = "undefined" === typeof document ? null : document;
function $f69c825c3eb0ddcd$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f69c825c3eb0ddcd$var$preconnectsSet.has(limitedEscapedHref) || ($f69c825c3eb0ddcd$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f69c825c3eb0ddcd$var$setInitialProperties(href, "link", rel), $f69c825c3eb0ddcd$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f69c825c3eb0ddcd$var$prefetchDNS(href) {
    $f69c825c3eb0ddcd$var$previousDispatcher.D(href);
    $f69c825c3eb0ddcd$var$preconnectAs("dns-prefetch", href, null);
}
function $f69c825c3eb0ddcd$var$preconnect(href, crossOrigin) {
    $f69c825c3eb0ddcd$var$previousDispatcher.C(href, crossOrigin);
    $f69c825c3eb0ddcd$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f69c825c3eb0ddcd$var$preload(href, as, options) {
    $f69c825c3eb0ddcd$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f69c825c3eb0ddcd$var$getStyleKey(href);
                break;
            case "script":
                key = $f69c825c3eb0ddcd$var$getScriptKey(href);
        }
        $f69c825c3eb0ddcd$var$preloadPropsMap.has(key) || (href = $f69c825c3eb0ddcd$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f69c825c3eb0ddcd$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f69c825c3eb0ddcd$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f69c825c3eb0ddcd$var$setInitialProperties(as, "link", href), $f69c825c3eb0ddcd$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f69c825c3eb0ddcd$var$preloadModule(href, options) {
    $f69c825c3eb0ddcd$var$previousDispatcher.m(href, options);
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f69c825c3eb0ddcd$var$getScriptKey(href);
        }
        if (!$f69c825c3eb0ddcd$var$preloadPropsMap.has(key) && (href = $f69c825c3eb0ddcd$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f69c825c3eb0ddcd$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f69c825c3eb0ddcd$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f69c825c3eb0ddcd$var$setInitialProperties(as, "link", href);
            $f69c825c3eb0ddcd$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f69c825c3eb0ddcd$var$preinitStyle(href, precedence, options) {
    $f69c825c3eb0ddcd$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f69c825c3eb0ddcd$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f69c825c3eb0ddcd$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f69c825c3eb0ddcd$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f69c825c3eb0ddcd$var$preloadPropsMap.get(key)) && $f69c825c3eb0ddcd$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f69c825c3eb0ddcd$var$markNodeAsHoistable(link);
                $f69c825c3eb0ddcd$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f69c825c3eb0ddcd$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f69c825c3eb0ddcd$var$preinitScript(src, options) {
    $f69c825c3eb0ddcd$var$previousDispatcher.X(src, options);
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f69c825c3eb0ddcd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f69c825c3eb0ddcd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f69c825c3eb0ddcd$var$getScriptSelectorFromKey(key)), resource || (src = $f69c825c3eb0ddcd$var$assign({
            src: src,
            async: !0
        }, options), (options = $f69c825c3eb0ddcd$var$preloadPropsMap.get(key)) && $f69c825c3eb0ddcd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f69c825c3eb0ddcd$var$markNodeAsHoistable(resource), $f69c825c3eb0ddcd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f69c825c3eb0ddcd$var$preinitModuleScript(src, options) {
    $f69c825c3eb0ddcd$var$previousDispatcher.M(src, options);
    var ownerDocument = $f69c825c3eb0ddcd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f69c825c3eb0ddcd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f69c825c3eb0ddcd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f69c825c3eb0ddcd$var$getScriptSelectorFromKey(key)), resource || (src = $f69c825c3eb0ddcd$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f69c825c3eb0ddcd$var$preloadPropsMap.get(key)) && $f69c825c3eb0ddcd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f69c825c3eb0ddcd$var$markNodeAsHoistable(resource), $f69c825c3eb0ddcd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f69c825c3eb0ddcd$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f69c825c3eb0ddcd$var$rootInstanceStackCursor.current) ? $f69c825c3eb0ddcd$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f69c825c3eb0ddcd$var$getStyleKey(pendingProps.href), pendingProps = $f69c825c3eb0ddcd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f69c825c3eb0ddcd$var$getStyleKey(pendingProps.href);
                var styles$243 = $f69c825c3eb0ddcd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $f69c825c3eb0ddcd$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f69c825c3eb0ddcd$var$preloadPropsMap.set(type, pendingProps), styles$243 || $f69c825c3eb0ddcd$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f69c825c3eb0ddcd$var$getScriptKey(pendingProps), pendingProps = $f69c825c3eb0ddcd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(444, type));
    }
}
function $f69c825c3eb0ddcd$var$getStyleKey(href) {
    return 'href="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f69c825c3eb0ddcd$var$stylesheetPropsFromRawProps(rawProps) {
    return $f69c825c3eb0ddcd$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f69c825c3eb0ddcd$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f69c825c3eb0ddcd$var$setInitialProperties(key, "link", preloadProps), $f69c825c3eb0ddcd$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f69c825c3eb0ddcd$var$getScriptKey(src) {
    return '[src="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f69c825c3eb0ddcd$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f69c825c3eb0ddcd$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f69c825c3eb0ddcd$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f69c825c3eb0ddcd$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance);
            $f69c825c3eb0ddcd$var$setInitialProperties(instance, "style", styleProps);
            $f69c825c3eb0ddcd$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f69c825c3eb0ddcd$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $f69c825c3eb0ddcd$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f69c825c3eb0ddcd$var$preloadPropsMap.get(styleProps)) && $f69c825c3eb0ddcd$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f69c825c3eb0ddcd$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $f69c825c3eb0ddcd$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $f69c825c3eb0ddcd$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f69c825c3eb0ddcd$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $f69c825c3eb0ddcd$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f69c825c3eb0ddcd$var$preloadPropsMap.get(instance$249)) instance = $f69c825c3eb0ddcd$var$assign({}, props), $f69c825c3eb0ddcd$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f69c825c3eb0ddcd$var$markNodeAsHoistable(styleProps);
            $f69c825c3eb0ddcd$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f69c825c3eb0ddcd$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f69c825c3eb0ddcd$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f69c825c3eb0ddcd$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f69c825c3eb0ddcd$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f69c825c3eb0ddcd$var$tagCaches = null;
function $f69c825c3eb0ddcd$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f69c825c3eb0ddcd$var$tagCaches) {
        var cache = new Map();
        var caches = $f69c825c3eb0ddcd$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f69c825c3eb0ddcd$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f69c825c3eb0ddcd$var$internalHoistableMarker] || node[$f69c825c3eb0ddcd$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f69c825c3eb0ddcd$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f69c825c3eb0ddcd$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f69c825c3eb0ddcd$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $f69c825c3eb0ddcd$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f69c825c3eb0ddcd$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f69c825c3eb0ddcd$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f69c825c3eb0ddcd$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f69c825c3eb0ddcd$var$stylesheetPropsFromRawProps(props);
            (key = $f69c825c3eb0ddcd$var$preloadPropsMap.get(key)) && $f69c825c3eb0ddcd$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f69c825c3eb0ddcd$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f69c825c3eb0ddcd$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f69c825c3eb0ddcd$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $f69c825c3eb0ddcd$var$estimatedBytesWithinLimit = 0;
function $f69c825c3eb0ddcd$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $f69c825c3eb0ddcd$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f69c825c3eb0ddcd$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $f69c825c3eb0ddcd$var$estimatedBytesWithinLimit && ($f69c825c3eb0ddcd$var$estimatedBytesWithinLimit = 62500 * $f69c825c3eb0ddcd$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $f69c825c3eb0ddcd$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $f69c825c3eb0ddcd$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $f69c825c3eb0ddcd$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $f69c825c3eb0ddcd$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f69c825c3eb0ddcd$var$precedencesByRoot = null;
function $f69c825c3eb0ddcd$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f69c825c3eb0ddcd$var$precedencesByRoot = new Map(), resources.forEach($f69c825c3eb0ddcd$var$insertStylesheetIntoRoot, state), $f69c825c3eb0ddcd$var$precedencesByRoot = null, $f69c825c3eb0ddcd$var$onUnsuspend.call(state));
}
function $f69c825c3eb0ddcd$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f69c825c3eb0ddcd$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f69c825c3eb0ddcd$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f69c825c3eb0ddcd$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f69c825c3eb0ddcd$var$HostTransitionContext = {
    $$typeof: $f69c825c3eb0ddcd$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f69c825c3eb0ddcd$var$sharedNotPendingObject,
    _currentValue2: $f69c825c3eb0ddcd$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f69c825c3eb0ddcd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f69c825c3eb0ddcd$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f69c825c3eb0ddcd$var$createLaneMap(0);
    this.hiddenUpdates = $f69c825c3eb0ddcd$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f69c825c3eb0ddcd$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $f69c825c3eb0ddcd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f69c825c3eb0ddcd$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f69c825c3eb0ddcd$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f69c825c3eb0ddcd$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f69c825c3eb0ddcd$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f69c825c3eb0ddcd$var$emptyContextObject;
    parentComponent = $f69c825c3eb0ddcd$var$emptyContextObject;
    return parentComponent;
}
function $f69c825c3eb0ddcd$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f69c825c3eb0ddcd$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f69c825c3eb0ddcd$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f69c825c3eb0ddcd$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f69c825c3eb0ddcd$var$entangleTransitions(element, rootFiber, lane));
}
function $f69c825c3eb0ddcd$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f69c825c3eb0ddcd$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f69c825c3eb0ddcd$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f69c825c3eb0ddcd$var$markRetryLaneImpl(fiber, retryLane);
}
function $f69c825c3eb0ddcd$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f69c825c3eb0ddcd$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $f69c825c3eb0ddcd$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $f69c825c3eb0ddcd$var$requestUpdateLane();
        lane = $f69c825c3eb0ddcd$var$getBumpedLaneForHydrationByLane(lane);
        var root = $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root, fiber, lane);
        $f69c825c3eb0ddcd$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $f69c825c3eb0ddcd$var$_enabled = !0;
function $f69c825c3eb0ddcd$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
    var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    try {
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 2, $f69c825c3eb0ddcd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f69c825c3eb0ddcd$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f69c825c3eb0ddcd$var$ReactSharedInternals.T;
    $f69c825c3eb0ddcd$var$ReactSharedInternals.T = null;
    var previousPriority = $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p;
    try {
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = 8, $f69c825c3eb0ddcd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f69c825c3eb0ddcd$var$ReactDOMSharedInternals.p = previousPriority, $f69c825c3eb0ddcd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f69c825c3eb0ddcd$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f69c825c3eb0ddcd$var$_enabled) {
        var blockedOn = $f69c825c3eb0ddcd$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f69c825c3eb0ddcd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f69c825c3eb0ddcd$var$return_targetInst, targetContainer), $f69c825c3eb0ddcd$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f69c825c3eb0ddcd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f69c825c3eb0ddcd$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f69c825c3eb0ddcd$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f69c825c3eb0ddcd$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f69c825c3eb0ddcd$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f69c825c3eb0ddcd$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f69c825c3eb0ddcd$var$ensureRootIsScheduled(fiber);
                                0 === ($f69c825c3eb0ddcd$var$executionContext & 6) && ($f69c825c3eb0ddcd$var$workInProgressRootRenderTargetTime = $f69c825c3eb0ddcd$var$now() + 500, $f69c825c3eb0ddcd$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $f69c825c3eb0ddcd$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f69c825c3eb0ddcd$var$scheduleUpdateOnFiber(root, fiber, 2), $f69c825c3eb0ddcd$var$flushSyncWork$1(), $f69c825c3eb0ddcd$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f69c825c3eb0ddcd$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f69c825c3eb0ddcd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f69c825c3eb0ddcd$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f69c825c3eb0ddcd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f69c825c3eb0ddcd$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f69c825c3eb0ddcd$var$getEventTarget(nativeEvent);
    return $f69c825c3eb0ddcd$var$findInstanceBlockingTarget(nativeEvent);
}
var $f69c825c3eb0ddcd$var$return_targetInst = null;
function $f69c825c3eb0ddcd$var$findInstanceBlockingTarget(targetNode) {
    $f69c825c3eb0ddcd$var$return_targetInst = null;
    targetNode = $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f69c825c3eb0ddcd$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f69c825c3eb0ddcd$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $f69c825c3eb0ddcd$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f69c825c3eb0ddcd$var$return_targetInst = targetNode;
    return null;
}
function $f69c825c3eb0ddcd$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f69c825c3eb0ddcd$var$getCurrentPriorityLevel()){
                case $f69c825c3eb0ddcd$var$ImmediatePriority:
                    return 2;
                case $f69c825c3eb0ddcd$var$UserBlockingPriority:
                    return 8;
                case $f69c825c3eb0ddcd$var$NormalPriority$1:
                case $f69c825c3eb0ddcd$var$LowPriority:
                    return 32;
                case $f69c825c3eb0ddcd$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f69c825c3eb0ddcd$var$hasScheduledReplayAttempt = !1, $f69c825c3eb0ddcd$var$queuedFocus = null, $f69c825c3eb0ddcd$var$queuedDrag = null, $f69c825c3eb0ddcd$var$queuedMouse = null, $f69c825c3eb0ddcd$var$queuedPointers = new Map(), $f69c825c3eb0ddcd$var$queuedPointerCaptures = new Map(), $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets = [], $f69c825c3eb0ddcd$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f69c825c3eb0ddcd$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f69c825c3eb0ddcd$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f69c825c3eb0ddcd$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f69c825c3eb0ddcd$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f69c825c3eb0ddcd$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f69c825c3eb0ddcd$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f69c825c3eb0ddcd$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f69c825c3eb0ddcd$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f69c825c3eb0ddcd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f69c825c3eb0ddcd$var$queuedFocus = $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent($f69c825c3eb0ddcd$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f69c825c3eb0ddcd$var$queuedDrag = $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent($f69c825c3eb0ddcd$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f69c825c3eb0ddcd$var$queuedMouse = $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent($f69c825c3eb0ddcd$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f69c825c3eb0ddcd$var$queuedPointers.set(pointerId, $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent($f69c825c3eb0ddcd$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f69c825c3eb0ddcd$var$queuedPointerCaptures.set(pointerId, $f69c825c3eb0ddcd$var$accumulateOrCreateContinuousQueuedReplayableEvent($f69c825c3eb0ddcd$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f69c825c3eb0ddcd$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f69c825c3eb0ddcd$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f69c825c3eb0ddcd$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f69c825c3eb0ddcd$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f69c825c3eb0ddcd$var$runWithPriority(queuedTarget.priority, function() {
                        $f69c825c3eb0ddcd$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $f69c825c3eb0ddcd$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f69c825c3eb0ddcd$var$runWithPriority(queuedTarget.priority, function() {
                        $f69c825c3eb0ddcd$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f69c825c3eb0ddcd$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f69c825c3eb0ddcd$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f69c825c3eb0ddcd$var$currentReplayingEvent = null;
        } else return targetContainers = $f69c825c3eb0ddcd$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f69c825c3eb0ddcd$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f69c825c3eb0ddcd$var$replayUnblockedEvents() {
    $f69c825c3eb0ddcd$var$hasScheduledReplayAttempt = !1;
    null !== $f69c825c3eb0ddcd$var$queuedFocus && $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEvent($f69c825c3eb0ddcd$var$queuedFocus) && ($f69c825c3eb0ddcd$var$queuedFocus = null);
    null !== $f69c825c3eb0ddcd$var$queuedDrag && $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEvent($f69c825c3eb0ddcd$var$queuedDrag) && ($f69c825c3eb0ddcd$var$queuedDrag = null);
    null !== $f69c825c3eb0ddcd$var$queuedMouse && $f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEvent($f69c825c3eb0ddcd$var$queuedMouse) && ($f69c825c3eb0ddcd$var$queuedMouse = null);
    $f69c825c3eb0ddcd$var$queuedPointers.forEach($f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEventInMap);
    $f69c825c3eb0ddcd$var$queuedPointerCaptures.forEach($f69c825c3eb0ddcd$var$attemptReplayContinuousQueuedEventInMap);
}
function $f69c825c3eb0ddcd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f69c825c3eb0ddcd$var$hasScheduledReplayAttempt || ($f69c825c3eb0ddcd$var$hasScheduledReplayAttempt = !0, $3CIn6.unstable_scheduleCallback($3CIn6.unstable_NormalPriority, $f69c825c3eb0ddcd$var$replayUnblockedEvents)));
}
var $f69c825c3eb0ddcd$var$lastScheduledReplayQueue = null;
function $f69c825c3eb0ddcd$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f69c825c3eb0ddcd$var$lastScheduledReplayQueue !== formReplayingQueue && ($f69c825c3eb0ddcd$var$lastScheduledReplayQueue = formReplayingQueue, $3CIn6.unstable_scheduleCallback($3CIn6.unstable_NormalPriority, function() {
        $f69c825c3eb0ddcd$var$lastScheduledReplayQueue === formReplayingQueue && ($f69c825c3eb0ddcd$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f69c825c3eb0ddcd$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f69c825c3eb0ddcd$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f69c825c3eb0ddcd$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f69c825c3eb0ddcd$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f69c825c3eb0ddcd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f69c825c3eb0ddcd$var$queuedFocus && $f69c825c3eb0ddcd$var$scheduleCallbackIfUnblocked($f69c825c3eb0ddcd$var$queuedFocus, unblocked);
    null !== $f69c825c3eb0ddcd$var$queuedDrag && $f69c825c3eb0ddcd$var$scheduleCallbackIfUnblocked($f69c825c3eb0ddcd$var$queuedDrag, unblocked);
    null !== $f69c825c3eb0ddcd$var$queuedMouse && $f69c825c3eb0ddcd$var$scheduleCallbackIfUnblocked($f69c825c3eb0ddcd$var$queuedMouse, unblocked);
    $f69c825c3eb0ddcd$var$queuedPointers.forEach(unblock);
    $f69c825c3eb0ddcd$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets.length && (i = $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f69c825c3eb0ddcd$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f69c825c3eb0ddcd$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f69c825c3eb0ddcd$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f69c825c3eb0ddcd$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f69c825c3eb0ddcd$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f69c825c3eb0ddcd$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f69c825c3eb0ddcd$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $f69c825c3eb0ddcd$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f69c825c3eb0ddcd$var$ReactDOMHydrationRoot.prototype.render = $f69c825c3eb0ddcd$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f69c825c3eb0ddcd$var$requestUpdateLane();
    $f69c825c3eb0ddcd$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f69c825c3eb0ddcd$var$ReactDOMHydrationRoot.prototype.unmount = $f69c825c3eb0ddcd$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f69c825c3eb0ddcd$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f69c825c3eb0ddcd$var$flushSyncWork$1();
        container[$f69c825c3eb0ddcd$var$internalContainerInstanceKey] = null;
    }
};
function $f69c825c3eb0ddcd$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f69c825c3eb0ddcd$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f69c825c3eb0ddcd$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f69c825c3eb0ddcd$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f69c825c3eb0ddcd$var$attemptExplicitHydrationTarget(target);
    }
};
var $f69c825c3eb0ddcd$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $ieaan.version;
if ("19.2.7" !== $f69c825c3eb0ddcd$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(527, $f69c825c3eb0ddcd$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$f69c825c3eb0ddcd$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f69c825c3eb0ddcd$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f69c825c3eb0ddcd$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f69c825c3eb0ddcd$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f69c825c3eb0ddcd$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f69c825c3eb0ddcd$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f69c825c3eb0ddcd$var$hook$jscomp$inline_2348.isDisabled && $f69c825c3eb0ddcd$var$hook$jscomp$inline_2348.supportsFiber) try {
        $f69c825c3eb0ddcd$var$rendererID = $f69c825c3eb0ddcd$var$hook$jscomp$inline_2348.inject($f69c825c3eb0ddcd$var$internals$jscomp$inline_2347), $f69c825c3eb0ddcd$var$injectedHook = $f69c825c3eb0ddcd$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$f69c825c3eb0ddcd$export$882461b6382ed46c = function(container, options) {
    if (!$f69c825c3eb0ddcd$var$isValidContainer(container)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f69c825c3eb0ddcd$var$defaultOnUncaughtError, onCaughtError = $f69c825c3eb0ddcd$var$defaultOnCaughtError, onRecoverableError = $f69c825c3eb0ddcd$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $f69c825c3eb0ddcd$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $f69c825c3eb0ddcd$var$defaultOnDefaultTransitionIndicator);
    container[$f69c825c3eb0ddcd$var$internalContainerInstanceKey] = options.current;
    $f69c825c3eb0ddcd$var$listenToAllSupportedEvents(container);
    return new $f69c825c3eb0ddcd$var$ReactDOMRoot(options);
};
$f69c825c3eb0ddcd$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f69c825c3eb0ddcd$var$isValidContainer(container)) throw Error($f69c825c3eb0ddcd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f69c825c3eb0ddcd$var$defaultOnUncaughtError, onCaughtError = $f69c825c3eb0ddcd$var$defaultOnCaughtError, onRecoverableError = $f69c825c3eb0ddcd$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f69c825c3eb0ddcd$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $f69c825c3eb0ddcd$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $f69c825c3eb0ddcd$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f69c825c3eb0ddcd$var$requestUpdateLane();
    isStrictMode = $f69c825c3eb0ddcd$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f69c825c3eb0ddcd$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f69c825c3eb0ddcd$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f69c825c3eb0ddcd$var$markRootUpdated$1(initialChildren, options);
    $f69c825c3eb0ddcd$var$ensureRootIsScheduled(initialChildren);
    container[$f69c825c3eb0ddcd$var$internalContainerInstanceKey] = initialChildren.current;
    $f69c825c3eb0ddcd$var$listenToAllSupportedEvents(container);
    return new $f69c825c3eb0ddcd$var$ReactDOMHydrationRoot(initialChildren);
};
$f69c825c3eb0ddcd$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("3CIn6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4330W"));

});
parcelRegister("4330W", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2f29c7c8b8f767ee$export$c4744153514ff05d; }, function (v) { return $2f29c7c8b8f767ee$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2f29c7c8b8f767ee$export$3e506c1ccc9cc1a7; }, function (v) { return $2f29c7c8b8f767ee$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2f29c7c8b8f767ee$export$e26fe2ed2fa76875; }, function (v) { return $2f29c7c8b8f767ee$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2f29c7c8b8f767ee$export$502329bbf4b505b1; }, function (v) { return $2f29c7c8b8f767ee$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2f29c7c8b8f767ee$export$6e3807111c4874c4; }, function (v) { return $2f29c7c8b8f767ee$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2f29c7c8b8f767ee$export$c27134553091fb3a; }, function (v) { return $2f29c7c8b8f767ee$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2f29c7c8b8f767ee$export$33ee1acdc04fd2a2; }, function (v) { return $2f29c7c8b8f767ee$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2f29c7c8b8f767ee$export$b00a404bbd5edef2; }, function (v) { return $2f29c7c8b8f767ee$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2f29c7c8b8f767ee$export$d66a1c1c77bd778b; }, function (v) { return $2f29c7c8b8f767ee$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2f29c7c8b8f767ee$export$d3dfb8e4810cb555; }, function (v) { return $2f29c7c8b8f767ee$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2f29c7c8b8f767ee$export$72fdf0e06517287b; }, function (v) { return $2f29c7c8b8f767ee$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2f29c7c8b8f767ee$export$816d2913ae6b83b1; }, function (v) { return $2f29c7c8b8f767ee$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2f29c7c8b8f767ee$export$61bcfe829111a1d0; }, function (v) { return $2f29c7c8b8f767ee$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2f29c7c8b8f767ee$export$7ee8c9beb337bc3f; }, function (v) { return $2f29c7c8b8f767ee$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2f29c7c8b8f767ee$export$b5836b71941fa3ed; }, function (v) { return $2f29c7c8b8f767ee$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2f29c7c8b8f767ee$export$cf845f2c119da08a; }, function (v) { return $2f29c7c8b8f767ee$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2f29c7c8b8f767ee$export$c4744153514ff05d;
var $2f29c7c8b8f767ee$export$3e506c1ccc9cc1a7;
var $2f29c7c8b8f767ee$export$e26fe2ed2fa76875;
var $2f29c7c8b8f767ee$export$502329bbf4b505b1;
var $2f29c7c8b8f767ee$export$6e3807111c4874c4;
var $2f29c7c8b8f767ee$export$c27134553091fb3a;
var $2f29c7c8b8f767ee$export$33ee1acdc04fd2a2;
var $2f29c7c8b8f767ee$export$b00a404bbd5edef2;
var $2f29c7c8b8f767ee$export$d66a1c1c77bd778b;
var $2f29c7c8b8f767ee$export$d3dfb8e4810cb555;
var $2f29c7c8b8f767ee$export$72fdf0e06517287b;
var $2f29c7c8b8f767ee$export$816d2913ae6b83b1;
var $2f29c7c8b8f767ee$export$61bcfe829111a1d0;
var $2f29c7c8b8f767ee$export$7ee8c9beb337bc3f;
var $2f29c7c8b8f767ee$export$b5836b71941fa3ed;
var $2f29c7c8b8f767ee$export$cf845f2c119da08a;
"use strict";
function $2f29c7c8b8f767ee$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $2f29c7c8b8f767ee$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $2f29c7c8b8f767ee$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $2f29c7c8b8f767ee$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $2f29c7c8b8f767ee$var$compare(left, last)) rightIndex < length && 0 > $2f29c7c8b8f767ee$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $2f29c7c8b8f767ee$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $2f29c7c8b8f767ee$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$2f29c7c8b8f767ee$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2f29c7c8b8f767ee$var$localPerformance = performance;
    $2f29c7c8b8f767ee$export$c4744153514ff05d = function() {
        return $2f29c7c8b8f767ee$var$localPerformance.now();
    };
} else {
    var $2f29c7c8b8f767ee$var$localDate = Date, $2f29c7c8b8f767ee$var$initialTime = $2f29c7c8b8f767ee$var$localDate.now();
    $2f29c7c8b8f767ee$export$c4744153514ff05d = function() {
        return $2f29c7c8b8f767ee$var$localDate.now() - $2f29c7c8b8f767ee$var$initialTime;
    };
}
var $2f29c7c8b8f767ee$var$taskQueue = [], $2f29c7c8b8f767ee$var$timerQueue = [], $2f29c7c8b8f767ee$var$taskIdCounter = 1, $2f29c7c8b8f767ee$var$currentTask = null, $2f29c7c8b8f767ee$var$currentPriorityLevel = 3, $2f29c7c8b8f767ee$var$isPerformingWork = !1, $2f29c7c8b8f767ee$var$isHostCallbackScheduled = !1, $2f29c7c8b8f767ee$var$isHostTimeoutScheduled = !1, $2f29c7c8b8f767ee$var$needsPaint = !1, $2f29c7c8b8f767ee$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $2f29c7c8b8f767ee$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $2f29c7c8b8f767ee$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $2f29c7c8b8f767ee$var$advanceTimers(currentTime) {
    for(var timer = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$timerQueue); null !== timer;){
        if (null === timer.callback) $2f29c7c8b8f767ee$var$pop($2f29c7c8b8f767ee$var$timerQueue);
        else if (timer.startTime <= currentTime) $2f29c7c8b8f767ee$var$pop($2f29c7c8b8f767ee$var$timerQueue), timer.sortIndex = timer.expirationTime, $2f29c7c8b8f767ee$var$push($2f29c7c8b8f767ee$var$taskQueue, timer);
        else break;
        timer = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$timerQueue);
    }
}
function $2f29c7c8b8f767ee$var$handleTimeout(currentTime) {
    $2f29c7c8b8f767ee$var$isHostTimeoutScheduled = !1;
    $2f29c7c8b8f767ee$var$advanceTimers(currentTime);
    if (!$2f29c7c8b8f767ee$var$isHostCallbackScheduled) {
        if (null !== $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$taskQueue)) $2f29c7c8b8f767ee$var$isHostCallbackScheduled = !0, $2f29c7c8b8f767ee$var$isMessageLoopRunning || ($2f29c7c8b8f767ee$var$isMessageLoopRunning = !0, $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$timerQueue);
            null !== firstTimer && $2f29c7c8b8f767ee$var$requestHostTimeout($2f29c7c8b8f767ee$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $2f29c7c8b8f767ee$var$isMessageLoopRunning = !1, $2f29c7c8b8f767ee$var$taskTimeoutID = -1, $2f29c7c8b8f767ee$var$frameInterval = 5, $2f29c7c8b8f767ee$var$startTime = -1;
function $2f29c7c8b8f767ee$var$shouldYieldToHost() {
    return $2f29c7c8b8f767ee$var$needsPaint ? !0 : $2f29c7c8b8f767ee$export$c4744153514ff05d() - $2f29c7c8b8f767ee$var$startTime < $2f29c7c8b8f767ee$var$frameInterval ? !1 : !0;
}
function $2f29c7c8b8f767ee$var$performWorkUntilDeadline() {
    $2f29c7c8b8f767ee$var$needsPaint = !1;
    if ($2f29c7c8b8f767ee$var$isMessageLoopRunning) {
        var currentTime = $2f29c7c8b8f767ee$export$c4744153514ff05d();
        $2f29c7c8b8f767ee$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $2f29c7c8b8f767ee$var$isHostCallbackScheduled = !1;
                $2f29c7c8b8f767ee$var$isHostTimeoutScheduled && ($2f29c7c8b8f767ee$var$isHostTimeoutScheduled = !1, $2f29c7c8b8f767ee$var$localClearTimeout($2f29c7c8b8f767ee$var$taskTimeoutID), $2f29c7c8b8f767ee$var$taskTimeoutID = -1);
                $2f29c7c8b8f767ee$var$isPerformingWork = !0;
                var previousPriorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
                try {
                    b: {
                        $2f29c7c8b8f767ee$var$advanceTimers(currentTime);
                        for($2f29c7c8b8f767ee$var$currentTask = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$taskQueue); null !== $2f29c7c8b8f767ee$var$currentTask && !($2f29c7c8b8f767ee$var$currentTask.expirationTime > currentTime && $2f29c7c8b8f767ee$var$shouldYieldToHost());){
                            var callback = $2f29c7c8b8f767ee$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $2f29c7c8b8f767ee$var$currentTask.callback = null;
                                $2f29c7c8b8f767ee$var$currentPriorityLevel = $2f29c7c8b8f767ee$var$currentTask.priorityLevel;
                                var continuationCallback = callback($2f29c7c8b8f767ee$var$currentTask.expirationTime <= currentTime);
                                currentTime = $2f29c7c8b8f767ee$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $2f29c7c8b8f767ee$var$currentTask.callback = continuationCallback;
                                    $2f29c7c8b8f767ee$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $2f29c7c8b8f767ee$var$currentTask === $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$taskQueue) && $2f29c7c8b8f767ee$var$pop($2f29c7c8b8f767ee$var$taskQueue);
                                $2f29c7c8b8f767ee$var$advanceTimers(currentTime);
                            } else $2f29c7c8b8f767ee$var$pop($2f29c7c8b8f767ee$var$taskQueue);
                            $2f29c7c8b8f767ee$var$currentTask = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$taskQueue);
                        }
                        if (null !== $2f29c7c8b8f767ee$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$timerQueue);
                            null !== firstTimer && $2f29c7c8b8f767ee$var$requestHostTimeout($2f29c7c8b8f767ee$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $2f29c7c8b8f767ee$var$currentTask = null, $2f29c7c8b8f767ee$var$currentPriorityLevel = previousPriorityLevel, $2f29c7c8b8f767ee$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline() : $2f29c7c8b8f767ee$var$isMessageLoopRunning = !1;
        }
    }
}
var $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $2f29c7c8b8f767ee$var$localSetImmediate) $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline = function() {
    $2f29c7c8b8f767ee$var$localSetImmediate($2f29c7c8b8f767ee$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2f29c7c8b8f767ee$var$channel = new MessageChannel(), $2f29c7c8b8f767ee$var$port = $2f29c7c8b8f767ee$var$channel.port2;
    $2f29c7c8b8f767ee$var$channel.port1.onmessage = $2f29c7c8b8f767ee$var$performWorkUntilDeadline;
    $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline = function() {
        $2f29c7c8b8f767ee$var$port.postMessage(null);
    };
} else $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline = function() {
    $2f29c7c8b8f767ee$var$localSetTimeout($2f29c7c8b8f767ee$var$performWorkUntilDeadline, 0);
};
function $2f29c7c8b8f767ee$var$requestHostTimeout(callback, ms) {
    $2f29c7c8b8f767ee$var$taskTimeoutID = $2f29c7c8b8f767ee$var$localSetTimeout(function() {
        callback($2f29c7c8b8f767ee$export$c4744153514ff05d());
    }, ms);
}
$2f29c7c8b8f767ee$export$3e506c1ccc9cc1a7 = 5;
$2f29c7c8b8f767ee$export$e26fe2ed2fa76875 = 1;
$2f29c7c8b8f767ee$export$502329bbf4b505b1 = 4;
$2f29c7c8b8f767ee$export$6e3807111c4874c4 = 3;
$2f29c7c8b8f767ee$export$c27134553091fb3a = null;
$2f29c7c8b8f767ee$export$33ee1acdc04fd2a2 = 2;
$2f29c7c8b8f767ee$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$2f29c7c8b8f767ee$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2f29c7c8b8f767ee$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$2f29c7c8b8f767ee$export$d3dfb8e4810cb555 = function() {
    return $2f29c7c8b8f767ee$var$currentPriorityLevel;
};
$2f29c7c8b8f767ee$export$72fdf0e06517287b = function(eventHandler) {
    switch($2f29c7c8b8f767ee$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
    $2f29c7c8b8f767ee$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2f29c7c8b8f767ee$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2f29c7c8b8f767ee$export$816d2913ae6b83b1 = function() {
    $2f29c7c8b8f767ee$var$needsPaint = !0;
};
$2f29c7c8b8f767ee$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
    $2f29c7c8b8f767ee$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2f29c7c8b8f767ee$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2f29c7c8b8f767ee$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $2f29c7c8b8f767ee$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $2f29c7c8b8f767ee$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $2f29c7c8b8f767ee$var$push($2f29c7c8b8f767ee$var$timerQueue, priorityLevel), null === $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$taskQueue) && priorityLevel === $2f29c7c8b8f767ee$var$peek($2f29c7c8b8f767ee$var$timerQueue) && ($2f29c7c8b8f767ee$var$isHostTimeoutScheduled ? ($2f29c7c8b8f767ee$var$localClearTimeout($2f29c7c8b8f767ee$var$taskTimeoutID), $2f29c7c8b8f767ee$var$taskTimeoutID = -1) : $2f29c7c8b8f767ee$var$isHostTimeoutScheduled = !0, $2f29c7c8b8f767ee$var$requestHostTimeout($2f29c7c8b8f767ee$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $2f29c7c8b8f767ee$var$push($2f29c7c8b8f767ee$var$taskQueue, priorityLevel), $2f29c7c8b8f767ee$var$isHostCallbackScheduled || $2f29c7c8b8f767ee$var$isPerformingWork || ($2f29c7c8b8f767ee$var$isHostCallbackScheduled = !0, $2f29c7c8b8f767ee$var$isMessageLoopRunning || ($2f29c7c8b8f767ee$var$isMessageLoopRunning = !0, $2f29c7c8b8f767ee$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$2f29c7c8b8f767ee$export$b5836b71941fa3ed = $2f29c7c8b8f767ee$var$shouldYieldToHost;
$2f29c7c8b8f767ee$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $2f29c7c8b8f767ee$var$currentPriorityLevel;
        $2f29c7c8b8f767ee$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $2f29c7c8b8f767ee$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ieaan", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eIZlp"));

});

parcelRegister("ie2rr", function(module, exports) {
'use strict';
function $d44b6dac8b4642ae$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d44b6dac8b4642ae$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d44b6dac8b4642ae$var$checkDCE();

module.exports = (parcelRequire("4TjIR"));

});
parcelRegister("4TjIR", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $38fb98f1891c8c5b$export$69ce8ef3fe5cead0; }, function (v) { return $38fb98f1891c8c5b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $38fb98f1891c8c5b$export$d39a5bbd09211389; }, function (v) { return $38fb98f1891c8c5b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $38fb98f1891c8c5b$export$cd75ccfd720a3cd4; }, function (v) { return $38fb98f1891c8c5b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $38fb98f1891c8c5b$export$a0816fa17a9e79be; }, function (v) { return $38fb98f1891c8c5b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $38fb98f1891c8c5b$export$7292efcadded39f3; }, function (v) { return $38fb98f1891c8c5b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $38fb98f1891c8c5b$export$da407abadb9b8f86; }, function (v) { return $38fb98f1891c8c5b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $38fb98f1891c8c5b$export$314cfea32580671c; }, function (v) { return $38fb98f1891c8c5b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $38fb98f1891c8c5b$export$513ccb98c53b8039; }, function (v) { return $38fb98f1891c8c5b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $38fb98f1891c8c5b$export$dbca993bc2d264a; }, function (v) { return $38fb98f1891c8c5b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $38fb98f1891c8c5b$export$4797a8006f0655d0; }, function (v) { return $38fb98f1891c8c5b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $38fb98f1891c8c5b$export$c78a37762a8d58e1; }, function (v) { return $38fb98f1891c8c5b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $38fb98f1891c8c5b$export$606f11b2eb45ecc6; }, function (v) { return $38fb98f1891c8c5b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $38fb98f1891c8c5b$export$f7e8a0bf92324b1e; }, function (v) { return $38fb98f1891c8c5b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $38fb98f1891c8c5b$export$83d89fbfd8236492; }, function (v) { return $38fb98f1891c8c5b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38fb98f1891c8c5b$export$69ce8ef3fe5cead0;
var $38fb98f1891c8c5b$export$d39a5bbd09211389;
var $38fb98f1891c8c5b$export$cd75ccfd720a3cd4;
var $38fb98f1891c8c5b$export$a0816fa17a9e79be;
var $38fb98f1891c8c5b$export$7292efcadded39f3;
var $38fb98f1891c8c5b$export$da407abadb9b8f86;
var $38fb98f1891c8c5b$export$314cfea32580671c;
var $38fb98f1891c8c5b$export$513ccb98c53b8039;
var $38fb98f1891c8c5b$export$dbca993bc2d264a;
var $38fb98f1891c8c5b$export$4797a8006f0655d0;
var $38fb98f1891c8c5b$export$c78a37762a8d58e1;
var $38fb98f1891c8c5b$export$606f11b2eb45ecc6;
var $38fb98f1891c8c5b$export$f7e8a0bf92324b1e;
var $38fb98f1891c8c5b$export$83d89fbfd8236492;
"use strict";

var $ieaan = parcelRequire("ieaan");
function $38fb98f1891c8c5b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $38fb98f1891c8c5b$var$noop() {}
var $38fb98f1891c8c5b$var$Internals = {
    d: {
        f: $38fb98f1891c8c5b$var$noop,
        r: function() {
            throw Error($38fb98f1891c8c5b$var$formatProdErrorMessage(522));
        },
        D: $38fb98f1891c8c5b$var$noop,
        C: $38fb98f1891c8c5b$var$noop,
        L: $38fb98f1891c8c5b$var$noop,
        m: $38fb98f1891c8c5b$var$noop,
        X: $38fb98f1891c8c5b$var$noop,
        S: $38fb98f1891c8c5b$var$noop,
        M: $38fb98f1891c8c5b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $38fb98f1891c8c5b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $38fb98f1891c8c5b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $38fb98f1891c8c5b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $38fb98f1891c8c5b$var$ReactSharedInternals = $ieaan.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $38fb98f1891c8c5b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$38fb98f1891c8c5b$export$69ce8ef3fe5cead0 = $38fb98f1891c8c5b$var$Internals;
$38fb98f1891c8c5b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($38fb98f1891c8c5b$var$formatProdErrorMessage(299));
    return $38fb98f1891c8c5b$var$createPortal$1(children, container, null, key);
};
$38fb98f1891c8c5b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $38fb98f1891c8c5b$var$ReactSharedInternals.T, previousUpdatePriority = $38fb98f1891c8c5b$var$Internals.p;
    try {
        if ($38fb98f1891c8c5b$var$ReactSharedInternals.T = null, $38fb98f1891c8c5b$var$Internals.p = 2, fn) return fn();
    } finally{
        $38fb98f1891c8c5b$var$ReactSharedInternals.T = previousTransition, $38fb98f1891c8c5b$var$Internals.p = previousUpdatePriority, $38fb98f1891c8c5b$var$Internals.d.f();
    }
};
$38fb98f1891c8c5b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $38fb98f1891c8c5b$var$Internals.d.C(href, options));
};
$38fb98f1891c8c5b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $38fb98f1891c8c5b$var$Internals.d.D(href);
};
$38fb98f1891c8c5b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $38fb98f1891c8c5b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $38fb98f1891c8c5b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $38fb98f1891c8c5b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$38fb98f1891c8c5b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $38fb98f1891c8c5b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $38fb98f1891c8c5b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $38fb98f1891c8c5b$var$Internals.d.M(href);
    }
};
$38fb98f1891c8c5b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $38fb98f1891c8c5b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $38fb98f1891c8c5b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$38fb98f1891c8c5b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $38fb98f1891c8c5b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $38fb98f1891c8c5b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $38fb98f1891c8c5b$var$Internals.d.m(href);
    }
};
$38fb98f1891c8c5b$export$4797a8006f0655d0 = function(form) {
    $38fb98f1891c8c5b$var$Internals.d.r(form);
};
$38fb98f1891c8c5b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$38fb98f1891c8c5b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $38fb98f1891c8c5b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$38fb98f1891c8c5b$export$f7e8a0bf92324b1e = function() {
    return $38fb98f1891c8c5b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$38fb98f1891c8c5b$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("iW5Se", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iKorB = parcelRequire("iKorB");
function $dc92333199a3d655$var$emptyFunction() {}
function $dc92333199a3d655$var$emptyFunctionWithReset() {}
$dc92333199a3d655$var$emptyFunctionWithReset.resetWarningCache = $dc92333199a3d655$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iKorB) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $dc92333199a3d655$var$emptyFunctionWithReset,
        resetWarningCache: $dc92333199a3d655$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iKorB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $da5f7bf9332d10da$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $da5f7bf9332d10da$var$ReactPropTypesSecret;

});


parcelRegister("2EWYt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $1efd1045b3a23add$export$306c0aa65ff9ec16; }, function (v) { return $1efd1045b3a23add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1efd1045b3a23add$export$306c0aa65ff9ec16;
"use strict";

var $ieaan = parcelRequire("ieaan");
function $1efd1045b3a23add$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $1efd1045b3a23add$var$objectIs = "function" === typeof Object.is ? Object.is : $1efd1045b3a23add$var$is, $1efd1045b3a23add$var$useState = $ieaan.useState, $1efd1045b3a23add$var$useEffect = $ieaan.useEffect, $1efd1045b3a23add$var$useLayoutEffect = $ieaan.useLayoutEffect, $1efd1045b3a23add$var$useDebugValue = $ieaan.useDebugValue;
function $1efd1045b3a23add$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $1efd1045b3a23add$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $1efd1045b3a23add$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $1efd1045b3a23add$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $1efd1045b3a23add$var$useEffect(function() {
        $1efd1045b3a23add$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $1efd1045b3a23add$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $1efd1045b3a23add$var$useDebugValue(value);
    return value;
}
function $1efd1045b3a23add$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$1efd1045b3a23add$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $1efd1045b3a23add$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $1efd1045b3a23add$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $1efd1045b3a23add$var$useSyncExternalStore$1 : $1efd1045b3a23add$var$useSyncExternalStore$2;
$1efd1045b3a23add$export$306c0aa65ff9ec16 = void 0 !== $ieaan.useSyncExternalStore ? $ieaan.useSyncExternalStore : $1efd1045b3a23add$var$shim;

});

var $b6287168c78e78f5$exports = {};
$parcel$extendImportMap({
    "dEznS": "custom_dnb_loading.fd10336f.svg",
    "3ehqk": "custom_dnb_calendar.5c698514.svg"
});

var $60739c7e3f826d8d$exports = {};
'use strict';

$60739c7e3f826d8d$exports = (parcelRequire("ekkyY"));


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';


if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behavior.
    (parcelRequire("jofHE")).enable();
    self.Promise = (parcelRequire("b0WhD"));
}

// Make sure we're in a Browser-like environment before importing polyfills
// This prevents `fetch()` from being imported in a Node test environment
if (typeof window !== 'undefined') // fetch() polyfill for making API calls.
(parcelRequire("aZEZV"));

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = (parcelRequire("cbYl1"));
var $95671b6a94937336$exports = {};
'use strict';

$95671b6a94937336$exports = (parcelRequire("7h4ZC"));


var $93c028943c528744$exports = {};
'use strict';

$93c028943c528744$exports = (parcelRequire("3MGWX"));





var $ieaan = parcelRequire("ieaan");
var $c75051cfa147f10e$exports = {};
'use strict';
function $c75051cfa147f10e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c75051cfa147f10e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c75051cfa147f10e$var$checkDCE();

$c75051cfa147f10e$exports = (parcelRequire("laHNN"));



parcelRequire("ieaan");
/**
 * react-router v7.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $ieaan = parcelRequire("ieaan");
var $5c8711a28b8203dd$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-4ZMWKKQ3.mjs"
});
var $5c8711a28b8203dd$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $5c8711a28b8203dd$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $5c8711a28b8203dd$var$__typeError("Cannot " + msg);
var $5c8711a28b8203dd$var$__privateGet = (obj, member, getter)=>($5c8711a28b8203dd$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $5c8711a28b8203dd$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $5c8711a28b8203dd$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $5c8711a28b8203dd$var$__privateSet = (obj, member, value, setter)=>($5c8711a28b8203dd$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $5c8711a28b8203dd$export$825a82322d91916e = /^[\\/]{2}/;
function $5c8711a28b8203dd$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $5c8711a28b8203dd$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($5c8711a28b8203dd$export$e19cd5f9376f8cee || {});
var $5c8711a28b8203dd$var$PopStateEventType = "popstate";
function $5c8711a28b8203dd$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $5c8711a28b8203dd$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $5c8711a28b8203dd$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $5c8711a28b8203dd$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $5c8711a28b8203dd$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $5c8711a28b8203dd$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $5c8711a28b8203dd$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $5c8711a28b8203dd$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to);
    }
    return $5c8711a28b8203dd$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $5c8711a28b8203dd$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5c8711a28b8203dd$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5c8711a28b8203dd$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5c8711a28b8203dd$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $5c8711a28b8203dd$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5c8711a28b8203dd$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5c8711a28b8203dd$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $5c8711a28b8203dd$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $5c8711a28b8203dd$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $5c8711a28b8203dd$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5c8711a28b8203dd$var$createKey(),
        mask: mask
    };
    return location;
}
function $5c8711a28b8203dd$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $5c8711a28b8203dd$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5c8711a28b8203dd$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $5c8711a28b8203dd$var$isLocation(to) ? to : $5c8711a28b8203dd$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5c8711a28b8203dd$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $5c8711a28b8203dd$var$isLocation(to) ? to : $5c8711a28b8203dd$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5c8711a28b8203dd$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $5c8711a28b8203dd$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($5c8711a28b8203dd$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($5c8711a28b8203dd$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $5c8711a28b8203dd$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $5c8711a28b8203dd$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $5c8711a28b8203dd$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $5c8711a28b8203dd$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $5c8711a28b8203dd$var$_map;
var $5c8711a28b8203dd$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $5c8711a28b8203dd$var$__privateAdd(this, $5c8711a28b8203dd$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_map).has(context)) return $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_map).set(context, value);
    }
};
$5c8711a28b8203dd$var$_map = new WeakMap();
var $5c8711a28b8203dd$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5c8711a28b8203dd$var$isUnsupportedLazyRouteObjectKey(key) {
    return $5c8711a28b8203dd$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $5c8711a28b8203dd$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $5c8711a28b8203dd$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $5c8711a28b8203dd$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $5c8711a28b8203dd$var$isIndexRoute(route) {
    return route.index === true;
}
function $5c8711a28b8203dd$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5c8711a28b8203dd$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $5c8711a28b8203dd$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($5c8711a28b8203dd$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $5c8711a28b8203dd$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $5c8711a28b8203dd$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $5c8711a28b8203dd$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $5c8711a28b8203dd$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $5c8711a28b8203dd$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $5c8711a28b8203dd$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $5c8711a28b8203dd$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5c8711a28b8203dd$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $5c8711a28b8203dd$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $5c8711a28b8203dd$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $5c8711a28b8203dd$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $5c8711a28b8203dd$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $5c8711a28b8203dd$var$flattenAndRankRoutes(routes) {
    let branches = $5c8711a28b8203dd$var$flattenRoutes(routes);
    $5c8711a28b8203dd$var$rankRouteBranches(branches);
    return branches;
}
function $5c8711a28b8203dd$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $5c8711a28b8203dd$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5c8711a28b8203dd$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $5c8711a28b8203dd$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $5c8711a28b8203dd$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5c8711a28b8203dd$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $5c8711a28b8203dd$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $5c8711a28b8203dd$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $5c8711a28b8203dd$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5c8711a28b8203dd$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5c8711a28b8203dd$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $5c8711a28b8203dd$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $5c8711a28b8203dd$var$paramRe = /^:[\w-]+$/;
var $5c8711a28b8203dd$var$dynamicSegmentValue = 3;
var $5c8711a28b8203dd$var$indexRouteValue = 2;
var $5c8711a28b8203dd$var$emptySegmentValue = 1;
var $5c8711a28b8203dd$var$staticSegmentValue = 10;
var $5c8711a28b8203dd$var$splatPenalty = -2;
var $5c8711a28b8203dd$var$isSplat = (s)=>s === "*";
function $5c8711a28b8203dd$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5c8711a28b8203dd$var$isSplat)) initialScore += $5c8711a28b8203dd$var$splatPenalty;
    if (index) initialScore += $5c8711a28b8203dd$var$indexRouteValue;
    return segments.filter((s)=>!$5c8711a28b8203dd$var$isSplat(s)).reduce((score, segment)=>score + ($5c8711a28b8203dd$var$paramRe.test(segment) ? $5c8711a28b8203dd$var$dynamicSegmentValue : segment === "" ? $5c8711a28b8203dd$var$emptySegmentValue : $5c8711a28b8203dd$var$staticSegmentValue), initialScore);
}
function $5c8711a28b8203dd$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5c8711a28b8203dd$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $5c8711a28b8203dd$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $5c8711a28b8203dd$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5c8711a28b8203dd$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5c8711a28b8203dd$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5c8711a28b8203dd$var$normalizePathname($5c8711a28b8203dd$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5c8711a28b8203dd$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $5c8711a28b8203dd$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5c8711a28b8203dd$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $5c8711a28b8203dd$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $5c8711a28b8203dd$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5c8711a28b8203dd$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $5c8711a28b8203dd$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $5c8711a28b8203dd$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5c8711a28b8203dd$var$compilePath(path, caseSensitive = false, end = true) {
    $5c8711a28b8203dd$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $5c8711a28b8203dd$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5c8711a28b8203dd$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $5c8711a28b8203dd$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $5c8711a28b8203dd$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $5c8711a28b8203dd$var$joinPaths([
        basename,
        pathname
    ]);
}
var $5c8711a28b8203dd$var$isAbsoluteUrl = (url)=>$5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX.test(url);
function $5c8711a28b8203dd$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $5c8711a28b8203dd$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $5c8711a28b8203dd$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $5c8711a28b8203dd$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $5c8711a28b8203dd$var$normalizeSearch(search),
        hash: $5c8711a28b8203dd$var$normalizeHash(hash)
    };
}
function $5c8711a28b8203dd$var$resolvePathname(relativePath, fromPathname) {
    let segments = $5c8711a28b8203dd$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5c8711a28b8203dd$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $5c8711a28b8203dd$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $5c8711a28b8203dd$var$getResolveToMatches(matches) {
    let pathMatches = $5c8711a28b8203dd$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $5c8711a28b8203dd$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $5c8711a28b8203dd$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $5c8711a28b8203dd$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $5c8711a28b8203dd$var$getInvalidPathError("?", "pathname", "search", to));
        $5c8711a28b8203dd$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $5c8711a28b8203dd$var$getInvalidPathError("#", "pathname", "hash", to));
        $5c8711a28b8203dd$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $5c8711a28b8203dd$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5c8711a28b8203dd$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $5c8711a28b8203dd$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $5c8711a28b8203dd$var$joinPaths = (paths)=>$5c8711a28b8203dd$var$removeDoubleSlashes(paths.join("/"));
var $5c8711a28b8203dd$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $5c8711a28b8203dd$var$normalizePathname = (pathname)=>$5c8711a28b8203dd$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $5c8711a28b8203dd$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $5c8711a28b8203dd$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $5c8711a28b8203dd$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $5c8711a28b8203dd$export$4051a07651545597(data2, init) {
    return new $5c8711a28b8203dd$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $5c8711a28b8203dd$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $5c8711a28b8203dd$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5c8711a28b8203dd$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $5c8711a28b8203dd$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5c8711a28b8203dd$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $5c8711a28b8203dd$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $5c8711a28b8203dd$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $5c8711a28b8203dd$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $5c8711a28b8203dd$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $5c8711a28b8203dd$var$joinPaths(parts) || "/";
}
var $5c8711a28b8203dd$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $5c8711a28b8203dd$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($5c8711a28b8203dd$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $5c8711a28b8203dd$export$825a82322d91916e.test(to) ? new URL($5c8711a28b8203dd$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $5c8711a28b8203dd$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $5c8711a28b8203dd$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $5c8711a28b8203dd$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $5c8711a28b8203dd$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $5c8711a28b8203dd$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $5c8711a28b8203dd$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$5c8711a28b8203dd$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $5c8711a28b8203dd$var$wrapImpl(aggregated[key], original, (...args)=>$5c8711a28b8203dd$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$5c8711a28b8203dd$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$5c8711a28b8203dd$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $5c8711a28b8203dd$var$wrapImpl(aggregated.middleware, original, (...args)=>$5c8711a28b8203dd$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$5c8711a28b8203dd$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $5c8711a28b8203dd$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$5c8711a28b8203dd$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $5c8711a28b8203dd$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $5c8711a28b8203dd$export$fe53371bee54353d(to) : ".",
                ...$5c8711a28b8203dd$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$5c8711a28b8203dd$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$5c8711a28b8203dd$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $5c8711a28b8203dd$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$5c8711a28b8203dd$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$5c8711a28b8203dd$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $5c8711a28b8203dd$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $5c8711a28b8203dd$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $5c8711a28b8203dd$var$getReadonlyRequest(request),
            context: context != null ? $5c8711a28b8203dd$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $5c8711a28b8203dd$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $5c8711a28b8203dd$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $5c8711a28b8203dd$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $5c8711a28b8203dd$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $5c8711a28b8203dd$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $5c8711a28b8203dd$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $5c8711a28b8203dd$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $5c8711a28b8203dd$var$getReadonlyContext(context)
    };
}
function $5c8711a28b8203dd$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $5c8711a28b8203dd$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $5c8711a28b8203dd$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $5c8711a28b8203dd$var$getReadonlyContext(context) {
    if ($5c8711a28b8203dd$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $5c8711a28b8203dd$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5c8711a28b8203dd$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5c8711a28b8203dd$var$objectProtoNames;
}
// lib/router/router.ts
var $5c8711a28b8203dd$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $5c8711a28b8203dd$var$validMutationMethods = new Set($5c8711a28b8203dd$var$validMutationMethodsArr);
var $5c8711a28b8203dd$var$validRequestMethodsArr = [
    "GET",
    ...$5c8711a28b8203dd$var$validMutationMethodsArr
];
var $5c8711a28b8203dd$var$validRequestMethods = new Set($5c8711a28b8203dd$var$validRequestMethodsArr);
var $5c8711a28b8203dd$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $5c8711a28b8203dd$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $5c8711a28b8203dd$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5c8711a28b8203dd$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5c8711a28b8203dd$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $5c8711a28b8203dd$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $5c8711a28b8203dd$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $5c8711a28b8203dd$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $5c8711a28b8203dd$var$_routes, $5c8711a28b8203dd$var$_branches, $5c8711a28b8203dd$var$_hmrRoutes, $5c8711a28b8203dd$var$_hmrBranches;
var $5c8711a28b8203dd$var$DataRoutes = class {
    constructor(routes){
        $5c8711a28b8203dd$var$__privateAdd(this, $5c8711a28b8203dd$var$_routes);
        $5c8711a28b8203dd$var$__privateAdd(this, $5c8711a28b8203dd$var$_branches);
        $5c8711a28b8203dd$var$__privateAdd(this, $5c8711a28b8203dd$var$_hmrRoutes);
        $5c8711a28b8203dd$var$__privateAdd(this, $5c8711a28b8203dd$var$_hmrBranches);
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_routes, routes);
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_branches, $5c8711a28b8203dd$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrRoutes) ?? $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrBranches) ?? $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_branches);
    }
    get hasHMRRoutes() {
        return $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_routes, routes);
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_branches, $5c8711a28b8203dd$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_hmrRoutes, routes);
        $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_hmrBranches, $5c8711a28b8203dd$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrRoutes)) {
            $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_routes, $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrRoutes));
            $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_branches, $5c8711a28b8203dd$var$__privateGet(this, $5c8711a28b8203dd$var$_hmrBranches));
            $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_hmrRoutes, void 0);
            $5c8711a28b8203dd$var$__privateSet(this, $5c8711a28b8203dd$var$_hmrBranches, void 0);
        }
    }
};
$5c8711a28b8203dd$var$_routes = new WeakMap();
$5c8711a28b8203dd$var$_branches = new WeakMap();
$5c8711a28b8203dd$var$_hmrRoutes = new WeakMap();
$5c8711a28b8203dd$var$_hmrBranches = new WeakMap();
function $5c8711a28b8203dd$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $5c8711a28b8203dd$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $5c8711a28b8203dd$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5c8711a28b8203dd$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $5c8711a28b8203dd$var$DataRoutes($5c8711a28b8203dd$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $5c8711a28b8203dd$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $5c8711a28b8203dd$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$5c8711a28b8203dd$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $5c8711a28b8203dd$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $5c8711a28b8203dd$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $5c8711a28b8203dd$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5c8711a28b8203dd$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $5c8711a28b8203dd$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5c8711a28b8203dd$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5c8711a28b8203dd$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $5c8711a28b8203dd$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5c8711a28b8203dd$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5c8711a28b8203dd$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $5c8711a28b8203dd$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $5c8711a28b8203dd$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $5c8711a28b8203dd$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $5c8711a28b8203dd$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $5c8711a28b8203dd$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $5c8711a28b8203dd$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5c8711a28b8203dd$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $5c8711a28b8203dd$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $5c8711a28b8203dd$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5c8711a28b8203dd$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $5c8711a28b8203dd$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $5c8711a28b8203dd$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $5c8711a28b8203dd$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5c8711a28b8203dd$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5c8711a28b8203dd$var$isErrorResult(result) && $5c8711a28b8203dd$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5c8711a28b8203dd$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $5c8711a28b8203dd$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$5c8711a28b8203dd$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $5c8711a28b8203dd$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $5c8711a28b8203dd$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $5c8711a28b8203dd$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $5c8711a28b8203dd$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5c8711a28b8203dd$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $5c8711a28b8203dd$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($5c8711a28b8203dd$var$isErrorResult(result)) {
            let boundaryMatch = $5c8711a28b8203dd$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $5c8711a28b8203dd$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $5c8711a28b8203dd$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $5c8711a28b8203dd$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5c8711a28b8203dd$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$5c8711a28b8203dd$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $5c8711a28b8203dd$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $5c8711a28b8203dd$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $5c8711a28b8203dd$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $5c8711a28b8203dd$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $5c8711a28b8203dd$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5c8711a28b8203dd$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5c8711a28b8203dd$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $5c8711a28b8203dd$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5c8711a28b8203dd$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5c8711a28b8203dd$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5c8711a28b8203dd$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5c8711a28b8203dd$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $5c8711a28b8203dd$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $5c8711a28b8203dd$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($5c8711a28b8203dd$var$isRedirectResult(actionResult) || $5c8711a28b8203dd$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($5c8711a28b8203dd$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5c8711a28b8203dd$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($5c8711a28b8203dd$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5c8711a28b8203dd$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $5c8711a28b8203dd$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5c8711a28b8203dd$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $5c8711a28b8203dd$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $5c8711a28b8203dd$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $5c8711a28b8203dd$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $5c8711a28b8203dd$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $5c8711a28b8203dd$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $5c8711a28b8203dd$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $5c8711a28b8203dd$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5c8711a28b8203dd$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $5c8711a28b8203dd$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5c8711a28b8203dd$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5c8711a28b8203dd$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5c8711a28b8203dd$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $5c8711a28b8203dd$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(void 0));
            return;
        }
        if ($5c8711a28b8203dd$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($5c8711a28b8203dd$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $5c8711a28b8203dd$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $5c8711a28b8203dd$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $5c8711a28b8203dd$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($5c8711a28b8203dd$var$isAbsoluteUrl(location)) {
                const url = $5c8711a28b8203dd$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5c8711a28b8203dd$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5c8711a28b8203dd$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($5c8711a28b8203dd$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $5c8711a28b8203dd$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $5c8711a28b8203dd$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5c8711a28b8203dd$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$5c8711a28b8203dd$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($5c8711a28b8203dd$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $5c8711a28b8203dd$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $5c8711a28b8203dd$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $5c8711a28b8203dd$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $5c8711a28b8203dd$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $5c8711a28b8203dd$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $5c8711a28b8203dd$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $5c8711a28b8203dd$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $5c8711a28b8203dd$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $5c8711a28b8203dd$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $5c8711a28b8203dd$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5c8711a28b8203dd$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5c8711a28b8203dd$export$386d57f03f0b2883;
        $5c8711a28b8203dd$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $5c8711a28b8203dd$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5c8711a28b8203dd$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $5c8711a28b8203dd$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$5c8711a28b8203dd$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5c8711a28b8203dd$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($5c8711a28b8203dd$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $5c8711a28b8203dd$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $5c8711a28b8203dd$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $5c8711a28b8203dd$export$3336b097a6fbc59a(routes, opts) {
    $5c8711a28b8203dd$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $5c8711a28b8203dd$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5c8711a28b8203dd$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $5c8711a28b8203dd$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $5c8711a28b8203dd$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $5c8711a28b8203dd$var$defaultNormalizePath;
        let method = request.method;
        let location = $5c8711a28b8203dd$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $5c8711a28b8203dd$export$b8d3e69d4b3eff04();
        if (!$5c8711a28b8203dd$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5c8711a28b8203dd$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $5c8711a28b8203dd$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5c8711a28b8203dd$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $5c8711a28b8203dd$export$f5708dca728d7177(requestContext instanceof $5c8711a28b8203dd$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $5c8711a28b8203dd$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $5c8711a28b8203dd$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $5c8711a28b8203dd$var$createDataFunctionUrl(request, location),
                    pattern: $5c8711a28b8203dd$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($5c8711a28b8203dd$export$6e80290866a84dd4(error)) return error;
                    if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $5c8711a28b8203dd$export$f2680fa305b734ca(error.status, error.statusText, await $5c8711a28b8203dd$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($5c8711a28b8203dd$export$e0163cfdf7bc9cfa(error)) error = $5c8711a28b8203dd$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $5c8711a28b8203dd$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $5c8711a28b8203dd$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $5c8711a28b8203dd$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $5c8711a28b8203dd$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $5c8711a28b8203dd$var$defaultNormalizePath;
        let method = request.method;
        let location = $5c8711a28b8203dd$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $5c8711a28b8203dd$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $5c8711a28b8203dd$export$b8d3e69d4b3eff04();
        if (!$5c8711a28b8203dd$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5c8711a28b8203dd$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5c8711a28b8203dd$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5c8711a28b8203dd$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5c8711a28b8203dd$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $5c8711a28b8203dd$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $5c8711a28b8203dd$export$f5708dca728d7177(requestContext instanceof $5c8711a28b8203dd$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $5c8711a28b8203dd$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $5c8711a28b8203dd$var$runServerMiddlewarePipeline({
                request: request,
                url: $5c8711a28b8203dd$var$createDataFunctionUrl(request, location),
                pattern: $5c8711a28b8203dd$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($5c8711a28b8203dd$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($5c8711a28b8203dd$var$dataWithResponseInitToResponse(error));
                if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $5c8711a28b8203dd$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5c8711a28b8203dd$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $5c8711a28b8203dd$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($5c8711a28b8203dd$var$isDataStrategyResult(e) && $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($5c8711a28b8203dd$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5c8711a28b8203dd$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5c8711a28b8203dd$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($5c8711a28b8203dd$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($5c8711a28b8203dd$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($5c8711a28b8203dd$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5c8711a28b8203dd$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $5c8711a28b8203dd$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5c8711a28b8203dd$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5c8711a28b8203dd$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $5c8711a28b8203dd$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $5c8711a28b8203dd$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $5c8711a28b8203dd$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5c8711a28b8203dd$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $5c8711a28b8203dd$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5c8711a28b8203dd$var$callDataStrategyImpl(dataStrategy || $5c8711a28b8203dd$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5c8711a28b8203dd$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $5c8711a28b8203dd$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($5c8711a28b8203dd$export$e0163cfdf7bc9cfa(result.result)) throw $5c8711a28b8203dd$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $5c8711a28b8203dd$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $5c8711a28b8203dd$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $5c8711a28b8203dd$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $5c8711a28b8203dd$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $5c8711a28b8203dd$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $5c8711a28b8203dd$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $5c8711a28b8203dd$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $5c8711a28b8203dd$var$resolveTo(to ? to : ".", $5c8711a28b8203dd$var$getResolveToMatches(contextualMatches), $5c8711a28b8203dd$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5c8711a28b8203dd$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $5c8711a28b8203dd$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $5c8711a28b8203dd$export$fe53371bee54353d(path);
}
function $5c8711a28b8203dd$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$5c8711a28b8203dd$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5c8711a28b8203dd$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5c8711a28b8203dd$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5c8711a28b8203dd$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $5c8711a28b8203dd$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$5c8711a28b8203dd$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$5c8711a28b8203dd$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5c8711a28b8203dd$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5c8711a28b8203dd$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5c8711a28b8203dd$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5c8711a28b8203dd$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5c8711a28b8203dd$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($5c8711a28b8203dd$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $5c8711a28b8203dd$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $5c8711a28b8203dd$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $5c8711a28b8203dd$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $5c8711a28b8203dd$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $5c8711a28b8203dd$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$5c8711a28b8203dd$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $5c8711a28b8203dd$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($5c8711a28b8203dd$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($5c8711a28b8203dd$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $5c8711a28b8203dd$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $5c8711a28b8203dd$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $5c8711a28b8203dd$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $5c8711a28b8203dd$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($5c8711a28b8203dd$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $5c8711a28b8203dd$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $5c8711a28b8203dd$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$5c8711a28b8203dd$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $5c8711a28b8203dd$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $5c8711a28b8203dd$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5c8711a28b8203dd$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5c8711a28b8203dd$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5c8711a28b8203dd$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$5c8711a28b8203dd$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $5c8711a28b8203dd$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $5c8711a28b8203dd$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $5c8711a28b8203dd$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$5c8711a28b8203dd$var$isSameRoute(aChild, bChild))) ?? false;
}
var $5c8711a28b8203dd$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $5c8711a28b8203dd$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $5c8711a28b8203dd$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $5c8711a28b8203dd$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $5c8711a28b8203dd$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $5c8711a28b8203dd$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $5c8711a28b8203dd$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $5c8711a28b8203dd$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $5c8711a28b8203dd$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $5c8711a28b8203dd$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $5c8711a28b8203dd$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $5c8711a28b8203dd$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $5c8711a28b8203dd$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $5c8711a28b8203dd$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $5c8711a28b8203dd$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $5c8711a28b8203dd$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $5c8711a28b8203dd$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $5c8711a28b8203dd$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $5c8711a28b8203dd$var$isNonNullable(value) {
    return value !== void 0;
}
function $5c8711a28b8203dd$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $5c8711a28b8203dd$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($5c8711a28b8203dd$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $5c8711a28b8203dd$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $5c8711a28b8203dd$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $5c8711a28b8203dd$var$defaultDataStrategy(args);
    return $5c8711a28b8203dd$var$runClientMiddlewarePipeline(args, ()=>$5c8711a28b8203dd$var$defaultDataStrategy(args));
}
function $5c8711a28b8203dd$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $5c8711a28b8203dd$var$runMiddlewarePipeline(args, handler, processResult, $5c8711a28b8203dd$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $5c8711a28b8203dd$export$e0163cfdf7bc9cfa(result) ? $5c8711a28b8203dd$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $5c8711a28b8203dd$var$runClientMiddlewarePipeline(args, handler) {
    return $5c8711a28b8203dd$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($5c8711a28b8203dd$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $5c8711a28b8203dd$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $5c8711a28b8203dd$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $5c8711a28b8203dd$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $5c8711a28b8203dd$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $5c8711a28b8203dd$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $5c8711a28b8203dd$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $5c8711a28b8203dd$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $5c8711a28b8203dd$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $5c8711a28b8203dd$var$loadLazyRoute(match.route, $5c8711a28b8203dd$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $5c8711a28b8203dd$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $5c8711a28b8203dd$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $5c8711a28b8203dd$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $5c8711a28b8203dd$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$5c8711a28b8203dd$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($5c8711a28b8203dd$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $5c8711a28b8203dd$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $5c8711a28b8203dd$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $5c8711a28b8203dd$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $5c8711a28b8203dd$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $5c8711a28b8203dd$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $5c8711a28b8203dd$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $5c8711a28b8203dd$var$createDataFunctionUrl(request, path),
        pattern: $5c8711a28b8203dd$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $5c8711a28b8203dd$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $5c8711a28b8203dd$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $5c8711a28b8203dd$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $5c8711a28b8203dd$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5c8711a28b8203dd$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5c8711a28b8203dd$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5c8711a28b8203dd$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $5c8711a28b8203dd$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $5c8711a28b8203dd$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $5c8711a28b8203dd$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($5c8711a28b8203dd$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $5c8711a28b8203dd$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $5c8711a28b8203dd$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $5c8711a28b8203dd$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($5c8711a28b8203dd$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $5c8711a28b8203dd$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $5c8711a28b8203dd$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5c8711a28b8203dd$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5c8711a28b8203dd$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $5c8711a28b8203dd$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $5c8711a28b8203dd$export$961a3ef7a4da3a39(location) {
    try {
        return $5c8711a28b8203dd$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $5c8711a28b8203dd$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($5c8711a28b8203dd$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $5c8711a28b8203dd$export$825a82322d91916e.test(normalizedLocation) ? new URL($5c8711a28b8203dd$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($5c8711a28b8203dd$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $5c8711a28b8203dd$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $5c8711a28b8203dd$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($5c8711a28b8203dd$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $5c8711a28b8203dd$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5c8711a28b8203dd$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5c8711a28b8203dd$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $5c8711a28b8203dd$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5c8711a28b8203dd$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $5c8711a28b8203dd$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5c8711a28b8203dd$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5c8711a28b8203dd$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5c8711a28b8203dd$export$f5708dca728d7177(!$5c8711a28b8203dd$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5c8711a28b8203dd$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $5c8711a28b8203dd$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $5c8711a28b8203dd$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $5c8711a28b8203dd$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5c8711a28b8203dd$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $5c8711a28b8203dd$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $5c8711a28b8203dd$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($5c8711a28b8203dd$var$isErrorResult(result)) {
            let boundaryMatch = $5c8711a28b8203dd$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($5c8711a28b8203dd$var$isRedirectResult(result)) $5c8711a28b8203dd$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $5c8711a28b8203dd$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5c8711a28b8203dd$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $5c8711a28b8203dd$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5c8711a28b8203dd$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5c8711a28b8203dd$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $5c8711a28b8203dd$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5c8711a28b8203dd$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5c8711a28b8203dd$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $5c8711a28b8203dd$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $5c8711a28b8203dd$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5c8711a28b8203dd$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5c8711a28b8203dd$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(path) : path;
    return $5c8711a28b8203dd$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $5c8711a28b8203dd$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $5c8711a28b8203dd$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $5c8711a28b8203dd$var$dataWithResponseInitToErrorResponse(data2) {
    return new $5c8711a28b8203dd$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $5c8711a28b8203dd$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $5c8711a28b8203dd$var$isDataStrategyResult(value));
}
function $5c8711a28b8203dd$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $5c8711a28b8203dd$var$isRedirectDataStrategyResult(result) {
    return $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result.result) && $5c8711a28b8203dd$var$redirectStatusCodes.has(result.result.status);
}
function $5c8711a28b8203dd$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $5c8711a28b8203dd$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $5c8711a28b8203dd$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5c8711a28b8203dd$export$794b2760043cf8cd(statusCode) {
    return $5c8711a28b8203dd$var$redirectStatusCodes.has(statusCode);
}
function $5c8711a28b8203dd$export$6e80290866a84dd4(result) {
    return $5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result) && $5c8711a28b8203dd$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $5c8711a28b8203dd$var$isValidMethod(method) {
    return $5c8711a28b8203dd$var$validRequestMethods.has(method.toUpperCase());
}
function $5c8711a28b8203dd$export$cbae47800eb95bc3(method) {
    return $5c8711a28b8203dd$var$validMutationMethods.has(method.toUpperCase());
}
function $5c8711a28b8203dd$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5c8711a28b8203dd$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5c8711a28b8203dd$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $5c8711a28b8203dd$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5c8711a28b8203dd$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $5c8711a28b8203dd$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $5c8711a28b8203dd$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5c8711a28b8203dd$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $5c8711a28b8203dd$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $5c8711a28b8203dd$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $5c8711a28b8203dd$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5c8711a28b8203dd$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $5c8711a28b8203dd$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5c8711a28b8203dd$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5c8711a28b8203dd$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $5c8711a28b8203dd$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $5c8711a28b8203dd$export$2eeee58951ff3c1c = $ieaan.createContext(null);
$5c8711a28b8203dd$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $5c8711a28b8203dd$export$315e3ffb01f217 = $ieaan.createContext(null);
$5c8711a28b8203dd$export$315e3ffb01f217.displayName = "DataRouterState";
var $5c8711a28b8203dd$export$717f757c655223f1 = $ieaan.createContext(false);
function $5c8711a28b8203dd$var$useIsRSCRouterContext() {
    return $ieaan.useContext($5c8711a28b8203dd$export$717f757c655223f1);
}
var $5c8711a28b8203dd$export$3681f408decb40d1 = $ieaan.createContext({
    isTransitioning: false
});
$5c8711a28b8203dd$export$3681f408decb40d1.displayName = "ViewTransition";
var $5c8711a28b8203dd$export$cb3f1df1bef00a39 = $ieaan.createContext(/* @__PURE__ */ new Map());
$5c8711a28b8203dd$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $5c8711a28b8203dd$var$AwaitContext = $ieaan.createContext(null);
$5c8711a28b8203dd$var$AwaitContext.displayName = "Await";
var $5c8711a28b8203dd$export$2666c20e15407622 = (props)=>$ieaan.createElement($5c8711a28b8203dd$var$AwaitContext.Provider, props);
var $5c8711a28b8203dd$export$3044ab7fdabeaee6 = $ieaan.createContext(null);
$5c8711a28b8203dd$export$3044ab7fdabeaee6.displayName = "Navigation";
var $5c8711a28b8203dd$export$e6a44b110a0c44d3 = $ieaan.createContext(null);
$5c8711a28b8203dd$export$e6a44b110a0c44d3.displayName = "Location";
var $5c8711a28b8203dd$export$aac280ed165a4397 = $ieaan.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$5c8711a28b8203dd$export$aac280ed165a4397.displayName = "Route";
var $5c8711a28b8203dd$var$RouteErrorContext = $ieaan.createContext(null);
$5c8711a28b8203dd$var$RouteErrorContext.displayName = "RouteError";
var $5c8711a28b8203dd$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $5c8711a28b8203dd$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $5c8711a28b8203dd$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $5c8711a28b8203dd$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $5c8711a28b8203dd$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$5c8711a28b8203dd$var$ERROR_DIGEST_BASE}:${$5c8711a28b8203dd$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $5c8711a28b8203dd$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$5c8711a28b8203dd$var$ERROR_DIGEST_BASE}:${$5c8711a28b8203dd$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $5c8711a28b8203dd$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $5c8711a28b8203dd$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $5c8711a28b8203dd$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $5c8711a28b8203dd$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $5c8711a28b8203dd$export$9c954a9d03d32f4a() {
    return $ieaan.useContext($5c8711a28b8203dd$export$e6a44b110a0c44d3) != null;
}
function $5c8711a28b8203dd$export$45d76561a5302f2b() {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $ieaan.useContext($5c8711a28b8203dd$export$e6a44b110a0c44d3).location;
}
function $5c8711a28b8203dd$export$1b3f31771c5d07c() {
    return $ieaan.useContext($5c8711a28b8203dd$export$e6a44b110a0c44d3).navigationType;
}
function $5c8711a28b8203dd$export$6c330e8992e8a295(pattern) {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $5c8711a28b8203dd$export$45d76561a5302f2b();
    return $ieaan.useMemo(()=>$5c8711a28b8203dd$export$81336c211d5ff295(pattern, $5c8711a28b8203dd$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $5c8711a28b8203dd$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $5c8711a28b8203dd$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6).static;
    if (!isStatic) $ieaan.useLayoutEffect(cb);
}
function $5c8711a28b8203dd$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    return isDataRoute ? $5c8711a28b8203dd$var$useNavigateStable() : $5c8711a28b8203dd$var$useNavigateUnstable();
}
function $5c8711a28b8203dd$var$useNavigateUnstable() {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let { matches: matches } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5c8711a28b8203dd$var$getResolveToMatches(matches));
    let activeRef = $ieaan.useRef(false);
    $5c8711a28b8203dd$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ieaan.useCallback((to, options = {})=>{
        $5c8711a28b8203dd$var$warning(activeRef.current, $5c8711a28b8203dd$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $5c8711a28b8203dd$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5c8711a28b8203dd$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $5c8711a28b8203dd$var$OutletContext = $ieaan.createContext(null);
function $5c8711a28b8203dd$export$4138103a3ae699cc() {
    return $ieaan.useContext($5c8711a28b8203dd$var$OutletContext);
}
function $5c8711a28b8203dd$export$a3be3530d8e40d0b(context) {
    let outlet = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397).outlet;
    return $ieaan.useMemo(()=>outlet && /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $5c8711a28b8203dd$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $5c8711a28b8203dd$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5c8711a28b8203dd$var$getResolveToMatches(matches));
    return $ieaan.useMemo(()=>$5c8711a28b8203dd$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $5c8711a28b8203dd$export$5d3fca4a98652595(routes, locationArg) {
    return $5c8711a28b8203dd$var$useRoutesImpl(routes, locationArg);
}
function $5c8711a28b8203dd$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $5c8711a28b8203dd$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $5c8711a28b8203dd$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $5c8711a28b8203dd$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $5c8711a28b8203dd$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
        $5c8711a28b8203dd$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $5c8711a28b8203dd$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $5c8711a28b8203dd$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $5c8711a28b8203dd$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $5c8711a28b8203dd$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5c8711a28b8203dd$var$DefaultErrorComponent() {
    let error = $5c8711a28b8203dd$export$ed527bf60f6e05f2();
    let message = $5c8711a28b8203dd$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $ieaan.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $ieaan.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $ieaan.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $ieaan.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $ieaan.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $5c8711a28b8203dd$var$defaultErrorElement = /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$DefaultErrorComponent, null);
var $5c8711a28b8203dd$var$RenderErrorBoundary = class extends $ieaan.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $5c8711a28b8203dd$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$5c8711a28b8203dd$var$RenderErrorBoundary.contextType = $5c8711a28b8203dd$export$717f757c655223f1;
var $5c8711a28b8203dd$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $5c8711a28b8203dd$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $5c8711a28b8203dd$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $5c8711a28b8203dd$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $5c8711a28b8203dd$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($5c8711a28b8203dd$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($5c8711a28b8203dd$var$isBrowser && !$5c8711a28b8203dd$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $5c8711a28b8203dd$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $ieaan.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $5c8711a28b8203dd$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $5c8711a28b8203dd$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $5c8711a28b8203dd$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $5c8711a28b8203dd$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $5c8711a28b8203dd$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5c8711a28b8203dd$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $ieaan.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $5c8711a28b8203dd$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5c8711a28b8203dd$var$useDataRouterContext(hookName) {
    let ctx = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    $5c8711a28b8203dd$export$f5708dca728d7177(ctx, $5c8711a28b8203dd$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5c8711a28b8203dd$var$useDataRouterState(hookName) {
    let state = $ieaan.useContext($5c8711a28b8203dd$export$315e3ffb01f217);
    $5c8711a28b8203dd$export$f5708dca728d7177(state, $5c8711a28b8203dd$var$getDataRouterConsoleError(hookName));
    return state;
}
function $5c8711a28b8203dd$var$useRouteContext(hookName) {
    let route = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    $5c8711a28b8203dd$export$f5708dca728d7177(route, $5c8711a28b8203dd$var$getDataRouterConsoleError(hookName));
    return route;
}
function $5c8711a28b8203dd$var$useCurrentRouteId(hookName) {
    let route = $5c8711a28b8203dd$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $5c8711a28b8203dd$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $5c8711a28b8203dd$var$useRouteId() {
    return $5c8711a28b8203dd$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $5c8711a28b8203dd$export$d0fd4b7106de2769() {
    let state = $5c8711a28b8203dd$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $ieaan.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $5c8711a28b8203dd$export$600dc272ed516c15() {
    let dataRouterContext = $5c8711a28b8203dd$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $5c8711a28b8203dd$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $ieaan.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $ieaan.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $5c8711a28b8203dd$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5c8711a28b8203dd$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $ieaan.useMemo(()=>matches.map((m)=>$5c8711a28b8203dd$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $5c8711a28b8203dd$export$1448a5050d252c4d() {
    let state = $5c8711a28b8203dd$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $5c8711a28b8203dd$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $5c8711a28b8203dd$export$fd5d37484eab868d(routeId) {
    let state = $5c8711a28b8203dd$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $5c8711a28b8203dd$export$fdc00f3f26066d5e() {
    let state = $5c8711a28b8203dd$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $5c8711a28b8203dd$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $5c8711a28b8203dd$export$ed527bf60f6e05f2() {
    let error = $ieaan.useContext($5c8711a28b8203dd$var$RouteErrorContext);
    let state = $5c8711a28b8203dd$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $5c8711a28b8203dd$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $5c8711a28b8203dd$export$78a72ddb39bdd145() {
    let value = $ieaan.useContext($5c8711a28b8203dd$var$AwaitContext);
    return value?._data;
}
function $5c8711a28b8203dd$export$17f53340677d5831() {
    let value = $ieaan.useContext($5c8711a28b8203dd$var$AwaitContext);
    return value?._error;
}
var $5c8711a28b8203dd$var$blockerId = 0;
function $5c8711a28b8203dd$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5c8711a28b8203dd$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $5c8711a28b8203dd$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $ieaan.useState("");
    let blockerFunction = $ieaan.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $5c8711a28b8203dd$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $5c8711a28b8203dd$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $ieaan.useEffect(()=>{
        let key = String(++$5c8711a28b8203dd$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $ieaan.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $5c8711a28b8203dd$export$386d57f03f0b2883;
}
function $5c8711a28b8203dd$var$useNavigateStable() {
    let { router: router } = $5c8711a28b8203dd$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $5c8711a28b8203dd$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $ieaan.useRef(false);
    $5c8711a28b8203dd$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ieaan.useCallback(async (to, options = {})=>{
        $5c8711a28b8203dd$var$warning(activeRef.current, $5c8711a28b8203dd$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $5c8711a28b8203dd$var$alreadyWarned = {};
function $5c8711a28b8203dd$var$warningOnce(key, cond, message) {
    if (!cond && !$5c8711a28b8203dd$var$alreadyWarned[key]) {
        $5c8711a28b8203dd$var$alreadyWarned[key] = true;
        $5c8711a28b8203dd$var$warning(false, message);
    }
}
function $5c8711a28b8203dd$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $5c8711a28b8203dd$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $5c8711a28b8203dd$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $5c8711a28b8203dd$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $5c8711a28b8203dd$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $5c8711a28b8203dd$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $ieaan.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$5c8711a28b8203dd$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $ieaan.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$5c8711a28b8203dd$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $ieaan.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $5c8711a28b8203dd$var$alreadyWarned2 = {};
function $5c8711a28b8203dd$export$5b28268982f175ba(condition, message) {
    if (!condition && !$5c8711a28b8203dd$var$alreadyWarned2[message]) {
        $5c8711a28b8203dd$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $5c8711a28b8203dd$var$USE_OPTIMISTIC = "useOptimistic";
var $5c8711a28b8203dd$var$useOptimisticImpl = $ieaan[$5c8711a28b8203dd$var$USE_OPTIMISTIC];
var $5c8711a28b8203dd$var$stableUseOptimisticSetter = ()=>void 0;
function $5c8711a28b8203dd$var$useOptimisticSafe(val) {
    if ($5c8711a28b8203dd$var$useOptimisticImpl) return $5c8711a28b8203dd$var$useOptimisticImpl(val);
    else return [
        val,
        $5c8711a28b8203dd$var$stableUseOptimisticSetter
    ];
}
function $5c8711a28b8203dd$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
            if (route.element) $5c8711a28b8203dd$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $ieaan.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $5c8711a28b8203dd$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $ieaan.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($5c8711a28b8203dd$export$945fecf35a8ef089) {
            if (route.errorElement) $5c8711a28b8203dd$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $ieaan.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $5c8711a28b8203dd$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $5c8711a28b8203dd$export$f30f7e456d254e83(routes, opts) {
    return $5c8711a28b8203dd$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5c8711a28b8203dd$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $5c8711a28b8203dd$export$e2fd2c03906469db,
        mapRouteProperties: $5c8711a28b8203dd$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $5c8711a28b8203dd$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $5c8711a28b8203dd$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $5c8711a28b8203dd$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $ieaan.useState(router.state);
    let [state, setOptimisticState] = $5c8711a28b8203dd$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $ieaan.useState();
    let [vtContext, setVtContext] = $ieaan.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $ieaan.useState();
    let [transition, setTransition] = $ieaan.useState();
    let [interruption, setInterruption] = $ieaan.useState();
    let fetcherData = $ieaan.useRef(/* @__PURE__ */ new Map());
    let setState = $ieaan.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $5c8711a28b8203dd$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $5c8711a28b8203dd$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $5c8711a28b8203dd$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $ieaan.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$5c8711a28b8203dd$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $ieaan.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $ieaan.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5c8711a28b8203dd$var$Deferred());
    }, [
        vtContext
    ]);
    $ieaan.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $ieaan.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$5c8711a28b8203dd$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $ieaan.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $ieaan.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $ieaan.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ieaan.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $5c8711a28b8203dd$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $5c8711a28b8203dd$var$MemoizedDataRoutes = $ieaan.memo($5c8711a28b8203dd$var$DataRoutes2);
function $5c8711a28b8203dd$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $5c8711a28b8203dd$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $5c8711a28b8203dd$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $5c8711a28b8203dd$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5c8711a28b8203dd$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $5c8711a28b8203dd$export$f5708dca728d7177($5c8711a28b8203dd$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    $5c8711a28b8203dd$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let navigate = $5c8711a28b8203dd$export$9770f232ac06a008();
    let path = $5c8711a28b8203dd$var$resolveTo(to, $5c8711a28b8203dd$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $ieaan.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $5c8711a28b8203dd$export$910ae8079b2c2852(props) {
    return $5c8711a28b8203dd$export$a3be3530d8e40d0b(props.context);
}
function $5c8711a28b8203dd$export$e7b0ac011bb776c6(props) {
    $5c8711a28b8203dd$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $5c8711a28b8203dd$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $5c8711a28b8203dd$export$f5708dca728d7177(!$5c8711a28b8203dd$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $ieaan.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $5c8711a28b8203dd$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $ieaan.useMemo(()=>{
        let trailingPathname = $5c8711a28b8203dd$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $5c8711a28b8203dd$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $5c8711a28b8203dd$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $5c8711a28b8203dd$export$5d3fca4a98652595($5c8711a28b8203dd$export$16da398f5434bdec(children), location);
}
function $5c8711a28b8203dd$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $ieaan.useContext($5c8711a28b8203dd$export$315e3ffb01f217);
    let onError = $ieaan.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $5c8711a28b8203dd$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$ResolveAwait, null, children));
}
var $5c8711a28b8203dd$var$AwaitErrorBoundary = class extends $ieaan.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $5c8711a28b8203dd$var$ResolveAwait({ children: children }) {
    let data2 = $5c8711a28b8203dd$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, toRender);
}
function $5c8711a28b8203dd$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $ieaan.Children.forEach(children, (element, index)=>{
        if (!$ieaan.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $ieaan.Fragment) {
            routes.push.apply(routes, $5c8711a28b8203dd$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $5c8711a28b8203dd$export$f5708dca728d7177(element.type === $5c8711a28b8203dd$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $5c8711a28b8203dd$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5c8711a28b8203dd$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $5c8711a28b8203dd$export$9b5b6d122dea0c88 = $5c8711a28b8203dd$export$16da398f5434bdec;
function $5c8711a28b8203dd$export$daf73786167a7f72(matches) {
    return $5c8711a28b8203dd$var$_renderMatches(matches);
}
function $5c8711a28b8203dd$var$useRouteComponentProps() {
    return {
        params: $5c8711a28b8203dd$export$99eaa27ddbbb95ef(),
        loaderData: $5c8711a28b8203dd$export$1448a5050d252c4d(),
        actionData: $5c8711a28b8203dd$export$fdc00f3f26066d5e(),
        matches: $5c8711a28b8203dd$export$2378eb7f5ff86053()
    };
}
function $5c8711a28b8203dd$export$6c4f3826290c37af({ children: children }) {
    const props = $5c8711a28b8203dd$var$useRouteComponentProps();
    return $ieaan.cloneElement(children, props);
}
function $5c8711a28b8203dd$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $5c8711a28b8203dd$var$useRouteComponentProps();
        return $ieaan.createElement(Component4, props);
    };
}
function $5c8711a28b8203dd$var$useHydrateFallbackProps() {
    return {
        params: $5c8711a28b8203dd$export$99eaa27ddbbb95ef(),
        loaderData: $5c8711a28b8203dd$export$1448a5050d252c4d(),
        actionData: $5c8711a28b8203dd$export$fdc00f3f26066d5e()
    };
}
function $5c8711a28b8203dd$export$f8cff34f39c1932a({ children: children }) {
    const props = $5c8711a28b8203dd$var$useHydrateFallbackProps();
    return $ieaan.cloneElement(children, props);
}
function $5c8711a28b8203dd$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $5c8711a28b8203dd$var$useHydrateFallbackProps();
        return $ieaan.createElement(HydrateFallback, props);
    };
}
function $5c8711a28b8203dd$var$useErrorBoundaryProps() {
    return {
        params: $5c8711a28b8203dd$export$99eaa27ddbbb95ef(),
        loaderData: $5c8711a28b8203dd$export$1448a5050d252c4d(),
        actionData: $5c8711a28b8203dd$export$fdc00f3f26066d5e(),
        error: $5c8711a28b8203dd$export$ed527bf60f6e05f2()
    };
}
function $5c8711a28b8203dd$export$e5afde5c4b6d747b({ children: children }) {
    const props = $5c8711a28b8203dd$var$useErrorBoundaryProps();
    return $ieaan.cloneElement(children, props);
}
function $5c8711a28b8203dd$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $5c8711a28b8203dd$var$useErrorBoundaryProps();
        return $ieaan.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $5c8711a28b8203dd$var$defaultMethod = "get";
var $5c8711a28b8203dd$var$defaultEncType = "application/x-www-form-urlencoded";
function $5c8711a28b8203dd$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $5c8711a28b8203dd$var$isButtonElement(object) {
    return $5c8711a28b8203dd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5c8711a28b8203dd$var$isFormElement(object) {
    return $5c8711a28b8203dd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5c8711a28b8203dd$var$isInputElement(object) {
    return $5c8711a28b8203dd$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5c8711a28b8203dd$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5c8711a28b8203dd$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5c8711a28b8203dd$var$isModifiedEvent(event);
}
function $5c8711a28b8203dd$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5c8711a28b8203dd$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5c8711a28b8203dd$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $5c8711a28b8203dd$var$_formDataSupportsSubmitter = null;
function $5c8711a28b8203dd$var$isFormDataSubmitterSupported() {
    if ($5c8711a28b8203dd$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5c8711a28b8203dd$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5c8711a28b8203dd$var$_formDataSupportsSubmitter = true;
    }
    return $5c8711a28b8203dd$var$_formDataSupportsSubmitter;
}
var $5c8711a28b8203dd$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5c8711a28b8203dd$var$getFormEncType(encType) {
    if (encType != null && !$5c8711a28b8203dd$var$supportedFormEncTypes.has(encType)) {
        $5c8711a28b8203dd$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$5c8711a28b8203dd$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $5c8711a28b8203dd$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5c8711a28b8203dd$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $5c8711a28b8203dd$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $5c8711a28b8203dd$var$defaultMethod;
        encType = $5c8711a28b8203dd$var$getFormEncType(target.getAttribute("enctype")) || $5c8711a28b8203dd$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5c8711a28b8203dd$var$isButtonElement(target) || $5c8711a28b8203dd$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $5c8711a28b8203dd$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5c8711a28b8203dd$var$defaultMethod;
        encType = $5c8711a28b8203dd$var$getFormEncType(target.getAttribute("formenctype")) || $5c8711a28b8203dd$var$getFormEncType(form.getAttribute("enctype")) || $5c8711a28b8203dd$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$5c8711a28b8203dd$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5c8711a28b8203dd$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $5c8711a28b8203dd$var$defaultMethod;
        action = null;
        encType = $5c8711a28b8203dd$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $5c8711a28b8203dd$var$HOLE = -1;
var $5c8711a28b8203dd$var$NAN = -2;
var $5c8711a28b8203dd$var$NEGATIVE_INFINITY = -3;
var $5c8711a28b8203dd$var$NEGATIVE_ZERO = -4;
var $5c8711a28b8203dd$var$NULL = -5;
var $5c8711a28b8203dd$var$POSITIVE_INFINITY = -6;
var $5c8711a28b8203dd$var$UNDEFINED = -7;
var $5c8711a28b8203dd$var$TYPE_BIGINT = "B";
var $5c8711a28b8203dd$var$TYPE_DATE = "D";
var $5c8711a28b8203dd$var$TYPE_ERROR = "E";
var $5c8711a28b8203dd$var$TYPE_MAP = "M";
var $5c8711a28b8203dd$var$TYPE_NULL_OBJECT = "N";
var $5c8711a28b8203dd$var$TYPE_PROMISE = "P";
var $5c8711a28b8203dd$var$TYPE_REGEXP = "R";
var $5c8711a28b8203dd$var$TYPE_SET = "S";
var $5c8711a28b8203dd$var$TYPE_SYMBOL = "Y";
var $5c8711a28b8203dd$var$TYPE_URL = "U";
var $5c8711a28b8203dd$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $5c8711a28b8203dd$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $5c8711a28b8203dd$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $5c8711a28b8203dd$var$TIME_LIMIT_MS = 1;
var $5c8711a28b8203dd$var$getNow = ()=>Date.now();
var $5c8711a28b8203dd$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $5c8711a28b8203dd$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $5c8711a28b8203dd$var$UNDEFINED;
    if (input === null) return $5c8711a28b8203dd$var$NULL;
    if (Number.isNaN(input)) return $5c8711a28b8203dd$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $5c8711a28b8203dd$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $5c8711a28b8203dd$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $5c8711a28b8203dd$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $5c8711a28b8203dd$var$stringify.call(this, stack);
    return index;
}
async function $5c8711a28b8203dd$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $5c8711a28b8203dd$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $5c8711a28b8203dd$var$UNDEFINED;
        if (value === null) return $5c8711a28b8203dd$var$NULL;
        if (Number.isNaN(value)) return $5c8711a28b8203dd$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $5c8711a28b8203dd$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $5c8711a28b8203dd$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $5c8711a28b8203dd$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $5c8711a28b8203dd$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $5c8711a28b8203dd$var$TIME_LIMIT_MS) {
            await $5c8711a28b8203dd$var$yieldToMain();
            lastYieldTime = $5c8711a28b8203dd$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$5c8711a28b8203dd$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$5c8711a28b8203dd$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$5c8711a28b8203dd$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $5c8711a28b8203dd$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$5c8711a28b8203dd$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$5c8711a28b8203dd$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$5c8711a28b8203dd$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$5c8711a28b8203dd$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$5c8711a28b8203dd$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$5c8711a28b8203dd$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$5c8711a28b8203dd$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$5c8711a28b8203dd$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$5c8711a28b8203dd$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$5c8711a28b8203dd$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($5c8711a28b8203dd$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $5c8711a28b8203dd$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5c8711a28b8203dd$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5c8711a28b8203dd$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $5c8711a28b8203dd$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $5c8711a28b8203dd$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $5c8711a28b8203dd$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $5c8711a28b8203dd$var$hydrate.call(this, startIndex);
}
function $5c8711a28b8203dd$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $5c8711a28b8203dd$var$UNDEFINED:
                set(void 0);
                continue;
            case $5c8711a28b8203dd$var$NULL:
                set(null);
                continue;
            case $5c8711a28b8203dd$var$NAN:
                set(NaN);
                continue;
            case $5c8711a28b8203dd$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $5c8711a28b8203dd$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $5c8711a28b8203dd$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $5c8711a28b8203dd$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $5c8711a28b8203dd$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $5c8711a28b8203dd$var$globalObj && $5c8711a28b8203dd$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $5c8711a28b8203dd$var$globalObj && typeof $5c8711a28b8203dd$var$globalObj[errorType] === "function" ? new $5c8711a28b8203dd$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $5c8711a28b8203dd$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $5c8711a28b8203dd$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $5c8711a28b8203dd$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $5c8711a28b8203dd$var$Deferred2();
    const reader = readable.pipeThrough($5c8711a28b8203dd$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $5c8711a28b8203dd$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $5c8711a28b8203dd$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $5c8711a28b8203dd$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $5c8711a28b8203dd$var$unflatten.call(this, line)
    };
}
async function $5c8711a28b8203dd$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $5c8711a28b8203dd$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5c8711a28b8203dd$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $5c8711a28b8203dd$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5c8711a28b8203dd$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $5c8711a28b8203dd$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $5c8711a28b8203dd$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $5c8711a28b8203dd$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_PROMISE}${deferredId}:[["${$5c8711a28b8203dd$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $5c8711a28b8203dd$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_ERROR}${deferredId}:[["${$5c8711a28b8203dd$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$5c8711a28b8203dd$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $5c8711a28b8203dd$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $5c8711a28b8203dd$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $5c8711a28b8203dd$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $5c8711a28b8203dd$export$4cf11838cdc2a8a8(html) {
    return html.replace($5c8711a28b8203dd$var$ESCAPE_REGEX, (match)=>$5c8711a28b8203dd$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $5c8711a28b8203dd$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $5c8711a28b8203dd$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $5c8711a28b8203dd$var$SingleFetchNoResultError = class extends Error {
};
var $5c8711a28b8203dd$export$ae9272e641ead836 = 202;
var $5c8711a28b8203dd$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $5c8711a28b8203dd$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$5c8711a28b8203dd$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, scriptTag, /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, scriptTag, /* @__PURE__ */ $ieaan.createElement($ieaan.Suspense, null, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $5c8711a28b8203dd$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $5c8711a28b8203dd$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $5c8711a28b8203dd$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $5c8711a28b8203dd$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $5c8711a28b8203dd$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $5c8711a28b8203dd$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $5c8711a28b8203dd$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $5c8711a28b8203dd$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $5c8711a28b8203dd$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $5c8711a28b8203dd$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5c8711a28b8203dd$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $5c8711a28b8203dd$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($5c8711a28b8203dd$export$3f1eb41d9a6a6a27(result.result) || $5c8711a28b8203dd$export$972111febbeef05b(result.result) || $5c8711a28b8203dd$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $5c8711a28b8203dd$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $5c8711a28b8203dd$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $5c8711a28b8203dd$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $5c8711a28b8203dd$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$5c8711a28b8203dd$var$createDeferred2());
    let singleFetchDfd = $5c8711a28b8203dd$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $5c8711a28b8203dd$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $5c8711a28b8203dd$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $5c8711a28b8203dd$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $5c8711a28b8203dd$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $5c8711a28b8203dd$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $5c8711a28b8203dd$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5c8711a28b8203dd$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $5c8711a28b8203dd$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $5c8711a28b8203dd$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $5c8711a28b8203dd$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $5c8711a28b8203dd$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$5c8711a28b8203dd$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$5c8711a28b8203dd$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $5c8711a28b8203dd$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $5c8711a28b8203dd$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $5c8711a28b8203dd$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $5c8711a28b8203dd$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $5c8711a28b8203dd$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $5c8711a28b8203dd$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($5c8711a28b8203dd$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $5c8711a28b8203dd$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $5c8711a28b8203dd$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($5c8711a28b8203dd$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$5c8711a28b8203dd$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $5c8711a28b8203dd$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $5c8711a28b8203dd$export$4023ad4ecd4126a2(body, global) {
    return $5c8711a28b8203dd$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $5c8711a28b8203dd$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $5c8711a28b8203dd$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$5c8711a28b8203dd$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $5c8711a28b8203dd$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $5c8711a28b8203dd$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $5c8711a28b8203dd$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $5c8711a28b8203dd$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $5c8711a28b8203dd$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $5c8711a28b8203dd$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $5c8711a28b8203dd$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $5c8711a28b8203dd$var$getModuleLinkHrefs(matches, manifest);
    return $5c8711a28b8203dd$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $5c8711a28b8203dd$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $5c8711a28b8203dd$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $5c8711a28b8203dd$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($5c8711a28b8203dd$var$prefetchStyleLink));
}
async function $5c8711a28b8203dd$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$5c8711a28b8203dd$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$5c8711a28b8203dd$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$5c8711a28b8203dd$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($5c8711a28b8203dd$var$prefetchStyleLink));
}
async function $5c8711a28b8203dd$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $5c8711a28b8203dd$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $5c8711a28b8203dd$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $5c8711a28b8203dd$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $5c8711a28b8203dd$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $5c8711a28b8203dd$var$dedupeLinkDescriptors(links.flat(1).filter($5c8711a28b8203dd$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $5c8711a28b8203dd$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $5c8711a28b8203dd$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $5c8711a28b8203dd$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $5c8711a28b8203dd$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $5c8711a28b8203dd$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $5c8711a28b8203dd$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$5c8711a28b8203dd$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($5c8711a28b8203dd$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $5c8711a28b8203dd$var$_isPreloadSupported;
function $5c8711a28b8203dd$var$isPreloadSupported() {
    if ($5c8711a28b8203dd$var$_isPreloadSupported !== void 0) return $5c8711a28b8203dd$var$_isPreloadSupported;
    let el = document.createElement("link");
    $5c8711a28b8203dd$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $5c8711a28b8203dd$var$_isPreloadSupported;
}
function $5c8711a28b8203dd$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $5c8711a28b8203dd$var$useFrameworkContext();
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $5c8711a28b8203dd$export$945fecf35a8ef089 ? /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $5c8711a28b8203dd$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $5c8711a28b8203dd$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $5c8711a28b8203dd$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $5c8711a28b8203dd$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RemixRootDefaultErrorBoundary, {
            error: $5c8711a28b8203dd$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $5c8711a28b8203dd$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $5c8711a28b8203dd$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $5c8711a28b8203dd$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$5c8711a28b8203dd$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $5c8711a28b8203dd$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5c8711a28b8203dd$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $5c8711a28b8203dd$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $5c8711a28b8203dd$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $5c8711a28b8203dd$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $5c8711a28b8203dd$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $5c8711a28b8203dd$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $5c8711a28b8203dd$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $5c8711a28b8203dd$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $5c8711a28b8203dd$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $5c8711a28b8203dd$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $5c8711a28b8203dd$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $5c8711a28b8203dd$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$5c8711a28b8203dd$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $5c8711a28b8203dd$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $5c8711a28b8203dd$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $5c8711a28b8203dd$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $5c8711a28b8203dd$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $5c8711a28b8203dd$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $5c8711a28b8203dd$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $5c8711a28b8203dd$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $5c8711a28b8203dd$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $5c8711a28b8203dd$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $5c8711a28b8203dd$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $5c8711a28b8203dd$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $5c8711a28b8203dd$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $5c8711a28b8203dd$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $5c8711a28b8203dd$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $5c8711a28b8203dd$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $5c8711a28b8203dd$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5c8711a28b8203dd$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $5c8711a28b8203dd$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $5c8711a28b8203dd$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $5c8711a28b8203dd$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $5c8711a28b8203dd$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $5c8711a28b8203dd$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $5c8711a28b8203dd$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $5c8711a28b8203dd$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $5c8711a28b8203dd$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $5c8711a28b8203dd$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $5c8711a28b8203dd$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $5c8711a28b8203dd$var$nextPaths = /* @__PURE__ */ new Set();
var $5c8711a28b8203dd$var$discoveredPathsMaxSize = 1e3;
var $5c8711a28b8203dd$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5c8711a28b8203dd$export$b5915cf27fa06b9f = 7680;
function $5c8711a28b8203dd$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $5c8711a28b8203dd$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $5c8711a28b8203dd$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $5c8711a28b8203dd$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $5c8711a28b8203dd$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$5c8711a28b8203dd$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($5c8711a28b8203dd$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $5c8711a28b8203dd$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $5c8711a28b8203dd$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $5c8711a28b8203dd$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $ieaan.useEffect(()=>{
        if (!$5c8711a28b8203dd$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5c8711a28b8203dd$var$discoveredPaths.has(pathname)) $5c8711a28b8203dd$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($5c8711a28b8203dd$var$nextPaths.keys()).filter((path)=>{
                if ($5c8711a28b8203dd$var$discoveredPaths.has(path)) {
                    $5c8711a28b8203dd$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $5c8711a28b8203dd$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5c8711a28b8203dd$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $5c8711a28b8203dd$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $5c8711a28b8203dd$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $5c8711a28b8203dd$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $5c8711a28b8203dd$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $5c8711a28b8203dd$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($5c8711a28b8203dd$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $5c8711a28b8203dd$export$b5915cf27fa06b9f) {
        $5c8711a28b8203dd$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($5c8711a28b8203dd$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($5c8711a28b8203dd$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($5c8711a28b8203dd$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$5c8711a28b8203dd$var$addToFifoQueue(p, $5c8711a28b8203dd$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $5c8711a28b8203dd$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $5c8711a28b8203dd$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5c8711a28b8203dd$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $5c8711a28b8203dd$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $5c8711a28b8203dd$var$useDataRouterContext2() {
    let context = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    $5c8711a28b8203dd$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $5c8711a28b8203dd$var$useDataRouterStateContext() {
    let context = $ieaan.useContext($5c8711a28b8203dd$export$315e3ffb01f217);
    $5c8711a28b8203dd$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $5c8711a28b8203dd$export$208d6a3bc3aa62bd = $ieaan.createContext(void 0);
$5c8711a28b8203dd$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $5c8711a28b8203dd$var$useFrameworkContext() {
    let context = $ieaan.useContext($5c8711a28b8203dd$export$208d6a3bc3aa62bd);
    $5c8711a28b8203dd$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $5c8711a28b8203dd$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $ieaan.useContext($5c8711a28b8203dd$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $ieaan.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $ieaan.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $ieaan.useRef(null);
    $ieaan.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $ieaan.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $5c8711a28b8203dd$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $5c8711a28b8203dd$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $5c8711a28b8203dd$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $5c8711a28b8203dd$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $5c8711a28b8203dd$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $5c8711a28b8203dd$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $5c8711a28b8203dd$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$5c8711a28b8203dd$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $5c8711a28b8203dd$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $5c8711a28b8203dd$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $5c8711a28b8203dd$var$useDataRouterStateContext();
    let matches = $5c8711a28b8203dd$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $ieaan.useMemo(()=>$5c8711a28b8203dd$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $ieaan.createElement("style", {
        [$5c8711a28b8203dd$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $ieaan.createElement("link", {
        [$5c8711a28b8203dd$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$5c8711a28b8203dd$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $ieaan.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $5c8711a28b8203dd$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $5c8711a28b8203dd$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { router: router } = $5c8711a28b8203dd$var$useDataRouterContext2();
    let matches = $ieaan.useMemo(()=>$5c8711a28b8203dd$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $5c8711a28b8203dd$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $5c8711a28b8203dd$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $ieaan.useState([]);
    $ieaan.useEffect(()=>{
        let interrupted = false;
        $5c8711a28b8203dd$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $5c8711a28b8203dd$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let { future: future } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { basename: basename } = $5c8711a28b8203dd$var$useDataRouterContext2();
    let dataHrefs = $ieaan.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $5c8711a28b8203dd$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $5c8711a28b8203dd$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { basename: basename } = $5c8711a28b8203dd$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $5c8711a28b8203dd$var$useDataRouterStateContext();
    let newMatchesForData = $ieaan.useMemo(()=>$5c8711a28b8203dd$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $ieaan.useMemo(()=>$5c8711a28b8203dd$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $ieaan.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $5c8711a28b8203dd$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $ieaan.useMemo(()=>$5c8711a28b8203dd$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $5c8711a28b8203dd$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $ieaan.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $5c8711a28b8203dd$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $5c8711a28b8203dd$var$useDataRouterStateContext();
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let _matches = $5c8711a28b8203dd$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$5c8711a28b8203dd$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $ieaan.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $ieaan.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $ieaan.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $ieaan.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $5c8711a28b8203dd$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $ieaan.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $5c8711a28b8203dd$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $5c8711a28b8203dd$var$isHydrated = false;
function $5c8711a28b8203dd$export$3be068dde909e563() {
    $5c8711a28b8203dd$var$isHydrated = true;
}
function $5c8711a28b8203dd$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $5c8711a28b8203dd$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $5c8711a28b8203dd$var$useDataRouterContext2();
    let { matches: routerMatches } = $5c8711a28b8203dd$var$useDataRouterStateContext();
    let isRSCRouterContext = $5c8711a28b8203dd$var$useIsRSCRouterContext();
    let enableFogOfWar = $5c8711a28b8203dd$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $5c8711a28b8203dd$var$getActiveMatches(routerMatches, null, isSpaMode);
    $ieaan.useEffect(()=>{
        $5c8711a28b8203dd$export$3be068dde909e563();
    }, []);
    let initialScripts = $ieaan.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $5c8711a28b8203dd$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($5c8711a28b8203dd$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $ieaan.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $5c8711a28b8203dd$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($5c8711a28b8203dd$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $5c8711a28b8203dd$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $5c8711a28b8203dd$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $ieaan.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $ieaan.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $ieaan.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $5c8711a28b8203dd$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $5c8711a28b8203dd$export$32e57f52df4b6e34 = class extends $ieaan.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $5c8711a28b8203dd$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $5c8711a28b8203dd$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($5c8711a28b8203dd$export$972111febbeef05b(error)) return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $ieaan.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $5c8711a28b8203dd$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $ieaan.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $ieaan.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $5c8711a28b8203dd$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $5c8711a28b8203dd$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $ieaan.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $ieaan.createElement("head", null, /* @__PURE__ */ $ieaan.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $ieaan.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $ieaan.createElement("title", null, title)), /* @__PURE__ */ $ieaan.createElement("body", null, /* @__PURE__ */ $ieaan.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$ff0bf87698939488, null) : null)));
}
var $5c8711a28b8203dd$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5c8711a28b8203dd$var$isBrowser2) window.__reactRouterVersion = "7.18.0";
} catch (e) {}
function $5c8711a28b8203dd$export$1f3f55432a00e06d(routes, opts) {
    return $5c8711a28b8203dd$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5c8711a28b8203dd$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5c8711a28b8203dd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5c8711a28b8203dd$export$9269a41d8c4635e,
        hydrationRouteProperties: $5c8711a28b8203dd$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5c8711a28b8203dd$export$1ba7ed8a3a7b3765(routes, opts) {
    return $5c8711a28b8203dd$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5c8711a28b8203dd$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5c8711a28b8203dd$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5c8711a28b8203dd$export$9269a41d8c4635e,
        hydrationRouteProperties: $5c8711a28b8203dd$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5c8711a28b8203dd$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5c8711a28b8203dd$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5c8711a28b8203dd$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $5c8711a28b8203dd$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $5c8711a28b8203dd$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $5c8711a28b8203dd$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $5c8711a28b8203dd$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5c8711a28b8203dd$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $5c8711a28b8203dd$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5c8711a28b8203dd$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$5c8711a28b8203dd$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $5c8711a28b8203dd$export$a6c7ac8248d6e38a = $ieaan.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $5c8711a28b8203dd$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $5c8711a28b8203dd$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $5c8711a28b8203dd$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $5c8711a28b8203dd$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $5c8711a28b8203dd$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $5c8711a28b8203dd$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $ieaan.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $5c8711a28b8203dd$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, link, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$5c8711a28b8203dd$export$a6c7ac8248d6e38a.displayName = "Link";
var $5c8711a28b8203dd$export$b0d92dbee9b5b60d = $ieaan.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $5c8711a28b8203dd$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let routerState = $ieaan.useContext($5c8711a28b8203dd$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5c8711a28b8203dd$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $5c8711a28b8203dd$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5c8711a28b8203dd$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $5c8711a28b8203dd$export$a7fed597f4b8afd8 = $ieaan.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $5c8711a28b8203dd$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let submit = $5c8711a28b8203dd$export$47c85c6e3a081d3();
    let formAction = $5c8711a28b8203dd$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $ieaan.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $ieaan.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5c8711a28b8203dd$export$a7fed597f4b8afd8.displayName = "Form";
function $5c8711a28b8203dd$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $ieaan.useContext($5c8711a28b8203dd$export$208d6a3bc3aa62bd);
    let { basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let matches = $5c8711a28b8203dd$export$2378eb7f5ff86053();
    $5c8711a28b8203dd$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $ieaan.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5c8711a28b8203dd$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $ieaan.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$5c8711a28b8203dd$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $5c8711a28b8203dd$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$5c8711a28b8203dd$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$5c8711a28b8203dd$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $5c8711a28b8203dd$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5c8711a28b8203dd$var$useDataRouterContext3(hookName) {
    let ctx = $ieaan.useContext($5c8711a28b8203dd$export$2eeee58951ff3c1c);
    $5c8711a28b8203dd$export$f5708dca728d7177(ctx, $5c8711a28b8203dd$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $5c8711a28b8203dd$var$useDataRouterState2(hookName) {
    let state = $ieaan.useContext($5c8711a28b8203dd$export$315e3ffb01f217);
    $5c8711a28b8203dd$export$f5708dca728d7177(state, $5c8711a28b8203dd$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $5c8711a28b8203dd$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $5c8711a28b8203dd$export$9770f232ac06a008();
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let path = $5c8711a28b8203dd$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $ieaan.useCallback((event)=>{
        if ($5c8711a28b8203dd$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $5c8711a28b8203dd$export$fe53371bee54353d(location) === $5c8711a28b8203dd$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $ieaan.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $5c8711a28b8203dd$export$f1a78c17382fe22a(defaultInit) {
    $5c8711a28b8203dd$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $ieaan.useRef($5c8711a28b8203dd$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $ieaan.useRef(false);
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let searchParams = $ieaan.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5c8711a28b8203dd$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $5c8711a28b8203dd$export$9770f232ac06a008();
    let setSearchParams = $ieaan.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5c8711a28b8203dd$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $5c8711a28b8203dd$var$fetcherId = 0;
var $5c8711a28b8203dd$var$getUniqueFetcherId = ()=>`__${String(++$5c8711a28b8203dd$var$fetcherId)}__`;
function $5c8711a28b8203dd$export$47c85c6e3a081d3() {
    let { router: router } = $5c8711a28b8203dd$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let currentRouteId = $5c8711a28b8203dd$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $ieaan.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5c8711a28b8203dd$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5c8711a28b8203dd$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $5c8711a28b8203dd$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let routeContext = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    $5c8711a28b8203dd$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$5c8711a28b8203dd$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $5c8711a28b8203dd$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $5c8711a28b8203dd$export$fe53371bee54353d(path);
}
function $5c8711a28b8203dd$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $5c8711a28b8203dd$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $5c8711a28b8203dd$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $ieaan.useContext($5c8711a28b8203dd$export$cb3f1df1bef00a39);
    let route = $ieaan.useContext($5c8711a28b8203dd$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $5c8711a28b8203dd$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $5c8711a28b8203dd$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $5c8711a28b8203dd$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $ieaan.useId();
    let [fetcherKey, setFetcherKey] = $ieaan.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $ieaan.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $ieaan.useCallback(async (href, opts)=>{
        $5c8711a28b8203dd$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5c8711a28b8203dd$export$47c85c6e3a081d3();
    let submit = $ieaan.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $ieaan.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $ieaan.useMemo(()=>{
        let FetcherForm2 = $ieaan.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $5c8711a28b8203dd$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $ieaan.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $5c8711a28b8203dd$export$fa996778a3a31087() {
    let state = $5c8711a28b8203dd$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $ieaan.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $5c8711a28b8203dd$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $5c8711a28b8203dd$var$savedScrollPositions = {};
function $5c8711a28b8203dd$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $5c8711a28b8203dd$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $5c8711a28b8203dd$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $5c8711a28b8203dd$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5c8711a28b8203dd$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $ieaan.useContext($5c8711a28b8203dd$export$3044ab7fdabeaee6);
    let location = $5c8711a28b8203dd$export$45d76561a5302f2b();
    let matches = $5c8711a28b8203dd$export$2378eb7f5ff86053();
    let navigation = $5c8711a28b8203dd$export$d0fd4b7106de2769();
    $ieaan.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5c8711a28b8203dd$var$usePageHide($ieaan.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5c8711a28b8203dd$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5c8711a28b8203dd$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5c8711a28b8203dd$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5c8711a28b8203dd$var$savedScrollPositions));
        } catch (error) {
            $5c8711a28b8203dd$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $ieaan.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5c8711a28b8203dd$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5c8711a28b8203dd$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $ieaan.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5c8711a28b8203dd$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$5c8711a28b8203dd$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $ieaan.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $5c8711a28b8203dd$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $5c8711a28b8203dd$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $ieaan.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5c8711a28b8203dd$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $ieaan.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5c8711a28b8203dd$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $5c8711a28b8203dd$export$b273b3273281a049(when);
    $ieaan.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $ieaan.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $5c8711a28b8203dd$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $ieaan.useContext($5c8711a28b8203dd$export$3681f408decb40d1);
    $5c8711a28b8203dd$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $5c8711a28b8203dd$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $5c8711a28b8203dd$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $5c8711a28b8203dd$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $5c8711a28b8203dd$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $5c8711a28b8203dd$export$81336c211d5ff295(path.pathname, nextPath) != null || $5c8711a28b8203dd$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $5c8711a28b8203dd$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $5c8711a28b8203dd$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $5c8711a28b8203dd$var$getStatelessNavigator();
    return /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $5c8711a28b8203dd$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $5c8711a28b8203dd$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $5c8711a28b8203dd$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $5c8711a28b8203dd$var$serializeErrors(context.errors)
        };
        let json = $5c8711a28b8203dd$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $ieaan.createElement($5c8711a28b8203dd$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $ieaan.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $5c8711a28b8203dd$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($5c8711a28b8203dd$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $5c8711a28b8203dd$var$getStatelessNavigator() {
    return {
        createHref: $5c8711a28b8203dd$var$createHref,
        encodeLocation: $5c8711a28b8203dd$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $5c8711a28b8203dd$export$69163f0b72ec60d9(routes, opts) {
    return $5c8711a28b8203dd$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $5c8711a28b8203dd$export$9269a41d8c4635e
    });
}
function $5c8711a28b8203dd$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $5c8711a28b8203dd$export$87cb1a9238dc3fba(routes, $5c8711a28b8203dd$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $5c8711a28b8203dd$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $5c8711a28b8203dd$var$createHref,
        encodeLocation: $5c8711a28b8203dd$var$encodeLocation,
        getFetcher () {
            return $5c8711a28b8203dd$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $5c8711a28b8203dd$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $5c8711a28b8203dd$var$createHref(to) {
    return typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to);
}
function $5c8711a28b8203dd$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $5c8711a28b8203dd$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $5c8711a28b8203dd$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}







var $1c1c6bce1a869e4d$exports = {};
'use strict';
var $226d7354db2b187a$exports = {};
'use strict';
var $edb622f056bc26b8$exports = {};
'use strict';
var $c3ca2daa31bfc688$exports = {};
'use strict';
var $d5e1f537844e7083$exports = {};
'use strict';
var $3b3cfeebcaab0b7e$exports = {};
'use strict';
$3b3cfeebcaab0b7e$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


$d5e1f537844e7083$exports = !$3b3cfeebcaab0b7e$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $c3ca2daa31bfc688$var$FunctionPrototype = Function.prototype;
var $c3ca2daa31bfc688$var$call = $c3ca2daa31bfc688$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $c3ca2daa31bfc688$var$uncurryThisWithBind = $d5e1f537844e7083$exports && $c3ca2daa31bfc688$var$FunctionPrototype.bind.bind($c3ca2daa31bfc688$var$call, $c3ca2daa31bfc688$var$call);
$c3ca2daa31bfc688$exports = $d5e1f537844e7083$exports ? $c3ca2daa31bfc688$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c3ca2daa31bfc688$var$call.apply(fn, arguments);
    };
};


$edb622f056bc26b8$exports = $c3ca2daa31bfc688$exports({}.isPrototypeOf);


var $b6366a4f9273b9c5$exports = {};
'use strict';
'use strict';
var $dd3b95617fde12ee$exports = {};
'use strict';
var $936962c05e31d160$exports = {};
'use strict';
var $936962c05e31d160$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$936962c05e31d160$exports = // eslint-disable-next-line es/no-global-this -- safe
$936962c05e31d160$var$check(typeof globalThis == 'object' && globalThis) || $936962c05e31d160$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$936962c05e31d160$var$check(typeof self == 'object' && self) || $936962c05e31d160$var$check(typeof $parcel$global == 'object' && $parcel$global) || $936962c05e31d160$var$check(typeof $936962c05e31d160$exports == 'object' && $936962c05e31d160$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $391cd427966f0182$exports = {};
'use strict';

var $391cd427966f0182$var$FunctionPrototype = Function.prototype;
var $391cd427966f0182$var$apply = $391cd427966f0182$var$FunctionPrototype.apply;
var $391cd427966f0182$var$call = $391cd427966f0182$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$391cd427966f0182$exports = typeof Reflect == 'object' && Reflect.apply || ($d5e1f537844e7083$exports ? $391cd427966f0182$var$call.bind($391cd427966f0182$var$apply) : function() {
    return $391cd427966f0182$var$call.apply($391cd427966f0182$var$apply, arguments);
});


var $7c6951035dfa1f63$exports = {};
'use strict';
var $18e36b683048fab6$exports = {};
'use strict';

var $18e36b683048fab6$var$toString = $c3ca2daa31bfc688$exports({}.toString);
var $18e36b683048fab6$var$stringSlice = $c3ca2daa31bfc688$exports(''.slice);
$18e36b683048fab6$exports = function(it) {
    return $18e36b683048fab6$var$stringSlice($18e36b683048fab6$var$toString(it), 8, -1);
};



$7c6951035dfa1f63$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($18e36b683048fab6$exports(fn) === 'Function') return $c3ca2daa31bfc688$exports(fn);
};


var $380223d687937afd$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $380223d687937afd$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$380223d687937afd$exports = typeof $380223d687937afd$var$documentAll == 'undefined' && $380223d687937afd$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $380223d687937afd$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $dabfe21458100563$export$2d1720544b23b823;
'use strict';
var $c3e68bacccb24be1$exports = {};
'use strict';

// Detect IE8's incomplete defineProperty implementation
$c3e68bacccb24be1$exports = !$3b3cfeebcaab0b7e$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $5af7fa12e239c1d4$exports = {};
'use strict';

var $5af7fa12e239c1d4$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$5af7fa12e239c1d4$exports = $d5e1f537844e7083$exports ? $5af7fa12e239c1d4$var$call.bind($5af7fa12e239c1d4$var$call) : function() {
    return $5af7fa12e239c1d4$var$call.apply($5af7fa12e239c1d4$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $ca69d0227bddb9e8$export$2d1720544b23b823;
'use strict';
var $ca69d0227bddb9e8$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ca69d0227bddb9e8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $ca69d0227bddb9e8$var$NASHORN_BUG = $ca69d0227bddb9e8$var$getOwnPropertyDescriptor && !$ca69d0227bddb9e8$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$ca69d0227bddb9e8$export$2d1720544b23b823 = $ca69d0227bddb9e8$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $ca69d0227bddb9e8$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $ca69d0227bddb9e8$var$$propertyIsEnumerable;


var $be180e5f424316f2$exports = {};
'use strict';
$be180e5f424316f2$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $7f8562f6c0423e6b$exports = {};
'use strict';
var $07552be8694c2a34$exports = {};
'use strict';



var $07552be8694c2a34$var$$Object = Object;
var $07552be8694c2a34$var$split = $c3ca2daa31bfc688$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$07552be8694c2a34$exports = $3b3cfeebcaab0b7e$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$07552be8694c2a34$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $18e36b683048fab6$exports(it) === 'String' ? $07552be8694c2a34$var$split(it, '') : $07552be8694c2a34$var$$Object(it);
} : $07552be8694c2a34$var$$Object;


var $6706450b3b2001c7$exports = {};
'use strict';
var $c027df839d1fbdfe$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c027df839d1fbdfe$exports = function(it) {
    return it === null || it === undefined;
};


var $6706450b3b2001c7$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$6706450b3b2001c7$exports = function(it) {
    if ($c027df839d1fbdfe$exports(it)) throw new $6706450b3b2001c7$var$$TypeError("Can't call method on " + it);
    return it;
};


$7f8562f6c0423e6b$exports = function(it) {
    return $07552be8694c2a34$exports($6706450b3b2001c7$exports(it));
};


var $a8ddcea05e49a8f8$exports = {};
'use strict';
var $634901f5993d1352$exports = {};
'use strict';

var $c93547f477590fb9$exports = {};
'use strict';

$c93547f477590fb9$exports = function(it) {
    return typeof it == 'object' ? it !== null : $380223d687937afd$exports(it);
};


var $c1a59443cbbf2e36$exports = {};
'use strict';
var $844f70c1fa8a6845$exports = {};
'use strict';
var $d3c3b06832d007ae$exports = {};
'use strict';
$d3c3b06832d007ae$exports = {};




var $844f70c1fa8a6845$var$aFunction = function(variable) {
    return $380223d687937afd$exports(variable) ? variable : undefined;
};
$844f70c1fa8a6845$exports = function(namespace, method) {
    return arguments.length < 2 ? $844f70c1fa8a6845$var$aFunction($d3c3b06832d007ae$exports[namespace]) || $844f70c1fa8a6845$var$aFunction($936962c05e31d160$exports[namespace]) : $d3c3b06832d007ae$exports[namespace] && $d3c3b06832d007ae$exports[namespace][method] || $936962c05e31d160$exports[namespace] && $936962c05e31d160$exports[namespace][method];
};




var $4e6bc22d444085ee$exports = {};
'use strict';
var $89a212be1ac9bf21$exports = {};
'use strict';
var $6c71725c535c07d2$exports = {};
'use strict';

var $532b7e5625233799$exports = {};
'use strict';

var $532b7e5625233799$var$navigator = $936962c05e31d160$exports.navigator;
var $532b7e5625233799$var$userAgent = $532b7e5625233799$var$navigator && $532b7e5625233799$var$navigator.userAgent;
$532b7e5625233799$exports = $532b7e5625233799$var$userAgent ? String($532b7e5625233799$var$userAgent) : '';


var $6c71725c535c07d2$var$process = $936962c05e31d160$exports.process;
var $6c71725c535c07d2$var$Deno = $936962c05e31d160$exports.Deno;
var $6c71725c535c07d2$var$versions = $6c71725c535c07d2$var$process && $6c71725c535c07d2$var$process.versions || $6c71725c535c07d2$var$Deno && $6c71725c535c07d2$var$Deno.version;
var $6c71725c535c07d2$var$v8 = $6c71725c535c07d2$var$versions && $6c71725c535c07d2$var$versions.v8;
var $6c71725c535c07d2$var$match, $6c71725c535c07d2$var$version;
if ($6c71725c535c07d2$var$v8) {
    $6c71725c535c07d2$var$match = $6c71725c535c07d2$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $6c71725c535c07d2$var$version = $6c71725c535c07d2$var$match[0] > 0 && $6c71725c535c07d2$var$match[0] < 4 ? 1 : +($6c71725c535c07d2$var$match[0] + $6c71725c535c07d2$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$6c71725c535c07d2$var$version && $532b7e5625233799$exports) {
    $6c71725c535c07d2$var$match = $532b7e5625233799$exports.match(/Edge\/(\d+)/);
    if (!$6c71725c535c07d2$var$match || $6c71725c535c07d2$var$match[1] >= 74) {
        $6c71725c535c07d2$var$match = $532b7e5625233799$exports.match(/Chrome\/(\d+)/);
        if ($6c71725c535c07d2$var$match) $6c71725c535c07d2$var$version = +$6c71725c535c07d2$var$match[1];
    }
}
$6c71725c535c07d2$exports = $6c71725c535c07d2$var$version;




var $89a212be1ac9bf21$var$$String = $936962c05e31d160$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$89a212be1ac9bf21$exports = !!Object.getOwnPropertySymbols && !$3b3cfeebcaab0b7e$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$89a212be1ac9bf21$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $6c71725c535c07d2$exports && $6c71725c535c07d2$exports < 41;
});


$4e6bc22d444085ee$exports = $89a212be1ac9bf21$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $c1a59443cbbf2e36$var$$Object = Object;
$c1a59443cbbf2e36$exports = $4e6bc22d444085ee$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $844f70c1fa8a6845$exports('Symbol');
    return $380223d687937afd$exports($Symbol) && $edb622f056bc26b8$exports($Symbol.prototype, $c1a59443cbbf2e36$var$$Object(it));
};


var $602ae16b3a722a9f$exports = {};
'use strict';
var $a89b823f37ef2db9$exports = {};
'use strict';

var $7a32ca0e14e78387$exports = {};
'use strict';
var $7a32ca0e14e78387$var$$String = String;
$7a32ca0e14e78387$exports = function(argument) {
    try {
        return $7a32ca0e14e78387$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $a89b823f37ef2db9$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$a89b823f37ef2db9$exports = function(argument) {
    if ($380223d687937afd$exports(argument)) return argument;
    throw new $a89b823f37ef2db9$var$$TypeError($7a32ca0e14e78387$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$602ae16b3a722a9f$exports = function(V, P) {
    var func = V[P];
    return $c027df839d1fbdfe$exports(func) ? undefined : $a89b823f37ef2db9$exports(func);
};


var $2d3f9ad56398d88b$exports = {};
'use strict';



var $2d3f9ad56398d88b$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$2d3f9ad56398d88b$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $380223d687937afd$exports(fn = input.toString) && !$c93547f477590fb9$exports(val = $5af7fa12e239c1d4$exports(fn, input))) return val;
    if ($380223d687937afd$exports(fn = input.valueOf) && !$c93547f477590fb9$exports(val = $5af7fa12e239c1d4$exports(fn, input))) return val;
    if (pref !== 'string' && $380223d687937afd$exports(fn = input.toString) && !$c93547f477590fb9$exports(val = $5af7fa12e239c1d4$exports(fn, input))) return val;
    throw new $2d3f9ad56398d88b$var$$TypeError("Can't convert object to primitive value");
};


var $4d5d0bb9bdb6c6aa$exports = {};
'use strict';

var $cdd9b1bfff19dbc8$exports = {};
'use strict';
var $364626008ba6fee1$exports = {};
'use strict';
var $a0a973fa7ee4372f$exports = {};
'use strict';
$a0a973fa7ee4372f$exports = true;



var $c7f12953c5866aee$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $c7f12953c5866aee$var$defineProperty = Object.defineProperty;
$c7f12953c5866aee$exports = function(key, value) {
    try {
        $c7f12953c5866aee$var$defineProperty($936962c05e31d160$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $936962c05e31d160$exports[key] = value;
    }
    return value;
};


var $364626008ba6fee1$var$SHARED = '__core-js_shared__';
var $364626008ba6fee1$var$store = $364626008ba6fee1$exports = $936962c05e31d160$exports[$364626008ba6fee1$var$SHARED] || $c7f12953c5866aee$exports($364626008ba6fee1$var$SHARED, {});
($364626008ba6fee1$var$store.versions || ($364626008ba6fee1$var$store.versions = [])).push({
    version: '3.47.0',
    mode: $a0a973fa7ee4372f$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$cdd9b1bfff19dbc8$exports = function(key, value) {
    return $364626008ba6fee1$exports[key] || ($364626008ba6fee1$exports[key] = value || {});
};


var $9c28affa4150640a$exports = {};
'use strict';

var $0b4d432f6f23be83$exports = {};
'use strict';

var $0b4d432f6f23be83$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$0b4d432f6f23be83$exports = function(argument) {
    return $0b4d432f6f23be83$var$$Object($6706450b3b2001c7$exports(argument));
};


var $9c28affa4150640a$var$hasOwnProperty = $c3ca2daa31bfc688$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$9c28affa4150640a$exports = Object.hasOwn || function hasOwn(it, key) {
    return $9c28affa4150640a$var$hasOwnProperty($0b4d432f6f23be83$exports(it), key);
};


var $366aedcbdb6770ea$exports = {};
'use strict';

var $366aedcbdb6770ea$var$id = 0;
var $366aedcbdb6770ea$var$postfix = Math.random();
var $366aedcbdb6770ea$var$toString = $c3ca2daa31bfc688$exports(1.1.toString);
$366aedcbdb6770ea$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $366aedcbdb6770ea$var$toString(++$366aedcbdb6770ea$var$id + $366aedcbdb6770ea$var$postfix, 36);
};




var $4d5d0bb9bdb6c6aa$var$Symbol = $936962c05e31d160$exports.Symbol;
var $4d5d0bb9bdb6c6aa$var$WellKnownSymbolsStore = $cdd9b1bfff19dbc8$exports('wks');
var $4d5d0bb9bdb6c6aa$var$createWellKnownSymbol = $4e6bc22d444085ee$exports ? $4d5d0bb9bdb6c6aa$var$Symbol['for'] || $4d5d0bb9bdb6c6aa$var$Symbol : $4d5d0bb9bdb6c6aa$var$Symbol && $4d5d0bb9bdb6c6aa$var$Symbol.withoutSetter || $366aedcbdb6770ea$exports;
$4d5d0bb9bdb6c6aa$exports = function(name) {
    if (!$9c28affa4150640a$exports($4d5d0bb9bdb6c6aa$var$WellKnownSymbolsStore, name)) $4d5d0bb9bdb6c6aa$var$WellKnownSymbolsStore[name] = $89a212be1ac9bf21$exports && $9c28affa4150640a$exports($4d5d0bb9bdb6c6aa$var$Symbol, name) ? $4d5d0bb9bdb6c6aa$var$Symbol[name] : $4d5d0bb9bdb6c6aa$var$createWellKnownSymbol('Symbol.' + name);
    return $4d5d0bb9bdb6c6aa$var$WellKnownSymbolsStore[name];
};


var $634901f5993d1352$var$$TypeError = TypeError;
var $634901f5993d1352$var$TO_PRIMITIVE = $4d5d0bb9bdb6c6aa$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$634901f5993d1352$exports = function(input, pref) {
    if (!$c93547f477590fb9$exports(input) || $c1a59443cbbf2e36$exports(input)) return input;
    var exoticToPrim = $602ae16b3a722a9f$exports(input, $634901f5993d1352$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $5af7fa12e239c1d4$exports(exoticToPrim, input, pref);
        if (!$c93547f477590fb9$exports(result) || $c1a59443cbbf2e36$exports(result)) return result;
        throw new $634901f5993d1352$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $2d3f9ad56398d88b$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$a8ddcea05e49a8f8$exports = function(argument) {
    var key = $634901f5993d1352$exports(argument, 'string');
    return $c1a59443cbbf2e36$exports(key) ? key : key + '';
};



var $2c56693c7751d9e5$exports = {};
'use strict';


var $edab527b9e624b1f$exports = {};
'use strict';


var $edab527b9e624b1f$var$document = $936962c05e31d160$exports.document;
// typeof document.createElement is 'object' in old IE
var $edab527b9e624b1f$var$EXISTS = $c93547f477590fb9$exports($edab527b9e624b1f$var$document) && $c93547f477590fb9$exports($edab527b9e624b1f$var$document.createElement);
$edab527b9e624b1f$exports = function(it) {
    return $edab527b9e624b1f$var$EXISTS ? $edab527b9e624b1f$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$2c56693c7751d9e5$exports = !$c3e68bacccb24be1$exports && !$3b3cfeebcaab0b7e$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($edab527b9e624b1f$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dabfe21458100563$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$dabfe21458100563$export$2d1720544b23b823 = $c3e68bacccb24be1$exports ? $dabfe21458100563$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $7f8562f6c0423e6b$exports(O);
    P = $a8ddcea05e49a8f8$exports(P);
    if ($2c56693c7751d9e5$exports) try {
        return $dabfe21458100563$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($9c28affa4150640a$exports(O, P)) return $be180e5f424316f2$exports(!$5af7fa12e239c1d4$exports($ca69d0227bddb9e8$export$2d1720544b23b823, O, P), O[P]);
};


var $dd3b95617fde12ee$require$getOwnPropertyDescriptor = $dabfe21458100563$export$2d1720544b23b823;
var $7a9d6e38caa453f9$exports = {};
'use strict';


var $7a9d6e38caa453f9$var$replacement = /#|\.prototype\./;
var $7a9d6e38caa453f9$var$isForced = function(feature, detection) {
    var value = $7a9d6e38caa453f9$var$data[$7a9d6e38caa453f9$var$normalize(feature)];
    return value === $7a9d6e38caa453f9$var$POLYFILL ? true : value === $7a9d6e38caa453f9$var$NATIVE ? false : $380223d687937afd$exports(detection) ? $3b3cfeebcaab0b7e$exports(detection) : !!detection;
};
var $7a9d6e38caa453f9$var$normalize = $7a9d6e38caa453f9$var$isForced.normalize = function(string) {
    return String(string).replace($7a9d6e38caa453f9$var$replacement, '.').toLowerCase();
};
var $7a9d6e38caa453f9$var$data = $7a9d6e38caa453f9$var$isForced.data = {};
var $7a9d6e38caa453f9$var$NATIVE = $7a9d6e38caa453f9$var$isForced.NATIVE = 'N';
var $7a9d6e38caa453f9$var$POLYFILL = $7a9d6e38caa453f9$var$isForced.POLYFILL = 'P';
$7a9d6e38caa453f9$exports = $7a9d6e38caa453f9$var$isForced;



var $37e4b8419e2f3d5c$exports = {};
'use strict';



var $37e4b8419e2f3d5c$var$bind = $7c6951035dfa1f63$exports($7c6951035dfa1f63$exports.bind);
// optional / simple context binding
$37e4b8419e2f3d5c$exports = function(fn, that) {
    $a89b823f37ef2db9$exports(fn);
    return that === undefined ? fn : $d5e1f537844e7083$exports ? $37e4b8419e2f3d5c$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};


var $284bd4683da8f80f$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $ad1213cc81f456a9$export$2d1720544b23b823;
'use strict';


var $740056ed1db2b442$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$740056ed1db2b442$exports = $c3e68bacccb24be1$exports && $3b3cfeebcaab0b7e$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $3d6f878a89057dba$exports = {};
'use strict';

var $3d6f878a89057dba$var$$String = String;
var $3d6f878a89057dba$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3d6f878a89057dba$exports = function(argument) {
    if ($c93547f477590fb9$exports(argument)) return argument;
    throw new $3d6f878a89057dba$var$$TypeError($3d6f878a89057dba$var$$String(argument) + ' is not an object');
};



var $ad1213cc81f456a9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $ad1213cc81f456a9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ad1213cc81f456a9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ad1213cc81f456a9$var$ENUMERABLE = 'enumerable';
var $ad1213cc81f456a9$var$CONFIGURABLE = 'configurable';
var $ad1213cc81f456a9$var$WRITABLE = 'writable';
$ad1213cc81f456a9$export$2d1720544b23b823 = $c3e68bacccb24be1$exports ? $740056ed1db2b442$exports ? function defineProperty(O, P, Attributes) {
    $3d6f878a89057dba$exports(O);
    P = $a8ddcea05e49a8f8$exports(P);
    $3d6f878a89057dba$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $ad1213cc81f456a9$var$WRITABLE in Attributes && !Attributes[$ad1213cc81f456a9$var$WRITABLE]) {
        var current = $ad1213cc81f456a9$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$ad1213cc81f456a9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $ad1213cc81f456a9$var$CONFIGURABLE in Attributes ? Attributes[$ad1213cc81f456a9$var$CONFIGURABLE] : current[$ad1213cc81f456a9$var$CONFIGURABLE],
                enumerable: $ad1213cc81f456a9$var$ENUMERABLE in Attributes ? Attributes[$ad1213cc81f456a9$var$ENUMERABLE] : current[$ad1213cc81f456a9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $ad1213cc81f456a9$var$$defineProperty(O, P, Attributes);
} : $ad1213cc81f456a9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3d6f878a89057dba$exports(O);
    P = $a8ddcea05e49a8f8$exports(P);
    $3d6f878a89057dba$exports(Attributes);
    if ($2c56693c7751d9e5$exports) try {
        return $ad1213cc81f456a9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $ad1213cc81f456a9$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$284bd4683da8f80f$exports = $c3e68bacccb24be1$exports ? function(object, key, value) {
    return $ad1213cc81f456a9$export$2d1720544b23b823(object, key, $be180e5f424316f2$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $dd3b95617fde12ee$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $391cd427966f0182$exports(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $dd3b95617fde12ee$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $936962c05e31d160$exports : STATIC ? $936962c05e31d160$exports[TARGET] : $936962c05e31d160$exports[TARGET] && $936962c05e31d160$exports[TARGET].prototype;
    var target = GLOBAL ? $d3c3b06832d007ae$exports : $d3c3b06832d007ae$exports[TARGET] || $284bd4683da8f80f$exports($d3c3b06832d007ae$exports, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $7a9d6e38caa453f9$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $9c28affa4150640a$exports(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $dd3b95617fde12ee$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $37e4b8419e2f3d5c$exports(sourceProperty, $936962c05e31d160$exports);
        else if (options.wrap && USE_NATIVE) resultProperty = $dd3b95617fde12ee$var$wrapConstructor(sourceProperty);
        else if (PROTO && $380223d687937afd$exports(sourceProperty)) resultProperty = $7c6951035dfa1f63$exports(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $284bd4683da8f80f$exports(resultProperty, 'sham', true);
        $284bd4683da8f80f$exports(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$9c28affa4150640a$exports($d3c3b06832d007ae$exports, VIRTUAL_PROTOTYPE)) $284bd4683da8f80f$exports($d3c3b06832d007ae$exports, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $284bd4683da8f80f$exports($d3c3b06832d007ae$exports[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $284bd4683da8f80f$exports(targetPrototype, key, sourceProperty);
        }
    }
};



var $7434b2fefbfba2d4$exports = {};
'use strict';
var $ff4bfd6c9b32a0d8$exports = {};
'use strict';
var $48dcb056cb8d4099$exports = {};
'use strict';
var $629a492182bcfcaf$exports = {};
'use strict';
var $629a492182bcfcaf$var$ceil = Math.ceil;
var $629a492182bcfcaf$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$629a492182bcfcaf$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $629a492182bcfcaf$var$floor : $629a492182bcfcaf$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$48dcb056cb8d4099$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $629a492182bcfcaf$exports(number);
};


var $ff4bfd6c9b32a0d8$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$ff4bfd6c9b32a0d8$exports = function(argument) {
    var len = $48dcb056cb8d4099$exports(argument);
    return len > 0 ? $ff4bfd6c9b32a0d8$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$7434b2fefbfba2d4$exports = function(obj) {
    return $ff4bfd6c9b32a0d8$exports(obj.length);
};


var $58f02076db9da0b9$exports = {};
'use strict';

var $9963164fb41290eb$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$9963164fb41290eb$exports = Array.isArray || function isArray(argument) {
    return $18e36b683048fab6$exports(argument) === 'Array';
};


var $58f02076db9da0b9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $58f02076db9da0b9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $58f02076db9da0b9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $c3e68bacccb24be1$exports && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
$58f02076db9da0b9$exports = $58f02076db9da0b9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($9963164fb41290eb$exports(O) && !$58f02076db9da0b9$var$getOwnPropertyDescriptor(O, 'length').writable) throw new $58f02076db9da0b9$var$$TypeError('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};


var $398710cd54dc6bbd$exports = {};
'use strict';
var $398710cd54dc6bbd$var$$TypeError = TypeError;
var $398710cd54dc6bbd$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$398710cd54dc6bbd$exports = function(it) {
    if (it > $398710cd54dc6bbd$var$MAX_SAFE_INTEGER) throw $398710cd54dc6bbd$var$$TypeError('Maximum allowed index exceeded');
    return it;
};



var $9199bac4eb2e5dee$var$INCORRECT_TO_LENGTH = $3b3cfeebcaab0b7e$exports(function() {
    return [].push.call({
        length: 0x100000000
    }, 1) !== 4294967297;
});
// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var $9199bac4eb2e5dee$var$properErrorOnNonWritableLength = function() {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).push();
    } catch (error) {
        return error instanceof TypeError;
    }
};
var $9199bac4eb2e5dee$var$FORCED = $9199bac4eb2e5dee$var$INCORRECT_TO_LENGTH || !$9199bac4eb2e5dee$var$properErrorOnNonWritableLength();
// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$dd3b95617fde12ee$exports({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $9199bac4eb2e5dee$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function push(item) {
        var O = $0b4d432f6f23be83$exports(this);
        var len = $7434b2fefbfba2d4$exports(O);
        var argCount = arguments.length;
        $398710cd54dc6bbd$exports(len + argCount);
        for(var i = 0; i < argCount; i++){
            O[len] = arguments[i];
            len++;
        }
        $58f02076db9da0b9$exports(O, len);
        return len;
    }
});


var $4df9d98921e75f68$exports = {};
'use strict';


$4df9d98921e75f68$exports = function(CONSTRUCTOR, METHOD) {
    var Namespace = $d3c3b06832d007ae$exports[CONSTRUCTOR + 'Prototype'];
    var pureMethod = Namespace && Namespace[METHOD];
    if (pureMethod) return pureMethod;
    var NativeConstructor = $936962c05e31d160$exports[CONSTRUCTOR];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    return NativePrototype && NativePrototype[METHOD];
};


$b6366a4f9273b9c5$exports = $4df9d98921e75f68$exports('Array', 'push');


var $226d7354db2b187a$var$ArrayPrototype = Array.prototype;
$226d7354db2b187a$exports = function(it) {
    var own = it.push;
    return it === $226d7354db2b187a$var$ArrayPrototype || $edb622f056bc26b8$exports($226d7354db2b187a$var$ArrayPrototype, it) && own === $226d7354db2b187a$var$ArrayPrototype.push ? $b6366a4f9273b9c5$exports : own;
};


$1c1c6bce1a869e4d$exports = $226d7354db2b187a$exports;


var $1eb0299e6a3602cd$exports = {};
'use strict';
var $82d68a05d5d5c4ad$exports = {};
'use strict';
'use strict';


var $6e8a9b7fe2617fff$exports = {};
'use strict';
var $216bcc0c99096fb3$exports = {};
'use strict';



var $4ca58d674ca87a06$exports = {};
'use strict';

var $b41812c69586cd3e$exports = {};
'use strict';

var $b41812c69586cd3e$var$max = Math.max;
var $b41812c69586cd3e$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$b41812c69586cd3e$exports = function(index, length) {
    var integer = $48dcb056cb8d4099$exports(index);
    return integer < 0 ? $b41812c69586cd3e$var$max(integer + length, 0) : $b41812c69586cd3e$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $4ca58d674ca87a06$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $7f8562f6c0423e6b$exports($this);
        var length = $7434b2fefbfba2d4$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $b41812c69586cd3e$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$4ca58d674ca87a06$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $4ca58d674ca87a06$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $4ca58d674ca87a06$var$createMethod(false)
};


var $216bcc0c99096fb3$require$indexOf = $4ca58d674ca87a06$exports.indexOf;
var $c131a9f8f1192565$exports = {};
'use strict';
$c131a9f8f1192565$exports = {};


var $216bcc0c99096fb3$var$push = $c3ca2daa31bfc688$exports([].push);
$216bcc0c99096fb3$exports = function(object, names) {
    var O = $7f8562f6c0423e6b$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$9c28affa4150640a$exports($c131a9f8f1192565$exports, key) && $9c28affa4150640a$exports(O, key) && $216bcc0c99096fb3$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($9c28affa4150640a$exports(O, key = names[i++])) ~$216bcc0c99096fb3$require$indexOf(result, key) || $216bcc0c99096fb3$var$push(result, key);
    return result;
};


var $68000919606a09dc$exports = {};
'use strict';
// IE8- don't enum bug keys
$68000919606a09dc$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$6e8a9b7fe2617fff$exports = Object.keys || function keys(O) {
    return $216bcc0c99096fb3$exports(O, $68000919606a09dc$exports);
};



var $bf2dc31e98863ed1$var$FAILS_ON_PRIMITIVES = $3b3cfeebcaab0b7e$exports(function() {
    $6e8a9b7fe2617fff$exports(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$dd3b95617fde12ee$exports({
    target: 'Object',
    stat: true,
    forced: $bf2dc31e98863ed1$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $6e8a9b7fe2617fff$exports($0b4d432f6f23be83$exports(it));
    }
});


'use strict';










var $990eed868b44f732$exports = {};
'use strict';
var $9c94a7637a1b3474$exports = {};
'use strict';
var $a37ccbf43b8c960a$exports = {};
'use strict';

var $a37ccbf43b8c960a$var$TO_STRING_TAG = $4d5d0bb9bdb6c6aa$exports('toStringTag');
var $a37ccbf43b8c960a$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$a37ccbf43b8c960a$var$test[$a37ccbf43b8c960a$var$TO_STRING_TAG] = 'z';
$a37ccbf43b8c960a$exports = String($a37ccbf43b8c960a$var$test) === '[object z]';





var $9c94a7637a1b3474$var$TO_STRING_TAG = $4d5d0bb9bdb6c6aa$exports('toStringTag');
var $9c94a7637a1b3474$var$$Object = Object;
// ES3 wrong here
var $9c94a7637a1b3474$var$CORRECT_ARGUMENTS = $18e36b683048fab6$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $9c94a7637a1b3474$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$9c94a7637a1b3474$exports = $a37ccbf43b8c960a$exports ? $18e36b683048fab6$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $9c94a7637a1b3474$var$tryGet(O = $9c94a7637a1b3474$var$$Object(it), $9c94a7637a1b3474$var$TO_STRING_TAG)) == 'string' ? tag : $9c94a7637a1b3474$var$CORRECT_ARGUMENTS ? $18e36b683048fab6$exports(O) : (result = $18e36b683048fab6$exports(O)) === 'Object' && $380223d687937afd$exports(O.callee) ? 'Arguments' : result;
};


var $990eed868b44f732$var$$String = String;
$990eed868b44f732$exports = function(argument) {
    if ($9c94a7637a1b3474$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $990eed868b44f732$var$$String(argument);
};



var $20b34104ab9ff842$exports = {};
'use strict';



$20b34104ab9ff842$exports = function(object, key, value) {
    if ($c3e68bacccb24be1$exports) $ad1213cc81f456a9$export$2d1720544b23b823(object, key, $be180e5f424316f2$exports(0, value));
    else object[key] = value;
};



var $b95742385e47a219$exports = {};
'use strict';


var $b95742385e47a219$var$$SyntaxError = SyntaxError;
var $b95742385e47a219$var$$parseInt = parseInt;
var $b95742385e47a219$var$fromCharCode = String.fromCharCode;
var $b95742385e47a219$var$at = $c3ca2daa31bfc688$exports(''.charAt);
var $b95742385e47a219$var$slice = $c3ca2daa31bfc688$exports(''.slice);
var $b95742385e47a219$var$exec = $c3ca2daa31bfc688$exports(/./.exec);
var $b95742385e47a219$var$codePoints = {
    '\\"': '"',
    '\\\\': '\\',
    '\\/': '/',
    '\\b': '\b',
    '\\f': '\f',
    '\\n': '\n',
    '\\r': '\r',
    '\\t': '\t'
};
var $b95742385e47a219$var$IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
// eslint-disable-next-line regexp/no-control-character -- safe
var $b95742385e47a219$var$IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
$b95742385e47a219$exports = function(source, i) {
    var unterminated = true;
    var value = '';
    while(i < source.length){
        var chr = $b95742385e47a219$var$at(source, i);
        if (chr === '\\') {
            var twoChars = $b95742385e47a219$var$slice(source, i, i + 2);
            if ($9c28affa4150640a$exports($b95742385e47a219$var$codePoints, twoChars)) {
                value += $b95742385e47a219$var$codePoints[twoChars];
                i += 2;
            } else if (twoChars === '\\u') {
                i += 2;
                var fourHexDigits = $b95742385e47a219$var$slice(source, i, i + 4);
                if (!$b95742385e47a219$var$exec($b95742385e47a219$var$IS_4_HEX_DIGITS, fourHexDigits)) throw new $b95742385e47a219$var$$SyntaxError('Bad Unicode escape at: ' + i);
                value += $b95742385e47a219$var$fromCharCode($b95742385e47a219$var$$parseInt(fourHexDigits, 16));
                i += 4;
            } else throw new $b95742385e47a219$var$$SyntaxError('Unknown escape sequence: "' + twoChars + '"');
        } else if (chr === '"') {
            unterminated = false;
            i++;
            break;
        } else {
            if ($b95742385e47a219$var$exec($b95742385e47a219$var$IS_C0_CONTROL_CODE, chr)) throw new $b95742385e47a219$var$$SyntaxError('Bad control character in string literal at: ' + i);
            value += chr;
            i++;
        }
    }
    if (unterminated) throw new $b95742385e47a219$var$$SyntaxError('Unterminated string at: ' + i);
    return {
        value: value,
        end: i
    };
};



var $e103b2a3258dd496$var$JSON = $936962c05e31d160$exports.JSON;
var $e103b2a3258dd496$var$Number = $936962c05e31d160$exports.Number;
var $e103b2a3258dd496$var$SyntaxError = $936962c05e31d160$exports.SyntaxError;
var $e103b2a3258dd496$var$nativeParse = $e103b2a3258dd496$var$JSON && $e103b2a3258dd496$var$JSON.parse;
var $e103b2a3258dd496$var$enumerableOwnProperties = $844f70c1fa8a6845$exports('Object', 'keys');
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e103b2a3258dd496$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e103b2a3258dd496$var$at = $c3ca2daa31bfc688$exports(''.charAt);
var $e103b2a3258dd496$var$slice = $c3ca2daa31bfc688$exports(''.slice);
var $e103b2a3258dd496$var$exec = $c3ca2daa31bfc688$exports(/./.exec);
var $e103b2a3258dd496$var$push = $c3ca2daa31bfc688$exports([].push);
var $e103b2a3258dd496$var$IS_DIGIT = /^\d$/;
var $e103b2a3258dd496$var$IS_NON_ZERO_DIGIT = /^[1-9]$/;
var $e103b2a3258dd496$var$IS_NUMBER_START = /^[\d-]$/;
var $e103b2a3258dd496$var$IS_WHITESPACE = /^[\t\n\r ]$/;
var $e103b2a3258dd496$var$PRIMITIVE = 0;
var $e103b2a3258dd496$var$OBJECT = 1;
var $e103b2a3258dd496$var$$parse = function(source, reviver) {
    source = $990eed868b44f732$exports(source);
    var context = new $e103b2a3258dd496$var$Context(source, 0, '');
    var root = context.parse();
    var value = root.value;
    var endIndex = context.skip($e103b2a3258dd496$var$IS_WHITESPACE, root.end);
    if (endIndex < source.length) throw new $e103b2a3258dd496$var$SyntaxError('Unexpected extra character: "' + $e103b2a3258dd496$var$at(source, endIndex) + '" after the parsed data at: ' + endIndex);
    return $380223d687937afd$exports(reviver) ? $e103b2a3258dd496$var$internalize({
        '': value
    }, '', reviver, root) : value;
};
var $e103b2a3258dd496$var$internalize = function(holder, name, reviver, node) {
    var val = holder[name];
    var unmodified = node && val === node.value;
    var context = unmodified && typeof node.source == 'string' ? {
        source: node.source
    } : {};
    var elementRecordsLen, keys, len, i, P;
    if ($c93547f477590fb9$exports(val)) {
        var nodeIsArray = $9963164fb41290eb$exports(val);
        var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
        if (nodeIsArray) {
            elementRecordsLen = nodes.length;
            len = $7434b2fefbfba2d4$exports(val);
            for(i = 0; i < len; i++)$e103b2a3258dd496$var$internalizeProperty(val, i, $e103b2a3258dd496$var$internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
        } else {
            keys = $e103b2a3258dd496$var$enumerableOwnProperties(val);
            len = $7434b2fefbfba2d4$exports(keys);
            for(i = 0; i < len; i++){
                P = keys[i];
                $e103b2a3258dd496$var$internalizeProperty(val, P, $e103b2a3258dd496$var$internalize(val, P, reviver, $9c28affa4150640a$exports(nodes, P) ? nodes[P] : undefined));
            }
        }
    }
    return $5af7fa12e239c1d4$exports(reviver, holder, name, val, context);
};
var $e103b2a3258dd496$var$internalizeProperty = function(object, key, value) {
    if ($c3e68bacccb24be1$exports) {
        var descriptor = $e103b2a3258dd496$var$getOwnPropertyDescriptor(object, key);
        if (descriptor && !descriptor.configurable) return;
    }
    if (value === undefined) delete object[key];
    else $20b34104ab9ff842$exports(object, key, value);
};
var $e103b2a3258dd496$var$Node = function(value, end, source, nodes) {
    this.value = value;
    this.end = end;
    this.source = source;
    this.nodes = nodes;
};
var $e103b2a3258dd496$var$Context = function(source, index) {
    this.source = source;
    this.index = index;
};
// https://www.json.org/json-en.html
$e103b2a3258dd496$var$Context.prototype = {
    fork: function(nextIndex) {
        return new $e103b2a3258dd496$var$Context(this.source, nextIndex);
    },
    parse: function() {
        var source = this.source;
        var i = this.skip($e103b2a3258dd496$var$IS_WHITESPACE, this.index);
        var fork = this.fork(i);
        var chr = $e103b2a3258dd496$var$at(source, i);
        if ($e103b2a3258dd496$var$exec($e103b2a3258dd496$var$IS_NUMBER_START, chr)) return fork.number();
        switch(chr){
            case '{':
                return fork.object();
            case '[':
                return fork.array();
            case '"':
                return fork.string();
            case 't':
                return fork.keyword(true);
            case 'f':
                return fork.keyword(false);
            case 'n':
                return fork.keyword(null);
        }
        throw new $e103b2a3258dd496$var$SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
    },
    node: function(type, value, start, end, nodes) {
        return new $e103b2a3258dd496$var$Node(value, end, type ? null : $e103b2a3258dd496$var$slice(this.source, start, end), nodes);
    },
    object: function() {
        var source = this.source;
        var i = this.index + 1;
        var expectKeypair = false;
        var object = {};
        var nodes = {};
        while(i < source.length){
            i = this.until([
                '"',
                '}'
            ], i);
            if ($e103b2a3258dd496$var$at(source, i) === '}' && !expectKeypair) {
                i++;
                break;
            }
            // Parsing the key
            var result = this.fork(i).string();
            var key = result.value;
            i = result.end;
            i = this.until([
                ':'
            ], i) + 1;
            // Parsing value
            i = this.skip($e103b2a3258dd496$var$IS_WHITESPACE, i);
            result = this.fork(i).parse();
            $20b34104ab9ff842$exports(nodes, key, result);
            $20b34104ab9ff842$exports(object, key, result.value);
            i = this.until([
                ',',
                '}'
            ], result.end);
            var chr = $e103b2a3258dd496$var$at(source, i);
            if (chr === ',') {
                expectKeypair = true;
                i++;
            } else if (chr === '}') {
                i++;
                break;
            }
        }
        return this.node($e103b2a3258dd496$var$OBJECT, object, this.index, i, nodes);
    },
    array: function() {
        var source = this.source;
        var i = this.index + 1;
        var expectElement = false;
        var array = [];
        var nodes = [];
        while(i < source.length){
            i = this.skip($e103b2a3258dd496$var$IS_WHITESPACE, i);
            if ($e103b2a3258dd496$var$at(source, i) === ']' && !expectElement) {
                i++;
                break;
            }
            var result = this.fork(i).parse();
            $e103b2a3258dd496$var$push(nodes, result);
            $e103b2a3258dd496$var$push(array, result.value);
            i = this.until([
                ',',
                ']'
            ], result.end);
            if ($e103b2a3258dd496$var$at(source, i) === ',') {
                expectElement = true;
                i++;
            } else if ($e103b2a3258dd496$var$at(source, i) === ']') {
                i++;
                break;
            }
        }
        return this.node($e103b2a3258dd496$var$OBJECT, array, this.index, i, nodes);
    },
    string: function() {
        var index = this.index;
        var parsed = $b95742385e47a219$exports(this.source, this.index + 1);
        return this.node($e103b2a3258dd496$var$PRIMITIVE, parsed.value, index, parsed.end);
    },
    number: function() {
        var source = this.source;
        var startIndex = this.index;
        var i = startIndex;
        if ($e103b2a3258dd496$var$at(source, i) === '-') i++;
        if ($e103b2a3258dd496$var$at(source, i) === '0') i++;
        else if ($e103b2a3258dd496$var$exec($e103b2a3258dd496$var$IS_NON_ZERO_DIGIT, $e103b2a3258dd496$var$at(source, i))) i = this.skip($e103b2a3258dd496$var$IS_DIGIT, i + 1);
        else throw new $e103b2a3258dd496$var$SyntaxError('Failed to parse number at: ' + i);
        if ($e103b2a3258dd496$var$at(source, i) === '.') i = this.skip($e103b2a3258dd496$var$IS_DIGIT, i + 1);
        if ($e103b2a3258dd496$var$at(source, i) === 'e' || $e103b2a3258dd496$var$at(source, i) === 'E') {
            i++;
            if ($e103b2a3258dd496$var$at(source, i) === '+' || $e103b2a3258dd496$var$at(source, i) === '-') i++;
            var exponentStartIndex = i;
            i = this.skip($e103b2a3258dd496$var$IS_DIGIT, i);
            if (exponentStartIndex === i) throw new $e103b2a3258dd496$var$SyntaxError("Failed to parse number's exponent value at: " + i);
        }
        return this.node($e103b2a3258dd496$var$PRIMITIVE, $e103b2a3258dd496$var$Number($e103b2a3258dd496$var$slice(source, startIndex, i)), startIndex, i);
    },
    keyword: function(value) {
        var keyword = '' + value;
        var index = this.index;
        var endIndex = index + keyword.length;
        if ($e103b2a3258dd496$var$slice(this.source, index, endIndex) !== keyword) throw new $e103b2a3258dd496$var$SyntaxError('Failed to parse value at: ' + index);
        return this.node($e103b2a3258dd496$var$PRIMITIVE, value, index, endIndex);
    },
    skip: function(regex, i) {
        var source = this.source;
        for(; i < source.length; i++)if (!$e103b2a3258dd496$var$exec(regex, $e103b2a3258dd496$var$at(source, i))) break;
        return i;
    },
    until: function(array, i) {
        i = this.skip($e103b2a3258dd496$var$IS_WHITESPACE, i);
        var chr = $e103b2a3258dd496$var$at(this.source, i);
        for(var j = 0; j < array.length; j++)if (array[j] === chr) return i;
        throw new $e103b2a3258dd496$var$SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
    }
};
var $e103b2a3258dd496$var$NO_SOURCE_SUPPORT = $3b3cfeebcaab0b7e$exports(function() {
    var unsafeInt = '9007199254740993';
    var source;
    $e103b2a3258dd496$var$nativeParse(unsafeInt, function(key, value, context) {
        source = context.source;
    });
    return source !== unsafeInt;
});
var $e103b2a3258dd496$var$PROPER_BASE_PARSE = $89a212be1ac9bf21$exports && !$3b3cfeebcaab0b7e$exports(function() {
    // Safari 9 bug
    return 1 / $e103b2a3258dd496$var$nativeParse('-0 \t') !== -Infinity;
});
// `JSON.parse` method
// https://tc39.es/ecma262/#sec-json.parse
// https://github.com/tc39/proposal-json-parse-with-source
$dd3b95617fde12ee$exports({
    target: 'JSON',
    stat: true,
    forced: $e103b2a3258dd496$var$NO_SOURCE_SUPPORT
}, {
    parse: function parse(text, reviver) {
        return $e103b2a3258dd496$var$PROPER_BASE_PARSE && !$380223d687937afd$exports(reviver) ? $e103b2a3258dd496$var$nativeParse(text) : $e103b2a3258dd496$var$$parse(text, reviver);
    }
});



$82d68a05d5d5c4ad$exports = $d3c3b06832d007ae$exports.JSON.parse;


$1eb0299e6a3602cd$exports = $82d68a05d5d5c4ad$exports;



var $ieaan = parcelRequire("ieaan");
function $2bc97902f5cc4941$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $2bc97902f5cc4941$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $2bc97902f5cc4941$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $2bc97902f5cc4941$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $2bc97902f5cc4941$export$2e2bcd8739ae039 = $2bc97902f5cc4941$export$4f5d2d50c9deca37;


function $428744f8f90337b7$export$2e2bcd8739ae039(component, markers) {
    Object.assign(component, markers);
}



var $ieaan = parcelRequire("ieaan");
const $07b61efe40a5ad0e$export$9824d860d0b120d9 = 'nb-NO';
const $07b61efe40a5ad0e$export$ebe860a2db7990ad = 'NOK';
const $07b61efe40a5ad0e$export$dfbea0c7aa245503 = 'narrowSymbol';
const $07b61efe40a5ad0e$export$9b7cc2bfbde84790 = 'code';
const $07b61efe40a5ad0e$export$5cd3cf0adfc46395 = 'NO';


var $760f6e735ba35488$export$2e2bcd8739ae039 = {
    'nb-NO': {
        TextCounter: {
            characterDown: "%count av %max tegn gjenst\xe5r.",
            characterUp: 'Du har brukt %count av %max tegn.',
            characterExceeded: "%count tegn over grensen p\xe5 %max."
        },
        TimelineItem: {
            altLabelCompleted: "Utf\xf8rt",
            altLabelCurrent: "N\xe5v\xe6rende",
            altLabelUpcoming: 'Kommende'
        },
        Breadcrumb: {
            navText: 'Sidehierarki',
            goBackText: 'Tilbake',
            homeText: 'Hjem',
            backToText: "G\xe5 til ..."
        },
        DateFormat: {
            invalidDate: 'Ugyldig dato: {value}'
        },
        DatePicker: {
            day: 'dag',
            month: "m\xe5ned",
            year: "\xe5r",
            start: 'fra',
            end: 'til',
            selectedDate: 'Valgt dato: %s',
            selectedDateRange: 'Valgte datoer: %s',
            selectedMonth: "Valgt m\xe5ned %s",
            selectedYear: "Valgt \xe5r %s",
            nextMonth: "Neste m\xe5ned %s",
            prevMonth: "Forrige m\xe5ned %s",
            nextYear: "Neste \xe5r %s",
            prevYear: "Forrige \xe5r %s",
            openPickerText: "\xc5pne datovelger",
            maskOrder: 'dd/mm/yyyy',
            maskPlaceholder: "dd.mm.\xe5\xe5\xe5\xe5",
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDay: 'monday',
            submitButtonText: 'Ok',
            cancelButtonText: 'Avbryt',
            resetButtonText: 'Tilbakestill',
            placeholderCharacters: {
                day: 'd',
                month: 'm',
                year: "\xe5"
            }
        },
        Anchor: {
            targetBlankTitle: "\xc5pner et nytt vindu"
        },
        GlobalStatus: {
            defaultTitle: 'En feil har skjedd',
            closeText: 'Lukk',
            statusAnchorText: "G\xe5 til %s"
        },
        GlobalError: {
            404: {
                title: "Vi finner ikke siden du leter etter \u2026",
                text: "Sikker p\xe5 at du har skrevet riktig adresse? Eller har vi rotet med lenkene?"
            },
            500: {
                title: 'Beklager, her skjedde det noe feil!',
                text: "Tjenesten fungerer ikke slik den skal for \xf8yeblikket, men pr\xf8v igjen senere."
            },
            errorMessageCode: 'Feilmeldings-kode: %statusCode',
            help: 'Her er noen lenker som kanskje kan hjelpe:'
        },
        ProgressIndicator: {
            indicatorLabel: 'Vennligst vent ...'
        },
        DrawerList: {
            defaultGroupSR: 'Standardvalg',
            missingGroup: 'Gruppe',
            noGroupSR: 'Andre valg'
        },
        Dropdown: {
            title: 'Valgmeny'
        },
        Autocomplete: {
            title: 'Skriv og velg',
            submitButtonTitle: 'Vis alternativer',
            noOptions: 'Ingen alternativer',
            showAll: 'Vis alt',
            showOptionsSr: 'Bla gjennom alternativer, lukk med esc knappen',
            ariaLiveOptions: '%s alternativer',
            selectedSr: 'Valgt:',
            indicatorLabel: 'Henter data ...'
        },
        Modal: {
            dialogTitle: 'Separat Vindu',
            closeTitle: 'Lukk'
        },
        Dialog: {
            declineText: 'Avbryt',
            confirmText: 'Godta'
        },
        CopyOnClick: {
            clipboardCopy: 'Kopiert'
        },
        NumberFormat: {
            clipboardCopy: 'Kopiert',
            notAvailable: 'Ikke tilgjengelig'
        },
        Stat: {
            rating: '%value av %max'
        },
        HelpButton: {
            title: 'Hjelpetekst',
            ariaRole: 'Hjelp-knapp'
        },
        Input: {
            submitButtonTitle: "S\xf8k",
            clearButtonTitle: 'Nullstill'
        },
        Pagination: {
            buttonTitle: 'Side %s',
            nextTitle: 'Neste side',
            prevTitle: 'Forrige side',
            morePages: '%s flere sider',
            isLoadingText: 'Laster nytt innhold',
            loadButtonText: 'Vis mer innhold'
        },
        Tabs: {
            prevButtonTitle: 'Forrige fane',
            nextButtonTitle: 'Neste fane'
        },
        Skeleton: {
            ariaBusy: 'Behandler data ...',
            ariaReady: "Klar til \xe5 samhandle"
        },
        StepIndicator: {
            overviewTitle: 'Stegoversikt',
            stepTitle: 'Steg %step av %count:'
        },
        Slider: {
            addTitle: "\xd8k (%s)",
            subtractTitle: 'Reduser (%s)'
        },
        PaymentCard: {
            textBlocked: 'Sperret',
            textExpired: "Utl\xf8pt",
            textNotActive: 'Inaktivt',
            textNewOrder: 'Bestilt',
            textOrderInProcess: "P\xe5 vei",
            textReplaced: 'Erstattet',
            textRenewed: 'Fornyes',
            textNew: 'Nytt',
            textUnknown: 'Ukjent'
        },
        Tag: {
            removeIconTitle: 'Fjern',
            addIconTitle: 'Legg til'
        },
        Table: {
            accordionToggleButtonSR: 'Vis mer innhold',
            accordionMoreContentSR: 'Mer innhold i neste rad',
            navigationButtonSR: 'Naviger til mer innhold'
        },
        Upload: {
            title: 'Last opp dokumenter',
            text: 'Dra og slipp eller velg hvilke filer du vil laste opp.',
            textSingular: 'Dra og slipp eller velg hvilken fil du vil laste opp.',
            fileTypeTableCaption: "Tillatte filformater og maks filst\xf8rrelse",
            fileTypeDescription: 'Tillatte filformater:',
            fileSizeDescription: "Maks filst\xf8rrelse:",
            fileAmountDescription: 'Maks antall filer:',
            fileSizeContent: '%size MB',
            buttonText: 'Velg filer',
            buttonTextSingular: 'Velg fil',
            loadingText: 'Laster',
            errorLargeFile: "Filen du pr\xf8ver \xe5 laste opp er for stor, den maksimale st\xf8ttede st\xf8rrelsen er %size MB.",
            errorAmountLimit: 'Det er begrenset hvor mange filer du kan laste opp (%amount).',
            errorUnsupportedFile: "Filen du pr\xf8ver \xe5 laste opp er ikke st\xf8ttet.",
            deleteButton: 'Slett',
            listAriaLabel: 'opplastede filer'
        },
        Popover: {
            closeButtonTitle: 'Lukk',
            openTriggerTitle: "Klikk for \xe5 \xe5pne",
            closeTriggerTitle: "Klikk for \xe5 lukke",
            focusTrapTitle: "Klikk for \xe5 g\xe5 tilbake"
        },
        List: {
            showMore: 'Vis mer',
            showLess: 'Vis mindre'
        },
        TermDefinition: {
            closeButtonTitle: 'Lukk ordforklaring',
            openTriggerTitle: "Klikk for \xe5 \xe5pne ordforklaring",
            closeTriggerTitle: "Klikk for \xe5 lukke ordforklaring"
        },
        Filter: {
            ariaLabel: 'Filter',
            activeFiltersLabel: 'Aktive filtre',
            activeFiltersCountLabel: '%s aktive filtre',
            clearAllLabel: 'Fjern alle',
            panelButtonLabel: 'Filter',
            hideFilterLabel: 'Skjul filter',
            applyFilterLabel: 'Bruk filter',
            cancelFilterLabel: 'Avbryt',
            dateLabel: 'Dato',
            sortButtonLabel: 'Sorter',
            noResultsMessage: "Pr\xf8v \xe5 endre eller fjerne noen filtre.",
            resultCountMessage: '%s treff'
        }
    }
};


var $d904a064453aaabf$export$2e2bcd8739ae039 = {
    'en-GB': {
        TextCounter: {
            characterDown: '%count of %max characters remaining.',
            characterUp: 'You have used %count of %max characters.',
            characterExceeded: '%count characters over the limit of %max.'
        },
        TimelineItem: {
            altLabelCompleted: 'Completed',
            altLabelCurrent: 'Current',
            altLabelUpcoming: 'Upcoming'
        },
        Breadcrumb: {
            navText: 'Page hierarchy',
            goBackText: 'Back',
            homeText: 'Home',
            backToText: 'Go to ...'
        },
        DateFormat: {
            invalidDate: 'Invalid date: {value}'
        },
        DatePicker: {
            day: 'Day',
            month: 'Month',
            year: 'Year',
            start: 'from',
            end: 'to',
            selectedDate: 'Selected date: %s',
            selectedDateRange: 'Selected dates: %s',
            selectedMonth: 'Selected month %s',
            selectedYear: 'Selected year %s',
            nextMonth: 'Next month %s',
            prevMonth: 'Previous month %s',
            nextYear: 'Next year %s',
            prevYear: 'Previous year %s',
            openPickerText: 'Open date picker',
            maskOrder: 'dd/mm/yyyy',
            maskPlaceholder: 'dd/mm/yyyy',
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDay: 'monday',
            submitButtonText: 'OK',
            cancelButtonText: 'Cancel',
            resetButtonText: 'Reset',
            placeholderCharacters: {
                day: 'd',
                month: 'm',
                year: 'y'
            }
        },
        Anchor: {
            targetBlankTitle: 'Opens a new window'
        },
        GlobalStatus: {
            defaultTitle: 'An error has occurred',
            closeText: 'Close',
            statusAnchorText: 'Go to %s'
        },
        GlobalError: {
            404: {
                title: "We can't find the page you're looking for \u2026",
                text: 'Are you sure you have entered the correct address? Or have we messed with the links?'
            },
            500: {
                title: 'Sorry, a technical error occurred!',
                text: 'The service is not working properly at the moment. Try again later.'
            },
            errorMessageCode: 'Error code: %statusCode',
            help: 'Here are some links that might help:'
        },
        ProgressIndicator: {
            indicatorLabel: 'Please wait ...'
        },
        DrawerList: {
            defaultGroupSR: 'Default options',
            missingGroup: 'Group',
            noGroupSR: 'Other options'
        },
        Dropdown: {
            title: 'Option Menu'
        },
        Autocomplete: {
            title: 'Type and select',
            submitButtonTitle: 'Show options',
            noOptions: 'No options',
            showAll: 'Show everything',
            showOptionsSr: 'Browse options, close with esc button',
            ariaLiveOptions: '%s options',
            selectedSr: 'Selected:',
            indicatorLabel: 'Getting data ...'
        },
        Modal: {
            dialogTitle: 'Dialog Window',
            closeTitle: 'Close'
        },
        Dialog: {
            declineText: 'Cancel',
            confirmText: 'Confirm'
        },
        CopyOnClick: {
            clipboardCopy: 'Copied'
        },
        NumberFormat: {
            clipboardCopy: 'Copied',
            notAvailable: 'Not available'
        },
        Stat: {
            rating: '%value of %max'
        },
        HelpButton: {
            title: 'Help text',
            ariaRole: 'Help button'
        },
        Skeleton: {
            ariaBusy: 'In progress ...',
            ariaReady: 'Ready to interact'
        },
        Input: {
            submitButtonTitle: 'Search',
            clearButtonTitle: 'Clear value'
        },
        Pagination: {
            buttonTitle: 'Page %s',
            nextTitle: 'Next page',
            prevTitle: 'Previous page',
            morePages: '%s more pages',
            isLoadingText: 'Loading new content',
            loadButtonText: 'Show more content'
        },
        Tabs: {
            prevButtonTitle: 'Previous tab',
            nextButtonTitle: 'Next tab'
        },
        StepIndicator: {
            overviewTitle: 'Steps Overview',
            stepTitle: 'Step %step of %count:'
        },
        Slider: {
            addTitle: 'Increase (%s)',
            subtractTitle: 'Decrease (%s)'
        },
        PaymentCard: {
            textBlocked: 'Blocked',
            textExpired: 'Expired',
            textNotActive: 'Inactive',
            textNewOrder: 'Ordered',
            textOrderInProcess: 'On the way',
            textReplaced: 'Replaced',
            textRenewed: 'Renewed',
            textNew: 'New',
            textUnknown: 'Unknown'
        },
        Tag: {
            removeIconTitle: 'Remove',
            addIconTitle: 'Add'
        },
        Table: {
            accordionToggleButtonSR: 'Show more content',
            accordionMoreContentSR: 'More content in the next row',
            navigationButtonSR: 'Navigate to more content'
        },
        Upload: {
            title: 'Upload documents',
            text: 'Drag & drop your files or choose files to upload.',
            textSingular: 'Drag & drop your file or choose which file to upload.',
            fileTypeTableCaption: 'Allowed formats and max. file size',
            fileTypeDescription: 'Allowed formats:',
            fileSizeDescription: 'Max. file size:',
            fileAmountDescription: 'Max. number of files:',
            fileSizeContent: '%size MB',
            buttonText: 'Choose files',
            buttonTextSingular: 'Choose file',
            loadingText: 'Loading',
            errorLargeFile: 'The file you are trying to upload is too big, the maximum size supported is %size MB.',
            errorAmountLimit: 'There is a limit to how many files you can upload (%amount).',
            errorUnsupportedFile: 'The file you are trying to upload is not supported.',
            deleteButton: 'Delete',
            listAriaLabel: 'uploaded files'
        },
        Popover: {
            closeButtonTitle: 'Close',
            openTriggerTitle: 'Click to open',
            closeTriggerTitle: 'Click to close',
            focusTrapTitle: 'Click to return'
        },
        List: {
            showMore: 'Show more',
            showLess: 'Show less'
        },
        TermDefinition: {
            closeButtonTitle: 'Close definition',
            openTriggerTitle: 'Click to open definition',
            closeTriggerTitle: 'Click to close definition'
        },
        Filter: {
            ariaLabel: 'Filter',
            activeFiltersLabel: 'Active filters',
            activeFiltersCountLabel: '%s active filters',
            clearAllLabel: 'Clear all',
            panelButtonLabel: 'Filter',
            hideFilterLabel: 'Hide filter',
            applyFilterLabel: 'Apply filter',
            cancelFilterLabel: 'Cancel',
            dateLabel: 'Date',
            sortButtonLabel: 'Sort',
            noResultsMessage: 'Try changing or removing some filters.',
            resultCountMessage: '%s result(s)'
        }
    }
};


const $cd34253258a667c2$var$locales = {
    ...(0, $760f6e735ba35488$export$2e2bcd8739ae039),
    ...(0, $d904a064453aaabf$export$2e2bcd8739ae039)
};
var $cd34253258a667c2$export$2e2bcd8739ae039 = $cd34253258a667c2$var$locales;


var $0deb50add52e39bd$exports = {};
'use strict';
var $60c560cbf30bb40c$exports = {};
'use strict';
'use strict';


// `Object.hasOwn` method
// https://tc39.es/ecma262/#sec-object.hasown
$dd3b95617fde12ee$exports({
    target: 'Object',
    stat: true
}, {
    hasOwn: $9c28affa4150640a$exports
});



$60c560cbf30bb40c$exports = $d3c3b06832d007ae$exports.Object.hasOwn;


$0deb50add52e39bd$exports = $60c560cbf30bb40c$exports;



var $ieaan = parcelRequire("ieaan");
let $257aa337e1886a2d$var$currentInput = 'initial';
let $257aa337e1886a2d$var$currentIntent = 'initial';
let $257aa337e1886a2d$var$currentTimestamp = Date.now();
const $257aa337e1886a2d$var$ignoreMap = [
    'Shift',
    'Control',
    'Alt',
    'Meta'
];
let $257aa337e1886a2d$var$specificMap = [];
let $257aa337e1886a2d$var$isScrolling = false;
const $257aa337e1886a2d$var$mousePos = {
    x: 0,
    y: 0
};
const $257aa337e1886a2d$var$formInputs = [
    'input',
    'select',
    'textarea'
];
let $257aa337e1886a2d$var$isSetUp = false;
function $257aa337e1886a2d$var$setUp() {
    if ($257aa337e1886a2d$var$isSetUp) return;
    $257aa337e1886a2d$var$isSetUp = true;
    const passiveCapture = {
        passive: true,
        capture: true
    };
    if (window.PointerEvent) {
        window.addEventListener('pointerdown', $257aa337e1886a2d$var$setInput, true);
        window.addEventListener('pointermove', $257aa337e1886a2d$var$setIntent, passiveCapture);
    } else {
        window.addEventListener('mousemove', $257aa337e1886a2d$var$setIntent, passiveCapture);
        if ('ontouchstart' in window) {
            window.addEventListener('touchstart', $257aa337e1886a2d$var$setInput, passiveCapture);
            window.addEventListener('touchend', $257aa337e1886a2d$var$setInput, true);
        }
    }
    window.addEventListener('mousedown', $257aa337e1886a2d$var$setInput, true);
    window.addEventListener('wheel', $257aa337e1886a2d$var$setIntent, passiveCapture);
    window.addEventListener('keydown', $257aa337e1886a2d$var$setInput, true);
    window.addEventListener('keyup', $257aa337e1886a2d$var$setInput, true);
    $257aa337e1886a2d$var$doUpdate('input');
    $257aa337e1886a2d$var$doUpdate('intent');
}
function $257aa337e1886a2d$var$resolvePointerType(event) {
    if (event.pointerType === 'pen' || event.pointerType === 'touch') return 'touch';
    return 'mouse';
}
function $257aa337e1886a2d$var$resolveInputType(event) {
    const type = event.type;
    if (type === 'keydown' || type === 'keyup') return 'keyboard';
    if (type === 'mousedown') return 'mouse';
    if (type === 'touchstart' || type === 'touchend') return 'touch';
    if (type === 'pointerdown') return $257aa337e1886a2d$var$resolvePointerType(event);
    if (type === 'pointermove') return $257aa337e1886a2d$var$resolvePointerType(event);
    if (type === 'mousemove' || type === 'wheel') return 'mouse';
    return 'mouse';
}
function $257aa337e1886a2d$var$validateTouch(value) {
    const now = Date.now();
    const isFalsePositive = value === 'mouse' && $257aa337e1886a2d$var$currentInput === 'touch' && now - $257aa337e1886a2d$var$currentTimestamp < 200;
    $257aa337e1886a2d$var$currentTimestamp = now;
    return isFalsePositive;
}
function $257aa337e1886a2d$var$setInput(event) {
    const value = $257aa337e1886a2d$var$resolveInputType(event);
    const eventKey = event.key;
    if (value === 'keyboard' && eventKey) {
        const ignoreMatch = $257aa337e1886a2d$var$specificMap.length === 0 && !$257aa337e1886a2d$var$ignoreMap.includes(eventKey);
        const specificMatch = $257aa337e1886a2d$var$specificMap.length > 0 && $257aa337e1886a2d$var$specificMap.includes(eventKey);
        if (!ignoreMatch && !specificMatch) return;
    }
    if ($257aa337e1886a2d$var$validateTouch(value)) return;
    if ($257aa337e1886a2d$var$currentInput !== value) {
        $257aa337e1886a2d$var$currentInput = value;
        $257aa337e1886a2d$var$doUpdate('input');
    }
    if ($257aa337e1886a2d$var$currentIntent !== value) {
        const activeElem = document.activeElement;
        if (activeElem?.nodeName && (!$257aa337e1886a2d$var$formInputs.includes(activeElem.nodeName.toLowerCase()) || activeElem.nodeName.toLowerCase() === 'button' && !activeElem.closest('form'))) {
            $257aa337e1886a2d$var$currentIntent = value;
            $257aa337e1886a2d$var$doUpdate('intent');
        }
    }
}
function $257aa337e1886a2d$var$detectScrolling(event) {
    if ($257aa337e1886a2d$var$mousePos.x !== event.screenX || $257aa337e1886a2d$var$mousePos.y !== event.screenY) {
        $257aa337e1886a2d$var$isScrolling = false;
        $257aa337e1886a2d$var$mousePos.x = event.screenX;
        $257aa337e1886a2d$var$mousePos.y = event.screenY;
    } else $257aa337e1886a2d$var$isScrolling = true;
}
function $257aa337e1886a2d$var$setIntent(event) {
    const value = $257aa337e1886a2d$var$resolveInputType(event);
    if (event.type === 'pointermove' || event.type === 'mousemove') $257aa337e1886a2d$var$detectScrolling(event);
    const isWheelEvent = event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll';
    if ((!$257aa337e1886a2d$var$isScrolling && !$257aa337e1886a2d$var$validateTouch(value) || $257aa337e1886a2d$var$isScrolling && isWheelEvent) && $257aa337e1886a2d$var$currentIntent !== value) {
        $257aa337e1886a2d$var$currentIntent = value;
        $257aa337e1886a2d$var$doUpdate('intent');
    }
}
function $257aa337e1886a2d$var$doUpdate(which) {
    document.documentElement.setAttribute(`data-what${which}`, which === 'input' ? $257aa337e1886a2d$var$currentInput : $257aa337e1886a2d$var$currentIntent);
}
function $257aa337e1886a2d$var$specificKeys(arr) {
    $257aa337e1886a2d$var$specificMap = arr;
}
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    if (typeof requestIdleCallback === 'function') requestIdleCallback($257aa337e1886a2d$var$setUp);
    else setTimeout($257aa337e1886a2d$var$setUp, 0);
}
const $257aa337e1886a2d$var$whatInput = {
    specificKeys: $257aa337e1886a2d$var$specificKeys
};
var $257aa337e1886a2d$export$2e2bcd8739ae039 = $257aa337e1886a2d$var$whatInput;



const $deeefef162515a83$export$38c6a3e5b70e61c0 = 'Mac|iPad|iPhone|iPod';
const $deeefef162515a83$export$336bae68914031bc = 'Win';
const $deeefef162515a83$export$1c2bb4c0f936e289 = 'Android';
const $deeefef162515a83$export$40a55710950a6734 = 'Linux';
const $deeefef162515a83$export$ef3703a40c1adf83 = 'iOS|iPhone|iPad|iPod';
let $deeefef162515a83$export$9135b5fce2a2854d = false;
let $deeefef162515a83$export$af54264dae9065e6 = false;
let $deeefef162515a83$export$540767c3840af530 = false;
let $deeefef162515a83$export$ff23e6b4c4401383 = false;
let $deeefef162515a83$export$2760ddee6a71ee7d = false;
let $deeefef162515a83$export$25e95d65b6faeb9a = false;
const $deeefef162515a83$var$getPlatform = ()=>{
    if (typeof navigator === 'undefined') return '';
    return navigator.userAgentData?.platform || navigator?.platform;
};
const $deeefef162515a83$export$9ac100e40613ea10 = ()=>$deeefef162515a83$export$ff23e6b4c4401383 = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$38c6a3e5b70e61c0, 'i').test($deeefef162515a83$var$getPlatform());
const $deeefef162515a83$export$1ab4082fb43308c8 = ()=>$deeefef162515a83$export$540767c3840af530 = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$336bae68914031bc, 'i').test($deeefef162515a83$var$getPlatform());
const $deeefef162515a83$export$a11b0059900ceec8 = ()=>$deeefef162515a83$export$2760ddee6a71ee7d = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$1c2bb4c0f936e289, 'i').test(navigator?.userAgent);
const $deeefef162515a83$export$a10d59b01729022b = ()=>$deeefef162515a83$export$25e95d65b6faeb9a = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$40a55710950a6734, 'i').test($deeefef162515a83$var$getPlatform());
const $deeefef162515a83$export$86c1a3f9ab33da5c = ()=>$deeefef162515a83$export$9135b5fce2a2854d = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$ef3703a40c1adf83, 'i').test($deeefef162515a83$var$getPlatform());
const $deeefef162515a83$export$95df08bae54cb4df = ()=>$deeefef162515a83$export$af54264dae9065e6 = typeof navigator !== 'undefined' && /safari/i.test(navigator?.userAgent) && !/chrome/i.test(navigator?.userAgent);
$deeefef162515a83$export$86c1a3f9ab33da5c();
$deeefef162515a83$export$95df08bae54cb4df();
$deeefef162515a83$export$1ab4082fb43308c8();
$deeefef162515a83$export$a11b0059900ceec8();
$deeefef162515a83$export$9ac100e40613ea10();
$deeefef162515a83$export$a10d59b01729022b();
const $deeefef162515a83$var$pageFocusElements = {};
function $deeefef162515a83$export$c2c6e5b2f41473ad(selectorOrElement, key = 'default') {
    return $deeefef162515a83$var$pageFocusElements[key] = selectorOrElement;
}
function $deeefef162515a83$export$cb56c24ac2eb4e7e(selector = 'default', callback = null) {
    try {
        let element = /^[.#]/.test(selector) ? selector : $deeefef162515a83$var$pageFocusElements[selector];
        if (typeof element === 'string' && typeof document !== 'undefined') element = document.querySelector(element);
        else if (!element && typeof document !== 'undefined') element = document.querySelector('.dnb-no-focus');
        if (!(element instanceof HTMLElement)) return undefined;
        const role = element.getAttribute('role');
        const list = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'label',
            'menu'
        ];
        const isInteractive = list.includes(String(element.nodeName).toLowerCase()) || list.includes(String(role).toLowerCase());
        const hasTabIndex = element.hasAttribute('tabindex');
        const hasNoFocus = element.classList.contains('dnb-no-focus');
        if (!isInteractive) {
            if (!hasTabIndex) element.setAttribute('tabindex', '-1');
            if (!hasNoFocus) element.classList.add('dnb-no-focus');
        }
        element.focus();
        const onBlur = ()=>{
            if (!isInteractive) {
                if (!hasTabIndex) element.removeAttribute('tabindex');
                if (!hasNoFocus) element.classList.remove('dnb-no-focus');
            }
        };
        element.addEventListener('blur', onBlur, {
            once: true
        });
        if (typeof callback === 'function') callback(element);
    } catch (e) {
        $deeefef162515a83$export$c106dd0671a0fc2d('Error on applyPageFocus:', e);
    }
}
function $deeefef162515a83$export$6fcff0dc60346367(elem) {
    let offsetTop = 0;
    let current = elem;
    if (current) {
        do if (!isNaN(current.offsetTop)) offsetTop += current.offsetTop;
        while (current = current.offsetParent);
    }
    return offsetTop;
}
function $deeefef162515a83$export$a6a488ff68b1bf7b(elem) {
    let offsetLeft = 0;
    let current = elem;
    if (current) {
        do if (!isNaN(current.offsetLeft)) offsetLeft += current.offsetLeft;
        while (current = current.offsetParent);
    }
    return offsetLeft;
}
function $deeefef162515a83$export$6f6442b1c96e0e12({ offset: offset = 0, delay: delay = null, onCompletion: onCompletion = null } = {}) {
    if (typeof document !== 'undefined' && typeof window !== 'undefined' && window.location) try {
        let _timeout;
        const id = String(window.location.hash).replace('#', '');
        if (id.length > 0) {
            const handleScroll = ()=>{
                const runScroll = ()=>{
                    const totalOffset = $deeefef162515a83$export$6fcff0dc60346367(elem);
                    if (totalOffset <= 0) return undefined;
                    const top = totalOffset - offset;
                    try {
                        if (typeof IntersectionObserver !== 'undefined') {
                            const intersectionObserver = new IntersectionObserver((entries)=>{
                                const [entry] = entries;
                                if (entry.isIntersecting) {
                                    intersectionObserver.unobserve(elem);
                                    if (typeof onCompletion === 'function') onCompletion(elem);
                                }
                            });
                            intersectionObserver.observe(elem);
                        }
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    } catch (e) {
                        $deeefef162515a83$export$c106dd0671a0fc2d('Error on scrollToLocationHashId:', e);
                    }
                };
                if (delay > 0) {
                    clearTimeout(_timeout);
                    _timeout = setTimeout(runScroll, delay);
                } else runScroll();
            };
            const elem = document.getElementById(id);
            if (elem instanceof HTMLElement) {
                window.addEventListener('beforeunload', ()=>clearTimeout(_timeout));
                if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleScroll);
                else handleScroll();
            }
            return elem;
        }
    } catch (e) {
        $deeefef162515a83$export$c106dd0671a0fc2d('Error on scrollToLocationHashId:', e);
    }
    return undefined;
}
function $deeefef162515a83$export$93850515e4be65a3() {
    try {
        return window.getSelection().toString();
    } catch (e) {}
    return undefined;
}
function $deeefef162515a83$export$beec7d15ad76327f(event) {
    if (!event) return false;
    return Boolean(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof event.button === 'number' && event.button !== 0);
}
function $deeefef162515a83$export$acc7c0c9db77f425() {
    try {
        if (window.getSelection && window.getSelection().empty) window.getSelection().empty();
    } catch (e) {}
}
function $deeefef162515a83$export$8f5e5df0ef949c4c() {
    return $deeefef162515a83$export$93850515e4be65a3().length > 0;
}
function $deeefef162515a83$export$48bc52c1b5641d9b() {
    try {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            let elem = selection.getRangeAt(0).startContainer;
            if (elem && typeof elem === 'object') elem = elem.parentNode;
            return elem;
        }
    } catch (e) {}
    return null;
}
async function $deeefef162515a83$export$2cdf1b96a9f86d16(string) {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    const selection = window.getSelection();
    const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
    const resetSelection = ()=>{
        try {
            if (range) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } catch (e) {}
    };
    const copyFallback = ()=>{
        try {
            const elem = document.createElement('textarea');
            elem.value = String(string);
            elem.contentEditable = 'true';
            elem.readOnly = false;
            elem.style.position = 'fixed';
            elem.style.top = '-1000px';
            document.body.appendChild(elem);
            elem.select();
            const success = document.execCommand('copy');
            document.body.removeChild(elem);
            resetSelection();
            if (success) return true;
        } catch (e) {
            return e;
        }
        return `Could not copy! Unknown reason. ${string}`;
    };
    let success;
    if (typeof navigator !== 'undefined' && navigator?.clipboard) try {
        await navigator.clipboard.writeText(String(string));
        success = true;
        resetSelection();
    } catch (e) {
        success = e;
        const newTry = copyFallback();
        if (newTry === true) success = newTry;
    }
    else success = copyFallback();
    return success;
}
const $deeefef162515a83$export$c106dd0671a0fc2d = (...params)=>{};
function $deeefef162515a83$export$5551a2d24ff40153(value) {
    if (String(value).includes('--')) return value;
    return value ? !/#|var/.test(value) ? `var(--color-${value})` : value : undefined;
}



const $83064abe1c16626d$export$aab59a836bba0c3 = (selector, element, excludeSelf = false)=>{
    try {
        const tagName = /[A-Z]/.test(selector) ? selector : null;
        const className = tagName ? null : selector.replace(/^\./, '');
        const contains = (element)=>{
            if (!element) return null;
            if (tagName) return element?.tagName === tagName;
            return element?.classList.contains(className);
        };
        if (excludeSelf) element = element?.parentElement;
        while(element && !contains(element))element = element?.parentElement;
    } catch (e) {
        (0, $deeefef162515a83$export$c106dd0671a0fc2d)('getClosest: Failed to traverse DOM tree:', e);
    }
    return element;
};



const $1f2378dc42ffeef6$export$83d89fbfd8236492 = '11.7.0';
const $1f2378dc42ffeef6$export$8256110f30169a5d = '3b8b24fa7a';
const $1f2378dc42ffeef6$export$32c600df5a6c24a7 = '2026-06-22T08:26:20.970Z';


const $bce3ea05de26e767$export$c506eb22e615ba4a = ()=>{
    return 0, $1f2378dc42ffeef6$export$83d89fbfd8236492;
};
const $bce3ea05de26e767$export$60d52592423e9732 = ()=>{
    return 0, $1f2378dc42ffeef6$export$8256110f30169a5d;
};
const $bce3ea05de26e767$export$f8c20b2b63a7ffbb = ()=>{
    return 0, $1f2378dc42ffeef6$export$32c600df5a6c24a7;
};



function $21b894ff0d4901e3$export$708d328211d9518d() {
    try {
        typeof document;
    } catch (error) {
        console.error(error);
    }
}


function $42d4c550e1bb3c63$export$a0f69164ba1dbb41() {
    try {
        typeof document;
    } catch (error) {
        console.error(error);
    }
}


const $179e89430ab61ea0$export$83d89fbfd8236492 = (0, $bce3ea05de26e767$export$c506eb22e615ba4a)();
const $179e89430ab61ea0$export$8256110f30169a5d = (0, $bce3ea05de26e767$export$60d52592423e9732)();
const $179e89430ab61ea0$export$32c600df5a6c24a7 = (0, $bce3ea05de26e767$export$f8c20b2b63a7ffbb)();
function $179e89430ab61ea0$export$2cd8252107eb640b() {
    if (typeof window !== 'undefined') {
        class Eufemia {
            constructor(){
                if (!window.__eufemiaVersions) window.__eufemiaVersions = [];
                if (!window.__eufemiaVersions.includes(this.version)) {
                    var _context;
                    (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context = window.__eufemiaVersions).call(_context, this.version);
                }
                if (!window.__eufemiaSHAs) window.__eufemiaSHAs = [];
                if (!window.__eufemiaSHAs.includes(this.sha)) {
                    var _context2;
                    (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context2 = window.__eufemiaSHAs).call(_context2, this.sha);
                }
            }
            get version() {
                return $179e89430ab61ea0$export$83d89fbfd8236492;
            }
            get sha() {
                return $179e89430ab61ea0$export$8256110f30169a5d;
            }
            get buildDate() {
                return $179e89430ab61ea0$export$32c600df5a6c24a7;
            }
            get shas() {
                return window.__eufemiaSHAs;
            }
            get versions() {
                return window.__eufemiaSHAs.map((sha, i)=>{
                    const scopeElement = document.querySelector(`[data-scope-hash-id][data-scope-sha="${sha}"]`);
                    const styleElement = scopeElement?.querySelector('.dnb-core-style');
                    const css = window.getComputedStyle(styleElement || document.body).getPropertyValue('--eufemia-version').replace(/"/g, '').replace(/\s+/g, '');
                    const js = window.__eufemiaVersions[i] || window.__eufemiaVersions[0] || this.version;
                    return {
                        js: js,
                        css: css,
                        sha: sha,
                        scopeElement: scopeElement
                    };
                });
            }
        }
        window.Eufemia = new Eufemia();
        (0, $21b894ff0d4901e3$export$708d328211d9518d)();
        (0, $42d4c550e1bb3c63$export$a0f69164ba1dbb41)();
    }
}




function $5cdea43e47e2bcbb$export$a1d0d20ee9546562() {
    if (typeof document !== 'undefined') {
        let intent = null;
        try {
            intent = document.documentElement.getAttribute('data-whatintent');
        } catch (e) {}
        return intent === 'touch';
    }
    return false;
}
function $5cdea43e47e2bcbb$export$50e883862acdbb29() {
    const handleNavigator = ()=>{
        if (typeof document === 'undefined' || typeof window === 'undefined' || typeof navigator === 'undefined') return;
        try {
            if (!(typeof window !== 'undefined' && window.IS_TEST)) {
                if ((0, $deeefef162515a83$export$9ac100e40613ea10)()) document.documentElement.setAttribute('data-os', 'mac');
                else if ((0, $deeefef162515a83$export$1ab4082fb43308c8)()) document.documentElement.setAttribute('data-os', 'win');
                else if ((0, $deeefef162515a83$export$a10d59b01729022b)()) document.documentElement.setAttribute('data-os', 'linux');
            } else document.documentElement.setAttribute('data-os', 'other');
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('setRunOnceDetectOS: Failed to detect OS:', e);
        }
        document.removeEventListener('DOMContentLoaded', handleNavigator);
    };
    if (typeof document !== 'undefined' && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleNavigator);
    else handleNavigator();
}
const $5cdea43e47e2bcbb$export$51751cece1adcf33 = (props)=>{
    if (!props) return null;
    const res = typeof props.children === 'function' ? props.children(props) : props.children;
    if (Array.isArray(res)) {
        const onlyTexts = res.reduce((pV, cV)=>{
            if (typeof cV === 'string' || typeof cV === 'number') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(pV).call(pV, cV);
            return pV;
        }, []);
        if (onlyTexts.length === res.length && onlyTexts.length > 0) return onlyTexts.join('');
    }
    return res;
};
const $5cdea43e47e2bcbb$export$4d3e60c1044d732d = (ignoreElements, onSuccess, options)=>new $5cdea43e47e2bcbb$export$be33f99ff14eb0df(ignoreElements, onSuccess, options);
class $5cdea43e47e2bcbb$export$be33f99ff14eb0df {
    handleClickOutside = null;
    keydownCallback = null;
    keyupCallback = null;
    constructor(ignoreElementsInput, onSuccess, options = {}){
        const ignoreElements = Array.isArray(ignoreElementsInput) ? ignoreElementsInput : [
            ignoreElementsInput
        ];
        if (!this.handleClickOutside && typeof document !== 'undefined' && typeof window !== 'undefined') {
            this.handleClickOutside = (event)=>{
                this.checkOutsideClick({
                    event: event,
                    ignoreElements: ignoreElements
                }, ()=>typeof onSuccess === 'function' && onSuccess({
                        event: event
                    }));
            };
            document.addEventListener('mousedown', this.handleClickOutside);
            this.keydownCallback = (event)=>{
                if (event.key === 'Escape') {
                    window.removeEventListener('keydown', this.keydownCallback);
                    if (typeof onSuccess === 'function') onSuccess({
                        event: event
                    });
                }
            };
            window.addEventListener('keydown', this.keydownCallback);
            if (options.includedKeys) {
                this.keyupCallback = (event)=>{
                    if (options.includedKeys.includes(event.key) && typeof this.handleClickOutside === 'function') this.handleClickOutside(event, ()=>{
                        if (this.keyupCallback) window.removeEventListener('keyup', this.keyupCallback);
                    });
                };
                window.addEventListener('keyup', this.keyupCallback);
            }
        }
    }
    remove() {
        if (this.handleClickOutside && typeof document !== 'undefined') {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.handleClickOutside = null;
        }
        if (this.keydownCallback && typeof window !== 'undefined') {
            window.removeEventListener('keydown', this.keydownCallback);
            this.keydownCallback = null;
        }
        if (this.keyupCallback && typeof window !== 'undefined') {
            window.removeEventListener('keyup', this.keyupCallback);
            this.keyupCallback = null;
        }
    }
    checkOutsideClick = ({ event: event, ignoreElements: ignoreElements }, onSuccess = null)=>{
        try {
            const currentElement = event.target;
            if (currentElement?.tagName === 'HTML' && (event.pageX > document.documentElement.clientWidth - 40 || event.pageY > document.documentElement.clientHeight - 40)) return;
            if ($5cdea43e47e2bcbb$export$54478a583b57e12a(currentElement)) return;
            for(let i = 0, elem, l = ignoreElements.length; i < l; ++i){
                const ignoreElement = ignoreElements[i] && ignoreElements[i] !== null && 'current' in ignoreElements[i] ? ignoreElements[i].current : ignoreElements[i];
                elem = currentElement;
                if (!ignoreElements[i]) continue;
                do {
                    if (elem === ignoreElement) return;
                    elem = elem && elem.parentNode;
                }while (elem);
            }
            if (typeof onSuccess === 'function') onSuccess();
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('detectOutsideClick: Failed to handle outside click:', e);
        }
    };
}
const $5cdea43e47e2bcbb$export$54478a583b57e12a = (elem)=>{
    return elem && (elem.scrollHeight > elem.offsetHeight || elem.scrollWidth > elem.offsetWidth) && $5cdea43e47e2bcbb$var$overflowIsScrollable(elem);
};
const $5cdea43e47e2bcbb$var$overflowIsScrollable = (elem)=>{
    if (typeof window === 'undefined') return false;
    const style = window.getComputedStyle(elem);
    return /scroll|auto/i.test((style.overflow || '') + (style.overflowX || '') + (style.overflowY || ''));
};



function $be16b996e1dc94eb$export$ad5cdd5a4635d9d0(props, defaults = {}, ...contexts) {
    props = {
        ...defaults,
        ...props
    };
    return {
        ...props,
        ...$be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts)
    };
}
function $be16b996e1dc94eb$export$6e15c46eedcbcbc6(props, defaults = {}, ...contexts) {
    return {
        ...props,
        ...$be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts, {
            onlyMergeExistingProps: true
        })
    };
}
function $be16b996e1dc94eb$export$838a0b3a8912daf4(contexts) {
    return contexts.reduce((acc, cur)=>{
        if (cur) acc = {
            ...acc,
            ...cur
        };
        return acc;
    }, {});
}
function $be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts, { onlyMergeExistingProps: onlyMergeExistingProps = false } = {}) {
    const context = $be16b996e1dc94eb$export$838a0b3a8912daf4(contexts);
    return Object.entries(context).reduce((acc, [key, value])=>{
        if (!onlyMergeExistingProps || Object.prototype.hasOwnProperty.call(props, key)) {
            if (props[key] === defaults?.[key]) acc[key] = value;
        }
        return acc;
    }, {});
}




function $de502bdad3b5fb4d$export$d697c39a2985a4c(props, remove = null, allowed = null) {
    if (Array.isArray(remove)) remove = Object.fromEntries(remove.map((key)=>[
            key,
            true
        ]));
    if (Array.isArray(allowed)) allowed = Object.fromEntries(allowed.map((key)=>[
            key,
            true
        ]));
    const isArray = Array.isArray(props);
    return Object.entries(props).reduce((acc, [k, v])=>{
        if (isArray) k = v;
        if ((typeof remove === 'function' ? !remove(k) : typeof remove?.[k] === 'undefined') || (typeof allowed === 'function' ? allowed(k) : typeof allowed?.[k] !== 'undefined')) {
            if (isArray) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, v);
            else acc[k] = v;
        }
        return acc;
    }, isArray ? [] : {});
}


(0, $179e89430ab61ea0$export$2cd8252107eb640b)();
(0, $257aa337e1886a2d$export$2e2bcd8739ae039).specificKeys([]);
(0, $5cdea43e47e2bcbb$export$50e883862acdbb29)();
const $11741836d1790446$var$startsWithCamelCaseRegex = /(^[a-z]{1,}[A-Z]{1})/;
const $11741836d1790446$var$notOnlyAZOrHyphenRegex = /[^a-z-]/i;
const $11741836d1790446$export$4ddc669a9a6a5940 = (props, params)=>{
    if (props && props.attributes) {
        const attr = props.attributes;
        if (attr && typeof attr === 'object') Object.entries(attr).forEach(([key, value])=>{
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
            Object.assign(params, {
                [key]: value
            });
        });
        delete params.attributes;
    }
    if (params.disabled === null) delete params.disabled;
    if (typeof params.space !== 'undefined') delete params.space;
    if (typeof params.top !== 'undefined') delete params.top;
    if (typeof params.right !== 'undefined') delete params.right;
    if (typeof params.bottom !== 'undefined') delete params.bottom;
    if (typeof params.left !== 'undefined') delete params.left;
    if (typeof params.noCollapse !== 'undefined') delete params.noCollapse;
    if (typeof params.innerSpace !== 'undefined') delete params.innerSpace;
    if (typeof params.labelDirection !== 'undefined') delete params.labelDirection;
    if (params.disabled === true) params['aria-disabled'] = true;
    if (params && typeof params === 'object') for(const i in params){
        if (typeof params[i] === 'function' && i !== 'ref' && !$11741836d1790446$var$startsWithCamelCaseRegex.test(i)) delete params[i];
        else if (params[i] === null || $11741836d1790446$var$notOnlyAZOrHyphenRegex.test(i)) delete params[i];
    }
    return params;
};
function $11741836d1790446$export$a6cdc56e425d0d0a(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $11741836d1790446$export$b29aee33601cce38(target = {}, ...sources) {
    for (const source of sources){
        if ($11741836d1790446$export$a6cdc56e425d0d0a(source)) for(const key in source){
            if (key === '__proto__' || key === 'constructor') continue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(source, key)) continue;
            if (!$11741836d1790446$export$a6cdc56e425d0d0a(target)) continue;
            if ($11741836d1790446$export$a6cdc56e425d0d0a(source[key])) {
                if (!$11741836d1790446$export$a6cdc56e425d0d0a(target[key])) target[key] = {};
                $11741836d1790446$export$b29aee33601cce38(target[key], source[key]);
            } else target[key] = source[key];
        }
    }
    return target;
}
const $11741836d1790446$export$89a1e257278b2134 = (src, eventName, eventObjectOrig)=>{
    let ret = undefined;
    const eventObject = {
        ...eventObjectOrig && eventObjectOrig.event || {},
        ...eventObjectOrig
    };
    const props = src && src.props || src;
    if (typeof props[eventName] === 'function') {
        const r = props[eventName].apply(src, [
            eventObject
        ]);
        if (typeof r !== 'undefined') ret = r;
    }
    return ret;
};
const $11741836d1790446$export$6fb43ff9addf7357 = (s)=>s.split(/_/g).reduce((acc, cur)=>acc + cur.replace(/(\w)(\w*)/g, (g0, g1, g2)=>g1.toUpperCase() + g2.toLowerCase()), '');
const $11741836d1790446$export$73bda83cddbc7187 = (str)=>str.replace(/\B[A-Z]/g, (letter)=>`-${letter}`).toLowerCase();
function $11741836d1790446$export$6c878285a9ef10a4(str) {
    return typeof str === 'string' ? str.toLowerCase().split('').map((char, index, arr)=>index === 0 || arr[index - 1] === ' ' || arr[index - 1] === '-' ? char.toUpperCase() : char).join('') : str;
}
const $11741836d1790446$export$d0c8ec0fe1b18b70 = (prefix = 'id-', length = 8)=>prefix + String(Math.random().toString(36).substring(2, 2 + length) + $11741836d1790446$var$idIncrement++).slice(-length);
let $11741836d1790446$var$idIncrement = 0;
const $11741836d1790446$export$c383cdd2a518017a = (s)=>String(s).toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
const $11741836d1790446$export$5ebe8f8550508fde = (element, target, callback = null)=>{
    try {
        const contains = (element)=>{
            if (callback) {
                const res = callback(element);
                if (res) return element;
            }
            return element && element === target;
        };
        if (contains(element)) return element;
        while((element = element && element.parentElement) && !contains(element));
    } catch (e) {}
    return element;
};
const $11741836d1790446$export$f72673597dacfcfa = (num, target)=>{
    const diff = num % target;
    return diff > target / 2 ? num - diff + target : num - diff;
};
const $11741836d1790446$export$6857ec1aec960893 = (currentElement)=>{
    return (0, $83064abe1c16626d$export$aab59a836bba0c3)('.dnb-scroll-view', currentElement);
};
function $11741836d1790446$export$5bfc594bd2dc6e21(elements, separator, transformWord) {
    if (!Array.isArray(elements)) elements = [
        elements
    ];
    const process = (word)=>{
        if ((0, $ieaan.isValidElement)(word)) {
            let element = word;
            if (transformWord) element = transformWord(element);
            if (Array.isArray(element.props.children)) word = element.props.children.reduce((acc, word)=>{
                if (typeof word !== 'string') word = process(word);
                if (typeof word === 'string') acc = (acc + (separator || '') + word).trim();
                return acc;
            }, '');
            else if (element.props.children) {
                word = element.props.children;
                if (typeof word !== 'string') word = process(word);
                if (typeof word === 'string') word = word.trim();
                else return undefined;
            } else return undefined;
        }
        return word;
    };
    return Array.from(elements).map((word)=>process(word)).filter(Boolean).join(separator).trim();
}
function $11741836d1790446$export$a5f4aa7ad013c9e9(status) {
    return status && status !== 'error' && status !== 'warning' && status !== 'information';
}
function $11741836d1790446$export$b31873477fdbab59(...params) {
    return $11741836d1790446$var$combineAriaBy('aria-labelledby', params);
}
function $11741836d1790446$export$ac6c18d26085326c(...params) {
    return $11741836d1790446$var$combineAriaBy('aria-describedby', params);
}
function $11741836d1790446$var$combineAriaBy(type, params) {
    params = params.map((cur)=>{
        if (Array.isArray(cur)) return cur.join(' ');
        if (cur && params.includes(cur[type])) return null;
        if (cur && typeof cur[type] !== 'undefined') cur = cur[type];
        if (typeof cur !== 'string') cur = null;
        return cur;
    });
    params = params.filter(Boolean).join(' ');
    if (params === '') params = undefined;
    return params;
}
function $11741836d1790446$export$b2730d17dab9d6f8(children, find) {
    if (!Array.isArray(children)) children = [
        children
    ];
    let result = null;
    children.some((cur)=>{
        if (cur && cur.props && cur.props.children) {
            const res = $11741836d1790446$export$b2730d17dab9d6f8(cur.props.children, find);
            if (res) return result = res;
        }
        if ((0, $ieaan.isValidElement)(cur) && find(cur)) return result = cur;
        return null;
    });
    return result;
}
function $11741836d1790446$export$5e3c9d2a613b9083(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
}
function $11741836d1790446$export$130f9de4db4d93ea(object) {
    Object.keys(object || {}).forEach((key)=>{
        if (object[key] === undefined) delete object[key];
    });
    return object;
}





"use client";
function $e220d71a88fa3fa1$export$9c634076e0a91d1f(props = {}) {
    if (props?.__context__) {
        props = Object.assign({}, props, props.__context__);
        delete props.__context__;
    }
    const translations = props.translations ? (0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039), props.translations) : (0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039));
    const localeWithFallback = $e220d71a88fa3fa1$var$handleLocaleFallbacks(props.locale || (0, $07b61efe40a5ad0e$export$9824d860d0b120d9), translations);
    const translation = $e220d71a88fa3fa1$export$ecdd031587aebaa5((0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9], translations[localeWithFallback]));
    const context = {
        ...props,
        updateTranslation: (locale, newTranslations)=>{
            context.translation = $e220d71a88fa3fa1$export$ecdd031587aebaa5((0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9], newTranslations[locale] || newTranslations[0, $07b61efe40a5ad0e$export$9824d860d0b120d9]));
            context.translations = newTranslations;
        },
        getTranslation: (localProps)=>{
            if (localProps) {
                const locale = localProps.lang || localProps.locale;
                if (locale && context.translations[locale] && locale !== localeWithFallback) return $e220d71a88fa3fa1$export$ecdd031587aebaa5((0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9], context.translations[locale]));
            }
            return context.translation || (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9];
        },
        translations: translations,
        translation: translation
    };
    return {
        ...context
    };
}
function $e220d71a88fa3fa1$var$handleLocaleFallbacks(locale, translations = {}) {
    if (translations[locale]) return locale;
    if (locale === 'en' || String(locale).split('-')[0] === 'en') return 'en-GB';
    return translations[locale] ? locale : (0, $07b61efe40a5ad0e$export$9824d860d0b120d9);
}
const $e220d71a88fa3fa1$var$Context = (0, $ieaan.createContext)($e220d71a88fa3fa1$export$9c634076e0a91d1f({
    locale: (0, $07b61efe40a5ad0e$export$9824d860d0b120d9),
    currency: (0, $07b61efe40a5ad0e$export$ebe860a2db7990ad),
    currencyDisplay: (0, $07b61efe40a5ad0e$export$dfbea0c7aa245503)
}));
var $e220d71a88fa3fa1$export$2e2bcd8739ae039 = $e220d71a88fa3fa1$var$Context;
function $e220d71a88fa3fa1$export$ecdd031587aebaa5(source) {
    for(const k in source)if (String(k).includes('.')) (0, $373d5d4f920f4ff6$exports.default).set(source, '/' + k.replace(/\./g, '/'), source[k]);
    return source;
}






var $ieaan = parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");
"use client";
const $b1c1557baef2edc9$var$SpaceResponsiveContext = (0, $ieaan.createContext)(false);
var $b1c1557baef2edc9$export$2e2bcd8739ae039 = $b1c1557baef2edc9$var$SpaceResponsiveContext;


"use client";
const $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317 = {
    'xx-small': 0.25,
    'x-small': 0.5,
    small: 1,
    medium: 1.5,
    large: 2,
    'x-large': 3,
    'xx-large': 3.5,
    'xx-large-x2': 7
};
globalThis.CALC_CACHE = {};
const $9a6e1a0e3c9a63a2$export$42bfa9b2d4dad91a = (...types)=>{
    const hash = types.join('|');
    if (globalThis.CALC_CACHE[hash]) return globalThis.CALC_CACHE[hash];
    const result = [];
    types.forEach((rawTypes)=>{
        $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(rawTypes).forEach((type)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(result).call(result, `var(--spacing-${type})`);
        });
    });
    return result.length ? globalThis.CALC_CACHE[hash] = `calc(${result.join(' + ')})` : null;
};
const $9a6e1a0e3c9a63a2$export$bf9e5e8342b9e38f = (props)=>{
    if (props?.innerSpace) return $9a6e1a0e3c9a63a2$var$computeProperties(props.innerSpace);
    return {};
};
const $9a6e1a0e3c9a63a2$export$77cad5ba6f0b598b = (props)=>{
    return $9a6e1a0e3c9a63a2$var$computeMarginProperties(props);
};
function $9a6e1a0e3c9a63a2$var$mergeSpacing(spaceValue, individualProps) {
    const { top: top, right: right, bottom: bottom, left: left } = individualProps;
    if (spaceValue === undefined || spaceValue === null) {
        const result = {};
        if (typeof top !== 'undefined') result.top = top;
        if (typeof right !== 'undefined') result.right = right;
        if (typeof bottom !== 'undefined') result.bottom = bottom;
        if (typeof left !== 'undefined') result.left = left;
        return result;
    }
    const base = $9a6e1a0e3c9a63a2$var$transformToAll(spaceValue);
    const result = {
        ...base
    };
    if (typeof top !== 'undefined') result.top = top;
    if (typeof right !== 'undefined') result.right = right;
    if (typeof bottom !== 'undefined') result.bottom = bottom;
    if (typeof left !== 'undefined') result.left = left;
    return result;
}
function $9a6e1a0e3c9a63a2$var$computeMarginProperties(props) {
    const { space: space, top: top, right: right, bottom: bottom, left: left } = props;
    const individualProps = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    const hasMedia = $9a6e1a0e3c9a63a2$var$hasMediaSize(space);
    let mediaSpace;
    if (hasMedia) {
        const spaceMedia = space;
        mediaSpace = {
            small: $9a6e1a0e3c9a63a2$var$mergeSpacing(spaceMedia.small, individualProps),
            medium: $9a6e1a0e3c9a63a2$var$mergeSpacing(spaceMedia.medium, individualProps),
            large: $9a6e1a0e3c9a63a2$var$mergeSpacing(spaceMedia.large, individualProps)
        };
    } else return {};
    const result = {};
    for(const size in mediaSpace){
        const value = mediaSpace[size];
        if (!value || typeof value === 'object' && !$9a6e1a0e3c9a63a2$var$hasSize(value)) continue;
        const props = $9a6e1a0e3c9a63a2$var$transformToAll(value);
        for(const key in props)if ($9a6e1a0e3c9a63a2$var$isValidInnerSpaceProp(key)) {
            const cur = props[key];
            const name = `--margin-${key[0]}-${size[0]}`;
            if (String(cur) === '0' || String(cur) === 'false') result[name] = '0';
            else if (cur) {
                const typeModifiers = $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(cur);
                const sum = $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b(typeModifiers);
                if (sum > 0) result[name] = `${sum}rem`;
            }
        }
    }
    return result;
}
function $9a6e1a0e3c9a63a2$var$hasMediaSize(media) {
    const keys = media ? Object.keys(media) : [];
    return keys.includes('small') || keys.includes('medium') || keys.includes('large');
}
function $9a6e1a0e3c9a63a2$var$hasSize(space) {
    const keys = Object.keys(space);
    return keys.includes('top') || keys.includes('right') || keys.includes('bottom') || keys.includes('left') || keys.includes('inline') || keys.includes('block');
}
function $9a6e1a0e3c9a63a2$var$computeProperties(space) {
    if (!$9a6e1a0e3c9a63a2$var$hasMediaSize(space)) space = {
        small: space,
        medium: space,
        large: space
    };
    const result = {};
    for(const size in space){
        const value = space?.[size];
        const props = $9a6e1a0e3c9a63a2$var$transformToAll(value);
        for(const key in props)if ($9a6e1a0e3c9a63a2$var$isValidInnerSpaceProp(key)) {
            const cur = props[key];
            const name = `--padding-${key[0]}-${size[0]}`;
            if (String(cur) === '0' || String(cur) === 'false') result[name] = '0';
            else if (cur) {
                const typeModifiers = $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(cur);
                const sum = $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b(typeModifiers);
                result[name] = `${sum}rem`;
            }
        }
    }
    return result;
}
function $9a6e1a0e3c9a63a2$var$transformToAll(value) {
    let result = value;
    if (!$9a6e1a0e3c9a63a2$var$hasSize(value)) result = {
        top: value,
        right: value,
        bottom: value,
        left: value
    };
    return $9a6e1a0e3c9a63a2$var$expandInnerSpaceShorthand(result);
}
function $9a6e1a0e3c9a63a2$var$expandInnerSpaceShorthand(space) {
    const result = {
        ...space
    };
    if (typeof result.inline !== 'undefined') {
        var _result$left, _result$right;
        result.left = (_result$left = result.left) !== null && _result$left !== void 0 ? _result$left : result.inline;
        result.right = (_result$right = result.right) !== null && _result$right !== void 0 ? _result$right : result.inline;
    }
    if (typeof result.block !== 'undefined') {
        var _result$top, _result$bottom;
        result.top = (_result$top = result.top) !== null && _result$top !== void 0 ? _result$top : result.block;
        result.bottom = (_result$bottom = result.bottom) !== null && _result$bottom !== void 0 ? _result$bottom : result.block;
    }
    return result;
}
function $9a6e1a0e3c9a63a2$var$isValidInnerSpaceProp(propName) {
    return [
        'top',
        'right',
        'bottom',
        'left'
    ].includes(propName);
}
const $9a6e1a0e3c9a63a2$var$collectSpacingClasses = (props, elementName = null)=>{
    const p = {
        ...props
    };
    if (typeof p.space !== 'undefined') {
        if (typeof p.space === 'string' || typeof p.space === 'number' || typeof p.space === 'boolean' && p.space) {
            var _p$left, _p$bottom, _p$right, _p$top;
            p.left = (_p$left = p.left) !== null && _p$left !== void 0 ? _p$left : p.space;
            p.bottom = (_p$bottom = p.bottom) !== null && _p$bottom !== void 0 ? _p$bottom : p.space;
            p.right = (_p$right = p.right) !== null && _p$right !== void 0 ? _p$right : p.space;
            p.top = (_p$top = p.top) !== null && _p$top !== void 0 ? _p$top : p.space;
        }
        if (typeof p.space === 'object') {
            if ($9a6e1a0e3c9a63a2$var$hasMediaSize(p.space)) {
                const smallValue = p.space['small'];
                if (smallValue) {
                    if (typeof smallValue === 'string' || typeof smallValue === 'number' || typeof smallValue === 'boolean' && smallValue) {
                        var _p$left2, _p$bottom2, _p$right2, _p$top2;
                        p.left = (_p$left2 = p.left) !== null && _p$left2 !== void 0 ? _p$left2 : smallValue;
                        p.bottom = (_p$bottom2 = p.bottom) !== null && _p$bottom2 !== void 0 ? _p$bottom2 : smallValue;
                        p.right = (_p$right2 = p.right) !== null && _p$right2 !== void 0 ? _p$right2 : smallValue;
                        p.top = (_p$top2 = p.top) !== null && _p$top2 !== void 0 ? _p$top2 : smallValue;
                    } else if (typeof smallValue === 'object') {
                        const expandedSmallValue = $9a6e1a0e3c9a63a2$var$expandInnerSpaceShorthand(smallValue);
                        for(const i in expandedSmallValue)if (!p[i] && $9a6e1a0e3c9a63a2$export$3eec253e4a999ac(i)) p[i] = expandedSmallValue[i];
                    }
                }
            } else {
                const expandedSpace = $9a6e1a0e3c9a63a2$var$expandInnerSpaceShorthand(p.space);
                for(const i in expandedSpace)if (!p[i] && $9a6e1a0e3c9a63a2$export$3eec253e4a999ac(i)) p[i] = expandedSpace[i];
            }
        }
        delete p.space;
    }
    return Object.entries(p).reduce((acc, [direction, cur])=>{
        if ($9a6e1a0e3c9a63a2$export$3eec253e4a999ac(direction) && direction !== 'innerSpace') {
            if (String(cur) === '0' || String(cur) === 'false') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, `dnb-space__${direction}--zero`);
            else if (cur) {
                const typeModifiers = $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(cur);
                const sum = $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b(typeModifiers);
                if (sum > 10) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Spacing of more than 10rem is not supported! You used ${sum} / (${typeModifiers.join(',')})`);
                else {
                    const nearestTypes = $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(sum, true);
                    acc = [
                        ...acc,
                        ...nearestTypes.map((type)=>`dnb-space__${direction}--${type}`)
                    ];
                }
            }
        } else if (direction === 'noCollapse') {
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, 'dnb-space--no-collapse');
            if (elementName && $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e(elementName)) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, 'dnb-space--inline');
        }
        return acc;
    }, []);
};
const $9a6e1a0e3c9a63a2$export$31a62238a3f24621 = (props, elementName = null)=>{
    const className = $9a6e1a0e3c9a63a2$var$collectSpacingClasses(props, elementName);
    const innerStyle = $9a6e1a0e3c9a63a2$export$bf9e5e8342b9e38f(props);
    const marginStyle = $9a6e1a0e3c9a63a2$export$77cad5ba6f0b598b(props);
    const style = {
        ...marginStyle,
        ...innerStyle
    };
    const hasStyle = Object.keys(style).length > 0;
    return {
        className: className,
        style: hasStyle ? style : undefined
    };
};
const $9a6e1a0e3c9a63a2$export$54320f909c736433 = (props, target, elementName = null)=>{
    const classes = $9a6e1a0e3c9a63a2$var$collectSpacingClasses(props, elementName);
    const innerStyle = $9a6e1a0e3c9a63a2$export$bf9e5e8342b9e38f(props);
    const marginStyle = $9a6e1a0e3c9a63a2$export$77cad5ba6f0b598b(props);
    const style = {
        ...marginStyle,
        ...innerStyle
    };
    const hasClasses = classes.length > 0;
    const hasStyle = Object.keys(style).length > 0;
    const hasSpacingKeyOnTarget = $9a6e1a0e3c9a63a2$var$spacingKeys.some((key)=>key in target);
    if (!hasClasses && !hasStyle && !hasSpacingKeyOnTarget) return target;
    const result = {
        ...target
    };
    for (const key of $9a6e1a0e3c9a63a2$var$spacingKeys)if (key in result) delete result[key];
    if (hasClasses) result.className = (0, $2bc97902f5cc4941$export$2e2bcd8739ae039)(target.className, ...classes);
    if (hasStyle) result.style = {
        ...target.style,
        ...style
    };
    return result;
};
const $9a6e1a0e3c9a63a2$export$d9dd5da15372e275 = (props, target, elementName = null)=>{
    const responsive = (0, $ieaan.useContext)((0, $b1c1557baef2edc9$export$2e2bcd8739ae039));
    const result = $9a6e1a0e3c9a63a2$export$54320f909c736433(props, target, elementName);
    if (responsive && !responsive.off) result.className = (0, $2bc97902f5cc4941$export$2e2bcd8739ae039)(result.className, 'dnb-space-responsive', responsive.defaultBreakpoint && `dnb-space-responsive--breakpoint-${responsive.defaultBreakpoint}`, responsive.density && `dnb-space-responsive--force-${responsive.density}`);
    else if (responsive && responsive.off) result.className = (0, $2bc97902f5cc4941$export$2e2bcd8739ae039)(result.className, 'dnb-space-responsive--off');
    return result;
};
const $9a6e1a0e3c9a63a2$var$spacingKeys = [
    'space',
    'innerSpace',
    'top',
    'right',
    'bottom',
    'left',
    'noCollapse'
];
const $9a6e1a0e3c9a63a2$export$60fa8e172c58e469 = (type)=>{
    if (/-x2$/.test(String(type))) return $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317[String(type).replace(/-x2$/, '')] * 2;
    return $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317[String(type)] || 0;
};
const $9a6e1a0e3c9a63a2$export$18e0705ec1565a40 = (types)=>{
    if (typeof types === 'string') {
        const test = types.split(/ /g);
        return clean(test);
    } else if (typeof types === 'boolean') return [
        types ? 'small' : 0
    ];
    else if (typeof types === 'number') return [
        types
    ];
    return clean(types) || null;
    function clean(t) {
        return t?.filter((r)=>r && String(r).length > 0);
    }
};
const $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b = (types)=>$9a6e1a0e3c9a63a2$export$18e0705ec1565a40(types).map((type)=>$9a6e1a0e3c9a63a2$export$60fa8e172c58e469(type)).reduce((acc, cur)=>{
        if (cur > 0) acc += cur;
        else if (cur < 0) acc -= cur;
        return acc;
    }, 0);
const $9a6e1a0e3c9a63a2$export$98a895390d0f29a0 = (types)=>{
    return ($9a6e1a0e3c9a63a2$export$18e0705ec1565a40(types) || []).reduce((acc, type)=>{
        if (type) {
            const firstLetter = String(type)[0];
            if (parseFloat(firstLetter) > -1) {
                let num = parseFloat(String(type));
                if (num >= 8 && /[0-9]px/.test(String(type))) num = num / 16;
                const foundType = $9a6e1a0e3c9a63a2$export$d35f3ef497fe5c30(num);
                if (foundType) type = foundType;
                else $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(num).forEach((type)=>{
                    if (type) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, type);
                });
            }
            if (!(parseFloat(String(type)) > 0)) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, type);
        }
        return acc;
    }, []);
};
const $9a6e1a0e3c9a63a2$export$d35f3ef497fe5c30 = (num)=>{
    const found = $9a6e1a0e3c9a63a2$export$3bc20d5818d8843(num);
    if (found) return found[0];
    return null;
};
const $9a6e1a0e3c9a63a2$export$3bc20d5818d8843 = (num)=>{
    const listOfSpacePatterns = Object.entries($9a6e1a0e3c9a63a2$export$a74ea660b7fc1317);
    const found = listOfSpacePatterns.find(([k, v])=>k && v === num) || null;
    return found;
};
const $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1 = (num, multiply = false)=>{
    let res = [];
    const near = Object.entries($9a6e1a0e3c9a63a2$export$a74ea660b7fc1317).reverse().filter((k)=>multiply ? true : !k[0].includes('-x')).find(([k, v])=>k && num >= v);
    const nearNum = near && near[1] || num;
    const types = $9a6e1a0e3c9a63a2$export$3bc20d5818d8843(nearNum);
    if (types) {
        const nearType = types[0];
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(res).call(res, nearType);
        const leftOver = num - parseFloat(String(types[1]));
        const foundMoreTypes = $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(leftOver, multiply);
        foundMoreTypes.forEach((type)=>{
            const index = res.indexOf(type);
            if (index !== -1) res[index] = multiply ? `${type}-x2` : type;
        });
        res = [
            ...res,
            ...foundMoreTypes
        ];
    }
    return res;
};
const $9a6e1a0e3c9a63a2$export$3eec253e4a999ac = (propName)=>propName && [
        'top',
        'right',
        'bottom',
        'left',
        'space',
        'innerSpace'
    ].includes(propName);
const $9a6e1a0e3c9a63a2$export$e275e554c9b8899e = (props)=>{
    const { space: space, innerSpace: innerSpace, top: top, bottom: bottom, left: left, right: right, ...restProps } = props;
    return restProps;
};
const $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e = (elementName)=>{
    switch(elementName){
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
        case 'p':
            return true;
    }
    return false;
};





const $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a = (params, skeleton, context)=>{
    if (skeleton || skeleton !== false && context?.skeleton) {
        params.disabled = true;
        params['aria-disabled'] = true;
        params['aria-label'] = context?.translation?.Skeleton?.ariaBusy;
    }
    return params;
};
const $cf2e6f3341d791ce$export$4165d624d0b91f0d = (method, skeleton, context, className = null)=>{
    if (skeleton || skeleton !== false && context?.skeleton) return (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(className, 'dnb-skeleton', method && `dnb-skeleton--${method}`);
    return className;
};
function $cf2e6f3341d791ce$export$c8a403edd36250a({ __element: Comp = null, children: children = null, className: className = null, style: style = null, ...props }) {
    const string = (0, $11741836d1790446$export$5bfc594bd2dc6e21)(children);
    if (typeof string === 'string') {
        const countChars = string.trim().length;
        if (countChars > 0) return (0, $60739c7e3f826d8d$exports.jsx)(Comp, {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(className, 'dnb-skeleton', 'dnb-skeleton--font'),
            "data-skeleton-chars": String(countChars),
            style: {
                ...style || {},
                '--skeleton-chars': `${countChars}ch`
            },
            ...props,
            children: children
        });
    }
    return (0, $60739c7e3f826d8d$exports.jsx)(Comp, {
        ...props,
        className: className,
        style: style
    });
}




var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");
function $e48c94c3f1835290$export$2e2bcd8739ae039(...refs) {
    return (0, $ieaan.useCallback)((instance)=>{
        for (const ref of refs){
            if (typeof ref === 'function') ref(instance);
            else if (ref) ref.current = instance;
        }
    }, refs);
}






var $ieaan = parcelRequire("ieaan");
function $89089e429f32bd45$export$2e2bcd8739ae039(customId) {
    const id = (0, $ieaan.useId)();
    return (0, $ieaan.useMemo)(()=>customId !== null && customId !== void 0 ? customId : id.replace(/_/, 'id-').replace(/_/g, ''), [
        customId,
        id
    ]);
}




function $c81beeaa1b3509d1$export$4fb86125780c91c0(props, validKeys, excludeKeys) {
    const res = {};
    const o = Object.prototype.hasOwnProperty;
    for(const key in props)if ((!validKeys || validKeys && o.call(validKeys, key)) && (!excludeKeys || excludeKeys && !o.call(excludeKeys, key))) res[key] = props[key];
    return res;
}
function $c81beeaa1b3509d1$export$8efbf5589742246(props, excludeProps) {
    return $c81beeaa1b3509d1$export$4fb86125780c91c0(props, $c81beeaa1b3509d1$var$validFormElementProps, excludeProps);
}
function $c81beeaa1b3509d1$export$c37735b23b2df049(props) {
    if (props.vertical) {
        if (typeof props.labelDirection === 'undefined') props.labelDirection = 'vertical';
    }
    return props;
}
const $c81beeaa1b3509d1$var$validFormElementProps = {
    skeleton: null,
    disabled: null,
    vertical: null,
    labelDirection: null,
    translate: null
};



var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");
"use client";
function $9738f50fda5b2f16$export$2e2bcd8739ae039(callback) {
    (0, $ieaan.useEffect)((...args)=>{
        return callback(...args);
    }, []);
}



var $ieaan = parcelRequire("ieaan");
"use client";
function $486a01c56256a5f9$export$2e2bcd8739ae039(callback, deps) {
    const wasMounted = (0, $ieaan.useRef)(false);
    (0, $ieaan.useEffect)((...args)=>{
        if (!wasMounted.current) {
            wasMounted.current = true;
            return;
        }
        callback(...args);
    }, deps);
}





var $ieaan = parcelRequire("ieaan");

"use client";
function $ad7f813f95b3e41b$export$2e2bcd8739ae039() {
    const { theme: theme } = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039)) || {};
    if (theme) {
        const { name: name } = theme;
        return {
            ...theme,
            isUi: name === 'ui',
            isSbanken: name === 'sbanken',
            isEiendom: name === 'eiendom',
            isCarnegie: name === 'carnegie'
        };
    }
    return null;
}






var $ieaan = parcelRequire("ieaan");


var $ieaan = parcelRequire("ieaan");

class $268ea9ed428cf6d0$export$2e2bcd8739ae039 {
    onStartStack = [];
    onEndStack = [];
    events = [];
    opts = {
        animate: true
    };
    timeouts = [];
    firstTime = 0;
    startTime = 0;
    duration = 0;
    firstPaintStyle = (()=>({
            visibility: 'hidden',
            opacity: '0',
            height: 'auto'
        }))();
    constructor(opts = {}){
        this.isInBrowser = typeof window !== 'undefined';
        this.setState('init');
        this.setOptions(opts);
    }
    callAnimationStart() {
        this.startTime = Date.now();
        if (!this.firstTime) this.firstTime = this.startTime;
        if (this.onStartStack) this.onStartStack.forEach((fn)=>{
            if (typeof fn === 'function') fn(this.state);
        });
    }
    callAnimationEnd() {
        this.isAnimating = false;
        if (this.state !== 'opened') delete this.__currentHeight;
        this.removeEndEvents();
        if (this.onEndStack) this.onEndStack.forEach((fn)=>{
            if (typeof fn === 'function') fn(this.state);
        });
    }
    addEndEvent(listener) {
        var _context2;
        this.removeEndEvents();
        const handleTransitionEnd = (e)=>{
            if (this.canFinish()) listener(e);
            else {
                const delay = this.duration - (Date.now() - this.startTime);
                if (delay === -1) listener(e);
                else {
                    var _context;
                    (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context = this.timeouts).call(_context, setTimeout(()=>listener(e), delay));
                }
            }
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context2 = this.events).call(_context2, handleTransitionEnd);
        this.elem?.addEventListener?.('transitionend', handleTransitionEnd);
    }
    removeEndEvents() {
        this.events.forEach((listener)=>{
            this.elem?.removeEventListener?.('transitionend', listener);
        });
        this.events = [];
    }
    setElement(elem) {
        var _globalThis$animation;
        this.elem = elem || typeof document !== 'undefined' && document.createElement('div');
        if (String(this.elem?.nodeName).toLowerCase() === 'td') this.elem = this.elem.parentElement;
        this.duration = (_globalThis$animation = globalThis.animationDuration) !== null && _globalThis$animation !== void 0 ? _globalThis$animation : parseFloat(window.getComputedStyle(this.elem).transitionDuration) * 1000 || 400;
    }
    setState(state) {
        this.state = Object.freeze(state);
    }
    setOptions(opts) {
        this.opts = Object.freeze({
            ...this.opts,
            ...opts
        });
    }
    getOptions() {
        return this.opts;
    }
    remove() {
        this.stop();
        this.removeEndEvents();
        this.setState('init');
        this.isAnimating = false;
        this.onEndStack = [];
        this.onStartStack = [];
        this.__currentHeight = undefined;
        this.elem = undefined;
    }
    setAsOpen() {
        if (this.state === 'opened') return;
        this.setState('opening');
        this.callAnimationStart();
        this.setState('opened');
        this.callAnimationEnd();
    }
    setAsClosed() {
        if (this.state === 'closed') return;
        this.setState('closing');
        this.callAnimationStart();
        this.setState('closed');
        this.callAnimationEnd();
    }
    getHeight() {
        var _this$withFallback;
        return (_this$withFallback = this.withFallback(this.elem, 'clientHeight')) !== null && _this$withFallback !== void 0 ? _this$withFallback : null;
    }
    getUnknownHeight() {
        var _this$withFallback2, _this$withFallback3;
        if (!this.elem) return null;
        if (this.isAnimating && typeof this.__currentHeight !== 'undefined') return this.__currentHeight;
        const clonedElem = this.elem.cloneNode(true);
        const inputs = clonedElem.querySelectorAll('input');
        inputs.forEach((input)=>{
            input.removeAttribute('name');
            input.removeAttribute('id');
        });
        for(const key in this.firstPaintStyle)clonedElem.style[key] = this.firstPaintStyle[key];
        clonedElem.style.position = 'absolute';
        this.elem.parentNode?.insertBefore(clonedElem, this.elem.nextSibling);
        const elemWidth = this.elem.clientWidth;
        const clonedWidth = (_this$withFallback2 = this.withFallback(clonedElem, 'clientWidth', 'data-width')) !== null && _this$withFallback2 !== void 0 ? _this$withFallback2 : 0;
        if (clonedWidth > elemWidth) clonedElem.style.width = `${elemWidth}px`;
        const height = (_this$withFallback3 = this.withFallback(this.elem, 'clientHeight', 'data-height')) !== null && _this$withFallback3 !== void 0 ? _this$withFallback3 : null;
        clonedElem.parentNode?.removeChild(clonedElem);
        if (height) this.__currentHeight = height;
        return height;
    }
    withFallback(elem, key, fallback) {
        const val = fallback && elem.hasAttribute(fallback) ? parseFloat(elem.getAttribute(fallback)) : elem?.[key];
        if (isNaN(val)) return null;
        return val;
    }
    onStart(fn) {
        var _context3;
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context3 = this.onStartStack).call(_context3, fn);
    }
    onEnd(fn) {
        var _context4;
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context4 = this.onEndStack).call(_context4, fn);
    }
    start(fromHeight, toHeight) {
        if (!this.elem || !this.isInBrowser) return;
        const opts = this.getOptions();
        if (opts.animate === false) return;
        this.stop();
        this.isAnimating = true;
        this.reqId1 = window.requestAnimationFrame(()=>{
            if (!this.elem || toHeight !== 0 && this.elem.classList.contains('dnb-height-animation--stop')) return;
            this.elem.style.height = `${fromHeight}px`;
            this.reqId2 = window.requestAnimationFrame(()=>{
                if (!this.elem) return;
                this.elem.style.height = `${toHeight}px`;
            });
        });
    }
    stop() {
        this.timeouts.forEach((id)=>clearTimeout(id));
        this.timeouts = [];
        if (this.isInBrowser) {
            window.cancelAnimationFrame(this.reqId1);
            window.cancelAnimationFrame(this.reqId2);
        }
    }
    open() {
        if (this.state === 'opened' || this.state === 'opening' || this.shouldBypassAnimation()) {
            this.setAsOpen();
            return;
        }
        this.setState('opening');
        this.callAnimationStart();
        const toHeight = this.getUnknownHeight();
        this.addEndEvent((e)=>{
            if (this.state === 'opening' && e.target === e.currentTarget || !e.currentTarget) {
                if (this.elem) this.elem.style.overflowY = '';
                this.setState('opened');
                this.readjust();
            }
        });
        this.start(0, toHeight);
    }
    close() {
        if (this.state === 'closed' || this.state === 'closing' || this.shouldBypassAnimation()) {
            this.setAsClosed();
            return;
        }
        this.setState('closing');
        this.callAnimationStart();
        const fromHeight = this.getHeight();
        this.addEndEvent((e)=>{
            if (this.state === 'closing' && e.target === e.currentTarget || !e.currentTarget) {
                if (this.elem) {
                    this.elem.style.visibility = 'hidden';
                    this.elem.style.overflowY = 'clip';
                }
                this.setState('closed');
                this.callAnimationEnd();
            }
        });
        this.start(fromHeight, 0);
    }
    adjustTo(fromHeight = null, toHeight = null) {
        const opts = this.getOptions();
        if (!this.elem || opts.animate === false || this.state === 'opening' || this.state === 'closing') return;
        if (fromHeight === null) fromHeight = this.getHeight();
        if (toHeight === null) toHeight = this.getUnknownHeight();
        if (fromHeight === toHeight) return;
        this.setState('adjusting');
        this.callAnimationStart();
        this.addEndEvent((e)=>{
            if (this.state === 'adjusting' && (e.target === e.currentTarget || !e.currentTarget)) {
                if (this.elem) this.elem.style.height = 'auto';
                this.setState('adjusted');
            }
            this.callAnimationEnd();
        });
        this.start(fromHeight, toHeight);
    }
    readjust() {
        const endHeight = this.getHeight();
        if (this.elem) this.elem.style.height = 'auto';
        this.__currentHeight = undefined;
        const newHeight = this.getUnknownHeight();
        if (endHeight !== newHeight) this.adjustTo(endHeight, newHeight);
        else this.callAnimationEnd();
    }
    canFinish() {
        var _globalThis$animation2;
        return Boolean(this.startTime && Date.now() - this.startTime > ((_globalThis$animation2 = globalThis.animationDuration) !== null && _globalThis$animation2 !== void 0 ? _globalThis$animation2 : this.duration));
    }
    shouldBypassAnimation() {
        var _globalThis$bypassTim;
        const opts = this.getOptions();
        if (!this.elem || opts.animate === false) return true;
        if (this.isInBrowser && (globalThis.IS_TEST || globalThis.bypassTime === -1)) return false;
        return Boolean(this.firstTime && Date.now() - this.firstTime < ((_globalThis$bypassTim = globalThis.bypassTime) !== null && _globalThis$bypassTim !== void 0 ? _globalThis$bypassTim : 100));
    }
}



var $ieaan = parcelRequire("ieaan");
"use client";
const $02a20abffd0fc9f2$export$700979bc83e7db82 = typeof window === 'undefined' ? (0, $ieaan.useEffect) : (0, $ieaan.useLayoutEffect);
var $02a20abffd0fc9f2$export$2e2bcd8739ae039 = $02a20abffd0fc9f2$export$700979bc83e7db82;


"use client";
function $d548f0d9e45b963b$export$6149b93ac8ab7004(targetRef, { open: open = true, animate: animate = true, children: children = null, compensateForGap: compensateForGap, onInit: onInit = null, onOpen: onOpen = null, onAnimationStart: onAnimationStart = null, onAnimationEnd: onAnimationEnd = null } = {}) {
    const instRef = (0, $ieaan.useRef)(null);
    const isInitialRenderRef = (0, $ieaan.useRef)(typeof globalThis !== 'undefined' ? globalThis.readjustTime !== -1 : true);
    const [isOpen, setIsOpen] = (0, $ieaan.useState)(open);
    const [isVisible, setIsVisible] = (0, $ieaan.useState)(open);
    const [isAnimating, setIsAnimating] = (0, $ieaan.useState)(false);
    const [isVisibleParallax, setParallax] = (0, $ieaan.useState)(open);
    const eventsRef = (0, $ieaan.useRef)({
        onInit: onInit,
        onAnimationEnd: onAnimationEnd,
        onAnimationStart: onAnimationStart,
        onOpen: onOpen
    });
    eventsRef.current.onInit = onInit;
    eventsRef.current.onAnimationEnd = onAnimationEnd;
    eventsRef.current.onAnimationStart = onAnimationStart;
    eventsRef.current.onOpen = onOpen;
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        instRef.current = new (0, $268ea9ed428cf6d0$export$2e2bcd8739ae039)();
        eventsRef.current.onInit?.(instRef.current);
        return ()=>{
            instRef.current?.remove();
            instRef.current = null;
        };
    }, []);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        instRef.current.setOptions({
            animate: animate
        });
        if (typeof $parcel$global !== 'undefined' && globalThis.IS_TEST) instRef.current.setOptions({
            animate: false
        });
    }, [
        animate
    ]);
    const handleCompensateForGap = (0, $ieaan.useCallback)(()=>{
        if (compensateForGap) {
            let gap = compensateForGap;
            const { elem: elem } = instRef.current;
            if (compensateForGap === 'auto') gap = window.getComputedStyle(elem.parentElement).getPropertyValue('row-gap');
            elem.style.marginTop = `calc(${gap} * -1)`;
            const inner = elem.querySelector('.dnb-height-animation__compensate-for-gap');
            inner.style.marginTop = gap;
        }
    }, [
        compensateForGap
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        instRef.current.onStart((state)=>{
            switch(state){
                case 'opening':
                    handleCompensateForGap();
                    setIsVisible(true);
                    setParallax(true);
                    setIsAnimating(true);
                    break;
                case 'closing':
                    setParallax(false);
                    setIsAnimating(true);
                    break;
                case 'adjusting':
                    setIsAnimating(true);
                    break;
            }
            if (!isInitialRenderRef.current) eventsRef.current.onAnimationStart?.(state);
        });
        instRef.current.onEnd((state)=>{
            switch(state){
                case 'opened':
                    setIsVisible(true);
                    setIsOpen(true);
                    setIsAnimating(false);
                    eventsRef.current.onOpen?.(true);
                    break;
                case 'closed':
                    setIsVisible(false);
                    setIsOpen(false);
                    setParallax(false);
                    setIsAnimating(false);
                    eventsRef.current.onOpen?.(false);
                    break;
                case 'adjusted':
                    setIsAnimating(false);
                    break;
            }
            if (!isInitialRenderRef.current) eventsRef.current.onAnimationEnd?.(state);
        });
    }, [
        compensateForGap,
        handleCompensateForGap
    ]);
    $d548f0d9e45b963b$var$useOpenClose({
        open: open,
        instRef: instRef,
        isInitialRenderRef: isInitialRenderRef,
        targetRef: targetRef
    });
    $d548f0d9e45b963b$var$useAdjust({
        children: children,
        instRef: instRef,
        isInitialRenderRef: isInitialRenderRef,
        targetRef: targetRef
    });
    const firstPaintStyle = open && !isVisible && !isAnimating && instRef.current?.firstPaintStyle || {};
    const isInDOM = open || isVisible;
    return {
        open: open,
        isOpen: isOpen,
        isInDOM: isInDOM,
        isVisible: isVisible,
        isVisibleParallax: isVisibleParallax,
        isAnimating: isAnimating,
        firstPaintStyle: firstPaintStyle
    };
}
function $d548f0d9e45b963b$var$useOpenClose({ open: open, instRef: instRef, isInitialRenderRef: isInitialRenderRef, targetRef: targetRef }) {
    const isTest = false;
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        instRef.current.setElement(targetRef.current);
        if (!targetRef.current || instRef.current.state === 'init' && isInitialRenderRef.current) {
            if (open) instRef.current.setAsOpen();
            else instRef.current.setAsClosed();
        } else if (open) instRef.current.open();
        else instRef.current.close();
        if (isTest) {
            const event = new CustomEvent('transitionend');
            targetRef.current?.dispatchEvent(event);
        }
    }, [
        open,
        targetRef,
        instRef,
        isInitialRenderRef,
        isTest
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        const run = ()=>{
            isInitialRenderRef.current = false;
        };
        if (globalThis.bypassTime === -1 || isTest) run();
        else window.requestAnimationFrame?.(run);
    }, [
        isInitialRenderRef,
        isTest
    ]);
}
function $d548f0d9e45b963b$var$useAdjust({ children: children, instRef: instRef, isInitialRenderRef: isInitialRenderRef, targetRef: targetRef }) {
    const fromHeight = (0, $ieaan.useRef)(0);
    const [timer] = (0, $ieaan.useState)(()=>Date.now());
    const shouldAdjust = ()=>{
        switch(instRef.current?.state){
            case 'opened':
            case 'adjusted':
            case 'adjusting':
                return !isInitialRenderRef.current && Date.now() - timer > (globalThis.readjustTime || 100);
        }
        return false;
    };
    (0, $ieaan.useMemo)(()=>{
        if (shouldAdjust()) fromHeight.current = instRef.current?.getHeight();
    }, [
        children
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (shouldAdjust()) {
            instRef.current.setElement(targetRef.current);
            instRef.current.elem.style.height = '';
            const toHeight = instRef.current.getHeight();
            instRef.current.adjustTo(fromHeight.current, toHeight);
        }
    }, [
        children
    ]);
}



var $ieaan = parcelRequire("ieaan");







var $ieaan = parcelRequire("ieaan");



"use client";
function $613a70daa79e6734$var$SpaceResponsive({ density: density, defaultBreakpoint: defaultBreakpoint, off: off, children: children }) {
    const parent = (0, $ieaan.useContext)((0, $b1c1557baef2edc9$export$2e2bcd8739ae039));
    const value = off ? {
        off: off
    } : {
        ...parent || undefined,
        ...density !== undefined && {
            density: density
        },
        ...defaultBreakpoint !== undefined && {
            defaultBreakpoint: defaultBreakpoint
        }
    };
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $b1c1557baef2edc9$export$2e2bcd8739ae039), {
        value: value,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($613a70daa79e6734$var$SpaceResponsive, {
    _supportsSpacingProps: 'passthrough'
});
var $613a70daa79e6734$export$2e2bcd8739ae039 = $613a70daa79e6734$var$SpaceResponsive;



"use client";
const $92bd738e6af0b834$var$defaultProps = {};
function $92bd738e6af0b834$var$SpaceInstance(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = context.space ? (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $92bd738e6af0b834$var$defaultProps, {
        space: context.space
    }, {
        skeleton: context?.skeleton
    }) : localProps;
    const { element: element = 'div', inline: inline, noCollapse: noCollapse, top: top, right: right, bottom: bottom, left: left, style: style, space: space, innerSpace: innerSpace, stretch: stretch, skeleton: skeleton, ref: ref, className: className, children: children, ...attributes } = props;
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        space: space,
        innerSpace: innerSpace
    }, {
        style: style,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-space', stretch && 'dnb-space--stretch', inline && 'dnb-space--inline', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(null, skeleton)),
        ...attributes
    });
    params.className = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(params.className, className);
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton);
    return (0, $60739c7e3f826d8d$exports.jsx)($92bd738e6af0b834$var$SpaceElement, {
        element: element,
        noCollapse: noCollapse,
        ref: ref,
        ...params,
        children: children
    });
}
function $92bd738e6af0b834$var$Space(props) {
    return (0, $60739c7e3f826d8d$exports.jsx)($92bd738e6af0b834$var$SpaceInstance, {
        ...props
    });
}
$92bd738e6af0b834$var$Space.ResponsiveContext = (0, $613a70daa79e6734$export$2e2bcd8739ae039);
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($92bd738e6af0b834$var$Space, {
    _supportsSpacingProps: true
});
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($92bd738e6af0b834$var$Space.ResponsiveContext, {
    _supportsSpacingProps: 'passthrough'
});
var $92bd738e6af0b834$export$2e2bcd8739ae039 = $92bd738e6af0b834$var$Space;
function $92bd738e6af0b834$var$SpaceElement({ element: element, noCollapse: noCollapse, children: children, ref: ref, ...props }) {
    const ElementDynamic = element;
    if (typeof element === 'string') (0, $11741836d1790446$export$4ddc669a9a6a5940)({}, props);
    props['ref'] = ref;
    const component = (0, $60739c7e3f826d8d$exports.jsx)(ElementDynamic, {
        ...props,
        children: children
    });
    if (noCollapse) {
        const R = ElementDynamic === 'span' || (0, $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e)(element) ? 'span' : 'div';
        return (0, $60739c7e3f826d8d$exports.jsx)(R, {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-space--no-collapse', (0, $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e)(element) && 'dnb-space--inline'),
            children: component
        });
    }
    return component;
}



"use client";
function $c329544388f437e5$var$HeightAnimation({ open: open = true, animate: animate = true, keepInDOM: keepInDOM = false, showOverflow: showOverflow = false, element: element, duration: duration, delay: delay, className: className, ref: ref, children: children, compensateForGap: compensateForGap, onInit: onInit = null, onOpen: onOpen = null, onAnimationStart: onAnimationStart = null, onAnimationEnd: onAnimationEnd = null, ...rest }) {
    const elementRef = (0, $ieaan.useRef)(undefined);
    const targetRef = ref || elementRef;
    const { isInDOM: isInDOM, isVisible: isVisible, isVisibleParallax: isVisibleParallax, isAnimating: isAnimating, firstPaintStyle: firstPaintStyle } = (0, $d548f0d9e45b963b$export$6149b93ac8ab7004)(targetRef, {
        open: open,
        animate: animate,
        children: children,
        compensateForGap: compensateForGap,
        onInit: onInit,
        onOpen: onOpen,
        onAnimationStart: onAnimationStart,
        onAnimationEnd: onAnimationEnd
    });
    (0, $ieaan.useEffect)(()=>{
        const el = targetRef.current;
        if (!el) return;
        if (duration) el.style.setProperty('--duration', `${duration}ms`);
        else el.style.removeProperty('--duration');
        if (delay) el.style.setProperty('--delay', `${delay}ms`);
        else el.style.removeProperty('--delay');
    }, [
        duration,
        delay,
        targetRef,
        isInDOM
    ]);
    if (!keepInDOM && !isInDOM && !isAnimating) return null;
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        ref: targetRef,
        element: element || 'div',
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-height-animation', isInDOM && 'dnb-height-animation--is-in-dom', isVisible && 'dnb-height-animation--is-visible', animate && isVisibleParallax && 'dnb-height-animation--parallax', isAnimating && 'dnb-height-animation--animating', !isVisible && !isAnimating && !open && 'dnb-height-animation--hidden', showOverflow && 'dnb-height-animation--show-overflow', className),
        style: {
            ...firstPaintStyle,
            ...rest?.style
        },
        "aria-hidden": keepInDOM ? !open : undefined,
        ...rest,
        children: compensateForGap ? (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-height-animation__compensate-for-gap",
            children: children
        }) : children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($c329544388f437e5$var$HeightAnimation, {
    _supportsSpacingProps: 'children'
});
var $c329544388f437e5$export$2e2bcd8739ae039 = $c329544388f437e5$var$HeightAnimation;




var $ieaan = parcelRequire("ieaan");





const $17c197fe5e85d9a5$export$126bd5ddaa4ee61e = (name)=>String(name).replace(/((?!^)[A-Z])/g, '_$1').toLowerCase().replace(/^[0-9]/g, '$1').replace(/[^a-z0-9_]/gi, '_');







var $ieaan = parcelRequire("ieaan");


function $b2f5e7b64029ed28$export$66bb15e2994e6a26(states) {
    const entries = Object.entries(states);
    const [defaultName, defaultIcon] = entries[0];
    const defaultPoints = $b2f5e7b64029ed28$var$parsePath($b2f5e7b64029ed28$var$extractPathD(defaultIcon));
    const canMorph = defaultPoints.length > 0 && entries.every(([name, icon])=>{
        const d = $b2f5e7b64029ed28$var$extractPathD(icon);
        if (!$b2f5e7b64029ed28$var$isFullyParseable(d)) return false;
        if (name === defaultName) return true;
        const points = $b2f5e7b64029ed28$var$parsePath(d);
        return points.length === defaultPoints.length;
    });
    const iconFn = (props)=>{
        const activeState = props?.['data-transition-state'] || defaultName;
        const { 'data-transition-state': _, ...svgProps } = props || {};
        return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: entries.map(([name, iconRenderer])=>{
                const element = iconRenderer(svgProps);
                return (0, $ieaan.cloneElement)(element, {
                    key: name,
                    'data-icon-state': name,
                    className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(element.props.className, name === activeState && 'dnb-icon__state--active')
                });
            })
        });
    };
    iconFn.__iconTransitionFallback = true;
    if (canMorph) {
        const style = {};
        for (const [name, icon] of entries){
            const points = name === defaultName ? defaultPoints : $b2f5e7b64029ed28$var$alignPath(defaultPoints, $b2f5e7b64029ed28$var$parsePath($b2f5e7b64029ed28$var$extractPathD(icon)));
            style[`--icon-transition-${name}`] = `path('${$b2f5e7b64029ed28$var$pointsToString(points)}')`;
        }
        style['--icon-transition-default'] = `var(--icon-transition-${defaultName})`;
        iconFn.__iconTransitionStyle = style;
    }
    Object.defineProperty(iconFn, 'name', {
        value: defaultIcon.name
    });
    return iconFn;
}
$b2f5e7b64029ed28$export$66bb15e2994e6a26.activate = (element, state)=>{
    element.querySelectorAll('svg[data-icon-state]').forEach((svg)=>{
        svg.classList.toggle('dnb-icon__state--active', svg.dataset.iconState === state);
    });
    if (element.style.getPropertyValue('--icon-transition-default')) element.style.setProperty('--icon-transition', `var(--icon-transition-${state})`);
};
function $b2f5e7b64029ed28$export$a1a623471fc929a(element, callback) {
    const targets = [
        element,
        ...Array.from(element.querySelectorAll('svg, svg path'))
    ];
    for (const el of targets)el.style.setProperty('transition', 'none');
    callback();
    element.getBoundingClientRect();
    for (const el of targets)el.style.removeProperty('transition');
}
$b2f5e7b64029ed28$export$66bb15e2994e6a26.isSupported = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('d: path("M0 0")');
function $b2f5e7b64029ed28$var$extractPathD(iconFn) {
    const svg = iconFn();
    return svg.props.children?.props?.d;
}
function $b2f5e7b64029ed28$var$isFullyParseable(d) {
    if (!d) return false;
    const parts = d.match(/[a-zA-Z][^a-zA-Z]*/g) || [];
    return parts.every((part)=>'mlhvMLHV'.includes(part[0]));
}
function $b2f5e7b64029ed28$var$parsePath(d) {
    if (!d) return [];
    const parts = d.match(/[a-zA-Z][^a-zA-Z]*/g) || [];
    const points = [];
    let x = 0;
    let y = 0;
    for (const part of parts){
        const command = part[0];
        const type = command.toLowerCase();
        const numbers = Array.from(part.slice(1).matchAll(/-?\d*\.?\d+/g), (match)=>Number(match[0]));
        const isRelative = command === type;
        const resolve = (current, value)=>isRelative ? current + value : value;
        if (type === 'm' || type === 'l') for(let i = 0; i < numbers.length; i += 2){
            x = resolve(x, numbers[i]);
            y = resolve(y, numbers[i + 1]);
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(points).call(points, {
                cmd: i === 0 && type === 'm' ? 'M' : 'L',
                x: x,
                y: y
            });
        }
        else if (type === 'h') {
            x = resolve(x, numbers[0]);
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(points).call(points, {
                cmd: 'L',
                x: x,
                y: y
            });
        } else if (type === 'v') {
            y = resolve(y, numbers[0]);
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(points).call(points, {
                cmd: 'L',
                x: x,
                y: y
            });
        }
    }
    return points;
}
function $b2f5e7b64029ed28$var$pointsToString(points) {
    return points.map((point)=>`${point.cmd}${point.x} ${point.y}`).join(' ');
}
function $b2f5e7b64029ed28$var$squaredDistance(pointsA, pointsB) {
    return pointsA.reduce((sum, point, i)=>sum + (point.x - pointsB[i].x) ** 2 + (point.y - pointsB[i].y) ** 2, 0);
}
function $b2f5e7b64029ed28$var$alignPath(reference, target) {
    if (reference.length !== target.length || reference.length === 0) return target;
    const subpaths = [];
    for(let i = 0; i < reference.length; i++){
        var _context, _context2;
        if (reference[i].cmd === 'M') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(subpaths).call(subpaths, [
            [],
            []
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context = subpaths[subpaths.length - 1][0]).call(_context, reference[i]);
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context2 = subpaths[subpaths.length - 1][1]).call(_context2, target[i]);
    }
    return subpaths.flatMap(([referenceSubpath, targetSubpath])=>{
        const reversed = [
            ...targetSubpath
        ].reverse().map((point, index)=>({
                ...point,
                cmd: index === 0 ? 'M' : 'L'
            }));
        return $b2f5e7b64029ed28$var$squaredDistance(referenceSubpath, reversed) < $b2f5e7b64029ed28$var$squaredDistance(referenceSubpath, targetSubpath) ? reversed : targetSubpath;
    });
}



"use client";
const $18e1fb7032604f9e$export$319c661b2c32450 = 16;
const $18e1fb7032604f9e$export$abf30d92431bd688 = {
    default: 16,
    medium: 24
};
const $18e1fb7032604f9e$export$52256abe9722101 = [
    [
        'default',
        16
    ],
    [
        'medium',
        24
    ]
];
const $18e1fb7032604f9e$export$973d29e2233a6203 = [
    'small',
    'default',
    'medium',
    'large',
    'x-large',
    'xx-large'
];
function $18e1fb7032604f9e$export$2e2bcd8739ae039(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, {}, {
        skeleton: context?.skeleton
    }, context.Icon);
    const { icon: iconProp, size: size, wrapperParams: wrapperParams, iconParams: iconParams, alt: alt, children: children, transitionState: transitionState } = $18e1fb7032604f9e$var$usePrepareIcon(props, context);
    const icon = iconProp !== null && iconProp !== void 0 ? iconProp : children;
    const ref = (0, $ieaan.useRef)(null);
    const isInitialMount = (0, $ieaan.useRef)(true);
    const { ref: externalRef, ...restWrapperParams } = wrapperParams;
    const combinedRef = (0, $e48c94c3f1835290$export$2e2bcd8739ae039)(ref, externalRef);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (!transitionState || !ref.current) return;
        if (isInitialMount.current) {
            isInitialMount.current = false;
            (0, $b2f5e7b64029ed28$export$a1a623471fc929a)(ref.current, ()=>{
                (0, $b2f5e7b64029ed28$export$66bb15e2994e6a26).activate(ref.current, transitionState);
            });
        } else (0, $b2f5e7b64029ed28$export$66bb15e2994e6a26).activate(ref.current, transitionState);
    }, [
        transitionState,
        icon
    ]);
    if (!icon) return null;
    const IconContainer = $18e1fb7032604f9e$export$20da8aa394d9a3ff({
        icon: icon,
        size: size,
        alt: alt
    });
    if (!IconContainer) return null;
    return (0, $60739c7e3f826d8d$exports.jsx)("span", {
        ...restWrapperParams,
        ref: combinedRef,
        children: (0, $60739c7e3f826d8d$exports.jsx)(IconContainer, {
            ...iconParams
        })
    });
}
function $18e1fb7032604f9e$export$3168922d086c8fe7(icon) {
    if ((0, $ieaan.isValidElement)(icon) && icon?.type) icon = icon?.type;
    const name = typeof icon === 'function' ? icon.name : String(icon);
    if (/^data:image\//.test(name)) return null;
    return name;
}
function $18e1fb7032604f9e$export$ffb38d77b69e936e(props) {
    const { icon: icon, size: size, width: width, height: height } = props;
    let sizeAsInt = null;
    let sizeAsString = null;
    if (!size || size === $18e1fb7032604f9e$export$319c661b2c32450) {
        const name = $18e1fb7032604f9e$export$3168922d086c8fe7(icon);
        const nameParts = String(name || '').split('_');
        if (nameParts.length > 1) {
            const lastPartOfIconName = nameParts.reverse()[0];
            const potentialSize = $18e1fb7032604f9e$export$52256abe9722101.filter(([key])=>key === lastPartOfIconName)?.[0]?.[1];
            if (potentialSize) sizeAsInt = potentialSize;
            if ($18e1fb7032604f9e$export$973d29e2233a6203.includes(lastPartOfIconName)) sizeAsString = lastPartOfIconName;
        } else {
            const iconFn = typeof icon === 'function' ? icon : (0, $ieaan.isValidElement)(icon) && typeof icon.type === 'function' ? icon.type : null;
            const hasHooks = iconFn ? /\buse[A-Z][A-Za-z0-9_]*\b/.test(iconFn.toString()) : false;
            if (iconFn && !hasHooks) try {
                const elem = iconFn();
                const potentialSize = elem?.props?.width;
                if (potentialSize && !isNaN(potentialSize)) sizeAsInt = potentialSize;
            } catch  {}
        }
    } else if (typeof size === 'string' && !(parseFloat(size) > 0)) {
        var _ListDefaultIconSizes;
        sizeAsInt = (_ListDefaultIconSizes = $18e1fb7032604f9e$export$52256abe9722101.filter(([key])=>key === size)?.[0]?.[1]) !== null && _ListDefaultIconSizes !== void 0 ? _ListDefaultIconSizes : -1;
        if ($18e1fb7032604f9e$export$973d29e2233a6203.includes(size)) sizeAsString = size;
    } else if (parseFloat(String(size)) > 0) {
        var _ListDefaultIconSizes2;
        sizeAsInt = (_ListDefaultIconSizes2 = $18e1fb7032604f9e$export$52256abe9722101.filter(([key, value])=>key && value === parseFloat(String(size)))?.[0]?.[1]) !== null && _ListDefaultIconSizes2 !== void 0 ? _ListDefaultIconSizes2 : -1;
        if (sizeAsInt === -1) {
            sizeAsInt = parseFloat(String(size));
            sizeAsString = 'custom-size';
        }
    }
    if (!sizeAsString && sizeAsInt > 0) {
        const potentialSizeAsString = $18e1fb7032604f9e$export$52256abe9722101.reduce((acc, [key, value])=>{
            if (key && value === sizeAsInt) return key;
            return acc;
        }, null);
        if (potentialSizeAsString) sizeAsString = potentialSizeAsString;
    }
    const { sizeAsString: isCustomSize, params: iconParams } = $18e1fb7032604f9e$var$prepareIconParams({
        sizeAsString: sizeAsString,
        sizeAsInt: sizeAsInt,
        size: size,
        width: width,
        height: height
    });
    if (isCustomSize) sizeAsString = isCustomSize;
    if (!(sizeAsInt > 0)) sizeAsInt = $18e1fb7032604f9e$export$319c661b2c32450;
    if (size === 'auto') {
        iconParams.width = '100%';
        iconParams.height = '100%';
        sizeAsString = 'auto';
    }
    return {
        iconParams: iconParams,
        sizeAsInt: sizeAsInt,
        sizeAsString: sizeAsString
    };
}
function $18e1fb7032604f9e$var$prepareIconParams({ sizeAsString: sizeAsString, ...rest }) {
    const { size: size, width: width, height: height, sizeAsInt: sizeAsInt } = rest;
    const params = {};
    if (!sizeAsString && !(sizeAsInt > 0) && parseFloat(String(size)) > -1) params.width = params.height = parseFloat(String(size));
    else if (sizeAsString === 'custom-size') params.width = params.height = parseFloat(String(sizeAsInt));
    if (parseFloat(String(width)) > -1) {
        sizeAsString = 'custom-size';
        params.width = parseFloat(String(width));
    }
    if (parseFloat(String(height)) > -1) {
        sizeAsString = 'custom-size';
        params.height = parseFloat(String(height));
    }
    (0, $11741836d1790446$export$4ddc669a9a6a5940)({}, params);
    return {
        params: params,
        sizeAsString: sizeAsString
    };
}
function $18e1fb7032604f9e$export$dbac4b0afb3666a7(props, context, cachedValues) {
    var _cachedValues$label;
    const { icon: icon, size: size, width: width, height: height, border: border, color: color, fill: fill, inheritColor: inheritColor, modifier: modifier, alt: alt, title: title, skeleton: skeleton, className: className, transitionState: _transitionState, ...attributes } = props;
    const { sizeAsString: sizeAsString, iconParams: iconParams } = cachedValues || $18e1fb7032604f9e$export$ffb38d77b69e936e({
        icon: icon,
        size: size,
        width: width,
        height: height
    });
    if (color) iconParams.color = color;
    const label = (_cachedValues$label = cachedValues?.label) !== null && _cachedValues$label !== void 0 ? _cachedValues$label : icon ? $18e1fb7032604f9e$export$3168922d086c8fe7(icon) : null;
    const isFilled = Boolean(fill);
    const wrapperParams = (0, $11741836d1790446$export$4ddc669a9a6a5940)(props, {
        role: alt ? 'img' : 'presentation',
        alt: alt,
        'aria-label': label && !label.includes('default') ? label.replace(/_/g, ' ') + ' icon' : null,
        title: title,
        ...attributes
    });
    if (!alt && typeof wrapperParams['aria-hidden'] === 'undefined') wrapperParams['aria-hidden'] = true;
    if (wrapperParams['aria-hidden']) {
        wrapperParams['data-testid'];
        delete wrapperParams['aria-label'];
    }
    wrapperParams.className = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-icon', modifier && `dnb-icon--${modifier}`, border && 'dnb-icon--border', isFilled && 'dnb-icon--filled', inheritColor !== false && 'dnb-icon--inherit-color', sizeAsString ? `dnb-icon--${sizeAsString}` : 'dnb-icon--default', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(null, skeleton, context), className);
    const iconToRender = $18e1fb7032604f9e$var$getIcon(props);
    if (typeof iconToRender === 'function') {
        if (iconToRender.__iconTransitionFallback) {
            wrapperParams.className += ' dnb-icon--transition-fallback';
            if (_transitionState) iconParams['data-transition-state'] = _transitionState;
        }
        if (iconToRender.__iconTransitionStyle) wrapperParams.style = {
            ...wrapperParams.style,
            ...iconToRender.__iconTransitionStyle,
            ..._transitionState && {
                '--icon-transition': `var(--icon-transition-${_transitionState})`
            }
        };
    }
    return {
        ...props,
        icon: iconToRender,
        alt: alt,
        iconParams: iconParams,
        wrapperParams: wrapperParams
    };
}
function $18e1fb7032604f9e$var$usePrepareIcon(props, context) {
    const { icon: icon, size: size, width: width, height: height } = props;
    const cachedCalcSize = $18e1fb7032604f9e$export$ffb38d77b69e936e({
        icon: icon,
        size: size,
        width: width,
        height: height
    });
    const label = (0, $ieaan.useMemo)(()=>icon ? $18e1fb7032604f9e$export$3168922d086c8fe7(icon) : null, [
        icon
    ]);
    const result = (0, $ieaan.useMemo)(()=>$18e1fb7032604f9e$export$dbac4b0afb3666a7(props, context, {
            ...cachedCalcSize,
            label: label
        }), [
        props,
        context,
        cachedCalcSize,
        label
    ]);
    const spacingProps = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(props, {
        className: result.wrapperParams.className,
        style: result.wrapperParams.style
    });
    return {
        ...result,
        wrapperParams: {
            ...result.wrapperParams,
            ...spacingProps
        }
    };
}
function $18e1fb7032604f9e$export$20da8aa394d9a3ff(props) {
    const { size: size = null, listOfIcons: listOfIcons = null, alt: alt = null } = props;
    let { icon: icon } = props;
    if (typeof icon === 'string' && /^data:image\//.test(icon)) return ()=>(0, $60739c7e3f826d8d$exports.jsx)("img", {
            src: String(icon),
            alt: alt || ''
        });
    if (typeof icon === 'function') return icon;
    if ((0, $ieaan.isValidElement)(icon) || Array.isArray(icon)) return ()=>icon;
    try {
        icon = (0, $17c197fe5e85d9a5$export$126bd5ddaa4ee61e)(icon);
        if (size && $18e1fb7032604f9e$export$abf30d92431bd688[size] && size !== 'basis' && size !== 'default' && !(parseFloat(String(size)) > 0) && !icon.includes(size)) icon = `${icon}_${size}`;
        const mod = (listOfIcons.dnbIcons ? listOfIcons.dnbIcons : listOfIcons)[icon];
        return mod && mod.default ? mod.default : mod;
    } catch (e) {
        (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Icon '${icon}' did not exist!`);
        return null;
    }
}
function $18e1fb7032604f9e$var$getIcon(props) {
    if (props.icon) return props.icon;
    if (typeof props.children === 'function') return props.children;
    return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($18e1fb7032604f9e$export$2e2bcd8739ae039, {
    _supportsSpacingProps: true
});
$18e1fb7032604f9e$export$2e2bcd8739ae039.transition = (0, $b2f5e7b64029ed28$export$66bb15e2994e6a26);





class $fe477a1647186b55$export$fac78e8a55bae6a6 {
    constructor(id, props = null){
        this.internalId = id;
        if (props) this.add(props);
    }
    onUpdate(event) {
        if (this._onUpdateEvents.filter((cb)=>cb === event).length === 0) {
            var _context;
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context = this._onUpdateEvents).call(_context, event);
        }
    }
    forceRerender(globalStatus, props, { bufferDelay: bufferDelay = 0, isEmpty: isEmpty = false } = {}) {
        const run = ()=>{
            this._onUpdateEvents.forEach((event)=>{
                if (typeof event === 'function') event(globalStatus, props, {
                    isEmpty: isEmpty
                });
            });
        };
        if (bufferDelay > 0) {
            clearTimeout(this._bufferDelayId);
            this._bufferDelayId = setTimeout(run, bufferDelay);
        } else run();
    }
    init(props) {
        return this.add(props, {
            preventRerender: true
        });
    }
    add(props, opts = {}) {
        this.remove('internal-close', {
            preventRerender: true
        });
        const newProps = {
            ...props
        };
        if (!newProps.statusId) newProps.statusId = (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
        if (typeof newProps.show === 'undefined') newProps.show = true;
        if (newProps.children) {
            newProps.text = newProps.children;
            delete newProps.children;
        }
        const stackIndex = this.stack.findIndex((cur)=>cur.statusId === newProps.statusId);
        if (stackIndex > -1) this.stack[stackIndex] = newProps;
        else {
            var _context2;
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context2 = this.stack).call(_context2, newProps);
        }
        const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
        if (!opts?.preventRerender) this.forceRerender(globalStatus, props, {
            bufferDelay: props?.bufferDelay > -1 ? props.bufferDelay : 0
        });
        return globalStatus;
    }
    get(statusId) {
        return this.stack.find((cur)=>cur.statusId === statusId);
    }
    update(statusId, newProps, opts = {}) {
        const item = this.get(statusId);
        if (!item) this.add(newProps, {
            preventRerender: true
        });
        else this.stack = this.stack.map((cur, i, arr)=>{
            if (statusId ? cur.statusId === statusId : i === arr.length - 1) return {
                ...cur,
                ...newProps
            };
            return cur;
        });
        this.restack(statusId);
        const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
        if (!opts?.preventRerender) this.forceRerender(globalStatus, null, {
            bufferDelay: newProps?.bufferDelay > -1 ? newProps.bufferDelay : 1
        });
    }
    restack(statusId) {
        const item = this.get(statusId);
        if (item) {
            var _context3;
            this.stack = this.stack.filter((cur)=>{
                return cur.statusId !== statusId;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context3 = this.stack).call(_context3, item);
        }
    }
    remove(statusId, opts = {}) {
        if (statusId) {
            this.stack = this.stack.filter((cur)=>{
                return cur.statusId !== statusId;
            });
            const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
            if (!opts?.preventRerender) this.forceRerender(globalStatus, null, {
                bufferDelay: opts?.bufferDelay > -1 ? opts.bufferDelay : 1
            });
        }
    }
    empty() {
        this._onUpdateEvents.forEach((cb, i)=>{
            this._onUpdateEvents[i] = null;
        });
        this._onUpdateEvents = [];
        this._onReadyEvents.forEach((cb, i)=>{
            this._onReadyEvents[i] = null;
        });
        this._onReadyEvents = [];
    }
    unbind() {
        this.empty();
        $fe477a1647186b55$var$GlobalStatusProvider.remove(this.internalId);
    }
    isReady() {
        this._onReadyEvents = this._onReadyEvents.filter(({ status: status, cb: cb }, i)=>{
            if (typeof cb === 'function') cb(status);
            this._onReadyEvents[i] = null;
            return false;
        });
        return true;
    }
    addOnReady(status, cb) {
        var _context4;
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context4 = this._onReadyEvents).call(_context4, {
            status: status,
            cb: cb
        });
    }
    stack = [];
    globalStatus = {};
    _onUpdateEvents = [];
    _onReadyEvents = [];
    _bufferDelayId = (()=>undefined)();
}
class $fe477a1647186b55$var$GlobalStatusProvider {
    static providers = {};
    static create = (id = 'main', props = null)=>{
        return $fe477a1647186b55$var$GlobalStatusProvider.providers[id] = new $fe477a1647186b55$export$fac78e8a55bae6a6(id, props);
    };
    static init(id = 'main', onReady = null, props = null) {
        const existingStatus = $fe477a1647186b55$var$GlobalStatusProvider.get(id);
        if (existingStatus) {
            if (props) existingStatus.add(props);
            if (typeof onReady === 'function') onReady(existingStatus);
            return existingStatus;
        }
        const newStatus = $fe477a1647186b55$var$GlobalStatusProvider.create(id, props);
        if (onReady) newStatus.addOnReady(newStatus, onReady);
        if (id !== 'main') (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`No <GlobalStatus ${`id="${id}"`} /> found.`);
        return newStatus;
    }
    static get(id = 'main') {
        return $fe477a1647186b55$var$GlobalStatusProvider.providers[id] || null;
    }
    static remove(id = 'main') {
        if ($fe477a1647186b55$var$GlobalStatusProvider.providers[id]) delete $fe477a1647186b55$var$GlobalStatusProvider.providers[id];
    }
    static prepareItemWithStatusId(item, statusId = null) {
        if (typeof item === 'string') item = {
            text: item
        };
        if (!item.itemId) {
            if (statusId && statusId !== 'status-main') item.itemId = statusId;
            else if (item?.text) item.itemId = (0, $11741836d1790446$export$c383cdd2a518017a)((0, $11741836d1790446$export$5bfc594bd2dc6e21)(item.text));
            else item.itemId = (0, $11741836d1790446$export$c383cdd2a518017a)(item);
        }
        return item;
    }
    static combineMessages(stack) {
        const globalStatus = stack.reduce((acc, cur)=>{
            cur = {
                ...cur
            };
            if (typeof cur.items === 'string' && cur.items[0] === '[') cur.items = (0, (/*@__PURE__*/$parcel$interopDefault($1eb0299e6a3602cd$exports)))(cur.items);
            if (cur.item) {
                if (typeof cur.item === 'string' && cur.item[0] === '{') cur.item = (0, (/*@__PURE__*/$parcel$interopDefault($1eb0299e6a3602cd$exports)))(cur.item);
                const items = Array.isArray(cur.items) ? cur.items : [];
                (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(items).call(items, cur.item);
                cur.items = items;
            }
            if (Array.isArray(cur.items)) cur.items = cur.items.reduce((_acc, item)=>{
                item = $fe477a1647186b55$var$GlobalStatusProvider.prepareItemWithStatusId(item);
                const foundAtIndex = _acc.findIndex(({ itemId: itemId })=>itemId === item.itemId);
                if (foundAtIndex > -1) _acc[foundAtIndex] = item;
                else (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_acc).call(_acc, item);
                return _acc;
            }, acc.items || []);
            Object.assign(acc, cur);
            return acc;
        }, {});
        return globalStatus;
    }
}
if (typeof window !== 'undefined') window.GlobalStatusProvider = $fe477a1647186b55$var$GlobalStatusProvider;
var $fe477a1647186b55$export$2e2bcd8739ae039 = $fe477a1647186b55$var$GlobalStatusProvider;




var $27f864b62ee5eaea$export$2e2bcd8739ae039 = {
    '--sb-font-family-default': "'Roboto', 'Helvetica', 'Arial', sans-serif",
    '--sb-font-family-heading': "'MaisonNeueHeadings', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    '--sb-font-weight-default': 'normal',
    '--sb-font-weight-basis': 'normal',
    '--sb-font-weight-regular': 'normal',
    '--sb-font-weight-medium': '500',
    '--sb-font-weight-bold': '700',
    '--sb-font-size-x-small': '0.75rem',
    '--sb-font-size-small': '0.875rem',
    '--sb-font-size-basis': '1rem',
    '--sb-font-size-basis--em': '1em',
    '--sb-font-size-lead': 'var(--font-size-medium)',
    '--sb-font-size-medium': '1.25rem',
    '--sb-font-size-medium--plus': '1.625rem',
    '--sb-font-size-large': '2rem',
    '--sb-font-size-x-large': '2.375rem',
    '--sb-font-size-xx-large': '3rem',
    '--sb-line-height-x-small': '1.125rem',
    '--sb-line-height-small': '1.25rem',
    '--sb-line-height-basis': '1.5rem',
    '--sb-line-height-basis--em': '1.5em',
    '--sb-line-height-lead': '1.75rem',
    '--sb-line-height-medium': '2rem',
    '--sb-line-height-large': '2.375rem',
    '--sb-line-height-x-large': '2.75rem',
    '--sb-line-height-xx-large': '3.375rem',
    '--sb-color-black': '#000',
    '--sb-color-text': '#18172a',
    '--sb-color-gray-dark-3': '#3a3a4a',
    '--sb-color-gray-dark-3-neutral': '#3e3e4a',
    '--sb-color-gray-dark-2': '#4a4a5b',
    '--sb-color-gray-dark-2-neutral': '#656472',
    '--sb-color-gray-dark': '#666578',
    '--sb-color-gray-dark-neutral': '#9494a3',
    '--sb-color-gray': '#bbbbce',
    '--sb-color-gray-neutral': '#bdbdc6',
    '--sb-color-gray-light': '#d9d9e4',
    '--sb-color-gray-light-2': '#ebebf2',
    '--sb-color-gray-light-3': '#f9f9fd',
    '--sb-color-purple': '#1c1b4e',
    '--sb-color-purple-alternative': '#222163',
    '--sb-color-green': '#92eecd',
    '--sb-color-white': '#fff',
    '--sb-color-red': '#d8134b',
    '--sb-color-magenta': '#ff3c64',
    '--sb-color-orange': '#ff5b44',
    '--sb-color-yellow-dark': '#f7bf16',
    '--sb-color-yellow': '#ffef57',
    '--sb-color-green-dark-3': '#00785b',
    '--sb-color-green-dark-2': '#1e9f73',
    '--sb-color-violet': '#4e08bc',
    '--sb-color-violet-light': '#7129e2',
    '--sb-color-blue-dark-2': '#044ccc',
    '--sb-color-blue-dark': '#005cff',
    '--sb-color-blue': '#008eff',
    '--sb-color-orange-light': '#ff817b',
    '--sb-color-orange-light-2': '#ffd7d5',
    '--sb-color-orange-light-3': '#fff0ef',
    '--sb-color-magenta-light': '#ffb6d2',
    '--sb-color-magenta-light-2': '#ffdbe9',
    '--sb-color-magenta-light-3': '#fff5f9',
    '--sb-color-yellow-light': '#fff489',
    '--sb-color-yellow-light-2': '#fff9c4',
    '--sb-color-yellow-light-3': '#fffce5',
    '--sb-color-green-dark': '#64d7b4',
    '--sb-color-green-light': '#c8f6e5',
    '--sb-color-green-light-2': '#e5fff7',
    '--sb-color-violet-light-2': '#be99ff',
    '--sb-color-violet-light-3': '#e0d0ff',
    '--sb-color-violet-light-4': '#f1ebff',
    '--sb-color-blue-light': '#61b9ff',
    '--sb-color-blue-light-2': '#bfe3ff',
    '--sb-color-blue-light-3': '#ebf6ff',
    '--sb-spacing-x-small': '0.5rem',
    '--sb-spacing-small': '1rem',
    '--sb-spacing-medium': '1.5rem',
    '--sb-spacing-large': '2rem',
    '--sb-spacing-x-large': '3rem',
    '--sb-spacing-xx-large': '3.5rem',
    '--sb-layout-small': '40em',
    '--sb-layout-medium': '60em',
    '--sb-layout-large': '72em',
    '--sb-shadow-small': '0 2px 4px rgba(38 35 66 / 12%)',
    '--sb-shadow-medium': '0 5px 20px rgba(38 35 66 / 10%)',
    '--sb-shadow-large': '0 5px 20px rgba(38 35 66 / 20%)',
    '--sb-shadow-hover': '0 20px 40px rgba(38 35 66 / 20%)',
    '--sb-easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--prose-max-width': '60ch',
    '--color-emerald-green-50': '#89aaac',
    '--color-emerald-green-25': '#c4d4d6',
    '--color-emerald-green-10': '#e8eeef',
    '--ca-font-family-heading': "'ArizonaFlare', var(--font-family-default)",
    '--ca-color-ocean-green': '#00343e',
    '--ca-color-burgundy-red': '#5c0022',
    '--ca-color-noir-green': '#001114',
    '--ca-color-sea-green': '#007272',
    '--ca-color-noir-red': '#24000d',
    '--ca-color-sober-red': '#8e4049',
    '--ca-color-classic-beige': '#f6eae4',
    '--ca-color-pale-green': '#ccf0e7',
    '--ca-color-pale-red': '#ffdedb',
    '--font-family-default': "'DNB', sans-serif",
    '--font-family-heading': 'var(--font-family-default)',
    '--font-family-monospace': "'DNBMono', 'Menlo', 'Consolas', 'Roboto Mono', 'Ubuntu Monospace', 'Noto Mono', 'Oxygen Mono', 'Liberation Mono', monospace",
    '--font-weight-default': 'normal',
    '--font-weight-basis': 'normal',
    '--font-weight-regular': 'normal',
    '--font-weight-medium': '500',
    '--font-weight-bold': '600',
    '--font-size-x-small': '0.875rem',
    '--font-size-small': '1rem',
    '--font-size-basis': '1.125rem',
    '--font-size-basis--em': '1em',
    '--font-size-lead': 'var(--font-size-medium)',
    '--font-size-medium': '1.25rem',
    '--font-size-large': '1.625rem',
    '--font-size-x-large': '2.125rem',
    '--font-size-xx-large': '3rem',
    '--line-height-xx-small--em': '1em',
    '--line-height-x-small': '1.25rem',
    '--line-height-small': '1.25rem',
    '--line-height-basis': '1.5rem',
    '--line-height-basis--em': '1.333em',
    '--line-height-lead': 'var(--line-height-medium)',
    '--line-height-medium': '1.5rem',
    '--line-height-large': '2rem',
    '--line-height-x-large': '2.5rem',
    '--line-height-xx-large': '3.5rem',
    '--color-mint-green-50': '#d2f0e9',
    '--color-mint-green-25': '#e9f8f4',
    '--color-mint-green-12': '#f4fbf9',
    '--color-sea-green-30': '#b3d5d5',
    '--color-accent-yellow-30': '#feebc1',
    '--color-signal-orange': '#ff5400',
    '--color-fire-red': '#dc2a2a',
    '--color-success-green': '#007b5e',
    '--color-fire-red-8': '#fdeeee',
    '--color-black': '#000',
    '--color-black-80': '#333',
    '--color-black-55': '#737373',
    '--color-black-20': '#ccc',
    '--color-black-8': '#ebebeb',
    '--color-black-3': '#f8f8f8',
    '--color-white': '#fff',
    '--color-sea-green': '#007272',
    '--color-mint-green': '#a5e1d2',
    '--color-summer-green': '#28b482',
    '--color-emerald-green': '#14555a',
    '--color-ocean-green': '#00343e',
    '--color-accent-yellow': '#fdbb31',
    '--color-indigo': '#23195a',
    '--color-violet': '#6e2382',
    '--color-sky-blue': '#4bbed2',
    '--color-lavender': '#f2f2f5',
    '--color-sand-yellow': '#fbf6ec',
    '--color-pistachio': '#f2f4ec',
    '--spacing-xx-small': '0.25rem',
    '--spacing-x-small': '0.5rem',
    '--spacing-small': '1rem',
    '--spacing-medium': '1.5rem',
    '--spacing-large': '2rem',
    '--spacing-x-large': '3rem',
    '--spacing-xx-large': '3.5rem',
    '--layout-small': '40em',
    '--layout-medium': '60em',
    '--layout-large': '72em',
    '--layout-x-large': '80em',
    '--layout-xx-large': '90em',
    '--shadow-default': '0 8px 16px rgb(51 51 51 / 8%)',
    '--shadow-default-x': '0',
    '--shadow-default-y': '8px',
    '--shadow-default-blur-radius': '16px',
    '--shadow-default-color': 'rgb(51 51 51 / 8%)',
    '--shadow-sharp': '0 1px 6px rgb(0 0 0 / 16%)',
    '--shadow-sharp-x': '0',
    '--shadow-sharp-y': '1px',
    '--shadow-sharp-blur-radius': '6px',
    '--shadow-sharp-color': 'rgb(0 0 0 / 16%)',
    '--easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--focus-ring-width': '0.25rem'
};


var $997b884982b21bd3$export$2e2bcd8739ae039 = {
    '--sb-font-family-default': "'Roboto', 'Helvetica', 'Arial', sans-serif",
    '--sb-font-family-heading': "'MaisonNeueHeadings', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    '--sb-font-weight-default': 'normal',
    '--sb-font-weight-basis': 'normal',
    '--sb-font-weight-regular': 'normal',
    '--sb-font-weight-medium': '500',
    '--sb-font-weight-bold': '700',
    '--sb-font-size-x-small': '0.75rem',
    '--sb-font-size-small': '0.875rem',
    '--sb-font-size-basis': '1rem',
    '--sb-font-size-basis--em': '1em',
    '--sb-font-size-lead': 'var(--font-size-medium)',
    '--sb-font-size-medium': '1.25rem',
    '--sb-font-size-medium--plus': '1.625rem',
    '--sb-font-size-large': '2rem',
    '--sb-font-size-x-large': '2.375rem',
    '--sb-font-size-xx-large': '3rem',
    '--sb-line-height-x-small': '1.125rem',
    '--sb-line-height-small': '1.25rem',
    '--sb-line-height-basis': '1.5rem',
    '--sb-line-height-basis--em': '1.5em',
    '--sb-line-height-lead': '1.75rem',
    '--sb-line-height-medium': '2rem',
    '--sb-line-height-large': '2.375rem',
    '--sb-line-height-x-large': '2.75rem',
    '--sb-line-height-xx-large': '3.375rem',
    '--sb-color-black': '#000',
    '--sb-color-text': '#18172a',
    '--sb-color-gray-dark-3': '#3a3a4a',
    '--sb-color-gray-dark-3-neutral': '#3e3e4a',
    '--sb-color-gray-dark-2': '#4a4a5b',
    '--sb-color-gray-dark-2-neutral': '#656472',
    '--sb-color-gray-dark': '#666578',
    '--sb-color-gray-dark-neutral': '#9494a3',
    '--sb-color-gray': '#bbbbce',
    '--sb-color-gray-neutral': '#bdbdc6',
    '--sb-color-gray-light': '#d9d9e4',
    '--sb-color-gray-light-2': '#ebebf2',
    '--sb-color-gray-light-3': '#f9f9fd',
    '--sb-color-purple': '#1c1b4e',
    '--sb-color-purple-alternative': '#222163',
    '--sb-color-green': '#92eecd',
    '--sb-color-white': '#fff',
    '--sb-color-red': '#d8134b',
    '--sb-color-magenta': '#ff3c64',
    '--sb-color-orange': '#ff5b44',
    '--sb-color-yellow-dark': '#f7bf16',
    '--sb-color-yellow': '#ffef57',
    '--sb-color-green-dark-3': '#00785b',
    '--sb-color-green-dark-2': '#1e9f73',
    '--sb-color-violet': '#4e08bc',
    '--sb-color-violet-light': '#7129e2',
    '--sb-color-blue-dark-2': '#044ccc',
    '--sb-color-blue-dark': '#005cff',
    '--sb-color-blue': '#008eff',
    '--sb-color-orange-light': '#ff817b',
    '--sb-color-orange-light-2': '#ffd7d5',
    '--sb-color-orange-light-3': '#fff0ef',
    '--sb-color-magenta-light': '#ffb6d2',
    '--sb-color-magenta-light-2': '#ffdbe9',
    '--sb-color-magenta-light-3': '#fff5f9',
    '--sb-color-yellow-light': '#fff489',
    '--sb-color-yellow-light-2': '#fff9c4',
    '--sb-color-yellow-light-3': '#fffce5',
    '--sb-color-green-dark': '#64d7b4',
    '--sb-color-green-light': '#c8f6e5',
    '--sb-color-green-light-2': '#e5fff7',
    '--sb-color-violet-light-2': '#be99ff',
    '--sb-color-violet-light-3': '#e0d0ff',
    '--sb-color-violet-light-4': '#f1ebff',
    '--sb-color-blue-light': '#61b9ff',
    '--sb-color-blue-light-2': '#bfe3ff',
    '--sb-color-blue-light-3': '#ebf6ff',
    '--sb-spacing-x-small': '0.5rem',
    '--sb-spacing-small': '1rem',
    '--sb-spacing-medium': '1.5rem',
    '--sb-spacing-large': '2rem',
    '--sb-spacing-x-large': '3rem',
    '--sb-spacing-xx-large': '3.5rem',
    '--sb-layout-small': '40em',
    '--sb-layout-medium': '60em',
    '--sb-layout-large': '72em',
    '--sb-shadow-small': '0 2px 4px rgba(38 35 66 / 12%)',
    '--sb-shadow-medium': '0 5px 20px rgba(38 35 66 / 10%)',
    '--sb-shadow-large': '0 5px 20px rgba(38 35 66 / 20%)',
    '--sb-shadow-hover': '0 20px 40px rgba(38 35 66 / 20%)',
    '--sb-easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--prose-max-width': '60ch',
    '--color-emerald-green-50': '#89aaac',
    '--color-emerald-green-25': '#c4d4d6',
    '--color-emerald-green-10': '#e8eeef',
    '--ca-font-family-heading': "'ArizonaFlare', var(--font-family-default)",
    '--ca-color-ocean-green': '#00343e',
    '--ca-color-burgundy-red': '#5c0022',
    '--ca-color-noir-green': '#001114',
    '--ca-color-sea-green': '#007272',
    '--ca-color-noir-red': '#24000d',
    '--ca-color-sober-red': '#8e4049',
    '--ca-color-classic-beige': '#f6eae4',
    '--ca-color-pale-green': '#ccf0e7',
    '--ca-color-pale-red': '#ffdedb',
    '--font-family-default': 'var(--sb-font-family-default)',
    '--font-family-heading': 'var(--sb-font-family-heading)',
    '--font-family-monospace': "'DNBMono', 'Menlo', 'Consolas', 'Roboto Mono', 'Ubuntu Monospace', 'Noto Mono', 'Oxygen Mono', 'Liberation Mono', monospace",
    '--font-weight-default': 'normal',
    '--font-weight-basis': 'normal',
    '--font-weight-regular': 'normal',
    '--font-weight-medium': 'var(--sb-font-weight-medium)',
    '--font-weight-bold': 'var(--sb-font-weight-bold)',
    '--font-size-x-small': '0.875rem',
    '--font-size-small': '1rem',
    '--font-size-basis': '1.125rem',
    '--font-size-basis--em': '1em',
    '--font-size-lead': 'var(--font-size-medium)',
    '--font-size-medium': '1.25rem',
    '--font-size-large': '1.625rem',
    '--font-size-x-large': '2.125rem',
    '--font-size-xx-large': '3rem',
    '--line-height-xx-small--em': '1em',
    '--line-height-x-small': '1.25rem',
    '--line-height-small': '1.25rem',
    '--line-height-basis': '1.5rem',
    '--line-height-basis--em': '1.333em',
    '--line-height-lead': 'var(--line-height-medium)',
    '--line-height-medium': '1.5rem',
    '--line-height-large': '2rem',
    '--line-height-x-large': '2.5rem',
    '--line-height-xx-large': '3.5rem',
    '--color-mint-green-50': '#d2f0e9',
    '--color-mint-green-25': '#e9f8f4',
    '--color-mint-green-12': '#f4fbf9',
    '--color-sea-green-30': '#b3d5d5',
    '--color-accent-yellow-30': '#feebc1',
    '--color-signal-orange': '#ff5400',
    '--color-fire-red': '#dc2a2a',
    '--color-success-green': '#007b5e',
    '--color-fire-red-8': '#fdeeee',
    '--color-black': '#000',
    '--color-black-80': '#333',
    '--color-black-55': '#737373',
    '--color-black-20': '#ccc',
    '--color-black-8': '#ebebeb',
    '--color-black-3': '#f8f8f8',
    '--color-white': '#fff',
    '--color-sea-green': '#007272',
    '--color-mint-green': '#a5e1d2',
    '--color-summer-green': '#28b482',
    '--color-emerald-green': '#14555a',
    '--color-ocean-green': '#00343e',
    '--color-accent-yellow': '#fdbb31',
    '--color-indigo': '#23195a',
    '--color-violet': '#6e2382',
    '--color-sky-blue': '#4bbed2',
    '--color-lavender': '#f2f2f5',
    '--color-sand-yellow': '#fbf6ec',
    '--color-pistachio': '#f2f4ec',
    '--spacing-xx-small': '0.25rem',
    '--spacing-x-small': '0.5rem',
    '--spacing-small': '1rem',
    '--spacing-medium': '1.5rem',
    '--spacing-large': '2rem',
    '--spacing-x-large': '3rem',
    '--spacing-xx-large': '3.5rem',
    '--layout-small': '40em',
    '--layout-medium': '60em',
    '--layout-large': '72em',
    '--layout-x-large': '80em',
    '--layout-xx-large': '90em',
    '--shadow-default': '0 8px 16px rgb(51 51 51 / 8%)',
    '--shadow-default-x': '0',
    '--shadow-default-y': '8px',
    '--shadow-default-blur-radius': '16px',
    '--shadow-default-color': 'rgb(51 51 51 / 8%)',
    '--shadow-sharp': '0 1px 6px rgb(0 0 0 / 16%)',
    '--shadow-sharp-x': '0',
    '--shadow-sharp-y': '1px',
    '--shadow-sharp-blur-radius': '6px',
    '--shadow-sharp-color': 'rgb(0 0 0 / 16%)',
    '--easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--focus-ring-width': '0.25rem'
};



"use client";
const $2fad1ad7e24667d0$var$properties = {
    ui: $27f864b62ee5eaea$export$2e2bcd8739ae039,
    sbanken: $997b884982b21bd3$export$2e2bcd8739ae039
};
const $2fad1ad7e24667d0$var$formStatusDefaultProps = {
    show: true,
    icon: 'error',
    iconSize: 'medium',
    size: 'default',
    state: 'error'
};
function $2fad1ad7e24667d0$var$getContent(props) {
    if (props.text) {
        if (props.text === true) return null;
        return props.text;
    }
    return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
}
function $2fad1ad7e24667d0$var$correctStatus(state) {
    return state;
}
function $2fad1ad7e24667d0$var$getIcon({ state: state, icon: icon, iconSize: iconSize }) {
    if (typeof icon !== 'string') return icon;
    switch($2fad1ad7e24667d0$var$correctStatus(state)){
        case 'information':
        case 'success':
            return (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: (0, $60739c7e3f826d8d$exports.jsx)($2fad1ad7e24667d0$export$2957fc44b3d2481, {
                    title: null,
                    state: state
                }),
                size: iconSize,
                inheritColor: false
            });
        case 'warning':
            return (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: (0, $60739c7e3f826d8d$exports.jsx)($2fad1ad7e24667d0$export$4b8ba45ae34f741a, {
                    title: null,
                    state: state
                }),
                size: iconSize,
                inheritColor: false
            });
        case 'marketing':
            return (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: (0, $60739c7e3f826d8d$exports.jsx)($2fad1ad7e24667d0$export$ddb421af37c7fad5, {
                    title: null,
                    state: state
                }),
                size: iconSize,
                inheritColor: false
            });
        case 'error':
        default:
            return (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: (0, $60739c7e3f826d8d$exports.jsx)($2fad1ad7e24667d0$export$19bc16ee58e19b3d, {
                    title: null,
                    state: state
                }),
                size: iconSize,
                inheritColor: false
            });
    }
}
function $2fad1ad7e24667d0$var$FormStatusComponent(ownProps) {
    const { ref: ref, ...restOwnProps } = ownProps;
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)({
        ...$2fad1ad7e24667d0$var$formStatusDefaultProps,
        ...(0, $11741836d1790446$export$130f9de4db4d93ea)({
            ...restOwnProps
        })
    }, $2fad1ad7e24667d0$var$formStatusDefaultProps, {
        skeleton: context?.skeleton
    }, (0, $c81beeaa1b3509d1$export$8efbf5589742246)(context?.formElement), context?.FormStatus);
    const { id: idProp, text: text, globalStatus: globalStatus, label: label, show: show, noAnimation: noAnimation, state: rawStateProp, widthElement: widthElement, widthSelector: widthSelector, ...restOfProps } = props;
    const id = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(idProp);
    const statusId = `${id}-gs`;
    const elementRef = (0, $ieaan.useRef)(null);
    const isMountedRef = (0, $ieaan.useRef)(false);
    const contentCacheRef = (0, $ieaan.useRef)(null);
    const stateCacheRef = (0, $ieaan.useRef)(undefined);
    const ownPropsRef = (0, $ieaan.useRef)(restOwnProps);
    ownPropsRef.current = restOwnProps;
    (0, $ieaan.useEffect)(()=>{
        if (typeof ref === 'function') ref(elementRef.current);
        else if (ref) ref.current = elementRef.current;
    });
    const shouldAnimate = noAnimation === false;
    const fillCache = (0, $ieaan.useCallback)(()=>{
        const content = shouldAnimate && $2fad1ad7e24667d0$var$getContent(ownPropsRef.current);
        if (content && content !== contentCacheRef.current) contentCacheRef.current = content;
        const stateVal = shouldAnimate && $2fad1ad7e24667d0$var$correctStatus(rawStateProp);
        if (stateVal) stateCacheRef.current = stateVal;
    }, [
        shouldAnimate,
        rawStateProp
    ]);
    const isReadyToGetVisible = (0, $ieaan.useCallback)((p = props)=>{
        return p.show && $2fad1ad7e24667d0$var$getContent(p) ? true : false;
    }, [
        props.show,
        props.text,
        props.children
    ]);
    const updateWidth = (0, $ieaan.useCallback)(()=>{
        if (elementRef.current) {
            var _widthElement$current;
            $2fad1ad7e24667d0$export$5cee5f2e6530e9ba({
                element: elementRef.current,
                widthElement: (_widthElement$current = widthElement?.current) !== null && _widthElement$current !== void 0 ? _widthElement$current : null,
                widthSelector: widthSelector
            });
        }
    }, [
        widthElement,
        widthSelector
    ]);
    const propsRef = (0, $ieaan.useRef)(props);
    propsRef.current = props;
    const isReadyToGetVisibleRef = (0, $ieaan.useRef)(isReadyToGetVisible);
    isReadyToGetVisibleRef.current = isReadyToGetVisible;
    const globalStatusRef = (0, $ieaan.useRef)(null);
    (0, $9738f50fda5b2f16$export$2e2bcd8739ae039)(()=>{
        globalStatusRef.current = (0, $fe477a1647186b55$export$2e2bcd8739ae039).init(globalStatus?.id || context?.FormStatus?.globalStatus?.id || context?.formElement?.globalStatus?.id || 'main', (provider)=>{
            const currentProps = propsRef.current;
            if (currentProps.state === 'error' && isReadyToGetVisibleRef.current()) provider.add({
                state: currentProps.state,
                statusId: statusId,
                item: {
                    itemId: id,
                    text: currentProps.globalStatus?.message || currentProps.text || currentProps.children,
                    statusAnchorLabel: currentProps.label,
                    statusAnchorUrl: true
                },
                ...currentProps.globalStatus
            });
        });
        return ()=>{
            globalStatusRef.current?.remove(statusId);
        };
    });
    (0, $9738f50fda5b2f16$export$2e2bcd8739ae039)(()=>{
        isMountedRef.current = true;
        const init = ()=>{
            if (isMountedRef.current) {
                globalStatusRef.current?.isReady();
                updateWidth();
                fillCache();
            }
        };
        if (document.readyState === 'complete') init();
        else if (typeof window !== 'undefined') window.addEventListener('load', init);
        if (typeof window !== 'undefined') window.addEventListener('resize', updateWidth);
        return ()=>{
            isMountedRef.current = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('load', init);
                window.removeEventListener('resize', updateWidth);
            }
        };
    });
    const prevPropsRef = (0, $ieaan.useRef)(restOwnProps);
    (0, $486a01c56256a5f9$export$2e2bcd8739ae039)(()=>{
        const prevProps = prevPropsRef.current;
        prevPropsRef.current = restOwnProps;
        const state = props.state;
        const { children: children } = props;
        if (prevProps.text !== text || prevProps.children !== children || prevProps.show !== show || prevProps.globalStatus?.show !== globalStatus?.show || prevProps.state !== state) {
            fillCache();
            if (state === 'error') {
                const content = $2fad1ad7e24667d0$var$getContent(restOwnProps);
                if (!content) globalStatusRef.current?.remove(statusId);
                else if (show) globalStatusRef.current?.update(statusId, {
                    state: state,
                    statusId: statusId,
                    item: {
                        itemId: id,
                        text: globalStatus?.message || text || children,
                        statusAnchorLabel: label,
                        statusAnchorUrl: true
                    },
                    ...globalStatus
                }, {
                    preventRestack: true
                });
            }
            if (isReadyToGetVisible()) updateWidth();
        }
    });
    const state = $2fad1ad7e24667d0$var$correctStatus(rawStateProp) || stateCacheRef.current;
    const iconToRender = $2fad1ad7e24667d0$var$getIcon({
        state: state,
        icon: restOfProps.icon,
        iconSize: restOfProps.iconSize
    });
    const contentToRender = $2fad1ad7e24667d0$var$getContent(restOwnProps);
    const hasStringContent = typeof contentToRender === 'string' && contentToRender.length > 0;
    const { title: title, size: size, variant: variant, className: className, stretch: stretch, shellSpace: shellSpace, textId: textId, skeleton: skeleton, role: role, icon: _icon, iconSize: _iconSize, ...rest } = restOfProps;
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(props, {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-form-status', state && `dnb-form-status--${state}`, `dnb-form-status__size--${size}`, variant && `dnb-form-status__variant--${variant}`, stretch && 'dnb-form-status--stretch', hasStringContent ? 'dnb-form-status--has-content' : null, className),
        id: !String(idProp).startsWith('null') ? id : null,
        title: title,
        role: role,
        ...rest
    });
    if (!role) switch(state){
        case 'information':
            params.role = 'status';
            break;
        default:
            params.role = 'alert';
    }
    const textParams = {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-form-status__text', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)('font', skeleton, context)),
        id: !String(textId).startsWith('null') ? textId : null
    };
    const shellParams = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        space: shellSpace
    }, {
        className: 'dnb-form-status__shell'
    });
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton, context);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(restOwnProps, params);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(null, textParams);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $c329544388f437e5$export$2e2bcd8739ae039), {
        element: "span",
        open: isReadyToGetVisible(),
        animate: shouldAnimate,
        duration: 600,
        ...params,
        ref: elementRef,
        children: (0, $60739c7e3f826d8d$exports.jsxs)("span", {
            ...shellParams,
            children: [
                iconToRender,
                (0, $60739c7e3f826d8d$exports.jsx)("span", {
                    ...textParams,
                    children: contentToRender || contentCacheRef.current
                })
            ]
        })
    });
}
$2fad1ad7e24667d0$var$FormStatusComponent.displayName = 'FormStatus';
const $2fad1ad7e24667d0$var$FormStatus = (0, $ieaan.memo)($2fad1ad7e24667d0$var$FormStatusComponent);
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($2fad1ad7e24667d0$var$FormStatus, {
    _supportsSpacingProps: true
});
var $2fad1ad7e24667d0$export$2e2bcd8739ae039 = $2fad1ad7e24667d0$var$FormStatus;
const $2fad1ad7e24667d0$export$19bc16ee58e19b3d = (props)=>{
    const { title: title = 'error' } = props || {};
    const isSbankenTheme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()?.name === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-magenta'] : $2fad1ad7e24667d0$var$properties.ui['--color-fire-red'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-magenta-light-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-white'];
    return (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)("title", {
                children: title
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M23.625 17.864A3.547 3.547 0 0120.45 23H3.548a3.546 3.546 0 01-3.172-5.136l8.45-14.902a3.548 3.548 0 016.347 0l8.452 14.902z",
                fill: fill
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M12 16.286a1.286 1.286 0 100 2.572 1.286 1.286 0 000-2.572z",
                fill: line
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M12 13.818v-5",
                stroke: line,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const $2fad1ad7e24667d0$export$4b8ba45ae34f741a = (props)=>{
    const { title: title = 'error' } = props || {};
    const isSbankenTheme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()?.name === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-yellow-dark'] : $2fad1ad7e24667d0$var$properties.ui['--color-accent-yellow'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-black'] : $2fad1ad7e24667d0$var$properties.ui['--color-black-80'];
    return (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)("title", {
                children: title
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M23.625 17.864A3.547 3.547 0 0120.45 23H3.548a3.546 3.546 0 01-3.172-5.136l8.45-14.902a3.548 3.548 0 016.347 0l8.452 14.902z",
                fill: fill
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M12 16.286a1.286 1.286 0 100 2.572 1.286 1.286 0 000-2.572z",
                fill: line
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M12 13.818v-5",
                stroke: line,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const $2fad1ad7e24667d0$export$2957fc44b3d2481 = (props)=>{
    const { title: title = 'information' } = props || {};
    const isSbankenTheme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()?.name === 'sbanken';
    let fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-dark-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-sea-green'];
    if (props && props?.state === 'success') fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-dark-3'] : $2fad1ad7e24667d0$var$properties.ui['--color-summer-green'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-light-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-white'];
    return (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)("title", {
                children: title
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.268 0a11.25 11.25 0 105.566 21.017l6.112 2.91a.75.75 0 001-1l-2.911-6.112A11.234 11.234 0 0011.268 0z",
                fill: fill
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("circle", {
                cx: "11",
                cy: "6.5",
                r: ".5",
                fill: "#fff",
                stroke: line
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M13.75 16H13a1.5 1.5 0 01-1.5-1.5v-3.75a.75.75 0 00-.75-.75H10",
                stroke: line,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const $2fad1ad7e24667d0$export$ddb421af37c7fad5 = (props)=>{
    const { title: title = 'marketing' } = props || {};
    const isSbankenTheme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()?.name === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-violet-light'] : $2fad1ad7e24667d0$var$properties.ui['--color-black-80'];
    return (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)("title", {
                children: title
            }),
            (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M6 15.25H4.5c-2.042 0-3.75-1.707-3.75-3.75S2.458 7.75 4.5 7.75H6v7.5ZM7.5 15.25c4.801 0 8.846 1.897 12.75 4.5V3.25c-3.904 2.603-7.949 4.5-12.75 4.5v7.5ZM23.25 10a.75.75 0 0 0-1.5 0h1.5Zm-1.5 3a.75.75 0 0 0 1.5 0h-1.5ZM8.483 21.043a.75.75 0 1 0 1.034-1.086l-1.034 1.086ZM21.75 10v3h1.5v-3h-1.5ZM6 15.25a8.058 8.058 0 0 0 2.483 5.793l1.034-1.086A6.559 6.559 0 0 1 7.5 15.25H6Z",
                fill: fill
            })
        ]
    });
};
function $2fad1ad7e24667d0$export$5cee5f2e6530e9ba({ element: element, id: id = null, widthElement: widthElement = null, widthSelector: widthSelector = null }) {
    if (!(element && typeof window !== 'undefined')) return;
    try {
        if (!id && !widthSelector) id = element.getAttribute('id');
        widthSelector = widthSelector || id?.replace('-form-status', '') || id;
        let width = $2fad1ad7e24667d0$var$sumElementWidth({
            widthElement: widthElement,
            widthSelector: widthSelector
        });
        if (width > 40) {
            const maxWidth = 480;
            if (width < maxWidth) width = maxWidth;
            const remWidth = `${width / 16}rem`;
            const style = window.getComputedStyle(element);
            const hasCustomWidth = element.style.maxWidth ? false : style.minWidth !== '' && style.minWidth !== 'auto' || style.maxWidth !== '' && style.maxWidth !== 'none';
            if (!hasCustomWidth) element.style.maxWidth = remWidth;
        }
    } catch (e) {}
}
function $2fad1ad7e24667d0$var$sumElementWidth({ widthElement: widthElement, widthSelector: widthSelector }) {
    let width = 0;
    if (typeof document === 'undefined') return width;
    try {
        const ids = widthElement ? [
            widthElement
        ] : widthSelector.split(/, |,/g);
        width = ids.reduce((acc, cur)=>{
            const elem = typeof cur === 'string' ? cur[0] === '.' ? document.querySelector(cur) : document.getElementById(cur) : cur;
            let elemWidth = elem && elem.offsetWidth || parseFloat(String(window.getComputedStyle(elem).width)) || 0;
            if (/em|rem/.test(String(window.getComputedStyle(elem).width))) elemWidth = parseFloat(String(window.getComputedStyle(elem).width)) * 16;
            if (elemWidth > 0) {
                if (acc > 0) acc += 16;
                acc += elemWidth;
            }
            return acc;
        }, width);
    } catch (e) {}
    return width;
}




var $ieaan = parcelRequire("ieaan");


var $ieaan = parcelRequire("ieaan");






"use client";
const $3d090471d65e4fa1$export$9c21a3269931e1e6 = {
    skeletonMethod: 'font'
};
function $3d090471d65e4fa1$var$Element(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $3d090471d65e4fa1$export$9c21a3269931e1e6, {
        skeleton: context?.skeleton
    });
    const { className: className, internalClass: internalClass, as: as, ref: ref, skeleton: skeleton, skeletonMethod: skeletonMethod, ...rest } = props;
    const Tag = as;
    const attributes = rest;
    const tagClass = internalClass === false ? '' : (internalClass === true ? undefined : internalClass) || (typeof Tag === 'string' ? `dnb-${Tag}` : '');
    const internalClassName = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(!new RegExp(`${tagClass}(\\s|$)`).test(String(className)) && tagClass, className, (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(skeletonMethod, skeleton, context));
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(attributes, {
        ...attributes,
        className: internalClassName
    }, typeof Tag === 'string' ? `dnb-${Tag}` : null);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(null, params);
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton, context);
    const isFragment = Tag === (0, $ieaan.Fragment);
    if (!isFragment && ref) params.ref = ref;
    if (isFragment) return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: params.children
    });
    return (0, $60739c7e3f826d8d$exports.jsx)(Tag, {
        ...params
    });
}
var $3d090471d65e4fa1$export$2e2bcd8739ae039 = $3d090471d65e4fa1$var$Element;







var $ieaan = parcelRequire("ieaan");








var $1b716dc1cd8c4f3d$exports = {};

$parcel$export($1b716dc1cd8c4f3d$exports, "add", function () { return $9a54021c8c6f6897$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_down", function () { return $5aee06c6fc066da5$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_left", function () { return $8babd7d7600991e7$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_right", function () { return $079e46673ec03c5e$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_up", function () { return $ae30ddfe9ad8c794$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "bell", function () { return $b8b6cde80f792eaf$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "calendar", function () { return $e0e3e6756100882c$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "check", function () { return $e1eb14feba73fda7$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_down", function () { return $b92167770415d548$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_left", function () { return $caf45c133b27358d$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_right", function () { return $13d0d04576b49b35$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_up", function () { return $920948a19cb7e62b$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "close", function () { return $65cc4599df394246$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "download", function () { return $de01eaf7c361be3d$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "exclamation", function () { return $a6c3aec677391eef$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "information", function () { return $a8e4075cfe4eba94$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "loupe", function () { return $b8531b951e273ce2$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "more", function () { return $5a6006ddc7c84806$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "question", function () { return $24c044af95424c5c$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "reset", function () { return $ccec2cab17a546b6$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "save", function () { return $24ff9e3b07a8f88f$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "subtract", function () { return $d40f7ac5f17f0080$export$2e2bcd8739ae039; });

var $9a54021c8c6f6897$var$_path;
const $9a54021c8c6f6897$var$add = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $9a54021c8c6f6897$var$_path || ($9a54021c8c6f6897$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M8 14V2m6 6H2"
        }))
    });
var $9a54021c8c6f6897$export$2e2bcd8739ae039 = $9a54021c8c6f6897$var$add;



var $5aee06c6fc066da5$var$_path;
const $5aee06c6fc066da5$var$arrow_down = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $5aee06c6fc066da5$var$_path || ($5aee06c6fc066da5$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m13 9.75-5 5-5-5m5 5V1.25"
        }))
    });
var $5aee06c6fc066da5$export$2e2bcd8739ae039 = $5aee06c6fc066da5$var$arrow_down;



var $8babd7d7600991e7$var$_path;
const $8babd7d7600991e7$var$arrow_left = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $8babd7d7600991e7$var$_path || ($8babd7d7600991e7$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M14.5 8H1m5 5L1 8l5-5"
        }))
    });
var $8babd7d7600991e7$export$2e2bcd8739ae039 = $8babd7d7600991e7$var$arrow_left;



var $079e46673ec03c5e$var$_path;
const $079e46673ec03c5e$var$arrow_right = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $079e46673ec03c5e$var$_path || ($079e46673ec03c5e$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M1.5 8H15m-5-5 5 5-5 5"
        }))
    });
var $079e46673ec03c5e$export$2e2bcd8739ae039 = $079e46673ec03c5e$var$arrow_right;



var $ae30ddfe9ad8c794$var$_path;
const $ae30ddfe9ad8c794$var$arrow_up = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $ae30ddfe9ad8c794$var$_path || ($ae30ddfe9ad8c794$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m13 6.25-5-5-5 5m5-5v13.5"
        }))
    });
var $ae30ddfe9ad8c794$export$2e2bcd8739ae039 = $ae30ddfe9ad8c794$var$arrow_up;



var $b8b6cde80f792eaf$var$_path;
const $b8b6cde80f792eaf$var$bell = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $b8b6cde80f792eaf$var$_path || ($b8b6cde80f792eaf$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M6.756 14.067a1.299 1.299 0 0 0 2.492 0M8 2.4a4.667 4.667 0 0 1 4.667 4.667c0 4.384.933 5.133.933 5.133H2.4s.933-1.192.933-5.133A4.667 4.667 0 0 1 8 2.4Zm0 0V1"
        }))
    });
var $b8b6cde80f792eaf$export$2e2bcd8739ae039 = $b8b6cde80f792eaf$var$bell;



var $e0e3e6756100882c$var$_path;
const $e0e3e6756100882c$var$calendar = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $e0e3e6756100882c$var$_path || ($e0e3e6756100882c$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M5.256 1v3.256M10.75 1v3.256M1 7.5V3.628a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1V7.5m-14 0V14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.5m-14 0h14"
        }))
    });
var $e0e3e6756100882c$export$2e2bcd8739ae039 = $e0e3e6756100882c$var$calendar;



var $e1eb14feba73fda7$var$_path;
const $e1eb14feba73fda7$var$check = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $e1eb14feba73fda7$var$_path || ($e1eb14feba73fda7$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m1 10 4 4L15 2"
        }))
    });
var $e1eb14feba73fda7$export$2e2bcd8739ae039 = $e1eb14feba73fda7$var$check;



var $b92167770415d548$var$_path;
const $b92167770415d548$var$chevron_down = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $b92167770415d548$var$_path || ($b92167770415d548$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m13 5.5-5 5-5-5"
        }))
    });
var $b92167770415d548$export$2e2bcd8739ae039 = $b92167770415d548$var$chevron_down;



var $caf45c133b27358d$var$_path;
const $caf45c133b27358d$var$chevron_left = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $caf45c133b27358d$var$_path || ($caf45c133b27358d$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M10 3 5 8l5 5"
        }))
    });
var $caf45c133b27358d$export$2e2bcd8739ae039 = $caf45c133b27358d$var$chevron_left;



var $13d0d04576b49b35$var$_path;
const $13d0d04576b49b35$var$chevron_right = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $13d0d04576b49b35$var$_path || ($13d0d04576b49b35$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m6 13 5-5-5-5"
        }))
    });
var $13d0d04576b49b35$export$2e2bcd8739ae039 = $13d0d04576b49b35$var$chevron_right;



var $920948a19cb7e62b$var$_path;
const $920948a19cb7e62b$var$chevron_up = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $920948a19cb7e62b$var$_path || ($920948a19cb7e62b$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m3 10.5 5-5 5 5"
        }))
    });
var $920948a19cb7e62b$export$2e2bcd8739ae039 = $920948a19cb7e62b$var$chevron_up;



var $65cc4599df394246$var$_path;
const $65cc4599df394246$var$close = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $65cc4599df394246$var$_path || ($65cc4599df394246$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M3 13 13 3m0 10L3 3"
        }))
    });
var $65cc4599df394246$export$2e2bcd8739ae039 = $65cc4599df394246$var$close;



var $de01eaf7c361be3d$var$_path;
const $de01eaf7c361be3d$var$download = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $de01eaf7c361be3d$var$_path || ($de01eaf7c361be3d$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M10.656 8.281 8 10.937 5.344 8.281M8 10.937V2.5M3 14h10"
        }))
    });
var $de01eaf7c361be3d$export$2e2bcd8739ae039 = $de01eaf7c361be3d$var$download;



var $a6c3aec677391eef$var$_path;
const $a6c3aec677391eef$var$exclamation = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $a6c3aec677391eef$var$_path || ($a6c3aec677391eef$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M8 10.412V2m-.177 11.519h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
        }))
    });
var $a6c3aec677391eef$export$2e2bcd8739ae039 = $a6c3aec677391eef$var$exclamation;



var $a8e4075cfe4eba94$var$_path;
const $a8e4075cfe4eba94$var$information = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $a8e4075cfe4eba94$var$_path || ($a8e4075cfe4eba94$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M9.914 13.5h-.75a1.5 1.5 0 0 1-1.498-1.499V6.914a.75.75 0 0 0-.75-.75h-.75m.825-3.487h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
        }))
    });
var $a8e4075cfe4eba94$export$2e2bcd8739ae039 = $a8e4075cfe4eba94$var$information;



var $b8531b951e273ce2$var$_path;
const $b8531b951e273ce2$var$loupe = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $b8531b951e273ce2$var$_path || ($b8531b951e273ce2$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M11.5 11.5 15 15m-3.182-8.59A5.41 5.41 0 1 1 1 6.41a5.41 5.41 0 0 1 10.818 0Z"
        }))
    });
var $b8531b951e273ce2$export$2e2bcd8739ae039 = $b8531b951e273ce2$var$loupe;



var $5a6006ddc7c84806$var$_path;
const $5a6006ddc7c84806$var$more = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $5a6006ddc7c84806$var$_path || ($5a6006ddc7c84806$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            fill: "#000",
            d: "M4.5 8A1.25 1.25 0 1 1 2 8a1.25 1.25 0 0 1 2.5 0ZM8 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
        }))
    });
var $5a6006ddc7c84806$export$2e2bcd8739ae039 = $5a6006ddc7c84806$var$more;



var $24c044af95424c5c$var$_path;
const $24c044af95424c5c$var$question = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $24c044af95424c5c$var$_path || ($24c044af95424c5c$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M5.392 4.876c0-1.642 1.452-2.98 3.074-2.868 1.638.113 2.874 1.653 2.65 3.264a2.923 2.923 0 0 1-1.89 2.316c-1.216.43-.958 1.9-.958 2.913m-.177 3.004h.346m.079 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
        }))
    });
var $24c044af95424c5c$export$2e2bcd8739ae039 = $24c044af95424c5c$var$question;



var $ccec2cab17a546b6$var$_path;
const $ccec2cab17a546b6$var$reset = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $ccec2cab17a546b6$var$_path || ($ccec2cab17a546b6$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            fill: "#000",
            d: "m5.333 14.474.634-.401-.128-.202-.22-.09-.286.693Zm1.084-3.807a.75.75 0 0 0-1.5 0h1.5ZM5.667 15v.75a.75.75 0 0 0 .75-.75h-.75Zm-4.334-.75a.75.75 0 0 0 0 1.5v-1.5Zm8.007-.144a.75.75 0 1 0 .32 1.466l-.32-1.466ZM1.75 8A6.25 6.25 0 0 1 8 1.75V.25A7.75 7.75 0 0 0 .25 8h1.5ZM8 1.75A6.25 6.25 0 0 1 14.25 8h1.5A7.75 7.75 0 0 0 8 .25v1.5ZM5.62 13.78A6.252 6.252 0 0 1 1.75 8H.25a7.752 7.752 0 0 0 4.797 7.168l.572-1.387Zm-.703-3.113V15h1.5v-4.333h-1.5Zm.75 3.583H1.333v1.5h4.334v-1.5Zm-.967.626.333.526 1.267-.803-.333-.526-1.267.803ZM14.25 8a6.253 6.253 0 0 1-4.91 6.106l.32 1.466A7.753 7.753 0 0 0 15.75 8h-1.5Z"
        }))
    });
var $ccec2cab17a546b6$export$2e2bcd8739ae039 = $ccec2cab17a546b6$var$reset;



var $24ff9e3b07a8f88f$var$_path;
const $24ff9e3b07a8f88f$var$save = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $24ff9e3b07a8f88f$var$_path || ($24ff9e3b07a8f88f$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M9.867 5.2 8 7.067 6.133 5.2M8 7.067V1m.5 11.5H4m8.044 0h-.622M1.933 15h12.134a.933.933 0 0 0 .933-.933v-3.734a.933.933 0 0 0-.933-.933H1.933a.933.933 0 0 0-.933.933v3.734c0 .515.418.933.933.933Z"
        }))
    });
var $24ff9e3b07a8f88f$export$2e2bcd8739ae039 = $24ff9e3b07a8f88f$var$save;



var $d40f7ac5f17f0080$var$_path;
const $d40f7ac5f17f0080$var$subtract = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $d40f7ac5f17f0080$var$_path || ($d40f7ac5f17f0080$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M14 8H2"
        }))
    });
var $d40f7ac5f17f0080$export$2e2bcd8739ae039 = $d40f7ac5f17f0080$var$subtract;




var $bacfbed3ffaac4a1$exports = {};

$parcel$export($bacfbed3ffaac4a1$exports, "add_medium", function () { return $6c7aad60512f1bd2$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_down_medium", function () { return $1722948fe2ec1072$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_left_medium", function () { return $c8884ce0dd63d21c$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_right_medium", function () { return $c4a7a100eb7a35e3$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_up_medium", function () { return $8326f19009e9b9ac$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "bell_medium", function () { return $2bc7da0c258affa2$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "calendar_medium", function () { return $dfc76dabefdc1b23$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "check_medium", function () { return $90e0e6911f5d437e$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_down_medium", function () { return $cd251e77d96cb4cc$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_left_medium", function () { return $b67ce929b86d1adc$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_right_medium", function () { return $a25fbe10272cbc4c$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_up_medium", function () { return $64105c8f87464477$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "close_medium", function () { return $cd24f0389f82a2ee$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "download_medium", function () { return $580bbde317508449$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "exclamation_medium", function () { return $c6167291c77af966$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "information_medium", function () { return $e23a478b825be356$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "loupe_medium", function () { return $4f9316fa6caedf83$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "more_medium", function () { return $7b3a2c9055c45800$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "question_medium", function () { return $d146b05d533b9a8b$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "reset_medium", function () { return $b63a1b80751f3d37$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "save_medium", function () { return $94d44e796cd0d521$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "subtract_medium", function () { return $156563afed3b2b82$export$2e2bcd8739ae039; });

var $6c7aad60512f1bd2$var$_path;
const $6c7aad60512f1bd2$var$add_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $6c7aad60512f1bd2$var$_path || ($6c7aad60512f1bd2$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M12 21V3m9 9H3"
        }))
    });
var $6c7aad60512f1bd2$export$2e2bcd8739ae039 = $6c7aad60512f1bd2$var$add_medium;



var $1722948fe2ec1072$var$_path;
const $1722948fe2ec1072$var$arrow_down_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $1722948fe2ec1072$var$_path || ($1722948fe2ec1072$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m19.5 14.625-7.5 7.5-7.5-7.5m7.5 7.5V1.875"
        }))
    });
var $1722948fe2ec1072$export$2e2bcd8739ae039 = $1722948fe2ec1072$var$arrow_down_medium;



var $c8884ce0dd63d21c$var$_path;
const $c8884ce0dd63d21c$var$arrow_left_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $c8884ce0dd63d21c$var$_path || ($c8884ce0dd63d21c$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M22.25 11.5H2M9.5 19 2 11.5 9.5 4"
        }))
    });
var $c8884ce0dd63d21c$export$2e2bcd8739ae039 = $c8884ce0dd63d21c$var$arrow_left_medium;



var $c4a7a100eb7a35e3$var$_path;
const $c4a7a100eb7a35e3$var$arrow_right_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $c4a7a100eb7a35e3$var$_path || ($c4a7a100eb7a35e3$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M2.25 12H22.5M15 4.5l7.5 7.5-7.5 7.5"
        }))
    });
var $c4a7a100eb7a35e3$export$2e2bcd8739ae039 = $c4a7a100eb7a35e3$var$arrow_right_medium;



var $8326f19009e9b9ac$var$_path;
const $8326f19009e9b9ac$var$arrow_up_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $8326f19009e9b9ac$var$_path || ($8326f19009e9b9ac$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m19.5 9.375-7.5-7.5-7.5 7.5m7.5-7.5v20.25"
        }))
    });
var $8326f19009e9b9ac$export$2e2bcd8739ae039 = $8326f19009e9b9ac$var$arrow_up_medium;



var $2bc7da0c258affa2$var$_path;
const $2bc7da0c258affa2$var$bell_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $2bc7da0c258affa2$var$_path || ($2bc7da0c258affa2$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M10 21.75a2.087 2.087 0 0 0 4.005 0M12 3a7.5 7.5 0 0 1 7.5 7.5c0 7.046 1.5 8.25 1.5 8.25H3s1.5-1.916 1.5-8.25A7.5 7.5 0 0 1 12 3Zm0 0V.75"
        }))
    });
var $2bc7da0c258affa2$export$2e2bcd8739ae039 = $2bc7da0c258affa2$var$bell_medium;



var $dfc76dabefdc1b23$var$_path;
const $dfc76dabefdc1b23$var$calendar_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $dfc76dabefdc1b23$var$_path || ($dfc76dabefdc1b23$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M6.5 1v5m11-5v5m-16 3.5v-5a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v5m-21 0v12a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-12m-21 0h21"
        }))
    });
var $dfc76dabefdc1b23$export$2e2bcd8739ae039 = $dfc76dabefdc1b23$var$calendar_medium;



var $90e0e6911f5d437e$var$_path;
const $90e0e6911f5d437e$var$check_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $90e0e6911f5d437e$var$_path || ($90e0e6911f5d437e$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m1.5 15 6 6 15-18"
        }))
    });
var $90e0e6911f5d437e$export$2e2bcd8739ae039 = $90e0e6911f5d437e$var$check_medium;



var $cd251e77d96cb4cc$var$_path;
const $cd251e77d96cb4cc$var$chevron_down_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $cd251e77d96cb4cc$var$_path || ($cd251e77d96cb4cc$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m19 8.5-7 7-7-7"
        }))
    });
var $cd251e77d96cb4cc$export$2e2bcd8739ae039 = $cd251e77d96cb4cc$var$chevron_down_medium;



var $b67ce929b86d1adc$var$_path;
const $b67ce929b86d1adc$var$chevron_left_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $b67ce929b86d1adc$var$_path || ($b67ce929b86d1adc$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m15 5-7 7 7 7"
        }))
    });
var $b67ce929b86d1adc$export$2e2bcd8739ae039 = $b67ce929b86d1adc$var$chevron_left_medium;



var $a25fbe10272cbc4c$var$_path;
const $a25fbe10272cbc4c$var$chevron_right_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $a25fbe10272cbc4c$var$_path || ($a25fbe10272cbc4c$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m9 19 7-7-7-7"
        }))
    });
var $a25fbe10272cbc4c$export$2e2bcd8739ae039 = $a25fbe10272cbc4c$var$chevron_right_medium;



var $64105c8f87464477$var$_path;
const $64105c8f87464477$var$chevron_up_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $64105c8f87464477$var$_path || ($64105c8f87464477$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m5 15.5 7-7 7 7"
        }))
    });
var $64105c8f87464477$export$2e2bcd8739ae039 = $64105c8f87464477$var$chevron_up_medium;



var $cd24f0389f82a2ee$var$_path;
const $cd24f0389f82a2ee$var$close_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $cd24f0389f82a2ee$var$_path || ($cd24f0389f82a2ee$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M5 19 19 5m0 14L5 5"
        }))
    });
var $cd24f0389f82a2ee$export$2e2bcd8739ae039 = $cd24f0389f82a2ee$var$close_medium;



var $580bbde317508449$var$_path;
const $580bbde317508449$var$download_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $580bbde317508449$var$_path || ($580bbde317508449$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M16.25 12.25 12 16.5l-4.25-4.25M12 16.5V3M4 21.25h16"
        }))
    });
var $580bbde317508449$export$2e2bcd8739ae039 = $580bbde317508449$var$download_medium;



var $c6167291c77af966$var$_path;
const $c6167291c77af966$var$exclamation_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $c6167291c77af966$var$_path || ($c6167291c77af966$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M11.997 15.118V3.25m-.646 16.765h1.31m.089 0c0 .438-.31.747-.753.747a.718.718 0 0 1-.747-.747c0-.442.31-.753.747-.753.443 0 .753.31.753.753Z"
        }))
    });
var $c6167291c77af966$export$2e2bcd8739ae039 = $c6167291c77af966$var$exclamation_medium;



var $e23a478b825be356$var$_path;
const $e23a478b825be356$var$information_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $e23a478b825be356$var$_path || ($e23a478b825be356$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M14.872 20.74h-1.125a2.249 2.249 0 0 1-2.248-2.248V10.87c0-.62-.504-1.124-1.125-1.124H9.25m.85-5.244h1.31m.09 0c0 .437-.31.747-.754.747A.718.718 0 0 1 10 4.502c0-.443.31-.753.747-.753.443 0 .753.31.753.753Z"
        }))
    });
var $e23a478b825be356$export$2e2bcd8739ae039 = $e23a478b825be356$var$information_medium;



var $4f9316fa6caedf83$var$_path;
const $4f9316fa6caedf83$var$loupe_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $4f9316fa6caedf83$var$_path || ($4f9316fa6caedf83$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M17.5 17.5 23 23M18 9.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z"
        }))
    });
var $4f9316fa6caedf83$export$2e2bcd8739ae039 = $4f9316fa6caedf83$var$loupe_medium;



var $7b3a2c9055c45800$var$_path;
const $7b3a2c9055c45800$var$more_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $7b3a2c9055c45800$var$_path || ($7b3a2c9055c45800$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            fill: "#000",
            d: "M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        }))
    });
var $7b3a2c9055c45800$export$2e2bcd8739ae039 = $7b3a2c9055c45800$var$more_medium;



var $d146b05d533b9a8b$var$_path;
const $d146b05d533b9a8b$var$question_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $d146b05d533b9a8b$var$_path || ($d146b05d533b9a8b$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M7.75 7.429c0-2.39 2.106-4.332 4.467-4.168 2.384.164 4.177 2.398 3.851 4.743a4.215 4.215 0 0 1-2.746 3.366c-1.743.616-1.393 2.671-1.393 4.13m-.577 4.5h1.31m.09 0c0 .437-.31.747-.754.747a.718.718 0 0 1-.747-.747c0-.443.31-.753.747-.753.443 0 .753.31.753.753Z"
        }))
    });
var $d146b05d533b9a8b$export$2e2bcd8739ae039 = $d146b05d533b9a8b$var$question_medium;



var $b63a1b80751f3d37$var$_path;
const $b63a1b80751f3d37$var$reset_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $b63a1b80751f3d37$var$_path || ($b63a1b80751f3d37$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            fill: "#000",
            d: "M13.628 21.615a.75.75 0 1 0 .248 1.48l-.248-1.48ZM8 21.71l.633-.401-.127-.201-.22-.091L8 21.71ZM9.25 16a.75.75 0 0 0-1.5 0h1.5Zm-.75 6.5v.75a.75.75 0 0 0 .75-.75H8.5ZM2 21.75a.75.75 0 0 0 0 1.5v-1.5ZM2.25 12A9.75 9.75 0 0 1 12 2.25V.75C5.787.75.75 5.787.75 12h1.5ZM12 2.25A9.75 9.75 0 0 1 21.75 12h1.5C23.25 5.787 18.213.75 12 .75v1.5ZM21.75 12c0 4.83-3.512 8.84-8.122 9.615l.248 1.48c5.32-.894 9.374-5.52 9.374-11.095h-1.5ZM8.286 21.018A9.753 9.753 0 0 1 2.25 12H.75c0 4.697 2.878 8.72 6.964 10.405l.572-1.387ZM7.75 16v6.5h1.5V16h-1.5Zm.75 5.75H2v1.5h6.5v-1.5Zm-1.133.363.5.788 1.266-.802-.5-.79-1.266.804Z"
        }))
    });
var $b63a1b80751f3d37$export$2e2bcd8739ae039 = $b63a1b80751f3d37$var$reset_medium;



var $94d44e796cd0d521$var$_path;
const $94d44e796cd0d521$var$save_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $94d44e796cd0d521$var$_path || ($94d44e796cd0d521$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m15 7.5-3 3-3-3m3 3V.75m7.5 19.5h-15m14-3h-1m-15.25 6h19.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5Z"
        }))
    });
var $94d44e796cd0d521$export$2e2bcd8739ae039 = $94d44e796cd0d521$var$save_medium;



var $156563afed3b2b82$var$_path;
const $156563afed3b2b82$var$subtract_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $156563afed3b2b82$var$_path || ($156563afed3b2b82$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "M21 12H3"
        }))
    });
var $156563afed3b2b82$export$2e2bcd8739ae039 = $156563afed3b2b82$var$subtract_medium;





"use client";
const $cad17f9ce60a2b23$var$icons = {
    ...$1b716dc1cd8c4f3d$exports,
    ...$bacfbed3ffaac4a1$exports
};
function $cad17f9ce60a2b23$export$2e2bcd8739ae039(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, {}, {
        skeleton: context?.skeleton
    }, context.Icon, context.IconPrimary);
    const { icon: icon, size: size, wrapperParams: wrapperParams, iconParams: iconParams, alt: alt, transitionState: transitionState } = (0, $18e1fb7032604f9e$export$dbac4b0afb3666a7)(props, context);
    const spacingProps = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(props, {
        className: wrapperParams.className,
        style: wrapperParams.style
    });
    const IconContainer = (0, $18e1fb7032604f9e$export$20da8aa394d9a3ff)({
        icon: icon,
        size: size,
        alt: alt,
        listOfIcons: $cad17f9ce60a2b23$var$icons
    });
    const ref = (0, $ieaan.useRef)(null);
    const isInitialMount = (0, $ieaan.useRef)(true);
    const { ref: externalRef, ...restWrapperParams } = wrapperParams;
    const combinedRef = (0, $e48c94c3f1835290$export$2e2bcd8739ae039)(ref, externalRef);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (!transitionState || !ref.current) return;
        const iconFn = icon;
        if (iconFn?.__iconTransitionStyle) for (const [key, value] of Object.entries(iconFn.__iconTransitionStyle))ref.current.style.setProperty(key, value);
        if (isInitialMount.current) {
            isInitialMount.current = false;
            (0, $b2f5e7b64029ed28$export$a1a623471fc929a)(ref.current, ()=>{
                (0, $b2f5e7b64029ed28$export$66bb15e2994e6a26).activate(ref.current, transitionState);
            });
        } else (0, $b2f5e7b64029ed28$export$66bb15e2994e6a26).activate(ref.current, transitionState);
    }, [
        transitionState,
        icon
    ]);
    if (!IconContainer) return null;
    return (0, $60739c7e3f826d8d$exports.jsx)("span", {
        ...restWrapperParams,
        ref: combinedRef,
        ...spacingProps,
        children: (0, $60739c7e3f826d8d$exports.jsx)(IconContainer, {
            ...iconParams
        })
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($cad17f9ce60a2b23$export$2e2bcd8739ae039, {
    _supportsSpacingProps: true
});



var $ieaan = parcelRequire("ieaan");






var $ieaan = parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");

function $911842e5a561b5ca$export$22dfc7bb2d427754(params) {
    params.tabIndex = '0';
    params.className = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tooltip__wrapper', 'dnb-tab-focus', params.className);
    return params;
}
const $911842e5a561b5ca$export$9c21a3269931e1e6 = {
    size: 'default',
    placement: 'top',
    arrow: 'center',
    fixedPosition: false,
    noAnimation: false,
    showDelay: 300,
    hideDelay: 500,
    triggerOffset: 16
};
function $911842e5a561b5ca$export$2562999169740ceb(target) {
    if (typeof document !== 'undefined') return typeof target === 'string' ? typeof document !== 'undefined' && document.querySelector(target) : target;
    return undefined;
}
function $911842e5a561b5ca$export$2414da066cdcef(localProps) {
    const { tooltip: tooltip } = localProps;
    if (!tooltip) return null;
    if ((0, $ieaan.isValidElement)(tooltip)) {
        const type = tooltip.type;
        if (type?.isTooltipComponent) return tooltip.props;
    }
    return {
        children: tooltip
    };
}
const $911842e5a561b5ca$export$971e5333ff27c622 = (type)=>{
    return /touch/i.test(type);
};





var $ieaan = parcelRequire("ieaan");


var $ieaan = parcelRequire("ieaan");





var $ieaan = parcelRequire("ieaan");


function $05612a99cdf7c35a$export$2e2bcd8739ae039({ className: className = null, children: children = null, pseudoElementOnly: pseudoElementOnly = false, ...props }) {
    return (0, $60739c7e3f826d8d$exports.jsx)("span", {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(pseudoElementOnly ? 'dnb-alignment-helper--pseudo-element-only' : 'dnb-alignment-helper', className),
        "aria-hidden": true,
        ...props,
        children: children
    });
}




var $890dd4bb8bcb7f69$var$_span, $890dd4bb8bcb7f69$var$_AlignmentHelper, $890dd4bb8bcb7f69$var$_AlignmentHelper2;
function $890dd4bb8bcb7f69$export$2e2bcd8739ae039({ title: title = null, content: content = null, customContent: customContent = null, icon: icon = null, iconSize: iconSize = 'default', bounding: bounding = null, skeleton: skeleton = null, isIconOnly: isIconOnly = null, iconElement: iconElement = null, transitionState: transitionState = null }) {
    return (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            bounding && ($890dd4bb8bcb7f69$var$_span || ($890dd4bb8bcb7f69$var$_span = (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-button__bounding"
            }, "button-bounding"))),
            customContent && (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: customContent
            }, "button-custom-content"),
            content && (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
                children: [
                    $890dd4bb8bcb7f69$var$_AlignmentHelper || ($890dd4bb8bcb7f69$var$_AlignmentHelper = (0, $60739c7e3f826d8d$exports.jsx)((0, $05612a99cdf7c35a$export$2e2bcd8739ae039), {
                        className: "dnb-button__alignment",
                        pseudoElementOnly: true
                    }, "button-alignment")),
                    (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-button__text dnb-skeleton--show-font",
                        children: content
                    }, "button-text")
                ]
            }),
            !content && icon && ($890dd4bb8bcb7f69$var$_AlignmentHelper2 || ($890dd4bb8bcb7f69$var$_AlignmentHelper2 = (0, $60739c7e3f826d8d$exports.jsx)((0, $05612a99cdf7c35a$export$2e2bcd8739ae039), {
                className: "dnb-button__alignment",
                pseudoElementOnly: true
            }, "button-alignment"))),
            icon && (iconElement || (0, $60739c7e3f826d8d$exports.jsx)((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
                className: "dnb-button__icon",
                icon: icon,
                size: iconSize,
                transitionState: transitionState,
                "aria-hidden": isIconOnly && !title ? null : true,
                skeleton: skeleton
            }, "button-icon"))
        ]
    });
}



"use client";
function $41765213373873a6$export$2e2bcd8739ae039({ icon: icon = 'close', iconSize: iconSize, iconPosition: iconPosition = 'right', variant: variant = 'tertiary', size: size, className: className, title: title, text: text, children: children, type: buttonType, stretch: stretch, wrap: wrap, skeleton: skeleton, ...rest }) {
    var _rest$ariaLabel;
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const hasIcon = Boolean(icon);
    const content = text !== null && text !== void 0 ? text : children;
    const hasContent = Boolean(content);
    const isIconOnly = Boolean(hasIcon && !hasContent);
    const iconElement = (0, $ieaan.isValidElement)(icon) ? (0, $ieaan.createElement)(icon.type, {
        ...icon.props,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(icon.props.className, 'dnb-button__icon')
    }) : null;
    const resolvedAriaLabel = (_rest$ariaLabel = rest['aria-label']) !== null && _rest$ariaLabel !== void 0 ? _rest$ariaLabel : typeof title === 'string' ? title : undefined;
    const resolvedType = buttonType === 'button' || buttonType === 'submit' || buttonType === 'reset' ? buttonType : 'button';
    let resolvedVariant = variant;
    let resolvedSize = size;
    let resolvedIconSize = iconSize;
    if (isIconOnly) {
        if (!resolvedVariant) resolvedVariant = 'secondary';
        if (!resolvedSize) resolvedSize = 'medium';
        if (!resolvedIconSize && (resolvedSize === 'default' || resolvedSize === 'large')) resolvedIconSize = 'medium';
    } else if (hasContent) {
        if (!resolvedVariant) resolvedVariant = 'primary';
        if (!resolvedSize) resolvedSize = 'default';
    }
    if (!resolvedIconSize && resolvedVariant === 'tertiary' && iconPosition === 'top') resolvedIconSize = 'medium';
    const buttonProps = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        ...rest,
        stretch: stretch,
        wrap: wrap,
        skeleton: skeleton
    }, {
        title: title,
        'aria-label': resolvedAriaLabel,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-button', `dnb-button--${resolvedVariant}`, resolvedSize && resolvedSize !== 'default' && `dnb-button--size-${resolvedSize}`, hasIcon && `dnb-button--icon-position-${iconPosition}`, hasIcon && resolvedIconSize && `dnb-button--icon-size-${resolvedIconSize}`, hasContent && 'dnb-button--has-text', hasIcon && 'dnb-button--has-icon', isIconOnly && 'dnb-button--icon-only', stretch && 'dnb-button--stretch', wrap && 'dnb-button--wrap', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(resolvedVariant === 'tertiary' ? 'font' : 'shape', skeleton, context), className),
        type: resolvedType,
        ...rest
    });
    return (0, $60739c7e3f826d8d$exports.jsx)("button", {
        ...buttonProps,
        children: (0, $60739c7e3f826d8d$exports.jsx)((0, $890dd4bb8bcb7f69$export$2e2bcd8739ae039), {
            title: title,
            content: content,
            icon: icon,
            iconSize: resolvedIconSize,
            skeleton: skeleton,
            isIconOnly: isIconOnly,
            iconElement: iconElement
        })
    });
}






var $ieaan = parcelRequire("ieaan");





"use client";
var $9aa14cee70657571$var$_br;
function $9aa14cee70657571$export$2e2bcd8739ae039(messages, args) {
    const { locale: locale, translation: translation, messageFormatter: messageFormatter } = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const { translations: contextTranslations } = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const { assignUtils: assignUtils } = $9aa14cee70657571$export$e3c8d3098529298d(messageFormatter);
    const { extMessages: extMessages, fallbackLocale: fallbackLocale, baseOverride: baseOverride, warnLabel: warnLabel } = (0, $ieaan.useMemo)(()=>{
        var _arg$fallbackLocale;
        const defaultLocaleKeys = Object.keys((0, $cd34253258a667c2$export$2e2bcd8739ae039));
        const defaultLocale = defaultLocaleKeys[0];
        const arg = (0, $11741836d1790446$export$a6cdc56e425d0d0a)(messages) && ('messages' in messages || 'fallbackLocale' in messages) ? messages : {
            messages: messages
        };
        return {
            extMessages: arg.messages,
            fallbackLocale: (_arg$fallbackLocale = arg.fallbackLocale) !== null && _arg$fallbackLocale !== void 0 ? _arg$fallbackLocale : defaultLocale,
            baseOverride: arg.base,
            warnLabel: arg.warnLabel || 'useTranslation'
        };
    }, [
        messages
    ]);
    return (0, $ieaan.useMemo)(()=>{
        var _ref;
        const id = typeof messages === 'string' ? messages : undefined;
        if (id) return $9aa14cee70657571$export$25868d1e8e76735f(id, args, translation);
        let translationLocale = locale;
        if (locale.startsWith('en-') && !Object.keys((0, $cd34253258a667c2$export$2e2bcd8739ae039)).some((l)=>l === locale)) translationLocale = 'en-GB';
        const base = assignUtils($9aa14cee70657571$export$1e0383c15842b2b9({
            translation: baseOverride || translation,
            messages: extMessages,
            locale: translationLocale
        }), translationLocale);
        if (!fallbackLocale) return base;
        const explicitMessages = extMessages;
        let hasExplicitCurrent = false;
        let currentMessages = undefined;
        if (explicitMessages && (0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(explicitMessages, locale)) {
            hasExplicitCurrent = true;
            currentMessages = explicitMessages[locale];
        } else if (contextTranslations && (0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(contextTranslations, locale)) {
            hasExplicitCurrent = true;
            currentMessages = contextTranslations[locale];
        }
        const fallbackMessages = (_ref = explicitMessages?.[fallbackLocale] || contextTranslations?.[fallbackLocale] || (0, $cd34253258a667c2$export$2e2bcd8739ae039)[fallbackLocale]) !== null && _ref !== void 0 ? _ref : undefined;
        if (!fallbackMessages || !hasExplicitCurrent) return base;
        const currentHasContent = (0, $11741836d1790446$export$a6cdc56e425d0d0a)(currentMessages) && Object.keys(currentMessages).length > 0;
        if (!currentHasContent) {
            $9aa14cee70657571$var$warnMissing(locale, warnLabel);
            const obj = $9aa14cee70657571$var$generateTranslationKeyReferences('', fallbackMessages);
            return $9aa14cee70657571$var$withUtils(base, obj);
        }
        const { result: result, hasMissing: hasMissing } = $9aa14cee70657571$var$mergeMissingKeys(base, fallbackMessages);
        if (hasMissing) {
            $9aa14cee70657571$var$warnMissing(locale, warnLabel);
            return $9aa14cee70657571$var$withUtils(base, result);
        }
        return base;
    }, [
        messages,
        locale,
        assignUtils,
        baseOverride,
        translation,
        extMessages,
        fallbackLocale,
        contextTranslations,
        args,
        warnLabel
    ]);
}
function $9aa14cee70657571$var$withUtils(base, obj) {
    return Object.assign({}, base, obj, {
        formatMessage: base.formatMessage,
        renderMessage: base.renderMessage,
        countries: base.countries
    });
}
function $9aa14cee70657571$var$mergeMissingKeys(target, source) {
    const resultLocal = {
        ...target
    };
    let hasMissing = false;
    const keys = Object.keys(source);
    for (const key of keys){
        const sourceValue = source[key];
        const targetValue = resultLocal[key];
        if ((0, $11741836d1790446$export$a6cdc56e425d0d0a)(sourceValue)) {
            if (!targetValue) {
                resultLocal[key] = $9aa14cee70657571$var$generateTranslationKeyReferences(key, sourceValue);
                hasMissing = true;
            } else if ((0, $11741836d1790446$export$a6cdc56e425d0d0a)(targetValue)) {
                const nested = $9aa14cee70657571$var$mergeMissingKeys(targetValue, sourceValue);
                resultLocal[key] = nested.result;
                if (nested.hasMissing) hasMissing = true;
            }
        } else if (targetValue === undefined) {
            resultLocal[key] = key;
            hasMissing = true;
        }
    }
    return {
        result: resultLocal,
        hasMissing: hasMissing
    };
}
function $9aa14cee70657571$var$generateTranslationKeyReferences(baseKey, sourceValue) {
    if (!(0, $11741836d1790446$export$a6cdc56e425d0d0a)(sourceValue)) return baseKey ? baseKey : sourceValue;
    const result = {};
    const entries = Object.entries(sourceValue);
    for (const [key, value] of entries){
        const translationKey = baseKey ? `${baseKey}.${key}` : key;
        result[key] = (0, $11741836d1790446$export$a6cdc56e425d0d0a)(value) ? $9aa14cee70657571$var$generateTranslationKeyReferences(translationKey, value) : translationKey;
    }
    return result;
}
function $9aa14cee70657571$var$warnMissing(locale, label = 'useTranslation') {
    (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`${label}: No translations found for locale "${locale}"!`);
}
function $9aa14cee70657571$export$e3c8d3098529298d(messageFormatter) {
    const translationsRef = (0, $ieaan.useRef)(undefined);
    const localeRef = (0, $ieaan.useRef)((0, $07b61efe40a5ad0e$export$9824d860d0b120d9));
    const messageFormatterRef = (0, $ieaan.useRef)(messageFormatter);
    messageFormatterRef.current = messageFormatter;
    const fM = (0, $ieaan.useCallback)((id, args)=>{
        return $9aa14cee70657571$export$25868d1e8e76735f(id, args, translationsRef.current, localeRef.current, messageFormatterRef.current);
    }, []);
    const rM = (0, $ieaan.useCallback)((message)=>{
        return $9aa14cee70657571$export$7b9c635b0dc56d38(message);
    }, []);
    const assignUtils = (0, $ieaan.useCallback)((translations, locale)=>{
        translationsRef.current = translations;
        if (locale) localeRef.current = locale;
        Object.assign(translations, {
            formatMessage: fM,
            renderMessage: rM
        });
        return translations;
    }, [
        fM,
        rM
    ]);
    return {
        assignUtils: assignUtils
    };
}
function $9aa14cee70657571$export$1e0383c15842b2b9({ translation: translation, messages: messages, locale: locale }) {
    let combined = {
        ...translation
    };
    if (messages) {
        if (Object.keys((0, $cd34253258a667c2$export$2e2bcd8739ae039)).some((locale)=>messages[locale])) {
            if (messages[locale]) combined = messages[locale];
        }
        for(const key in messages)combined[key] = {
            ...translation[key],
            ...messages[key]
        };
    }
    return combined;
}
function $9aa14cee70657571$export$25868d1e8e76735f(id, args, messages, locale, messageFormatter) {
    let str = undefined;
    if (typeof id === 'string') {
        let found = false;
        if (messages[id]) {
            str = messages[id];
            found = true;
        } else if (id?.includes?.('.')) {
            const keys = id.split('.');
            for (const key of keys){
                if (messages[key]) messages = messages[key];
                else break;
            }
            if (typeof messages === 'string') {
                str = messages;
                found = true;
            }
        }
        if (!found && typeof id === 'string') {
            if (id.includes('.')) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`formatMessage: Could not resolve translation key "${id}". It may be missing or incorrectly formatted.`);
            str = id;
        }
    } else if (typeof id === 'function') str = id(messages);
    if (typeof str === 'string') {
        if (args && messageFormatter && messageFormatter.isICU(str)) try {
            const result = messageFormatter.format(str, args, locale || (0, $07b61efe40a5ad0e$export$9824d860d0b120d9));
            if (Array.isArray(result)) return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
                children: result.map((part, i)=>(0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                        children: part
                    }, i))
            });
            return result;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`formatMessage: ICU formatting failed for "${typeof id === 'string' ? id : '(function)'}":`, e);
            return typeof id === 'string' ? id : str;
        }
        let hasTagHandlers = false;
        for(const t in args){
            if (typeof args[t] === 'function' && str.includes(`<${t}>`)) {
                hasTagHandlers = true;
                continue;
            }
            const value = typeof args[t] === 'function' ? args[t]() : args[t];
            const regex = new RegExp(`{${t}}`, 'g');
            str = str.replace(regex, value);
        }
        const unreplaced = str.match(/\{(\w+)\}/g)?.filter((p)=>p !== '{br}');
        if (unreplaced?.length > 0) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`formatMessage: Unreplaced placeholder(s) ${unreplaced.join(', ')} in "${typeof id === 'string' ? id : '(function)'}".`);
        if (hasTagHandlers) return $9aa14cee70657571$var$renderTags(str, args);
    }
    return str !== null && str !== void 0 ? str : id;
}
function $9aa14cee70657571$export$7b9c635b0dc56d38(text) {
    let element = text;
    if (typeof text === 'string') element = text.split('{br}');
    if (Array.isArray(element)) return element.map((item, index)=>(0, $60739c7e3f826d8d$exports.jsxs)((0, $ieaan.Fragment), {
            children: [
                item,
                $9aa14cee70657571$var$_br || ($9aa14cee70657571$var$_br = (0, $60739c7e3f826d8d$exports.jsx)("br", {}))
            ]
        }, index));
    return text;
}
function $9aa14cee70657571$var$renderTags(str, args) {
    const TAG_RE = /<(\w+)>([\s\S]*?)<\/\1>/;
    const parts = [];
    let remaining = str;
    let match;
    while((match = TAG_RE.exec(remaining)) !== null){
        const [fullMatch, tagName, content] = match;
        if (match.index > 0) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(parts).call(parts, remaining.slice(0, match.index));
        const handler = args[tagName];
        if (typeof handler === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(parts).call(parts, handler(content));
        else (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(parts).call(parts, fullMatch);
        remaining = remaining.slice(match.index + fullMatch.length);
    }
    if (remaining) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(parts).call(parts, remaining);
    if (parts.length === 1 && typeof parts[0] === 'string') return parts[0];
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: parts.map((part, i)=>(0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: part
            }, i))
    });
}




function $94ac3bc13091b86b$export$2e2bcd8739ae039(target) {
    if (!target) return null;
    const unknownTarget = target;
    let element = target;
    if (unknownTarget?.current?._ref) element = $94ac3bc13091b86b$export$2e2bcd8739ae039(unknownTarget.current._ref);
    if (element && (0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(element, 'current')) element = element.current;
    return element;
}



var $ieaan = parcelRequire("ieaan");




var $ieaan = parcelRequire("ieaan");
"use client";
function $628cfc5c68413f65$export$2e2bcd8739ae039() {
    const mounted = (0, $ieaan.useRef)(false);
    (0, $ieaan.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return mounted;
}



var $ieaan = parcelRequire("ieaan");

var $ie2rr = parcelRequire("ie2rr");


var $ieaan = parcelRequire("ieaan");

const $8898afc1b6d058e7$var$slugify = (s)=>String(s).toLowerCase().replace(/[^a-z0-9-]/g, '_');
const $8898afc1b6d058e7$export$bd0a6d13e5f3800b = (opts)=>{
    const version = opts?.version || (0, $bce3ea05de26e767$export$c506eb22e615ba4a)();
    const isVersion = String(version).match(/^\d/);
    const isBranch = String(version).includes('/');
    if (isVersion) return $8898afc1b6d058e7$var$slugify(`eufemia-scope--${version}`);
    if (isBranch) {
        const sha = opts?.sha || (0, $bce3ea05de26e767$export$60d52592423e9732)();
        return $8898afc1b6d058e7$var$slugify(`eufemia-scope--${sha}`);
    }
    return 'eufemia-scope--default';
};




"use client";
const $ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4 = (0, $ieaan.createContext)(undefined);
const $ce0e0ed7ebbe2d2a$var$parentScopeContextMap = new Map();
function $ce0e0ed7ebbe2d2a$export$2e2bcd8739ae039(props) {
    const styleScopeContext = (0, $ieaan.useContext)($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4);
    const { scopeHash: scopeHash = 'auto', disableCoreStyleWrapper: disableCoreStyleWrapper = false, uniqueKey: uniqueKey = 'default', ref: refProp, children: children, style: style } = props;
    const localRef = (0, $ieaan.useRef)(undefined);
    const scopeElementRef = refProp || localRef;
    const generatedScopeHash = scopeHash === 'auto' ? styleScopeContext?.generatedScopeHash || (0, $8898afc1b6d058e7$export$bd0a6d13e5f3800b)() : scopeHash;
    const isNestedWithNewScope = styleScopeContext && styleScopeContext.generatedScopeHash && styleScopeContext.generatedScopeHash !== generatedScopeHash;
    const parentContextMap = styleScopeContext?.parentContextMap || $ce0e0ed7ebbe2d2a$var$parentScopeContextMap;
    if (styleScopeContext?.generatedScopeHash) parentContextMap.set(styleScopeContext.generatedScopeHash, styleScopeContext);
    if (styleScopeContext?.generatedScopeHash ? props.scopeHash : true) {
        if (uniqueKey === false || !styleScopeContext?.internalKeys?.has(uniqueKey) || isNestedWithNewScope) {
            var _styleScopeContext$sc;
            const internalKeys = new Set(styleScopeContext?.internalKeys || []);
            if (typeof uniqueKey === 'string') internalKeys.add(uniqueKey);
            return (0, $60739c7e3f826d8d$exports.jsx)($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4, {
                value: {
                    scopeHash: scopeHash,
                    generatedScopeHash: generatedScopeHash,
                    disableCoreStyleWrapper: disableCoreStyleWrapper,
                    style: style,
                    scopeElementRef: scopeElementRef,
                    internalKeys: internalKeys,
                    parentContextMap: parentContextMap
                },
                children: (0, $60739c7e3f826d8d$exports.jsx)("div", {
                    "data-scope-hash": scopeHash === 'auto' ? (_styleScopeContext$sc = styleScopeContext?.scopeHash) !== null && _styleScopeContext$sc !== void 0 ? _styleScopeContext$sc : scopeHash : scopeHash,
                    "data-scope-hash-id": uniqueKey || undefined,
                    "data-scope-sha": uniqueKey ? (0, $bce3ea05de26e767$export$60d52592423e9732)() : undefined,
                    className: generatedScopeHash,
                    style: style || styleScopeContext?.style,
                    ref: scopeElementRef,
                    children: disableCoreStyleWrapper ? children : (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-core-style",
                        children: children
                    })
                })
            });
        }
    }
    return children;
}
function $ce0e0ed7ebbe2d2a$export$5cf7a780904d1670(currentElement, scopeHash = 'auto', fallback = null) {
    if (scopeHash === 'auto') scopeHash = (0, $8898afc1b6d058e7$export$bd0a6d13e5f3800b)();
    if (typeof window === 'undefined') return undefined;
    if (scopeHash) return currentElement.closest(`.${scopeHash}`);
    return fallback || document.body;
}
function $ce0e0ed7ebbe2d2a$export$885c19c3d536c50f(scopeHash) {
    const styleScopeContext = (0, $ieaan.useContext)($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4);
    const { scopeElementRef: scopeElementRef, generatedScopeHash: generatedScopeHash, parentContextMap: parentContextMap } = styleScopeContext || {};
    const getScopeElement = (0, $ieaan.useCallback)(()=>{
        if (!scopeHash || scopeHash === generatedScopeHash) return scopeElementRef?.current;
        const map = parentContextMap || $ce0e0ed7ebbe2d2a$var$parentScopeContextMap;
        const parentCtx = map.get(scopeHash);
        return parentCtx?.scopeElementRef?.current;
    }, [
        scopeElementRef,
        generatedScopeHash,
        parentContextMap,
        scopeHash
    ]);
    return {
        getScopeElement: getScopeElement
    };
}





var $ieaan = parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");




var $ieaan = parcelRequire("ieaan");




var $ieaan = parcelRequire("ieaan");

function $a728b57d880c2c9c$export$2e2bcd8739ae039({ className: className, children: children, ...rest }) {
    const hasNode = typeof children !== 'string';
    const classes = [
        'dnb-anchor',
        hasNode ? 'dnb-anchor--was-node' : null,
        'dnb-a',
        className
    ].filter(Boolean).join(' ');
    return (0, $60739c7e3f826d8d$exports.jsx)("a", {
        className: classes,
        ...rest,
        children: children
    });
}



var $ieaan = parcelRequire("ieaan");





"use client";
function $4b1aff00b000d315$var$Code({ className: className, ref: ref, ...props }) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $3d090471d65e4fa1$export$2e2bcd8739ae039), {
        as: "code",
        ref: ref,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(context?.theme?.surface === 'dark' && 'dnb-code--surface-dark', className),
        ...props
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($4b1aff00b000d315$var$Code, {
    _supportsSpacingProps: true
});
var $4b1aff00b000d315$export$2e2bcd8739ae039 = $4b1aff00b000d315$var$Code;


var $4b74e561c86f4bee$export$2e2bcd8739ae039 = (0, $4b1aff00b000d315$export$2e2bcd8739ae039);



const $4ab0f6282d83030b$var$Strong = (c)=>(0, $60739c7e3f826d8d$exports.jsx)("strong", {
        children: c
    });
const $4ab0f6282d83030b$var$Em = (c)=>(0, $60739c7e3f826d8d$exports.jsx)("em", {
        children: c
    });
const $4ab0f6282d83030b$var$Code = (c)=>(0, $60739c7e3f826d8d$exports.jsx)((0, $4b74e561c86f4bee$export$2e2bcd8739ae039), {
        children: c
    });
const $4ab0f6282d83030b$var$Link = (c, href)=>(0, $60739c7e3f826d8d$exports.jsx)((0, $a728b57d880c2c9c$export$2e2bcd8739ae039), {
        href: href,
        rel: "noopener noreferrer",
        children: c
    });
function $4ab0f6282d83030b$export$2e2bcd8739ae039(text, { br: br = '{br}', strong: strong = $4ab0f6282d83030b$var$Strong, em: em = $4ab0f6282d83030b$var$Em, link: link = $4ab0f6282d83030b$var$Link, code: code = $4ab0f6282d83030b$var$Code } = {}) {
    if (typeof text === 'string') {
        const HAS_MARKERS_RE = /(`[^`]+`|\[[^\]]+\]\([^)\s]+\)|\bhttps?:\/\/[^\s<>()]+|\*\*[^*]+\*\*|_[^_]+_)/;
        const hasFormatting = br && text.includes(br) || HAS_MARKERS_RE.test(text);
        if (!hasFormatting) return text;
    }
    return $4ab0f6282d83030b$var$withFormatting(text, {
        strong: strong,
        em: em,
        br: br,
        link: link,
        code: code
    });
}
function $4ab0f6282d83030b$var$withFormatting(text, { br: br, strong: strong, em: em, link: link, code: code }) {
    let nodes = Array.isArray(text) ? text : [
        text
    ];
    nodes = $4ab0f6282d83030b$var$splitToken(nodes, br, ({ k: k })=>(0, $60739c7e3f826d8d$exports.jsx)("br", {}, k()));
    const codeRe = /(`[^`]+`)/g;
    nodes = $4ab0f6282d83030b$var$replaceInStrings(nodes, codeRe, (m, { k: k })=>[
            (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: code(m[0].slice(1, -1))
            }, `c-${k()}`)
        ]);
    const linkRe = /\[([^\]]+)\]\(([^)\s]+)\)/g;
    nodes = $4ab0f6282d83030b$var$replaceInStrings(nodes, linkRe, (m, { k: k })=>{
        const [, label, href] = m;
        const children = $4ab0f6282d83030b$var$withFormatting(label, {
            br: br,
            strong: strong,
            em: em,
            link: link,
            code: code
        });
        return [
            (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: link(children, href)
            }, `a-${k()}`)
        ];
    });
    const bareUrlRe = /\b((?:https?:\/\/)[^\s<>()]+)\b/g;
    nodes = $4ab0f6282d83030b$var$replaceInStrings(nodes, bareUrlRe, (m, { k: k })=>{
        const href = m[1];
        return [
            (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: link(href, href)
            }, `l-${k()}`)
        ];
    });
    const boldRe = /\*\*([^*]+)\*\*/g;
    nodes = $4ab0f6282d83030b$var$replaceInStrings(nodes, boldRe, (m, { k: k })=>[
            (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: strong(m[1])
            }, `b-${k()}`)
        ]);
    const italicRe = /_([^_]+)_/g;
    nodes = $4ab0f6282d83030b$var$replaceInStrings(nodes, italicRe, (m, { k: k })=>[
            (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: em(m[1])
            }, `i-${k()}`)
        ]);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
        children: nodes
    }, "renderWithFormatting");
}
function $4ab0f6282d83030b$var$replaceInStrings(nodes, re, replacer) {
    let key = 0;
    const k = ()=>String(key++);
    return nodes.flatMap((n, i)=>{
        if (typeof n !== 'string') return [
            n
        ];
        const out = [];
        let last = 0;
        let m;
        while((m = re.exec(n)) !== null){
            const before = n.slice(last, m.index);
            if (before) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(out).call(out, before);
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(out).call(out, ...replacer(m, {
                i: i,
                k: k
            }));
            last = m.index + m[0].length;
            if (re.lastIndex === m.index) re.lastIndex++;
        }
        const tail = n.slice(last);
        if (tail) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(out).call(out, tail);
        return out;
    });
}
function $4ab0f6282d83030b$var$splitToken(nodes, token, make) {
    let key = 0;
    const k = ()=>String(key++);
    return nodes.flatMap((n, i)=>{
        if (typeof n !== 'string') return [
            n
        ];
        const parts = n.split(token);
        const out = [];
        parts.forEach((chunk, idx)=>{
            if (chunk) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(out).call(out, chunk);
            if (idx < parts.length - 1) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(out).call(out, (0, $60739c7e3f826d8d$exports.jsx)((0, $ieaan.Fragment), {
                children: make({
                    i: i,
                    idx: idx,
                    k: k
                })
            }, k()));
        });
        return out;
    });
}



"use client";
const $3e7c4939f4eb3152$var$TranslationImpl = ({ id: id, children: children, ...params })=>{
    const { translation: translation, locale: locale, messageFormatter: messageFormatter } = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const result = (0, $9aa14cee70657571$export$25868d1e8e76735f)(id || children, params, translation, locale, messageFormatter);
    if ((0, $ieaan.isValidElement)(result) || Array.isArray(result)) return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: result
    });
    if (typeof result !== 'string') return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: String(id)
    });
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: (0, $4ab0f6282d83030b$export$2e2bcd8739ae039)(result)
    });
};
const $3e7c4939f4eb3152$var$Translation = $3e7c4939f4eb3152$var$TranslationImpl;
$3e7c4939f4eb3152$var$Translation.withTypes = function withTypes() {
    return function TypedTranslation(props) {
        return (0, $60739c7e3f826d8d$exports.jsx)($3e7c4939f4eb3152$var$TranslationImpl, {
            ...props
        });
    };
};
var $3e7c4939f4eb3152$export$2e2bcd8739ae039 = $3e7c4939f4eb3152$var$Translation;
function $3e7c4939f4eb3152$var$isPlainObject(value) {
    if (value === null || typeof value !== 'object') return false;
    if (Array.isArray(value)) return false;
    return Object.getPrototypeOf(value) === Object.prototype;
}
function $3e7c4939f4eb3152$export$2e544a74383fa820(...translations) {
    return translations.reduce((acc, cur)=>{
        Object.keys(cur).forEach((key)=>{
            const accValue = acc[key];
            const curValue = cur[key];
            if (Array.isArray(accValue) && Array.isArray(curValue)) {
                acc[key] = [
                    ...accValue,
                    ...curValue
                ];
                return;
            }
            if ($3e7c4939f4eb3152$var$isPlainObject(accValue) && $3e7c4939f4eb3152$var$isPlainObject(curValue)) {
                acc[key] = $3e7c4939f4eb3152$export$2e544a74383fa820(accValue, curValue);
                return;
            }
            acc[key] = curValue;
        });
        return acc;
    }, {});
}




"use client";
function $8311cfcd13326d81$export$2e2bcd8739ae039(localProps) {
    const nestedContext = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const [localContext, setLocalContext] = (0, $ieaan.useState)(null);
    const updateCurrent = (0, $ieaan.useCallback)((props)=>{
        setLocalContext({
            __context__: props
        });
    }, []);
    const setCurrentLocale = (0, $ieaan.useCallback)((locale)=>{
        setLocalContext({
            __context__: {
                locale: locale
            }
        });
    }, []);
    const update = (0, $ieaan.useCallback)((props)=>{
        nestedContext.update?.(props);
        setLocalContext({
            __context__: props
        });
    }, [
        nestedContext
    ]);
    const setLocale = (0, $ieaan.useCallback)((locale)=>{
        update({
            locale: locale
        });
    }, [
        update
    ]);
    const { translationsLoader: translationsLoader, translations: propTranslations } = localProps;
    const propTranslationsRef = (0, $ieaan.useRef)(propTranslations);
    propTranslationsRef.current = propTranslations;
    const translationsLoaderRef = (0, $ieaan.useRef)(translationsLoader);
    translationsLoaderRef.current = translationsLoader;
    const effectiveLocale = localContext?.__context__?.locale || localProps.locale || nestedContext.locale || (0, $07b61efe40a5ad0e$export$9824d860d0b120d9);
    (0, $ieaan.useEffect)(()=>{
        const loader = translationsLoaderRef.current;
        if (!loader) return undefined;
        let cancelled = false;
        loader(effectiveLocale).then((loaded)=>{
            if (!cancelled && loaded) {
                const base = propTranslationsRef.current || {};
                const merged = (0, $3e7c4939f4eb3152$export$2e544a74383fa820)(base, loaded);
                setLocalContext((prev)=>({
                        __context__: {
                            ...prev?.__context__,
                            translations: merged
                        }
                    }));
            }
        }).catch((error)=>{
            if (!cancelled) (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Provider: translationsLoader failed:', error);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        effectiveLocale
    ]);
    const value = (0, $ieaan.useMemo)(()=>{
        const { children: children, ...rest } = localProps;
        const preparedContext = {
            ...(0, $e220d71a88fa3fa1$export$9c634076e0a91d1f)($8311cfcd13326d81$var$mergeContextWithProps(nestedContext, {
                ...localContext,
                ...rest
            }))
        };
        preparedContext.update = update;
        preparedContext.setLocale = setLocale;
        preparedContext.updateCurrent = updateCurrent;
        preparedContext.setCurrentLocale = setCurrentLocale;
        nestedContext.updateTranslation(preparedContext.locale, preparedContext.translations);
        return preparedContext;
    }, [
        localProps,
        nestedContext,
        localContext,
        update,
        setLocale,
        updateCurrent,
        setCurrentLocale
    ]);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039), {
        value: value,
        children: localProps.children
    });
}
function $8311cfcd13326d81$var$mergeContextWithProps(nestedContext, localProps) {
    const { value: value, ...rest } = localProps;
    const props = {
        ...value,
        ...rest
    };
    const mergedContext = {
        ...nestedContext,
        ...props
    };
    const nestedTranslations = nestedContext?.translations;
    const localTranslations = props.translations;
    if (nestedTranslations && localTranslations) {
        const mergedTranslations = (0, $3e7c4939f4eb3152$export$2e544a74383fa820)(nestedTranslations, localTranslations);
        mergedContext.translations = mergedTranslations;
    }
    if (nestedContext?.formElement && props.formElement) {
        mergedContext.formElement = {
            ...nestedContext.formElement,
            ...props.formElement
        };
        mergedContext.formElement = (0, $c81beeaa1b3509d1$export$c37735b23b2df049)(mergedContext.formElement);
    }
    return mergedContext;
}





var $ieaan = parcelRequire("ieaan");





const $ccaa0a2f61c56410$export$f44bcf56d375ea05 = {
    small: '40em',
    medium: '60em',
    large: '72em',
    'x-large': '80em',
    'xx-large': '90em'
};
function $ccaa0a2f61c56410$export$426729170c6eaa88(property, callback, { runOnInit: runOnInit = false } = {}) {
    let query = property;
    let when = null;
    let not = null;
    if (property && typeof property === 'object') {
        query = null;
        when = property.when || property;
        not = property.not;
    }
    const mediaQueryList = $ccaa0a2f61c56410$export$e57d90d0ec36fcbc({
        query: query,
        when: when,
        not: not
    });
    if (runOnInit) {
        if (typeof callback === 'function') callback(mediaQueryList?.matches, mediaQueryList);
    }
    return $ccaa0a2f61c56410$export$1946718a333328e0(mediaQueryList, callback);
}
const $ccaa0a2f61c56410$export$26316165d3b380c8 = ()=>typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
function $ccaa0a2f61c56410$export$e57d90d0ec36fcbc({ query: query, when: when, not: not = null } = {}, breakpoints = null, options) {
    const isSupported = $ccaa0a2f61c56410$export$26316165d3b380c8();
    if (options?.disabled || !isSupported) return null;
    if (when) query = $ccaa0a2f61c56410$export$d7b58f10109feb02({
        query: query,
        when: when,
        not: not
    }, breakpoints, options);
    const mediaQueryString = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(query, breakpoints, options);
    const mediaQueryList = window.matchMedia(mediaQueryString);
    if (options?.log) (0, $deeefef162515a83$export$c106dd0671a0fc2d)('MediaQuery:', mediaQueryString);
    return mediaQueryList;
}
function $ccaa0a2f61c56410$export$1946718a333328e0(mediaQueryList, callback) {
    if (!mediaQueryList) return ()=>null;
    const listener = (event)=>{
        if (typeof callback === 'function') callback(event?.matches, event);
    };
    if (mediaQueryList?.addEventListener) mediaQueryList.addEventListener('change', listener);
    return ()=>{
        if (mediaQueryList?.removeEventListener) mediaQueryList.removeEventListener('change', listener);
    };
}
function $ccaa0a2f61c56410$export$d7b58f10109feb02({ query: query = null, when: when = null, not: not = null } = {}, breakpoints, options) {
    if (when) {
        if (typeof when === 'string') when = when.split(/[ ,]/g);
        let listOfQueries = [];
        if (Array.isArray(when)) listOfQueries = listOfQueries.concat($ccaa0a2f61c56410$var$combineQueries(when, breakpoints, options));
        else if (typeof when === 'object') {
            const queryItem = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(when, breakpoints, options);
            if (queryItem) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(listOfQueries).call(listOfQueries, queryItem);
        }
        if (listOfQueries.length > 0) query = [
            listOfQueries.join(' '),
            query || ''
        ].filter(Boolean).join(' and ').replace(/ +/g, ' ').replace(/ ,/g, ',');
    }
    if (not) query = $ccaa0a2f61c56410$var$reverseQuery(String(query));
    return query || 'not';
}
function $ccaa0a2f61c56410$var$reverseQuery(query) {
    if (query.startsWith('not')) return query.replace(/^not +/, '');
    if (!/^(screen|all|print|speech)/.test(query)) query = `all and ${query}`;
    return `not ${query}`;
}
function $ccaa0a2f61c56410$var$combineQueries(queries, breakpoints = null, options) {
    return queries.reduce((listOfQueries, when, i, arr)=>{
        if (breakpoints) breakpoints = $ccaa0a2f61c56410$var$mergeBreakpoints(breakpoints);
        const query = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(when, breakpoints, options);
        if (query) {
            if (query !== 'and' && arr[i - 1] !== 'and') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(listOfQueries).call(listOfQueries, ', ');
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(listOfQueries).call(listOfQueries, query);
        }
        return listOfQueries;
    }, []).filter((query, i)=>{
        return !(i === 0 && query.startsWith(', '));
    });
}
function $ccaa0a2f61c56410$var$mergeBreakpoints(breakpoints) {
    return Object.entries({
        ...$ccaa0a2f61c56410$export$f44bcf56d375ea05,
        ...breakpoints
    }).sort((a, b)=>a[1] > b[1] ? 1 : -1).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
function $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(query, breakpoints = null, options) {
    if (typeof query === 'string') return query;
    if (Array.isArray(query)) return query.reduce((acc, q, index)=>{
        acc += $ccaa0a2f61c56410$var$objToMediaQuery(q, breakpoints, options);
        if (index < query.length - 1) {
            if (q !== 'and' && query[index + 1] !== 'and') acc += ',';
            acc += ' ';
        }
        return acc;
    }, '');
    return $ccaa0a2f61c56410$var$objToMediaQuery(query, breakpoints, options);
}
function $ccaa0a2f61c56410$var$objToMediaQuery(obj, breakpoints = null, options) {
    if (typeof obj === 'string') return obj;
    let hasNot = false;
    let query = Object.keys(obj).reduce((acc, feature)=>{
        let value = obj[feature];
        feature = (0, $11741836d1790446$export$73bda83cddbc7187)(feature);
        if (feature === 'not') {
            hasNot = true;
            return acc;
        }
        if (feature === 'monochrome') feature = `(${feature})`;
        if (feature === 'min' || feature === 'max') feature = `${feature}-width`;
        if (typeof value === 'number' && /[height|width]$/.test(feature)) value = value + 'em';
        if (value === true) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, feature);
        else if (value === false) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, 'not ' + feature);
        else {
            value = $ccaa0a2f61c56410$var$getValueByFeature(value, breakpoints);
            if (typeof value !== 'undefined') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, `(${feature}: ${value})`);
        }
        return acc;
    }, []);
    if (Array.isArray(query)) query = query.length > 0 ? query.join(' and ') : query.join('');
    if (hasNot) query = $ccaa0a2f61c56410$var$reverseQuery(query);
    if (options?.correctRange && /\(min-width: [0-9]+em\)/.test(query)) {
        const size = parseFloat(query.match(/\(min-width: ([0-9]+)em\)/)[1]) || 0;
        if (size > 0) {
            const correctedSize = (size * 16 + 0.1) / 16;
            query = query.replace(/(min-width: [0-9]+em)/, `min-width: ${correctedSize}em`);
        }
    }
    return query;
}
function $ccaa0a2f61c56410$var$getValueByFeature(value, types = null) {
    types = types || $ccaa0a2f61c56410$export$f44bcf56d375ea05;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(types, value)) value = types[value];
    return value;
}



"use client";
function $b06e42c9bd29b5a4$export$2e2bcd8739ae039(props) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const { query: query, when: when, not: not, matchOnSSR: matchOnSSR, disabled: disabled, correctRange: correctRange = true, log: log } = props;
    const matches = (0, $ieaan.useMemo)(()=>{
        if (disabled) return false;
        return matchOnSSR && !(0, $ccaa0a2f61c56410$export$26316165d3b380c8)();
    }, [
        disabled,
        matchOnSSR
    ]);
    const mediaQueryList = (0, $ieaan.useRef)((0, $ccaa0a2f61c56410$export$e57d90d0ec36fcbc)({
        query: query,
        when: when,
        not: not
    }, context.breakpoints, {
        disabled: disabled,
        correctRange: correctRange,
        log: log
    }));
    const [match, matchUpdate] = (0, $ieaan.useState)(matches);
    const listenerRef = (0, $ieaan.useRef)(undefined);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (disabled) return undefined;
        if (typeof listenerRef.current === 'function') listenerRef.current();
        mediaQueryList.current = (0, $ccaa0a2f61c56410$export$e57d90d0ec36fcbc)({
            query: query,
            when: when,
            not: not
        }, context.breakpoints, {
            disabled: disabled,
            correctRange: correctRange,
            log: log
        });
        if (mediaQueryList.current) matchUpdate(mediaQueryList.current.matches);
        listenerRef.current = (0, $ccaa0a2f61c56410$export$1946718a333328e0)(mediaQueryList.current, (match)=>matchUpdate(match));
        return listenerRef.current;
    }, [
        query,
        when,
        not,
        disabled
    ]);
    return Boolean(match);
}




"use client";
function $db09087c4569f84b$export$2e2bcd8739ae039(themeProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const { children: children, element: element, name: name, variant: variant, size: size, contrastMode: contrastMode, colorScheme: colorScheme, surface: surface, ...restProps } = themeProps;
    const prefersDarkColorScheme = (0, $b06e42c9bd29b5a4$export$2e2bcd8739ae039)({
        query: '(prefers-color-scheme: dark)',
        disabled: colorScheme !== 'auto'
    });
    const activeColorScheme = colorScheme === 'auto' ? globalThis.__eufemiaColorScheme || (prefersDarkColorScheme ? 'dark' : 'light') : colorScheme;
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        delete globalThis.__eufemiaColorScheme;
    }, []);
    const theme = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)({
        name: name,
        variant: variant,
        size: size,
        contrastMode: contrastMode,
        colorScheme: activeColorScheme,
        surface: surface
    }, null, context?.theme);
    if (surface === 'initial') theme.surface = undefined;
    const isNestedColorScheme = Boolean(context?.theme?.colorScheme);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $8311cfcd13326d81$export$2e2bcd8739ae039), {
        theme: theme,
        children: (0, $60739c7e3f826d8d$exports.jsx)($db09087c4569f84b$export$cf6495336e7980c8, {
            element: element,
            theme: theme,
            isNestedColorScheme: isNestedColorScheme,
            ...restProps,
            children: children
        })
    });
}
$db09087c4569f84b$export$2e2bcd8739ae039.Context = ({ element: element, ...themeProps })=>{
    return (0, $60739c7e3f826d8d$exports.jsx)($db09087c4569f84b$export$2e2bcd8739ae039, {
        ...themeProps,
        element: false
    });
};
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($db09087c4569f84b$export$2e2bcd8739ae039.Context, {
    _supportsSpacingProps: 'passthrough'
});
function $db09087c4569f84b$export$cf6495336e7980c8({ children: children, theme: theme, element: element = null, className: className = null, isNestedColorScheme: isNestedColorScheme = false, ...rest }) {
    const Wrapper = element === false ? (0, $ieaan.Fragment) : element || 'div';
    const ref = (0, $ieaan.useRef)(null);
    $db09087c4569f84b$var$useSyncBodyColorScheme(theme, isNestedColorScheme);
    $db09087c4569f84b$var$useSyncElementColorScheme(ref, theme);
    const classNames = $db09087c4569f84b$export$23c366e92bb8901c(theme, className);
    const { name: name, variant: variant, size: size } = theme;
    if (Wrapper === (0, $ieaan.Fragment)) return children;
    rest['ref'] = ref;
    return (0, $60739c7e3f826d8d$exports.jsx)(Wrapper, {
        "data-name": name,
        "data-variant": variant,
        "data-size": size,
        className: classNames,
        ...rest,
        children: children
    });
}
function $db09087c4569f84b$export$23c366e92bb8901c(theme, className = null) {
    if (!theme) return className;
    const { name: name, variant: variant, size: size, contrastMode: contrastMode, colorScheme: colorScheme } = theme;
    return (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(className, 'eufemia-theme', name && `eufemia-theme__${name}`, name && variant && `eufemia-theme__${name}--${variant}`, contrastMode && 'eufemia-theme__contrast-mode', colorScheme && `eufemia-theme__color-scheme--${colorScheme}`, size && `eufemia-theme__size--${size}`);
}
function $db09087c4569f84b$var$useSyncElementColorScheme(ref, theme) {
    const colorScheme = theme?.colorScheme;
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        const el = ref.current;
        if (!el || !colorScheme) return;
        el.classList.remove('eufemia-theme__color-scheme--light', 'eufemia-theme__color-scheme--dark');
        el.classList.add(`eufemia-theme__color-scheme--${colorScheme}`);
    }, [
        colorScheme
    ]);
}
function $db09087c4569f84b$var$useSyncBodyColorScheme(theme, isNestedColorScheme) {
    const colorScheme = theme?.colorScheme;
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        if (typeof document === 'undefined' || !colorScheme || isNestedColorScheme) return;
        document.body.classList.remove('eufemia-theme__color-scheme--light', 'eufemia-theme__color-scheme--dark');
        document.body.classList.add(`eufemia-theme__color-scheme--${colorScheme}`);
    }, [
        colorScheme,
        isNestedColorScheme
    ]);
}
const $db09087c4569f84b$var$STORAGE_KEY = 'eufemia-theme';
function $db09087c4569f84b$export$89cbf1a0881c8b9c(defaultTheme = 'ui') {
    if (typeof window === 'undefined') return {
        name: defaultTheme
    };
    try {
        const data = window.localStorage.getItem($db09087c4569f84b$var$STORAGE_KEY);
        const theme = (0, (/*@__PURE__*/$parcel$interopDefault($1eb0299e6a3602cd$exports)))(data?.startsWith('{') ? data : '{}');
        const regex = /.*eufemia-theme=([^&]*).*/;
        const query = window.location.search;
        const fromQuery = regex.test(query) && query?.replace(regex, '$1') || null;
        const name = fromQuery || theme?.name || defaultTheme;
        return {
            ...theme,
            name: name
        };
    } catch  {
        return {
            name: defaultTheme
        };
    }
}
function $db09087c4569f84b$export$2e49b867b7a0847c(themeProps, callback) {
    if (typeof window === 'undefined') return;
    try {
        const theme = {
            ...$db09087c4569f84b$export$89cbf1a0881c8b9c(),
            ...themeProps
        };
        window.localStorage.setItem($db09087c4569f84b$var$STORAGE_KEY, JSON.stringify(theme));
        callback?.(theme);
    } catch  {}
}




"use client";
const $3f8ee7b36ba48dd0$var$PortalRootContext = (0, $ieaan.createContext)(null);
function $3f8ee7b36ba48dd0$export$9b67548e25ad0637(props) {
    const { id: id, insideSelector: insideSelector, beforeSelector: beforeSelector, children: children, ...rest } = props;
    const hasRest = Object.keys(rest).length > 0;
    const restKey = hasRest ? JSON.stringify(rest) : '';
    const value = (0, $ieaan.useMemo)(()=>({
            id: id,
            insideSelector: insideSelector,
            beforeSelector: beforeSelector,
            ...hasRest ? {
                portalAttributes: rest
            } : undefined
        }), [
        id,
        insideSelector,
        beforeSelector,
        restKey
    ]);
    return (0, $60739c7e3f826d8d$exports.jsx)($3f8ee7b36ba48dd0$var$PortalRootContext, {
        value: value,
        children: children
    });
}
function $3f8ee7b36ba48dd0$var$PortalRootInstance(props = {}) {
    var _ref;
    const { id: idProp, insideSelector: insideSelectorProp, beforeSelector: beforeSelectorProp, ref: refProp, className: className, style: style, children: children, ...rest } = props;
    const [, forceUpdate] = (0, $ieaan.useReducer)(()=>({}), {});
    const { style: scopeStyle } = (0, $ieaan.useContext)((0, $ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4)) || {};
    const selectorContext = (0, $ieaan.useContext)($3f8ee7b36ba48dd0$var$PortalRootContext);
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const hasPropOverride = typeof insideSelectorProp !== 'undefined' || typeof beforeSelectorProp !== 'undefined';
    const insideSelector = hasPropOverride ? insideSelectorProp : selectorContext?.insideSelector;
    const beforeSelector = hasPropOverride ? beforeSelectorProp : selectorContext?.beforeSelector;
    const effectiveId = (_ref = idProp !== null && idProp !== void 0 ? idProp : selectorContext?.id) !== null && _ref !== void 0 ? _ref : 'eufemia-portal-root';
    const initialElement = (0, $ieaan.useMemo)(()=>{
        if (idProp && typeof document !== 'undefined') return document.getElementById(idProp);
        return $3f8ee7b36ba48dd0$export$19d5eea5285f880d({
            id: effectiveId,
            insideSelector: insideSelector,
            beforeSelector: beforeSelector
        });
    }, [
        effectiveId,
        idProp,
        insideSelector,
        beforeSelector
    ]);
    const localRef = (0, $ieaan.useRef)(initialElement);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (idProp || insideSelector || beforeSelector) {
            const elem = $3f8ee7b36ba48dd0$export$19d5eea5285f880d({
                id: effectiveId,
                insideSelector: insideSelector,
                beforeSelector: beforeSelector
            });
            if (localRef.current !== elem) {
                localRef.current = elem;
                forceUpdate();
            }
        }
        if (refProp && localRef.current) {
            if (typeof refProp === 'function') refProp(localRef.current);
            else {
                const ref = refProp;
                ref.current = localRef.current;
            }
        }
    }, [
        effectiveId,
        idProp,
        refProp,
        insideSelector,
        beforeSelector
    ]);
    const portalElement = localRef.current || initialElement;
    if (!portalElement) return null;
    return (0, $ie2rr.createPortal)((0, $60739c7e3f826d8d$exports.jsx)((0, $ce0e0ed7ebbe2d2a$export$2e2bcd8739ae039), {
        scopeHash: "auto",
        disableCoreStyleWrapper: true,
        uniqueKey: false,
        children: (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-core-style', 'eufemia-portal-root', (0, $db09087c4569f84b$export$23c366e92bb8901c)(context?.theme), className),
            style: {
                ...scopeStyle,
                ...style
            },
            ...selectorContext?.portalAttributes,
            ...rest,
            children: children
        })
    }), portalElement);
}
function $3f8ee7b36ba48dd0$export$19d5eea5285f880d({ id: id, insideSelector: insideSelector, beforeSelector: beforeSelector }) {
    if (typeof document === 'undefined') return null;
    let elem = document.getElementById(id);
    if (!elem) {
        let parent = document.body;
        let referenceNode = document.body.firstChild;
        if (beforeSelector) {
            const target = document.querySelector(beforeSelector);
            if (target && target.parentElement) {
                parent = target.parentElement;
                referenceNode = target;
            }
        } else if (insideSelector) {
            const target = document.querySelector(insideSelector);
            if (target) {
                parent = target;
                referenceNode = target.firstChild;
            }
        }
        elem = document.createElement('div');
        elem.setAttribute('id', id);
        parent.insertBefore(elem, referenceNode);
    }
    if (!elem.hasAttribute('role')) elem.setAttribute('role', 'presentation');
    return elem;
}
function $3f8ee7b36ba48dd0$var$PortalRoot(props) {
    return (0, $60739c7e3f826d8d$exports.jsx)($3f8ee7b36ba48dd0$var$PortalRootInstance, {
        ...props
    });
}
$3f8ee7b36ba48dd0$var$PortalRoot.Provider = $3f8ee7b36ba48dd0$export$9b67548e25ad0637;
var $3f8ee7b36ba48dd0$export$2e2bcd8739ae039 = $3f8ee7b36ba48dd0$var$PortalRoot;


var $5d465b8f84f7d74a$export$2e2bcd8739ae039 = (0, $3f8ee7b36ba48dd0$export$2e2bcd8739ae039);



var $ieaan = parcelRequire("ieaan");
"use client";
const $76e00ffe77c40f50$var$ModalContext = (0, $ieaan.createContext)({
    preventClick: null,
    onKeyDownHandler: null,
    id: null,
    title: null,
    hideCloseButton: null,
    closeButtonAttributes: null,
    closeTitle: null,
    onCloseClickHandler: null,
    contentRef: null,
    scrollRef: null,
    hide: null,
    contentId: null,
    close: null
});
var $76e00ffe77c40f50$export$2e2bcd8739ae039 = $76e00ffe77c40f50$var$ModalContext;



var $ieaan = parcelRequire("ieaan");





"use client";
const $63c1495605c79490$var$isResolvedTargetRefsObject = (target)=>Boolean(target) && typeof target === 'object' && !('getBoundingClientRect' in target) && ('verticalRef' in target || 'horizontalRef' in target);
function $63c1495605c79490$var$PopoverContainer(props) {
    const { baseClassNames: baseClassNames = [
        'dnb-popover'
    ], active: active, showDelay: showDelay = 0, attributes: attributes, arrowPosition: arrowPosition = 'center', placement: placement = 'bottom', alignOnTarget: alignOnTarget, horizontalOffset: horizontalOffset = 0, arrowPositionSelector: arrowPositionSelector, hideDelay: hideDelay = 0, fixedPosition: fixedPosition, keepInDOM: keepInDOMProp, noAnimation: noAnimation, skipPortal: skipPortal, contentRef: contentRef, children: children, targetElement: targetElement, triggerOffset: triggerOffsetProp = 0, autoAlignMode: autoAlignMode = 'initial', autoAlignViewportThreshold: autoAlignViewportThreshold, hideArrow: hideArrow = false, arrowEdgeOffset: arrowEdgeOffset, targetRefreshKey: targetRefreshKey } = props;
    const [style, setStyle] = (0, $ieaan.useState)(null);
    const [arrowStyle, setArrowStyle] = (0, $ieaan.useState)(null);
    const [resolvedPlacement, setResolvedPlacement] = (0, $ieaan.useState)(placement);
    const [wasActive, setWasActive] = (0, $ieaan.useState)(active);
    const [delayedActive, setDelayedActive] = (0, $ieaan.useState)(false);
    const showDelayTimeout = (0, $ieaan.useRef)(undefined);
    const isActive = delayedActive;
    const [isInDOM, setIsInDOM] = (0, $ieaan.useState)(()=>keepInDOMProp || active);
    const offset = (0, $ieaan.useRef)(triggerOffsetProp);
    const domTimeout = (0, $ieaan.useRef)(undefined);
    const clearDomTimeout = ()=>{
        clearTimeout(domTimeout.current);
    };
    (0, $ieaan.useEffect)(()=>{
        offset.current = triggerOffsetProp;
    }, [
        triggerOffsetProp
    ]);
    const debounceTimeout = (0, $ieaan.useRef)(undefined);
    const resizeObserver = (0, $ieaan.useRef)(null);
    const tmpRef = (0, $ieaan.useRef)(null);
    const elementRef = contentRef && 'current' in contentRef ? contentRef : tmpRef;
    const scrollViewElementRef = (0, $ieaan.useRef)(null);
    const resolvedTargetRef = (0, $ieaan.useRef)(null);
    const autoAlignInitialUsedRef = (0, $ieaan.useRef)(false);
    const prevIsActiveRef = (0, $ieaan.useRef)(false);
    const clearTimers = ()=>{
        clearTimeout(debounceTimeout.current);
    };
    const clearShowDelay = ()=>{
        clearTimeout(showDelayTimeout.current);
    };
    (0, $ieaan.useEffect)(()=>clearShowDelay, []);
    (0, $ieaan.useEffect)(()=>{
        if (active) {
            const run = ()=>{
                setDelayedActive(true);
                setWasActive(true);
            };
            if (noAnimation || globalThis.IS_TEST) {
                clearShowDelay();
                run();
                return undefined;
            }
            const delay = Math.max(0, parseFloat(String(showDelay)) || 0);
            if (delay === 0) {
                clearShowDelay();
                run();
                return undefined;
            }
            clearShowDelay();
            showDelayTimeout.current = setTimeout(run, delay);
            return undefined;
        }
        clearShowDelay();
        setDelayedActive(false);
    }, [
        active,
        noAnimation,
        showDelay
    ]);
    (0, $ieaan.useEffect)(()=>{
        clearDomTimeout();
        if (active) {
            setIsInDOM(true);
            return clearDomTimeout;
        }
        if (keepInDOMProp) return clearDomTimeout;
        if (noAnimation || globalThis.IS_TEST) {
            setIsInDOM(false);
            return clearDomTimeout;
        }
        const delay = Math.max(0, parseFloat(String(hideDelay)) || 0);
        domTimeout.current = setTimeout(()=>{
            setIsInDOM(false);
        }, delay + 300);
        return clearDomTimeout;
    }, [
        active,
        hideDelay,
        keepInDOMProp,
        noAnimation
    ]);
    const getBodySize = (0, $ieaan.useCallback)(()=>{
        if (!isActive || typeof document === 'undefined') return 1;
        const { width: width, height: height } = document.body.getBoundingClientRect();
        return width + height;
    }, [
        isActive
    ]);
    const [renewStyles, triggerRecalculation] = (0, $ieaan.useState)(getBodySize);
    const requestRecalculation = (0, $ieaan.useCallback)(()=>{
        triggerRecalculation((value)=>value + 1);
    }, [
        triggerRecalculation
    ]);
    const handleViewportResize = (0, $ieaan.useCallback)(()=>{
        triggerRecalculation(getBodySize());
    }, [
        getBodySize
    ]);
    const addPositionObserver = (0, $ieaan.useCallback)(()=>{
        if (resizeObserver.current || typeof document === 'undefined') return undefined;
        try {
            resizeObserver.current = new ResizeObserver(()=>{
                clearTimers();
                debounceTimeout.current = setTimeout(()=>triggerRecalculation(getBodySize()), 100);
            });
            resizeObserver.current.observe(document.body);
        } catch (e) {}
    }, [
        getBodySize
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        const removePositionObserver = ()=>{
            clearTimers();
            resizeObserver.current?.disconnect();
        };
        const hasJustActivated = isActive && !prevIsActiveRef.current;
        prevIsActiveRef.current = isActive;
        if (hasJustActivated) autoAlignInitialUsedRef.current = false;
        if (isActive) {
            setWasActive(true);
            addPositionObserver();
        } else if (wasActive) removePositionObserver();
        return removePositionObserver;
    }, [
        addPositionObserver,
        isActive,
        wasActive
    ]);
    const offsetLeft = (0, $ieaan.useRef)(0);
    const offsetTop = (0, $ieaan.useRef)(0);
    (0, $ieaan.useEffect)(()=>{
        setResolvedPlacement(placement);
    }, [
        placement
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (isActive) requestRecalculation();
    }, [
        children,
        isActive,
        requestRecalculation
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (typeof window === 'undefined') return undefined;
        window.addEventListener('resize', handleViewportResize);
        return ()=>window.removeEventListener('resize', handleViewportResize);
    }, [
        handleViewportResize
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        if (typeof document === 'undefined') return undefined;
        if (!isActive) return undefined;
        const handleScroll = (event)=>{
            const targetNode = event.target;
            const scrollViewElement = scrollViewElementRef.current;
            const resolvedTarget = resolvedTargetRef.current;
            if (scrollViewElement && resolvedTarget && typeof resolvedTarget.getBoundingClientRect === 'function' && scrollViewElement.contains(targetNode)) {
                const scrollRect = scrollViewElement.getBoundingClientRect();
                const targetRect = resolvedTarget.getBoundingClientRect();
                const isVisible = targetRect.bottom >= scrollRect.top && targetRect.top <= scrollRect.bottom;
                if (!isVisible) return undefined;
            }
            requestRecalculation();
        };
        document.addEventListener('scroll', handleScroll, true);
        return ()=>{
            document.removeEventListener('scroll', handleScroll, true);
        };
    }, [
        isActive,
        requestRecalculation
    ]);
    (0, $02a20abffd0fc9f2$export$700979bc83e7db82)(()=>{
        var _ref, _resolvedRefs$horizon, _ref2, _resolvedRefs$vertica, _ref3, _ref4, _ref5;
        if (!isActive && renewStyles) {
            if (wasActive) {
                clearTimers();
                debounceTimeout.current = setTimeout(()=>{
                    setStyle(null);
                }, hideDelay + 200);
            }
            return undefined;
        }
        const element = elementRef?.current;
        if (typeof window === 'undefined' || !element) return undefined;
        const resolvedRefs = $63c1495605c79490$var$isResolvedTargetRefsObject(targetElement) ? targetElement : null;
        const horizontalTarget = (_ref = (_resolvedRefs$horizon = resolvedRefs?.horizontalRef) !== null && _resolvedRefs$horizon !== void 0 ? _resolvedRefs$horizon : resolvedRefs?.verticalRef) !== null && _ref !== void 0 ? _ref : targetElement;
        const verticalTarget = (_ref2 = (_resolvedRefs$vertica = resolvedRefs?.verticalRef) !== null && _resolvedRefs$vertica !== void 0 ? _resolvedRefs$vertica : resolvedRefs?.horizontalRef) !== null && _ref2 !== void 0 ? _ref2 : targetElement;
        const effectiveHorizontalTarget = (_ref3 = horizontalTarget !== null && horizontalTarget !== void 0 ? horizontalTarget : verticalTarget) !== null && _ref3 !== void 0 ? _ref3 : null;
        const effectiveVerticalTarget = (_ref4 = verticalTarget !== null && verticalTarget !== void 0 ? verticalTarget : horizontalTarget) !== null && _ref4 !== void 0 ? _ref4 : null;
        const primaryTarget = (_ref5 = effectiveHorizontalTarget !== null && effectiveHorizontalTarget !== void 0 ? effectiveHorizontalTarget : effectiveVerticalTarget) !== null && _ref5 !== void 0 ? _ref5 : null;
        scrollViewElementRef.current = primaryTarget ? (0, $11741836d1790446$export$6857ec1aec960893)(primaryTarget) : null;
        resolvedTargetRef.current = primaryTarget;
        if (!effectiveHorizontalTarget?.getBoundingClientRect || !effectiveVerticalTarget?.getBoundingClientRect) return undefined;
        const elementWidth = element.offsetWidth;
        const elementHeight = element.offsetHeight;
        const horizontalRect = effectiveHorizontalTarget.getBoundingClientRect();
        const verticalRect = effectiveVerticalTarget.getBoundingClientRect();
        const scrollViewElement = scrollViewElementRef.current;
        const scrollViewRect = scrollViewElement && typeof scrollViewElement.getBoundingClientRect === 'function' ? scrollViewElement.getBoundingClientRect() : null;
        const horizontalTargetSize = {
            width: horizontalRect.width || effectiveHorizontalTarget.offsetWidth,
            height: horizontalRect.height || effectiveHorizontalTarget.offsetHeight
        };
        const verticalTargetSize = {
            width: verticalRect.width || effectiveVerticalTarget.offsetWidth,
            height: verticalRect.height || effectiveVerticalTarget.offsetHeight
        };
        const targetBodySize = {
            width: horizontalTargetSize.width || verticalTargetSize.width,
            height: verticalTargetSize.height || horizontalTargetSize.height
        };
        if (skipPortal && (!offsetLeft.current || !offsetTop.current)) {
            offsetLeft.current = (0, $deeefef162515a83$export$a6a488ff68b1bf7b)(element) - offset.current;
            offsetTop.current = (0, $deeefef162515a83$export$6fcff0dc60346367)(element) - offset.current;
        }
        const containerRect = skipPortal && element.offsetParent instanceof HTMLElement ? element.offsetParent.getBoundingClientRect() : null;
        const relativeVerticalTop = containerRect ? verticalRect.top - containerRect.top : 0;
        const relativeHorizontalLeft = containerRect ? horizontalRect.left - containerRect.left : 0;
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;
        const scrollYOffset = fixedPosition ? 0 : scrollY;
        const top = skipPortal ? relativeVerticalTop : scrollYOffset + verticalRect.top - offsetTop.current;
        const widthBased = skipPortal ? relativeHorizontalLeft : scrollX + horizontalRect.left;
        const left = skipPortal ? widthBased : widthBased - offsetLeft.current;
        const computedStyle = {};
        const arrowStyle = {
            top: null,
            left: null
        };
        const viewportMargin = 16;
        const shouldReuseResolved = autoAlignMode === 'initial' && autoAlignInitialUsedRef.current;
        let placementKey = shouldReuseResolved ? resolvedPlacement : placement;
        const centerX = left + targetBodySize.width / 2;
        let anchorY = top + targetBodySize.height / 2;
        const isInitialVertical = placementKey === 'top' || placementKey === 'bottom';
        const alignOffset = alignOnTarget === 'left' ? -targetBodySize.width / 2 : alignOnTarget === 'right' ? targetBodySize.width / 2 : 0;
        let anchorX = centerX + (isInitialVertical ? alignOffset : 0);
        if (arrowPositionSelector) {
            var _alignmentRoot$ownerD;
            const matchesSelector = (element)=>{
                if (!element || typeof element.matches !== 'function') return false;
                try {
                    return element.matches(arrowPositionSelector);
                } catch (_error) {
                    return false;
                }
            };
            const queryWithin = (root)=>{
                if (!root || typeof root.querySelector !== 'function') return null;
                try {
                    return root.querySelector(arrowPositionSelector);
                } catch (_error) {
                    return null;
                }
            };
            const alignmentRoot = isInitialVertical ? effectiveHorizontalTarget : effectiveVerticalTarget;
            const ownerDocument = (_alignmentRoot$ownerD = alignmentRoot?.ownerDocument) !== null && _alignmentRoot$ownerD !== void 0 ? _alignmentRoot$ownerD : typeof document !== 'undefined' ? document : null;
            const alignmentElement = (matchesSelector(alignmentRoot) ? alignmentRoot : null) || queryWithin(alignmentRoot) || queryWithin(ownerDocument);
            if (alignmentElement?.getBoundingClientRect) {
                const alignmentRect = alignmentElement.getBoundingClientRect();
                if (isInitialVertical) anchorX = scrollX + alignmentRect.left + alignmentRect.width / 2 - offsetLeft.current;
                else anchorY = scrollYOffset + alignmentRect.top + alignmentRect.height / 2 - offsetTop.current;
            }
        }
        const placements = {
            left: ()=>({
                    left: left - elementWidth - offset.current + horizontalOffset,
                    top: anchorY - elementHeight / 2
                }),
            right: ()=>({
                    left: left + targetBodySize.width + offset.current + horizontalOffset,
                    top: anchorY - elementHeight / 2
                }),
            top: ()=>({
                    left: anchorX - elementWidth / 2 + horizontalOffset,
                    top: top - elementHeight - offset.current
                }),
            bottom: ()=>({
                    left: anchorX - elementWidth / 2 + horizontalOffset,
                    top: top + targetBodySize.height + offset.current
                })
        };
        const getPlacement = (key)=>{
            const resolver = placements[key] || placements.bottom;
            return resolver();
        };
        const topPlacement = getPlacement('top');
        const bottomPlacement = getPlacement('bottom');
        let { left: nextLeft, top: nextTop } = getPlacement(placementKey);
        const initialAutoAlignAllowed = autoAlignMode === 'initial' && !autoAlignInitialUsedRef.current;
        const allowAutoAlign = autoAlignMode === 'never' ? false : autoAlignMode === 'initial' ? initialAutoAlignAllowed : true;
        if (initialAutoAlignAllowed) autoAlignInitialUsedRef.current = true;
        if (typeof window !== 'undefined' && allowAutoAlign && (placementKey === 'top' || placementKey === 'bottom')) {
            const clampedViewportThreshold = typeof autoAlignViewportThreshold === 'number' ? Math.min(Math.max(autoAlignViewportThreshold, 0), 1) : null;
            const viewportTopEdge = scrollYOffset + viewportMargin;
            const viewportBottomEdge = scrollYOffset + window.innerHeight - viewportMargin;
            const canFlipFromBottom = clampedViewportThreshold === null || verticalRect.top >= window.innerHeight * clampedViewportThreshold;
            const canFlipFromTop = clampedViewportThreshold === null || verticalRect.bottom <= window.innerHeight * (1 - clampedViewportThreshold);
            const fitsTop = topPlacement.top >= viewportTopEdge;
            const fitsBottom = bottomPlacement.top + elementHeight <= viewportBottomEdge;
            if (placementKey === 'bottom' && !fitsBottom && fitsTop && canFlipFromBottom) {
                placementKey = 'top';
                nextLeft = topPlacement.left;
                nextTop = topPlacement.top;
            } else if (placementKey === 'top' && !fitsTop && fitsBottom && canFlipFromTop) {
                placementKey = 'bottom';
                nextLeft = bottomPlacement.left;
                nextTop = bottomPlacement.top;
            } else if (!fitsTop && !fitsBottom) {
                if (placementKey === 'bottom' && !canFlipFromBottom) {
                    placementKey = 'bottom';
                    nextLeft = bottomPlacement.left;
                    nextTop = bottomPlacement.top;
                } else if (placementKey === 'top' && !canFlipFromTop) {
                    placementKey = 'top';
                    nextLeft = topPlacement.left;
                    nextTop = topPlacement.top;
                } else {
                    const topInvalid = topPlacement.top < 0;
                    if (topInvalid) {
                        placementKey = 'bottom';
                        nextLeft = bottomPlacement.left;
                        nextTop = bottomPlacement.top;
                    } else {
                        const getVisibleHeight = (y)=>{
                            const top = y;
                            const bottom = y + elementHeight;
                            const visibleTop = Math.max(top, viewportTopEdge);
                            const visibleBottom = Math.min(bottom, viewportBottomEdge);
                            return Math.max(0, visibleBottom - visibleTop);
                        };
                        const topVisible = getVisibleHeight(topPlacement.top);
                        const bottomVisible = getVisibleHeight(bottomPlacement.top);
                        if (topVisible > bottomVisible) {
                            placementKey = 'top';
                            nextLeft = topPlacement.left;
                            nextTop = topPlacement.top;
                        } else {
                            placementKey = 'bottom';
                            nextLeft = bottomPlacement.left;
                            nextTop = bottomPlacement.top;
                        }
                    }
                }
            }
        }
        const isVerticalPlacement = placementKey === 'top' || placementKey === 'bottom';
        const arrowOffset = arrowEdgeOffset !== null && arrowEdgeOffset !== void 0 ? arrowEdgeOffset : 16;
        const arrowPositions = {
            left: ()=>({
                    left: centerX - offset.current + alignOffset + horizontalOffset - arrowOffset
                }),
            right: ()=>({
                    left: centerX - elementWidth + offset.current + alignOffset + horizontalOffset + arrowOffset
                }),
            top: ()=>({
                    top: anchorY - offset.current - arrowOffset
                }),
            bottom: ()=>({
                    top: anchorY - elementHeight + offset.current + arrowOffset
                })
        };
        const shouldOverrideHorizontal = isVerticalPlacement && (arrowPosition === 'left' || arrowPosition === 'right');
        const shouldOverrideVertical = !isVerticalPlacement && (arrowPosition === 'top' || arrowPosition === 'bottom');
        const arrowOverride = (shouldOverrideHorizontal || shouldOverrideVertical) && arrowPositions[arrowPosition];
        if (arrowOverride) {
            const overrides = arrowOverride();
            if ('left' in overrides) nextLeft = overrides.left;
            if ('top' in overrides) nextTop = overrides.top;
        } else nextLeft += horizontalOffset;
        const edgeSpacing = arrowEdgeOffset !== null && arrowEdgeOffset !== void 0 ? arrowEdgeOffset : 8;
        const arrowHugsEdge = isVerticalPlacement && (arrowPosition === 'left' || arrowPosition === 'right');
        if (arrowHugsEdge) nextLeft += arrowPosition === 'left' ? -edgeSpacing : edgeSpacing;
        const clampTopWithinScrollView = (value)=>{
            if (!scrollViewRect) return value;
            const minTop = scrollViewRect.top + scrollYOffset - elementHeight;
            const maxTop = scrollViewRect.bottom + scrollYOffset;
            if (maxTop < minTop) return minTop;
            return Math.min(Math.max(value, minTop), maxTop);
        };
        nextTop = clampTopWithinScrollView(nextTop);
        const lacksLayout = !elementWidth && !elementHeight && !targetBodySize.width && !targetBodySize.height;
        if (lacksLayout) {
            if (typeof computedStyle.left === 'undefined') computedStyle.left = 0;
            if (typeof computedStyle.top === 'undefined') computedStyle.top = 0;
            setStyle(computedStyle);
            setArrowStyle(arrowStyle);
            return;
        }
        const computedElementStyle = typeof window !== 'undefined' && element ? window.getComputedStyle(element) : null;
        const marginLeft = computedElementStyle ? parseFloat(computedElementStyle.marginLeft) || 0 : 0;
        const marginRight = computedElementStyle ? parseFloat(computedElementStyle.marginRight) || 0 : 0;
        const rawBorderRadius = computedElementStyle ? parseFloat(computedElementStyle.borderRadius) || 0 : 0;
        const borderRadius = Math.min(rawBorderRadius, elementWidth / 2, elementHeight / 2);
        let actualLeft = nextLeft;
        if (!skipPortal) {
            const elementWidthWithMargins = elementWidth + marginRight;
            const rightBoundary = window.innerWidth - viewportMargin;
            const actualRight = actualLeft + elementWidthWithMargins;
            if (actualRight > rightBoundary) {
                const allowedLeft = rightBoundary - elementWidthWithMargins;
                actualLeft = Math.max(viewportMargin, allowedLeft);
            }
            if (actualLeft < viewportMargin) actualLeft = viewportMargin;
            computedStyle.left = actualLeft - marginLeft;
        } else computedStyle.left = nextLeft - marginLeft;
        computedStyle.top = nextTop;
        const actualTop = nextTop;
        if (isVerticalPlacement) {
            const arrowWidth = 16;
            const arrowBoundary = Math.max(arrowEdgeOffset !== null && arrowEdgeOffset !== void 0 ? arrowEdgeOffset : 8, borderRadius);
            const maxLeft = Math.max(0, elementWidth - arrowWidth);
            const arrowLeft = anchorX - actualLeft - arrowWidth / 2;
            const arrowMin = Math.min(maxLeft, arrowBoundary);
            const arrowMax = Math.max(arrowMin, Math.max(0, maxLeft - arrowBoundary));
            let arrowClampMin = arrowMin;
            let arrowClampMax = arrowMax;
            if (scrollViewRect) {
                const scrollMin = scrollViewRect.left + scrollX - actualLeft;
                const scrollMax = scrollViewRect.right + scrollX - actualLeft - arrowWidth;
                arrowClampMin = Math.max(arrowClampMin, scrollMin);
                arrowClampMax = Math.min(arrowClampMax, scrollMax);
            }
            if (arrowClampMax < arrowClampMin) arrowClampMax = arrowClampMin;
            let nextArrowLeft = arrowLeft;
            if (nextArrowLeft < arrowClampMin) nextArrowLeft = arrowClampMin;
            else if (nextArrowLeft > arrowClampMax) nextArrowLeft = arrowClampMax;
            arrowStyle.left = nextArrowLeft;
        } else {
            const arrowHeight = 16;
            const arrowBoundary = Math.max(arrowEdgeOffset !== null && arrowEdgeOffset !== void 0 ? arrowEdgeOffset : 8, borderRadius);
            const maxTop = Math.max(0, elementHeight - arrowHeight);
            const arrowTop = anchorY - actualTop - arrowHeight / 2;
            const arrowMin = Math.min(maxTop, arrowBoundary);
            const arrowMax = Math.max(arrowMin, Math.max(0, maxTop - arrowBoundary));
            let arrowClampMin = arrowMin;
            let arrowClampMax = arrowMax;
            if (scrollViewRect) {
                const scrollMin = scrollViewRect.top + scrollYOffset - actualTop;
                const scrollMax = scrollViewRect.bottom + scrollYOffset - actualTop - arrowHeight;
                arrowClampMin = Math.max(arrowClampMin, scrollMin);
                arrowClampMax = Math.min(arrowClampMax, scrollMax);
            }
            if (arrowClampMax < arrowClampMin) arrowClampMax = arrowClampMin;
            let nextArrowTop = arrowTop;
            if (nextArrowTop < arrowClampMin) nextArrowTop = arrowClampMin;
            else if (nextArrowTop > arrowClampMax) nextArrowTop = arrowClampMax;
            arrowStyle.top = nextArrowTop;
        }
        if (resolvedPlacement !== placementKey) setResolvedPlacement(placementKey);
        setStyle(computedStyle);
        setArrowStyle(arrowStyle);
    }, [
        alignOnTarget,
        autoAlignMode,
        arrowPosition,
        horizontalOffset,
        arrowEdgeOffset,
        elementRef,
        fixedPosition,
        hideDelay,
        isActive,
        triggerOffsetProp,
        placement,
        renewStyles,
        skipPortal,
        targetElement,
        targetRefreshKey,
        wasActive,
        arrowPositionSelector,
        resolvedPlacement
    ]);
    const handlePropagation = (0, $ieaan.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const shouldRender = isInDOM || keepInDOMProp;
    const mergedStyle = {
        ...style || {},
        ...attributes?.style || {}
    };
    const hasPlacement = Boolean(style) && typeof style.left !== 'undefined' && typeof style.top !== 'undefined';
    const containerStyle = !hasPlacement && (active || isActive) && typeof mergedStyle.visibility === 'undefined' ? {
        ...mergedStyle,
        visibility: 'hidden'
    } : mergedStyle;
    if (!shouldRender) return null;
    const noAnimationClasses = noAnimation ? baseClassNames.map((base)=>`${base}--no-animation`) : null;
    const fixedClasses = fixedPosition ? baseClassNames.map((base)=>`${base}--fixed`) : null;
    const activeClasses = isActive ? baseClassNames.map((base)=>`${base}--active`) : null;
    const hideClasses = !isActive && wasActive ? baseClassNames.map((base)=>`${base}--hide`) : null;
    return (0, $60739c7e3f826d8d$exports.jsxs)("span", {
        ref: elementRef,
        ...attributes,
        onMouseMove: handlePropagation,
        onMouseDown: handlePropagation,
        onTouchStart: handlePropagation,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(attributes?.className, noAnimationClasses, fixedClasses, activeClasses, hideClasses),
        style: containerStyle,
        children: [
            !hideArrow && (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(baseClassNames.map((base)=>`${base}__arrow`), baseClassNames.map((base)=>`${base}__arrow__arrow--${arrowPosition}`), baseClassNames.map((base)=>`${base}__arrow__placement--${resolvedPlacement}`)),
                style: {
                    ...arrowStyle
                }
            }),
            children
        ]
    });
}
var $63c1495605c79490$export$2e2bcd8739ae039 = $63c1495605c79490$var$PopoverContainer;



"use client";
let $84bb03d700bdd73e$var$popoverPortal;
if (typeof globalThis !== 'undefined') {
    globalThis.popoverPortal = globalThis.popoverPortal || {};
    $84bb03d700bdd73e$var$popoverPortal = globalThis.popoverPortal;
} else $84bb03d700bdd73e$var$popoverPortal = {};
function $84bb03d700bdd73e$var$PopoverPortal(props) {
    const { baseClassNames: baseClassNames = [
        'dnb-popover'
    ], active: active, targetElement: targetElement, showDelay: showDelay, hideDelay: hideDelay, keepInDOM: keepInDOM, noAnimation: noAnimation, portalRootClass: portalRootClass, children: children, attributes: attributes, arrowPosition: arrowPosition, placement: placement, alignOnTarget: alignOnTarget, horizontalOffset: horizontalOffset, arrowPositionSelector: arrowPositionSelector, fixedPosition: fixedPosition, contentRef: contentRef, triggerOffset: triggerOffset, autoAlignMode: autoAlignMode, autoAlignViewportThreshold: autoAlignViewportThreshold, hideArrow: hideArrow, arrowEdgeOffset: arrowEdgeOffset, targetRefreshKey: targetRefreshKey } = props;
    const id = (0, $89089e429f32bd45$export$2e2bcd8739ae039)();
    const modalContext = (0, $ieaan.useContext)((0, $76e00ffe77c40f50$export$2e2bcd8739ae039));
    const { isActive: portalActive, shouldRenderPortal: shouldRenderPortal } = $84bb03d700bdd73e$var$usePopoverPortalLifecycle({
        id: id,
        active: active,
        hideDelay: hideDelay,
        keepInDOM: keepInDOM,
        noAnimation: noAnimation
    });
    if (!shouldRenderPortal) return null;
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $5d465b8f84f7d74a$export$2e2bcd8739ae039), {
        children: (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(baseClassNames.map((base)=>`${base}__portal`), portalRootClass, modalContext?.id && baseClassNames.map((base)=>`${base}--inside-modal`)),
            children: (0, $60739c7e3f826d8d$exports.jsx)((0, $63c1495605c79490$export$2e2bcd8739ae039), {
                baseClassNames: baseClassNames,
                active: portalActive,
                targetElement: targetElement || null,
                showDelay: showDelay,
                hideDelay: hideDelay,
                keepInDOM: keepInDOM,
                noAnimation: noAnimation,
                arrowPosition: arrowPosition,
                placement: placement,
                alignOnTarget: alignOnTarget,
                horizontalOffset: horizontalOffset,
                arrowPositionSelector: arrowPositionSelector,
                fixedPosition: fixedPosition,
                attributes: attributes,
                contentRef: contentRef,
                triggerOffset: triggerOffset,
                autoAlignMode: autoAlignMode,
                autoAlignViewportThreshold: autoAlignViewportThreshold,
                hideArrow: hideArrow,
                arrowEdgeOffset: arrowEdgeOffset,
                targetRefreshKey: targetRefreshKey,
                children: children
            })
        })
    });
}
var $84bb03d700bdd73e$export$2e2bcd8739ae039 = $84bb03d700bdd73e$var$PopoverPortal;
function $84bb03d700bdd73e$var$usePopoverPortalLifecycle({ id: id, active: active, hideDelay: hideDelay, keepInDOM: keepInDOM, noAnimation: noAnimation }) {
    const [isActive, setIsActive] = (0, $ieaan.useState)(active);
    const [isInDOM, setIsInDOM] = (0, $ieaan.useState)(()=>keepInDOM || active);
    const isMountedRef = (0, $628cfc5c68413f65$export$2e2bcd8739ae039)();
    const ensurePortalEntry = (0, $ieaan.useCallback)(()=>{
        if (!$84bb03d700bdd73e$var$popoverPortal[id]) $84bb03d700bdd73e$var$popoverPortal[id] = {
            count: 0
        };
        return $84bb03d700bdd73e$var$popoverPortal[id];
    }, [
        id
    ]);
    const clearTimers = (0, $ieaan.useCallback)(()=>{
        const entry = $84bb03d700bdd73e$var$popoverPortal[id];
        if (entry) {
            clearTimeout(entry.delayTimeout);
            clearTimeout(entry.hiddenTimeout);
        }
    }, [
        id
    ]);
    (0, $ieaan.useEffect)(()=>{
        const entry = ensurePortalEntry();
        if (active) {
            clearTimers();
            setIsActive(true);
            setIsInDOM(true);
            if (!isMountedRef.current) entry.count++;
            return ()=>{
                clearTimers();
            };
        }
        if (keepInDOM) {
            clearTimers();
            setIsActive(false);
            setIsInDOM(true);
            return ()=>{
                clearTimers();
            };
        }
        if (!isMountedRef.current) return ()=>{
            clearTimers();
        };
        const delayRender = ()=>setIsActive(false);
        const delayHidden = ()=>{
            setIsInDOM(false);
        };
        if (noAnimation || globalThis.IS_TEST) {
            delayRender();
            delayHidden();
            return ()=>{
                clearTimers();
            };
        }
        const delay = parseFloat(String(hideDelay));
        entry.delayTimeout = setTimeout(delayRender, delay);
        entry.hiddenTimeout = setTimeout(delayHidden, delay + 300);
        return ()=>{
            clearTimers();
        };
    }, [
        active,
        clearTimers,
        ensurePortalEntry,
        hideDelay,
        isMountedRef,
        keepInDOM,
        noAnimation
    ]);
    (0, $9738f50fda5b2f16$export$2e2bcd8739ae039)(()=>{
        if (keepInDOM) ensurePortalEntry();
    });
    return {
        isActive: isActive,
        shouldRenderPortal: isInDOM || keepInDOM
    };
}





"use client";
function $157ea48181af41f6$export$2e2bcd8739ae039(props) {
    var _closeButtonProps$var, _closeButtonProps$ico;
    const { children: children, content: content, trigger: trigger, triggerProps: triggerPropsProp, triggerAttributes: triggerAttributesProp, triggerClassName: triggerClassName, title: title, placement: placement = 'bottom', open: controlledOpenProp, openInitially: openInitiallyProp = false, onOpenChange: onOpenChange, focusOnOpen: focusOnOpen = true, focusOnOpenElement: focusOnOpenElement, onFocusComplete: onFocusComplete, restoreFocus: restoreFocus = true, preventClose: preventClose = false, hideCloseButton: hideCloseButton = false, closeButtonProps: closeButtonProps, contentClassName: contentClassName, className: className, baseClassName: baseClassName, disableFocusTrap: disableFocusTrap = false, hideOutline: hideOutline = false, noInnerSpace: noInnerSpace = false, noMaxWidth: noMaxWidth = false, keepInDOM: keepInDOM = false, triggerOffset: triggerOffset, targetElement: externalTargetElement, targetSelector: targetSelector, targetRefreshKey: targetRefreshKey, portalRootClass: portalRootClass, showDelay: showDelayProp, hideDelay: hideDelayProp, contentRef: externalContentRef, alignOnTarget: alignOnTarget = 'center', horizontalOffset: horizontalOffset, autoAlignMode: autoAlignMode = 'initial', autoAlignViewportThreshold: autoAlignViewportThreshold, arrowPosition: arrowPosition = 'center', arrowPositionSelector: arrowPositionSelector, hideArrow: hideArrow = false, skipPortal: skipPortal = false, noAnimation: noAnimation = false, fixedPosition: fixedPosition = false, arrowEdgeOffset: arrowEdgeOffset, id: idProp, omitDescribedBy: omitDescribedBy, ...restAttributes } = props;
    const triggerAttributes = triggerPropsProp || triggerAttributesProp;
    const baseClassNames = (0, $ieaan.useMemo)(()=>{
        const names = [
            'dnb-popover'
        ];
        if (baseClassName && baseClassName !== 'dnb-popover') (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(names).call(names, baseClassName);
        return names;
    }, [
        baseClassName
    ]);
    const tr = (0, $9aa14cee70657571$export$2e2bcd8739ae039)().Popover;
    const { isOpen: isOpen, setOpenState: setOpenState } = $157ea48181af41f6$var$usePopoverOpenState({
        open: controlledOpenProp,
        openInitially: openInitiallyProp,
        onOpenChange: onOpenChange
    });
    const triggerRef = (0, $ieaan.useRef)(null);
    const tooltipRef = (0, $ieaan.useRef)(null);
    const contentWrapperRef = (0, $ieaan.useRef)(null);
    const previousTargetElementRef = (0, $ieaan.useRef)(null);
    const focusRestoreAnimationRef = (0, $ieaan.useRef)(null);
    const touchStartTargetRef = (0, $ieaan.useRef)(null);
    const touchMovedRef = (0, $ieaan.useRef)(false);
    const tooltipId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(idProp);
    const descriptionId = `${tooltipId}-description`;
    const showDelay = showDelayProp !== null && showDelayProp !== void 0 ? showDelayProp : 0;
    const hideDelay = hideDelayProp !== null && hideDelayProp !== void 0 ? hideDelayProp : 0;
    const hasExplicitTargetElement = (0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(props, 'targetElement');
    const shouldRenderTrigger = !hasExplicitTargetElement && typeof targetSelector !== 'string';
    const getCurrentTriggerElement = (0, $ieaan.useCallback)(()=>{
        if (shouldRenderTrigger) return triggerRef.current;
        if ($157ea48181af41f6$var$isPopoverTargetElementObject(externalTargetElement)) return $157ea48181af41f6$var$resolveTargetNode(externalTargetElement.verticalRef) || $157ea48181af41f6$var$resolveTargetNode(externalTargetElement.horizontalRef);
        if (externalTargetElement) return $157ea48181af41f6$var$resolveTargetNode(externalTargetElement);
        if (typeof targetSelector === 'string' && typeof document !== 'undefined') return document.querySelector(targetSelector);
        return null;
    }, [
        externalTargetElement,
        shouldRenderTrigger,
        targetSelector
    ]);
    const [targetElement, setTargetElement] = (0, $ieaan.useState)(null);
    const resolveTargetElementForContainer = (0, $ieaan.useCallback)(()=>{
        if ($157ea48181af41f6$var$isPopoverTargetElementObject(externalTargetElement)) {
            const horizontalRef = $157ea48181af41f6$var$resolveTargetNode(externalTargetElement.horizontalRef);
            const verticalRef = $157ea48181af41f6$var$resolveTargetNode(externalTargetElement.verticalRef);
            return {
                horizontalRef: horizontalRef,
                verticalRef: verticalRef
            };
        }
        if (externalTargetElement) return $157ea48181af41f6$var$resolveTargetNode(externalTargetElement);
        if (typeof targetSelector === 'string' && typeof document !== 'undefined') return document.querySelector(targetSelector);
        if (shouldRenderTrigger) return triggerRef.current;
        return null;
    }, [
        externalTargetElement,
        shouldRenderTrigger,
        targetSelector
    ]);
    (0, $ieaan.useEffect)(()=>{
        const resolved = resolveTargetElementForContainer();
        const hadPreviousTarget = previousTargetElementRef.current !== null;
        const hadValidPreviousTarget = hadPreviousTarget && (previousTargetElementRef.current instanceof HTMLElement || typeof previousTargetElementRef.current === 'object' && previousTargetElementRef.current !== null && ('horizontalRef' in previousTargetElementRef.current || 'verticalRef' in previousTargetElementRef.current));
        previousTargetElementRef.current = resolved;
        setTargetElement(resolved);
        if (!resolved && isOpen && hadValidPreviousTarget) setOpenState(false);
    }, [
        resolveTargetElementForContainer,
        isOpen,
        setOpenState
    ]);
    const resolveFocusTarget = (0, $ieaan.useCallback)(()=>{
        if (!focusOnOpenElement) return null;
        return typeof focusOnOpenElement === 'function' ? focusOnOpenElement() : focusOnOpenElement;
    }, [
        focusOnOpenElement
    ]);
    const focusTrigger = (0, $ieaan.useCallback)(()=>{
        if (!restoreFocus) return undefined;
        const element = getCurrentTriggerElement();
        if (!element || typeof element.focus !== 'function') return undefined;
        if (focusRestoreAnimationRef.current !== null) cancelAnimationFrame(focusRestoreAnimationRef.current);
        focusRestoreAnimationRef.current = requestAnimationFrame(()=>{
            element.focus({
                preventScroll: true
            });
            focusRestoreAnimationRef.current = null;
        });
    }, [
        getCurrentTriggerElement,
        restoreFocus
    ]);
    (0, $ieaan.useEffect)(()=>{
        return ()=>{
            if (focusRestoreAnimationRef.current !== null) cancelAnimationFrame(focusRestoreAnimationRef.current);
        };
    }, []);
    const close = (0, $ieaan.useCallback)(()=>{
        if (preventClose) return undefined;
        setOpenState(false);
        focusTrigger();
    }, [
        focusTrigger,
        setOpenState,
        preventClose
    ]);
    const openPopover = (0, $ieaan.useCallback)(()=>{
        setOpenState(true);
    }, [
        setOpenState
    ]);
    const toggle = (0, $ieaan.useCallback)((next)=>{
        const value = typeof next === 'boolean' ? next : !isOpen;
        if (value) openPopover();
        else close();
    }, [
        close,
        isOpen,
        openPopover
    ]);
    const runTriggerClick = (0, $ieaan.useCallback)((event)=>{
        if (event && 'preventDefault' in event) event.preventDefault();
        toggle();
    }, [
        toggle
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (!focusOnOpen || !isOpen) return undefined;
        const timers = [];
        const focusContent = ()=>{
            const focusTarget = resolveFocusTarget() || contentWrapperRef.current || tooltipRef.current?.querySelector('.dnb-popover__content');
            if (!(focusTarget instanceof HTMLElement)) return false;
            focusTarget.focus({
                preventScroll: true
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(timers).call(timers, setTimeout(()=>{
                if (!tooltipRef.current?.contains(document.activeElement)) focusTarget?.focus({
                    preventScroll: true
                });
                onFocusComplete?.();
            }, 10));
            return true;
        };
        const scheduleFocusAttempt = (delay, retries)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(timers).call(timers, setTimeout(()=>{
                if (!focusContent() && retries > 0) scheduleFocusAttempt(delay, retries - 1);
            }, delay));
        };
        if (!focusContent()) scheduleFocusAttempt(10, 3);
        return ()=>timers.forEach(clearTimeout);
    }, [
        focusOnOpen,
        isOpen,
        resolveFocusTarget,
        onFocusComplete
    ]);
    const handleDocumentInteraction = (0, $ieaan.useCallback)((event, overrideTarget)=>{
        if (preventClose) return undefined;
        const target = overrideTarget !== null && overrideTarget !== void 0 ? overrideTarget : event.target;
        if (!(target instanceof Node)) return undefined;
        if (event instanceof KeyboardEvent && target === document.body) return undefined;
        const insideContent = !!tooltipRef.current && tooltipRef.current.contains(target);
        const triggerElement = getCurrentTriggerElement();
        const insideTrigger = !!triggerElement && typeof triggerElement.contains === 'function' && triggerElement.contains(target);
        const horizontalElement = $157ea48181af41f6$var$isPopoverTargetElementObject(externalTargetElement) ? $157ea48181af41f6$var$resolveTargetNode(externalTargetElement.horizontalRef) : null;
        const insideHorizontal = !!horizontalElement && horizontalElement.contains(target);
        if (!insideContent && !insideTrigger && !insideHorizontal) toggle(false);
    }, [
        preventClose,
        getCurrentTriggerElement,
        toggle,
        externalTargetElement
    ]);
    const handleDocumentTouchStart = (0, $ieaan.useCallback)((event)=>{
        touchMovedRef.current = false;
        touchStartTargetRef.current = event.target;
    }, []);
    const handleDocumentTouchMove = (0, $ieaan.useCallback)(()=>{
        touchMovedRef.current = true;
    }, []);
    const handleDocumentTouchEnd = (0, $ieaan.useCallback)((event)=>{
        const target = touchStartTargetRef.current;
        const moved = touchMovedRef.current;
        touchMovedRef.current = false;
        touchStartTargetRef.current = null;
        if (moved) return undefined;
        handleDocumentInteraction(event, target);
    }, [
        handleDocumentInteraction
    ]);
    const handleDocumentKeyDown = (0, $ieaan.useCallback)((event)=>{
        if (event.defaultPrevented || preventClose) return undefined;
        if (event.key === 'Escape') {
            const target = event.target || document.activeElement;
            const triggerElement = getCurrentTriggerElement();
            const insideTrigger = typeof triggerElement?.contains === 'function' && triggerElement.contains(target);
            const insideContent = tooltipRef.current?.contains(target);
            if (insideContent || insideTrigger) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation?.();
                toggle(false);
            }
        }
    }, [
        preventClose,
        getCurrentTriggerElement,
        toggle
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (!isOpen) return undefined;
        document.documentElement.addEventListener('mousedown', handleDocumentInteraction);
        document.documentElement.addEventListener('touchstart', handleDocumentTouchStart, {
            passive: true
        });
        document.documentElement.addEventListener('touchmove', handleDocumentTouchMove, {
            passive: true
        });
        document.documentElement.addEventListener('touchend', handleDocumentTouchEnd, {
            passive: true
        });
        document.documentElement.addEventListener('keyup', handleDocumentInteraction);
        document.addEventListener('keydown', handleDocumentKeyDown, true);
        return ()=>{
            document.documentElement.removeEventListener('mousedown', handleDocumentInteraction);
            document.documentElement.removeEventListener('touchstart', handleDocumentTouchStart);
            document.documentElement.removeEventListener('touchmove', handleDocumentTouchMove);
            document.documentElement.removeEventListener('touchend', handleDocumentTouchEnd);
            document.documentElement.removeEventListener('keyup', handleDocumentInteraction);
            document.removeEventListener('keydown', handleDocumentKeyDown, true);
        };
    }, [
        handleDocumentInteraction,
        handleDocumentKeyDown,
        handleDocumentTouchEnd,
        handleDocumentTouchMove,
        handleDocumentTouchStart,
        isOpen
    ]);
    const handleTriggerKeyDown = (0, $ieaan.useCallback)((event, userHandler)=>{
        userHandler?.(event);
        if (event.defaultPrevented) return undefined;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
        }
    }, [
        toggle
    ]);
    const mergedTriggerAttributes = triggerAttributes || {};
    const { onClick: triggerOnClick, onKeyDown: triggerOnKeyDown, className: triggerAttrClassName, ref: triggerAttrRef, role: triggerAttrRole, tabIndex: triggerAttrTabIndex, title: triggerAttrTitle, ['aria-describedby']: triggerAttrDescribedBy, ...restTriggerAttrs } = mergedTriggerAttributes;
    const assignTriggerRef = (0, $ieaan.useCallback)((node)=>{
        triggerRef.current = node;
        if (!triggerAttrRef) return undefined;
        if (typeof triggerAttrRef === 'function') triggerAttrRef(node);
        else if ('current' in triggerAttrRef) {
            const mutableTriggerAttrRef = triggerAttrRef;
            mutableTriggerAttrRef.current = node;
        }
    }, [
        triggerAttrRef
    ]);
    const statefulTitle = isOpen ? tr.closeTriggerTitle : tr.openTriggerTitle;
    const triggerDomProps = {
        ...restTriggerAttrs,
        ref: assignTriggerRef,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-popover__trigger', triggerAttrClassName, triggerClassName),
        title: triggerAttrTitle || statefulTitle,
        role: triggerAttrRole || 'button',
        tabIndex: typeof triggerAttrTabIndex === 'number' ? triggerAttrTabIndex : 0,
        'aria-controls': tooltipId,
        'aria-expanded': isOpen,
        'aria-describedby': $157ea48181af41f6$var$mergeDescribedBy(triggerAttrDescribedBy, descriptionId),
        onClick: (event)=>{
            triggerOnClick?.(event);
            if (event.defaultPrevented) return undefined;
            runTriggerClick(event);
        },
        onKeyDown: (event)=>handleTriggerKeyDown(event, triggerOnKeyDown)
    };
    const triggerRenderProps = {
        ...triggerDomProps
    };
    Object.defineProperties(triggerRenderProps, {
        active: {
            value: isOpen,
            enumerable: false
        },
        open: {
            value: openPopover,
            enumerable: false
        },
        close: {
            value: close,
            enumerable: false
        },
        toggle: {
            value: toggle,
            enumerable: false
        }
    });
    let triggerMarkup = null;
    if (shouldRenderTrigger) {
        if ($157ea48181af41f6$var$isRenderer(trigger)) triggerMarkup = trigger(triggerRenderProps);
        else if ((0, $ieaan.isValidElement)(trigger)) triggerMarkup = (0, $ieaan.createElement)(trigger.type, {
            ...trigger.props,
            ...triggerDomProps
        });
        else if (trigger) (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Popover: `trigger` must be a valid React element or render function when not using targetElement/targetSelector.');
        else (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Popover: please provide a `trigger` prop or point to an existing element using `targetElement` / `targetSelector`.');
    }
    const hasInternalTrigger = shouldRenderTrigger && Boolean(triggerMarkup);
    const contentContext = (0, $ieaan.useMemo)(()=>({
            active: isOpen,
            open: openPopover,
            close: close,
            toggle: toggle,
            id: tooltipId
        }), [
        close,
        isOpen,
        openPopover,
        toggle,
        tooltipId
    ]);
    const userContent = (0, $ieaan.useMemo)(()=>{
        const source = typeof content !== 'undefined' ? content : children;
        if ($157ea48181af41f6$var$isRenderer(source)) return source(contentContext);
        return source;
    }, [
        children,
        content,
        contentContext
    ]);
    const closeButton = !hideCloseButton && (0, $60739c7e3f826d8d$exports.jsx)((0, $41765213373873a6$export$2e2bcd8739ae039), {
        variant: (_closeButtonProps$var = closeButtonProps?.variant) !== null && _closeButtonProps$var !== void 0 ? _closeButtonProps$var : 'tertiary',
        icon: (_closeButtonProps$ico = closeButtonProps?.icon) !== null && _closeButtonProps$ico !== void 0 ? _closeButtonProps$ico : 'close',
        ...closeButtonProps,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-popover__close', closeButtonProps?.className),
        title: (0, $11741836d1790446$export$5bfc594bd2dc6e21)(closeButtonProps?.title) || tr.closeButtonTitle,
        onClick: (event)=>{
            closeButtonProps?.onClick?.(event);
            if (event?.defaultPrevented) return undefined;
            toggle(false);
        }
    });
    const popoverClassName = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(baseClassNames, !hideOutline && baseClassNames.map((name)=>`${name}--show-outline`), noInnerSpace && baseClassNames.map((name)=>`${name}--no-inner-space`), noMaxWidth && baseClassNames.map((name)=>`${name}--no-max-width`), className);
    const popoverAttributes = {
        ...restAttributes,
        className: popoverClassName
    };
    const contentRef = externalContentRef || tooltipRef;
    const overlayContent = (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            !disableFocusTrap && (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-sr-only",
                type: "button",
                onFocus: close,
                children: tr.focusTrapTitle
            }),
            (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-popover__content', 'dnb-no-focus', contentClassName),
                id: tooltipId,
                tabIndex: -1,
                ref: contentWrapperRef,
                children: [
                    title && (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-popover__title",
                        children: (0, $60739c7e3f826d8d$exports.jsx)("strong", {
                            className: "dnb-h--basis",
                            children: title
                        })
                    }),
                    (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-popover__body",
                        children: userContent
                    })
                ]
            }),
            closeButton,
            !disableFocusTrap && (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-sr-only",
                type: "button",
                onFocus: close,
                children: tr.focusTrapTitle
            })
        ]
    });
    if (targetElement === null) return triggerMarkup;
    const PopoverElement = skipPortal ? (0, $63c1495605c79490$export$2e2bcd8739ae039) : (0, $84bb03d700bdd73e$export$2e2bcd8739ae039);
    return (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            triggerMarkup,
            hasInternalTrigger && (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-sr-only",
                "aria-hidden": "true",
                id: descriptionId,
                children: statefulTitle
            }),
            (0, $60739c7e3f826d8d$exports.jsx)(PopoverElement, {
                baseClassNames: baseClassNames,
                active: isOpen,
                showDelay: showDelay,
                attributes: popoverAttributes,
                targetElement: targetElement,
                hideDelay: hideDelay,
                keepInDOM: keepInDOM,
                autoAlignMode: autoAlignMode,
                autoAlignViewportThreshold: autoAlignViewportThreshold,
                noAnimation: noAnimation,
                arrowPosition: arrowPosition,
                placement: placement,
                alignOnTarget: alignOnTarget,
                horizontalOffset: horizontalOffset,
                arrowPositionSelector: arrowPositionSelector,
                fixedPosition: fixedPosition,
                skipPortal: skipPortal,
                ...!skipPortal && {
                    portalRootClass: portalRootClass
                },
                contentRef: contentRef,
                triggerOffset: triggerOffset,
                hideArrow: hideArrow,
                arrowEdgeOffset: arrowEdgeOffset,
                targetRefreshKey: targetRefreshKey,
                children: overlayContent
            })
        ]
    });
}
function $157ea48181af41f6$var$usePopoverOpenState({ open: open, openInitially: openInitially, onOpenChange: onOpenChange }) {
    const isControlled = typeof open === 'boolean';
    const [internalOpen, setInternalOpen] = (0, $ieaan.useState)(()=>{
        if (typeof openInitially === 'boolean') return openInitially;
        return false;
    });
    const isOpen = isControlled ? open : internalOpen;
    const setOpenState = (0, $ieaan.useCallback)((next)=>{
        if (!isControlled) setInternalOpen(next);
        onOpenChange?.(next);
    }, [
        isControlled,
        onOpenChange
    ]);
    return {
        isOpen: isOpen,
        setOpenState: setOpenState
    };
}
function $157ea48181af41f6$var$isRenderer(value) {
    return typeof value === 'function';
}
function $157ea48181af41f6$var$mergeDescribedBy(existing, next) {
    return (0, $11741836d1790446$export$ac6c18d26085326c)({
        'aria-describedby': existing
    }, next);
}
function $157ea48181af41f6$var$isPopoverTargetElementObject(target) {
    return Boolean(target) && typeof target === 'object' && !('getBoundingClientRect' in target) && ('verticalRef' in target || 'horizontalRef' in target);
}
function $157ea48181af41f6$var$resolveTargetNode(target) {
    if (!target || $157ea48181af41f6$var$isPopoverTargetElementObject(target)) return null;
    if (target instanceof HTMLElement) return target;
    if (typeof target === 'object' && 'current' in target) return (0, $94ac3bc13091b86b$export$2e2bcd8739ae039)(target);
    return null;
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($157ea48181af41f6$export$2e2bcd8739ae039, {
    _supportsSpacingProps: true
});




var $ieaan = parcelRequire("ieaan");
"use client";
const $a531f09590037035$export$39ae08fa83328b12 = (0, $ieaan.createContext)(null);



var $ieaan = parcelRequire("ieaan");


"use client";
const $80f5cfb5a689d258$var$variantConfig = {
    text: {
        delay: 1000,
        atomic: true,
        showAnnouncement: false
    },
    content: {
        delay: -1,
        atomic: false,
        showAnnouncement: true
    }
};
const $80f5cfb5a689d258$var$priorityConfig = {
    low: {
        politeness: 'polite'
    },
    high: {
        politeness: 'assertive'
    }
};
function $80f5cfb5a689d258$export$2e2bcd8739ae039(props) {
    const [announcement, setAnnouncement] = (0, $ieaan.useState)('');
    const timeoutRef = (0, $ieaan.useRef)(null);
    const { disabled: disabled = false, delay: delay, atomic: atomic, politeness: politeness, relevant: relevant, className: className, children: children, showAnnouncement: showAnnouncement, variant: variant, priority: priority, ...rest } = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(props, $80f5cfb5a689d258$var$variantConfig[props.variant || 'text'], $80f5cfb5a689d258$var$priorityConfig[props.priority || 'low']);
    const showTextAnnouncement = delay > -1;
    (0, $ieaan.useEffect)(()=>{
        if (showTextAnnouncement) {
            var _ref;
            setAnnouncement('');
            const isTest = false;
            const timer = setTimeout(()=>{
                if (!disabled) setAnnouncement(children);
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(()=>setAnnouncement(''), isTest ? 100 : delay + 1000);
            }, (_ref = isTest ? 0 : delay) !== null && _ref !== void 0 ? _ref : 1000);
            return ()=>{
                clearTimeout(timer);
                clearTimeout(timeoutRef.current);
            };
        }
        return undefined;
    }, [
        delay,
        children,
        disabled,
        showTextAnnouncement
    ]);
    return {
        'aria-live': disabled && !showTextAnnouncement ? 'off' : politeness,
        'aria-atomic': atomic,
        'aria-relevant': relevant,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-aria-live', !showAnnouncement && 'dnb-sr-only', className),
        children: showTextAnnouncement ? announcement : children,
        ...rest
    };
}




function $cda1cc32163383c9$var$AriaLive({ element: element, ...props }) {
    const ariaAttributes = (0, $80f5cfb5a689d258$export$2e2bcd8739ae039)(props);
    const Element = element || 'section';
    return (0, $60739c7e3f826d8d$exports.jsx)(Element, {
        ...ariaAttributes
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($cda1cc32163383c9$var$AriaLive, {
    _supportsSpacingProps: 'children'
});
var $cda1cc32163383c9$export$2e2bcd8739ae039 = $cda1cc32163383c9$var$AriaLive;


var $98ab316b19446389$export$2e2bcd8739ae039 = (0, $cda1cc32163383c9$export$2e2bcd8739ae039);



"use client";
function $d24b1e1646088a6a$var$TooltipWithEvents(props) {
    const { children: children, attributes: attributes, ...restProps } = props;
    const { open: open, target: target, skipPortal: skipPortal, noAnimation: noAnimation, showDelay: showDelay, hideDelay: hideDelay, arrow: arrow, placement: placement, align: align, fixedPosition: fixedPosition, portalRootClass: portalRootClass, triggerOffset: triggerOffset, contentRef: contentRef, size: size, keepInDOM: keepInDOM = false, targetRefreshKey: targetRefreshKey, omitDescribedBy: omitDescribedBy } = restProps;
    const { internalId: internalId, isControlled: isControlled } = (0, $ieaan.useContext)((0, $a531f09590037035$export$39ae08fa83328b12));
    const [isOpen, setIsOpen] = (0, $ieaan.useState)(open);
    const [isOverlayHovered, setOverlayHovered] = (0, $ieaan.useState)(false);
    const delayTimeout = (0, $ieaan.useRef)(undefined);
    const overlayDelayTimeout = (0, $ieaan.useRef)(undefined);
    const cloneRef = (0, $ieaan.useRef)(undefined);
    const previousDescribedByIdRef = (0, $ieaan.useRef)(null);
    const clearTimers = ()=>{
        clearTimeout(delayTimeout.current);
    };
    const onMouseEnter = (0, $ieaan.useCallback)((e)=>{
        try {
            const elem = e.currentTarget;
            if (elem.getAttribute('data-autofocus')) return undefined;
            if ((0, $911842e5a561b5ca$export$971e5333ff27c622)(e.type)) elem.style.userSelect = 'none';
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tooltip: Failed to handle mouse enter event:', e);
        }
        const run = ()=>{
            setIsOpen(true);
        };
        if (noAnimation || globalThis.IS_TEST) run();
        else {
            clearTimers();
            delayTimeout.current = setTimeout(run, parseFloat(String(showDelay)) || 1);
        }
    }, [
        noAnimation,
        showDelay
    ]);
    const onFocus = (0, $ieaan.useCallback)((e)=>{
        return onMouseEnter(e);
    }, [
        onMouseEnter
    ]);
    const onMouseLeave = (0, $ieaan.useCallback)((e)=>{
        if (open) return;
        try {
            if ((0, $911842e5a561b5ca$export$971e5333ff27c622)(e.type)) {
                const elem = e.currentTarget;
                elem.style.userSelect = '';
            }
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tooltip: Failed to handle mouse leave event:', e);
        }
        clearTimers();
        const run = ()=>{
            setIsOpen(false);
        };
        if (skipPortal) delayTimeout.current = setTimeout(run, parseFloat(String(hideDelay)));
        else run();
    }, [
        open,
        hideDelay,
        skipPortal
    ]);
    const addEvents = (0, $ieaan.useCallback)((element)=>{
        try {
            element.addEventListener('focus', onFocus);
            element.addEventListener('blur', onMouseLeave);
            element.addEventListener('mouseenter', onMouseEnter);
            element.addEventListener('mouseleave', onMouseLeave);
            element.addEventListener('touchstart', onMouseEnter);
            element.addEventListener('touchend', onMouseLeave);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tooltip: Failed to add event listeners to target element:', e);
        }
    }, [
        onFocus,
        onMouseLeave,
        onMouseEnter
    ]);
    const removeEvents = (0, $ieaan.useCallback)((element)=>{
        if (!(element instanceof HTMLElement)) return undefined;
        try {
            element.removeEventListener('focus', onFocus);
            element.removeEventListener('blur', onMouseLeave);
            element.removeEventListener('mouseenter', onMouseEnter);
            element.removeEventListener('mouseleave', onMouseLeave);
            element.removeEventListener('touchstart', onMouseEnter);
            element.removeEventListener('touchend', onMouseLeave);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tooltip: Failed to remove event listeners from target element:', e);
        }
    }, [
        onFocus,
        onMouseEnter,
        onMouseLeave
    ]);
    const overlayOpen = Boolean(isOpen || isOverlayHovered);
    const describedById = overlayOpen && !omitDescribedBy ? internalId : null;
    const componentWrapper = (0, $ieaan.useMemo)(()=>{
        if ((0, $ieaan.isValidElement)(target)) return (0, $ieaan.createElement)(target.type, {
            ...target.props,
            ref: cloneRef,
            ...!omitDescribedBy && {
                'aria-describedby': (0, $11741836d1790446$export$ac6c18d26085326c)(target.props['aria-describedby'], describedById)
            }
        });
        cloneRef.current = target;
        return null;
    }, [
        describedById,
        omitDescribedBy,
        target
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (!target) return ()=>clearTimers();
        const element = (0, $94ac3bc13091b86b$export$2e2bcd8739ae039)(cloneRef);
        if (!(element instanceof HTMLElement) || isControlled) return ()=>clearTimers();
        addEvents(element);
        return ()=>{
            clearTimers();
            removeEvents(element);
        };
    }, [
        addEvents,
        removeEvents,
        isControlled,
        target
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (isControlled) setIsOpen(open);
        else setIsOpen(false);
    }, [
        open,
        isControlled
    ]);
    (0, $ieaan.useEffect)(()=>{
        const targetElement = (0, $94ac3bc13091b86b$export$2e2bcd8739ae039)(cloneRef);
        if (!(targetElement instanceof HTMLElement)) {
            previousDescribedByIdRef.current = null;
            return undefined;
        }
        const updateAriaDescribedBy = (nextId)=>{
            var _targetElement$getAtt;
            const existingValues = (_targetElement$getAtt = targetElement.getAttribute('aria-describedby')?.split(/\s+/).map((value)=>value.trim()).filter(Boolean)) !== null && _targetElement$getAtt !== void 0 ? _targetElement$getAtt : [];
            const withoutPrevious = previousDescribedByIdRef.current !== null ? existingValues.filter((value)=>value !== previousDescribedByIdRef.current) : existingValues;
            let nextValues = withoutPrevious;
            if (nextId) {
                nextValues = nextValues.filter((value)=>value !== nextId);
                nextValues = [
                    ...nextValues,
                    nextId
                ];
            }
            if (nextValues.length > 0) targetElement.setAttribute('aria-describedby', nextValues.join(' '));
            else targetElement.removeAttribute('aria-describedby');
            previousDescribedByIdRef.current = nextId;
        };
        updateAriaDescribedBy(describedById);
        return ()=>{
            updateAriaDescribedBy(null);
        };
    }, [
        cloneRef,
        describedById,
        target
    ]);
    const clearOverlayTimers = ()=>{
        clearTimeout(overlayDelayTimeout.current);
    };
    (0, $ieaan.useEffect)(()=>clearOverlayTimers, []);
    const handleOverlayMouseEnter = (0, $ieaan.useCallback)(()=>{
        clearOverlayTimers();
        if (!isControlled) setOverlayHovered(true);
    }, [
        isControlled
    ]);
    const handleOverlayMouseLeave = (0, $ieaan.useCallback)(()=>{
        if (isControlled) return undefined;
        const run = ()=>setOverlayHovered(false);
        clearOverlayTimers();
        if (skipPortal) overlayDelayTimeout.current = setTimeout(run, parseFloat(String(hideDelay)) || 1);
        else run();
    }, [
        hideDelay,
        isControlled,
        skipPortal
    ]);
    const { className: attributeClassName, ...restAttributes } = attributes || {};
    return (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)((0, $157ea48181af41f6$export$2e2bcd8739ae039), {
                baseClassName: "dnb-tooltip",
                className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(attributeClassName, 'dnb-tooltip', size && size !== 'default' && `dnb-tooltip--${size}`),
                id: internalId,
                open: overlayOpen,
                targetElement: cloneRef,
                arrowEdgeOffset: 4,
                hideDelay: hideDelay,
                skipPortal: skipPortal,
                keepInDOM: keepInDOM,
                noAnimation: noAnimation,
                triggerOffset: triggerOffset,
                targetRefreshKey: targetRefreshKey,
                arrowPosition: arrow,
                placement: placement,
                alignOnTarget: align,
                fixedPosition: fixedPosition,
                portalRootClass: portalRootClass,
                contentClassName: "dnb-tooltip__content",
                contentRef: contentRef,
                focusOnOpen: false,
                restoreFocus: false,
                preventClose: false,
                noInnerSpace: true,
                noMaxWidth: true,
                hideOutline: true,
                hideCloseButton: true,
                disableFocusTrap: true,
                onMouseEnter: handleOverlayMouseEnter,
                onMouseLeave: handleOverlayMouseLeave,
                role: "tooltip",
                ...restAttributes,
                children: children
            }),
            (0, $60739c7e3f826d8d$exports.jsx)((0, $98ab316b19446389$export$2e2bcd8739ae039), {
                element: "span",
                priority: "low",
                children: overlayOpen ? children : null
            }),
            componentWrapper
        ]
    });
}
var $d24b1e1646088a6a$export$2e2bcd8739ae039 = $d24b1e1646088a6a$var$TooltipWithEvents;






"use client";
function $afdc5ea86ffcb5b6$var$Tooltip(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = $afdc5ea86ffcb5b6$var$resolveProps(localProps, context);
    const { targetElement: targetElement, targetSelector: targetSelector, className: className, id: id, size: size, children: children, tooltip: tooltip, fixedPosition: fixedPosition, skipPortal: skipPortal, noAnimation: noAnimation, showDelay: showDelay, hideDelay: hideDelay, open: open, placement: placement, arrow: arrow, align: align, portalRootClass: portalRootClass, omitDescribedBy: omitDescribedBy, contentRef: contentRef, triggerOffset: triggerOffset, ...attributeProps } = props;
    const targetSource = targetElement || targetSelector;
    const target = $afdc5ea86ffcb5b6$var$useTooltipTarget(targetElement, targetSelector);
    const internalId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(id);
    const isControlled = typeof open === 'boolean';
    const attributes = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(props, {
        ...attributeProps,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tooltip', size === 'large' && 'dnb-tooltip--large', className)
    });
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(localProps, attributes);
    if (targetSource && !target) return null;
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $a531f09590037035$export$39ae08fa83328b12), {
        value: {
            isControlled: isControlled,
            internalId: internalId,
            props: props
        },
        children: (0, $60739c7e3f826d8d$exports.jsx)((0, $d24b1e1646088a6a$export$2e2bcd8739ae039), {
            target: target,
            attributes: attributes,
            ...props,
            children: children
        })
    });
}
function $afdc5ea86ffcb5b6$var$resolveProps(localProps, context) {
    const inherited = (0, $911842e5a561b5ca$export$2414da066cdcef)(localProps);
    const translation = context.getTranslation?.(localProps) || {};
    const tooltipTranslation = translation['Tooltip'] || {};
    return {
        ...(0, $911842e5a561b5ca$export$9c21a3269931e1e6),
        ...localProps,
        ...inherited,
        ...tooltipTranslation,
        ...context.Tooltip
    };
}
function $afdc5ea86ffcb5b6$var$useTooltipTarget(targetElement, targetSelector) {
    const [target, setTarget] = (0, $ieaan.useState)(null);
    const source = targetElement || targetSelector;
    (0, $ieaan.useEffect)(()=>{
        if (!source) {
            setTarget(null);
            return;
        }
        const resolved = (0, $911842e5a561b5ca$export$2562999169740ceb)(typeof source === 'string' ? source : (0, $94ac3bc13091b86b$export$2e2bcd8739ae039)(source)) || (typeof source === 'string' ? null : source);
        setTarget(resolved);
    }, [
        source
    ]);
    return target;
}
$afdc5ea86ffcb5b6$var$Tooltip.isTooltipComponent = true;
var $afdc5ea86ffcb5b6$export$2e2bcd8739ae039 = $afdc5ea86ffcb5b6$var$Tooltip;



var $923170eb2742d277$var$_path;
const $923170eb2742d277$var$launch = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $923170eb2742d277$var$_path || ($923170eb2742d277$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M5.857 2H2v12h12v-3.857M8.429 7.57 14 2m0 4.286V2H9.714"
        }))
    });
var $923170eb2742d277$export$2e2bcd8739ae039 = $923170eb2742d277$var$launch;



"use client";
var $1f174d88b9f7c15a$var$_IconPrimary;
const $1f174d88b9f7c15a$var$defaultProps = {
    noAnimation: false,
    noStyle: false,
    noHover: false,
    noUnderline: false,
    noIcon: false,
    noLaunchIcon: false,
    disabled: false
};
function $1f174d88b9f7c15a$export$6c00cc313b6acc4c(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const allProps = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $1f174d88b9f7c15a$var$defaultProps, {
        skeleton: context?.skeleton
    }, context?.getTranslation(localProps).Anchor, context?.Anchor);
    const fallbackRef = (0, $ieaan.useRef)(null);
    if (!allProps.ref) allProps.ref = fallbackRef;
    const tooltipRef = (0, $ieaan.useRef)(null);
    const { id: id, element: element, className: className, children: children, tooltip: tooltip, icon: icon, iconPosition: iconPosition = 'left', omitClass: omitClass, ref: refProp, targetBlankTitle: targetBlankTitle, noAnimation: noAnimation, noHover: noHover, noStyle: noStyle, noUnderline: noUnderline, noIcon: noIcon, noLaunchIcon: noLaunchIcon, disabled: disabled, ...rest } = allProps;
    const attributes = rest;
    const internalId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(id);
    const as = element || 'a';
    const isDisabled = disabled;
    const hasNoHover = noHover || isDisabled;
    const hasNoAnimation = noAnimation || isDisabled;
    const hasNoUnderline = noUnderline || isDisabled;
    const href = allProps.href || allProps.to;
    const _opensNewTab = $1f174d88b9f7c15a$export$d250f3a139860f83(allProps.target, href);
    const showLaunchIcon = _opensNewTab && !isDisabled && !noIcon && !noLaunchIcon && !className?.includes('dnb-anchor--no-icon') && !className?.includes('dnb-anchor--no-launch-icon') && !omitClass;
    const showTooltip = (tooltip || _opensNewTab) && !allProps.title;
    if (_opensNewTab && !attributes.rel) attributes.rel = 'noopener noreferrer';
    const iconNode = icon && $1f174d88b9f7c15a$var$getIcon(icon);
    const suffix = iconPosition === 'right' && iconNode || showLaunchIcon && ($1f174d88b9f7c15a$var$_IconPrimary || ($1f174d88b9f7c15a$var$_IconPrimary = (0, $60739c7e3f826d8d$exports.jsx)((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
        className: "dnb-anchor__launch-icon",
        icon: (0, $923170eb2742d277$export$2e2bcd8739ae039)
    })));
    const prefix = iconPosition === 'left' && iconNode;
    const anchorRef = (0, $ieaan.useCallback)((elem)=>{
        tooltipRef.current = elem;
        if (typeof refProp === 'function') refProp(elem);
        else if (refProp) refProp.current = elem;
    }, [
        refProp
    ]);
    if (isDisabled) {
        attributes.disabled = true;
        if (as === 'a') {
            attributes.tabIndex = -1;
            attributes['aria-disabled'] = true;
            if (attributes.href) delete attributes.href;
            if (attributes.to) delete attributes.to;
            attributes.onClick = (event)=>{
                event.preventDefault();
                event.stopPropagation();
            };
        }
    }
    return (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            (0, $60739c7e3f826d8d$exports.jsxs)((0, $3d090471d65e4fa1$export$2e2bcd8739ae039), {
                as: as,
                id: id,
                internalClass: as !== 'button',
                className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(omitClass !== true && (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-anchor', prefix && 'dnb-anchor--icon-left', suffix && 'dnb-anchor--icon-right', typeof children !== 'string' && 'dnb-anchor--was-node', hasNoAnimation && 'dnb-anchor--no-animation', hasNoHover && 'dnb-anchor--no-hover', noStyle && 'dnb-anchor--no-style', hasNoUnderline && 'dnb-anchor--no-underline', isDisabled && 'dnb-anchor--disabled', noIcon && !className?.includes('dnb-anchor--no-icon') && 'dnb-anchor--no-icon', noLaunchIcon && !className?.includes('dnb-anchor--no-launch-icon') && 'dnb-anchor--no-launch-icon', context?.theme?.surface === 'dark' && 'dnb-anchor--surface-dark'), className),
                ...attributes,
                ref: anchorRef,
                children: [
                    prefix,
                    children,
                    suffix
                ]
            }),
            showTooltip && (0, $60739c7e3f826d8d$exports.jsx)((0, $afdc5ea86ffcb5b6$export$2e2bcd8739ae039), {
                showDelay: 100,
                id: internalId + '-tooltip',
                targetElement: tooltipRef,
                tooltip: tooltip,
                children: allProps.title || targetBlankTitle
            })
        ]
    });
}
function $1f174d88b9f7c15a$var$Anchor(props) {
    return (0, $60739c7e3f826d8d$exports.jsx)($1f174d88b9f7c15a$export$6c00cc313b6acc4c, {
        ...props
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($1f174d88b9f7c15a$var$Anchor, {
    _supportsSpacingProps: true
});
var $1f174d88b9f7c15a$export$2e2bcd8739ae039 = $1f174d88b9f7c15a$var$Anchor;
function $1f174d88b9f7c15a$export$97d524d4c64bb6e3(hash) {
    if (typeof document === 'undefined' || !hash || !hash.includes('#')) return undefined;
    const id = hash.split(/#/g).reverse()[0];
    const anchorElem = document.getElementById(id);
    if (anchorElem instanceof HTMLElement) try {
        const scrollPadding = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop);
        const top = (0, $deeefef162515a83$export$6fcff0dc60346367)(anchorElem) - scrollPadding || 0;
        window.scroll({
            top: top
        });
        return {
            element: anchorElem
        };
    } catch (error) {
        console.error('Anchor: Failed to scroll to element:', error);
    }
    return undefined;
}
function $1f174d88b9f7c15a$var$getIcon(icon) {
    return $1f174d88b9f7c15a$export$5fb244b331be8433(icon) || (0, $60739c7e3f826d8d$exports.jsx)((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
        icon: icon
    });
}
function $1f174d88b9f7c15a$export$5fb244b331be8433(icon, className) {
    if (icon?.props?.icon || icon?.props?.className?.includes('dnb-icon')) return (0, $ieaan.createElement)(icon.type, {
        ...icon.props,
        key: 'button-icon-clone',
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(icon.props?.className, className)
    });
    return null;
}
const $1f174d88b9f7c15a$export$d250f3a139860f83 = (target, href)=>target === '_blank' && !/^(mailto|tel|sms)/.test(href);






"use client";
const $62da03d0a8a66ef6$var$buttonDefaultProps = {
    type: null,
    text: null,
    variant: null,
    size: null,
    title: null,
    icon: null,
    iconPosition: 'right',
    iconSize: null,
    href: null,
    target: null,
    rel: null,
    to: null,
    id: null,
    customContent: null,
    wrap: null,
    bounding: null,
    stretch: null,
    skeleton: null,
    disabled: null,
    tooltip: null,
    status: null,
    statusState: 'error',
    statusProps: null,
    statusNoAnimation: null,
    globalStatus: null,
    className: null,
    ref: null,
    children: null,
    element: null,
    onClick: null
};
function $62da03d0a8a66ef6$var$getContent(props) {
    return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
}
function $62da03d0a8a66ef6$var$Button({ ref: ref, transitionState: transitionState, ...restProps }) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const elementRef = (0, $ieaan.useRef)(null);
    const combinedRef = (0, $e48c94c3f1835290$export$2e2bcd8739ae039)(ref, elementRef);
    const generatedId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(restProps.id);
    const resolvedId = restProps.id || restProps.status || restProps.tooltip ? generatedId : undefined;
    const [afterContent, setAfterContent] = (0, $ieaan.useState)(null);
    const props = (0, $be16b996e1dc94eb$export$6e15c46eedcbcbc6)({
        ...$62da03d0a8a66ef6$var$buttonDefaultProps,
        ...(0, $11741836d1790446$export$130f9de4db4d93ea)({
            ...restProps
        })
    }, $62da03d0a8a66ef6$var$buttonDefaultProps, {
        skeleton: context?.skeleton
    }, (0, $c81beeaa1b3509d1$export$8efbf5589742246)(context?.formElement), context.Button);
    const { className: className, variant: variant, size: size, title: title, customContent: customContent, tooltip: tooltip, status: status, statusState: statusState, statusProps: statusProps, statusNoAnimation: statusNoAnimation, globalStatus: globalStatus, disabled: disabled, text: _text, icon: _icon, iconPosition: iconPosition, iconSize: iconSize, wrap: wrap, bounding: bounding, stretch: stretch, skeleton: skeleton, element: element, selected: selected, ...attributes } = props;
    const showStatus = (0, $11741836d1790446$export$a5f4aa7ad013c9e9)(status);
    const { text: text } = props;
    let { icon: usedIcon } = props;
    let usedVariant = variant;
    let usedSize = size;
    let usedIconSize = iconSize;
    const content = $62da03d0a8a66ef6$var$getContent(restProps);
    if (variant === 'tertiary' && (text || content) && !usedIcon && usedIcon !== false) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Icon required: A Tertiary Button requires an icon to be WCAG compliant in most cases, because variant tertiary has no underline.
(Override this warning using icon={false}, or consider using one of the other variants)`);
    const isIconOnly = Boolean(!text && !content && usedIcon);
    if (isIconOnly) {
        if (!usedVariant) usedVariant = 'secondary';
        if (!usedIconSize && (usedSize === 'default' || usedSize === 'large')) usedIconSize = 'medium';
        if (!usedSize) usedSize = 'medium';
    } else if (content) {
        if (!usedVariant) usedVariant = 'primary';
        if (!usedSize) usedSize = 'default';
    }
    if (!usedIconSize && variant === 'tertiary' && iconPosition === 'top') usedIconSize = 'medium';
    const Element = element ? element : props.href || props.to ? (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) : 'button';
    if (Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039)) {
        if ((0, $1f174d88b9f7c15a$export$d250f3a139860f83)(props.target, props.href) && !usedIcon) usedIcon = (0, $923170eb2742d277$export$2e2bcd8739ae039);
    }
    const titleString = (0, $11741836d1790446$export$5bfc594bd2dc6e21)(title) || undefined;
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(props, {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-button', `dnb-button--${usedVariant || 'primary'}`, usedSize && usedSize !== 'default' && `dnb-button--size-${usedSize}`, context?.theme?.surface === 'dark' && `dnb-button--surface-dark`, usedIcon && `dnb-button--icon-position-${iconPosition}`, stretch && 'dnb-button--stretch', usedIcon && usedIconSize && `dnb-button--icon-size-${usedIconSize}`, (text || content || customContent) && 'dnb-button--has-text', usedIcon && 'dnb-button--has-icon', isIconOnly && 'dnb-button--icon-only', selected && 'dnb-button--selected', wrap && 'dnb-button--wrap', status && `dnb-button__status--${statusState}`, (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(variant === 'tertiary' ? 'font' : 'shape', skeleton, context), className, props.href || props.to ? '' : null, Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && 'dnb-anchor--no-style'),
        title: titleString,
        id: resolvedId,
        disabled: disabled,
        ...attributes,
        ...Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && {
            omitClass: true
        }
    });
    const handleClick = (event)=>{
        const result = (0, $11741836d1790446$export$89a1e257278b2134)(props, 'onClick', {
            event: event
        });
        if (result && (0, $ieaan.isValidElement)(result)) setAfterContent(result);
    };
    if (props.onClick) params.onClick = handleClick;
    if (Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && params.disabled) {
        const originalOnClick = params.onClick;
        params.onClick = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (typeof originalOnClick === 'function') originalOnClick(e);
        };
        params.tabIndex = -1;
        params['aria-disabled'] = true;
        if (params.href) delete params.href;
    }
    if (Element !== (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && !params.type) params.type = params.type === '' ? undefined : 'button';
    if (isIconOnly) params['aria-label'] = params['aria-label'] || titleString;
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton, context);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(restProps, params);
    return (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)(Element, {
                ref: combinedRef,
                ...params,
                children: (0, $60739c7e3f826d8d$exports.jsx)((0, $890dd4bb8bcb7f69$export$2e2bcd8739ae039), {
                    ...restProps,
                    icon: usedIcon,
                    iconSize: usedIconSize,
                    content: text || content,
                    customContent: customContent,
                    isIconOnly: isIconOnly,
                    skeleton: skeleton,
                    transitionState: transitionState,
                    iconElement: (0, $1f174d88b9f7c15a$export$5fb244b331be8433)(usedIcon, 'dnb-button__icon')
                })
            }),
            afterContent,
            (0, $60739c7e3f826d8d$exports.jsx)((0, $2fad1ad7e24667d0$export$2e2bcd8739ae039), {
                show: showStatus,
                id: resolvedId + '-form-status',
                globalStatus: globalStatus,
                label: text,
                text: status,
                state: statusState,
                textId: resolvedId + '-status',
                noAnimation: statusNoAnimation,
                skeleton: skeleton,
                ...statusProps
            }),
            tooltip && elementRef && (0, $60739c7e3f826d8d$exports.jsx)((0, $afdc5ea86ffcb5b6$export$2e2bcd8739ae039), {
                id: resolvedId + '-tooltip',
                targetElement: elementRef,
                tooltip: tooltip,
                omitDescribedBy: Boolean(params['aria-label']) && (0, $11741836d1790446$export$5bfc594bd2dc6e21)(tooltip) === params['aria-label']
            })
        ]
    });
}
$62da03d0a8a66ef6$var$Button.getContent = $62da03d0a8a66ef6$var$getContent;
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($62da03d0a8a66ef6$var$Button, {
    _formElement: true,
    _supportsSpacingProps: true
});
var $62da03d0a8a66ef6$export$2e2bcd8739ae039 = $62da03d0a8a66ef6$var$Button;








var $ieaan = parcelRequire("ieaan");




var $ieaan = parcelRequire("ieaan");








"use client";
const $b72c82c3d5da1e25$var$defaultProps = {
    element: 'section'
};
function $b72c82c3d5da1e25$var$SectionInstance(localProps) {
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        ...$b72c82c3d5da1e25$export$a739c8d3f97ecf5f(localProps)
    });
}
function $b72c82c3d5da1e25$export$2e2bcd8739ae039(props) {
    return (0, $60739c7e3f826d8d$exports.jsx)($b72c82c3d5da1e25$var$SectionInstance, {
        ...props
    });
}
function $b72c82c3d5da1e25$export$a739c8d3f97ecf5f(localProps) {
    var _localProps$surface, _ref;
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $b72c82c3d5da1e25$var$defaultProps, context.Section, {
        surface: (_localProps$surface = localProps?.surface) !== null && _localProps$surface !== void 0 ? _localProps$surface : context?.theme?.surface
    });
    const { variant: variant, breakout: breakout = !props.outset, outset: outset, roundedCorner: roundedCorner, textColor: textColor, backgroundColor: backgroundColor, dropShadow: dropShadow, outline: outline, outlineWidth: outlineWidth = typeof props.outline === 'undefined' && typeof props.outlineWidth === 'undefined' ? 'none' : props.outlineWidth, surface: surface, ref: refProp, className: className, children: children, ...attributes } = props;
    const internalRef = (0, $ieaan.useRef)(undefined);
    const elementRef = refProp || internalRef;
    return Object.freeze({
        ...attributes,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-section', `dnb-section--${(_ref = variant !== null && variant !== void 0 ? variant : surface) !== null && _ref !== void 0 ? _ref : 'default'}`, surface && `dnb-section--surface-${surface}`, className),
        style: {
            ...$b72c82c3d5da1e25$var$computeStyle(breakout, 'breakout', (value)=>`var(--breakout--${value ? 'on' : 'off'})`),
            ...$b72c82c3d5da1e25$var$computeStyle(outset, 'outset', (value)=>value ? '1' : '0'),
            ...$b72c82c3d5da1e25$var$computeStyle(roundedCorner, 'rounded-corner', (value)=>typeof value === 'boolean' ? value && 'var(--rounded-corner--value)' : value.map((v)=>v ? 'var(--rounded-corner--value)' : '0').join(' ')),
            ...$b72c82c3d5da1e25$var$computeStyle(textColor, 'text-color', (value)=>(0, $deeefef162515a83$export$5551a2d24ff40153)(value)),
            ...$b72c82c3d5da1e25$var$computeStyle(backgroundColor, 'background-color', (value)=>(0, $deeefef162515a83$export$5551a2d24ff40153)(value)),
            ...$b72c82c3d5da1e25$var$computeStyle(dropShadow, 'drop-shadow', (value)=>value && 'var(--shadow-default)'),
            ...$b72c82c3d5da1e25$var$computeStyle(outline, 'outline-color', (value)=>typeof value === 'boolean' ? value && 'var(--outline-color--value)' : (0, $deeefef162515a83$export$5551a2d24ff40153)(value)),
            ...$b72c82c3d5da1e25$var$computeStyle(outlineWidth, 'outline-width', (value)=>typeof value === 'number' ? `${value}px` : value),
            ...attributes?.style
        },
        ref: elementRef,
        children: surface ? (0, $60739c7e3f826d8d$exports.jsx)((0, $db09087c4569f84b$export$2e2bcd8739ae039).Context, {
            surface: surface,
            children: children
        }) : children
    });
}
function $b72c82c3d5da1e25$var$computeStyle(property, name, valueCallback) {
    let media = property;
    if (media !== null && (Array.isArray(media) || typeof media !== 'object')) media = {
        small: property,
        medium: property,
        large: property
    };
    const result = {};
    for(const size in media)if (typeof media?.[size] !== 'undefined') {
        const value = valueCallback(media?.[size]);
        if (typeof value === 'string') result[`--${name}--${size}`] = value;
    }
    return result;
}
$b72c82c3d5da1e25$export$2e2bcd8739ae039._name = 'Section';
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($b72c82c3d5da1e25$export$2e2bcd8739ae039, {
    _supportsSpacingProps: true
});





var $ieaan = parcelRequire("ieaan");
"use client";
function $de6abad5311f963a$export$ce36c717a10e802(id, initialData, onChange = null) {
    return $de6abad5311f963a$export$635072b6ebae27f9(id, initialData, onChange, {
        weak: true
    });
}
function $de6abad5311f963a$export$635072b6ebae27f9(id, initialData, onChange = null, { weak: weak = false } = {}) {
    const instanceRef = (0, $ieaan.useRef)({});
    const sharedState = (0, $ieaan.useMemo)(()=>{
        if (id) return $de6abad5311f963a$export$7f3d1916298b3c77(id, initialData);
        return undefined;
    }, [
        id,
        initialData
    ]);
    const sharedAttachment = (0, $ieaan.useMemo)(()=>{
        if (id) return $de6abad5311f963a$export$7f3d1916298b3c77($de6abad5311f963a$export$e8009621ef6eb(id, 'oc'), {
            onChange: onChange
        });
        return undefined;
    }, [
        id,
        onChange
    ]);
    const syncAttachment = (0, $ieaan.useCallback)((newData)=>{
        if (id) sharedAttachment.data?.onChange?.(newData);
    }, [
        id,
        sharedAttachment
    ]);
    const subscribe = (0, $ieaan.useCallback)((onStoreChange)=>{
        if (!id || !sharedState) return ()=>{};
        const subscriber = ()=>onStoreChange();
        subscriber['ref'] = instanceRef.current;
        sharedState.subscribe(subscriber);
        return ()=>{
            sharedState.unsubscribe(subscriber);
            if (weak && sharedState.subscribersRef.current.length === 0) sharedState.update(undefined);
        };
    }, [
        id,
        sharedState,
        weak
    ]);
    const getSnapshot = (0, $ieaan.useCallback)(()=>{
        var _sharedState$get;
        return id ? (_sharedState$get = sharedState?.get?.()) !== null && _sharedState$get !== void 0 ? _sharedState$get : undefined : undefined;
    }, [
        id,
        sharedState
    ]);
    const data = (0, $ieaan.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    const get = (0, $ieaan.useCallback)(()=>{
        if (id) return sharedState?.get?.();
        return undefined;
    }, [
        id,
        sharedState
    ]);
    const update = (0, $ieaan.useCallback)((newData, opts)=>{
        if (id) sharedState.update(newData, {
            ...opts,
            callerRef: instanceRef.current
        });
    }, [
        id,
        sharedState
    ]);
    const set = (0, $ieaan.useCallback)((newData, opts)=>{
        if (!id) return false;
        const changed = sharedState.set(newData, {
            ...opts,
            callerRef: instanceRef.current
        });
        if (changed) syncAttachment(newData);
        return changed;
    }, [
        id,
        sharedState,
        syncAttachment
    ]);
    const extend = (0, $ieaan.useCallback)((newData, opts)=>{
        if (!id) return false;
        const changed = sharedState.extend(newData, {
            ...opts,
            callerRef: instanceRef.current
        });
        if (changed) syncAttachment(newData);
        return changed;
    }, [
        id,
        sharedState,
        syncAttachment
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (id && onChange && !sharedAttachment.data?.onChange) sharedAttachment.set({
            onChange: onChange
        });
    }, [
        id,
        onChange,
        sharedAttachment
    ]);
    return {
        get: get,
        data: data,
        hadInitialData: sharedState?.hadInitialData,
        update: update,
        set: set,
        extend: extend
    };
}
const $de6abad5311f963a$var$sharedStates = new Map();
function $de6abad5311f963a$export$7f3d1916298b3c77(id, initialData) {
    if (!$de6abad5311f963a$var$sharedStates.get(id)) {
        const subscribersRef = {
            current: []
        };
        const sync = (opts = {})=>{
            subscribersRef.current.forEach((subscriber)=>{
                if (opts.preventSyncOfSameInstance && opts.callerRef !== undefined && subscriber['ref'] === opts.callerRef) return;
                subscriber();
            });
        };
        const get = ()=>$de6abad5311f963a$var$sharedStates.get(id).data;
        const set = (newData, opts)=>{
            const store = $de6abad5311f963a$var$sharedStates.get(id);
            const current = store.data;
            if (newData === undefined) {
                if (current === undefined) return false;
                store.data = undefined;
                if (!opts?.silent) sync(opts);
                return true;
            }
            const next = $de6abad5311f963a$var$cloneData(newData);
            if (!opts?.forceSync && $de6abad5311f963a$export$d36bdfa510afb180(current, next)) return false;
            store.data = next;
            if (!opts?.silent) sync(opts);
            return true;
        };
        const update = (newData, opts)=>{
            set(newData, opts);
        };
        const extend = (newData, opts)=>{
            const store = $de6abad5311f963a$var$sharedStates.get(id);
            const current = store.data;
            if (!$de6abad5311f963a$var$isMergeableObject(newData)) return set(newData, opts);
            const base = $de6abad5311f963a$var$isMergeableObject(current) ? current : {};
            const next = {
                ...base,
                ...newData
            };
            if (!opts?.forceSync && $de6abad5311f963a$export$d36bdfa510afb180(base, next)) return false;
            store.data = next;
            if (!opts?.silent) sync(opts);
            return true;
        };
        const subscribe = (subscriber)=>{
            if (!subscribersRef.current.includes(subscriber)) {
                var _context;
                (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(_context = subscribersRef.current).call(_context, subscriber);
            }
        };
        const unsubscribe = (subscriber)=>{
            subscribersRef.current = subscribersRef.current.filter((sub)=>sub !== subscriber);
        };
        $de6abad5311f963a$var$sharedStates.set(id, {
            data: undefined,
            get: get,
            set: set,
            extend: extend,
            update: update,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            hadInitialData: Boolean(initialData),
            subscribersRef: subscribersRef
        });
        if (initialData) extend(initialData);
    } else if ($de6abad5311f963a$var$sharedStates.get(id).data === undefined && initialData !== undefined) $de6abad5311f963a$var$sharedStates.get(id).data = $de6abad5311f963a$var$cloneData(initialData);
    return $de6abad5311f963a$var$sharedStates.get(id);
}
function $de6abad5311f963a$export$2020b37bc026ce00(id, data) {
    $de6abad5311f963a$export$7f3d1916298b3c77(id);
    const store = $de6abad5311f963a$var$sharedStates.get(id);
    if (store && store.data === undefined && data !== undefined) store.data = $de6abad5311f963a$var$cloneData(data);
}
function $de6abad5311f963a$export$e8009621ef6eb(ref1, ref2) {
    if (!$de6abad5311f963a$var$cache.has(ref1)) $de6abad5311f963a$var$cache.set(ref1, new Map());
    const innerMap = $de6abad5311f963a$var$cache.get(ref1);
    if (!innerMap.has(ref2)) innerMap.set(ref2, {});
    return innerMap.get(ref2);
}
const $de6abad5311f963a$var$cache = new Map();
function $de6abad5311f963a$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
function $de6abad5311f963a$var$isMergeableObject(value) {
    return $de6abad5311f963a$var$isObjectLike(value) && !Array.isArray(value);
}
function $de6abad5311f963a$var$cloneData(value) {
    if (Array.isArray(value)) return [
        ...value
    ];
    if ($de6abad5311f963a$var$isMergeableObject(value)) return {
        ...value
    };
    return value;
}
function $de6abad5311f963a$export$d36bdfa510afb180(a, b) {
    if (Object.is(a, b)) return true;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!Object.is(a[i], b[i])) return false;
        }
        return true;
    }
    if ($de6abad5311f963a$var$isMergeableObject(a) && $de6abad5311f963a$var$isMergeableObject(b)) {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        for (const key of keysA){
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($0deb50add52e39bd$exports)))(b, key) || !Object.is(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}




"use client";
function $26d57369cefb5383$export$2e2bcd8739ae039({ id: id, children: children = null, selectedKey: selectedKey = null, contentStyle: contentStyle = null, animate: animate = null, contentInnerSpace: contentInnerSpace = {
    top: 'large'
}, ...rest }) {
    const sharedStateRef = (0, $ieaan.useRef)(null);
    const [state, setState] = (0, $ieaan.useState)(()=>{
        if (id) {
            const shared = (0, $de6abad5311f963a$export$7f3d1916298b3c77)(id);
            sharedStateRef.current = shared;
            return shared.get() || {
                key: null
            };
        }
        return {
            key: null
        };
    });
    (0, $ieaan.useEffect)(()=>{
        if (!id || !sharedStateRef.current) return undefined;
        const sharedState = sharedStateRef.current;
        const subscriber = ()=>{
            const params = sharedState.get();
            if (params?.key !== undefined) setState((prev)=>{
                if (params.key !== prev.key) return params;
                return prev;
            });
        };
        sharedState.subscribe(subscriber);
        return ()=>{
            sharedState.unsubscribe(subscriber);
            sharedStateRef.current = null;
        };
    }, [
        id
    ]);
    const resolvedInnerSpace = contentInnerSpace === true ? 'large' : contentInnerSpace;
    const spacingProps = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        ...rest,
        innerSpace: !contentStyle && resolvedInnerSpace ? resolvedInnerSpace : undefined
    }, {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__content', 'dnb-no-focus', !contentStyle && resolvedInnerSpace && 'dnb-space')
    });
    if (!children) return null;
    const params = {
        ...rest
    };
    const activeKey = state.key !== null ? state.key : selectedKey;
    if (activeKey) params['aria-labelledby'] = (0, $11741836d1790446$export$b31873477fdbab59)(params, `${id}-tab-${activeKey}`);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)({
        id: id,
        children: children,
        selectedKey: selectedKey,
        contentStyle: contentStyle,
        animate: animate,
        contentInnerSpace: contentInnerSpace,
        ...rest
    }, params);
    let content = children;
    if (typeof children === 'function') {
        const stateToPass = state.key !== null ? state : {
            ...state,
            key: activeKey
        };
        content = children(stateToPass);
    }
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $c329544388f437e5$export$2e2bcd8739ae039), {
        role: "tabpanel",
        tabIndex: -1,
        id: `${id}-content`,
        element: contentStyle ? ({ ref: ref, ...props })=>{
            return (0, $60739c7e3f826d8d$exports.jsx)((0, $b72c82c3d5da1e25$export$2e2bcd8739ae039), {
                variant: contentStyle ? contentStyle : undefined,
                innerSpace: resolvedInnerSpace || undefined,
                ref: ref,
                ...props
            });
        } : 'div',
        ...spacingProps,
        duration: 600,
        animate: animate === true,
        ...params,
        children: content
    });
}



function $6f50effd50029855$var$CustomContent(props) {
    const { displayName: _displayName = 'CustomContent', title: _title = null, hash: _hash = null, selected: _selected = null, disabled: _disabled = null, className: className = null, children: children = null, id: id, ...rest } = props;
    const spacingProps = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(rest, {
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__content__inner', className)
    });
    if (id) {
        const contentWrapperProps = rest;
        return (0, $60739c7e3f826d8d$exports.jsx)((0, $26d57369cefb5383$export$2e2bcd8739ae039), {
            ...contentWrapperProps,
            id: id,
            children: children
        });
    }
    return (0, $60739c7e3f826d8d$exports.jsx)("div", {
        ...spacingProps,
        children: children
    });
}
var $6f50effd50029855$export$2e2bcd8739ae039 = $6f50effd50029855$var$CustomContent;





"use client";
const $eea10711b390990c$var$tabsDefaultProps = {
    data: null,
    content: null,
    contentStyle: null,
    contentInnerSpace: {
        top: 'large'
    },
    label: null,
    tabElement: 'button',
    selectedKey: null,
    align: 'left',
    tabsStyle: null,
    tabsInnerSpace: undefined,
    noBorder: false,
    navButtonEdge: false,
    onOpenTabNavigationFn: null,
    keepInDOM: false,
    preventRerender: false,
    scroll: null,
    skeleton: null,
    id: null,
    className: null,
    children: null,
    render: null,
    onChange: null,
    onMouseEnter: null,
    onClick: null,
    onFocus: null,
    breakout: true
};
function $eea10711b390990c$var$getSelectedKeyOrFallback(selectedKey, data) {
    let useKey = selectedKey;
    if (!useKey) useKey = data.reduce((acc, { selected: selected, key: key })=>selected ? key : acc, null) || data[0] && data[0].key;
    else {
        const keyExists = data.findIndex(({ key: key })=>key == selectedKey);
        if (keyExists === -1) useKey = data[0] && data[0].key;
    }
    return useKey;
}
function $eea10711b390990c$var$getData(props) {
    const addReactElement = (list, reactElem, reactElemIndex)=>{
        if (reactElem && reactElem.type === (0, $6f50effd50029855$export$2e2bcd8739ae039)) {
            const dataProps = props.children && Array.isArray(props.children) && props.children[reactElemIndex] || {};
            const componentProps = {
                ...reactElem.props
            };
            if (componentProps.title === null) delete componentProps.title;
            const { title: title, key: _key, hash: hash, ...rest } = {
                ...dataProps,
                ...componentProps,
                children: null
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(list).call(list, {
                title: title,
                key: (!_key && hash ? hash : _key) || (0, $11741836d1790446$export$c383cdd2a518017a)(title),
                content: reactElem,
                ...rest
            });
        }
    };
    let res = [];
    const data = !props.data && props.children ? props.children : props.data;
    if (Array.isArray(props.children) && props.children.some((element)=>typeof element === 'function' || (0, $ieaan.isValidElement)(element))) res = props.children.reduce((list, reactElem, i)=>{
        addReactElement(list, reactElem, i);
        return list;
    }, []);
    if (!Array.isArray(props.children) && (typeof props.children === 'function' || (0, $ieaan.isValidElement)(props.children))) addReactElement(res, props.children);
    if (!(res && res.length > 0)) {
        if (props.data && Array.isArray(data)) res = data;
        else if (typeof data === 'string') res = data[0] === '[' ? (0, (/*@__PURE__*/$parcel$interopDefault($1eb0299e6a3602cd$exports)))(data) : [];
        else if (data && typeof data === 'object') res = Object.entries(data).reduce((acc, [key, obj])=>{
            if (obj) (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(acc).call(acc, {
                key: key,
                ...obj
            });
            return acc;
        }, []);
    }
    return res || [];
}
function $eea10711b390990c$var$TabsComponent(ownProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(ownProps, $eea10711b390990c$var$tabsDefaultProps, {
        skeleton: context?.skeleton
    });
    const propsRef = (0, $ieaan.useRef)(props);
    propsRef.current = props;
    const tabsRef = (0, $ieaan.useRef)(null);
    const tablistRef = (0, $ieaan.useRef)(null);
    const cacheRef = (0, $ieaan.useRef)({});
    const listenForPropChangesRef = (0, $ieaan.useRef)(true);
    const _id = (0, $89089e429f32bd45$export$2e2bcd8739ae039)(ownProps.id);
    const sharedStateRef = (0, $ieaan.useRef)(null);
    const propChangeRef = (0, $ieaan.useRef)(false);
    const initialData = (0, $ieaan.useRef)($eea10711b390990c$var$getData(ownProps));
    const [data, setData] = (0, $ieaan.useState)(initialData.current);
    const [selectedKey, setSelectedKey] = (0, $ieaan.useState)(()=>$eea10711b390990c$var$getSelectedKeyOrFallback(ownProps.selectedKey, initialData.current));
    const [focusKey, setFocusKey] = (0, $ieaan.useState)(selectedKey);
    const [hasScrollbar, setHasScrollbar] = (0, $ieaan.useState)(false);
    const [isFirst, setIsFirst] = (0, $ieaan.useState)(undefined);
    const [isLast, setIsLast] = (0, $ieaan.useState)(undefined);
    const [prevDataSource, setPrevDataSource] = (0, $ieaan.useState)(ownProps.data || ownProps.children);
    const [prevSelectedKey, setPrevSelectedKey] = (0, $ieaan.useState)(ownProps.selectedKey);
    if (listenForPropChangesRef.current) {
        const dataSource = ownProps.data || ownProps.children;
        let currentData = data;
        if (prevDataSource !== dataSource) {
            setPrevDataSource(dataSource);
            const newData = $eea10711b390990c$var$getData(ownProps);
            setData(newData);
            currentData = newData;
            propChangeRef.current = true;
        }
        if (ownProps.selectedKey && prevSelectedKey !== ownProps.selectedKey) {
            setPrevSelectedKey(ownProps.selectedKey);
            setSelectedKey($eea10711b390990c$var$getSelectedKeyOrFallback(ownProps.selectedKey, currentData));
            propChangeRef.current = true;
        }
    }
    (0, $ieaan.useEffect)(()=>{
        listenForPropChangesRef.current = true;
    });
    const dataRef = (0, $ieaan.useRef)(data);
    dataRef.current = data;
    const selectedKeyRef = (0, $ieaan.useRef)(selectedKey);
    selectedKeyRef.current = selectedKey;
    const focusKeyRef = (0, $ieaan.useRef)(focusKey);
    focusKeyRef.current = focusKey;
    const hasScrollbarRef = (0, $ieaan.useRef)(hasScrollbar);
    hasScrollbarRef.current = hasScrollbar;
    const isFirstRef = (0, $ieaan.useRef)(isFirst);
    isFirstRef.current = isFirst;
    const isLastRef = (0, $ieaan.useRef)(isLast);
    isLastRef.current = isLast;
    const contextRef = (0, $ieaan.useRef)(context);
    contextRef.current = context;
    const getLastPosition = ()=>{
        if (typeof window !== 'undefined') try {
            const pos = parseFloat(window.localStorage.getItem(`tabs-pos-${_id}`));
            window.localStorage.removeItem(`tabs-pos-${_id}`);
            return isNaN(pos) ? -1 : pos;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to read last scroll position from localStorage:', e);
        }
        return -1;
    };
    const hasLastPosition = ()=>{
        return lastPositionRef.current > -1;
    };
    const lastPositionRef = (0, $ieaan.useRef)(getLastPosition());
    const hasLastUsedTab = ()=>{
        if (typeof window !== 'undefined') try {
            const key = window.localStorage.getItem(`tabs-last-${_id}`) || null;
            window.localStorage.removeItem(`tabs-last-${_id}`);
            return key;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to read last used tab from localStorage:', e);
        }
        return -1;
    };
    const saveLastUsedTab = ()=>{
        if (typeof window !== 'undefined') try {
            window.localStorage.setItem(`tabs-last-${_id}`, String(selectedKeyRef.current));
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to save last used tab to localStorage:', e);
        }
    };
    const saveLastPosition = (position = tablistRef.current?.scrollLeft)=>{
        if (typeof window !== 'undefined') try {
            window.localStorage.setItem(`tabs-pos-${_id}`, String(position));
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to save scroll position to localStorage:', e);
        }
    };
    const checkHasScrollbar = ()=>{
        if (!tablistRef.current) return false;
        const tablistElem = tablistRef.current;
        let tolerance = 1;
        const lastSnap = tablistElem.querySelector('.dnb-tabs__button__snap:last-of-type');
        if (lastSnap) {
            const lastButton = lastSnap.querySelector('.dnb-tabs__button');
            if (lastButton) {
                const buttonMargin = parseFloat(window.getComputedStyle(lastButton).marginRight) || 0;
                const snapMargin = parseFloat(window.getComputedStyle(lastSnap).marginRight) || 0;
                tolerance += Math.max(0, buttonMargin + snapMargin);
            }
        }
        return tablistElem.scrollWidth - tolerance > tablistElem.offsetWidth;
    };
    const setLeftPosition = (scrollLeft)=>{
        try {
            tablistRef.current.style.scrollBehavior = 'auto';
            tablistRef.current.scrollLeft = scrollLeft;
            tablistRef.current.style.scrollBehavior = 'smooth';
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to set scroll position:', e);
        }
    };
    const scrollToTab = (0, $ieaan.useCallback)(({ type: type, behavior: behavior = 'smooth' })=>{
        if (typeof window === 'undefined') return;
        if (globalThis.IS_TEST) behavior = 'auto';
        const delay = ()=>{
            try {
                if (hasScrollbarRef.current && tablistRef.current) {
                    const first = tablistRef.current.querySelector('.dnb-tabs__button__snap:first-of-type');
                    const isFirstItem = first.classList.contains(type);
                    const last = tablistRef.current.querySelector('.dnb-tabs__button__snap:last-of-type');
                    const isLastItem = last.classList.contains(type);
                    const elem = tablistRef.current.querySelector(`.dnb-tabs__button.${type}`);
                    const style = window.getComputedStyle(tabsRef.current);
                    const margin = parseFloat(style.marginLeft);
                    let padding = margin < 0 ? parseFloat(style.paddingLeft) : 0;
                    if (!isFirstItem && !isLastItem && parseFloat(style.paddingLeft) < 16) {
                        const navButton = tabsRef.current.querySelector('.dnb-tabs__scroll-nav-button:first-of-type');
                        const additionalSpace = parseFloat(window.getComputedStyle(navButton).width) * 1.5;
                        padding += additionalSpace;
                    }
                    const leftPadding = (margin < 0 ? Math.abs(margin) : 0) + padding + parseFloat(window.getComputedStyle(first).paddingLeft);
                    const offsetLeft = elem.offsetLeft;
                    const left = elem && !isFirstItem ? offsetLeft - leftPadding : 0;
                    if (behavior === 'auto') {
                        tablistRef.current.style.scrollBehavior = 'auto';
                        tablistRef.current.scrollLeft = left;
                        tablistRef.current.style.scrollBehavior = '';
                    } else tablistRef.current.scrollTo({
                        left: left,
                        behavior: behavior
                    });
                    setIsFirst(isFirstItem);
                    setIsLast(isLastItem);
                }
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to scroll to tab:', e);
            }
        };
        if (globalThis.IS_TEST) delay();
        else window.requestAnimationFrame(delay);
    }, []);
    const handleVerticalScroll = ()=>{
        if (propsRef.current.scroll && tablistRef.current && typeof tablistRef.current.scrollIntoView === 'function') tablistRef.current.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
    };
    const onTablistWheelHandler = (event)=>{
        if (event.ctrlKey || event.shiftKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        window.scrollBy({
            top: event.deltaY,
            behavior: 'auto'
        });
    };
    const setFocusOnTabButton = (0, $ieaan.useCallback)(()=>{
        try {
            const elem = tablistRef.current.querySelector('.dnb-tabs__button.focus');
            elem.focus({
                preventScroll: true
            });
            document.getElementById(`${_id}-content`);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to set focus on tab button:', e);
        }
    }, [
        _id
    ]);
    const getCurrentTitle = (key)=>{
        const useKey = key !== null && key !== void 0 ? key : selectedKeyRef.current;
        const current = dataRef.current.filter(({ key: k })=>k == useKey)[0];
        return current && current.title || null;
    };
    const getStepKey = (useKey, stateKey)=>{
        const currentData = dataRef.current.filter(({ disabled: disabled })=>!disabled);
        const currentIndex = currentData.reduce((acc, { key: key }, i)=>key == stateKey ? i : acc, -1);
        let nextIndex = currentIndex + Number(useKey);
        if (nextIndex < 0) nextIndex = currentData.length - 1;
        if (nextIndex >= currentData.length) nextIndex = 0;
        return currentData.reduce((acc, { key: key }, i)=>i === nextIndex ? key : acc, null);
    };
    const getEventArgs = (args)=>{
        const key = typeof args.selectedKey !== 'undefined' ? args.selectedKey : selectedKeyRef.current;
        return {
            key: key,
            selectedKey: selectedKeyRef.current,
            focusKey: focusKeyRef.current,
            title: getCurrentTitle(key),
            ...args
        };
    };
    const focusTab = (newFocusKey, event = null, mode = null)=>{
        if (mode === 'step' && parseFloat(String(newFocusKey))) newFocusKey = getStepKey(newFocusKey, focusKeyRef.current);
        listenForPropChangesRef.current = false;
        setFocusKey(newFocusKey);
        (0, $11741836d1790446$export$89a1e257278b2134)({
            props: propsRef.current
        }, 'onFocus', getEventArgs({
            event: event,
            focusKey: newFocusKey
        }));
    };
    (0, $486a01c56256a5f9$export$2e2bcd8739ae039)(()=>{
        setFocusOnTabButton();
    }, [
        focusKey
    ]);
    const openTab = (newSelectedKey, event = null, mode = null)=>{
        saveLastPosition();
        saveLastUsedTab();
        if (mode === 'step' && parseFloat(String(newSelectedKey))) newSelectedKey = getStepKey(newSelectedKey, selectedKeyRef.current);
        if (typeof newSelectedKey !== 'undefined') {
            listenForPropChangesRef.current = false;
            setSelectedKey(newSelectedKey);
            setFocusKey(newSelectedKey);
        }
        (0, $11741836d1790446$export$89a1e257278b2134)({
            props: propsRef.current
        }, 'onChange', getEventArgs({
            event: event,
            selectedKey: newSelectedKey
        }));
        if (propsRef.current.onOpenTabNavigationFn && typeof window !== 'undefined') try {
            propsRef.current.onOpenTabNavigationFn(newSelectedKey);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to call onOpenTabNavigationFn callback:', e);
        }
        if (sharedStateRef.current) sharedStateRef.current.update(getEventArgs({
            event: event,
            selectedKey: newSelectedKey
        }));
    };
    const hasHandledVerticalScroll = (0, $ieaan.useRef)(false);
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        if (!hasHandledVerticalScroll.current) {
            hasHandledVerticalScroll.current = true;
            return;
        }
        handleVerticalScroll();
    }, [
        selectedKey
    ]);
    const onResizeHandler = (0, $ieaan.useCallback)(()=>{
        const scrollbarVisible = checkHasScrollbar();
        setHasScrollbar(scrollbarVisible);
        hasScrollbarRef.current = scrollbarVisible;
        if (scrollbarVisible) {
            const data = dataRef.current;
            const key = selectedKeyRef.current;
            if (data.length > 0) {
                setIsFirst(key === data[0].key);
                setIsLast(key === data[data.length - 1].key);
            }
            scrollToTab({
                type: 'selected'
            });
        }
    }, [
        scrollToTab
    ]);
    if (ownProps.id && !sharedStateRef.current) {
        sharedStateRef.current = (0, $de6abad5311f963a$export$7f3d1916298b3c77)(ownProps.id);
        sharedStateRef.current.set({
            key: selectedKey,
            selectedKey: selectedKey,
            focusKey: focusKey,
            title: getCurrentTitle(selectedKey)
        }, {
            silent: true
        });
    }
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        let isMounted = true;
        const init = ()=>{
            if (isMounted && tablistRef.current) {
                const scrollbarVisible = checkHasScrollbar();
                const hasLP = lastPositionRef.current > -1;
                setHasScrollbar(scrollbarVisible);
                hasScrollbarRef.current = scrollbarVisible;
                if (hasLP) setLeftPosition(lastPositionRef.current);
                if (scrollbarVisible) {
                    const data = dataRef.current;
                    const key = selectedKeyRef.current;
                    if (data.length > 0) {
                        setIsFirst(key === data[0].key);
                        setIsLast(key === data[data.length - 1].key);
                    }
                    scrollToTab({
                        type: 'selected',
                        behavior: hasLP ? 'smooth' : 'auto'
                    });
                }
                if (hasLastUsedTab() !== null) setFocusOnTabButton();
            }
        };
        if (document.readyState === 'complete') init();
        else if (typeof window !== 'undefined') window.addEventListener('load', init);
        let resizeObserver;
        if (tabsRef.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(onResizeHandler);
            resizeObserver.observe(tabsRef.current);
        }
        return ()=>{
            isMounted = false;
            sharedStateRef.current = null;
            resizeObserver?.disconnect();
            if (typeof window !== 'undefined') window.removeEventListener('load', init);
        };
    }, []);
    const hasHandledPropChange = (0, $ieaan.useRef)(false);
    (0, $02a20abffd0fc9f2$export$2e2bcd8739ae039)(()=>{
        if (!hasHandledPropChange.current) {
            hasHandledPropChange.current = true;
            return;
        }
        if (sharedStateRef.current && propChangeRef.current) {
            propChangeRef.current = false;
            onResizeHandler();
            sharedStateRef.current.update(getEventArgs({
                selectedKey: selectedKey
            }));
        }
    }, [
        selectedKey,
        data
    ]);
    const focusFirstTab = (e)=>{
        const key = dataRef.current[0].key;
        focusTab(key, e, 'step');
        scrollToTab({
            type: 'focus'
        });
    };
    const focusLastTab = (e)=>{
        const d = dataRef.current;
        const key = d[d.length - 1].key;
        focusTab(key, e, 'step');
        scrollToTab({
            type: 'focus'
        });
    };
    const focusPrevTab = (e)=>{
        focusTab(-1, e, 'step');
        scrollToTab({
            type: 'focus'
        });
    };
    const focusNextTab = (e)=>{
        focusTab(1, e, 'step');
        scrollToTab({
            type: 'focus'
        });
    };
    const openPrevTab = (e)=>{
        openTab(-1, e, 'step');
        scrollToTab({
            type: 'selected'
        });
    };
    const openNextTab = (e)=>{
        openTab(1, e, 'step');
        scrollToTab({
            type: 'selected'
        });
    };
    const onTablistKeyDownHandler = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
            case 'ArrowLeft':
                e.preventDefault();
                focusPrevTab(e);
                break;
            case 'ArrowDown':
            case 'PageDown':
            case 'ArrowRight':
                e.preventDefault();
                focusNextTab(e);
                break;
            case 'Home':
                e.preventDefault();
                focusFirstTab(e);
                break;
            case 'End':
                e.preventDefault();
                focusLastTab(e);
                break;
        }
    };
    const getCurrentKey = (event)=>{
        let currentKey;
        try {
            const elem = (0, $83064abe1c16626d$export$aab59a836bba0c3)('dnb-tabs__button', event.target);
            currentKey = elem?.dataset?.tabKey;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs: Failed to get tab key from event target:', e);
        }
        return currentKey;
    };
    const onMouseEnterHandler = (event)=>{
        const key = getCurrentKey(event);
        if (key) (0, $11741836d1790446$export$89a1e257278b2134)({
            props: propsRef.current
        }, 'onMouseEnter', getEventArgs({
            event: event,
            selectedKey: key
        }));
    };
    const onClickHandler = (event)=>{
        const key = getCurrentKey(event);
        if (key) {
            const ret = (0, $11741836d1790446$export$89a1e257278b2134)({
                props: propsRef.current
            }, 'onClick', getEventArgs({
                event: event,
                selectedKey: key
            }));
            if (ret !== false) {
                openTab(key, event);
                scrollToTab({
                    type: 'selected'
                });
            }
        }
    };
    const onKeyDownHandler = (event)=>{
        if (event.key === 'Enter') try {
            const elem = document.getElementById(`${_id}-content`);
            elem.focus({
                preventScroll: true
            });
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Could not find the required <Tabs.Content id="${_id}-content" ... /> that provides role="tabpanel"`);
        }
    };
    const getContent = (key)=>{
        const { children: children, content: _content } = propsRef.current;
        const contentToRender = children || _content;
        let content = null;
        if (contentToRender) {
            if (typeof contentToRender === 'object' && contentToRender[key]) content = contentToRender[key];
            else if (typeof contentToRender === 'function') content = contentToRender(key);
            else if ((0, $ieaan.isValidElement)(contentToRender)) content = contentToRender;
        }
        if (!content) {
            let items = [];
            if (Array.isArray(dataRef.current)) items = dataRef.current;
            else if (Array.isArray(contentToRender)) items = contentToRender;
            if (items) content = items.filter(({ key: k })=>k && key && k == key).reduce((acc, { content: content })=>content || acc, null);
        }
        if (typeof content === 'function') {
            const Component = content;
            content = (0, $60739c7e3f826d8d$exports.jsx)(Component, {});
        }
        return content;
    };
    const renderWrapperRef = (0, $ieaan.useRef)(null);
    const renderTabsListRef = (0, $ieaan.useRef)(null);
    const renderContentRef = (0, $ieaan.useRef)(null);
    const renderTabsRef = (0, $ieaan.useRef)(null);
    const { className: className } = ownProps;
    const { ...attributes } = (0, $de502bdad3b5fb4d$export$d697c39a2985a4c)(ownProps, $eea10711b390990c$var$tabsDefaultProps);
    const wrapperSpacingParams = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)(ownProps, {
        ...attributes,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs', className)
    });
    const { prevButtonTitle: prevButtonTitle, nextButtonTitle: nextButtonTitle } = context.getTranslation?.(props)?.Tabs || {};
    renderWrapperRef.current = ({ children: children, ...rest })=>{
        const params = {
            ...wrapperSpacingParams
        };
        (0, $11741836d1790446$export$4ddc669a9a6a5940)(ownProps, params);
        delete params.contentInnerSpace;
        delete params.tabsInnerSpace;
        return (0, $60739c7e3f826d8d$exports.jsx)("div", {
            ...params,
            ...rest,
            children: children
        });
    };
    renderTabsListRef.current = ({ children: children, className: extraClassName, ...rest })=>{
        const { align: align, tabsStyle: tabsStyle, tabsInnerSpace: tabsInnerSpace, noBorder: noBorder, navButtonEdge: navButtonEdge, breakout: breakout } = propsRef.current;
        return (0, $60739c7e3f826d8d$exports.jsxs)("div", {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__tabs', align ? `dnb-tabs__tabs--${align}` : null, tabsStyle ? `dnb-section dnb-section--${tabsStyle}` : null, hasScrollbarRef.current && 'dnb-tabs--has-scrollbar', navButtonEdge && 'dnb-tabs--at-edge', noBorder && 'dnb-tabs__tabs--no-border', breakout && 'dnb-tabs__tabs--breakout', extraClassName),
            ref: tabsRef,
            style: tabsInnerSpace ? {
                paddingTop: `var(--spacing-${tabsInnerSpace === true ? 'large' : tabsInnerSpace})`
            } : undefined,
            ...rest,
            children: [
                (0, $60739c7e3f826d8d$exports.jsx)($eea10711b390990c$var$ScrollNavButton, {
                    onMouseDown: openPrevTab,
                    icon: "chevron_left",
                    title: prevButtonTitle,
                    className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(hasScrollbarRef.current && (typeof isFirstRef.current !== 'undefined' || hasLastPosition()) && 'dnb-tabs__scroll-nav-button--visible', isFirstRef.current && 'dnb-tabs__scroll-nav-button--hide')
                }),
                children,
                (0, $60739c7e3f826d8d$exports.jsx)($eea10711b390990c$var$ScrollNavButton, {
                    onMouseDown: openNextTab,
                    icon: "chevron_right",
                    title: nextButtonTitle,
                    className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(hasScrollbarRef.current && (typeof isLastRef.current !== 'undefined' || hasLastPosition()) && 'dnb-tabs__scroll-nav-button--visible', isLastRef.current && 'dnb-tabs__scroll-nav-button--hide')
                })
            ]
        });
    };
    renderContentRef.current = ()=>{
        const { preventRerender: preventRerender, keepInDOM: keepInDOM } = propsRef.current;
        const currentSelectedKey = selectedKeyRef.current;
        const currentData = dataRef.current;
        let content;
        if (preventRerender || keepInDOM) {
            if (keepInDOM) cacheRef.current = Object.entries(currentData).reduce((acc, [_idx, cur])=>{
                acc[cur.key] = {
                    ...cur,
                    content: getContent(cur.key)
                };
                return acc;
            }, {});
            else if (preventRerender) cacheRef.current = {
                ...cacheRef.current || {},
                [currentSelectedKey]: {
                    content: getContent(currentSelectedKey)
                }
            };
            content = Object.entries(cacheRef.current).map(([key, { content: cachedContent }])=>{
                const hide = key !== String(currentSelectedKey);
                return (0, $60739c7e3f826d8d$exports.jsx)("div", {
                    "aria-hidden": hide ? true : undefined,
                    className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__cached', hide && 'dnb-tabs__cached--hidden'),
                    children: cachedContent
                }, key);
            });
        } else content = getContent(currentSelectedKey);
        if (!sharedStateRef.current && !content) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`No content was given to the Tabs component!
Tip: Check out other solutions like <Tabs.Content id="unique">Your content, outside of the Tabs component</Tabs.Content>
`);
        return (0, $60739c7e3f826d8d$exports.jsx)((0, $26d57369cefb5383$export$2e2bcd8739ae039), {
            id: _id,
            selectedKey: currentSelectedKey,
            contentStyle: propsRef.current.contentStyle,
            contentInnerSpace: propsRef.current.contentInnerSpace,
            animate: propsRef.current.keepInDOM,
            children: content
        });
    };
    renderTabsRef.current = (extraProps = {})=>{
        const mergedProps = propsRef.current;
        const { label: label, skeleton: skeleton, tabElement: tabElement } = {
            ...mergedProps,
            ...extraProps
        };
        const currentData = dataRef.current;
        const currentFocusKey = focusKeyRef.current;
        const currentSelectedKey = selectedKeyRef.current;
        const currentContext = contextRef.current;
        const TabElement = tabElement || 'button';
        const tabs = currentData.map(({ title: title, key: key, disabled: disabled = false, to: to, href: href })=>{
            const itemParams = {
                to: to,
                href: href
            };
            const isFocus = currentFocusKey == key;
            const isSelected = currentSelectedKey == key;
            if (isSelected) itemParams['aria-controls'] = `${_id}-content`;
            if (disabled) {
                itemParams.disabled = true;
                itemParams['aria-disabled'] = true;
            }
            if (TabElement === 'button') itemParams.type = 'button';
            (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(itemParams, skeleton, currentContext);
            return (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__button__snap', isFocus && 'focus', isSelected && 'selected'),
                children: (0, $60739c7e3f826d8d$exports.jsxs)(TabElement, {
                    role: "tab",
                    tabIndex: -1,
                    id: `${_id}-tab-${key}`,
                    "aria-selected": isSelected,
                    className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__button', isFocus && 'focus', isSelected && 'selected'),
                    onMouseEnter: onMouseEnterHandler,
                    onClick: onClickHandler,
                    onKeyUp: onKeyDownHandler,
                    "data-tab-key": key,
                    ...itemParams,
                    children: [
                        (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__button__title', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)('font', skeleton, currentContext)),
                            children: title
                        }),
                        (0, $60739c7e3f826d8d$exports.jsx)($eea10711b390990c$export$8ca53608f6ef5f6f, {
                            children: title
                        })
                    ]
                })
            }, `tab-${key}`);
        });
        const params = {};
        if (label) params['aria-label'] = label;
        if (currentSelectedKey) params['aria-labelledby'] = (0, $11741836d1790446$export$b31873477fdbab59)(params, `${_id}-tab-${currentSelectedKey}`);
        return (0, $60739c7e3f826d8d$exports.jsx)("div", {
            role: "tablist",
            className: "dnb-tabs__tabs__tablist",
            tabIndex: 0,
            onKeyDown: onTablistKeyDownHandler,
            onWheelCapture: onTablistWheelHandler,
            ref: tablistRef,
            ...params,
            children: tabs
        });
    };
    const Wrapper = (0, $ieaan.useMemo)(()=>{
        const C = (p)=>renderWrapperRef.current(p);
        C.displayName = 'TabsWrapper';
        return C;
    }, []);
    const TabsList = (0, $ieaan.useMemo)(()=>{
        const C = (p)=>renderTabsListRef.current(p);
        C.displayName = 'TabsList';
        return C;
    }, []);
    const Content = (0, $ieaan.useMemo)(()=>{
        const C = ()=>renderContentRef.current();
        C.displayName = 'TabContent';
        return C;
    }, []);
    const TabItems = (0, $ieaan.useMemo)(()=>{
        const C = (p)=>renderTabsRef.current(p);
        C.displayName = 'Tabs';
        return C;
    }, []);
    if (typeof props.render === 'function') return props.render({
        Wrapper: Wrapper,
        Content: Content,
        TabsList: TabsList,
        Tabs: TabItems
    });
    return (0, $60739c7e3f826d8d$exports.jsxs)(Wrapper, {
        children: [
            (0, $60739c7e3f826d8d$exports.jsx)(TabsList, {
                children: (0, $60739c7e3f826d8d$exports.jsx)(TabItems, {})
            }),
            (0, $60739c7e3f826d8d$exports.jsx)(Content, {})
        ]
    });
}
$eea10711b390990c$var$TabsComponent.displayName = 'Tabs';
const $eea10711b390990c$var$Tabs = Object.assign((0, $ieaan.memo)($eea10711b390990c$var$TabsComponent), {
    Content: (0, $6f50effd50029855$export$2e2bcd8739ae039),
    ContentWrapper: (0, $26d57369cefb5383$export$2e2bcd8739ae039)
});
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($eea10711b390990c$var$Tabs, {
    _supportsSpacingProps: true
});
var $eea10711b390990c$export$2e2bcd8739ae039 = $eea10711b390990c$var$Tabs;
const $eea10711b390990c$export$8ca53608f6ef5f6f = ({ children: children })=>{
    return (0, $60739c7e3f826d8d$exports.jsx)("span", {
        "aria-hidden": true,
        hidden: true,
        className: "dnb-dummy",
        children: children
    });
};
const $eea10711b390990c$var$ScrollNavButton = (props)=>{
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
        size: "medium",
        variant: "primary",
        tabIndex: -1,
        bounding: true,
        "aria-hidden": true,
        ...props,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-tabs__scroll-nav-button', props.className)
    });
};



parcelRequire("ieaan");
var $9bb40a131bb21204$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bb40a131bb21204$var$ReactIs, $9bb40a131bb21204$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$9bb40a131bb21204$exports = (parcelRequire("iW5Se"))();



parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");
const $156c1d4c5addba0b$var$isString = (obj)=>typeof obj === 'string';
const $156c1d4c5addba0b$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $156c1d4c5addba0b$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $156c1d4c5addba0b$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $156c1d4c5addba0b$var$lastOfPathSeparatorRegExp = /###/g;
const $156c1d4c5addba0b$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($156c1d4c5addba0b$var$lastOfPathSeparatorRegExp, '.') : key;
const $156c1d4c5addba0b$var$canNotTraverseDeeper = (object)=>!object || $156c1d4c5addba0b$var$isString(object);
const $156c1d4c5addba0b$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$156c1d4c5addba0b$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($156c1d4c5addba0b$var$canNotTraverseDeeper(object)) return {};
        const key = $156c1d4c5addba0b$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($156c1d4c5addba0b$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $156c1d4c5addba0b$var$cleanKey(stack[stackIndex])
    };
};
const $156c1d4c5addba0b$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $156c1d4c5addba0b$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $156c1d4c5addba0b$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $156c1d4c5addba0b$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $156c1d4c5addba0b$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $156c1d4c5addba0b$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $156c1d4c5addba0b$var$getPath(data, key);
    if (value !== undefined) return value;
    return $156c1d4c5addba0b$var$getPath(defaultData, key);
};
const $156c1d4c5addba0b$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($156c1d4c5addba0b$var$isString(target[prop]) || target[prop] instanceof String || $156c1d4c5addba0b$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $156c1d4c5addba0b$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $156c1d4c5addba0b$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $156c1d4c5addba0b$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $156c1d4c5addba0b$var$escape = (data)=>{
    if ($156c1d4c5addba0b$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$156c1d4c5addba0b$var$_entityMap[s]);
    return data;
};
class $156c1d4c5addba0b$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $156c1d4c5addba0b$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $156c1d4c5addba0b$var$looksLikeObjectPathRegExpCache = new $156c1d4c5addba0b$var$RegExpCache(20);
const $156c1d4c5addba0b$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $156c1d4c5addba0b$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $156c1d4c5addba0b$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $156c1d4c5addba0b$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $156c1d4c5addba0b$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $156c1d4c5addba0b$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $156c1d4c5addba0b$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $156c1d4c5addba0b$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$156c1d4c5addba0b$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($156c1d4c5addba0b$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $156c1d4c5addba0b$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $156c1d4c5addba0b$var$Logger(this.logger, options);
    }
}
var $156c1d4c5addba0b$var$baseLogger = new $156c1d4c5addba0b$var$Logger();
class $156c1d4c5addba0b$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
class $156c1d4c5addba0b$var$ResourceStore extends $156c1d4c5addba0b$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($156c1d4c5addba0b$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $156c1d4c5addba0b$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$156c1d4c5addba0b$var$isString(key)) return result;
        return $156c1d4c5addba0b$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $156c1d4c5addba0b$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($156c1d4c5addba0b$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $156c1d4c5addba0b$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $156c1d4c5addba0b$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $156c1d4c5addba0b$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $156c1d4c5addba0b$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $156c1d4c5addba0b$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $156c1d4c5addba0b$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $156c1d4c5addba0b$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$156c1d4c5addba0b$var$PATH_KEY]: path } = selector($156c1d4c5addba0b$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $156c1d4c5addba0b$var$shouldHandleAsObject = (res)=>!$156c1d4c5addba0b$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $156c1d4c5addba0b$var$Translator extends $156c1d4c5addba0b$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $156c1d4c5addba0b$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $156c1d4c5addba0b$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$156c1d4c5addba0b$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $156c1d4c5addba0b$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $156c1d4c5addba0b$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$156c1d4c5addba0b$var$isString(opt.count);
        const hasDefaultValue = $156c1d4c5addba0b$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $156c1d4c5addba0b$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($156c1d4c5addba0b$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $156c1d4c5addba0b$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $156c1d4c5addba0b$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $156c1d4c5addba0b$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$156c1d4c5addba0b$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $156c1d4c5addba0b$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $156c1d4c5addba0b$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($156c1d4c5addba0b$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$156c1d4c5addba0b$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($156c1d4c5addba0b$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$156c1d4c5addba0b$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $156c1d4c5addba0b$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $156c1d4c5addba0b$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $156c1d4c5addba0b$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($156c1d4c5addba0b$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($156c1d4c5addba0b$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($156c1d4c5addba0b$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($156c1d4c5addba0b$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (!codes.includes(fc)) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $156c1d4c5addba0b$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $156c1d4c5addba0b$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $156c1d4c5addba0b$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $156c1d4c5addba0b$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $156c1d4c5addba0b$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $156c1d4c5addba0b$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$156c1d4c5addba0b$var$suffixesOrder[pluralCategory1] - $156c1d4c5addba0b$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $156c1d4c5addba0b$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $156c1d4c5addba0b$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $156c1d4c5addba0b$var$isString(key)) {
        path = $156c1d4c5addba0b$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $156c1d4c5addba0b$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $156c1d4c5addba0b$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $156c1d4c5addba0b$var$Interpolator {
    constructor(options = {}){
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $156c1d4c5addba0b$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $156c1d4c5addba0b$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $156c1d4c5addba0b$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $156c1d4c5addba0b$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $156c1d4c5addba0b$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $156c1d4c5addba0b$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $156c1d4c5addba0b$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $156c1d4c5addba0b$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $156c1d4c5addba0b$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $156c1d4c5addba0b$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($156c1d4c5addba0b$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$156c1d4c5addba0b$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $156c1d4c5addba0b$var$regexSafe(this.escape(val)) : $156c1d4c5addba0b$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $156c1d4c5addba0b$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$156c1d4c5addba0b$var$isString(value) && !this.useRawValueToEscape) value = $156c1d4c5addba0b$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$156c1d4c5addba0b$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$156c1d4c5addba0b$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$156c1d4c5addba0b$var$isString(value)) return value;
            if (!$156c1d4c5addba0b$var$isString(value)) value = $156c1d4c5addba0b$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $156c1d4c5addba0b$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $156c1d4c5addba0b$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($156c1d4c5addba0b$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $156c1d4c5addba0b$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($156c1d4c5addba0b$var$getCleanedCode(l), o)(v);
class $156c1d4c5addba0b$var$Formatter {
    constructor(options = {}){
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $156c1d4c5addba0b$var$createCachedFormatter : $156c1d4c5addba0b$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $156c1d4c5addba0b$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $156c1d4c5addba0b$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $156c1d4c5addba0b$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $156c1d4c5addba0b$var$Connector extends $156c1d4c5addba0b$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $156c1d4c5addba0b$var$pushPath(q.loaded, [
                lng
            ], ns);
            $156c1d4c5addba0b$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($156c1d4c5addba0b$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($156c1d4c5addba0b$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $156c1d4c5addba0b$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($156c1d4c5addba0b$var$isString(args[1])) ret.defaultValue = args[1];
            if ($156c1d4c5addba0b$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $156c1d4c5addba0b$var$transformOptions = (options)=>{
    if ($156c1d4c5addba0b$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($156c1d4c5addba0b$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($156c1d4c5addba0b$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $156c1d4c5addba0b$var$noop = ()=>{};
const $156c1d4c5addba0b$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $156c1d4c5addba0b$var$I18n extends $156c1d4c5addba0b$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $156c1d4c5addba0b$var$transformOptions(options);
        this.services = {};
        this.logger = $156c1d4c5addba0b$var$baseLogger;
        this.modules = {
            external: []
        };
        $156c1d4c5addba0b$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($156c1d4c5addba0b$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $156c1d4c5addba0b$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$156c1d4c5addba0b$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $156c1d4c5addba0b$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $156c1d4c5addba0b$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $156c1d4c5addba0b$var$Formatter;
            const lu = new $156c1d4c5addba0b$var$LanguageUtil(this.options);
            this.store = new $156c1d4c5addba0b$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $156c1d4c5addba0b$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $156c1d4c5addba0b$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $156c1d4c5addba0b$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $156c1d4c5addba0b$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $156c1d4c5addba0b$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $156c1d4c5addba0b$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $156c1d4c5addba0b$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $156c1d4c5addba0b$var$noop) {
        let usedCallback = callback;
        const usedLng = $156c1d4c5addba0b$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $156c1d4c5addba0b$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $156c1d4c5addba0b$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $156c1d4c5addba0b$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $156c1d4c5addba0b$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($156c1d4c5addba0b$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($156c1d4c5addba0b$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($156c1d4c5addba0b$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if ($156c1d4c5addba0b$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $156c1d4c5addba0b$var$LanguageUtil($156c1d4c5addba0b$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $156c1d4c5addba0b$var$I18n(options, callback);
        instance.createInstance = $156c1d4c5addba0b$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $156c1d4c5addba0b$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $156c1d4c5addba0b$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $156c1d4c5addba0b$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $156c1d4c5addba0b$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $156c1d4c5addba0b$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $156c1d4c5addba0b$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $156c1d4c5addba0b$export$2e2bcd8739ae039 = $156c1d4c5addba0b$var$I18n.createInstance();
const $156c1d4c5addba0b$export$99152e8d49ca4e7d = $156c1d4c5addba0b$export$2e2bcd8739ae039.createInstance;
const $156c1d4c5addba0b$export$147ec2801e896265 = $156c1d4c5addba0b$export$2e2bcd8739ae039.dir;
const $156c1d4c5addba0b$export$2cd8252107eb640b = $156c1d4c5addba0b$export$2e2bcd8739ae039.init;
const $156c1d4c5addba0b$export$d3d08d944062d7e = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadResources;
const $156c1d4c5addba0b$export$a5d9bf5d83fcab09 = $156c1d4c5addba0b$export$2e2bcd8739ae039.reloadResources;
const $156c1d4c5addba0b$export$1f96ae73734a86cc = $156c1d4c5addba0b$export$2e2bcd8739ae039.use;
const $156c1d4c5addba0b$export$61465194746e7fd2 = $156c1d4c5addba0b$export$2e2bcd8739ae039.changeLanguage;
const $156c1d4c5addba0b$export$f90d180fc7da3b3b = $156c1d4c5addba0b$export$2e2bcd8739ae039.getFixedT;
const $156c1d4c5addba0b$export$625550452a3fa3ec = $156c1d4c5addba0b$export$2e2bcd8739ae039.t;
const $156c1d4c5addba0b$export$f7e9f41ea797a17 = $156c1d4c5addba0b$export$2e2bcd8739ae039.exists;
const $156c1d4c5addba0b$export$2b4b218e406d2d00 = $156c1d4c5addba0b$export$2e2bcd8739ae039.setDefaultNamespace;
const $156c1d4c5addba0b$export$93d9ee97c1ad3f31 = $156c1d4c5addba0b$export$2e2bcd8739ae039.hasLoadedNamespace;
const $156c1d4c5addba0b$export$83be934b53fff43b = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadNamespaces;
const $156c1d4c5addba0b$export$8cd7e7a54fa865bc = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadLanguages;


var $863e05d76e4207f8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $863e05d76e4207f8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $ac97bd3bcf31462d$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $ac97bd3bcf31462d$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($863e05d76e4207f8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($ac97bd3bcf31462d$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $ac97bd3bcf31462d$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $ac97bd3bcf31462d$var$i = /^\s*$/, $ac97bd3bcf31462d$var$s = Object.create(null);
function $ac97bd3bcf31462d$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($ac97bd3bcf31462d$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $ac97bd3bcf31462d$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $ac97bd3bcf31462d$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($ac97bd3bcf31462d$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $ac97bd3bcf31462d$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $ac97bd3bcf31462d$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $ac97bd3bcf31462d$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $ac97bd3bcf31462d$var$a("", t);
        }, "");
    }
};
var $ac97bd3bcf31462d$export$2e2bcd8739ae039 = $ac97bd3bcf31462d$var$c;


const $788ef5f0a22132b3$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($788ef5f0a22132b3$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $788ef5f0a22132b3$var$alreadyWarned = {};
const $788ef5f0a22132b3$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($788ef5f0a22132b3$export$844ec244b1367d54(msg) && $788ef5f0a22132b3$var$alreadyWarned[msg]) return;
    if ($788ef5f0a22132b3$export$844ec244b1367d54(msg)) $788ef5f0a22132b3$var$alreadyWarned[msg] = new Date();
    $788ef5f0a22132b3$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $788ef5f0a22132b3$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $788ef5f0a22132b3$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $788ef5f0a22132b3$var$loadedClb(i18n, cb));
};
const $788ef5f0a22132b3$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($788ef5f0a22132b3$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $788ef5f0a22132b3$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $788ef5f0a22132b3$var$loadedClb(i18n, cb));
};
const $788ef5f0a22132b3$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $788ef5f0a22132b3$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $788ef5f0a22132b3$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($788ef5f0a22132b3$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $788ef5f0a22132b3$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $788ef5f0a22132b3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $80cec8eabd80f098$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $80cec8eabd80f098$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $80cec8eabd80f098$var$unescapeHtmlEntity = (m)=>$80cec8eabd80f098$var$htmlEntities[m];
const $80cec8eabd80f098$export$e8bacd2802a88316 = (text)=>text.replace($80cec8eabd80f098$var$matchHtmlEntity, $80cec8eabd80f098$var$unescapeHtmlEntity);


let $5acb5a01c1fced2e$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $80cec8eabd80f098$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $5acb5a01c1fced2e$export$2e2366488d12e20d = (options = {})=>{
    $5acb5a01c1fced2e$var$defaultOptions = {
        ...$5acb5a01c1fced2e$var$defaultOptions,
        ...options
    };
};
const $5acb5a01c1fced2e$export$212bb2fc580a90a8 = ()=>$5acb5a01c1fced2e$var$defaultOptions;


let $cef3f991bd1debe1$var$i18nInstance;
const $cef3f991bd1debe1$export$a039134f2fc7e0 = (instance)=>{
    $cef3f991bd1debe1$var$i18nInstance = instance;
};
const $cef3f991bd1debe1$export$64af334f494c2f47 = ()=>$cef3f991bd1debe1$var$i18nInstance;



const $c5570c9d85f055d7$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $c5570c9d85f055d7$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $c5570c9d85f055d7$var$getAsArray(children) : children;
};
const $c5570c9d85f055d7$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $ieaan.isValidElement));
const $c5570c9d85f055d7$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $c5570c9d85f055d7$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $c5570c9d85f055d7$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $c5570c9d85f055d7$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) return;
            if ($c5570c9d85f055d7$var$hasChildren(child)) getData($c5570c9d85f055d7$var$getChildren(child));
            else if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && !(0, $ieaan.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $c5570c9d85f055d7$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $c5570c9d85f055d7$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $ieaan.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(childChildren) ? childChildren : $c5570c9d85f055d7$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $c5570c9d85f055d7$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $c5570c9d85f055d7$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9_-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9_-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $c5570c9d85f055d7$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $c5570c9d85f055d7$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) return;
            if ($c5570c9d85f055d7$var$hasChildren(child)) getData($c5570c9d85f055d7$var$getChildren(child));
            else if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && !(0, $ieaan.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $c5570c9d85f055d7$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $ac97bd3bcf31462d$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $c5570c9d85f055d7$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $c5570c9d85f055d7$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $ieaan.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $ieaan.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $ieaan.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $ieaan.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $ieaan.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $c5570c9d85f055d7$var$getAsArray(reactNode);
        const astNodes = $c5570c9d85f055d7$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(val)) props[p] = (0, $80cec8eabd80f098$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $c5570c9d85f055d7$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $ieaan.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $c5570c9d85f055d7$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($c5570c9d85f055d7$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $ieaan.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $ieaan.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $c5570c9d85f055d7$var$getAsArray($c5570c9d85f055d7$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $ieaan.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $5acb5a01c1fced2e$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $ieaan.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $c5570c9d85f055d7$var$getAsArray(children || []));
    return $c5570c9d85f055d7$var$getChildren(result[0]);
};
const $c5570c9d85f055d7$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $ieaan.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $ieaan.createElement)((0, $ieaan.Fragment), null, comp);
    }
    return (0, $ieaan.createElement)(Componentized, {
        key: componentKey
    });
};
const $c5570c9d85f055d7$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$c5570c9d85f055d7$var$fixComponentProps(c, index, translation));
const $c5570c9d85f055d7$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $c5570c9d85f055d7$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $c5570c9d85f055d7$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $c5570c9d85f055d7$var$generateArrayComponents(components, translation);
    if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(components)) return $c5570c9d85f055d7$var$generateObjectComponents(components, translation);
    (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $c5570c9d85f055d7$var$isComponentsMap = (object)=>{
    if (!(0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $c5570c9d85f055d7$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $5acb5a01c1fced2e$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $c5570c9d85f055d7$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $156c1d4c5addba0b$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $c5570c9d85f055d7$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $c5570c9d85f055d7$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($c5570c9d85f055d7$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $c5570c9d85f055d7$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $ieaan.createElement)(useAsParent, additionalProps, content) : content;
}



var $ieaan = parcelRequire("ieaan");




const $de8f8501ef445db0$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $5acb5a01c1fced2e$export$2e2366488d12e20d)(instance.options.react);
        (0, $cef3f991bd1debe1$export$a039134f2fc7e0)(instance);
    }
};


const $631fe60334437123$export$5603ab5ced17ce64 = (0, $ieaan.createContext)();
class $631fe60334437123$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $631fe60334437123$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $631fe60334437123$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $631fe60334437123$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $338e4881dec88176$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $c5570c9d85f055d7$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");


class $8580cce1ac0000dc$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $8580cce1ac0000dc$export$aa9e222d9ffc5d1b);
    }
}


const $57f93f3335fe4ee5$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $57f93f3335fe4ee5$var$entityPattern = new RegExp(Object.keys($57f93f3335fe4ee5$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $57f93f3335fe4ee5$export$5cfeaa4af6841c8f = (text)=>text.replace($57f93f3335fe4ee5$var$entityPattern, (match)=>$57f93f3335fe4ee5$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5190711d0a96d82a$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $ieaan = parcelRequire("ieaan");



const $6c6599c4dd940db0$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(type, props, ...children);
};
const $6c6599c4dd940db0$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5190711d0a96d82a$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $57f93f3335fe4ee5$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $8580cce1ac0000dc$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $8580cce1ac0000dc$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $6c6599c4dd940db0$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $8580cce1ac0000dc$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $bfc87515c4f028e4$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $6c6599c4dd940db0$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {}, translation);
    }
}
$bfc87515c4f028e4$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $25d79e41dbbc3fb1$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $bfc87515c4f028e4$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$25d79e41dbbc3fb1$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $ieaan = parcelRequire("ieaan");
var $e55f76bdefc07083$exports = {};
'use strict';

$e55f76bdefc07083$exports = (parcelRequire("2EWYt"));




const $0a2dcaaf70b12078$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $788ef5f0a22132b3$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $0a2dcaaf70b12078$var$notReadySnapshot = {
    t: $0a2dcaaf70b12078$var$notReadyT,
    ready: false
};
const $0a2dcaaf70b12078$var$dummySubscribe = ()=>()=>{};
const $0a2dcaaf70b12078$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $631fe60334437123$export$ea171b67e3820290)();
    if (!i18n) (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $ieaan.useMemo)(()=>({
            ...(0, $5acb5a01c1fced2e$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $ieaan.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $ieaan.useRef)(0);
    const subscribe = (0, $ieaan.useCallback)((callback)=>{
        if (!i18n) return $0a2dcaaf70b12078$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $ieaan.useRef)();
    const getSnapshot = (0, $ieaan.useCallback)(()=>{
        if (!i18n) return $0a2dcaaf70b12078$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $788ef5f0a22132b3$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $ieaan.useState)(0);
    const { t: t, ready: ready } = (0, $e55f76bdefc07083$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $ieaan.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $788ef5f0a22132b3$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $788ef5f0a22132b3$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $ieaan.useRef)(null);
    const wrapperLangRef = (0, $ieaan.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $ieaan.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $788ef5f0a22132b3$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $788ef5f0a22132b3$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};



var $ieaan = parcelRequire("ieaan");


const $897a72ae0fd4d410$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $ieaan.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $788ef5f0a22132b3$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $ieaan.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $ieaan.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $2f8b76f51aefa2ea$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $ieaan = parcelRequire("ieaan");

function $b8cab056955ecb0d$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $ieaan.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $ieaan.createElement)((0, $631fe60334437123$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");


const $05248fcac2fb08ab$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $bc217581721fce81$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $05248fcac2fb08ab$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $ieaan.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $631fe60334437123$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $788ef5f0a22132b3$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $1523e0e577b08933$export$324d90190a8b822a = ()=>'';
const $1523e0e577b08933$export$2da9be4cfdb689b1 = ()=>'';
const $1523e0e577b08933$export$98e628dec113755e = ()=>'';
const $1523e0e577b08933$export$2e6c959c16ff56b8 = ()=>'';
const $1523e0e577b08933$export$4e35d5c922a95490 = ()=>'';
const $1523e0e577b08933$export$720a3b9db04b7a0f = ()=>'';



var $3b462a98d423171a$exports = {};

$parcel$export($3b462a98d423171a$exports, "Container", function () { return $c5056bdb3fca4cb3$export$2e2bcd8739ae039; });
$parcel$export($3b462a98d423171a$exports, "Item", function () { return $19d7ef6c1640e749$export$2e2bcd8739ae039; });





function $c5056bdb3fca4cb3$var$GridContainer(props) {
    const { columns: columns, rowGap: rowGap, columnGap: columnGap, style: style, className: className, children: children, element: element = 'div', ...rest } = props;
    const styleObj = {
        ...$c5056bdb3fca4cb3$var$compute(columns),
        ...style
    };
    const n = 'dnb-grid-container';
    const unsetClasses = [];
    for(const prop in styleObj)if (styleObj[prop] === 'unset') {
        const disableClass = `${n}__disabled--${prop.replace(/--([a-z]+)-.*/, '$1')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($1c1c6bce1a869e4d$exports)))(unsetClasses).call(unsetClasses, disableClass);
    }
    const cn = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(n, className, columnGap && `${n}--column-gap-${columnGap === true ? 'small' : columnGap}`, rowGap && `${n}--row-gap-${rowGap === true ? 'small' : rowGap}`, unsetClasses);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: cn,
        style: styleObj,
        ...rest,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($c5056bdb3fca4cb3$var$GridContainer, {
    _supportsSpacingProps: true
});
var $c5056bdb3fca4cb3$export$2e2bcd8739ae039 = $c5056bdb3fca4cb3$var$GridContainer;
function $c5056bdb3fca4cb3$var$compute(columns) {
    if (!columns) return null;
    const result = {};
    if (typeof columns === 'number') columns = {
        small: columns,
        medium: columns,
        large: columns
    };
    for(const media in columns){
        const value = columns?.[media];
        result[`--${media}-columns`] = value || 'unset';
    }
    return result;
}






const $19d7ef6c1640e749$var$media = [
    'small',
    'medium',
    'large'
];
function $19d7ef6c1640e749$var$GridItem(props) {
    const { element: element = 'div', span: span, className: className, style: style, children: children, ...rest } = props;
    const styleObj = {
        ...$19d7ef6c1640e749$var$compute(span, 'c'),
        ...style
    };
    const cn = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-grid-item', className);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: cn,
        style: styleObj,
        ...rest,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($19d7ef6c1640e749$var$GridItem, {
    _supportsSpacingProps: true
});
var $19d7ef6c1640e749$export$2e2bcd8739ae039 = $19d7ef6c1640e749$var$GridItem;
function $19d7ef6c1640e749$var$compute(span, modifier) {
    if (!span) return null;
    const result = {};
    const collect = (media, values)=>{
        values.forEach((value, i)=>{
            const pos = i === 0 ? 's' : 'e';
            if (i === 1 && value > 0) value += 1;
            if (value === 'end') value = '-1';
            result[makeStyle(media, pos)] = value;
        });
    };
    if (Array.isArray(span)) $19d7ef6c1640e749$var$media.forEach((media)=>{
        collect(media, span);
    });
    else for(const media in span){
        const values = span?.[media];
        if (values === 'full') {
            result[makeStyle(media, 's')] = '1';
            result[makeStyle(media, 'e')] = '-1';
        } else if (Array.isArray(values)) collect(media, values);
    }
    return result;
    function makeStyle(media, pos) {
        return `--${media}-${modifier}-${pos}`;
    }
}





parcelRequire("ieaan");

const $9bb65aaaaefb5cdf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $9bb65aaaaefb5cdf$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $9bb65aaaaefb5cdf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $47fded15351fa5db$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $65a63d0ee89ffdf6$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $65a63d0ee89ffdf6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $65a63d0ee89ffdf6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $65a63d0ee89ffdf6$export$cbf60ecb96cbb82f = {
    date: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $a001ca238ce744d1$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $a001ca238ce744d1$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$a001ca238ce744d1$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $a04bc661e865b431$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $4e26238e924f114e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $4e26238e924f114e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $4e26238e924f114e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $4e26238e924f114e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $4e26238e924f114e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $4e26238e924f114e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $4e26238e924f114e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $4e26238e924f114e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4e26238e924f114e$var$ordinalNumber,
    era: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4e26238e924f114e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $d90c374667fc9bd5$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $d90c374667fc9bd5$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $d90c374667fc9bd5$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d90c374667fc9bd5$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d90c374667fc9bd5$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $70cb8aaf6e245039$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $8a8f5125e173ca9f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $8a8f5125e173ca9f$var$parseOrdinalNumberPattern = /\d+/i;
const $8a8f5125e173ca9f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $8a8f5125e173ca9f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $8a8f5125e173ca9f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $8a8f5125e173ca9f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8a8f5125e173ca9f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $8a8f5125e173ca9f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $8a8f5125e173ca9f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $8a8f5125e173ca9f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $8a8f5125e173ca9f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $8a8f5125e173ca9f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $8a8f5125e173ca9f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $70cb8aaf6e245039$export$fdaf2fd6d7edde95)({
        matchPattern: $8a8f5125e173ca9f$var$matchOrdinalNumberPattern,
        parsePattern: $8a8f5125e173ca9f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8a8f5125e173ca9f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $ef15c8be5320e65f$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $9bb65aaaaefb5cdf$export$2c14ff85d6318973),
    formatLong: (0, $65a63d0ee89ffdf6$export$cbf60ecb96cbb82f),
    formatRelative: (0, $a001ca238ce744d1$export$8fbbfd65594f46a0),
    localize: (0, $4e26238e924f114e$export$b3bd0bc58e36cd63),
    match: (0, $8a8f5125e173ca9f$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$ef15c8be5320e65f$export$2e2bcd8739ae039 = $ef15c8be5320e65f$export$137380d9ce54f7f;


let $36bdc9e07551bf7d$var$defaultOptions = {};
function $36bdc9e07551bf7d$export$430a3269e24b912e() {
    return $36bdc9e07551bf7d$var$defaultOptions;
}
function $36bdc9e07551bf7d$export$95365be1b0704abc(newOptions) {
    $36bdc9e07551bf7d$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $37682150499c1c6a$export$dfd9b671c89acc8e = 7;
const $37682150499c1c6a$export$3913210603d8e9ae = 365.2425;
const $37682150499c1c6a$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $37682150499c1c6a$export$4dec998e48f9c246 = -$37682150499c1c6a$export$81caae6e1cc7a622;
const $37682150499c1c6a$export$4fad13613e88edc8 = 604800000;
const $37682150499c1c6a$export$b76b1809a2898f9a = 86400000;
const $37682150499c1c6a$export$91246f0b9bd9beff = 60000;
const $37682150499c1c6a$export$7f72910d6dfd237a = 3600000;
const $37682150499c1c6a$export$397c2d5776aa9055 = 1000;
const $37682150499c1c6a$export$3633035e63cee86a = 525600;
const $37682150499c1c6a$export$ab7da2ccd1075c38 = 43200;
const $37682150499c1c6a$export$2423174df8cd3cd2 = 1440;
const $37682150499c1c6a$export$f2f5ae5a8e2d8f9f = 60;
const $37682150499c1c6a$export$3c58128db900d44e = 3;
const $37682150499c1c6a$export$80d7e435f744f319 = 12;
const $37682150499c1c6a$export$4db7641526e3241f = 4;
const $37682150499c1c6a$export$698aec755e92c695 = 3600;
const $37682150499c1c6a$export$a77c1a7ebebe2a5a = 60;
const $37682150499c1c6a$export$815a9362476d2fe3 = $37682150499c1c6a$export$698aec755e92c695 * 24;
const $37682150499c1c6a$export$34804a017b31e2fe = $37682150499c1c6a$export$815a9362476d2fe3 * 7;
const $37682150499c1c6a$export$7271e9e3478110d1 = $37682150499c1c6a$export$815a9362476d2fe3 * $37682150499c1c6a$export$3913210603d8e9ae;
const $37682150499c1c6a$export$8e6600bbdee7dabb = $37682150499c1c6a$export$7271e9e3478110d1 / 12;
const $37682150499c1c6a$export$be1dccf2de902d31 = $37682150499c1c6a$export$8e6600bbdee7dabb * 3;
const $37682150499c1c6a$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $7c1787257eb00a81$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $37682150499c1c6a$export$2a7b97929c48d47d) in date) return date[0, $37682150499c1c6a$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$7c1787257eb00a81$export$2e2bcd8739ae039 = $7c1787257eb00a81$export$ead8a1812b171991;


function $f9702abd9ae62b8a$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $7c1787257eb00a81$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$f9702abd9ae62b8a$export$2e2bcd8739ae039 = $f9702abd9ae62b8a$export$e67a095c620b86fe;


function $f756ac946a5bd298$export$113002b5eff6e430(date) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $e05a7d9b16061e55$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $7c1787257eb00a81$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $8fed386bda761bf6$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$8fed386bda761bf6$export$2e2bcd8739ae039 = $8fed386bda761bf6$export$63fa379ae8a9ba2;


function $c01225e8282db0ef$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $8fed386bda761bf6$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $8fed386bda761bf6$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $f756ac946a5bd298$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $f756ac946a5bd298$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $37682150499c1c6a$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$c01225e8282db0ef$export$2e2bcd8739ae039 = $c01225e8282db0ef$export$4a02e9c37dab4871;



function $9053b48f59f32827$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$9053b48f59f32827$export$2e2bcd8739ae039 = $9053b48f59f32827$export$f91e89d3d0406102;



function $cde82db767bc9b6b$export$d3b42cd8452deec(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $c01225e8282db0ef$export$4a02e9c37dab4871)(_date, (0, $9053b48f59f32827$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$cde82db767bc9b6b$export$2e2bcd8739ae039 = $cde82db767bc9b6b$export$d3b42cd8452deec;





function $745fbff77e10d60d$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$745fbff77e10d60d$export$2e2bcd8739ae039 = $745fbff77e10d60d$export$42c81a444fbfb5d4;


function $9461c79606c02f2c$export$6173213f95a4431e(date, options) {
    return (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$9461c79606c02f2c$export$2e2bcd8739ae039 = $9461c79606c02f2c$export$6173213f95a4431e;






function $23d284a44a393c3d$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$23d284a44a393c3d$export$2e2bcd8739ae039 = $23d284a44a393c3d$export$3dbc52535f6f8fcc;



function $5d98a96100403307$export$236bdfa374eb69a9(date, options) {
    const year = (0, $23d284a44a393c3d$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$5d98a96100403307$export$2e2bcd8739ae039 = $5d98a96100403307$export$236bdfa374eb69a9;



function $b249011336f9bc7f$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $9461c79606c02f2c$export$6173213f95a4431e)(_date) - +(0, $5d98a96100403307$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $37682150499c1c6a$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$b249011336f9bc7f$export$2e2bcd8739ae039 = $b249011336f9bc7f$export$7cabdc5698b63e2f;











function $c9463c2fda3f28c7$export$12d572480ceb6e58(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c9463c2fda3f28c7$export$2e2bcd8739ae039 = $c9463c2fda3f28c7$export$12d572480ceb6e58;



function $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $c9463c2fda3f28c7$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$15d3c55c8e9bc2ef$export$2e2bcd8739ae039 = $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f;



function $a9e104ef0f3c8cb9$export$efe19b760242b2fc(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(_date, options) - +(0, $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $37682150499c1c6a$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$a9e104ef0f3c8cb9$export$2e2bcd8739ae039 = $a9e104ef0f3c8cb9$export$efe19b760242b2fc;



function $a25e318a409c6a3f$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $b26f1f7176577786$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $122af9549e803407$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $122af9549e803407$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $c9463c2fda3f28c7$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $23d284a44a393c3d$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $b26f1f7176577786$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $a9e104ef0f3c8cb9$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $b249011336f9bc7f$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $cde82db767bc9b6b$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $122af9549e803407$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $122af9549e803407$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $122af9549e803407$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $122af9549e803407$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $122af9549e803407$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $122af9549e803407$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $122af9549e803407$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(minutes, 2);
}
function $122af9549e803407$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $122af9549e803407$var$formatTimezone(offset, delimiter);
}
function $122af9549e803407$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $fccd8ac5b2f199a5$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $fccd8ac5b2f199a5$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $fccd8ac5b2f199a5$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $fccd8ac5b2f199a5$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $fccd8ac5b2f199a5$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $fccd8ac5b2f199a5$var$timeLongFormatter(timePattern, formatLong));
};
const $fccd8ac5b2f199a5$export$70cc8fd02856fd58 = {
    p: $fccd8ac5b2f199a5$var$timeLongFormatter,
    P: $fccd8ac5b2f199a5$var$dateTimeLongFormatter
};


const $7cb6c07d9954f47a$var$dayOfYearTokenRE = /^D+$/;
const $7cb6c07d9954f47a$var$weekYearTokenRE = /^Y+$/;
const $7cb6c07d9954f47a$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7cb6c07d9954f47a$export$c6cc36aa33304772(token) {
    return $7cb6c07d9954f47a$var$dayOfYearTokenRE.test(token);
}
function $7cb6c07d9954f47a$export$c6b49d6dceb604a1(token) {
    return $7cb6c07d9954f47a$var$weekYearTokenRE.test(token);
}
function $7cb6c07d9954f47a$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7cb6c07d9954f47a$var$message(token, format, input);
    console.warn(_message);
    if ($7cb6c07d9954f47a$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7cb6c07d9954f47a$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $a0a0eb85328584c5$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$a0a0eb85328584c5$export$2e2bcd8739ae039 = $a0a0eb85328584c5$export$871608497c498473;



function $4d71b265e812de38$export$1ea939691cdc45b8(date) {
    return !(!(0, $a0a0eb85328584c5$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$4d71b265e812de38$export$2e2bcd8739ae039 = $4d71b265e812de38$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $5e113df2845e4dc9$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $5e113df2845e4dc9$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $5e113df2845e4dc9$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $5e113df2845e4dc9$var$doubleQuoteRegExp = /''/g;
const $5e113df2845e4dc9$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $5e113df2845e4dc9$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $ef15c8be5320e65f$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $4d71b265e812de38$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($5e113df2845e4dc9$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $fccd8ac5b2f199a5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($5e113df2845e4dc9$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $5e113df2845e4dc9$var$cleanEscapedString(substring)
        };
        if ((0, $122af9549e803407$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($5e113df2845e4dc9$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7cb6c07d9954f47a$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7cb6c07d9954f47a$export$c6cc36aa33304772)(token)) (0, $7cb6c07d9954f47a$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $122af9549e803407$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $5e113df2845e4dc9$var$cleanEscapedString(input) {
    const matched = input.match($5e113df2845e4dc9$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($5e113df2845e4dc9$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$5e113df2845e4dc9$export$2e2bcd8739ae039 = $5e113df2845e4dc9$export$d9468344d3651243;




var $ieaan = parcelRequire("ieaan");

var $4779e2ed9944bb95$exports = {};

$parcel$export($4779e2ed9944bb95$exports, "Container", function () { return $9c92da99f2492306$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Item", function () { return $2b6d53905ebe52fd$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Stack", function () { return $743f404748c291b2$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Horizontal", function () { return $806dc62f7614bebc$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Vertical", function () { return $c4b063a9f8ac836f$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "withChildren", function () { return $54a1423428abe660$export$2e2bcd8739ae039; });

var $ieaan = parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");





"use client";
const $18267a16830f8f91$var$Hr = ({ breakout: breakout, dashed: dashed, className: className, ...props } = {})=>{
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $3d090471d65e4fa1$export$2e2bcd8739ae039), {
        as: "hr",
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(className, context?.theme?.surface === 'dark' && 'dnb-hr--surface-dark', dashed && 'dnb-hr--dashed', breakout && 'dnb-hr--breakout'),
        ...props
    });
};
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($18267a16830f8f91$var$Hr, {
    _supportsSpacingProps: true
});
var $18267a16830f8f91$export$2e2bcd8739ae039 = $18267a16830f8f91$var$Hr;


var $a395d78185689abd$export$2e2bcd8739ae039 = (0, $18267a16830f8f91$export$2e2bcd8739ae039);



var $ieaan = parcelRequire("ieaan");



"use client";
const $5c47cf00b4b6f77e$var$makeLayoutEffect = ()=>{
    return typeof window === 'undefined' ? (0, $ieaan.useEffect) : window['__SSR_TEST__'] ? ()=>null : (0, $ieaan.useLayoutEffect);
};
const $5c47cf00b4b6f77e$export$fad5e1e85bc5d785 = {
    small: {
        min: 0,
        max: 'small'
    },
    medium: {
        min: 'small',
        max: 'medium'
    },
    large: {
        min: 'medium'
    }
};
function $5c47cf00b4b6f77e$export$2e2bcd8739ae039(props = {}) {
    const { initialValue: initialValue = null, disabled: disabled, correctRange: correctRange = true, breakpoints: breakpoints, queries: queries = $5c47cf00b4b6f77e$export$fad5e1e85bc5d785, log: log } = props;
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const refs = (0, $ieaan.useRef)({});
    const defaultsRef = (0, $ieaan.useRef)({});
    const resultRef = (0, $ieaan.useRef)({});
    const isMountedRef = (0, $ieaan.useRef)(false);
    const isDisabledRef = (0, $ieaan.useRef)(disabled);
    const removeListeners = (0, $ieaan.useCallback)(()=>{
        Object.entries(refs.current).forEach(([key, item])=>{
            item?.event?.();
            delete refs.current[key];
        });
    }, []);
    const runQuery = (0, $ieaan.useCallback)(({ when: when, name: name, key: key })=>{
        if (!(0, $ccaa0a2f61c56410$export$26316165d3b380c8)()) return undefined;
        const mediaQueryList = (0, $ccaa0a2f61c56410$export$e57d90d0ec36fcbc)({
            when: when
        }, breakpoints || context.breakpoints, {
            disabled: disabled,
            correctRange: correctRange,
            log: log
        });
        const event = (0, $ccaa0a2f61c56410$export$1946718a333328e0)(mediaQueryList, (match)=>{
            if (!isDisabledRef.current && match) {
                const state = {
                    ...defaultsRef.current,
                    key: key,
                    isSSR: resultRef.current.isSSR
                };
                state[name] = match;
                updateRerender(state);
            }
        });
        return {
            event: event,
            mediaQueryList: mediaQueryList
        };
    }, [
        breakpoints,
        context.breakpoints,
        correctRange,
        disabled,
        log
    ]);
    const makeResult = (0, $ieaan.useCallback)(()=>{
        return Object.entries(queries).reduce((acc, [k, when])=>{
            const key = k;
            const name = `is${(0, $11741836d1790446$export$6fb43ff9addf7357)(key)}`;
            if (disabled) {
                acc[name] = false;
                return acc;
            }
            defaultsRef.current[name] = false;
            const item = runQuery({
                when: when,
                name: name,
                key: key
            });
            let hasMatch;
            if (typeof initialValue?.[name] !== 'undefined' && !isMountedRef.current) hasMatch = initialValue[name];
            else hasMatch = item?.mediaQueryList?.matches || false;
            acc[name] = hasMatch;
            if (hasMatch) acc.key = key;
            refs.current[key] = item;
            return acc;
        }, {
            isSSR: !(0, $ccaa0a2f61c56410$export$26316165d3b380c8)(),
            key: null
        });
    }, [
        disabled,
        initialValue,
        queries,
        runQuery
    ]);
    const [result, updateRerender] = (0, $ieaan.useState)(makeResult);
    resultRef.current = result;
    const useLayoutEffect = (0, $ieaan.useMemo)($5c47cf00b4b6f77e$var$makeLayoutEffect, []);
    useLayoutEffect(()=>{
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            const result = makeResult();
            const resultKeys = Object.keys(result);
            const hasChanged = resultKeys.some((key)=>resultRef.current[key] !== result[key]);
            if (hasChanged) updateRerender(result);
        }
        return removeListeners;
    }, [
        makeResult,
        removeListeners
    ]);
    useLayoutEffect(()=>{
        if (isDisabledRef.current && !disabled) updateRerender(makeResult());
        isDisabledRef.current = disabled;
    }, [
        disabled,
        makeResult
    ]);
    return result;
}



var $ieaan = parcelRequire("ieaan");




const $dd5c8d159e0e7768$export$f6ab8fdac90442ec = (0, $9a6e1a0e3c9a63a2$export$e275e554c9b8899e);
function $dd5c8d159e0e7768$export$ab5c332da23a9003(props) {
    const obj = {};
    for(const key in props)if ((0, $9a6e1a0e3c9a63a2$export$3eec253e4a999ac)(key) && typeof props[key] !== 'undefined') obj[key] = props[key];
    return obj;
}
function $dd5c8d159e0e7768$export$26933d4133c059f8(type, element) {
    var _elementProps$type;
    if (!(0, $ieaan.isValidElement)(element)) return undefined;
    const elementProps = element.props || {};
    return (_elementProps$type = elementProps?.[type]) !== null && _elementProps$type !== void 0 ? _elementProps$type : typeof elementProps?.space === 'object' ? elementProps.space[type] : undefined;
}
function $dd5c8d159e0e7768$export$5c501ecf46bfbf15(element) {
    return (0, $ieaan.isValidElement)(element) && element?.type?._isHeadingElement === true;
}
function $dd5c8d159e0e7768$export$4a972b2a98229b7c(element) {
    if ((0, $ieaan.isValidElement)(element)) {
        var _props;
        if (element?.type === (0, $ieaan.Fragment)) return 'children';
        const check = element?.type?._supportsSpacingProps;
        if (typeof check !== 'undefined') return check;
        const keys = [
            'space',
            'top',
            'right',
            'bottom',
            'left'
        ];
        const props = (_props = element?.props) !== null && _props !== void 0 ? _props : {};
        if (keys.some((key)=>key in props)) return true;
    }
    return undefined;
}
function $dd5c8d159e0e7768$export$531a6af995d5df92(element, spaceProps) {
    const variant = $dd5c8d159e0e7768$export$4a972b2a98229b7c(element);
    const { wrapInSpace: wrapInSpace = true } = spaceProps;
    if (variant === false) return element;
    if (variant === 'passthrough') {
        const childElement = element;
        const children = childElement?.props?.children;
        const childKey = childElement?.key;
        const childProps = childElement?.props || {};
        return (0, $ieaan.Children).toArray(children).map((child, i)=>{
            const wrapped = $dd5c8d159e0e7768$var$wrapWithSpace({
                element: child,
                spaceProps: spaceProps,
                wrapInSpace: wrapInSpace
            });
            return (0, $ieaan.createElement)(childElement.type, {
                ...childProps,
                key: childKey ? `${childKey}-${i}` : `${i}`
            }, wrapped);
        });
    }
    if (variant === 'children') return (0, $ieaan.Children).toArray(element).map((child)=>{
        const children = child?.props?.children;
        const childKey = child?.key;
        const childProps = child?.props || {};
        return (0, $ieaan.Children).toArray(children).map((element, i)=>{
            return (0, $ieaan.createElement)(child.type, {
                ...childProps,
                key: childKey ? `${childKey}-${i}` : i
            }, $dd5c8d159e0e7768$var$wrapWithSpace({
                element: element,
                spaceProps: spaceProps,
                wrapInSpace: wrapInSpace
            }));
        });
    });
    return $dd5c8d159e0e7768$var$wrapWithSpace({
        element: element,
        spaceProps: spaceProps,
        variant: variant,
        wrapInSpace: wrapInSpace
    });
}
function $dd5c8d159e0e7768$var$isIntrinsicElement(element) {
    return (0, $ieaan.isValidElement)(element) && typeof element.type === 'string';
}
function $dd5c8d159e0e7768$var$wrapWithSpace({ element: element, spaceProps: spaceProps, variant: variant = null, wrapInSpace: wrapInSpace = true }) {
    const resolvedVariant = variant !== null && variant !== void 0 ? variant : $dd5c8d159e0e7768$export$4a972b2a98229b7c(element);
    const { wrapInSpace: _, key: key, ...props } = spaceProps;
    if (resolvedVariant === true) return (0, $ieaan.createElement)(element.type, {
        ...element.props,
        key: key,
        ...props
    });
    if (resolvedVariant === 'children') return $dd5c8d159e0e7768$export$531a6af995d5df92(element, spaceProps);
    if (!wrapInSpace && $dd5c8d159e0e7768$var$isIntrinsicElement(element)) return $dd5c8d159e0e7768$var$cloneIntrinsicElementWithSpacing(element, spaceProps);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        ...props,
        children: element
    }, key);
}
function $dd5c8d159e0e7768$var$cloneIntrinsicElementWithSpacing(element, { wrapInSpace: wrapInSpace, className: className, style: style, ...spaceProps }) {
    if (!(0, $ieaan.isValidElement)(element)) return element;
    const elementProps = element.props || {};
    const spacing = (0, $9a6e1a0e3c9a63a2$export$31a62238a3f24621)(spaceProps);
    return (0, $ieaan.createElement)(element.type, {
        ...element.props,
        key: spaceProps.key,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(elementProps?.className, ...spacing.className, className),
        style: {
            ...elementProps?.style,
            ...spacing.style,
            ...style
        }
    });
}




"use client";
const $9c92da99f2492306$var$propNames = [
    'direction',
    'wrap',
    'wrapChildrenInSpace',
    'justify',
    'align',
    'divider',
    'gap'
];
function $9c92da99f2492306$export$e3d3270fdbbcb8ec(props, defaults = {}, skip = []) {
    return {
        ...defaults,
        ...Object.fromEntries(Object.entries(props !== null && props !== void 0 ? props : {}).filter(([key])=>$9c92da99f2492306$var$propNames.includes(key) && !skip.includes(key)))
    };
}
function $9c92da99f2492306$var$FlexContainer(props) {
    const { className: className, style: style, children: children, element: element = 'div', direction: direction = 'horizontal', wrap: wrap = true, wrapChildrenInSpace: wrapChildrenInSpace = true, sizeCount: sizeCount = 12, rowGap: rowGap, justify: justify = 'flex-start', align: align = 'flex-start', alignSelf: alignSelf, divider: divider = 'space', gap: gap = 'small', breakpoints: breakpoints, queries: queries, ...rest } = props;
    const spacing = (0, $ieaan.useMemo)(()=>{
        var _ref;
        return (_ref = direction === 'vertical' ? rowGap : undefined) !== null && _ref !== void 0 ? _ref : gap;
    }, [
        direction,
        gap,
        rowGap
    ]);
    const childrenArray = $9c92da99f2492306$var$replaceRootFragment($9c92da99f2492306$var$wrapChildren(props, children));
    const hasHeading = childrenArray.some((child, i)=>{
        const previousChild = childrenArray?.[i - 1];
        return (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(child) || i > 0 && (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(previousChild);
    });
    const hasSizeProp = !hasHeading && direction === 'horizontal' && childrenArray.some((child)=>child['props']?.span);
    const { key: mediaKey } = (0, $5c47cf00b4b6f77e$export$2e2bcd8739ae039)({
        disabled: !hasSizeProp,
        breakpoints: breakpoints,
        queries: queries
    });
    const content = childrenArray.map((child, i)=>{
        const isFirst = i === 0;
        const isLast = i >= childrenArray.length - 1;
        const previousChild = childrenArray?.[i - 1];
        const isHeading = hasHeading && (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(previousChild);
        const start = direction === 'horizontal' ? 'left' : 'top';
        const end = direction === 'horizontal' ? 'right' : 'bottom';
        const endSpacing = 0;
        let startSpacing;
        if (!isHeading && (divider === 'line' && !isFirst || divider === 'line-framed')) {
            var _getSpaceValue, _getSpaceValue2;
            const spaceAboveLine = (_getSpaceValue = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(end, previousChild)) !== null && _getSpaceValue !== void 0 ? _getSpaceValue : spacing;
            startSpacing = (_getSpaceValue2 = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(start, child)) !== null && _getSpaceValue2 !== void 0 ? _getSpaceValue2 : spacing;
            return (0, $60739c7e3f826d8d$exports.jsxs)((0, $ieaan.Fragment), {
                children: [
                    (0, $60739c7e3f826d8d$exports.jsx)((0, $a395d78185689abd$export$2e2bcd8739ae039), {
                        top: !isFirst ? spaceAboveLine : 0,
                        space: 0,
                        className: "dnb-flex-container__hr"
                    }),
                    (0, $dd5c8d159e0e7768$export$531a6af995d5df92)(child, {
                        space: {
                            [start]: startSpacing,
                            [end]: endSpacing
                        },
                        wrapInSpace: wrapChildrenInSpace
                    }),
                    divider === 'line-framed' && isLast && (0, $60739c7e3f826d8d$exports.jsx)((0, $a395d78185689abd$export$2e2bcd8739ae039), {
                        top: spaceAboveLine,
                        space: 0,
                        className: "dnb-flex-container__hr"
                    })
                ]
            }, `element-${i}`);
        }
        if (isFirst && direction !== 'horizontal') startSpacing = 0;
        else {
            var _ref2, _getSpaceValue3;
            startSpacing = (_ref2 = (_getSpaceValue3 = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(start, child)) !== null && _getSpaceValue3 !== void 0 ? _getSpaceValue3 : (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(end, previousChild)) !== null && _ref2 !== void 0 ? _ref2 : spacing;
        }
        if ((0, $ieaan.isValidElement)(previousChild) && previousChild?.type?.['_supportsSpacingProps'] === false) startSpacing = 0;
        const space = direction === 'horizontal' ? {
            [start]: endSpacing,
            [end]: startSpacing
        } : {
            [start]: startSpacing,
            [end]: endSpacing
        };
        return (0, $dd5c8d159e0e7768$export$531a6af995d5df92)(child, {
            key: child?.['key'] || `element-${i}`,
            space: space,
            wrapInSpace: wrapChildrenInSpace
        });
    });
    const n = 'dnb-flex-container';
    const rowGapClass = (0, $ieaan.useMemo)(()=>{
        if (rowGap !== false && direction === 'horizontal') return `${n}--row-gap-${rowGap !== null && rowGap !== void 0 ? rowGap : 'small'}`;
        return undefined;
    }, [
        direction,
        rowGap
    ]);
    const cn = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-flex-container', direction && `${n}--direction-${direction}`, justify && `${n}--justify-${justify}`, align && `${n}--align-${align}`, alignSelf && `${n}--align-self-${alignSelf}`, spacing && `${n}--spacing-${spacing}`, wrap && `${n}--wrap`, rowGapClass, hasSizeProp && `${n}--has-size`, divider && `${n}--divider-${divider}`, className);
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: cn,
        "data-media-key": mediaKey,
        style: hasSizeProp ? {
            '--size-count': sizeCount,
            ...style
        } : style,
        ...rest,
        children: content
    });
}
function $9c92da99f2492306$var$wrapChildren(props, children) {
    return (0, $ieaan.Children).toArray(children).map((child)=>{
        if ((0, $ieaan.isValidElement)(child) && child.type['_supportsSpacingProps'] === 'children') {
            const childElement = child;
            const childKey = childElement.key;
            const childProps = childElement.props || {};
            return (0, $ieaan.createElement)(childElement.type, {
                ...childProps,
                key: childKey
            }, (0, $60739c7e3f826d8d$exports.jsx)($9c92da99f2492306$var$FlexContainer, {
                ...props,
                children: childElement.props.children
            }));
        }
        return child;
    });
}
function $9c92da99f2492306$var$replaceRootFragment(children) {
    const firstChild = children[0];
    if ((0, $ieaan.Children).count(children) === 1 && firstChild?.type === (0, $ieaan.Fragment)) return (0, $ieaan.Children).toArray(firstChild?.props?.children);
    return children;
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($9c92da99f2492306$var$FlexContainer, {
    _supportsSpacingProps: true
});
var $9c92da99f2492306$export$2e2bcd8739ae039 = $9c92da99f2492306$var$FlexContainer;



var $ieaan = parcelRequire("ieaan");




function $2b6d53905ebe52fd$var$FlexItem(props) {
    const { element: element = 'div', className: className, grow: grow, shrink: shrink, alignSelf: alignSelf, span: span, style: style, children: children, ...rest } = props;
    const cn = (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-flex-item', grow && 'dnb-flex-item--grow', shrink && 'dnb-flex-item--shrink', alignSelf && `dnb-flex-item--align-self-${alignSelf}`, span && 'dnb-flex-item--responsive');
    const isValidSpan = (0, $ieaan.useCallback)((span)=>{
        return typeof span === 'number' || span === 'auto';
    }, []);
    const spaceStyles = {};
    if (span) {
        if (isValidSpan(span)) spaceStyles['--span--default'] = span;
        else {
            const spans = span;
            for(const key in spans)if (isValidSpan(span[key])) spaceStyles[`--${key}`] = span[key];
        }
    }
    if (Object.keys(spaceStyles).length) return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: cn,
        style: spaceStyles,
        children: (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
            className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-flex-item__spacer', className),
            style: style,
            ...rest,
            children: children
        })
    });
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)(cn, className),
        style: style,
        ...rest,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($2b6d53905ebe52fd$var$FlexItem, {
    _supportsSpacingProps: true
});
var $2b6d53905ebe52fd$export$2e2bcd8739ae039 = $2b6d53905ebe52fd$var$FlexItem;






function $743f404748c291b2$var$Stack(props) {
    const { className: className, direction: direction = 'vertical', alignSelf: alignSelf = 'stretch', align: align = 'stretch', gap: gap = props.divider !== 'line' && props.divider !== 'line-framed' ? 'medium' : 'small', children: children, ...rest } = props;
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $9c92da99f2492306$export$2e2bcd8739ae039), {
        element: "section",
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-flex-stack', className),
        direction: direction,
        alignSelf: alignSelf,
        align: align,
        gap: gap,
        ...rest,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($743f404748c291b2$var$Stack, {
    _supportsSpacingProps: true
});
var $743f404748c291b2$export$2e2bcd8739ae039 = $743f404748c291b2$var$Stack;





function $806dc62f7614bebc$var$Horizontal({ children: children, ...props }) {
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $9c92da99f2492306$export$2e2bcd8739ae039), {
        ...props,
        direction: "horizontal",
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($806dc62f7614bebc$var$Horizontal, {
    _supportsSpacingProps: true
});
var $806dc62f7614bebc$export$2e2bcd8739ae039 = $806dc62f7614bebc$var$Horizontal;





function $c4b063a9f8ac836f$var$Vertical({ children: children, ...props }) {
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $9c92da99f2492306$export$2e2bcd8739ae039), {
        ...props,
        direction: "vertical",
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($c4b063a9f8ac836f$var$Vertical, {
    _supportsSpacingProps: true
});
var $c4b063a9f8ac836f$export$2e2bcd8739ae039 = $c4b063a9f8ac836f$var$Vertical;



function $54a1423428abe660$var$withChildren(Component) {
    (0, $428744f8f90337b7$export$2e2bcd8739ae039)(Component, {
        _supportsSpacingProps: 'children'
    });
    return Component;
}
var $54a1423428abe660$export$2e2bcd8739ae039 = $54a1423428abe660$var$withChildren;







var $ieaan = parcelRequire("ieaan");
"use client";
const $aaae999405fb60c3$var$CardContext = (0, $ieaan.createContext)(undefined);
var $aaae999405fb60c3$export$2e2bcd8739ae039 = $aaae999405fb60c3$var$CardContext;



var $9c2bf02738ee5bae$export$2e2bcd8739ae039 = (0, $92bd738e6af0b834$export$2e2bcd8739ae039);




"use client";
function $a8f3e7953144ed9a$var$Card(props) {
    const nestedContext = (0, $ieaan.useContext)((0, $aaae999405fb60c3$export$2e2bcd8739ae039));
    const { className: className, stack: stack, direction: direction, gap: gap, innerSpace: innerSpace, alignSelf: alignSelf = 'stretch', align: align, divider: divider = 'space', rowGap: rowGap, responsive: responsive = !nestedContext?.isNested, filled: filled, outset: outset, outlineWidth: outlineWidth = 'var(--card-outline-width)', dropShadow: dropShadow, title: title, element: element = 'section', children: children, ...rest } = props;
    const titleId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)();
    const falseWhenSmall = {
        small: false,
        medium: true,
        large: true
    };
    const trueWhenSmall = {
        small: true,
        medium: false,
        large: false
    };
    const basisSpace = {
        top: 'small',
        right: 'small',
        bottom: 'small',
        left: 'small'
    };
    const smallSpace = responsive ? {
        ...basisSpace,
        right: 0,
        left: 0
    } : basisSpace;
    const params = (0, $b72c82c3d5da1e25$export$a739c8d3f97ecf5f)({
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-card', className, responsive && 'dnb-card--responsive', filled && 'dnb-card--filled', !innerSpace && innerSpace != null && 'dnb-card--no-inner-space'),
        breakout: responsive ? trueWhenSmall : false,
        outset: nestedContext?.isNested ? false : outset === true ? falseWhenSmall : outset,
        roundedCorner: responsive ? falseWhenSmall : true,
        outline: 'var(--card-outline-color)',
        outlineWidth: outlineWidth,
        dropShadow: dropShadow,
        backgroundColor: 'var(--card-background-color)',
        innerSpace: innerSpace !== null && innerSpace !== void 0 ? innerSpace : {
            small: smallSpace,
            medium: basisSpace,
            large: basisSpace
        },
        ...rest,
        'aria-labelledby': (0, $11741836d1790446$export$b31873477fdbab59)(rest, title && titleId)
    });
    return (0, $60739c7e3f826d8d$exports.jsx)((0, $4779e2ed9944bb95$exports).Item, {
        alignSelf: alignSelf,
        ...params,
        element: element,
        children: (0, $60739c7e3f826d8d$exports.jsx)((0, $aaae999405fb60c3$export$2e2bcd8739ae039), {
            value: {
                ...nestedContext,
                isNested: true
            },
            children: (0, $60739c7e3f826d8d$exports.jsxs)((0, $4779e2ed9944bb95$exports).Container, {
                direction: direction !== null && direction !== void 0 ? direction : 'vertical',
                divider: divider,
                alignSelf: alignSelf,
                align: stack ? 'stretch' : align,
                wrap: !stack,
                gap: gap !== null && gap !== void 0 ? gap : stack ? 'medium' : false,
                rowGap: rowGap,
                children: [
                    title && (0, $60739c7e3f826d8d$exports.jsx)((0, $9c2bf02738ee5bae$export$2e2bcd8739ae039), {
                        id: titleId,
                        className: "dnb-card__title",
                        children: title
                    }),
                    children
                ]
            })
        })
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($a8f3e7953144ed9a$var$Card, {
    _supportsSpacingProps: true
});
var $a8f3e7953144ed9a$export$2e2bcd8739ae039 = $a8f3e7953144ed9a$var$Card;



var $ieaan = parcelRequire("ieaan");





"use client";
function $f895973e0a13f753$var$CardAction(props) {
    const { href: href, to: to, target: target, rel: relProp, onClick: onClick, element: element, ref: ref, children: children, ...cardProps } = props;
    const isLink = Boolean(href || to);
    const internalRef = (0, $ieaan.useRef)(null);
    const combinedRef = (0, $e48c94c3f1835290$export$2e2bcd8739ae039)(ref, internalRef);
    (0, $ieaan.useEffect)(()=>{
        return;
    }, []);
    const handleKeyDown = (0, $ieaan.useCallback)((event)=>{
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const rel = target === '_blank' && !relProp ? 'noopener noreferrer' : relProp;
    const card = (0, $60739c7e3f826d8d$exports.jsx)((0, $a8f3e7953144ed9a$export$2e2bcd8739ae039), {
        ...cardProps,
        children: children
    });
    if (isLink) {
        const AnchorElement = element || 'a';
        if (AnchorElement !== 'a') return (0, $60739c7e3f826d8d$exports.jsx)(AnchorElement, {
            className: "dnb-card-action",
            ref: combinedRef,
            onClick: onClick,
            target: target,
            rel: rel,
            to: to || href,
            children: card
        });
        return (0, $60739c7e3f826d8d$exports.jsx)("a", {
            className: "dnb-card-action",
            ref: combinedRef,
            onClick: onClick,
            target: target,
            rel: rel,
            href: href || to,
            children: card
        });
    }
    return (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-card-action",
        ref: combinedRef,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: 0,
        children: card
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($f895973e0a13f753$var$CardAction, {
    _supportsSpacingProps: true
});
var $f895973e0a13f753$export$2e2bcd8739ae039 = $f895973e0a13f753$var$CardAction;






function $0466874ec966929d$var$CardList(props) {
    const { children: children, className: className, top: top, right: right, bottom: bottom, left: left, space: space, ...rest } = props;
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        space: space
    }, {
        ...rest,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-card-list', className)
    });
    return (0, $60739c7e3f826d8d$exports.jsx)("ul", {
        ...params,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($0466874ec966929d$var$CardList, {
    _supportsSpacingProps: true
});
var $0466874ec966929d$export$2e2bcd8739ae039 = $0466874ec966929d$var$CardList;






function $b851dc384dcd8735$var$CardListItem(props) {
    const { children: children, className: className, center: center, top: top, right: right, bottom: bottom, left: left, space: space, ...rest } = props;
    const params = (0, $9a6e1a0e3c9a63a2$export$d9dd5da15372e275)({
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        space: space
    }, {
        ...rest,
        className: (0, $2bc97902f5cc4941$export$4f5d2d50c9deca37)('dnb-card-list__item', center === true && 'dnb-card-list__item--center', center === 'when-small' && 'dnb-card-list__item--center-when-small', className)
    });
    return (0, $60739c7e3f826d8d$exports.jsx)("li", {
        ...params,
        children: children
    });
}
(0, $428744f8f90337b7$export$2e2bcd8739ae039)($b851dc384dcd8735$var$CardListItem, {
    _supportsSpacingProps: true
});
var $b851dc384dcd8735$export$2e2bcd8739ae039 = $b851dc384dcd8735$var$CardListItem;


const $e5d3166d137618a2$var$CardCompound = Object.assign((0, $a8f3e7953144ed9a$export$2e2bcd8739ae039), {
    Action: (0, $f895973e0a13f753$export$2e2bcd8739ae039),
    List: (0, $0466874ec966929d$export$2e2bcd8739ae039),
    ListItem: (0, $b851dc384dcd8735$export$2e2bcd8739ae039)
});
var $e5d3166d137618a2$export$2e2bcd8739ae039 = $e5d3166d137618a2$var$CardCompound;




// Function to extract string on the left of || and put in norwegian, and on the right to english

//Function takes a string, if it finds ||, it assumes that string on the left is norwegian, and on the right is english
//the string it finds, it runs through the i18n t function, which further translates it
const $a37d7511f1690d99$var$FindLanguage = (incidentText)=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    console.log('Language: ' + i18n.language);
    let incidentTextInLanguage = incidentText;
    let splitter = incidentText.indexOf('||');
    // If we find splitter in the text
    if (splitter !== -1) {
        console.log('Found language splitter');
        // If the detected language is norwegian we select the left side of the string
        if (i18n.language === 'nb-NO' || i18n.language === 'no' || i18n.language === 'nb') incidentTextInLanguage = incidentText.substring(0, splitter);
        else incidentTextInLanguage = incidentText.substring(2 + splitter);
    // Else we do not find a splitter, and we return the string untouched.
    } else console.log('Did not find language splitter for text: -->' + incidentTextInLanguage + '<--');
    console.log('Returning this text: ' + t(incidentTextInLanguage));
    return t(incidentTextInLanguage);
};
var $a37d7511f1690d99$export$2e2bcd8739ae039 = $a37d7511f1690d99$var$FindLanguage;



function $456835a5566ee681$export$ed84005ac9356f7a(dateLeft, dateRight) {
    const diff = +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(dateLeft) - +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(dateRight);
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$456835a5566ee681$export$2e2bcd8739ae039 = $456835a5566ee681$export$ed84005ac9356f7a;



parcelRequire("ieaan");
const $18a341d907f43f4e$var$CustomDnbCalendar = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 39.5 39.5",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M9.8 15a.75.75 0 0 0 0 1.5zm19.9 1.5a.75.75 0 0 0 0-1.5zM5.27 5.92a.75.75 0 0 0 0-1.5zM.75 5.17v-.75a.75.75 0 0 0-.75.75zm0 33.58H0a.76.76 0 0 0 .75.75zm38 0v.75a.76.76 0 0 0 .75-.75zm0-33.58h.75a.75.75 0 0 0-.75-.75zm-4.52-.75a.75.75 0 0 0 0 1.5zm-19.91 0a.75.75 0 0 0 0 1.5zm10.86 1.5a.75.75 0 0 0 0-1.5zM10.55.75a.75.75 0 0 0-1.5 0zm-1.5 8.84a.75.75 0 0 0 1.5 0zM30.45.75a.75.75 0 0 0-1.5 0zM29 9.59a.75.75 0 0 0 1.5 0zM9.8 16.52h19.9V15H9.8zM5.27 4.42H.75v1.5h4.52zM0 5.17v33.58h1.5V5.17zM.75 39.5h38V38h-38zm38.75-.75V5.17H38v33.58zm-.75-34.33h-4.52v1.5h4.52zm-24.43 1.5h10.86v-1.5H14.32zM9.05.75v8.84h1.5V.75zM29 .75v8.84h1.5V.75z",
                className: "custom_dnb_calendar_svg__cls-1",
                "data-name": "Layer 1"
            })
        })
    });
var $18a341d907f43f4e$export$2e2bcd8739ae039 = $18a341d907f43f4e$var$CustomDnbCalendar;



parcelRequire("ieaan");
const $4fdf17dc453c2890$var$CustomDnbStatus = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("style", {
                    children: '.custom_dnb_status_svg__cls-1{fill:none;stroke:#b3b3b3;stroke-linecap:round;stroke-linejoin:round}'
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
                id: "custom_dnb_status_svg__Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                    id: "custom_dnb_status_svg__Layer_1-2",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                            d: "M18 35.5A17.5 17.5 0 1 0 .5 18 17.49 17.49 0 0 0 18 35.5",
                            className: "custom_dnb_status_svg__cls-1"
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                            d: "M3.54 20.28h3.62c3.35 0 3.06-2.84 5.52-14.65a.75.75 0 0 1 .32-.44.76.76 0 0 1 .43-.19.78.78 0 0 1 .48.17.7.7 0 0 1 .26.44l4.66 22.72a.8.8 0 0 0 .26.43.76.76 0 0 0 1 0 .82.82 0 0 0 .27-.43L23.53 15a.7.7 0 0 1 .25-.4.7.7 0 0 1 .43-.18.8.8 0 0 1 .46.11.8.8 0 0 1 .31.37c1.13 2.82 1.58 5.38 4.21 5.38h3.27",
                            className: "custom_dnb_status_svg__cls-1"
                        })
                    ]
                })
            })
        ]
    });
var $4fdf17dc453c2890$export$2e2bcd8739ae039 = $4fdf17dc453c2890$var$CustomDnbStatus;



var $e41c6e1a3d2d827e$var$_path;
const $e41c6e1a3d2d827e$var$exclamation_triangle = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $e41c6e1a3d2d827e$var$_path || ($e41c6e1a3d2d827e$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M8 9.06V5.88m-.177 6.133h.346m6.612-.257a2.038 2.038 0 0 1-.09 1.998 2.083 2.083 0 0 1-1.761.973H3.07a2.082 2.082 0 0 1-1.761-.973 2.04 2.04 0 0 1-.09-1.998l4.93-8.62c.171-.342.435-.629.762-.83a2.082 2.082 0 0 1 2.94.83l4.93 8.62Zm-6.533.257c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
        }))
    });
var $e41c6e1a3d2d827e$export$2e2bcd8739ae039 = $e41c6e1a3d2d827e$var$exclamation_triangle;


var $5a76cdf66a6b8d42$export$2e2bcd8739ae039 = (0, $e41c6e1a3d2d827e$export$2e2bcd8739ae039);



var $3dc9ae77036e7be5$export$2e2bcd8739ae039 = (0, $c6167291c77af966$export$2e2bcd8739ae039);



var $aba813b8c0d20ad3$var$_path;
const $aba813b8c0d20ad3$var$stop = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $aba813b8c0d20ad3$var$_path || ($aba813b8c0d20ad3$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeWidth: 1.5,
            d: "M12.95 3.05a7 7 0 0 0-9.9 9.9m9.9-9.9a7 7 0 1 1-9.9 9.9m9.9-9.9-9.9 9.9"
        }))
    });
var $aba813b8c0d20ad3$export$2e2bcd8739ae039 = $aba813b8c0d20ad3$var$stop;


var $dcf2779cdc5e8ab5$export$2e2bcd8739ae039 = (0, $aba813b8c0d20ad3$export$2e2bcd8739ae039);



var $57fc06c0fedf3ba9$var$_path, $57fc06c0fedf3ba9$var$_path2;
const $57fc06c0fedf3ba9$var$account_card_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            $57fc06c0fedf3ba9$var$_path || ($57fc06c0fedf3ba9$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fill: "#000",
                d: "m11.622 9.75.449-.601-.2-.149h-.249v.75Zm-5.994 0V9h-.25l-.199.149.449.601Zm-.378-3a.75.75 0 0 0 0 1.5v-1.5ZM12 8.25a.75.75 0 0 0 0-1.5v1.5Zm1.5-7.5.496.562a.75.75 0 0 0-.62-1.302l.124.74Zm-9 1.5-.123-.74a.75.75 0 0 0-.236 1.398L4.5 2.25Zm1.5 3h-.75V6H6v-.75Zm4.875 0V6h.75v-.75h-.75Zm1.715 6.294a.75.75 0 0 0 1.032-1.088l-1.032 1.088ZM6.942 23.938a.75.75 0 0 0 .116-1.495l-.116 1.495ZM11.622 9H5.628v1.5h5.994V9Zm-6.443.149c-1.235.922-2.514 2.143-3.49 3.519C.716 14.035 0 15.619 0 17.25h1.5c0-1.2.536-2.481 1.411-3.714.87-1.224 2.03-2.338 3.165-3.185L5.18 9.15Zm.071-.899H12v-1.5H5.25v1.5ZM13.377.01l-9 1.5.246 1.48 9-1.5-.246-1.48ZM4.5 2.25l-.36.658-.002-.001-.002-.001-.003-.002A1.564 1.564 0 0 1 4.27 3c.103.081.246.21.391.395.284.361.59.951.59 1.855h1.5c0-1.278-.444-2.188-.91-2.782a3.86 3.86 0 0 0-.641-.645 3.062 3.062 0 0 0-.337-.23h-.001l-.001-.001-.36.658ZM6 6h4.875V4.5H6V6Zm5.625-.75c0-.828.519-1.782 1.157-2.61a11.026 11.026 0 0 1 1.211-1.325l.004-.003L13.5.75a171.156 171.156 0 0 0-.498-.56H13a.82.82 0 0 0-.034.031l-.093.086a12.513 12.513 0 0 0-1.28 1.416c-.674.876-1.468 2.172-1.468 3.526h1.5Zm1.997 5.206a17.389 17.389 0 0 0-1.551-1.307l-.897 1.202c.473.354.954.755 1.416 1.193l1.032-1.088ZM0 17.25c0 1.87.419 3.491 1.59 4.684 1.16 1.183 2.934 1.815 5.352 2.004l.116-1.495c-2.249-.176-3.6-.746-4.398-1.56-.787-.802-1.16-1.968-1.16-3.633H0ZM11.25 15h11v-1.5h-11V15Zm11 7.5h-11V24h11v-1.5ZM11 22.25v-2.5H9.5v2.5H11Zm0-2.5v-4.5H9.5v4.5H11Zm11.5-4.5v4.5H24v-4.5h-1.5Zm0 4.5v2.5H24v-2.5h-1.5Zm-12.25.75h13V19h-13v1.5Zm1 2a.25.25 0 0 1-.25-.25H9.5c0 .966.784 1.75 1.75 1.75v-1.5Zm11 1.5A1.75 1.75 0 0 0 24 22.25h-1.5a.25.25 0 0 1-.25.25V24Zm0-9a.25.25 0 0 1 .25.25H24a1.75 1.75 0 0 0-1.75-1.75V15Zm-11-1.5a1.75 1.75 0 0 0-1.75 1.75H11a.25.25 0 0 1 .25-.25v-1.5Z"
            })),
            $57fc06c0fedf3ba9$var$_path2 || ($57fc06c0fedf3ba9$var$_path2 = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                stroke: "#000",
                d: "M5.814 13.7V19H5.5v-5.3h.314Zm1.795 2.349-.548.603-.284.31.257.333.575.74v.327l-.562-.797-.361-.513-.42.466-.159.177.597-.744.905-1.129v.227Z"
            }))
        ]
    });
var $57fc06c0fedf3ba9$export$2e2bcd8739ae039 = $57fc06c0fedf3ba9$var$account_card_medium;


var $b9b638ebb8114184$var$_path, $b9b638ebb8114184$var$_path2;
const $b9b638ebb8114184$var$account_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            $b9b638ebb8114184$var$_path || ($b9b638ebb8114184$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M8.25 7.5H15m-.378 2.25H8.628c-2.371 1.77-4.878 4.67-4.878 7.5 0 3.918 1.945 6 7.875 6s7.875-2.082 7.875-6c0-2.83-2.507-5.73-4.878-7.5Zm1.878-9-9 1.5s1.5.818 1.5 3h4.875c0-2.182 2.625-4.5 2.625-4.5Z"
            })),
            $b9b638ebb8114184$var$_path2 || ($b9b638ebb8114184$var$_path2 = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fill: "#000",
                d: "M10.799 19.5h1.575l-1.944-2.511L12.239 15h-1.611l-1.314 1.638V13.2H8v6.3h1.314v-1.287l.324-.36 1.161 1.647Zm4.651-4.59c-.576 0-1.071.306-1.323.774V15h-1.17v4.5h1.314v-2.457c0-.657.387-.999 1.152-.999.189 0 .36.018.495.045v-1.125a1.733 1.733 0 0 0-.468-.054Z"
            }))
        ]
    });
var $b9b638ebb8114184$export$2e2bcd8739ae039 = $b9b638ebb8114184$var$account_medium;


var $f769a448ff6985fb$var$_path, $f769a448ff6985fb$var$_path2;
const $f769a448ff6985fb$var$cog_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            $f769a448ff6985fb$var$_path || ($f769a448ff6985fb$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M10.54 2.434a1.957 1.957 0 0 0 2.908 0l.946-1.038a1.959 1.959 0 0 1 3.41 1.413l-.07 1.4a1.958 1.958 0 0 0 2.05 2.054l1.4-.071a1.959 1.959 0 0 1 1.41 3.41l-1.042.94a1.96 1.96 0 0 0 0 2.909l1.042.94a1.96 1.96 0 0 1-1.413 3.41l-1.4-.071a1.958 1.958 0 0 0-2.056 2.056l.071 1.4a1.959 1.959 0 0 1-3.402 1.41l-.94-1.041a1.96 1.96 0 0 0-2.909 0l-.945 1.04a1.959 1.959 0 0 1-3.406-1.407l.072-1.4a1.958 1.958 0 0 0-2.056-2.056l-1.4.07a1.958 1.958 0 0 1-1.416-3.406l1.041-.94a1.96 1.96 0 0 0 0-2.91l-1.04-.944a1.958 1.958 0 0 1 1.408-3.406l1.4.07a1.958 1.958 0 0 0 2.058-2.06l-.067-1.4A1.959 1.959 0 0 1 9.6 1.396l.94 1.038Z",
                clipRule: "evenodd"
            })),
            $f769a448ff6985fb$var$_path2 || ($f769a448ff6985fb$var$_path2 = (0, $60739c7e3f826d8d$exports.jsx)("path", {
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
                clipRule: "evenodd"
            }))
        ]
    });
var $f769a448ff6985fb$export$2e2bcd8739ae039 = $f769a448ff6985fb$var$cog_medium;


var $99dd7cc4f112b7bd$var$_path;
const $99dd7cc4f112b7bd$var$log_in_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $99dd7cc4f112b7bd$var$_path || ($99dd7cc4f112b7bd$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M6.933 5.4V3.933A1.467 1.467 0 0 1 8.4 2.466h1.4m0 17.6H8.4A1.466 1.466 0 0 1 6.933 18.6v-1.466m9.1-4.767a.367.367 0 1 0-.339-.222.364.364 0 0 0 .34.226m-9.9-4.036 2.933 2.933L6.133 14.2m2.934-2.933H1m12.57-10.26 8.8 1.258a.732.732 0 0 1 .63.725v17.104a.733.733 0 0 1-.58.718l-8.8 2.172a.734.734 0 0 1-.887-.718V1.733a.731.731 0 0 1 .837-.726Z"
        }))
    });
var $99dd7cc4f112b7bd$export$2e2bcd8739ae039 = $99dd7cc4f112b7bd$var$log_in_medium;


var $3fcb1d502b2a2f33$var$_path;
const $3fcb1d502b2a2f33$var$mobilephone = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $3fcb1d502b2a2f33$var$_path || ($3fcb1d502b2a2f33$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M7.2 3.227H9m-.88 8.77h.023M4.636 1h7c.352 0 .637.285.637.636v12.728a.636.636 0 0 1-.637.636h-7A.636.636 0 0 1 4 14.364V1.636C4 1.285 4.285 1 4.636 1Z"
        }))
    });
var $3fcb1d502b2a2f33$export$2e2bcd8739ae039 = $3fcb1d502b2a2f33$var$mobilephone;


var $e1ca6ec3b8207d0f$var$_path;
const $e1ca6ec3b8207d0f$var$savings_account_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $e1ca6ec3b8207d0f$var$_path || ($e1ca6ec3b8207d0f$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M10.5 8.25h5.25m-3.75-6a1.5 1.5 0 1 1 3 0M3.737 7.013a1.05 1.05 0 0 1 .593-1.428 4.511 4.511 0 0 1 3.548.218C9.43 4.978 11.558 4.5 13.534 4.5c5.524 0 9.716 3.832 9.716 8.438 0 1.945-.8 3.644-2.139 5.056a1.04 1.04 0 0 0-.218.344l-1.291 4.245a1.023 1.023 0 0 1-.954.667h-2.402c-.489 0-.91-.353-1.004-.842l-.174-1.316a1.028 1.028 0 0 0-1.004-.842h-1.76c-.488 0-.909.353-1.003.843l-.118 1.315c-.093.49-.514.842-1.003.842H7.862c-.447 0-.841-.295-.976-.728l-.877-3.284c-.1-.32-.342-.572-.657-.675-1.27-.419-4.602-2.04-4.602-3.954v-1.897c0-1.244.951-2.272 2.184-2.433a.974.974 0 0 0 .613-.353l.56-.675c.257-.31.314-.745.146-1.112l-.516-1.126Z"
        }))
    });
var $e1ca6ec3b8207d0f$export$2e2bcd8739ae039 = $e1ca6ec3b8207d0f$var$savings_account_medium;


var $16d77439b369692e$var$_path;
const $16d77439b369692e$var$wallet_medium = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: $16d77439b369692e$var$_path || ($16d77439b369692e$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M22 11.5V8a2 2 0 0 0-2-2h-1m3 5.5h-4.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1H22m0-5h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H22m0 0V21a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m0 0 10.467-4.55a1 1 0 0 1 1.357.629L19 6M6 6h13m-.179 8.003h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
        }))
    });
var $16d77439b369692e$export$2e2bcd8739ae039 = $16d77439b369692e$var$wallet_medium;


function $948a817567efcc0c$export$16b26cd5e98d9100(icon) {
    switch(icon){
        case 'Andre tjenester privat':
        case 'Other services personal':
        case 'Andre tjenester business':
        case 'Other services business':
        case 'Andre tjenester bedrift':
            return 0, $b9b638ebb8114184$export$2e2bcd8739ae039;
        case 'wallet':
        case 'Nettbank':
        case 'Corporate Internet banking':
            return 0, $16d77439b369692e$export$2e2bcd8739ae039;
        case 'credit-card':
        case 'Minibanker, kort og betalingsterminaler':
        case 'Minibanker, Kort Og Betalingsterminaler':
            return 0, $57fc06c0fedf3ba9$export$2e2bcd8739ae039;
        case 'log-in':
        case 'Innlogging':
        case 'Login':
            return 0, $99dd7cc4f112b7bd$export$2e2bcd8739ae039;
        case 'calendar':
            return 0, $18a341d907f43f4e$export$2e2bcd8739ae039;
        case 'status':
            return 0, $4fdf17dc453c2890$export$2e2bcd8739ae039;
        case 'mobile-bank':
        case 'Mobilbank':
        case 'DNB Bedrift':
        case 'Sbanken Mobilbank':
            return 0, $3fcb1d502b2a2f33$export$2e2bcd8739ae039;
        case 'Spare':
        case 'Savings':
            return 0, $e1ca6ec3b8207d0f$export$2e2bcd8739ae039;
        // case 'DNB Bedrift':  
        // return bank_medium;
        default:
            return null;
    }
}
function $948a817567efcc0c$export$e544001a802bddb8(status) {
    switch(status){
        case 'operational':
            return 'ok';
        case 'partial_outage':
            return 'partial';
        case 'degraded_performance':
            return 'partial';
        case 'major_outage':
            return 'down';
        case 'under_maintenance':
            return 'partial';
        default:
            break;
    }
}
function $948a817567efcc0c$export$9c3ee57c664156cd(status) {
    console.log("getStatusColor", status);
    switch(status){
        case 'operational':
        case 'none':
            return 'sea-green';
        case 'degraded_performance':
            return 'accent-yellow';
        case 'major':
        case 'major_outage':
        case 'critical':
        case 'minor':
        case 'minor_outage':
        case 'partial_outage':
            return 'accent-red';
        default:
            return 'sea-green';
    }
}
function $948a817567efcc0c$export$c742923ea4ac4c1c(status) {
    switch(status){
        case 'operational':
        case 'none':
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
        case 'minor':
        case 'minor_outage':
        case 'partial_outage':
            return 0, $5a76cdf66a6b8d42$export$2e2bcd8739ae039;
        case 'degraded_performance':
            return 0, $3dc9ae77036e7be5$export$2e2bcd8739ae039;
        case 'major':
        case 'major_outage':
        case 'critical':
            return 0, $dcf2779cdc5e8ab5$export$2e2bcd8739ae039;
        case 'under_maintenance':
            return 0, $f769a448ff6985fb$export$2e2bcd8739ae039;
        default:
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
    }
}
function $948a817567efcc0c$export$b40c13a3e6d581cb(status) {
    switch(status){
        case 'operational':
        case 'none':
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
        case 'minor_outage':
        case 'partial_outage':
        case 'minor':
            return 0, $5a76cdf66a6b8d42$export$2e2bcd8739ae039;
        case 'major_outage':
        case 'critical':
        case 'major':
            return 0, $dcf2779cdc5e8ab5$export$2e2bcd8739ae039;
        case 'degraded_performance':
            return 0, $3dc9ae77036e7be5$export$2e2bcd8739ae039;
        default:
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
    }
}
function $948a817567efcc0c$export$30430f1e824a18e1(item) {
    let arr = [];
    for (let sub of item.subComponents)for (let incident of sub.incidents)arr.push(incident);
    let allIncidents = [
        ...item.incidents,
        ...arr
    ].sort((a, b)=>{
        return (0, $456835a5566ee681$export$2e2bcd8739ae039)(new Date(a.created_at), new Date(b.created_at));
    });
    return allIncidents;
}
function $948a817567efcc0c$export$7e162e1ca82c6723(groups, incidents) {
    let groupsCopy = [
        ...groups
    ];
    /* Iterate through all incidents, we need to attach them to the correct component */ for (let incident of incidents)for (let component of incident.components){
        let correctGroup;
        correctGroup = groupsCopy.find((e)=>e.id === component.id);
        if (correctGroup) correctGroup.incidents.push(incident);
        else /* If incident is not in one of our groups, check subgroups/components, and push to correct one */ for (let group of groupsCopy){
            let found = group.subComponents.find((el)=>el.id === component.id);
            if (found) {
                if (!group.incidents.some((e)=>e.id === incident.id)) group.incidents.push(incident);
            }
        }
    }
    return groupsCopy;
}
function $948a817567efcc0c$export$1ef61927080de40d(incident) {
    return incident.name.toLowerCase().includes('bankid');
}
function $948a817567efcc0c$export$dea2b423f9e4a3c5(path) {
    return '/' + path.split('/')[1];
}




const $1db01b5b63d8fe4c$var$StatusMessage = ({ incident: incident })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const incidentsLocation = location.pathname === "/" ? '/incidents' : `${location.pathname}/incidents`;
    if ((0, $948a817567efcc0c$export$1ef61927080de40d)(incident)) incident.incident_updates[0].body = "Leverand\xf8r jobber med saken.||Vendor is working to resolve the issue.";
    console.log("Incident: ", incident);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: `dnb-status-message dnb-status-message--${incident.impact}`,
        outline: "none",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Container, {
            columnGap: "medium",
            style: {
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            1,
                            10
                        ],
                        large: [
                            1,
                            10
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                            className: "dnb-heading-large",
                            children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incident.name)
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-no-statuses__last-updated",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                                dateTime: (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm'),
                                children: (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-status-message__time",
                            children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incident.incident_updates[0].body)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            11,
                            'end'
                        ],
                        large: [
                            11,
                            'end'
                        ]
                    },
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        className: "dnb-button-custom",
                        text: t('See incidents'),
                        variant: "tertiary",
                        href: incidentsLocation,
                        target: "_self",
                        title: t('Go to the incident overview'),
                        icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039)
                    })
                })
            ]
        })
    });
};
$1db01b5b63d8fe4c$var$StatusMessage.propTypes = {
    incident: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};
var $1db01b5b63d8fe4c$export$2e2bcd8739ae039 = $1db01b5b63d8fe4c$var$StatusMessage;






const $125d6477a8342063$var$StatusMessageWrapper = ({ incidents: incidents, updateTimestamp: updateTimestamp, includedComponents: includedComponents })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const incidentsList = incidents.filter((e)=>e.status !== 'resolved').filter((e)=>{
        if (e.components.length > 0) {
            if (e.components[0].id in includedComponents) return e;
        } else return e;
    }) // If we want to filter out only the components that are affected
    .map((incident)=>{
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $1db01b5b63d8fe4c$export$2e2bcd8739ae039), {
            incident: incident
        }, incident.id);
    });
    const lastUpdated = updateTimestamp !== null ? (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(updateTimestamp, 'dd.MM.yyyy, HH:mm') : '';
    // Get relative path for incidents link
    const incidentsLocation = location.pathname === "/" ? '/incidents' : `${location.pathname}/incidents`;
    if (incidentsList.length > 0) //return <ul className='dnb-status-messages-wrapper'>{incidentsList}</ul>;
    //return <Flex.Container className='dnb-status-messages-wrapper' direction='vertical' gap='small'>{incidentsList}</Flex.Container>;
    return incidentsList;
    else // Should use card here, to get the same style as the status messages
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: "dnb-no-statuses",
        outline: "none",
        backgroundColor: "pistachio",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Container, {
            columnGap: "medium",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            1,
                            10
                        ],
                        large: [
                            1,
                            10
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                            className: "dnb-heading-large",
                            children: t('All our systems and services are working as normal')
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                            className: "dnb-no-statuses__last-updated",
                            children: [
                                t('Last updated'),
                                ": ",
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                                    dateTime: lastUpdated,
                                    children: lastUpdated
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            11,
                            'end'
                        ],
                        large: [
                            11,
                            'end'
                        ]
                    },
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        className: "dnb-button-custom",
                        text: t('See incidents'),
                        variant: "tertiary",
                        href: incidentsLocation,
                        target: "_self",
                        title: t('Go to the incident overview'),
                        icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039)
                    })
                })
            ]
        })
    });
};
var $125d6477a8342063$export$2e2bcd8739ae039 = $125d6477a8342063$var$StatusMessageWrapper;
$125d6477a8342063$var$StatusMessageWrapper.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    updateTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};



parcelRequire("ieaan");


parcelRequire("ieaan");




var $46d2f88363187f49$var$_path;
const $46d2f88363187f49$var$information_bubble = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $46d2f88363187f49$var$_path || ($46d2f88363187f49$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M9 10.666h-.5a1 1 0 0 1-1-1v-2.5a.5.5 0 0 0-.5-.5h-.5m.664-2.41h.022M7.523.75a6.747 6.747 0 0 1 5.91 3.471 6.76 6.76 0 0 1-.168 6.856l1.985 4.173-4.169-1.987A6.757 6.757 0 0 1 1.008 9.37a6.772 6.772 0 0 1 3.497-7.913A6.757 6.757 0 0 1 7.523.75Z"
        }))
    });
var $46d2f88363187f49$export$2e2bcd8739ae039 = $46d2f88363187f49$var$information_bubble;




parcelRequire("ieaan");



function $2e391ba95e263515$export$2e2bcd8739ae039({ item: item }) {
    const formattedStartDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(item.scheduled_for), 'dd.MM.yyyy, HH:mm');
    const formattedEndDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(item.scheduled_until), 'dd.MM.yyyy, HH:mm');
    // Assigns the first update (which gets pushed), to the incidentUpdate, this until this one
    // is fixed: https://community.atlassian.com/t5/Statuspage-questions/Keeping-maintenance-message-from-scheduled-to-ongoing/qaq-p/1879278?utm_source=atlcomm&utm_medium=email&utm_campaign=accept_as_solution_reminder&utm_content=topic
    let incidentUpdate = item.incident_updates.filter((e)=>{
        if (e.status == 'scheduled') return e;
    });
    incidentUpdate = incidentUpdate[0].body;
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-planned-incident__time",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                        dateTime: item.scheduled_for,
                        children: formattedStartDate
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        children: " - "
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                        dateTime: item.scheduled_until,
                        children: formattedEndDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(item.name)
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incidentUpdate)
            })
        ]
    });
}
$2e391ba95e263515$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};


const $a9ee01301fa74513$var$PlannedIncidents = ({ maintenances: maintenances, includedComponents: includedComponents })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const renderContent = ()=>{
        const maintenancesList = maintenances.filter((e)=>{
            if (e.components.length > 0) {
                if (e.components[0].id in includedComponents) return e;
            } else return e;
        });
        if (maintenancesList.length > 0) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
            className: "dnb-planned-incidents",
            style: {
                width: '100%',
                maxWidth: '100%'
            },
            children: maintenancesList.map((maintenance)=>{
                return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $2e391ba95e263515$export$2e2bcd8739ae039), {
                    item: maintenance
                }, maintenance.id);
            })
        });
        else return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-planned-incidents__no-incidents",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                        icon: (0, $46d2f88363187f49$export$2e2bcd8739ae039),
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                        children: [
                            t('There is currently no scheduled maintenance'),
                            "."
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-planned-incidents-wrapper",
        style: {
            width: '100%',
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                className: "dnb-planned-incidents__heading",
                children: t('Scheduled maintenance')
            }),
            renderContent()
        ]
    });
};
var $a9ee01301fa74513$export$2e2bcd8739ae039 = $a9ee01301fa74513$var$PlannedIncidents;
$a9ee01301fa74513$var$PlannedIncidents.propTypes = {
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};



parcelRequire("ieaan");


var $f837560e143adcd2$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($f837560e143adcd2$exports) {
        classNames.default = classNames;
        $f837560e143adcd2$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();





const $c13f7f1437f70ce1$var$Legend = (props)=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    let legendClass = (0, (/*@__PURE__*/$parcel$interopDefault($f837560e143adcd2$exports)))('dnb-legend', {
        'dnb-legend--left': props.iconPosition === 'left'
    });
    const LegendData = [
        {
            id: 'operational',
            status: t('operational')
        },
        {
            id: 'minor',
            status: t('minor')
        },
        {
            id: 'major',
            status: t('major')
        },
        {
            id: 'degraded_performance',
            status: t('degraded_performance')
        },
        {
            id: 'under_maintenance',
            status: t('under_maintenance')
        }
    ];
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: legendClass,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
            children: LegendData.length > 0 && LegendData.map((item)=>{
                return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: `dnb-status-icon dnb-status-icon--${item.id}`,
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.id),
                                size: "16"
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-legend__text",
                            children: item.status
                        })
                    ]
                }, `legend-${item.id}`);
            })
        })
    });
};
var $c13f7f1437f70ce1$export$2e2bcd8739ae039 = $c13f7f1437f70ce1$var$Legend;
$c13f7f1437f70ce1$var$Legend.propTypes = {
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};



parcelRequire("ieaan");



parcelRequire("ieaan");




function $0e3b30b754be7297$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $0e3b30b754be7297$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $c01225e8282db0ef$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($0e3b30b754be7297$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $0e3b30b754be7297$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$0e3b30b754be7297$export$2e2bcd8739ae039 = $0e3b30b754be7297$export$86415ebf4eb36b8c;




parcelRequire("ieaan");





function $ee14c77e46cdc1df$export$2e2bcd8739ae039({ item: item }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    let iconClass = (0, (/*@__PURE__*/$parcel$interopDefault($f837560e143adcd2$exports)))('dnb-status-icon', {
        'dnb-status-icon--operational': item.status === 'operational',
        'dnb-status-icon--minor': item.status === 'minor_outage' || item.status === 'partial_outage',
        'dnb-status-icon--major': item.status === 'major_outage',
        'dnb-status-icon--degraded_performance': item.status === 'degraded_performance',
        'dnb-status-icon--under_maintenance': item.status === 'under_maintenance'
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
        className: "dnb-status-list__item",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: iconClass,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    size: "16",
                    icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.status),
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                children: t(item.name)
            })
        ]
    });
}
$ee14c77e46cdc1df$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};



parcelRequire("ieaan");





function $0bc1282718aeb9f8$export$2e2bcd8739ae039({ name: name, subtitle: subtitle, pageHeader: pageHeader, icon: icon }) {
    let headerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f837560e143adcd2$exports)))('dnb-icon-header', {
        'dnb-icon-header--page-header': pageHeader
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: headerClass,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-icon-header__icon",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    size: "auto",
                    icon: (0, $948a817567efcc0c$export$16b26cd5e98d9100)(icon),
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("h2", {
                children: [
                    name && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
                        children: name
                    }),
                    " ",
                    subtitle && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-icon-header__subtitle",
                        children: subtitle
                    })
                ]
            })
        ]
    });
}
$0bc1282718aeb9f8$export$2e2bcd8739ae039.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    pageHeader: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired
};




const $d8373414d63d1b0f$var$Group = ({ item: item })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const daysSinceIncidentNumber = ()=>{
        if (item.incidents.length === 0) return '00';
        else {
            let sorted = item.incidents.sort((a, b)=>{
                return (0, $456835a5566ee681$export$2e2bcd8739ae039)(new Date(a.started_at), new Date(b.started_at));
            });
            let days = (0, $0e3b30b754be7297$export$2e2bcd8739ae039)(new Date(), new Date(sorted[0].started_at));
            /*if (days < 10) return `0${days}`;*/ return days.toString();
        }
    };
    const daysSinceIncidentText = ()=>{
        if (item.incidents.length === 0) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: [
                t('No incidents in'),
                " ",
                t('over'),
                " 3 ",
                t('months')
            ]
        });
        else return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: [
                daysSinceIncidentNumber(),
                " ",
                t('days since'),
                " ",
                t('last'),
                " ",
                t('incident')
            ]
        });
    };
    /*return (
    <article className='dnb-group'>
      <IconHeader name={t(item.name)} icon={item.name} />
      <div className='dnb-group-content'>
        <div className='dnb-group-content__left'>
          <div className='dnb-incident-counter'>
            <span className='dnb-incident-counter__number'>{daysSinceIncidentNumber()}</span>
            <span className='dnb-incident-counter__text'>{daysSinceIncidentText()}</span>
          </div>
        </div>
        <div className='dnb-group-content__right'>
          <div className='dnb-status-list'>
            <ul>
              {item.subComponents.map((el) => {
                return <GroupListItem item={el} key={el.id} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    </article>
  );
};*/ return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: "dnb-group",
        innerSpace: false,
        align: "stretch",
        outlineWidth: 1.5,
        radius: "1.5rem",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $0bc1282718aeb9f8$export$2e2bcd8739ae039), {
                name: t(item.name),
                icon: item.name
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-incident-counter",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                    className: "dnb-incident-counter__text",
                    children: daysSinceIncidentText()
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $a395d78185689abd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-group-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-group-content__left",
                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "dnb-status-list",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                                children: item.subComponents.map((el)=>{
                                    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee14c77e46cdc1df$export$2e2bcd8739ae039), {
                                        item: el
                                    }, el.id);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-group-content__right"
                    })
                ]
            })
        ]
    });
};
$d8373414d63d1b0f$var$Group.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};
var $d8373414d63d1b0f$export$2e2bcd8739ae039 = $d8373414d63d1b0f$var$Group;



const $28af0973880b5e9a$var$GroupsWrapper = ({ groups: groups })=>{
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-groups-wrapper",
        children: groups.length > 0 && groups.map((item)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d8373414d63d1b0f$export$2e2bcd8739ae039), {
                item: item
            }, item.id))
    });
};
$28af0973880b5e9a$var$GroupsWrapper.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};
var $28af0973880b5e9a$export$2e2bcd8739ae039 = $28af0973880b5e9a$var$GroupsWrapper;




const $839ef15b0a2ceacf$var$FrontpageComponents = ({ maintenances: maintenances, groups: groups, includedComponents: includedComponents, incidents: incidents })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $a9ee01301fa74513$export$2e2bcd8739ae039), {
                maintenances: maintenances,
                includedComponents: includedComponents
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-services-section",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                        className: "dnb-services-section__heading",
                        children: t('Services')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $c13f7f1437f70ce1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $28af0973880b5e9a$export$2e2bcd8739ae039), {
                        groups: groups,
                        incidents: incidents
                    })
                ]
            })
        ]
    });
};
$839ef15b0a2ceacf$var$FrontpageComponents.propTypes = {
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};
var $839ef15b0a2ceacf$export$2e2bcd8739ae039 = $839ef15b0a2ceacf$var$FrontpageComponents;



function $05bb2c4ee1fde64f$export$2e2bcd8739ae039({ groups: groups, incidents: incidents, maintenances: maintenances, updateTimestamp: updateTimestamp, includedComponents: includedComponents }) {
    const groupsWithIncidents = (0, $948a817567efcc0c$export$7e162e1ca82c6723)(groups, incidents);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_home-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("section", {
            className: "dnb-center-content",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $125d6477a8342063$export$2e2bcd8739ae039), {
                    incidents: incidents,
                    updateTimestamp: updateTimestamp,
                    includedComponents: includedComponents
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $839ef15b0a2ceacf$export$2e2bcd8739ae039), {
                    maintenances: maintenances,
                    groups: groupsWithIncidents,
                    incidents: incidents,
                    includedComponents: includedComponents
                })
            ]
        })
    });
}
$05bb2c4ee1fde64f$export$2e2bcd8739ae039.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    isFetchingStatusPage: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    updateTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};



parcelRequire("ieaan");





var $c2d6136bdaab29eb$var$_path;
const $c2d6136bdaab29eb$var$home = (props)=>(0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: $c2d6136bdaab29eb$var$_path || ($c2d6136bdaab29eb$var$_path = (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#000",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M5.667 12.976v-3.66c0-.367.298-.664.666-.664h3.334c.368 0 .666.297.666.665v3.659m-8 1.996h11.334c.736 0 1.333-.596 1.333-1.33V6.674c0-.43-.208-.833-.558-1.083L8.775 1.553a1.336 1.336 0 0 0-1.55 0l-5.667 4.04A1.33 1.33 0 0 0 1 6.674v6.966c0 .735.597 1.33 1.333 1.33Z"
        }))
    });
var $c2d6136bdaab29eb$export$2e2bcd8739ae039 = $c2d6136bdaab29eb$var$home;



parcelRequire("ieaan");
const $09a5b5c9c72636b7$var$CustomDnbLogo = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 57.3 46",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M56.7 30a7.3 7.3 0 0 0 .6-3 5.49 5.49 0 0 0-2.1-4.4 4.1 4.1 0 0 0-1.1-.7l-.1-.1.1-.1a5.34 5.34 0 0 0 1.7-4.2 5.35 5.35 0 0 0-2.1-4.6 8.8 8.8 0 0 0-5-1.2h-6.2a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h7.1a9.83 9.83 0 0 0 5.4-1.4 8.7 8.7 0 0 0 1.7-2.2M43.9 13.8h4.9a6.45 6.45 0 0 1 3.8.9 3.28 3.28 0 0 1 1.2 2.9 3.16 3.16 0 0 1-3.4 3.5h-6.6v-7.3zm5.7 17.7h-5.8v-8.4h6.6c2.9 0 4.9 1.6 4.9 3.9 0 1.1 0 4.5-5.7 4.5m-13.3 2.1h.2a.55.55 0 0 0 .4-.6V0h-2v28.9L21.5 11.8a.55.55 0 0 0-.5-.3h-.2a.55.55 0 0 0-.4.6V46h2V16.3l13.4 17.1a.76.76 0 0 0 .5.2m-22.4-3.3a12.07 12.07 0 0 0 2.4-7.5c0-1.5-.2-5.1-2.4-7.8a8.4 8.4 0 0 0-3.4-2.5 10.5 10.5 0 0 0-3.9-.8H.7a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h5.9a9.2 9.2 0 0 0 3.8-.7 10 10 0 0 0 3.5-2.6m-7.3 1.2H2V13.8h4.6a7 7 0 0 1 5.7 2.5c1.8 2.2 1.9 5.5 1.9 6.5a10.46 10.46 0 0 1-1.9 6.2 7 7 0 0 1-5.7 2.5",
                className: "custom_dnb_logo_svg__cls-1",
                "data-name": "Layer 1"
            })
        })
    });
var $09a5b5c9c72636b7$export$2e2bcd8739ae039 = $09a5b5c9c72636b7$var$CustomDnbLogo;



const $c851a5131cd8667e$var$Header = ()=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("header", {
        className: "dnb-header",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-header__content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $5c8711a28b8203dd$export$a6c7ac8248d6e38a), {
                        to: "/",
                        "aria-label": t('DNB Status front page'),
                        title: t('DNB Status front page'),
                        className: "dnb-main-title",
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                                children: "DNB Status"
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-main-title__logo",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                    icon: (0, $09a5b5c9c72636b7$export$2e2bcd8739ae039),
                                    size: "xx-large"
                                })
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-main-title__sub",
                                children: "Status"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        text: "dnb.no",
                        icon: (0, $c2d6136bdaab29eb$export$2e2bcd8739ae039),
                        variant: "secondary",
                        icon_position: "left",
                        href: "https://www.dnb.no/",
                        target: "_blank"
                    })
                ]
            })
        })
    });
};
var $c851a5131cd8667e$export$2e2bcd8739ae039 = $c851a5131cd8667e$var$Header;



parcelRequire("ieaan");

const $41b6d7e12730d823$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("footer", {
        className: "dnb-footer",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-footer__content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                    className: "dnb-footer__copyright",
                    children: "\xa9 DNB"
                })
            })
        })
    });
};
var $41b6d7e12730d823$export$2e2bcd8739ae039 = $41b6d7e12730d823$var$Footer;



parcelRequire("ieaan");
var $0cdd67f3eabac774$exports = {};
$0cdd67f3eabac774$exports = $parcel$resolve("dEznS");



function $7ec8b67fa7687b7e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("header", {
        className: "dnb-loading",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
            className: "dnb-loading__icon",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0cdd67f3eabac774$exports))),
                alt: "Loading..."
            })
        })
    });
}



var $ieaan = parcelRequire("ieaan");
const $4cb3579337f6afdd$var$GENERIC_ERROR = "Vi har noen problemer som gj\xf8r at vi ikke klarer \xe5 innhente status p\xe5 systemene v\xe5re. Det skal ikke p\xe5virke selve driften av systemene, s\xe5 forh\xe5pentlig fungerer alt fint. Sjekk gjerne innom igjen om noen minutter.";
function $4cb3579337f6afdd$export$2e2bcd8739ae039({ page: page, getIncidents: getIncidents = true, getComponents: getComponents = true, incidentsType: incidentsType = '', getScheduledMaintenances: getScheduledMaintenances = true, scheduledMaintenancesType: scheduledMaintenancesType = {
    in_progress: true,
    scheduled: false,
    completed: false
}, updateInterval: updateInterval = null, includedComponents: includedComponents = {} }) {
    const [groups, setGroups] = (0, $ieaan.useState)([]);
    const [incidents, setIncidents] = (0, $ieaan.useState)([]);
    const [maintenances, setMaintenances] = (0, $ieaan.useState)([]);
    const [error, setError] = (0, $ieaan.useState)(null);
    const [updateTimestamp, setUpdateTimestamp] = (0, $ieaan.useState)(null);
    const [intervalId, setIntervalId] = (0, $ieaan.useState)(null);
    (0, $ieaan.useEffect)(()=>{
        getComponents && fetchComponents();
        getIncidents && fetchIncidents(incidentsType);
        getScheduledMaintenances && fetchScheduledMaintenances(scheduledMaintenancesType);
        if (updateInterval && !intervalId) {
            const id = setInterval(()=>{
                getComponents && fetchComponents();
                getIncidents && fetchIncidents(incidentsType);
                getScheduledMaintenances && fetchScheduledMaintenances(scheduledMaintenancesType);
            }, updateInterval);
            setIntervalId(id);
        }
        return ()=>{
            if (intervalId) clearInterval(intervalId);
        };
        async function fetchScheduledMaintenances(filter) {
            let url;
            url = '/scheduled-maintenances.json';
            const { data: data, error: error } = await getStatusPageData(url);
            if (!error) {
                let scheduled_maintenances = data.scheduled_maintenances.filter((e)=>{
                    if (filter[e.status]) return e;
                });
                setMaintenances(scheduled_maintenances);
            } else setError(error);
        }
        async function fetchIncidents(filter) {
            let url;
            if (filter === '') url = '/incidents.json';
            else url = `/incidents/${filter}.json`;
            const { data: data, error: error } = await getStatusPageData(url);
            if (!error) {
                setIncidents(data.incidents);
                setUpdateTimestamp(new Date());
            } else setError(error);
        }
        async function fetchComponents() {
            const { data: data, error: error } = await getStatusPageData('/components.json');
            if (!error) {
                const tempGroups = [];
                for (let component of data.components){
                    component.incidents = [];
                    if (component.group) {
                        component.subComponents = component.components.map((id)=>data.components.find((e)=>e.id === id));
                        if (includedComponents.hasOwnProperty(component.id)) {
                            console.log('Included ' + component.id + ' ' + component.name);
                            tempGroups.push(component);
                        } else console.log('Not included ' + component.id + ' ' + component.name);
                    }
                }
                setGroups(tempGroups);
            } else setError(error);
        }
        async function getStatusPageData(endpoint) {
            try {
                const url = `https://${page}.statuspage.io/api/v2${endpoint}`;
                let response = await fetch(url);
                if (response.ok) {
                    let data = await response.json();
                    return {
                        data: data
                    };
                } else return {
                    error: $4cb3579337f6afdd$var$GENERIC_ERROR
                };
            } catch (error) {
                return {
                    error: $4cb3579337f6afdd$var$GENERIC_ERROR
                };
            }
        }
    }, [
        getComponents,
        getIncidents,
        getScheduledMaintenances,
        incidentsType,
        scheduledMaintenancesType,
        updateInterval,
        intervalId,
        page
    ]);
    return {
        groups: groups,
        incidents: incidents,
        maintenances: maintenances,
        error: error,
        updateTimestamp: updateTimestamp
    };
}



parcelRequire("ieaan");


parcelRequire("ieaan");



var $47658ea72bda9870$exports = {};
$47658ea72bda9870$exports = $parcel$resolve("3ehqk");




parcelRequire("ieaan");





function $f9b0fd5354592e88$export$2e2bcd8739ae039(props) {
    let linkClass = (0, (/*@__PURE__*/$parcel$interopDefault($f837560e143adcd2$exports)))('dnb-status-link', {
        'dnb-status-link--right': props.iconPosition === 'right'
    });
    if (props.external) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("a", {
        href: props.href,
        className: linkClass,
        to: props.href,
        title: props.title,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            props.icon && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: props.icon,
                size: "auto",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-button__text",
                children: props.children
            })
        ]
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $5c8711a28b8203dd$export$a6c7ac8248d6e38a), {
        className: linkClass,
        to: props.href,
        title: props.title,
        relative: "path",
        children: [
            props.icon && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                "aria-hidden": true,
                icon: props.icon,
                size: "auto"
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-button__text",
                children: props.children
            })
        ]
    });
}
$f9b0fd5354592e88$export$2e2bcd8739ae039.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).any,
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    external: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool
};



parcelRequire("ieaan");



function $9782eb266730637b$export$5846dc2d57a5c860(date, options) {
    return (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$9782eb266730637b$export$2e2bcd8739ae039 = $9782eb266730637b$export$5846dc2d57a5c860;





function $3a7664a91dacafb6$export$2e2bcd8739ae039({ date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek }) {
    const week = (0, $b249011336f9bc7f$export$2e2bcd8739ae039)(date);
    const year = (0, $9782eb266730637b$export$2e2bcd8739ae039)(date);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-month-picker",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-small-button dnb-small-button--prev",
                onClick: ()=>decrementWeek(),
                "aria-label": "G\xe5 til forrige uke",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                    size: "25",
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-month-picker__current-week",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                    children: [
                        "Uke ",
                        week,
                        " ",
                        year
                    ]
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-small-button dnb-small-button--next",
                onClick: ()=>incrementWeek(),
                "aria-label": "G\xe5 til neste uke",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039),
                    size: "25",
                    "aria-hidden": true
                })
            })
        ]
    });
}
$3a7664a91dacafb6$export$2e2bcd8739ae039.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    incrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func,
    decrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func
};



const $b74d20f62e4fd045$var$HistoryHeader = ({ date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek })=>{
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-history-header",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-history-header__actions",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                        href: "/",
                        title: t('Back to the front page'),
                        icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                        children: t('Back')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                        href: "/",
                        title: t('Subscribe to updates'),
                        children: t('Subscribe to updates')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-history-header__content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("h2", {
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($47658ea72bda9870$exports))),
                                size: "auto",
                                "aria-hidden": true
                            }),
                            t('History')
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3a7664a91dacafb6$export$2e2bcd8739ae039), {
                        date: date,
                        decrementWeek: decrementWeek,
                        incrementWeek: incrementWeek
                    })
                ]
            })
        ]
    });
};
$b74d20f62e4fd045$var$HistoryHeader.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    incrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func,
    decrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func
};
var $b74d20f62e4fd045$export$2e2bcd8739ae039 = $b74d20f62e4fd045$var$HistoryHeader;



parcelRequire("ieaan");




function $af9de907ec618575$export$6ea683876c36b8d2(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(laterDate_, options) === +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(earlierDate_, options);
}
var // Fallback for modularized imports:
$af9de907ec618575$export$2e2bcd8739ae039 = $af9de907ec618575$export$6ea683876c36b8d2;



function $45397e0bd0a09e73$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$45397e0bd0a09e73$export$2e2bcd8739ae039 = $45397e0bd0a09e73$export$5841f9eb9773f25f;




var $ieaan = parcelRequire("ieaan");





const $fd69deb2242d3b89$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $fd69deb2242d3b89$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $fd69deb2242d3b89$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};



const $20d7cb3bcc724425$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $20d7cb3bcc724425$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $20d7cb3bcc724425$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $20d7cb3bcc724425$export$cbf60ecb96cbb82f = {
    date: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $e986719f1e8e2d8d$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $e986719f1e8e2d8d$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$e986719f1e8e2d8d$var$formatRelativeLocale[token];



const $7b80591259fcde5f$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $7b80591259fcde5f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $7b80591259fcde5f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $7b80591259fcde5f$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $7b80591259fcde5f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
const $7b80591259fcde5f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7b80591259fcde5f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7b80591259fcde5f$var$ordinalNumber,
    era: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};




const $53b6ee5e08c77e5f$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $53b6ee5e08c77e5f$var$parseOrdinalNumberPattern = /\d+/i;
const $53b6ee5e08c77e5f$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $53b6ee5e08c77e5f$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $53b6ee5e08c77e5f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $53b6ee5e08c77e5f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $53b6ee5e08c77e5f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $53b6ee5e08c77e5f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $53b6ee5e08c77e5f$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $53b6ee5e08c77e5f$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $53b6ee5e08c77e5f$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
const $53b6ee5e08c77e5f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $53b6ee5e08c77e5f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $70cb8aaf6e245039$export$fdaf2fd6d7edde95)({
        matchPattern: $53b6ee5e08c77e5f$var$matchOrdinalNumberPattern,
        parsePattern: $53b6ee5e08c77e5f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $53b6ee5e08c77e5f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $c8d01de8f15790bb$export$38ef0e3f791a121e = {
    code: "nb",
    formatDistance: (0, $fd69deb2242d3b89$export$2c14ff85d6318973),
    formatLong: (0, $20d7cb3bcc724425$export$cbf60ecb96cbb82f),
    formatRelative: (0, $e986719f1e8e2d8d$export$8fbbfd65594f46a0),
    localize: (0, $7b80591259fcde5f$export$b3bd0bc58e36cd63),
    match: (0, $53b6ee5e08c77e5f$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$c8d01de8f15790bb$export$2e2bcd8739ae039 = $c8d01de8f15790bb$export$38ef0e3f791a121e;





function $f33c67b2bf6fd23c$export$2e2bcd8739ae039({ item: item }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [isClosed, setClosed] = (0, $ieaan.useState)([
        true
    ]);
    const date = new Date(item.started_at);
    const formattedDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(date, 'dd');
    const formattedMonth = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(date, 'MMM', {
        locale: (0, $c8d01de8f15790bb$export$38ef0e3f791a121e)
    });
    const formattedIncidentStatusDate = (date)=>{
        let dateObj;
        if (typeof date === 'string') dateObj = new Date(date);
        else dateObj = date;
        return (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(dateObj, 'dd.MM.yy HH:mm');
    };
    //const affectedComponentsString = item.components.map((e) => e.name).join(', ');
    // Trying to map with translated names
    const affectedComponentsString = item.components.map((e)=>t(e.name)).join(', ');
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("article", {
        className: `dnb-historic-incident-card dnb-historic-incident-card--${item.impact}`,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-card-date",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-card-date__day",
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-card-date__month",
                        children: formattedMonth
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-card-text",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                        children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(item.name)
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('affected'),
                            ": ",
                            affectedComponentsString
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('started'),
                            ": ",
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                children: formattedIncidentStatusDate(item.started_at)
                            })
                        ]
                    }),
                    item.resolved_at && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('resolved'),
                            ": ",
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                children: formattedIncidentStatusDate(item.resolved_at)
                            })
                        ]
                    }),
                    item.incident_updates.length > 0 && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("button", {
                        "aria-expanded": isClosed === true ? 'false' : 'true',
                        className: `dnb-status-text-button ${isClosed ? '' : 'dnb-status-text-button--clicked'}`,
                        onClick: ()=>setClosed(!isClosed),
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-status-text-button__text",
                                children: isClosed ? t('Show log') : t('Hide log')
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-status-text-button__icon",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                    icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039),
                                    size: "20",
                                    "aria-hidden": true
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: `dnb-status-icon dnb-status-icon--${item.impact}`,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    class: "",
                    icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.impact),
                    "aria-hidden": true,
                    size: "25"
                })
            }),
            item.incident_updates.length > 0 && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: `dnb-incident-history ${isClosed ? '' : 'dnb-incident-history--open'}`,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                    children: item.incident_updates.map((e)=>{
                        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                    className: "dnb-incident-history__body",
                                    children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(e.body)
                                }),
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                    className: "dnb-incident-history__date",
                                    children: formattedIncidentStatusDate(e.updated_at)
                                })
                            ]
                        }, e.id);
                    })
                })
            })
        ]
    });
}
$f33c67b2bf6fd23c$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};


function $1688829d097592bb$export$2e2bcd8739ae039({ group: group, date: date }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    /* All resolved incidents in the same month / year as currently selected */ const resolvedIncidents = group.incidents.filter((e)=>{
        if (e.status === 'resolved' && (0, $af9de907ec618575$export$2e2bcd8739ae039)(date, new Date(e.started_at)) && (0, $45397e0bd0a09e73$export$2e2bcd8739ae039)(date, new Date(e.started_at))) return e;
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "left",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    children: [
                        resolvedIncidents.length,
                        " ",
                        t('incidents')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "right",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                    className: "incident-list",
                    children: resolvedIncidents.map((e)=>{
                        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f33c67b2bf6fd23c$export$2e2bcd8739ae039), {
                            item: e
                        }, e.id);
                    })
                })
            })
        ]
    });
}
$1688829d097592bb$export$2e2bcd8739ae039.propTypes = {
    group: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date)
};



var $ieaan = parcelRequire("ieaan");


function $6cc55444142e86f5$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$6cc55444142e86f5$export$2e2bcd8739ae039 = $6cc55444142e86f5$export$dd412b56f1e4d8aa;


function $08f9c67d76427a6a$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $6cc55444142e86f5$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$08f9c67d76427a6a$export$2e2bcd8739ae039 = $08f9c67d76427a6a$export$ef501a2bb4f3ee6b;



function $2c053222becae1a0$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $08f9c67d76427a6a$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$2c053222becae1a0$export$2e2bcd8739ae039 = $2c053222becae1a0$export$b4d8ae6376193efb;


function $a991984b621a0dfb$export$2e2bcd8739ae039(initialDate) {
    const [date, setDate] = (0, $ieaan.useState)(initialDate);
    function incrementWeek() {
        let newDate = (0, $08f9c67d76427a6a$export$2e2bcd8739ae039)(date, 1);
        setDate(newDate);
    }
    function decrementWeek() {
        let newDate = (0, $2c053222becae1a0$export$2e2bcd8739ae039)(date, 1);
        setDate(newDate);
    }
    return {
        date: date,
        incrementWeek: incrementWeek,
        decrementWeek: decrementWeek
    };
}



function $7b4fbae4d9f02598$export$2e2bcd8739ae039({ groups: groups, incidents: incidents }) {
    const { date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek } = (0, $a991984b621a0dfb$export$2e2bcd8739ae039)(new Date());
    const resolvedIncidents = incidents.filter((e)=>e.status === 'resolved');
    const mergedGroupsAndIncidents = (0, $948a817567efcc0c$export$7e162e1ca82c6723)(groups, resolvedIncidents);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "p_history-page",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b74d20f62e4fd045$export$2e2bcd8739ae039), {
                    date: date,
                    incrementWeek: incrementWeek,
                    decrementWeek: decrementWeek
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: mergedGroupsAndIncidents.map((group)=>{
                    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $1688829d097592bb$export$2e2bcd8739ae039), {
                        group: group,
                        date: date
                    }, group.id);
                })
            })
        ]
    });
}
$7b4fbae4d9f02598$export$2e2bcd8739ae039.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};



parcelRequire("ieaan");





var $ieaan = parcelRequire("ieaan");


function $5a66ca5ff1e7abcd$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options?.in);
    const [startTime, endTime] = [
        +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(interval.start, options?.in),
        +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(interval.end, options?.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$5a66ca5ff1e7abcd$export$2e2bcd8739ae039 = $5a66ca5ff1e7abcd$export$d7deef7a3738e19d;




function $802d7bb0636862ee$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $7c1787257eb00a81$export$ead8a1812b171991)(options?.in || date, +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$802d7bb0636862ee$export$2e2bcd8739ae039 = $802d7bb0636862ee$export$baf757aaf0c95c94;



function $146955a13de5ac75$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $802d7bb0636862ee$export$baf757aaf0c95c94)(date, amount * (0, $37682150499c1c6a$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$146955a13de5ac75$export$2e2bcd8739ae039 = $146955a13de5ac75$export$4a4306ad4fa0e5e6;


function $221f579b1555e59c$export$5e9fa51cd5bb1e71(date, amount, options) {
    return (0, $146955a13de5ac75$export$4a4306ad4fa0e5e6)(date, -amount, options);
}
var // Fallback for modularized imports:
$221f579b1555e59c$export$2e2bcd8739ae039 = $221f579b1555e59c$export$5e9fa51cd5bb1e71;



function $afc41f9a060402a8$export$70823084e2deb1ea(date, amount, options) {
    return (0, $6cc55444142e86f5$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$afc41f9a060402a8$export$2e2bcd8739ae039 = $afc41f9a060402a8$export$70823084e2deb1ea;









function $b66aecc48eb0b618$export$2e2bcd8739ae039({ incidents: incidents = [], filterType: filterType = 'ongoing', timeRange: timeRange = 48, title: title, className: className = '' }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [filteredIncidents, setFilteredIncidents] = (0, $ieaan.useState)([]);
    // Helper function to handle bilingual text (Norwegian||English)
    const FindLanguage = (incidentText)=>{
        console.log('Language: ' + i18n.language);
        let incidentTextInLanguage = incidentText;
        let splitter = incidentText.indexOf('||');
        // If we find splitter in the text
        if (splitter !== -1) {
            console.log('Found language splitter');
            // If the detected language is norwegian we select the left side of the string
            if (i18n.language === 'nb-NO' || i18n.language === 'no' || i18n.language === 'nb') incidentTextInLanguage = incidentText.substring(0, splitter);
            else incidentTextInLanguage = incidentText.substring(2 + splitter);
        // Else we do not find a splitter, and we return the string untouched.
        } else console.log('Did not find language splitter for text: -->' + incidentTextInLanguage + '<--');
        console.log('Returning this text: ' + t(incidentTextInLanguage));
        return t(incidentTextInLanguage);
    };
    // Helper function to get status text - only four options
    const getStatusText = (status)=>{
        switch(status){
            case 'operational':
            case 'none':
                return t('operational');
            case 'minor_outage':
            case 'partial_outage':
            case 'minor':
                return t('minor');
            case 'major_outage':
            case 'critical':
            case 'major':
                return t('major');
            case 'degraded_performance':
                return t('degraded_performance');
            default:
                return status;
        }
    };
    (0, $ieaan.useEffect)(()=>{
        if (!incidents || !Array.isArray(incidents)) {
            setFilteredIncidents([]);
            return;
        }
        let filtered = [];
        switch(filterType){
            case 'ongoing':
                // Only unresolved incidents
                filtered = incidents.filter((e)=>e.status !== 'resolved');
                break;
            case 'historic':
                // Only resolved incidents
                filtered = incidents.filter((e)=>e.status === 'resolved');
                break;
            case 'hours':
                // Incidents within the last X hours
                {
                    let now = new Date();
                    let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, timeRange);
                    filtered = incidents.filter((e)=>{
                        if (e.status !== 'resolved') return true;
                        else return (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                            start: earliestDate,
                            end: now
                        });
                    });
                }
                break;
            case 'days':
                // Incidents within the last X days
                {
                    let now = new Date();
                    let earliestDate = (0, $afc41f9a060402a8$export$2e2bcd8739ae039)(now, timeRange);
                    filtered = incidents.filter((e)=>{
                        if (e.status !== 'resolved') return true;
                        else return (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                            start: earliestDate,
                            end: now
                        });
                    });
                }
                break;
            case 'all':
                // All incidents
                filtered = incidents;
                break;
            default:
                filtered = incidents.filter((e)=>e.status !== 'resolved');
        }
        setFilteredIncidents(filtered);
    }, [
        incidents,
        filterType,
        timeRange
    ]);
    const renderIncidentCard = (incident)=>{
        try {
            const startedAt = incident.started_at ? (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm') : 'N/A';
            const latestUpdate = incident.incident_updates && incident.incident_updates.length > 0 ? incident.incident_updates[0] : null;
            // Get affected components
            const affectedComponents = incident.components && incident.components.length > 0 ? incident.components.map((c)=>t(c.name || c)).join(', ') : '';
            const impactStatus = incident.impact || 'none';
            return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
                className: "incident-viewer__card",
                outline: "none",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    className: "incident-viewer__card-content",
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__card-header",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                                className: "incident-viewer__card-start",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                                    className: "incident-viewer__label",
                                    children: [
                                        t('Incident started'),
                                        ": ",
                                        startedAt
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__right-section",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                                className: `incident-viewer__status-container incident-viewer__status-container--${impactStatus}`,
                                children: [
                                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                        className: `incident-viewer__icon-circle incident-viewer__icon-circle--${impactStatus}`,
                                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                            icon: (0, $948a817567efcc0c$export$b40c13a3e6d581cb)(impactStatus),
                                            size: "16"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                        className: `incident-viewer__status-text`,
                                        children: getStatusText(impactStatus)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                            className: "incident-viewer__title",
                            children: incident.name ? FindLanguage(incident.name) : 'Incident'
                        }),
                        affectedComponents && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: `incident-viewer__affected incident-viewer__affected--${impactStatus}`,
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                                className: "incident-viewer__affected-label",
                                children: [
                                    t('Incident affects'),
                                    ": ",
                                    affectedComponents
                                ]
                            })
                        }),
                        latestUpdate && latestUpdate.body && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__description",
                            children: FindLanguage(latestUpdate.body)
                        })
                    ]
                })
            }, incident.id);
        } catch (error) {
            console.error('Error rendering incident card:', error, incident);
            return null;
        }
    };
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: `incident-viewer ${className}`,
        children: [
            title && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                className: "incident-viewer__section-title",
                children: title
            }),
            filteredIncidents.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "incident-viewer__list",
                children: filteredIncidents.map((incident)=>renderIncidentCard(incident))
            }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
                className: "incident-viewer__empty-card",
                outline: "none",
                backgroundColor: "pistachio",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                    className: "incident-viewer__empty-content",
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incident-viewer__empty-title",
                        children: filterType === 'ongoing' ? t('All systems are currently operating normally') : t('No resolved incidents in the archive')
                    })
                })
            })
        ]
    });
}
$b66aecc48eb0b618$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    filterType: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOf([
        'ongoing',
        'historic',
        'hours',
        'days',
        'all'
    ]),
    timeRange: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};





function $12faf44e51eb8812$export$2e2bcd8739ae039({ incidents: incidents = [] }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const navigate = (0, $5c8711a28b8203dd$export$9770f232ac06a008)();
    const location = (0, $5c8711a28b8203dd$export$45d76561a5302f2b)();
    // Determine if we're on the business tab or personal tab
    const isBusiness = location.pathname.startsWith('/business');
    const homeRoute = isBusiness ? '/business' : '/';
    const archiveRoute = isBusiness ? '/business/archive' : '/archive';
    if (!incidents) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_incidents-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: "Loading incidents..."
            })
        })
    });
    try {
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                        className: "incidents-header",
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                                className: "back-button",
                                text: t('Back'),
                                variant: "secondary",
                                size: "medium",
                                icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                                icon_position: "left",
                                onClick: ()=>navigate(homeRoute)
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                                className: "archive-button",
                                text: t('Archive'),
                                variant: "secondary",
                                size: "medium",
                                onClick: ()=>navigate(archiveRoute)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incidents-page-title",
                        children: t('Ongoing incidents')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b66aecc48eb0b618$export$2e2bcd8739ae039), {
                        incidents: incidents,
                        filterType: "ongoing"
                    })
                ]
            })
        });
    } catch (error) {
        console.error('OngoingIncidentPage render error:', error);
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                    children: [
                        "Error loading incidents page: ",
                        error.message
                    ]
                })
            })
        });
    }
}
$12faf44e51eb8812$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};



parcelRequire("ieaan");







function $d41e63f8456ed3d6$export$2e2bcd8739ae039({ incidents: incidents = [] }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const navigate = (0, $5c8711a28b8203dd$export$9770f232ac06a008)();
    const location = (0, $5c8711a28b8203dd$export$45d76561a5302f2b)();
    // Determine if we're on the business tab or personal tab
    const isBusiness = location.pathname.startsWith('/business');
    const incidentsRoute = isBusiness ? '/business/incidents' : '/incidents';
    // Add a check to ensure incidents is an array
    if (!incidents) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_incidents-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: "Loading archived incidents..."
            })
        })
    });
    try {
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "incidents-header",
                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                            className: "back-button",
                            text: t('Back'),
                            variant: "secondary",
                            size: "medium",
                            icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                            icon_position: "left",
                            onClick: ()=>navigate(incidentsRoute)
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incidents-page-title",
                        children: t('Archive')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b66aecc48eb0b618$export$2e2bcd8739ae039), {
                        incidents: incidents,
                        filterType: "historic"
                    })
                ]
            })
        });
    } catch (error) {
        console.error('ArchivePage render error:', error);
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                    children: [
                        "Error loading archive page: ",
                        error.message
                    ]
                })
            })
        });
    }
}
$d41e63f8456ed3d6$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};





var $b00a38d86ff97cb9$exports = {};
$b00a38d86ff97cb9$exports = JSON.parse("{\"page\":\"n3pkrn6d6qtk\"}");


//const config = require('./dev.json')
const $caf4cd8c41e1fa55$var$statusPageConfigPersonal = {
    //Preprod page: 'cr0lphtyqjz0', //Production page: 'n3pkrn6d6qtk'
    page: (0, (/*@__PURE__*/$parcel$interopDefault($b00a38d86ff97cb9$exports))).page,
    getIncidents: true,
    incidentsType: '',
    getComponents: true,
    getScheduledMaintenances: true,
    scheduledMaintenancesType: {
        in_progress: true,
        scheduled: true,
        completed: false
    },
    updateInterval: 30000,
    includedComponents: {
        //#PROD
        //Innlogging
        l2lgzys2gz88: 'Innlogging',
        tnw56bcc739s: 'BankID',
        '1dm46zl9zk0z': "BankID p\xe5 mobil for Telenor",
        '8b23mx7mnkcv': "BankID p\xe5 mobil for Telia",
        xyynf61zkx6m: "BankID p\xe5 mobil for Ice.net",
        hfq6c7k81w89: 'BankID (OIDC)',
        '1pfztystjrzk': 'BankID App',
        l3t64spqnfzn: 'DigiPass',
        cttbsnk1nnk4: 'GO3Phonecode',
        //Nettbank
        rtdlds1sbwl7: 'Nettbank',
        gtsl57dxb26f: 'Kontoer/balanse Nett',
        y6ng73k0nqp8: "Overf\xf8ringer Nett",
        przh27kqfg7w: 'Betalinger Nett',
        //Mobilbank
        '4klj7trfzvp5': 'Mobilbank',
        '4yvx39ckc5jy': 'Betalinger Mobil',
        qkxyg79t7d7g: 'Kontoer/Balanse Mobil',
        txjq2s9926sw: "Overf\xf8ringer Mobil",
        ypxdcjjrsvcr: 'Regninger Mobil',
        //Kort
        c3cvf4lsnfzg: 'Minibanker, kort og betalingsterminaler',
        '0gtsdyvskqng': 'Kort',
        //Spare
        '6dldw262pd9z': 'Spare',
        '9mdp0dscmp7z': 'Pensjonskonto Flex',
        //Andre tjenester
        ldbl8vk30rb6: 'Andre tjenester privat',
        '1n9zpt1sh5dh': 'Andre tjenester privat',
        // Sbanken Mobilbank
        '1zl3jrflgc9t': 'Sbanken Mobilbank',
        'ck6y3x1fmz7q': 'Betalinger Mobil',
        'jdxr3vjj5d6b': 'Kontoer/Balanse Mobil',
        'p5151pwllfd3': "Overf\xf8ringer Mobil",
        '9n1z2j6zpfw5': 'Regninger Mobil',
        //#Test / Dev
        // Nettbank
        vcn6bh1rx3yg: 'Corporate internet banking',
        wl494vvmvckp: 'Nettbank',
        vtkxbj52qf6w: "Overf\xf8ringer Nett",
        ndlfykymrw0v: 'Kontoer/balanse Nett',
        // Kort
        hdyvd0v0w8gh: 'Minibankenr',
        '603y3yfkdhf3': 'Kort',
        //Mobilbank
        wcfk3rn3hpdl: 'Mobilbank',
        vjbyt2zktkrm: 'Betalinger Mobil',
        wds7kg6y5prc: 'Kontoer/Balanse Mobil',
        gyg6gyl54cnv: "Overf\xf8ring Mobil",
        //Sbanken Mobilbank
        'z08v9zqhc37g': 'Sbanken Mobilbank',
        'hjrc9m2drl1t': 'Betalinger Mobil',
        'fql7qp08r937': 'Kontoer/Balanse Mobil',
        // Innlogging
        // Innlogging
        z2fqtbpsh52z: 'Innlogging',
        qsytltngrx8r: 'BankID mob TN',
        '2rt3lmgbsy7v': 'BankID mob TL',
        cqd3nnsblbyh: 'BankID mob ICE',
        md8v5vg7xc9k: 'BankID OIDC',
        stv8gcy7fxxh: 'BankID App',
        kv3m47y6d6f2: 'BankID',
        //Andre tjenester privat
        '49g1fjyryvkb': 'Andre tjenester privat',
        gkcsc9yk7grw: 'Andre tjenester privat'
    }
};
const $caf4cd8c41e1fa55$var$statusPageConfigBusiness = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($b00a38d86ff97cb9$exports))).page,
    getIncidents: true,
    incidentsType: '',
    getComponents: true,
    getScheduledMaintenances: true,
    scheduledMaintenancesType: {
        in_progress: true,
        scheduled: true,
        completed: false
    },
    updateInterval: 30000,
    includedComponents: {
        // #PROD#
        // DNB Bedrift (app)
        'h14z7m281186': 'DNB Bedrift (app)',
        '11b0x4pr6xb2': 'Payments',
        //Corporate internet banking
        xlnqvn1tr7zb: 'Corporate Internet banking',
        '8y74k6rbjrqm': 'Transactions',
        l465c623dflm: 'Payments Overview',
        '5bx84bcgntst': 'Payments',
        z9w32g0yr69f: 'Account Overview',
        'tn52rl4sqb2x': 'International Payments',
        //Innlogging
        l2lgzys2gz88: 'Innlogging',
        tnw56bcc739s: 'BankID',
        '1dm46zl9zk0z': "BankID p\xe5 mobil for Telenor",
        '8b23mx7mnkcv': "BankID p\xe5 mobil for Telia",
        xyynf61zkx6m: "BankID p\xe5 mobil for Ice.net",
        hfq6c7k81w89: 'BankID (OIDC)',
        l3t64spqnfzn: 'DigiPass',
        cttbsnk1nnk4: 'GO3Phonecode',
        '1pfztystjrzk': 'BankID App',
        //Andre tjenester bedrift
        'xdhm469t57s2': 'Andre tjenester bedrift',
        'x4dfh4vtjt2p': 'Andre tjenester bedrift',
        //#Test / Dev
        // Innlogging
        z2fqtbpsh52z: 'Innlogging',
        qsytltngrx8r: 'BankID mob TN',
        '2rt3lmgbsy7v': 'BankID mob TL',
        cqd3nnsblbyh: 'BankID mob ICE',
        md8v5vg7xc9k: 'BankID OIDC',
        stv8gcy7fxxh: 'BankID App',
        kv3m47y6d6f2: 'BankID',
        // Corporate internet banking
        vcn6bh1rx3yg: 'Corporate internet banking',
        '7vg5p63crcvg': 'International Payments',
        // Andre tjenester bedrift
        jtzztlxn7p9y: 'Andre tjenester bedrift',
        mj2lgfg7yn0d: 'Andre tjenester bedrift'
    }
};
function $caf4cd8c41e1fa55$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $5c8711a28b8203dd$export$9ba4e89fdfa1fc54), {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $c851a5131cd8667e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)($caf4cd8c41e1fa55$var$Content, {})
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $41b6d7e12730d823$export$2e2bcd8739ae039), {})
        ]
    });
}
const $caf4cd8c41e1fa55$var$Content = ()=>{
    const navigate = (0, $5c8711a28b8203dd$export$9770f232ac06a008)();
    const location = (0, $5c8711a28b8203dd$export$45d76561a5302f2b)();
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const personal = (0, $4cb3579337f6afdd$export$2e2bcd8739ae039)($caf4cd8c41e1fa55$var$statusPageConfigPersonal);
    const business = (0, $4cb3579337f6afdd$export$2e2bcd8739ae039)($caf4cd8c41e1fa55$var$statusPageConfigBusiness);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-center-content",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $eea10711b390990c$export$2e2bcd8739ae039), {
            data: [
                {
                    title: t('Personal'),
                    key: '/'
                },
                {
                    title: t('Business'),
                    key: '/business'
                }
            ],
            tabs_style: "white",
            selectedKey: (0, $948a817567efcc0c$export$dea2b423f9e4a3c5)(location.pathname),
            onChange: ({ key: key })=>navigate(key),
            align: "left",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $5c8711a28b8203dd$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/incidents",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $12faf44e51eb8812$export$2e2bcd8739ae039), {
                            incidents: personal.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/archive",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d41e63f8456ed3d6$export$2e2bcd8739ae039), {
                            incidents: personal.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/business/incidents",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $12faf44e51eb8812$export$2e2bcd8739ae039), {
                            incidents: business.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/business/archive",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d41e63f8456ed3d6$export$2e2bcd8739ae039), {
                            incidents: business.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/history",
                        element: personal.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7b4fbae4d9f02598$export$2e2bcd8739ae039), {
                            groups: personal.groups,
                            incidents: personal.incidents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                            children: [
                                t('Loading'),
                                "..."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/business",
                        element: business.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $05bb2c4ee1fde64f$export$2e2bcd8739ae039), {
                            groups: business.groups,
                            incidents: business.incidents,
                            maintenances: business.maintenances,
                            updateTimestamp: business.updateTimestamp,
                            includedComponents: $caf4cd8c41e1fa55$var$statusPageConfigBusiness.includedComponents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7ec8b67fa7687b7e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $5c8711a28b8203dd$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: personal.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $05bb2c4ee1fde64f$export$2e2bcd8739ae039), {
                            groups: personal.groups,
                            incidents: personal.incidents,
                            maintenances: personal.maintenances,
                            updateTimestamp: personal.updateTimestamp,
                            includedComponents: $caf4cd8c41e1fa55$var$statusPageConfigPersonal.includedComponents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7ec8b67fa7687b7e$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};




const { slice: $e10a9fba5fb103db$var$slice, forEach: $e10a9fba5fb103db$var$forEach } = [];
function $e10a9fba5fb103db$var$defaults(obj) {
    $e10a9fba5fb103db$var$forEach.call($e10a9fba5fb103db$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $e10a9fba5fb103db$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $e10a9fba5fb103db$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $e10a9fba5fb103db$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$e10a9fba5fb103db$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$e10a9fba5fb103db$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $e10a9fba5fb103db$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $e10a9fba5fb103db$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $e10a9fba5fb103db$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $e10a9fba5fb103db$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $e10a9fba5fb103db$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $e10a9fba5fb103db$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $e10a9fba5fb103db$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $e10a9fba5fb103db$var$hasLocalStorageSupport = null;
const $e10a9fba5fb103db$var$localStorageAvailable = ()=>{
    if ($e10a9fba5fb103db$var$hasLocalStorageSupport !== null) return $e10a9fba5fb103db$var$hasLocalStorageSupport;
    try {
        $e10a9fba5fb103db$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$e10a9fba5fb103db$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $e10a9fba5fb103db$var$hasLocalStorageSupport = false;
    }
    return $e10a9fba5fb103db$var$hasLocalStorageSupport;
};
var $e10a9fba5fb103db$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $e10a9fba5fb103db$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $e10a9fba5fb103db$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $e10a9fba5fb103db$var$hasSessionStorageSupport = null;
const $e10a9fba5fb103db$var$sessionStorageAvailable = ()=>{
    if ($e10a9fba5fb103db$var$hasSessionStorageSupport !== null) return $e10a9fba5fb103db$var$hasSessionStorageSupport;
    try {
        $e10a9fba5fb103db$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$e10a9fba5fb103db$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $e10a9fba5fb103db$var$hasSessionStorageSupport = false;
    }
    return $e10a9fba5fb103db$var$hasSessionStorageSupport;
};
var $e10a9fba5fb103db$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $e10a9fba5fb103db$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $e10a9fba5fb103db$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $e10a9fba5fb103db$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $e10a9fba5fb103db$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $e10a9fba5fb103db$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $e10a9fba5fb103db$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $e10a9fba5fb103db$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $e10a9fba5fb103db$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $e10a9fba5fb103db$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$e10a9fba5fb103db$var$canCookies) $e10a9fba5fb103db$var$order.splice(1, 1);
const $e10a9fba5fb103db$var$getDefaults = ()=>({
        order: $e10a9fba5fb103db$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $e10a9fba5fb103db$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $e10a9fba5fb103db$var$defaults(options, this.options || {}, $e10a9fba5fb103db$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($e10a9fba5fb103db$var$cookie$1);
        this.addDetector($e10a9fba5fb103db$var$querystring);
        this.addDetector($e10a9fba5fb103db$var$localStorage);
        this.addDetector($e10a9fba5fb103db$var$sessionStorage);
        this.addDetector($e10a9fba5fb103db$var$navigator$1);
        this.addDetector($e10a9fba5fb103db$var$htmlTag);
        this.addDetector($e10a9fba5fb103db$var$path);
        this.addDetector($e10a9fba5fb103db$var$subdomain);
        this.addDetector($e10a9fba5fb103db$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$e10a9fba5fb103db$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$e10a9fba5fb103db$export$2e2bcd8739ae039.type = 'languageDetector';


//import React from 'react';
//import DnbStatusLink from './components/dnb-status-link/DnbStatusLink';
// the translations
// (tip move them in a JSON file and import them)
const $c9ba6a600c92ba5a$var$norwegian = {
    translation: {
        'Incident started': 'Hendelsen startet',
        'Incident affects': "Hendelsen p\xe5virker",
        'Archive': 'Arkiv',
        'We will be undergoing scheduled maintenance during this time': "Vi vil gjennomf\xf8re planlagt vedlikehold under denne tiden",
        "Det er for tiden problemer med konto/saldo p\xe5 mobil.": "Det er for tiden problemer med konto/saldo p\xe5 mobil.",
        'Andre tjenester privat': 'Andre Tjenester Privat',
        'Andre tjenester bedrift': 'Andre Tjenester Bedrift',
        'Scheduled maintenance is currently in progress. We will provide updates as necessary.': "Vedlikehold p\xe5g\xe5r, vi oppdaterer etter behov.",
        'We are continuing to investigate this issue.': "Det jobbes fortsatt med \xe5 l\xf8se feilen.",
        'We are currently investigating this issue.': 'Det jobbes med problemet.',
        'We are working on solving the incident.': "Det jobbes med \xe5 l\xf8se problemet s\xe5 raskt som mulig.",
        'This incident has been resolved.': "Dette problemet er l\xf8st.",
        'Corporate Internet banking': 'Nettbank Bedrift',
        'Corporate Internet Banking': 'Nettbank Bedrift',
        'Account Overview': 'Kontooversikt',
        'International Payments': 'Betaling Utland',
        Transactions: 'Transaksjoner',
        'Payments Overview': 'Betalingsoversikt',
        Payments: 'Betaling',
        'DNB Bedrift': 'Mobilbank Bedrift',
        Personal: 'Privat',
        Services: 'Tjenester',
        Business: 'Bedrift',
        Loading: 'Laster',
        'All systems are currently operating normally': "Alle v\xe5re systemer fungerer normalt",
        'No resolved incidents in the archive': 'Ingen hendelser i arkivet',
        'All our systems and services are working as normal': "Alle v\xe5re systemer fungerer normalt",
        'See incidents': 'Se hendelser',
        'Last updated': 'Sist oppdatert',
        'Go to the incident overview': "G\xe5 til hendelsesoversikt",
        incidents: 'hendelser',
        Incidents: 'Hendelser',
        incident: 'hendelse',
        Incident: 'Hendelse',
        resolved: "l\xf8st",
        started: 'oppstod',
        'Last 48 hours': 'Siste 48 timer',
        'last 24 hours': 'siste 24 timer',
        'Last 90 days': 'Siste 90 dager',
        Systems: 'Systemer',
        working: 'fungerer',
        'There is currently no scheduled maintenance': 'Det er for tiden ingen planlagte vedlikehold',
        'Scheduled maintenance': 'Planlagt vedlikehold',
        'days since': 'dager siden',
        last: 'siste',
        'No incidents in': "Ingen hendelser p\xe5",
        over: 'over',
        months: "m\xe5neder",
        Nettbank: 'Nettbank',
        'Kontoer/balanse Nett': 'Kontoer/balanse',
        "Overf\xf8ringer Nett": "Overf\xf8ringer",
        'Betalinger Nett': 'Betalinger',
        'Minibanker, Kort Og Betalingsterminaler': 'Minibanker, Kort Og Betalingsterminaler',
        'Minibanker, kort og betalingsterminaler': 'Minibanker, Kort Og Betalingsterminaler',
        Kort: 'Kort',
        Innlogging: 'Innlogging',
        'BankID (OIDC)': "BankID p\xe5 DNBs mobilapplikasjoner",
        DigiPass: 'Innlogging uten BankID',
        GO3Phonecode: 'Personlig kode',
        Mobilbank: 'Mobilbank',
        'Sbanken Mobilbank': 'Sbanken Mobilbank',
        'Betalinger Mobil': 'Betalinger',
        'Kontoer/Balanse Mobil': 'Kontoer/balanse',
        "Overf\xf8ringer Mobil": "Overf\xf8ringer",
        'Regninger Mobil': 'Regninger',
        operational: 'Normal drift',
        minor: 'Redusert funksjonalitet',
        major: 'Utilgjengelig',
        critical: 'Utilgjengelig',
        degraded_performance: 'Redusert ytelse',
        under_maintenance: 'Vedlikehold',
        'Affected systems': "System(er) som vil bli p\xe5virket",
        //Header.js
        'DNB Status front page': 'Forsiden DNB Status',
        'Go to dnb.no': "G\xe5 til dnb.no",
        // HistoryHeader.js
        'Back to the front page': "G\xe5 tilbake til startsiden",
        Back: 'Tilbake',
        'Subscribe to updates': "Abonn\xe9r p\xe5 oppdateringer",
        History: 'Historikk',
        // HistoricIncidentCard.js
        'Show log': 'Vis logg',
        'Hide log': 'Skjul logg',
        affect: "p\xe5virker",
        affected: "p\xe5virket",
        // IncidentsListWrapper.js
        'Ongoing incidents': 'Aktive hendelser',
        // NoIncident.js
        'Not much is happening here': 'Her skjer det ikke stort',
        // IncidentsNoIncidents.js
        'No incidents in the last 48 hours': 'Ingen hendelser de siste 48 timene'
    }
};
const $c9ba6a600c92ba5a$var$resources = {
    en: {
        translation: {
            //'Vi jobber med problemet.': 'We are working on solving the incident.',
            'We will be undergoing scheduled maintenance during this time': 'We will be undergoing scheduled maintenance during this time',
            "Det er for tiden problemer med konto/saldo p\xe5 mobil.": 'We are currently experiencing issues with accounts / balances on Mobile.',
            // Components
            'Minibanker, kort og betalingsterminaler': 'Cash Machines/ATMs, Cards, And Payment Terminals',
            'Andre tjenester privat': 'Other Services Personal',
            'Andre Tjenester Privat': 'Other Services Personal',
            'Andre tjenester bedrift': 'Other Services Business',
            'Andre Tjenester Bedrift': 'Other Services Business',
            Kort: 'Cards',
            Innlogging: 'Login',
            'DNB Bedrift': 'Corporate Mobile Bank',
            'BankID (OIDC)': 'BankID (OIDC)',
            DigiPass: 'DigiPass',
            GO3Phonecode: 'GO3Phonecode',
            Mobilbank: 'Mobile Bank',
            'Sbanken Mobilbank': 'Sbanken Mobile Bank',
            'Betalinger Mobil': 'Payments',
            'Kontoer/Balanse Mobil': 'Accounts/balance',
            "Overf\xf8ringer Mobil": 'Transactions',
            'Regninger Mobil': 'Invoices/Bills',
            Nettbank: 'Internet Bank',
            'Kontoer/balanse Nett': 'Accounts/balance',
            "Overf\xf8ringer Nett": 'Transactions',
            'Betalinger Nett': 'Payments',
            'Minibanker, Kort Og Betalingsterminaler': 'Cash Machines/ATMs, Cards, And Payment Terminals',
            'Corporate Internet banking': 'Corporate Internet Banking',
            // End components
            Personal: 'Personal',
            Business: 'Business',
            Loading: 'Loading',
            'All our systems and services are working as normal': 'All our systems and services are working as normal',
            'See incidents': 'See incidents',
            'Last updated': 'Last updated',
            'Go to the incident overview': 'Go to the incident overview',
            incidents: 'incidents',
            Incidents: 'Incidents',
            incident: 'incident',
            Incident: 'Incident',
            resolved: 'resolved',
            started: 'started',
            'Last 48 hours': 'Last 48 hours',
            'last 24 hours': 'last 24 hours',
            'Last 90 days': 'Last 90 days',
            Systems: 'Systems',
            working: 'working',
            'There is currently no scheduled maintenance': 'There is currently no scheduled maintenance',
            'Scheduled maintenance': 'Scheduled maintenance',
            'days since': 'days since',
            last: 'last',
            'No incidents in': 'No incidents in',
            over: 'over',
            months: 'months',
            'Scheduled maintenance is currently in progress. We will provide updates as necessary.': 'Scheduled maintenance is currently in progress. We will provide updates as necessary.',
            'This incident has been resolved.': 'This incident has been resolved.',
            operational: 'Operational',
            minor: 'Minor outage',
            major: 'Major outage',
            critical: 'Critical',
            degraded_performance: 'Degraded performance',
            under_maintenance: 'Under maintenance',
            'Affected systems': 'Affected systems',
            // Header.js
            'DNB Status front page': 'DNB Status front page',
            'Go to dnb.no': 'Go to dnb.no',
            // HistoryHeader.js
            'Back to the front page': 'Back to the front page',
            Back: 'Back',
            'Subscribe to updates': 'Subscribe to updates',
            History: 'History',
            // HistoricIncidentCard.js
            'Show log': 'Show log',
            'Hide log': 'Hide log',
            affect: 'affect',
            // IncidentsListWrapper.js
            'Ongoing incidents': 'Ongoing incidents',
            // NoIncident.js
            'Not much is happening here': 'Not much is happening here',
            // IncidentsNoIncidents.js
            'No incidents in the last 48 hours': 'No incidents in the last 48 hours'
        }
    },
    no: $c9ba6a600c92ba5a$var$norwegian,
    nb: $c9ba6a600c92ba5a$var$norwegian
};
(0, $156c1d4c5addba0b$export$2e2bcd8739ae039).use((0, $de8f8501ef445db0$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.use((0, $e10a9fba5fb103db$export$2e2bcd8739ae039)).init({
    resources: $c9ba6a600c92ba5a$var$resources,
    //lng: 'no',
    fallbackLng: 'en',
    detection: {
        order: [
            'navigator'
        ]
    },
    debug: true,
    keySeparator: false,
    nsSeparator: false,
    namespaceSeparator: false,
    interpolation: {
        escapeValue: false
    }
});
var $c9ba6a600c92ba5a$export$2e2bcd8739ae039 = (0, $156c1d4c5addba0b$export$2e2bcd8739ae039);


// Deprecated in react 18
//var mountNode = document.getElementById('root');
//ReactDOM.render(<App />, mountNode);
const $226ab363cb34c004$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($c75051cfa147f10e$exports))).createRoot(document.getElementById('root'));
$226ab363cb34c004$var$root.render(/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).StrictMode, {
    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $caf4cd8c41e1fa55$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=public-gh-fail.a743197a.js.map
